(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("369XB", function(module, exports) {

var $gjZEs = parcelRequire("gjZEs");

var $87K8r = parcelRequire("87K8r");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($87K8r(that));
        var i = $gjZEs(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});
parcelRegister("gjZEs", function(module, exports) {
// 7.1.4 ToInteger
var $be1e3e6d7e21383c$var$ceil = Math.ceil;
var $be1e3e6d7e21383c$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $be1e3e6d7e21383c$var$floor : $be1e3e6d7e21383c$var$ceil)(it);
};

});

parcelRegister("87K8r", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("hCjYU", function(module, exports) {
'use strict';

var $hQvTY = parcelRequire("hQvTY");

var $7XiCc = parcelRequire("7XiCc");

var $jdgAl = parcelRequire("jdgAl");

var $doViN = parcelRequire("doViN");

var $afDmW = parcelRequire("afDmW");

var $2dGQ0 = parcelRequire("2dGQ0");

var $6AWi8 = parcelRequire("6AWi8");

var $dNXKl = parcelRequire("dNXKl");

var $cd357c2e621d749b$var$ITERATOR = (parcelRequire("3KDgq"))('iterator');
var $cd357c2e621d749b$var$BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var $cd357c2e621d749b$var$FF_ITERATOR = '@@iterator';
var $cd357c2e621d749b$var$KEYS = 'keys';
var $cd357c2e621d749b$var$VALUES = 'values';
var $cd357c2e621d749b$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $2dGQ0(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$cd357c2e621d749b$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $cd357c2e621d749b$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $cd357c2e621d749b$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == $cd357c2e621d749b$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$cd357c2e621d749b$var$ITERATOR] || proto[$cd357c2e621d749b$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $dNXKl($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $6AWi8(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$hQvTY && typeof IteratorPrototype[$cd357c2e621d749b$var$ITERATOR] != 'function') $doViN(IteratorPrototype, $cd357c2e621d749b$var$ITERATOR, $cd357c2e621d749b$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $cd357c2e621d749b$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$hQvTY || FORCED) && ($cd357c2e621d749b$var$BUGGY || VALUES_BUG || !proto[$cd357c2e621d749b$var$ITERATOR])) $doViN(proto, $cd357c2e621d749b$var$ITERATOR, $default);
    // Plug for library
    $afDmW[NAME] = $default;
    $afDmW[TAG] = $cd357c2e621d749b$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($cd357c2e621d749b$var$VALUES),
            keys: IS_SET ? $default : getMethod($cd357c2e621d749b$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $jdgAl(proto, key, methods[key]);
        } else $7XiCc($7XiCc.P + $7XiCc.F * ($cd357c2e621d749b$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("hQvTY", function(module, exports) {
module.exports = false;

});

parcelRegister("7XiCc", function(module, exports) {

var $5OCD9 = parcelRequire("5OCD9");

var $kLmzM = parcelRequire("kLmzM");

var $doViN = parcelRequire("doViN");

var $jdgAl = parcelRequire("jdgAl");

var $h2rcp = parcelRequire("h2rcp");
var $5cac7ba8d5199c43$var$PROTOTYPE = 'prototype';
var $5cac7ba8d5199c43$var$$export = function(type, name, source) {
    var IS_FORCED = type & $5cac7ba8d5199c43$var$$export.F;
    var IS_GLOBAL = type & $5cac7ba8d5199c43$var$$export.G;
    var IS_STATIC = type & $5cac7ba8d5199c43$var$$export.S;
    var IS_PROTO = type & $5cac7ba8d5199c43$var$$export.P;
    var IS_BIND = type & $5cac7ba8d5199c43$var$$export.B;
    var target = IS_GLOBAL ? $5OCD9 : IS_STATIC ? $5OCD9[name] || ($5OCD9[name] = {}) : ($5OCD9[name] || {})[$5cac7ba8d5199c43$var$PROTOTYPE];
    var exports = IS_GLOBAL ? $kLmzM : $kLmzM[name] || ($kLmzM[name] = {});
    var expProto = exports[$5cac7ba8d5199c43$var$PROTOTYPE] || (exports[$5cac7ba8d5199c43$var$PROTOTYPE] = {});
    var key, own, out, exp;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        // export native or passed
        out = (own ? target : source)[key];
        // bind timers to global for call from export context
        exp = IS_BIND && own ? $h2rcp(out, $5OCD9) : IS_PROTO && typeof out == 'function' ? $h2rcp(Function.call, out) : out;
        // extend global
        if (target) $jdgAl(target, key, out, type & $5cac7ba8d5199c43$var$$export.U);
        // export
        if (exports[key] != out) $doViN(exports, key, exp);
        if (IS_PROTO && expProto[key] != out) expProto[key] = out;
    }
};
$5OCD9.core = $kLmzM;
// type bitmap
$5cac7ba8d5199c43$var$$export.F = 1; // forced
$5cac7ba8d5199c43$var$$export.G = 2; // global
$5cac7ba8d5199c43$var$$export.S = 4; // static
$5cac7ba8d5199c43$var$$export.P = 8; // proto
$5cac7ba8d5199c43$var$$export.B = 16; // bind
$5cac7ba8d5199c43$var$$export.W = 32; // wrap
$5cac7ba8d5199c43$var$$export.U = 64; // safe
$5cac7ba8d5199c43$var$$export.R = 128; // real proto method for `library`
module.exports = $5cac7ba8d5199c43$var$$export;

});
parcelRegister("5OCD9", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $43bf967b6ef28b6b$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $43bf967b6ef28b6b$var$global; // eslint-disable-line no-undef

});

parcelRegister("kLmzM", function(module, exports) {
var $f1d9b594212cd228$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $f1d9b594212cd228$var$core; // eslint-disable-line no-undef

});

parcelRegister("doViN", function(module, exports) {

var $yXi7N = parcelRequire("yXi7N");

var $1SVLC = parcelRequire("1SVLC");

module.exports = (parcelRequire("5Isbs")) ? function(object, key, value) {
    return $yXi7N.f(object, key, $1SVLC(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("yXi7N", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $06912b1d6b7bf5bf$export$2d1720544b23b823; }, function (v) { return $06912b1d6b7bf5bf$export$2d1720544b23b823 = v; });
var $06912b1d6b7bf5bf$export$2d1720544b23b823;

var $kamYu = parcelRequire("kamYu");

var $1zlrw = parcelRequire("1zlrw");

var $jlrcV = parcelRequire("jlrcV");
var $06912b1d6b7bf5bf$var$dP = Object.defineProperty;

$06912b1d6b7bf5bf$export$2d1720544b23b823 = (parcelRequire("5Isbs")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $kamYu(O);
    P = $jlrcV(P, true);
    $kamYu(Attributes);
    if ($1zlrw) try {
        return $06912b1d6b7bf5bf$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("kamYu", function(module, exports) {

var $jWixV = parcelRequire("jWixV");
module.exports = function(it) {
    if (!$jWixV(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("jWixV", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("1zlrw", function(module, exports) {



module.exports = !(parcelRequire("5Isbs")) && !(parcelRequire("4Gc6B"))(function() {
    return Object.defineProperty((parcelRequire("fseId"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("5Isbs", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("4Gc6B"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("4Gc6B", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("fseId", function(module, exports) {

var $jWixV = parcelRequire("jWixV");

var $5OCD9 = parcelRequire("5OCD9");
var $b404e217477b2cc6$require$document = $5OCD9.document;
// typeof document.createElement is 'object' in old IE
var $b404e217477b2cc6$var$is = $jWixV($b404e217477b2cc6$require$document) && $jWixV($b404e217477b2cc6$require$document.createElement);
module.exports = function(it) {
    return $b404e217477b2cc6$var$is ? $b404e217477b2cc6$require$document.createElement(it) : {};
};

});


parcelRegister("jlrcV", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $jWixV = parcelRequire("jWixV");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$jWixV(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$jWixV(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$jWixV(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$jWixV(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("1SVLC", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("jdgAl", function(module, exports) {

var $5OCD9 = parcelRequire("5OCD9");

var $doViN = parcelRequire("doViN");

var $1oXND = parcelRequire("1oXND");

var $dfcc18ad588bd9b3$var$SRC = (parcelRequire("2lzLu"))('src');

var $7lrsx = parcelRequire("7lrsx");
var $dfcc18ad588bd9b3$var$TO_STRING = 'toString';
var $dfcc18ad588bd9b3$var$TPL = ('' + $7lrsx).split($dfcc18ad588bd9b3$var$TO_STRING);

(parcelRequire("kLmzM")).inspectSource = function(it) {
    return $7lrsx.call(it);
};
(module.exports = function(O, key, val, safe) {
    var isFunction = typeof val == 'function';
    if (isFunction) $1oXND(val, 'name') || $doViN(val, 'name', key);
    if (O[key] === val) return;
    if (isFunction) $1oXND(val, $dfcc18ad588bd9b3$var$SRC) || $doViN(val, $dfcc18ad588bd9b3$var$SRC, O[key] ? '' + O[key] : $dfcc18ad588bd9b3$var$TPL.join(String(key)));
    if (O === $5OCD9) O[key] = val;
    else if (!safe) {
        delete O[key];
        $doViN(O, key, val);
    } else if (O[key]) O[key] = val;
    else $doViN(O, key, val);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, $dfcc18ad588bd9b3$var$TO_STRING, function toString() {
    return typeof this == 'function' && this[$dfcc18ad588bd9b3$var$SRC] || $7lrsx.call(this);
});

});
parcelRegister("1oXND", function(module, exports) {
var $10566b4c466cc7cc$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $10566b4c466cc7cc$var$hasOwnProperty.call(it, key);
};

});

parcelRegister("2lzLu", function(module, exports) {
var $1b59492001d41103$var$id = 0;
var $1b59492001d41103$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$1b59492001d41103$var$id + $1b59492001d41103$var$px).toString(36));
};

});

parcelRegister("7lrsx", function(module, exports) {

module.exports = (parcelRequire("dPR8U"))('native-function-to-string', Function.toString);

});
parcelRegister("dPR8U", function(module, exports) {

var $kLmzM = parcelRequire("kLmzM");

var $5OCD9 = parcelRequire("5OCD9");
var $a12942cea049aecf$var$SHARED = '__core-js_shared__';
var $a12942cea049aecf$var$store = $5OCD9[$a12942cea049aecf$var$SHARED] || ($5OCD9[$a12942cea049aecf$var$SHARED] = {});

(module.exports = function(key, value) {
    return $a12942cea049aecf$var$store[key] || ($a12942cea049aecf$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $kLmzM.version,
    mode: (parcelRequire("hQvTY")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});



parcelRegister("h2rcp", function(module, exports) {
// optional / simple context binding

var $l2Ctg = parcelRequire("l2Ctg");
module.exports = function(fn, that, length) {
    $l2Ctg(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("l2Ctg", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});



parcelRegister("afDmW", function(module, exports) {
module.exports = {};

});

parcelRegister("2dGQ0", function(module, exports) {
'use strict';

var $a4vdI = parcelRequire("a4vdI");

var $1SVLC = parcelRequire("1SVLC");

var $6AWi8 = parcelRequire("6AWi8");
var $19de065f678e9d92$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("doViN"))($19de065f678e9d92$var$IteratorPrototype, (parcelRequire("3KDgq"))('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $a4vdI($19de065f678e9d92$var$IteratorPrototype, {
        next: $1SVLC(1, next)
    });
    $6AWi8(Constructor, NAME + ' Iterator');
};

});
parcelRegister("a4vdI", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $kamYu = parcelRequire("kamYu");

var $eWLAM = parcelRequire("eWLAM");

var $cncou = parcelRequire("cncou");

var $75527ec807e8027a$var$IE_PROTO = (parcelRequire("cKnMd"))('IE_PROTO');
var $75527ec807e8027a$var$Empty = function() {};
var $75527ec807e8027a$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $75527ec807e8027a$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("fseId"))('iframe');
    var i = $cncou.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("65KYc")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $75527ec807e8027a$var$createDict = iframeDocument.F;
    while(i--)delete $75527ec807e8027a$var$createDict[$75527ec807e8027a$var$PROTOTYPE][$cncou[i]];
    return $75527ec807e8027a$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $75527ec807e8027a$var$Empty[$75527ec807e8027a$var$PROTOTYPE] = $kamYu(O);
        result = new $75527ec807e8027a$var$Empty();
        $75527ec807e8027a$var$Empty[$75527ec807e8027a$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$75527ec807e8027a$var$IE_PROTO] = O;
    } else result = $75527ec807e8027a$var$createDict();
    return Properties === undefined ? result : $eWLAM(result, Properties);
};

});
parcelRegister("eWLAM", function(module, exports) {

var $yXi7N = parcelRequire("yXi7N");

var $kamYu = parcelRequire("kamYu");

var $dj11b = parcelRequire("dj11b");

module.exports = (parcelRequire("5Isbs")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $kamYu(O);
    var keys = $dj11b(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$yXi7N.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("dj11b", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $d9Uu1 = parcelRequire("d9Uu1");

var $cncou = parcelRequire("cncou");
module.exports = Object.keys || function keys(O) {
    return $d9Uu1(O, $cncou);
};

});
parcelRegister("d9Uu1", function(module, exports) {

var $1oXND = parcelRequire("1oXND");

var $2XGMh = parcelRequire("2XGMh");

var $9947ee077e5f05a2$var$arrayIndexOf = (parcelRequire("2so6k"))(false);

var $9947ee077e5f05a2$var$IE_PROTO = (parcelRequire("cKnMd"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $2XGMh(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $9947ee077e5f05a2$var$IE_PROTO) $1oXND(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($1oXND(O, key = names[i++])) ~$9947ee077e5f05a2$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("2XGMh", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $b9ATX = parcelRequire("b9ATX");

var $87K8r = parcelRequire("87K8r");
module.exports = function(it) {
    return $b9ATX($87K8r(it));
};

});
parcelRegister("b9ATX", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $lk5ZL = parcelRequire("lk5ZL");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $lk5ZL(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("lk5ZL", function(module, exports) {
var $f8601dc6412c2c36$var$toString = {}.toString;
module.exports = function(it) {
    return $f8601dc6412c2c36$var$toString.call(it).slice(8, -1);
};

});



parcelRegister("2so6k", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $2XGMh = parcelRequire("2XGMh");

var $dZ2Pj = parcelRequire("dZ2Pj");

var $6Rj8z = parcelRequire("6Rj8z");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $2XGMh($this);
        var length = $dZ2Pj(O.length);
        var index = $6Rj8z(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("dZ2Pj", function(module, exports) {
// 7.1.15 ToLength

var $gjZEs = parcelRequire("gjZEs");
var $a2e32a2d00ac727c$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $a2e32a2d00ac727c$var$min($gjZEs(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});

parcelRegister("6Rj8z", function(module, exports) {

var $gjZEs = parcelRequire("gjZEs");
var $4fe68990d87c3e76$var$max = Math.max;
var $4fe68990d87c3e76$var$min = Math.min;
module.exports = function(index, length) {
    index = $gjZEs(index);
    return index < 0 ? $4fe68990d87c3e76$var$max(index + length, 0) : $4fe68990d87c3e76$var$min(index, length);
};

});


parcelRegister("cKnMd", function(module, exports) {

var $947c3973205d075a$var$shared = (parcelRequire("dPR8U"))('keys');

var $2lzLu = parcelRequire("2lzLu");
module.exports = function(key) {
    return $947c3973205d075a$var$shared[key] || ($947c3973205d075a$var$shared[key] = $2lzLu(key));
};

});


parcelRegister("cncou", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});



parcelRegister("65KYc", function(module, exports) {

var $5OCD9 = parcelRequire("5OCD9");
var $46f7a4f93324fb69$require$document = $5OCD9.document;
module.exports = $46f7a4f93324fb69$require$document && $46f7a4f93324fb69$require$document.documentElement;

});


parcelRegister("6AWi8", function(module, exports) {

var $yXi7N = parcelRequire("yXi7N");
var $4cd3525ede1072e3$require$def = $yXi7N.f;

var $1oXND = parcelRequire("1oXND");

var $4cd3525ede1072e3$var$TAG = (parcelRequire("3KDgq"))('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !$1oXND(it = stat ? it : it.prototype, $4cd3525ede1072e3$var$TAG)) $4cd3525ede1072e3$require$def(it, $4cd3525ede1072e3$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("3KDgq", function(module, exports) {

var $2bb41ffe57fed81f$var$store = (parcelRequire("dPR8U"))('wks');

var $2lzLu = parcelRequire("2lzLu");

var $5OCD9 = parcelRequire("5OCD9");
var $2bb41ffe57fed81f$require$Symbol = $5OCD9.Symbol;
var $2bb41ffe57fed81f$var$USE_SYMBOL = typeof $2bb41ffe57fed81f$require$Symbol == 'function';
var $2bb41ffe57fed81f$var$$exports = module.exports = function(name) {
    return $2bb41ffe57fed81f$var$store[name] || ($2bb41ffe57fed81f$var$store[name] = $2bb41ffe57fed81f$var$USE_SYMBOL && $2bb41ffe57fed81f$require$Symbol[name] || ($2bb41ffe57fed81f$var$USE_SYMBOL ? $2bb41ffe57fed81f$require$Symbol : $2lzLu)('Symbol.' + name));
};
$2bb41ffe57fed81f$var$$exports.store = $2bb41ffe57fed81f$var$store;

});



parcelRegister("dNXKl", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $1oXND = parcelRequire("1oXND");

var $ezwWl = parcelRequire("ezwWl");

var $a0ce32640db478f0$var$IE_PROTO = (parcelRequire("cKnMd"))('IE_PROTO');
var $a0ce32640db478f0$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $ezwWl(O);
    if ($1oXND(O, $a0ce32640db478f0$var$IE_PROTO)) return O[$a0ce32640db478f0$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $a0ce32640db478f0$var$ObjectProto : null;
};

});
parcelRegister("ezwWl", function(module, exports) {
// 7.1.13 ToObject(argument)

var $87K8r = parcelRequire("87K8r");
module.exports = function(it) {
    return Object($87K8r(it));
};

});



parcelRegister("eepmO", function(module, exports) {

var $a5c60cd5b02b8518$var$ITERATOR = (parcelRequire("3KDgq"))('iterator');
var $a5c60cd5b02b8518$var$SAFE_CLOSING = false;
try {
    var $a5c60cd5b02b8518$var$riter = [
        7
    ][$a5c60cd5b02b8518$var$ITERATOR]();
    $a5c60cd5b02b8518$var$riter['return'] = function() {
        $a5c60cd5b02b8518$var$SAFE_CLOSING = true;
    };
    // eslint-disable-next-line no-throw-literal
    Array.from($a5c60cd5b02b8518$var$riter, function() {
        throw 2;
    });
} catch (e) {}
module.exports = function(exec, skipClosing) {
    if (!skipClosing && !$a5c60cd5b02b8518$var$SAFE_CLOSING) return false;
    var safe = false;
    try {
        var arr = [
            7
        ];
        var iter = arr[$a5c60cd5b02b8518$var$ITERATOR]();
        iter.next = function() {
            return {
                done: safe = true
            };
        };
        arr[$a5c60cd5b02b8518$var$ITERATOR] = function() {
            return iter;
        };
        exec(arr);
    } catch (e) {}
    return safe;
};

});

parcelRegister("hpsD3", function(module, exports) {
'use strict';

var $4Gc6B = parcelRequire("4Gc6B");
module.exports = function(method, arg) {
    return !!method && $4Gc6B(function() {
        // eslint-disable-next-line no-useless-call
        arg ? method.call(null, function() {}, 1) : method.call(null);
    });
};

});

parcelRegister("iwRi4", function(module, exports) {
'use strict';

var $5Isbs = parcelRequire("5Isbs");

var $dj11b = parcelRequire("dj11b");

var $cGvdD = parcelRequire("cGvdD");

var $8x6SA = parcelRequire("8x6SA");

var $ezwWl = parcelRequire("ezwWl");

var $b9ATX = parcelRequire("b9ATX");
var $d7d48d839f97ab7a$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$d7d48d839f97ab7a$var$$assign || (parcelRequire("4Gc6B"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $d7d48d839f97ab7a$var$$assign({}, A)[S] != 7 || Object.keys($d7d48d839f97ab7a$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $ezwWl(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $cGvdD.f;
    var isEnum = $8x6SA.f;
    while(aLen > index){
        var S = $b9ATX(arguments[index++]);
        var keys = getSymbols ? $dj11b(S).concat(getSymbols(S)) : $dj11b(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$5Isbs || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $d7d48d839f97ab7a$var$$assign;

});
parcelRegister("cGvdD", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $93c19fb7b17b4a2d$export$2d1720544b23b823; }, function (v) { return $93c19fb7b17b4a2d$export$2d1720544b23b823 = v; });
var $93c19fb7b17b4a2d$export$2d1720544b23b823;
$93c19fb7b17b4a2d$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("8x6SA", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $6366bde63b61477c$export$2d1720544b23b823; }, function (v) { return $6366bde63b61477c$export$2d1720544b23b823 = v; });
var $6366bde63b61477c$export$2d1720544b23b823;
$6366bde63b61477c$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});


parcelRegister("2bavT", function(module, exports) {

var $5Isbs = parcelRequire("5Isbs");

var $dj11b = parcelRequire("dj11b");

var $2XGMh = parcelRequire("2XGMh");

var $8x6SA = parcelRequire("8x6SA");
var $1964c39aed802e7f$require$isEnum = $8x6SA.f;
module.exports = function(isEntries) {
    return function(it) {
        var O = $2XGMh(it);
        var keys = $dj11b(O);
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!$5Isbs || $1964c39aed802e7f$require$isEnum.call(O, key)) result.push(isEntries ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};

});

parcelRegister("9u6t1", function(module, exports) {
parcelRequire("9Ji4B");

var $iutpE = parcelRequire("iutpE");
var $6e7bee9bae2a805d$require$$Object = $iutpE.Object;
module.exports = function defineProperty(it, key, desc) {
    return $6e7bee9bae2a805d$require$$Object.defineProperty(it, key, desc);
};

});
parcelRegister("9Ji4B", function(module, exports) {

var $1AZ5u = parcelRequire("1AZ5u");


// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$1AZ5u($1AZ5u.S + $1AZ5u.F * !(parcelRequire("gcUbC")), 'Object', {
    defineProperty: (parcelRequire("bMqA1")).f
});

});
parcelRegister("1AZ5u", function(module, exports) {

var $cW64K = parcelRequire("cW64K");

var $iutpE = parcelRequire("iutpE");

var $jSFZY = parcelRequire("jSFZY");

var $9ttfG = parcelRequire("9ttfG");

var $5NGXo = parcelRequire("5NGXo");
var $129889f48f9fe8b3$var$PROTOTYPE = 'prototype';
var $129889f48f9fe8b3$var$$export = function(type, name, source) {
    var IS_FORCED = type & $129889f48f9fe8b3$var$$export.F;
    var IS_GLOBAL = type & $129889f48f9fe8b3$var$$export.G;
    var IS_STATIC = type & $129889f48f9fe8b3$var$$export.S;
    var IS_PROTO = type & $129889f48f9fe8b3$var$$export.P;
    var IS_BIND = type & $129889f48f9fe8b3$var$$export.B;
    var IS_WRAP = type & $129889f48f9fe8b3$var$$export.W;
    var exports = IS_GLOBAL ? $iutpE : $iutpE[name] || ($iutpE[name] = {});
    var expProto = exports[$129889f48f9fe8b3$var$PROTOTYPE];
    var target = IS_GLOBAL ? $cW64K : IS_STATIC ? $cW64K[name] : ($cW64K[name] || {})[$129889f48f9fe8b3$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $5NGXo(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $jSFZY(out, $cW64K) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$129889f48f9fe8b3$var$PROTOTYPE] = C[$129889f48f9fe8b3$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $jSFZY(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $129889f48f9fe8b3$var$$export.R && expProto && !expProto[key]) $9ttfG(expProto, key, out);
        }
    }
};
// type bitmap
$129889f48f9fe8b3$var$$export.F = 1; // forced
$129889f48f9fe8b3$var$$export.G = 2; // global
$129889f48f9fe8b3$var$$export.S = 4; // static
$129889f48f9fe8b3$var$$export.P = 8; // proto
$129889f48f9fe8b3$var$$export.B = 16; // bind
$129889f48f9fe8b3$var$$export.W = 32; // wrap
$129889f48f9fe8b3$var$$export.U = 64; // safe
$129889f48f9fe8b3$var$$export.R = 128; // real proto method for `library`
module.exports = $129889f48f9fe8b3$var$$export;

});
parcelRegister("cW64K", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $96af9d46720a30af$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $96af9d46720a30af$var$global; // eslint-disable-line no-undef

});

parcelRegister("iutpE", function(module, exports) {
var $d761d81b57f3e0b7$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $d761d81b57f3e0b7$var$core; // eslint-disable-line no-undef

});

parcelRegister("jSFZY", function(module, exports) {
// optional / simple context binding

var $bQqJW = parcelRequire("bQqJW");
module.exports = function(fn, that, length) {
    $bQqJW(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("bQqJW", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("9ttfG", function(module, exports) {

var $bMqA1 = parcelRequire("bMqA1");

var $eS6gR = parcelRequire("eS6gR");

module.exports = (parcelRequire("gcUbC")) ? function(object, key, value) {
    return $bMqA1.f(object, key, $eS6gR(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("bMqA1", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $8938cba23996efc3$export$2d1720544b23b823; }, function (v) { return $8938cba23996efc3$export$2d1720544b23b823 = v; });
var $8938cba23996efc3$export$2d1720544b23b823;

var $3Otap = parcelRequire("3Otap");

var $2W7gZ = parcelRequire("2W7gZ");

var $dYlYw = parcelRequire("dYlYw");
var $8938cba23996efc3$var$dP = Object.defineProperty;

$8938cba23996efc3$export$2d1720544b23b823 = (parcelRequire("gcUbC")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $3Otap(O);
    P = $dYlYw(P, true);
    $3Otap(Attributes);
    if ($2W7gZ) try {
        return $8938cba23996efc3$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("3Otap", function(module, exports) {

var $jJprq = parcelRequire("jJprq");
module.exports = function(it) {
    if (!$jJprq(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("jJprq", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("2W7gZ", function(module, exports) {



module.exports = !(parcelRequire("gcUbC")) && !(parcelRequire("4Uuph"))(function() {
    return Object.defineProperty((parcelRequire("3UJf0"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("gcUbC", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("4Uuph"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("4Uuph", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("3UJf0", function(module, exports) {

var $jJprq = parcelRequire("jJprq");

var $cW64K = parcelRequire("cW64K");
var $2d99b1fea72864de$require$document = $cW64K.document;
// typeof document.createElement is 'object' in old IE
var $2d99b1fea72864de$var$is = $jJprq($2d99b1fea72864de$require$document) && $jJprq($2d99b1fea72864de$require$document.createElement);
module.exports = function(it) {
    return $2d99b1fea72864de$var$is ? $2d99b1fea72864de$require$document.createElement(it) : {};
};

});


parcelRegister("dYlYw", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $jJprq = parcelRequire("jJprq");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$jJprq(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$jJprq(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$jJprq(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$jJprq(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("eS6gR", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("5NGXo", function(module, exports) {
var $4392d9b2fff35168$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $4392d9b2fff35168$var$hasOwnProperty.call(it, key);
};

});




parcelRegister("gTRtf", function(module, exports) {
parcelRequire("jSGWG");
parcelRequire("4qjBi");
parcelRequire("ecewl");
parcelRequire("aLMuf");
parcelRequire("3bbmc");

module.exports = (parcelRequire("iutpE")).WeakMap;

});
parcelRegister("jSGWG", function(module, exports) {

});

parcelRegister("4qjBi", function(module, exports) {
parcelRequire("jG6qg");

var $cW64K = parcelRequire("cW64K");

var $9ttfG = parcelRequire("9ttfG");

var $ie3lC = parcelRequire("ie3lC");

var $3388cb68460c192c$var$TO_STRING_TAG = (parcelRequire("8FpOB"))('toStringTag');
var $3388cb68460c192c$var$DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(',');
for(var $3388cb68460c192c$var$i = 0; $3388cb68460c192c$var$i < $3388cb68460c192c$var$DOMIterables.length; $3388cb68460c192c$var$i++){
    var $3388cb68460c192c$var$NAME = $3388cb68460c192c$var$DOMIterables[$3388cb68460c192c$var$i];
    var $3388cb68460c192c$var$Collection = $cW64K[$3388cb68460c192c$var$NAME];
    var $3388cb68460c192c$var$proto = $3388cb68460c192c$var$Collection && $3388cb68460c192c$var$Collection.prototype;
    if ($3388cb68460c192c$var$proto && !$3388cb68460c192c$var$proto[$3388cb68460c192c$var$TO_STRING_TAG]) $9ttfG($3388cb68460c192c$var$proto, $3388cb68460c192c$var$TO_STRING_TAG, $3388cb68460c192c$var$NAME);
    $ie3lC[$3388cb68460c192c$var$NAME] = $ie3lC.Array;
}

});
parcelRegister("jG6qg", function(module, exports) {
'use strict';

var $90H0p = parcelRequire("90H0p");

var $gQit3 = parcelRequire("gQit3");

var $ie3lC = parcelRequire("ie3lC");

var $fPxf9 = parcelRequire("fPxf9");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = (parcelRequire("2w2j0"))(Array, 'Array', function(iterated, kind) {
    this._t = $fPxf9(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $gQit3(1);
    }
    if (kind == 'keys') return $gQit3(0, index);
    if (kind == 'values') return $gQit3(0, O[index]);
    return $gQit3(0, [
        index,
        O[index]
    ]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$ie3lC.Arguments = $ie3lC.Array;
$90H0p('keys');
$90H0p('values');
$90H0p('entries');

});
parcelRegister("90H0p", function(module, exports) {
module.exports = function() {};

});

parcelRegister("gQit3", function(module, exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

});

parcelRegister("ie3lC", function(module, exports) {
module.exports = {};

});

parcelRegister("fPxf9", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $7Vp9q = parcelRequire("7Vp9q");

var $dVa69 = parcelRequire("dVa69");
module.exports = function(it) {
    return $7Vp9q($dVa69(it));
};

});
parcelRegister("7Vp9q", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $jt1RI = parcelRequire("jt1RI");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $jt1RI(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("jt1RI", function(module, exports) {
var $e2c22c2f575bd9a2$var$toString = {}.toString;
module.exports = function(it) {
    return $e2c22c2f575bd9a2$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("dVa69", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("2w2j0", function(module, exports) {
'use strict';

var $kQq1m = parcelRequire("kQq1m");

var $1AZ5u = parcelRequire("1AZ5u");

var $bB2oy = parcelRequire("bB2oy");

var $9ttfG = parcelRequire("9ttfG");

var $ie3lC = parcelRequire("ie3lC");

var $dyTkF = parcelRequire("dyTkF");

var $fZd8M = parcelRequire("fZd8M");

var $gZnbA = parcelRequire("gZnbA");

var $1d505bc8fec69785$var$ITERATOR = (parcelRequire("8FpOB"))('iterator');
var $1d505bc8fec69785$var$BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var $1d505bc8fec69785$var$FF_ITERATOR = '@@iterator';
var $1d505bc8fec69785$var$KEYS = 'keys';
var $1d505bc8fec69785$var$VALUES = 'values';
var $1d505bc8fec69785$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $dyTkF(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$1d505bc8fec69785$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $1d505bc8fec69785$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $1d505bc8fec69785$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == $1d505bc8fec69785$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$1d505bc8fec69785$var$ITERATOR] || proto[$1d505bc8fec69785$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $gZnbA($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $fZd8M(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$kQq1m && typeof IteratorPrototype[$1d505bc8fec69785$var$ITERATOR] != 'function') $9ttfG(IteratorPrototype, $1d505bc8fec69785$var$ITERATOR, $1d505bc8fec69785$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $1d505bc8fec69785$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$kQq1m || FORCED) && ($1d505bc8fec69785$var$BUGGY || VALUES_BUG || !proto[$1d505bc8fec69785$var$ITERATOR])) $9ttfG(proto, $1d505bc8fec69785$var$ITERATOR, $default);
    // Plug for library
    $ie3lC[NAME] = $default;
    $ie3lC[TAG] = $1d505bc8fec69785$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($1d505bc8fec69785$var$VALUES),
            keys: IS_SET ? $default : getMethod($1d505bc8fec69785$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $bB2oy(proto, key, methods[key]);
        } else $1AZ5u($1AZ5u.P + $1AZ5u.F * ($1d505bc8fec69785$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("kQq1m", function(module, exports) {
module.exports = true;

});

parcelRegister("bB2oy", function(module, exports) {

module.exports = (parcelRequire("9ttfG"));

});

parcelRegister("dyTkF", function(module, exports) {
'use strict';

var $lhdYS = parcelRequire("lhdYS");

var $eS6gR = parcelRequire("eS6gR");

var $fZd8M = parcelRequire("fZd8M");
var $028c47baa8089d69$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("9ttfG"))($028c47baa8089d69$var$IteratorPrototype, (parcelRequire("8FpOB"))('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $lhdYS($028c47baa8089d69$var$IteratorPrototype, {
        next: $eS6gR(1, next)
    });
    $fZd8M(Constructor, NAME + ' Iterator');
};

});
parcelRegister("lhdYS", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $3Otap = parcelRequire("3Otap");

var $hHCZG = parcelRequire("hHCZG");

var $akHJJ = parcelRequire("akHJJ");

var $f7d607d2c0516a90$var$IE_PROTO = (parcelRequire("jjGbX"))('IE_PROTO');
var $f7d607d2c0516a90$var$Empty = function() {};
var $f7d607d2c0516a90$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $f7d607d2c0516a90$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("3UJf0"))('iframe');
    var i = $akHJJ.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("fRBiE")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $f7d607d2c0516a90$var$createDict = iframeDocument.F;
    while(i--)delete $f7d607d2c0516a90$var$createDict[$f7d607d2c0516a90$var$PROTOTYPE][$akHJJ[i]];
    return $f7d607d2c0516a90$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $f7d607d2c0516a90$var$Empty[$f7d607d2c0516a90$var$PROTOTYPE] = $3Otap(O);
        result = new $f7d607d2c0516a90$var$Empty();
        $f7d607d2c0516a90$var$Empty[$f7d607d2c0516a90$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$f7d607d2c0516a90$var$IE_PROTO] = O;
    } else result = $f7d607d2c0516a90$var$createDict();
    return Properties === undefined ? result : $hHCZG(result, Properties);
};

});
parcelRegister("hHCZG", function(module, exports) {

var $bMqA1 = parcelRequire("bMqA1");

var $3Otap = parcelRequire("3Otap");

var $ikPq9 = parcelRequire("ikPq9");

module.exports = (parcelRequire("gcUbC")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $3Otap(O);
    var keys = $ikPq9(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$bMqA1.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("ikPq9", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $iPOpw = parcelRequire("iPOpw");

var $akHJJ = parcelRequire("akHJJ");
module.exports = Object.keys || function keys(O) {
    return $iPOpw(O, $akHJJ);
};

});
parcelRegister("iPOpw", function(module, exports) {

var $5NGXo = parcelRequire("5NGXo");

var $fPxf9 = parcelRequire("fPxf9");

var $db6417ebbd291a44$var$arrayIndexOf = (parcelRequire("AKPBX"))(false);

var $db6417ebbd291a44$var$IE_PROTO = (parcelRequire("jjGbX"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $fPxf9(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $db6417ebbd291a44$var$IE_PROTO) $5NGXo(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($5NGXo(O, key = names[i++])) ~$db6417ebbd291a44$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("AKPBX", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $fPxf9 = parcelRequire("fPxf9");

var $fItVy = parcelRequire("fItVy");

var $6ewe1 = parcelRequire("6ewe1");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $fPxf9($this);
        var length = $fItVy(O.length);
        var index = $6ewe1(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("fItVy", function(module, exports) {
// 7.1.15 ToLength

var $eFZTr = parcelRequire("eFZTr");
var $b7122e099de0a406$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $b7122e099de0a406$var$min($eFZTr(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("eFZTr", function(module, exports) {
// 7.1.4 ToInteger
var $aaf4e7ba8e0ec682$var$ceil = Math.ceil;
var $aaf4e7ba8e0ec682$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $aaf4e7ba8e0ec682$var$floor : $aaf4e7ba8e0ec682$var$ceil)(it);
};

});


parcelRegister("6ewe1", function(module, exports) {

var $eFZTr = parcelRequire("eFZTr");
var $489d0c1f5877718b$var$max = Math.max;
var $489d0c1f5877718b$var$min = Math.min;
module.exports = function(index, length) {
    index = $eFZTr(index);
    return index < 0 ? $489d0c1f5877718b$var$max(index + length, 0) : $489d0c1f5877718b$var$min(index, length);
};

});


parcelRegister("jjGbX", function(module, exports) {

var $e10085158c47a9f9$var$shared = (parcelRequire("9V7D7"))('keys');

var $38cef = parcelRequire("38cef");
module.exports = function(key) {
    return $e10085158c47a9f9$var$shared[key] || ($e10085158c47a9f9$var$shared[key] = $38cef(key));
};

});
parcelRegister("9V7D7", function(module, exports) {

var $iutpE = parcelRequire("iutpE");

var $cW64K = parcelRequire("cW64K");
var $738f5b17c2f71867$var$SHARED = '__core-js_shared__';
var $738f5b17c2f71867$var$store = $cW64K[$738f5b17c2f71867$var$SHARED] || ($cW64K[$738f5b17c2f71867$var$SHARED] = {});

(module.exports = function(key, value) {
    return $738f5b17c2f71867$var$store[key] || ($738f5b17c2f71867$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $iutpE.version,
    mode: (parcelRequire("kQq1m")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});

parcelRegister("38cef", function(module, exports) {
var $247b9ad2475236d3$var$id = 0;
var $247b9ad2475236d3$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$247b9ad2475236d3$var$id + $247b9ad2475236d3$var$px).toString(36));
};

});



parcelRegister("akHJJ", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});



parcelRegister("fRBiE", function(module, exports) {

var $cW64K = parcelRequire("cW64K");
var $b8c8bd386461e793$require$document = $cW64K.document;
module.exports = $b8c8bd386461e793$require$document && $b8c8bd386461e793$require$document.documentElement;

});


parcelRegister("fZd8M", function(module, exports) {

var $bMqA1 = parcelRequire("bMqA1");
var $ba36bef9c74c6463$require$def = $bMqA1.f;

var $5NGXo = parcelRequire("5NGXo");

var $ba36bef9c74c6463$var$TAG = (parcelRequire("8FpOB"))('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !$5NGXo(it = stat ? it : it.prototype, $ba36bef9c74c6463$var$TAG)) $ba36bef9c74c6463$require$def(it, $ba36bef9c74c6463$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("8FpOB", function(module, exports) {

var $64f62d70766c25f4$var$store = (parcelRequire("9V7D7"))('wks');

var $38cef = parcelRequire("38cef");

var $cW64K = parcelRequire("cW64K");
var $64f62d70766c25f4$require$Symbol = $cW64K.Symbol;
var $64f62d70766c25f4$var$USE_SYMBOL = typeof $64f62d70766c25f4$require$Symbol == 'function';
var $64f62d70766c25f4$var$$exports = module.exports = function(name) {
    return $64f62d70766c25f4$var$store[name] || ($64f62d70766c25f4$var$store[name] = $64f62d70766c25f4$var$USE_SYMBOL && $64f62d70766c25f4$require$Symbol[name] || ($64f62d70766c25f4$var$USE_SYMBOL ? $64f62d70766c25f4$require$Symbol : $38cef)('Symbol.' + name));
};
$64f62d70766c25f4$var$$exports.store = $64f62d70766c25f4$var$store;

});



parcelRegister("gZnbA", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $5NGXo = parcelRequire("5NGXo");

var $9kDPO = parcelRequire("9kDPO");

var $c5e454155c084862$var$IE_PROTO = (parcelRequire("jjGbX"))('IE_PROTO');
var $c5e454155c084862$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $9kDPO(O);
    if ($5NGXo(O, $c5e454155c084862$var$IE_PROTO)) return O[$c5e454155c084862$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $c5e454155c084862$var$ObjectProto : null;
};

});
parcelRegister("9kDPO", function(module, exports) {
// 7.1.13 ToObject(argument)

var $dVa69 = parcelRequire("dVa69");
module.exports = function(it) {
    return Object($dVa69(it));
};

});





parcelRegister("ecewl", function(module, exports) {
'use strict';

var $cW64K = parcelRequire("cW64K");

var $a55d7329d1ef56eb$var$each = (parcelRequire("kac7E"))(0);

var $bB2oy = parcelRequire("bB2oy");

var $e0mVj = parcelRequire("e0mVj");

var $6BrvE = parcelRequire("6BrvE");

var $dESMm = parcelRequire("dESMm");

var $jJprq = parcelRequire("jJprq");

var $gsqpA = parcelRequire("gsqpA");

var $gsqpA = parcelRequire("gsqpA");
var $a55d7329d1ef56eb$var$IS_IE11 = !$cW64K.ActiveXObject && 'ActiveXObject' in $cW64K;
var $a55d7329d1ef56eb$var$WEAK_MAP = 'WeakMap';
var $a55d7329d1ef56eb$var$getWeak = $e0mVj.getWeak;
var $a55d7329d1ef56eb$var$isExtensible = Object.isExtensible;
var $a55d7329d1ef56eb$var$uncaughtFrozenStore = $dESMm.ufstore;
var $a55d7329d1ef56eb$var$InternalMap;
var $a55d7329d1ef56eb$var$wrapper = function(get) {
    return function WeakMap() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
};
var $a55d7329d1ef56eb$var$methods = {
    // 23.3.3.3 WeakMap.prototype.get(key)
    get: function get(key) {
        if ($jJprq(key)) {
            var data = $a55d7329d1ef56eb$var$getWeak(key);
            if (data === true) return $a55d7329d1ef56eb$var$uncaughtFrozenStore($gsqpA(this, $a55d7329d1ef56eb$var$WEAK_MAP)).get(key);
            return data ? data[this._i] : undefined;
        }
    },
    // 23.3.3.5 WeakMap.prototype.set(key, value)
    set: function set(key, value) {
        return $dESMm.def($gsqpA(this, $a55d7329d1ef56eb$var$WEAK_MAP), key, value);
    }
};

// 23.3 WeakMap Objects
var $a55d7329d1ef56eb$var$$WeakMap = module.exports = (parcelRequire("lvqQH"))($a55d7329d1ef56eb$var$WEAK_MAP, $a55d7329d1ef56eb$var$wrapper, $a55d7329d1ef56eb$var$methods, $dESMm, true, true);
// IE11 WeakMap frozen keys fix
if ($gsqpA && $a55d7329d1ef56eb$var$IS_IE11) {
    $a55d7329d1ef56eb$var$InternalMap = $dESMm.getConstructor($a55d7329d1ef56eb$var$wrapper, $a55d7329d1ef56eb$var$WEAK_MAP);
    $6BrvE($a55d7329d1ef56eb$var$InternalMap.prototype, $a55d7329d1ef56eb$var$methods);
    $e0mVj.NEED = true;
    $a55d7329d1ef56eb$var$each([
        'delete',
        'has',
        'get',
        'set'
    ], function(key) {
        var proto = $a55d7329d1ef56eb$var$$WeakMap.prototype;
        var method = proto[key];
        $bB2oy(proto, key, function(a, b) {
            // store frozen objects on internal weakmap shim
            if ($jJprq(a) && !$a55d7329d1ef56eb$var$isExtensible(a)) {
                if (!this._f) this._f = new $a55d7329d1ef56eb$var$InternalMap();
                var result = this._f[key](a, b);
                return key == 'set' ? this : result;
            // store all the rest on native weakmap
            }
            return method.call(this, a, b);
        });
    });
}

});
parcelRegister("kac7E", function(module, exports) {
// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex

var $jSFZY = parcelRequire("jSFZY");

var $7Vp9q = parcelRequire("7Vp9q");

var $9kDPO = parcelRequire("9kDPO");

var $fItVy = parcelRequire("fItVy");

var $7DtCu = parcelRequire("7DtCu");
module.exports = function(TYPE, $create) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    var create = $create || $7DtCu;
    return function($this, callbackfn, that) {
        var O = $9kDPO($this);
        var self = $7Vp9q(O);
        var f = $jSFZY(callbackfn, that, 3);
        var length = $fItVy(self.length);
        var index = 0;
        var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
        var val, res;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            val = self[index];
            res = f(val, index, O);
            if (TYPE) {
                if (IS_MAP) result[index] = res; // map
                else if (res) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return val; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        result.push(val); // filter
                }
                else if (IS_EVERY) return false; // every
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
    };
};

});
parcelRegister("7DtCu", function(module, exports) {
// 9.4.2.3 ArraySpeciesCreate(originalArray, length)

var $6T08U = parcelRequire("6T08U");
module.exports = function(original, length) {
    return new ($6T08U(original))(length);
};

});
parcelRegister("6T08U", function(module, exports) {

var $jJprq = parcelRequire("jJprq");

var $g8A4L = parcelRequire("g8A4L");

var $5037fd7ae80568c8$var$SPECIES = (parcelRequire("8FpOB"))('species');
module.exports = function(original) {
    var C;
    if ($g8A4L(original)) {
        C = original.constructor;
        // cross-realm fallback
        if (typeof C == 'function' && (C === Array || $g8A4L(C.prototype))) C = undefined;
        if ($jJprq(C)) {
            C = C[$5037fd7ae80568c8$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? Array : C;
};

});
parcelRegister("g8A4L", function(module, exports) {
// 7.2.2 IsArray(argument)

var $jt1RI = parcelRequire("jt1RI");
module.exports = Array.isArray || function isArray(arg) {
    return $jt1RI(arg) == 'Array';
};

});




parcelRegister("e0mVj", function(module, exports) {

var $a322d8e6c8dc2de6$var$META = (parcelRequire("38cef"))('meta');

var $jJprq = parcelRequire("jJprq");

var $5NGXo = parcelRequire("5NGXo");

var $bMqA1 = parcelRequire("bMqA1");
var $a322d8e6c8dc2de6$require$setDesc = $bMqA1.f;
var $a322d8e6c8dc2de6$var$id = 0;
var $a322d8e6c8dc2de6$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $a322d8e6c8dc2de6$var$FREEZE = !(parcelRequire("4Uuph"))(function() {
    return $a322d8e6c8dc2de6$var$isExtensible(Object.preventExtensions({}));
});
var $a322d8e6c8dc2de6$var$setMeta = function(it) {
    $a322d8e6c8dc2de6$require$setDesc(it, $a322d8e6c8dc2de6$var$META, {
        value: {
            i: 'O' + ++$a322d8e6c8dc2de6$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $a322d8e6c8dc2de6$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$jJprq(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$5NGXo(it, $a322d8e6c8dc2de6$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$a322d8e6c8dc2de6$var$isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $a322d8e6c8dc2de6$var$setMeta(it);
    // return object ID
    }
    return it[$a322d8e6c8dc2de6$var$META].i;
};
var $a322d8e6c8dc2de6$var$getWeak = function(it, create) {
    if (!$5NGXo(it, $a322d8e6c8dc2de6$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$a322d8e6c8dc2de6$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $a322d8e6c8dc2de6$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$a322d8e6c8dc2de6$var$META].w;
};
// add metadata on freeze-family methods calling
var $a322d8e6c8dc2de6$var$onFreeze = function(it) {
    if ($a322d8e6c8dc2de6$var$FREEZE && $a322d8e6c8dc2de6$var$meta.NEED && $a322d8e6c8dc2de6$var$isExtensible(it) && !$5NGXo(it, $a322d8e6c8dc2de6$var$META)) $a322d8e6c8dc2de6$var$setMeta(it);
    return it;
};
var $a322d8e6c8dc2de6$var$meta = module.exports = {
    KEY: $a322d8e6c8dc2de6$var$META,
    NEED: false,
    fastKey: $a322d8e6c8dc2de6$var$fastKey,
    getWeak: $a322d8e6c8dc2de6$var$getWeak,
    onFreeze: $a322d8e6c8dc2de6$var$onFreeze
};

});

parcelRegister("6BrvE", function(module, exports) {
'use strict';

var $gcUbC = parcelRequire("gcUbC");

var $ikPq9 = parcelRequire("ikPq9");

var $ajVIn = parcelRequire("ajVIn");

var $7GUeD = parcelRequire("7GUeD");

var $9kDPO = parcelRequire("9kDPO");

var $7Vp9q = parcelRequire("7Vp9q");
var $4ceb8997fc02564c$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$4ceb8997fc02564c$var$$assign || (parcelRequire("4Uuph"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $4ceb8997fc02564c$var$$assign({}, A)[S] != 7 || Object.keys($4ceb8997fc02564c$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $9kDPO(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $ajVIn.f;
    var isEnum = $7GUeD.f;
    while(aLen > index){
        var S = $7Vp9q(arguments[index++]);
        var keys = getSymbols ? $ikPq9(S).concat(getSymbols(S)) : $ikPq9(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$gcUbC || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $4ceb8997fc02564c$var$$assign;

});
parcelRegister("ajVIn", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $783872af883e2dd8$export$2d1720544b23b823; }, function (v) { return $783872af883e2dd8$export$2d1720544b23b823 = v; });
var $783872af883e2dd8$export$2d1720544b23b823;
$783872af883e2dd8$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("7GUeD", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $599813c05efe0fe2$export$2d1720544b23b823; }, function (v) { return $599813c05efe0fe2$export$2d1720544b23b823 = v; });
var $599813c05efe0fe2$export$2d1720544b23b823;
$599813c05efe0fe2$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});


parcelRegister("dESMm", function(module, exports) {
'use strict';

var $icC0X = parcelRequire("icC0X");

var $e0mVj = parcelRequire("e0mVj");
var $9f1980bebf6e4f9d$require$getWeak = $e0mVj.getWeak;

var $3Otap = parcelRequire("3Otap");

var $jJprq = parcelRequire("jJprq");

var $kndNp = parcelRequire("kndNp");

var $6Mb2T = parcelRequire("6Mb2T");

var $kac7E = parcelRequire("kac7E");

var $5NGXo = parcelRequire("5NGXo");

var $gsqpA = parcelRequire("gsqpA");
var $9f1980bebf6e4f9d$var$arrayFind = $kac7E(5);
var $9f1980bebf6e4f9d$var$arrayFindIndex = $kac7E(6);
var $9f1980bebf6e4f9d$var$id = 0;
// fallback for uncaught frozen keys
var $9f1980bebf6e4f9d$var$uncaughtFrozenStore = function(that) {
    return that._l || (that._l = new $9f1980bebf6e4f9d$var$UncaughtFrozenStore());
};
var $9f1980bebf6e4f9d$var$UncaughtFrozenStore = function() {
    this.a = [];
};
var $9f1980bebf6e4f9d$var$findUncaughtFrozen = function(store, key) {
    return $9f1980bebf6e4f9d$var$arrayFind(store.a, function(it) {
        return it[0] === key;
    });
};
$9f1980bebf6e4f9d$var$UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = $9f1980bebf6e4f9d$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!$9f1980bebf6e4f9d$var$findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = $9f1980bebf6e4f9d$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.a.push([
            key,
            value
        ]);
    },
    'delete': function(key) {
        var index = $9f1980bebf6e4f9d$var$arrayFindIndex(this.a, function(it) {
            return it[0] === key;
        });
        if (~index) this.a.splice(index, 1);
        return !!~index;
    }
};
module.exports = {
    getConstructor: function(wrapper, NAME, IS_MAP, ADDER) {
        var C = wrapper(function(that, iterable) {
            $kndNp(that, C, NAME, '_i');
            that._t = NAME; // collection type
            that._i = $9f1980bebf6e4f9d$var$id++; // collection id
            that._l = undefined; // leak store for uncaught frozen objects
            if (iterable != undefined) $6Mb2T(iterable, IS_MAP, that[ADDER], that);
        });
        $icC0X(C.prototype, {
            // 23.3.3.2 WeakMap.prototype.delete(key)
            // 23.4.3.3 WeakSet.prototype.delete(value)
            'delete': function(key) {
                if (!$jJprq(key)) return false;
                var data = $9f1980bebf6e4f9d$require$getWeak(key);
                if (data === true) return $9f1980bebf6e4f9d$var$uncaughtFrozenStore($gsqpA(this, NAME))['delete'](key);
                return data && $5NGXo(data, this._i) && delete data[this._i];
            },
            // 23.3.3.4 WeakMap.prototype.has(key)
            // 23.4.3.4 WeakSet.prototype.has(value)
            has: function has(key) {
                if (!$jJprq(key)) return false;
                var data = $9f1980bebf6e4f9d$require$getWeak(key);
                if (data === true) return $9f1980bebf6e4f9d$var$uncaughtFrozenStore($gsqpA(this, NAME)).has(key);
                return data && $5NGXo(data, this._i);
            }
        });
        return C;
    },
    def: function(that, key, value) {
        var data = $9f1980bebf6e4f9d$require$getWeak($3Otap(key), true);
        if (data === true) $9f1980bebf6e4f9d$var$uncaughtFrozenStore(that).set(key, value);
        else data[that._i] = value;
        return that;
    },
    ufstore: $9f1980bebf6e4f9d$var$uncaughtFrozenStore
};

});
parcelRegister("icC0X", function(module, exports) {

var $9ttfG = parcelRequire("9ttfG");
module.exports = function(target, src, safe) {
    for(var key in src)if (safe && target[key]) target[key] = src[key];
    else $9ttfG(target, key, src[key]);
    return target;
};

});

parcelRegister("kndNp", function(module, exports) {
module.exports = function(it, Constructor, name, forbiddenField) {
    if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) throw TypeError(name + ': incorrect invocation!');
    return it;
};

});

parcelRegister("6Mb2T", function(module, exports) {

var $jSFZY = parcelRequire("jSFZY");

var $in68R = parcelRequire("in68R");

var $57Pgz = parcelRequire("57Pgz");

var $3Otap = parcelRequire("3Otap");

var $fItVy = parcelRequire("fItVy");

var $a6JFb = parcelRequire("a6JFb");
var $4eefcb2f3d773b86$var$BREAK = {};
var $4eefcb2f3d773b86$var$RETURN = {};
var $4eefcb2f3d773b86$var$exports = module.exports = function(iterable, entries, fn, that, ITERATOR) {
    var iterFn = ITERATOR ? function() {
        return iterable;
    } : $a6JFb(iterable);
    var f = $jSFZY(fn, that, entries ? 2 : 1);
    var index = 0;
    var length, step, iterator, result;
    if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
    // fast case for arrays with default iterator
    if ($57Pgz(iterFn)) for(length = $fItVy(iterable.length); length > index; index++){
        result = entries ? f($3Otap(step = iterable[index])[0], step[1]) : f(iterable[index]);
        if (result === $4eefcb2f3d773b86$var$BREAK || result === $4eefcb2f3d773b86$var$RETURN) return result;
    }
    else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done;){
        result = $in68R(iterator, f, step.value, entries);
        if (result === $4eefcb2f3d773b86$var$BREAK || result === $4eefcb2f3d773b86$var$RETURN) return result;
    }
};
$4eefcb2f3d773b86$var$exports.BREAK = $4eefcb2f3d773b86$var$BREAK;
$4eefcb2f3d773b86$var$exports.RETURN = $4eefcb2f3d773b86$var$RETURN;

});
parcelRegister("in68R", function(module, exports) {
// call something on iterator step with safe closing on error

var $3Otap = parcelRequire("3Otap");
module.exports = function(iterator, fn, value, entries) {
    try {
        return entries ? fn($3Otap(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
    } catch (e) {
        var ret = iterator['return'];
        if (ret !== undefined) $3Otap(ret.call(iterator));
        throw e;
    }
};

});

parcelRegister("57Pgz", function(module, exports) {
// check on default Array iterator

var $ie3lC = parcelRequire("ie3lC");

var $3bb55f9d624629f6$var$ITERATOR = (parcelRequire("8FpOB"))('iterator');
var $3bb55f9d624629f6$var$ArrayProto = Array.prototype;
module.exports = function(it) {
    return it !== undefined && ($ie3lC.Array === it || $3bb55f9d624629f6$var$ArrayProto[$3bb55f9d624629f6$var$ITERATOR] === it);
};

});

parcelRegister("a6JFb", function(module, exports) {

var $8yjk1 = parcelRequire("8yjk1");

var $75bde2abd94f0770$var$ITERATOR = (parcelRequire("8FpOB"))('iterator');

var $ie3lC = parcelRequire("ie3lC");

module.exports = (parcelRequire("iutpE")).getIteratorMethod = function(it) {
    if (it != undefined) return it[$75bde2abd94f0770$var$ITERATOR] || it['@@iterator'] || $ie3lC[$8yjk1(it)];
};

});
parcelRegister("8yjk1", function(module, exports) {
// getting tag from 19.1.3.6 Object.prototype.toString()

var $jt1RI = parcelRequire("jt1RI");

var $63a07ca3d9959f39$var$TAG = (parcelRequire("8FpOB"))('toStringTag');
// ES3 wrong here
var $63a07ca3d9959f39$var$ARG = $jt1RI(function() {
    return arguments;
}()) == 'Arguments';
// fallback for IE11 Script Access Denied error
var $63a07ca3d9959f39$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (e) {}
};
module.exports = function(it) {
    var O, T, B;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (T = $63a07ca3d9959f39$var$tryGet(O = Object(it), $63a07ca3d9959f39$var$TAG)) == 'string' ? T : $63a07ca3d9959f39$var$ARG ? $jt1RI(O) : (B = $jt1RI(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

});



parcelRegister("gsqpA", function(module, exports) {

var $jJprq = parcelRequire("jJprq");
module.exports = function(it, TYPE) {
    if (!$jJprq(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
    return it;
};

});


parcelRegister("lvqQH", function(module, exports) {
'use strict';

var $cW64K = parcelRequire("cW64K");

var $1AZ5u = parcelRequire("1AZ5u");

var $e0mVj = parcelRequire("e0mVj");

var $4Uuph = parcelRequire("4Uuph");

var $9ttfG = parcelRequire("9ttfG");

var $icC0X = parcelRequire("icC0X");

var $6Mb2T = parcelRequire("6Mb2T");

var $kndNp = parcelRequire("kndNp");

var $jJprq = parcelRequire("jJprq");

var $fZd8M = parcelRequire("fZd8M");

var $bMqA1 = parcelRequire("bMqA1");
var $fa8151d996d4bbe8$require$dP = $bMqA1.f;

var $fa8151d996d4bbe8$var$each = (parcelRequire("kac7E"))(0);

var $gcUbC = parcelRequire("gcUbC");
module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
    var Base = $cW64K[NAME];
    var C = Base;
    var ADDER = IS_MAP ? 'set' : 'add';
    var proto = C && C.prototype;
    var O = {};
    if (!$gcUbC || typeof C != 'function' || !(IS_WEAK || proto.forEach && !$4Uuph(function() {
        new C().entries().next();
    }))) {
        // create collection constructor
        C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
        $icC0X(C.prototype, methods);
        $e0mVj.NEED = true;
    } else {
        C = wrapper(function(target, iterable) {
            $kndNp(target, C, NAME, '_c');
            target._c = new Base();
            if (iterable != undefined) $6Mb2T(iterable, IS_MAP, target[ADDER], target);
        });
        $fa8151d996d4bbe8$var$each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function(KEY) {
            var IS_ADDER = KEY == 'add' || KEY == 'set';
            if (KEY in proto && !(IS_WEAK && KEY == 'clear')) $9ttfG(C.prototype, KEY, function(a, b) {
                $kndNp(this, C, KEY);
                if (!IS_ADDER && IS_WEAK && !$jJprq(a)) return KEY == 'get' ? undefined : false;
                var result = this._c[KEY](a === 0 ? 0 : a, b);
                return IS_ADDER ? this : result;
            });
        });
        IS_WEAK || $fa8151d996d4bbe8$require$dP(C.prototype, 'size', {
            get: function() {
                return this._c.size;
            }
        });
    }
    $fZd8M(C, NAME);
    O[NAME] = C;
    $1AZ5u($1AZ5u.G + $1AZ5u.W + $1AZ5u.F, O);
    if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
    return C;
};

});


parcelRegister("aLMuf", function(module, exports) {
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of

(parcelRequire("kZED6"))('WeakMap');

});
parcelRegister("kZED6", function(module, exports) {
'use strict';

var $1AZ5u = parcelRequire("1AZ5u");
module.exports = function(COLLECTION) {
    $1AZ5u($1AZ5u.S, COLLECTION, {
        of: function of() {
            var length = arguments.length;
            var A = new Array(length);
            while(length--)A[length] = arguments[length];
            return new this(A);
        }
    });
};

});


parcelRegister("3bbmc", function(module, exports) {
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from

(parcelRequire("bTgor"))('WeakMap');

});
parcelRegister("bTgor", function(module, exports) {
'use strict';

var $1AZ5u = parcelRequire("1AZ5u");

var $bQqJW = parcelRequire("bQqJW");

var $jSFZY = parcelRequire("jSFZY");

var $6Mb2T = parcelRequire("6Mb2T");
module.exports = function(COLLECTION) {
    $1AZ5u($1AZ5u.S, COLLECTION, {
        from: function from(source /* , mapFn, thisArg */ ) {
            var mapFn = arguments[1];
            var mapping, A, n, cb;
            $bQqJW(this);
            mapping = mapFn !== undefined;
            if (mapping) $bQqJW(mapFn);
            if (source == undefined) return new this();
            A = [];
            if (mapping) {
                n = 0;
                cb = $jSFZY(mapFn, arguments[2], 2);
                $6Mb2T(source, false, function(nextItem) {
                    A.push(cb(nextItem, n++));
                });
            } else $6Mb2T(source, false, A.push, A);
            return new this(A);
        }
    });
};

});



parcelRegister("1LXZS", function(module, exports) {
// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// ┌────────────────────────────────────────────────────────────┐ \\
// │ Eve 0.5.4 - JavaScript Events Library                      │ \\
// ├────────────────────────────────────────────────────────────┤ \\
// │ Author Dmitry Baranovskiy (http://dmitry.baranovskiy.com/) │ \\
// └────────────────────────────────────────────────────────────┘ \\
(function(glob) {
    var version = "0.5.4", has = "hasOwnProperty", separator = /[\.\/]/, comaseparator = /\s*,\s*/, wildcard = "*", numsort = function(a, b) {
        return a - b;
    }, current_event, stop, events = {
        n: {}
    }, firstDefined = function() {
        for(var i = 0, ii = this.length; i < ii; i++){
            if (typeof this[i] != "undefined") return this[i];
        }
    }, lastDefined = function() {
        var i = this.length;
        while(--i){
            if (typeof this[i] != "undefined") return this[i];
        }
    }, objtos = Object.prototype.toString, Str = String, isArray = Array.isArray || function(ar) {
        return ar instanceof Array || objtos.call(ar) == "[object Array]";
    }, /*\
     * eve
     [ method ]

     * Fires event with given `name`, given scope and other parameters.

     - name (string) name of the *event*, dot (`.`) or slash (`/`) separated
     - scope (object) context for the event handlers
     - varargs (...) the rest of arguments will be sent to event handlers

     = (object) array of returned values from the listeners. Array has two methods `.firstDefined()` and `.lastDefined()` to get first or last not `undefined` value.
    \*/ eve = function(name, scope) {
        var oldstop = stop, args = Array.prototype.slice.call(arguments, 2), listeners = eve.listeners(name), z = 0, l, indexed = [], queue = {}, out = [], ce = current_event;
        out.firstDefined = firstDefined;
        out.lastDefined = lastDefined;
        current_event = name;
        stop = 0;
        for(var i = 0, ii = listeners.length; i < ii; i++)if ("zIndex" in listeners[i]) {
            indexed.push(listeners[i].zIndex);
            if (listeners[i].zIndex < 0) queue[listeners[i].zIndex] = listeners[i];
        }
        indexed.sort(numsort);
        while(indexed[z] < 0){
            l = queue[indexed[z++]];
            out.push(l.apply(scope, args));
            if (stop) {
                stop = oldstop;
                return out;
            }
        }
        for(i = 0; i < ii; i++){
            l = listeners[i];
            if ("zIndex" in l) {
                if (l.zIndex == indexed[z]) {
                    out.push(l.apply(scope, args));
                    if (stop) break;
                    do {
                        z++;
                        l = queue[indexed[z]];
                        l && out.push(l.apply(scope, args));
                        if (stop) break;
                    }while (l);
                } else queue[l.zIndex] = l;
            } else {
                out.push(l.apply(scope, args));
                if (stop) break;
            }
        }
        stop = oldstop;
        current_event = ce;
        return out;
    };
    // Undocumented. Debug only.
    eve._events = events;
    /*\
     * eve.listeners
     [ method ]

     * Internal method which gives you array of all event handlers that will be triggered by the given `name`.

     - name (string) name of the event, dot (`.`) or slash (`/`) separated

     = (array) array of event handlers
    \*/ eve.listeners = function(name) {
        var names = isArray(name) ? name : name.split(separator), e = events, item, items, k, i, ii, j, jj, nes, es = [
            e
        ], out = [];
        for(i = 0, ii = names.length; i < ii; i++){
            nes = [];
            for(j = 0, jj = es.length; j < jj; j++){
                e = es[j].n;
                items = [
                    e[names[i]],
                    e[wildcard]
                ];
                k = 2;
                while(k--){
                    item = items[k];
                    if (item) {
                        nes.push(item);
                        out = out.concat(item.f || []);
                    }
                }
            }
            es = nes;
        }
        return out;
    };
    /*\
     * eve.separator
     [ method ]

     * If for some reasons you don’t like default separators (`.` or `/`) you can specify yours
     * here. Be aware that if you pass a string longer than one character it will be treated as
     * a list of characters.

     - separator (string) new separator. Empty string resets to default: `.` or `/`.
    \*/ eve.separator = function(sep) {
        if (sep) {
            sep = Str(sep).replace(/(?=[\.\^\]\[\-])/g, "\\");
            sep = "[" + sep + "]";
            separator = new RegExp(sep);
        } else separator = /[\.\/]/;
    };
    /*\
     * eve.on
     [ method ]
     **
     * Binds given event handler with a given name. You can use wildcards “`*`” for the names:
     | eve.on("*.under.*", f);
     | eve("mouse.under.floor"); // triggers f
     * Use @eve to trigger the listener.
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
     **
     - name (array) if you don’t want to use separators, you can use array of strings
     - f (function) event handler function
     **
     = (function) returned function accepts a single numeric parameter that represents z-index of the handler. It is an optional feature and only used when you need to ensure that some subset of handlers will be invoked in a given order, despite of the order of assignment.
     > Example:
     | eve.on("mouse", eatIt)(2);
     | eve.on("mouse", scream);
     | eve.on("mouse", catchIt)(1);
     * This will ensure that `catchIt` function will be called before `eatIt`.
     *
     * If you want to put your handler before non-indexed handlers, specify a negative value.
     * Note: I assume most of the time you don’t need to worry about z-index, but it’s nice to have this feature “just in case”.
    \*/ eve.on = function(name, f) {
        if (typeof f != "function") return function() {};
        var names = isArray(name) ? isArray(name[0]) ? name : [
            name
        ] : Str(name).split(comaseparator);
        for(var i = 0, ii = names.length; i < ii; i++)(function(name) {
            var names = isArray(name) ? name : Str(name).split(separator), e = events, exist;
            for(var i = 0, ii = names.length; i < ii; i++){
                e = e.n;
                e = e.hasOwnProperty(names[i]) && e[names[i]] || (e[names[i]] = {
                    n: {}
                });
            }
            e.f = e.f || [];
            for(i = 0, ii = e.f.length; i < ii; i++)if (e.f[i] == f) {
                exist = true;
                break;
            }
            !exist && e.f.push(f);
        })(names[i]);
        return function(zIndex) {
            if (+zIndex == +zIndex) f.zIndex = +zIndex;
        };
    };
    /*\
     * eve.f
     [ method ]
     **
     * Returns function that will fire given event with optional arguments.
     * Arguments that will be passed to the result function will be also
     * concated to the list of final arguments.
     | el.onclick = eve.f("click", 1, 2);
     | eve.on("click", function (a, b, c) {
     |     console.log(a, b, c); // 1, 2, [event object]
     | });
     - event (string) event name
     - varargs (…) and any other arguments
     = (function) possible event handler function
    \*/ eve.f = function(event) {
        var attrs = [].slice.call(arguments, 1);
        return function() {
            eve.apply(null, [
                event,
                null
            ].concat(attrs).concat([].slice.call(arguments, 0)));
        };
    };
    /*\
     * eve.stop
     [ method ]
     **
     * Is used inside an event handler to stop the event, preventing any subsequent listeners from firing.
    \*/ eve.stop = function() {
        stop = 1;
    };
    /*\
     * eve.nt
     [ method ]
     **
     * Could be used inside event handler to figure out actual name of the event.
     **
     - subname (string) #optional subname of the event
     **
     = (string) name of the event, if `subname` is not specified
     * or
     = (boolean) `true`, if current event’s name contains `subname`
    \*/ eve.nt = function(subname) {
        var cur = isArray(current_event) ? current_event.join(".") : current_event;
        if (subname) return new RegExp("(?:\\.|\\/|^)" + subname + "(?:\\.|\\/|$)").test(cur);
        return cur;
    };
    /*\
     * eve.nts
     [ method ]
     **
     * Could be used inside event handler to figure out actual name of the event.
     **
     **
     = (array) names of the event
    \*/ eve.nts = function() {
        return isArray(current_event) ? current_event : current_event.split(separator);
    };
    /*\
     * eve.off
     [ method ]
     **
     * Removes given function from the list of event listeners assigned to given name.
     * If no arguments specified all the events will be cleared.
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
    \*/ /*\
     * eve.unbind
     [ method ]
     **
     * See @eve.off
    \*/ eve.off = eve.unbind = function(name, f) {
        if (!name) {
            eve._events = events = {
                n: {}
            };
            return;
        }
        var names = isArray(name) ? isArray(name[0]) ? name : [
            name
        ] : Str(name).split(comaseparator);
        if (names.length > 1) {
            for(var i = 0, ii = names.length; i < ii; i++)eve.off(names[i], f);
            return;
        }
        names = isArray(name) ? name : Str(name).split(separator);
        var e, key, splice, i, ii, j, jj, cur = [
            events
        ], inodes = [];
        for(i = 0, ii = names.length; i < ii; i++)for(j = 0; j < cur.length; j += splice.length - 2){
            splice = [
                j,
                1
            ];
            e = cur[j].n;
            if (names[i] != wildcard) {
                if (e[names[i]]) {
                    splice.push(e[names[i]]);
                    inodes.unshift({
                        n: e,
                        name: names[i]
                    });
                }
            } else {
                for(key in e)if (e[has](key)) {
                    splice.push(e[key]);
                    inodes.unshift({
                        n: e,
                        name: key
                    });
                }
            }
            cur.splice.apply(cur, splice);
        }
        for(i = 0, ii = cur.length; i < ii; i++){
            e = cur[i];
            while(e.n){
                if (f) {
                    if (e.f) {
                        for(j = 0, jj = e.f.length; j < jj; j++)if (e.f[j] == f) {
                            e.f.splice(j, 1);
                            break;
                        }
                        !e.f.length && delete e.f;
                    }
                    for(key in e.n)if (e.n[has](key) && e.n[key].f) {
                        var funcs = e.n[key].f;
                        for(j = 0, jj = funcs.length; j < jj; j++)if (funcs[j] == f) {
                            funcs.splice(j, 1);
                            break;
                        }
                        !funcs.length && delete e.n[key].f;
                    }
                } else {
                    delete e.f;
                    for(key in e.n)if (e.n[has](key) && e.n[key].f) delete e.n[key].f;
                }
                e = e.n;
            }
        }
        // prune inner nodes in path
        prune: for(i = 0, ii = inodes.length; i < ii; i++){
            e = inodes[i];
            for(key in e.n[e.name].f)continue prune;
            for(key in e.n[e.name].n)continue prune;
            // is empty
            delete e.n[e.name];
        }
    };
    /*\
     * eve.once
     [ method ]
     **
     * Binds given event handler with a given name to only run once then unbind itself.
     | eve.once("login", f);
     | eve("login"); // triggers f
     | eve("login"); // no listeners
     * Use @eve to trigger the listener.
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
     **
     = (function) same return function as @eve.on
    \*/ eve.once = function(name, f) {
        var f2 = function() {
            eve.off(name, f2);
            return f.apply(this, arguments);
        };
        return eve.on(name, f2);
    };
    /*\
     * eve.version
     [ property (string) ]
     **
     * Current version of the library.
    \*/ eve.version = version;
    eve.toString = function() {
        return "You are running Eve " + version;
    };
    glob.eve = eve;
    (0, module.exports) ? module.exports = eve : typeof define === "function" && define.amd ? define("eve", [], function() {
        return eve;
    }) : glob.eve = eve;
})(typeof window != "undefined" ? window : module.exports);

});

parcelRegister("3BvQE", function(module, exports) {
/**
 * EvEmitter v2.1.1
 * Lil' event emitter
 * MIT License
 */ (function(global, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory();
    else // Browser globals
    global.EvEmitter = factory();
})(typeof window != 'undefined' ? window : module.exports, function() {
    function EvEmitter() {}
    let proto = EvEmitter.prototype;
    proto.on = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // set events hash
        let events = this._events = this._events || {};
        // set listeners array
        let listeners = events[eventName] = events[eventName] || [];
        // only add once
        if (!listeners.includes(listener)) listeners.push(listener);
        return this;
    };
    proto.once = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // add event
        this.on(eventName, listener);
        // set once flag
        // set onceEvents hash
        let onceEvents = this._onceEvents = this._onceEvents || {};
        // set onceListeners object
        let onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        // set flag
        onceListeners[listener] = true;
        return this;
    };
    proto.off = function(eventName, listener) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        let index = listeners.indexOf(listener);
        if (index != -1) listeners.splice(index, 1);
        return this;
    };
    proto.emitEvent = function(eventName, args) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        let onceListeners = this._onceEvents && this._onceEvents[eventName];
        for (let listener of listeners){
            let isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off(eventName, listener);
                // unset once flag
                delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
        }
        return this;
    };
    proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
        return this;
    };
    return EvEmitter;
});

});

parcelRegister("94H9l", function(module, exports) {
/*!
 * Vue.js v2.7.16
 * (c) 2014-2023 Evan You
 * Released under the MIT License.
 */ 'use strict';
const $69b5f56b6d1ac1d8$var$emptyObject = Object.freeze({});
const $69b5f56b6d1ac1d8$var$isArray = Array.isArray;
// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function $69b5f56b6d1ac1d8$var$isUndef(v) {
    return v === undefined || v === null;
}
function $69b5f56b6d1ac1d8$var$isDef(v) {
    return v !== undefined && v !== null;
}
function $69b5f56b6d1ac1d8$var$isTrue(v) {
    return v === true;
}
function $69b5f56b6d1ac1d8$var$isFalse(v) {
    return v === false;
}
/**
 * Check if value is primitive.
 */ function $69b5f56b6d1ac1d8$var$isPrimitive(value) {
    return typeof value === 'string' || typeof value === 'number' || // $flow-disable-line
    typeof value === 'symbol' || typeof value === 'boolean';
}
function $69b5f56b6d1ac1d8$var$isFunction(value) {
    return typeof value === 'function';
}
/**
 * Quick object check - this is primarily used to tell
 * objects from primitive values when we know the value
 * is a JSON-compliant type.
 */ function $69b5f56b6d1ac1d8$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
/**
 * Get the raw type string of a value, e.g., [object Object].
 */ const $69b5f56b6d1ac1d8$var$_toString = Object.prototype.toString;
function $69b5f56b6d1ac1d8$var$toRawType(value) {
    return $69b5f56b6d1ac1d8$var$_toString.call(value).slice(8, -1);
}
/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */ function $69b5f56b6d1ac1d8$var$isPlainObject(obj) {
    return $69b5f56b6d1ac1d8$var$_toString.call(obj) === '[object Object]';
}
function $69b5f56b6d1ac1d8$var$isRegExp(v) {
    return $69b5f56b6d1ac1d8$var$_toString.call(v) === '[object RegExp]';
}
/**
 * Check if val is a valid array index.
 */ function $69b5f56b6d1ac1d8$var$isValidArrayIndex(val) {
    const n = parseFloat(String(val));
    return n >= 0 && Math.floor(n) === n && isFinite(val);
}
function $69b5f56b6d1ac1d8$var$isPromise(val) {
    return $69b5f56b6d1ac1d8$var$isDef(val) && typeof val.then === 'function' && typeof val.catch === 'function';
}
/**
 * Convert a value to a string that is actually rendered.
 */ function $69b5f56b6d1ac1d8$var$toString(val) {
    return val == null ? '' : Array.isArray(val) || $69b5f56b6d1ac1d8$var$isPlainObject(val) && val.toString === $69b5f56b6d1ac1d8$var$_toString ? JSON.stringify(val, $69b5f56b6d1ac1d8$var$replacer, 2) : String(val);
}
function $69b5f56b6d1ac1d8$var$replacer(_key, val) {
    // avoid circular deps from v3
    if (val && val.__v_isRef) return val.value;
    return val;
}
/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */ function $69b5f56b6d1ac1d8$var$toNumber(val) {
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
}
/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */ function $69b5f56b6d1ac1d8$var$makeMap(str, expectsLowerCase) {
    const map = Object.create(null);
    const list = str.split(',');
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>map[val.toLowerCase()] : (val)=>map[val];
}
/**
 * Check if a tag is a built-in tag.
 */ const $69b5f56b6d1ac1d8$var$isBuiltInTag = $69b5f56b6d1ac1d8$var$makeMap('slot,component', true);
/**
 * Check if an attribute is a reserved attribute.
 */ const $69b5f56b6d1ac1d8$var$isReservedAttribute = $69b5f56b6d1ac1d8$var$makeMap('key,ref,slot,slot-scope,is');
/**
 * Remove an item from an array.
 */ function $69b5f56b6d1ac1d8$var$remove$2(arr, item) {
    const len = arr.length;
    if (len) {
        // fast path for the only / last item
        if (item === arr[len - 1]) {
            arr.length = len - 1;
            return;
        }
        const index = arr.indexOf(item);
        if (index > -1) return arr.splice(index, 1);
    }
}
/**
 * Check whether an object has the property.
 */ const $69b5f56b6d1ac1d8$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $69b5f56b6d1ac1d8$var$hasOwn(obj, key) {
    return $69b5f56b6d1ac1d8$var$hasOwnProperty.call(obj, key);
}
/**
 * Create a cached version of a pure function.
 */ function $69b5f56b6d1ac1d8$var$cached(fn) {
    const cache = Object.create(null);
    return function cachedFn(str) {
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
}
/**
 * Camelize a hyphen-delimited string.
 */ const $69b5f56b6d1ac1d8$var$camelizeRE = /-(\w)/g;
const $69b5f56b6d1ac1d8$var$camelize = $69b5f56b6d1ac1d8$var$cached((str)=>{
    return str.replace($69b5f56b6d1ac1d8$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : '');
});
/**
 * Capitalize a string.
 */ const $69b5f56b6d1ac1d8$var$capitalize = $69b5f56b6d1ac1d8$var$cached((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
/**
 * Hyphenate a camelCase string.
 */ const $69b5f56b6d1ac1d8$var$hyphenateRE = /\B([A-Z])/g;
const $69b5f56b6d1ac1d8$var$hyphenate = $69b5f56b6d1ac1d8$var$cached((str)=>{
    return str.replace($69b5f56b6d1ac1d8$var$hyphenateRE, '-$1').toLowerCase();
});
/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */ /* istanbul ignore next */ function $69b5f56b6d1ac1d8$var$polyfillBind(fn, ctx) {
    function boundFn(a) {
        const l = arguments.length;
        return l ? l > 1 ? fn.apply(ctx, arguments) : fn.call(ctx, a) : fn.call(ctx);
    }
    boundFn._length = fn.length;
    return boundFn;
}
function $69b5f56b6d1ac1d8$var$nativeBind(fn, ctx) {
    return fn.bind(ctx);
}
// @ts-expect-error bind cannot be `undefined`
const $69b5f56b6d1ac1d8$var$bind$1 = Function.prototype.bind ? $69b5f56b6d1ac1d8$var$nativeBind : $69b5f56b6d1ac1d8$var$polyfillBind;
/**
 * Convert an Array-like object to a real Array.
 */ function $69b5f56b6d1ac1d8$var$toArray(list, start) {
    start = start || 0;
    let i = list.length - start;
    const ret = new Array(i);
    while(i--)ret[i] = list[i + start];
    return ret;
}
/**
 * Mix properties into target object.
 */ function $69b5f56b6d1ac1d8$var$extend(to, _from) {
    for(const key in _from)to[key] = _from[key];
    return to;
}
/**
 * Merge an Array of Objects into a single Object.
 */ function $69b5f56b6d1ac1d8$var$toObject(arr) {
    const res = {};
    for(let i = 0; i < arr.length; i++)if (arr[i]) $69b5f56b6d1ac1d8$var$extend(res, arr[i]);
    return res;
}
/* eslint-disable no-unused-vars */ /**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */ function $69b5f56b6d1ac1d8$var$noop(a, b, c) {}
/**
 * Always return false.
 */ const $69b5f56b6d1ac1d8$var$no = (a, b, c)=>false;
/* eslint-enable no-unused-vars */ /**
 * Return the same value.
 */ const $69b5f56b6d1ac1d8$var$identity = (_)=>_;
/**
 * Generate a string containing static keys from compiler modules.
 */ function $69b5f56b6d1ac1d8$var$genStaticKeys$1(modules) {
    return modules.reduce((keys, m)=>keys.concat(m.staticKeys || []), []).join(',');
}
/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */ function $69b5f56b6d1ac1d8$var$looseEqual(a, b) {
    if (a === b) return true;
    const isObjectA = $69b5f56b6d1ac1d8$var$isObject(a);
    const isObjectB = $69b5f56b6d1ac1d8$var$isObject(b);
    if (isObjectA && isObjectB) try {
        const isArrayA = Array.isArray(a);
        const isArrayB = Array.isArray(b);
        if (isArrayA && isArrayB) return a.length === b.length && a.every((e, i)=>{
            return $69b5f56b6d1ac1d8$var$looseEqual(e, b[i]);
        });
        else if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
        else if (!isArrayA && !isArrayB) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            return keysA.length === keysB.length && keysA.every((key)=>{
                return $69b5f56b6d1ac1d8$var$looseEqual(a[key], b[key]);
            });
        } else /* istanbul ignore next */ return false;
    } catch (e) {
        /* istanbul ignore next */ return false;
    }
    else if (!isObjectA && !isObjectB) return String(a) === String(b);
    else return false;
}
/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */ function $69b5f56b6d1ac1d8$var$looseIndexOf(arr, val) {
    for(let i = 0; i < arr.length; i++){
        if ($69b5f56b6d1ac1d8$var$looseEqual(arr[i], val)) return i;
    }
    return -1;
}
/**
 * Ensure a function is called only once.
 */ function $69b5f56b6d1ac1d8$var$once(fn) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            fn.apply(this, arguments);
        }
    };
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is#polyfill
function $69b5f56b6d1ac1d8$var$hasChanged(x, y) {
    if (x === y) return x === 0 && 1 / x !== 1 / y;
    else return x === x || y === y;
}
const $69b5f56b6d1ac1d8$var$SSR_ATTR = 'data-server-rendered';
const $69b5f56b6d1ac1d8$var$ASSET_TYPES = [
    'component',
    'directive',
    'filter'
];
const $69b5f56b6d1ac1d8$var$LIFECYCLE_HOOKS = [
    'beforeCreate',
    'created',
    'beforeMount',
    'mounted',
    'beforeUpdate',
    'updated',
    'beforeDestroy',
    'destroyed',
    'activated',
    'deactivated',
    'errorCaptured',
    'serverPrefetch',
    'renderTracked',
    'renderTriggered'
];
var $69b5f56b6d1ac1d8$var$config = {
    /**
     * Option merge strategies (used in core/util/options)
     */ // $flow-disable-line
    optionMergeStrategies: Object.create(null),
    /**
     * Whether to suppress warnings.
     */ silent: false,
    /**
     * Show production mode tip message on boot?
     */ productionTip: true,
    /**
     * Whether to enable devtools
     */ devtools: true,
    /**
     * Whether to record perf
     */ performance: false,
    /**
     * Error handler for watcher errors
     */ errorHandler: null,
    /**
     * Warn handler for watcher warns
     */ warnHandler: null,
    /**
     * Ignore certain custom elements
     */ ignoredElements: [],
    /**
     * Custom user key aliases for v-on
     */ // $flow-disable-line
    keyCodes: Object.create(null),
    /**
     * Check if a tag is reserved so that it cannot be registered as a
     * component. This is platform-dependent and may be overwritten.
     */ isReservedTag: $69b5f56b6d1ac1d8$var$no,
    /**
     * Check if an attribute is reserved so that it cannot be used as a component
     * prop. This is platform-dependent and may be overwritten.
     */ isReservedAttr: $69b5f56b6d1ac1d8$var$no,
    /**
     * Check if a tag is an unknown element.
     * Platform-dependent.
     */ isUnknownElement: $69b5f56b6d1ac1d8$var$no,
    /**
     * Get the namespace of an element
     */ getTagNamespace: $69b5f56b6d1ac1d8$var$noop,
    /**
     * Parse the real tag name for the specific platform.
     */ parsePlatformTagName: $69b5f56b6d1ac1d8$var$identity,
    /**
     * Check if an attribute must be bound using property, e.g. value
     * Platform-dependent.
     */ mustUseProp: $69b5f56b6d1ac1d8$var$no,
    /**
     * Perform updates asynchronously. Intended to be used by Vue Test Utils
     * This will significantly reduce performance if set to false.
     */ async: true,
    /**
     * Exposed for legacy reasons
     */ _lifecycleHooks: $69b5f56b6d1ac1d8$var$LIFECYCLE_HOOKS
};
/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */ const $69b5f56b6d1ac1d8$var$unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;
/**
 * Check if a string starts with $ or _
 */ function $69b5f56b6d1ac1d8$var$isReserved(str) {
    const c = (str + '').charCodeAt(0);
    return c === 0x24 || c === 0x5f;
}
/**
 * Define a property.
 */ function $69b5f56b6d1ac1d8$var$def(obj, key, val, enumerable) {
    Object.defineProperty(obj, key, {
        value: val,
        enumerable: !!enumerable,
        writable: true,
        configurable: true
    });
}
/**
 * Parse simple path.
 */ const $69b5f56b6d1ac1d8$var$bailRE = new RegExp(`[^${$69b5f56b6d1ac1d8$var$unicodeRegExp.source}.$_\\d]`);
function $69b5f56b6d1ac1d8$var$parsePath(path) {
    if ($69b5f56b6d1ac1d8$var$bailRE.test(path)) return;
    const segments = path.split('.');
    return function(obj) {
        for(let i = 0; i < segments.length; i++){
            if (!obj) return;
            obj = obj[segments[i]];
        }
        return obj;
    };
}
// can we use __proto__?
const $69b5f56b6d1ac1d8$var$hasProto = '__proto__' in {};
// Browser environment sniffing
const $69b5f56b6d1ac1d8$var$inBrowser = typeof window !== 'undefined';
const $69b5f56b6d1ac1d8$var$UA = $69b5f56b6d1ac1d8$var$inBrowser && window.navigator.userAgent.toLowerCase();
const $69b5f56b6d1ac1d8$var$isIE = $69b5f56b6d1ac1d8$var$UA && /msie|trident/.test($69b5f56b6d1ac1d8$var$UA);
const $69b5f56b6d1ac1d8$var$isIE9 = $69b5f56b6d1ac1d8$var$UA && $69b5f56b6d1ac1d8$var$UA.indexOf('msie 9.0') > 0;
const $69b5f56b6d1ac1d8$var$isEdge = $69b5f56b6d1ac1d8$var$UA && $69b5f56b6d1ac1d8$var$UA.indexOf('edge/') > 0;
$69b5f56b6d1ac1d8$var$UA && $69b5f56b6d1ac1d8$var$UA.indexOf('android');
const $69b5f56b6d1ac1d8$var$isIOS = $69b5f56b6d1ac1d8$var$UA && /iphone|ipad|ipod|ios/.test($69b5f56b6d1ac1d8$var$UA);
$69b5f56b6d1ac1d8$var$UA && /chrome\/\d+/.test($69b5f56b6d1ac1d8$var$UA) && $69b5f56b6d1ac1d8$var$isEdge;
$69b5f56b6d1ac1d8$var$UA && /phantomjs/.test($69b5f56b6d1ac1d8$var$UA);
const $69b5f56b6d1ac1d8$var$isFF = $69b5f56b6d1ac1d8$var$UA && $69b5f56b6d1ac1d8$var$UA.match(/firefox\/(\d+)/);
// Firefox has a "watch" function on Object.prototype...
// @ts-expect-error firebox support
const $69b5f56b6d1ac1d8$var$nativeWatch = {}.watch;
let $69b5f56b6d1ac1d8$var$supportsPassive = false;
if ($69b5f56b6d1ac1d8$var$inBrowser) try {
    const opts = {};
    Object.defineProperty(opts, 'passive', {
        get () {
            /* istanbul ignore next */ $69b5f56b6d1ac1d8$var$supportsPassive = true;
        }
    }); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
} catch (e) {}
// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
let $69b5f56b6d1ac1d8$var$_isServer;
const $69b5f56b6d1ac1d8$var$isServerRendering = ()=>{
    if ($69b5f56b6d1ac1d8$var$_isServer === undefined) {
        /* istanbul ignore if */ if (!$69b5f56b6d1ac1d8$var$inBrowser && typeof $parcel$global !== 'undefined') // detect presence of vue-server-renderer and avoid
        // Webpack shimming the process
        $69b5f56b6d1ac1d8$var$_isServer = $parcel$global['process'] && $parcel$global['process'].env.VUE_ENV === 'server';
        else $69b5f56b6d1ac1d8$var$_isServer = false;
    }
    return $69b5f56b6d1ac1d8$var$_isServer;
};
// detect devtools
const $69b5f56b6d1ac1d8$var$devtools = $69b5f56b6d1ac1d8$var$inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
/* istanbul ignore next */ function $69b5f56b6d1ac1d8$var$isNative(Ctor) {
    return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
}
const $69b5f56b6d1ac1d8$var$hasSymbol = typeof Symbol !== 'undefined' && $69b5f56b6d1ac1d8$var$isNative(Symbol) && typeof Reflect !== 'undefined' && $69b5f56b6d1ac1d8$var$isNative(Reflect.ownKeys);
let $69b5f56b6d1ac1d8$var$_Set; // $flow-disable-line
/* istanbul ignore if */ if (typeof Set !== 'undefined' && $69b5f56b6d1ac1d8$var$isNative(Set)) // use native Set when available.
$69b5f56b6d1ac1d8$var$_Set = Set;
else // a non-standard Set polyfill that only works with primitive keys.
$69b5f56b6d1ac1d8$var$_Set = class Set1 {
    constructor(){
        this.set = Object.create(null);
    }
    has(key) {
        return this.set[key] === true;
    }
    add(key) {
        this.set[key] = true;
    }
    clear() {
        this.set = Object.create(null);
    }
};
let $69b5f56b6d1ac1d8$var$currentInstance = null;
/**
 * This is exposed for compatibility with v3 (e.g. some functions in VueUse
 * relies on it). Do not use this internally, just use `currentInstance`.
 *
 * @internal this function needs manual type declaration because it relies
 * on previously manually authored types from Vue 2
 */ function $69b5f56b6d1ac1d8$var$getCurrentInstance() {
    return $69b5f56b6d1ac1d8$var$currentInstance && {
        proxy: $69b5f56b6d1ac1d8$var$currentInstance
    };
}
/**
 * @internal
 */ function $69b5f56b6d1ac1d8$var$setCurrentInstance(vm = null) {
    if (!vm) $69b5f56b6d1ac1d8$var$currentInstance && $69b5f56b6d1ac1d8$var$currentInstance._scope.off();
    $69b5f56b6d1ac1d8$var$currentInstance = vm;
    vm && vm._scope.on();
}
/**
 * @internal
 */ class $69b5f56b6d1ac1d8$var$VNode {
    constructor(tag, data, children, text, elm, context, componentOptions, asyncFactory){
        this.tag = tag;
        this.data = data;
        this.children = children;
        this.text = text;
        this.elm = elm;
        this.ns = undefined;
        this.context = context;
        this.fnContext = undefined;
        this.fnOptions = undefined;
        this.fnScopeId = undefined;
        this.key = data && data.key;
        this.componentOptions = componentOptions;
        this.componentInstance = undefined;
        this.parent = undefined;
        this.raw = false;
        this.isStatic = false;
        this.isRootInsert = true;
        this.isComment = false;
        this.isCloned = false;
        this.isOnce = false;
        this.asyncFactory = asyncFactory;
        this.asyncMeta = undefined;
        this.isAsyncPlaceholder = false;
    }
    // DEPRECATED: alias for componentInstance for backwards compat.
    /* istanbul ignore next */ get child() {
        return this.componentInstance;
    }
}
const $69b5f56b6d1ac1d8$var$createEmptyVNode = (text = '')=>{
    const node = new $69b5f56b6d1ac1d8$var$VNode();
    node.text = text;
    node.isComment = true;
    return node;
};
function $69b5f56b6d1ac1d8$var$createTextVNode(val) {
    return new $69b5f56b6d1ac1d8$var$VNode(undefined, undefined, undefined, String(val));
}
// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function $69b5f56b6d1ac1d8$var$cloneVNode(vnode) {
    const cloned = new $69b5f56b6d1ac1d8$var$VNode(vnode.tag, vnode.data, // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(), vnode.text, vnode.elm, vnode.context, vnode.componentOptions, vnode.asyncFactory);
    cloned.ns = vnode.ns;
    cloned.isStatic = vnode.isStatic;
    cloned.key = vnode.key;
    cloned.isComment = vnode.isComment;
    cloned.fnContext = vnode.fnContext;
    cloned.fnOptions = vnode.fnOptions;
    cloned.fnScopeId = vnode.fnScopeId;
    cloned.asyncMeta = vnode.asyncMeta;
    cloned.isCloned = true;
    return cloned;
}
/* not type checking this file because flow doesn't play well with Proxy */ let $69b5f56b6d1ac1d8$var$initProxy;
{
    const allowedGlobals = $69b5f56b6d1ac1d8$var$makeMap("Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,require" // for Webpack/Browserify
    );
    const warnNonPresent = (target, key)=>{
        $69b5f56b6d1ac1d8$var$warn$2(`Property or method "${key}" is not defined on the instance but ` + 'referenced during render. Make sure that this property is reactive, ' + 'either in the data option, or for class-based components, by ' + 'initializing the property. ' + 'See: https://v2.vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.', target);
    };
    const warnReservedPrefix = (target, key)=>{
        $69b5f56b6d1ac1d8$var$warn$2(`Property "${key}" must be accessed with "$data.${key}" because ` + 'properties starting with "$" or "_" are not proxied in the Vue instance to ' + 'prevent conflicts with Vue internals. ' + 'See: https://v2.vuejs.org/v2/api/#data', target);
    };
    const hasProxy = typeof Proxy !== 'undefined' && $69b5f56b6d1ac1d8$var$isNative(Proxy);
    if (hasProxy) {
        const isBuiltInModifier = $69b5f56b6d1ac1d8$var$makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
        $69b5f56b6d1ac1d8$var$config.keyCodes = new Proxy($69b5f56b6d1ac1d8$var$config.keyCodes, {
            set (target, key, value) {
                if (isBuiltInModifier(key)) {
                    $69b5f56b6d1ac1d8$var$warn$2(`Avoid overwriting built-in modifier in config.keyCodes: .${key}`);
                    return false;
                } else {
                    target[key] = value;
                    return true;
                }
            }
        });
    }
    const hasHandler = {
        has (target, key) {
            const has = key in target;
            const isAllowed = allowedGlobals(key) || typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data);
            if (!has && !isAllowed) {
                if (key in target.$data) warnReservedPrefix(target, key);
                else warnNonPresent(target, key);
            }
            return has || !isAllowed;
        }
    };
    const getHandler = {
        get (target, key) {
            if (typeof key === 'string' && !(key in target)) {
                if (key in target.$data) warnReservedPrefix(target, key);
                else warnNonPresent(target, key);
            }
            return target[key];
        }
    };
    $69b5f56b6d1ac1d8$var$initProxy = function initProxy(vm) {
        if (hasProxy) {
            // determine which proxy handler to use
            const options = vm.$options;
            const handlers = options.render && options.render._withStripped ? getHandler : hasHandler;
            vm._renderProxy = new Proxy(vm, handlers);
        } else vm._renderProxy = vm;
    };
}let $69b5f56b6d1ac1d8$var$uid$2 = 0;
const $69b5f56b6d1ac1d8$var$pendingCleanupDeps = [];
const $69b5f56b6d1ac1d8$var$cleanupDeps = ()=>{
    for(let i = 0; i < $69b5f56b6d1ac1d8$var$pendingCleanupDeps.length; i++){
        const dep = $69b5f56b6d1ac1d8$var$pendingCleanupDeps[i];
        dep.subs = dep.subs.filter((s)=>s);
        dep._pending = false;
    }
    $69b5f56b6d1ac1d8$var$pendingCleanupDeps.length = 0;
};
/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 * @internal
 */ class $69b5f56b6d1ac1d8$var$Dep {
    constructor(){
        // pending subs cleanup
        this._pending = false;
        this.id = $69b5f56b6d1ac1d8$var$uid$2++;
        this.subs = [];
    }
    addSub(sub) {
        this.subs.push(sub);
    }
    removeSub(sub) {
        // #12696 deps with massive amount of subscribers are extremely slow to
        // clean up in Chromium
        // to workaround this, we unset the sub for now, and clear them on
        // next scheduler flush.
        this.subs[this.subs.indexOf(sub)] = null;
        if (!this._pending) {
            this._pending = true;
            $69b5f56b6d1ac1d8$var$pendingCleanupDeps.push(this);
        }
    }
    depend(info) {
        if ($69b5f56b6d1ac1d8$var$Dep.target) {
            $69b5f56b6d1ac1d8$var$Dep.target.addDep(this);
            if (info && $69b5f56b6d1ac1d8$var$Dep.target.onTrack) $69b5f56b6d1ac1d8$var$Dep.target.onTrack(Object.assign({
                effect: $69b5f56b6d1ac1d8$var$Dep.target
            }, info));
        }
    }
    notify(info) {
        // stabilize the subscriber list first
        const subs = this.subs.filter((s)=>s);
        if (!$69b5f56b6d1ac1d8$var$config.async) // subs aren't sorted in scheduler if not running async
        // we need to sort them now to make sure they fire in correct
        // order
        subs.sort((a, b)=>a.id - b.id);
        for(let i = 0, l = subs.length; i < l; i++){
            const sub = subs[i];
            if (info) sub.onTrigger && sub.onTrigger(Object.assign({
                effect: subs[i]
            }, info));
            sub.update();
        }
    }
}
// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
$69b5f56b6d1ac1d8$var$Dep.target = null;
const $69b5f56b6d1ac1d8$var$targetStack = [];
function $69b5f56b6d1ac1d8$var$pushTarget(target) {
    $69b5f56b6d1ac1d8$var$targetStack.push(target);
    $69b5f56b6d1ac1d8$var$Dep.target = target;
}
function $69b5f56b6d1ac1d8$var$popTarget() {
    $69b5f56b6d1ac1d8$var$targetStack.pop();
    $69b5f56b6d1ac1d8$var$Dep.target = $69b5f56b6d1ac1d8$var$targetStack[$69b5f56b6d1ac1d8$var$targetStack.length - 1];
}
/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */ const $69b5f56b6d1ac1d8$var$arrayProto = Array.prototype;
const $69b5f56b6d1ac1d8$var$arrayMethods = Object.create($69b5f56b6d1ac1d8$var$arrayProto);
const $69b5f56b6d1ac1d8$var$methodsToPatch = [
    'push',
    'pop',
    'shift',
    'unshift',
    'splice',
    'sort',
    'reverse'
];
/**
 * Intercept mutating methods and emit events
 */ $69b5f56b6d1ac1d8$var$methodsToPatch.forEach(function(method) {
    // cache original method
    const original = $69b5f56b6d1ac1d8$var$arrayProto[method];
    $69b5f56b6d1ac1d8$var$def($69b5f56b6d1ac1d8$var$arrayMethods, method, function mutator(...args) {
        const result = original.apply(this, args);
        const ob = this.__ob__;
        let inserted;
        switch(method){
            case 'push':
            case 'unshift':
                inserted = args;
                break;
            case 'splice':
                inserted = args.slice(2);
                break;
        }
        if (inserted) ob.observeArray(inserted);
        ob.dep.notify({
            type: "array mutation" /* TriggerOpTypes.ARRAY_MUTATION */ ,
            target: this,
            key: method
        });
        return result;
    });
});
const $69b5f56b6d1ac1d8$var$arrayKeys = Object.getOwnPropertyNames($69b5f56b6d1ac1d8$var$arrayMethods);
const $69b5f56b6d1ac1d8$var$NO_INITIAL_VALUE = {};
/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */ let $69b5f56b6d1ac1d8$var$shouldObserve = true;
function $69b5f56b6d1ac1d8$var$toggleObserving(value) {
    $69b5f56b6d1ac1d8$var$shouldObserve = value;
}
// ssr mock dep
const $69b5f56b6d1ac1d8$var$mockDep = {
    notify: $69b5f56b6d1ac1d8$var$noop,
    depend: $69b5f56b6d1ac1d8$var$noop,
    addSub: $69b5f56b6d1ac1d8$var$noop,
    removeSub: $69b5f56b6d1ac1d8$var$noop
};
/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */ class $69b5f56b6d1ac1d8$var$Observer {
    constructor(value, shallow = false, mock = false){
        this.value = value;
        this.shallow = shallow;
        this.mock = mock;
        // this.value = value
        this.dep = mock ? $69b5f56b6d1ac1d8$var$mockDep : new $69b5f56b6d1ac1d8$var$Dep();
        this.vmCount = 0;
        $69b5f56b6d1ac1d8$var$def(value, '__ob__', this);
        if ($69b5f56b6d1ac1d8$var$isArray(value)) {
            if (!mock) {
                if ($69b5f56b6d1ac1d8$var$hasProto) value.__proto__ = $69b5f56b6d1ac1d8$var$arrayMethods;
                else for(let i = 0, l = $69b5f56b6d1ac1d8$var$arrayKeys.length; i < l; i++){
                    const key = $69b5f56b6d1ac1d8$var$arrayKeys[i];
                    $69b5f56b6d1ac1d8$var$def(value, key, $69b5f56b6d1ac1d8$var$arrayMethods[key]);
                }
            }
            if (!shallow) this.observeArray(value);
        } else {
            /**
             * Walk through all properties and convert them into
             * getter/setters. This method should only be called when
             * value type is Object.
             */ const keys = Object.keys(value);
            for(let i = 0; i < keys.length; i++){
                const key = keys[i];
                $69b5f56b6d1ac1d8$var$defineReactive(value, key, $69b5f56b6d1ac1d8$var$NO_INITIAL_VALUE, undefined, shallow, mock);
            }
        }
    }
    /**
     * Observe a list of Array items.
     */ observeArray(value) {
        for(let i = 0, l = value.length; i < l; i++)$69b5f56b6d1ac1d8$var$observe(value[i], false, this.mock);
    }
}
// helpers
/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */ function $69b5f56b6d1ac1d8$var$observe(value, shallow, ssrMockReactivity) {
    if (value && $69b5f56b6d1ac1d8$var$hasOwn(value, '__ob__') && value.__ob__ instanceof $69b5f56b6d1ac1d8$var$Observer) return value.__ob__;
    if ($69b5f56b6d1ac1d8$var$shouldObserve && (ssrMockReactivity || !$69b5f56b6d1ac1d8$var$isServerRendering()) && ($69b5f56b6d1ac1d8$var$isArray(value) || $69b5f56b6d1ac1d8$var$isPlainObject(value)) && Object.isExtensible(value) && !value.__v_skip /* ReactiveFlags.SKIP */  && !$69b5f56b6d1ac1d8$var$isRef(value) && !(value instanceof $69b5f56b6d1ac1d8$var$VNode)) return new $69b5f56b6d1ac1d8$var$Observer(value, shallow, ssrMockReactivity);
}
/**
 * Define a reactive property on an Object.
 */ function $69b5f56b6d1ac1d8$var$defineReactive(obj, key, val, customSetter, shallow, mock, observeEvenIfShallow = false) {
    const dep = new $69b5f56b6d1ac1d8$var$Dep();
    const property = Object.getOwnPropertyDescriptor(obj, key);
    if (property && property.configurable === false) return;
    // cater for pre-defined getter/setters
    const getter = property && property.get;
    const setter = property && property.set;
    if ((!getter || setter) && (val === $69b5f56b6d1ac1d8$var$NO_INITIAL_VALUE || arguments.length === 2)) val = obj[key];
    let childOb = shallow ? val && val.__ob__ : $69b5f56b6d1ac1d8$var$observe(val, false, mock);
    Object.defineProperty(obj, key, {
        enumerable: true,
        configurable: true,
        get: function reactiveGetter() {
            const value = getter ? getter.call(obj) : val;
            if ($69b5f56b6d1ac1d8$var$Dep.target) {
                dep.depend({
                    target: obj,
                    type: "get" /* TrackOpTypes.GET */ ,
                    key: key
                });
                if (childOb) {
                    childOb.dep.depend();
                    if ($69b5f56b6d1ac1d8$var$isArray(value)) $69b5f56b6d1ac1d8$var$dependArray(value);
                }
            }
            return $69b5f56b6d1ac1d8$var$isRef(value) && !shallow ? value.value : value;
        },
        set: function reactiveSetter(newVal1) {
            const value = getter ? getter.call(obj) : val;
            if (!$69b5f56b6d1ac1d8$var$hasChanged(value, newVal1)) return;
            if (customSetter) customSetter();
            if (setter) setter.call(obj, newVal1);
            else if (getter) // #7981: for accessor properties without setter
            return;
            else if (!shallow && $69b5f56b6d1ac1d8$var$isRef(value) && !$69b5f56b6d1ac1d8$var$isRef(newVal1)) {
                value.value = newVal1;
                return;
            } else val = newVal1;
            childOb = shallow ? newVal1 && newVal1.__ob__ : $69b5f56b6d1ac1d8$var$observe(newVal1, false, mock);
            dep.notify({
                type: "set" /* TriggerOpTypes.SET */ ,
                target: obj,
                key: key,
                newValue: newVal1,
                oldValue: value
            });
        }
    });
    return dep;
}
function $69b5f56b6d1ac1d8$var$set(target, key, val) {
    if ($69b5f56b6d1ac1d8$var$isUndef(target) || $69b5f56b6d1ac1d8$var$isPrimitive(target)) $69b5f56b6d1ac1d8$var$warn$2(`Cannot set reactive property on undefined, null, or primitive value: ${target}`);
    if ($69b5f56b6d1ac1d8$var$isReadonly(target)) {
        $69b5f56b6d1ac1d8$var$warn$2(`Set operation on key "${key}" failed: target is readonly.`);
        return;
    }
    const ob = target.__ob__;
    if ($69b5f56b6d1ac1d8$var$isArray(target) && $69b5f56b6d1ac1d8$var$isValidArrayIndex(key)) {
        target.length = Math.max(target.length, key);
        target.splice(key, 1, val);
        // when mocking for SSR, array methods are not hijacked
        if (ob && !ob.shallow && ob.mock) $69b5f56b6d1ac1d8$var$observe(val, false, true);
        return val;
    }
    if (key in target && !(key in Object.prototype)) {
        target[key] = val;
        return val;
    }
    if (target._isVue || ob && ob.vmCount) {
        $69b5f56b6d1ac1d8$var$warn$2("Avoid adding reactive properties to a Vue instance or its root $data at runtime - declare it upfront in the data option.");
        return val;
    }
    if (!ob) {
        target[key] = val;
        return val;
    }
    $69b5f56b6d1ac1d8$var$defineReactive(ob.value, key, val, undefined, ob.shallow, ob.mock);
    ob.dep.notify({
        type: "add" /* TriggerOpTypes.ADD */ ,
        target: target,
        key: key,
        newValue: val,
        oldValue: undefined
    });
    return val;
}
function $69b5f56b6d1ac1d8$var$del(target, key) {
    if ($69b5f56b6d1ac1d8$var$isUndef(target) || $69b5f56b6d1ac1d8$var$isPrimitive(target)) $69b5f56b6d1ac1d8$var$warn$2(`Cannot delete reactive property on undefined, null, or primitive value: ${target}`);
    if ($69b5f56b6d1ac1d8$var$isArray(target) && $69b5f56b6d1ac1d8$var$isValidArrayIndex(key)) {
        target.splice(key, 1);
        return;
    }
    const ob = target.__ob__;
    if (target._isVue || ob && ob.vmCount) {
        $69b5f56b6d1ac1d8$var$warn$2("Avoid deleting properties on a Vue instance or its root $data - just set it to null.");
        return;
    }
    if ($69b5f56b6d1ac1d8$var$isReadonly(target)) {
        $69b5f56b6d1ac1d8$var$warn$2(`Delete operation on key "${key}" failed: target is readonly.`);
        return;
    }
    if (!$69b5f56b6d1ac1d8$var$hasOwn(target, key)) return;
    delete target[key];
    if (!ob) return;
    ob.dep.notify({
        type: "delete" /* TriggerOpTypes.DELETE */ ,
        target: target,
        key: key
    });
}
/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */ function $69b5f56b6d1ac1d8$var$dependArray(value) {
    for(let e, i = 0, l = value.length; i < l; i++){
        e = value[i];
        if (e && e.__ob__) e.__ob__.dep.depend();
        if ($69b5f56b6d1ac1d8$var$isArray(e)) $69b5f56b6d1ac1d8$var$dependArray(e);
    }
}
function $69b5f56b6d1ac1d8$var$reactive(target) {
    $69b5f56b6d1ac1d8$var$makeReactive(target, false);
    return target;
}
/**
 * Return a shallowly-reactive copy of the original object, where only the root
 * level properties are reactive. It also does not auto-unwrap refs (even at the
 * root level).
 */ function $69b5f56b6d1ac1d8$var$shallowReactive(target) {
    $69b5f56b6d1ac1d8$var$makeReactive(target, true);
    $69b5f56b6d1ac1d8$var$def(target, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */ , true);
    return target;
}
function $69b5f56b6d1ac1d8$var$makeReactive(target, shallow) {
    // if trying to observe a readonly proxy, return the readonly version.
    if (!$69b5f56b6d1ac1d8$var$isReadonly(target)) {
        {
            if ($69b5f56b6d1ac1d8$var$isArray(target)) $69b5f56b6d1ac1d8$var$warn$2(`Avoid using Array as root value for ${shallow ? `shallowReactive()` : `reactive()`} as it cannot be tracked in watch() or watchEffect(). Use ${shallow ? `shallowRef()` : `ref()`} instead. This is a Vue-2-only limitation.`);
            const existingOb = target && target.__ob__;
            if (existingOb && existingOb.shallow !== shallow) $69b5f56b6d1ac1d8$var$warn$2(`Target is already a ${existingOb.shallow ? `` : `non-`}shallow reactive object, and cannot be converted to ${shallow ? `` : `non-`}shallow.`);
        }
        const ob = $69b5f56b6d1ac1d8$var$observe(target, shallow, $69b5f56b6d1ac1d8$var$isServerRendering());
        if (!ob) {
            if (target == null || $69b5f56b6d1ac1d8$var$isPrimitive(target)) $69b5f56b6d1ac1d8$var$warn$2(`value cannot be made reactive: ${String(target)}`);
            if ($69b5f56b6d1ac1d8$var$isCollectionType(target)) $69b5f56b6d1ac1d8$var$warn$2(`Vue 2 does not support reactive collection types such as Map or Set.`);
        }
    }
}
function $69b5f56b6d1ac1d8$var$isReactive(value) {
    if ($69b5f56b6d1ac1d8$var$isReadonly(value)) return $69b5f56b6d1ac1d8$var$isReactive(value["__v_raw" /* ReactiveFlags.RAW */ ]);
    return !!(value && value.__ob__);
}
function $69b5f56b6d1ac1d8$var$isShallow(value) {
    return !!(value && value.__v_isShallow);
}
function $69b5f56b6d1ac1d8$var$isReadonly(value) {
    return !!(value && value.__v_isReadonly);
}
function $69b5f56b6d1ac1d8$var$isProxy(value) {
    return $69b5f56b6d1ac1d8$var$isReactive(value) || $69b5f56b6d1ac1d8$var$isReadonly(value);
}
function $69b5f56b6d1ac1d8$var$toRaw(observed) {
    const raw = observed && observed["__v_raw" /* ReactiveFlags.RAW */ ];
    return raw ? $69b5f56b6d1ac1d8$var$toRaw(raw) : observed;
}
function $69b5f56b6d1ac1d8$var$markRaw(value) {
    // non-extensible objects won't be observed anyway
    if (Object.isExtensible(value)) $69b5f56b6d1ac1d8$var$def(value, "__v_skip" /* ReactiveFlags.SKIP */ , true);
    return value;
}
/**
 * @internal
 */ function $69b5f56b6d1ac1d8$var$isCollectionType(value) {
    const type = $69b5f56b6d1ac1d8$var$toRawType(value);
    return type === 'Map' || type === 'WeakMap' || type === 'Set' || type === 'WeakSet';
}
/**
 * @internal
 */ const $69b5f56b6d1ac1d8$var$RefFlag = `__v_isRef`;
function $69b5f56b6d1ac1d8$var$isRef(r) {
    return !!(r && r.__v_isRef === true);
}
function $69b5f56b6d1ac1d8$var$ref$1(value) {
    return $69b5f56b6d1ac1d8$var$createRef(value, false);
}
function $69b5f56b6d1ac1d8$var$shallowRef(value) {
    return $69b5f56b6d1ac1d8$var$createRef(value, true);
}
function $69b5f56b6d1ac1d8$var$createRef(rawValue, shallow) {
    if ($69b5f56b6d1ac1d8$var$isRef(rawValue)) return rawValue;
    const ref = {};
    $69b5f56b6d1ac1d8$var$def(ref, $69b5f56b6d1ac1d8$var$RefFlag, true);
    $69b5f56b6d1ac1d8$var$def(ref, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */ , shallow);
    $69b5f56b6d1ac1d8$var$def(ref, 'dep', $69b5f56b6d1ac1d8$var$defineReactive(ref, 'value', rawValue, null, shallow, $69b5f56b6d1ac1d8$var$isServerRendering()));
    return ref;
}
function $69b5f56b6d1ac1d8$var$triggerRef(ref) {
    if (!ref.dep) $69b5f56b6d1ac1d8$var$warn$2(`received object is not a triggerable ref.`);
    ref.dep && ref.dep.notify({
        type: "set" /* TriggerOpTypes.SET */ ,
        target: ref,
        key: 'value'
    });
}
function $69b5f56b6d1ac1d8$var$unref(ref) {
    return $69b5f56b6d1ac1d8$var$isRef(ref) ? ref.value : ref;
}
function $69b5f56b6d1ac1d8$var$proxyRefs(objectWithRefs) {
    if ($69b5f56b6d1ac1d8$var$isReactive(objectWithRefs)) return objectWithRefs;
    const proxy = {};
    const keys = Object.keys(objectWithRefs);
    for(let i = 0; i < keys.length; i++)$69b5f56b6d1ac1d8$var$proxyWithRefUnwrap(proxy, objectWithRefs, keys[i]);
    return proxy;
}
function $69b5f56b6d1ac1d8$var$proxyWithRefUnwrap(target, source, key) {
    Object.defineProperty(target, key, {
        enumerable: true,
        configurable: true,
        get: ()=>{
            const val = source[key];
            if ($69b5f56b6d1ac1d8$var$isRef(val)) return val.value;
            else {
                const ob = val && val.__ob__;
                if (ob) ob.dep.depend();
                return val;
            }
        },
        set: (value)=>{
            const oldValue = source[key];
            if ($69b5f56b6d1ac1d8$var$isRef(oldValue) && !$69b5f56b6d1ac1d8$var$isRef(value)) oldValue.value = value;
            else source[key] = value;
        }
    });
}
function $69b5f56b6d1ac1d8$var$customRef(factory) {
    const dep = new $69b5f56b6d1ac1d8$var$Dep();
    const { get: get, set: set } = factory(()=>{
        dep.depend({
            target: ref,
            type: "get" /* TrackOpTypes.GET */ ,
            key: 'value'
        });
    }, ()=>{
        dep.notify({
            target: ref,
            type: "set" /* TriggerOpTypes.SET */ ,
            key: 'value'
        });
    });
    const ref = {
        get value () {
            return get();
        },
        set value (newVal){
            set(newVal);
        }
    };
    $69b5f56b6d1ac1d8$var$def(ref, $69b5f56b6d1ac1d8$var$RefFlag, true);
    return ref;
}
function $69b5f56b6d1ac1d8$var$toRefs(object) {
    if (!$69b5f56b6d1ac1d8$var$isReactive(object)) $69b5f56b6d1ac1d8$var$warn$2(`toRefs() expects a reactive object but received a plain one.`);
    const ret = $69b5f56b6d1ac1d8$var$isArray(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $69b5f56b6d1ac1d8$var$toRef(object, key);
    return ret;
}
function $69b5f56b6d1ac1d8$var$toRef(object, key, defaultValue) {
    const val = object[key];
    if ($69b5f56b6d1ac1d8$var$isRef(val)) return val;
    const ref = {
        get value () {
            const val = object[key];
            return val === undefined ? defaultValue : val;
        },
        set value (newVal){
            object[key] = newVal;
        }
    };
    $69b5f56b6d1ac1d8$var$def(ref, $69b5f56b6d1ac1d8$var$RefFlag, true);
    return ref;
}
const $69b5f56b6d1ac1d8$var$rawToReadonlyFlag = `__v_rawToReadonly`;
const $69b5f56b6d1ac1d8$var$rawToShallowReadonlyFlag = `__v_rawToShallowReadonly`;
function $69b5f56b6d1ac1d8$var$readonly(target) {
    return $69b5f56b6d1ac1d8$var$createReadonly(target, false);
}
function $69b5f56b6d1ac1d8$var$createReadonly(target, shallow) {
    if (!$69b5f56b6d1ac1d8$var$isPlainObject(target)) {
        if ($69b5f56b6d1ac1d8$var$isArray(target)) $69b5f56b6d1ac1d8$var$warn$2(`Vue 2 does not support readonly arrays.`);
        else if ($69b5f56b6d1ac1d8$var$isCollectionType(target)) $69b5f56b6d1ac1d8$var$warn$2(`Vue 2 does not support readonly collection types such as Map or Set.`);
        else $69b5f56b6d1ac1d8$var$warn$2(`value cannot be made readonly: ${typeof target}`);
        return target;
    }
    if (!Object.isExtensible(target)) $69b5f56b6d1ac1d8$var$warn$2(`Vue 2 does not support creating readonly proxy for non-extensible object.`);
    // already a readonly object
    if ($69b5f56b6d1ac1d8$var$isReadonly(target)) return target;
    // already has a readonly proxy
    const existingFlag = shallow ? $69b5f56b6d1ac1d8$var$rawToShallowReadonlyFlag : $69b5f56b6d1ac1d8$var$rawToReadonlyFlag;
    const existingProxy = target[existingFlag];
    if (existingProxy) return existingProxy;
    const proxy = Object.create(Object.getPrototypeOf(target));
    $69b5f56b6d1ac1d8$var$def(target, existingFlag, proxy);
    $69b5f56b6d1ac1d8$var$def(proxy, "__v_isReadonly" /* ReactiveFlags.IS_READONLY */ , true);
    $69b5f56b6d1ac1d8$var$def(proxy, "__v_raw" /* ReactiveFlags.RAW */ , target);
    if ($69b5f56b6d1ac1d8$var$isRef(target)) $69b5f56b6d1ac1d8$var$def(proxy, $69b5f56b6d1ac1d8$var$RefFlag, true);
    if (shallow || $69b5f56b6d1ac1d8$var$isShallow(target)) $69b5f56b6d1ac1d8$var$def(proxy, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */ , true);
    const keys = Object.keys(target);
    for(let i = 0; i < keys.length; i++)$69b5f56b6d1ac1d8$var$defineReadonlyProperty(proxy, target, keys[i], shallow);
    return proxy;
}
function $69b5f56b6d1ac1d8$var$defineReadonlyProperty(proxy, target, key, shallow) {
    Object.defineProperty(proxy, key, {
        enumerable: true,
        configurable: true,
        get () {
            const val = target[key];
            return shallow || !$69b5f56b6d1ac1d8$var$isPlainObject(val) ? val : $69b5f56b6d1ac1d8$var$readonly(val);
        },
        set () {
            $69b5f56b6d1ac1d8$var$warn$2(`Set operation on key "${key}" failed: target is readonly.`);
        }
    });
}
/**
 * Returns a reactive-copy of the original object, where only the root level
 * properties are readonly, and does NOT unwrap refs nor recursively convert
 * returned properties.
 * This is used for creating the props proxy object for stateful components.
 */ function $69b5f56b6d1ac1d8$var$shallowReadonly(target) {
    return $69b5f56b6d1ac1d8$var$createReadonly(target, true);
}
function $69b5f56b6d1ac1d8$var$computed(getterOrOptions, debugOptions) {
    let getter;
    let setter;
    const onlyGetter = $69b5f56b6d1ac1d8$var$isFunction(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = ()=>{
            $69b5f56b6d1ac1d8$var$warn$2('Write operation failed: computed value is readonly');
        };
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const watcher = $69b5f56b6d1ac1d8$var$isServerRendering() ? null : new $69b5f56b6d1ac1d8$var$Watcher($69b5f56b6d1ac1d8$var$currentInstance, getter, $69b5f56b6d1ac1d8$var$noop, {
        lazy: true
    });
    if (watcher && debugOptions) {
        watcher.onTrack = debugOptions.onTrack;
        watcher.onTrigger = debugOptions.onTrigger;
    }
    const ref = {
        // some libs rely on the presence effect for checking computed refs
        // from normal refs, but the implementation doesn't matter
        effect: watcher,
        get value () {
            if (watcher) {
                if (watcher.dirty) watcher.evaluate();
                if ($69b5f56b6d1ac1d8$var$Dep.target) {
                    if ($69b5f56b6d1ac1d8$var$Dep.target.onTrack) $69b5f56b6d1ac1d8$var$Dep.target.onTrack({
                        effect: $69b5f56b6d1ac1d8$var$Dep.target,
                        target: ref,
                        type: "get" /* TrackOpTypes.GET */ ,
                        key: 'value'
                    });
                    watcher.depend();
                }
                return watcher.value;
            } else return getter();
        },
        set value (newVal){
            setter(newVal);
        }
    };
    $69b5f56b6d1ac1d8$var$def(ref, $69b5f56b6d1ac1d8$var$RefFlag, true);
    $69b5f56b6d1ac1d8$var$def(ref, "__v_isReadonly" /* ReactiveFlags.IS_READONLY */ , onlyGetter);
    return ref;
}
let $69b5f56b6d1ac1d8$var$mark;
let $69b5f56b6d1ac1d8$var$measure;
{
    const perf = $69b5f56b6d1ac1d8$var$inBrowser && window.performance;
    /* istanbul ignore if */ if (perf && // @ts-ignore
    perf.mark && // @ts-ignore
    perf.measure && // @ts-ignore
    perf.clearMarks && // @ts-ignore
    perf.clearMeasures) {
        $69b5f56b6d1ac1d8$var$mark = (tag)=>perf.mark(tag);
        $69b5f56b6d1ac1d8$var$measure = (name, startTag, endTag)=>{
            perf.measure(name, startTag, endTag);
            perf.clearMarks(startTag);
            perf.clearMarks(endTag);
        // perf.clearMeasures(name)
        };
    }
}const $69b5f56b6d1ac1d8$var$normalizeEvent = $69b5f56b6d1ac1d8$var$cached((name)=>{
    const passive = name.charAt(0) === '&';
    name = passive ? name.slice(1) : name;
    const once = name.charAt(0) === '~'; // Prefixed last, checked first
    name = once ? name.slice(1) : name;
    const capture = name.charAt(0) === '!';
    name = capture ? name.slice(1) : name;
    return {
        name: name,
        once: once,
        capture: capture,
        passive: passive
    };
});
function $69b5f56b6d1ac1d8$var$createFnInvoker(fns, vm) {
    function invoker() {
        const fns = invoker.fns;
        if ($69b5f56b6d1ac1d8$var$isArray(fns)) {
            const cloned = fns.slice();
            for(let i = 0; i < cloned.length; i++)$69b5f56b6d1ac1d8$var$invokeWithErrorHandling(cloned[i], null, arguments, vm, `v-on handler`);
        } else // return handler return value for single handlers
        return $69b5f56b6d1ac1d8$var$invokeWithErrorHandling(fns, null, arguments, vm, `v-on handler`);
    }
    invoker.fns = fns;
    return invoker;
}
function $69b5f56b6d1ac1d8$var$updateListeners(on, oldOn, add, remove, createOnceHandler, vm) {
    let name, cur, old, event;
    for(name in on){
        cur = on[name];
        old = oldOn[name];
        event = $69b5f56b6d1ac1d8$var$normalizeEvent(name);
        if ($69b5f56b6d1ac1d8$var$isUndef(cur)) $69b5f56b6d1ac1d8$var$warn$2(`Invalid handler for event "${event.name}": got ` + String(cur), vm);
        else if ($69b5f56b6d1ac1d8$var$isUndef(old)) {
            if ($69b5f56b6d1ac1d8$var$isUndef(cur.fns)) cur = on[name] = $69b5f56b6d1ac1d8$var$createFnInvoker(cur, vm);
            if ($69b5f56b6d1ac1d8$var$isTrue(event.once)) cur = on[name] = createOnceHandler(event.name, cur, event.capture);
            add(event.name, cur, event.capture, event.passive, event.params);
        } else if (cur !== old) {
            old.fns = cur;
            on[name] = old;
        }
    }
    for(name in oldOn)if ($69b5f56b6d1ac1d8$var$isUndef(on[name])) {
        event = $69b5f56b6d1ac1d8$var$normalizeEvent(name);
        remove(event.name, oldOn[name], event.capture);
    }
}
function $69b5f56b6d1ac1d8$var$mergeVNodeHook(def, hookKey, hook) {
    if (def instanceof $69b5f56b6d1ac1d8$var$VNode) def = def.data.hook || (def.data.hook = {});
    let invoker;
    const oldHook = def[hookKey];
    function wrappedHook() {
        hook.apply(this, arguments);
        // important: remove merged hook to ensure it's called only once
        // and prevent memory leak
        $69b5f56b6d1ac1d8$var$remove$2(invoker.fns, wrappedHook);
    }
    if ($69b5f56b6d1ac1d8$var$isUndef(oldHook)) // no existing hook
    invoker = $69b5f56b6d1ac1d8$var$createFnInvoker([
        wrappedHook
    ]);
    else /* istanbul ignore if */ if ($69b5f56b6d1ac1d8$var$isDef(oldHook.fns) && $69b5f56b6d1ac1d8$var$isTrue(oldHook.merged)) {
        // already a merged invoker
        invoker = oldHook;
        invoker.fns.push(wrappedHook);
    } else // existing plain hook
    invoker = $69b5f56b6d1ac1d8$var$createFnInvoker([
        oldHook,
        wrappedHook
    ]);
    invoker.merged = true;
    def[hookKey] = invoker;
}
function $69b5f56b6d1ac1d8$var$extractPropsFromVNodeData(data, Ctor, tag) {
    // we are only extracting raw values here.
    // validation and default values are handled in the child
    // component itself.
    const propOptions = Ctor.options.props;
    if ($69b5f56b6d1ac1d8$var$isUndef(propOptions)) return;
    const res = {};
    const { attrs: attrs, props: props } = data;
    if ($69b5f56b6d1ac1d8$var$isDef(attrs) || $69b5f56b6d1ac1d8$var$isDef(props)) for(const key in propOptions){
        const altKey = $69b5f56b6d1ac1d8$var$hyphenate(key);
        {
            const keyInLowerCase = key.toLowerCase();
            if (key !== keyInLowerCase && attrs && $69b5f56b6d1ac1d8$var$hasOwn(attrs, keyInLowerCase)) $69b5f56b6d1ac1d8$var$tip(`Prop "${keyInLowerCase}" is passed to component ` + `${$69b5f56b6d1ac1d8$var$formatComponentName(// @ts-expect-error tag is string
            tag || Ctor)}, but the declared prop name is` + ` "${key}". ` + `Note that HTML attributes are case-insensitive and camelCased ` + `props need to use their kebab-case equivalents when using in-DOM ` + `templates. You should probably use "${altKey}" instead of "${key}".`);
        }
        $69b5f56b6d1ac1d8$var$checkProp(res, props, key, altKey, true) || $69b5f56b6d1ac1d8$var$checkProp(res, attrs, key, altKey, false);
    }
    return res;
}
function $69b5f56b6d1ac1d8$var$checkProp(res, hash, key, altKey, preserve) {
    if ($69b5f56b6d1ac1d8$var$isDef(hash)) {
        if ($69b5f56b6d1ac1d8$var$hasOwn(hash, key)) {
            res[key] = hash[key];
            if (!preserve) delete hash[key];
            return true;
        } else if ($69b5f56b6d1ac1d8$var$hasOwn(hash, altKey)) {
            res[key] = hash[altKey];
            if (!preserve) delete hash[altKey];
            return true;
        }
    }
    return false;
}
// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:
// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function $69b5f56b6d1ac1d8$var$simpleNormalizeChildren(children) {
    for(let i = 0; i < children.length; i++){
        if ($69b5f56b6d1ac1d8$var$isArray(children[i])) return Array.prototype.concat.apply([], children);
    }
    return children;
}
// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function $69b5f56b6d1ac1d8$var$normalizeChildren(children) {
    return $69b5f56b6d1ac1d8$var$isPrimitive(children) ? [
        $69b5f56b6d1ac1d8$var$createTextVNode(children)
    ] : $69b5f56b6d1ac1d8$var$isArray(children) ? $69b5f56b6d1ac1d8$var$normalizeArrayChildren(children) : undefined;
}
function $69b5f56b6d1ac1d8$var$isTextNode(node) {
    return $69b5f56b6d1ac1d8$var$isDef(node) && $69b5f56b6d1ac1d8$var$isDef(node.text) && $69b5f56b6d1ac1d8$var$isFalse(node.isComment);
}
function $69b5f56b6d1ac1d8$var$normalizeArrayChildren(children, nestedIndex) {
    const res = [];
    let i, c, lastIndex, last;
    for(i = 0; i < children.length; i++){
        c = children[i];
        if ($69b5f56b6d1ac1d8$var$isUndef(c) || typeof c === 'boolean') continue;
        lastIndex = res.length - 1;
        last = res[lastIndex];
        //  nested
        if ($69b5f56b6d1ac1d8$var$isArray(c)) {
            if (c.length > 0) {
                c = $69b5f56b6d1ac1d8$var$normalizeArrayChildren(c, `${nestedIndex || ''}_${i}`);
                // merge adjacent text nodes
                if ($69b5f56b6d1ac1d8$var$isTextNode(c[0]) && $69b5f56b6d1ac1d8$var$isTextNode(last)) {
                    res[lastIndex] = $69b5f56b6d1ac1d8$var$createTextVNode(last.text + c[0].text);
                    c.shift();
                }
                res.push.apply(res, c);
            }
        } else if ($69b5f56b6d1ac1d8$var$isPrimitive(c)) {
            if ($69b5f56b6d1ac1d8$var$isTextNode(last)) // merge adjacent text nodes
            // this is necessary for SSR hydration because text nodes are
            // essentially merged when rendered to HTML strings
            res[lastIndex] = $69b5f56b6d1ac1d8$var$createTextVNode(last.text + c);
            else if (c !== '') // convert primitive to vnode
            res.push($69b5f56b6d1ac1d8$var$createTextVNode(c));
        } else if ($69b5f56b6d1ac1d8$var$isTextNode(c) && $69b5f56b6d1ac1d8$var$isTextNode(last)) // merge adjacent text nodes
        res[lastIndex] = $69b5f56b6d1ac1d8$var$createTextVNode(last.text + c.text);
        else {
            // default key for nested array children (likely generated by v-for)
            if ($69b5f56b6d1ac1d8$var$isTrue(children._isVList) && $69b5f56b6d1ac1d8$var$isDef(c.tag) && $69b5f56b6d1ac1d8$var$isUndef(c.key) && $69b5f56b6d1ac1d8$var$isDef(nestedIndex)) c.key = `__vlist${nestedIndex}_${i}__`;
            res.push(c);
        }
    }
    return res;
}
const $69b5f56b6d1ac1d8$var$SIMPLE_NORMALIZE = 1;
const $69b5f56b6d1ac1d8$var$ALWAYS_NORMALIZE = 2;
// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function $69b5f56b6d1ac1d8$var$createElement$1(context, tag, data, children, normalizationType, alwaysNormalize) {
    if ($69b5f56b6d1ac1d8$var$isArray(data) || $69b5f56b6d1ac1d8$var$isPrimitive(data)) {
        normalizationType = children;
        children = data;
        data = undefined;
    }
    if ($69b5f56b6d1ac1d8$var$isTrue(alwaysNormalize)) normalizationType = $69b5f56b6d1ac1d8$var$ALWAYS_NORMALIZE;
    return $69b5f56b6d1ac1d8$var$_createElement(context, tag, data, children, normalizationType);
}
function $69b5f56b6d1ac1d8$var$_createElement(context, tag, data, children, normalizationType) {
    if ($69b5f56b6d1ac1d8$var$isDef(data) && $69b5f56b6d1ac1d8$var$isDef(data.__ob__)) {
        $69b5f56b6d1ac1d8$var$warn$2(`Avoid using observed data object as vnode data: ${JSON.stringify(data)}\n` + 'Always create fresh vnode data objects in each render!', context);
        return $69b5f56b6d1ac1d8$var$createEmptyVNode();
    }
    // object syntax in v-bind
    if ($69b5f56b6d1ac1d8$var$isDef(data) && $69b5f56b6d1ac1d8$var$isDef(data.is)) tag = data.is;
    if (!tag) // in case of component :is set to falsy value
    return $69b5f56b6d1ac1d8$var$createEmptyVNode();
    // warn against non-primitive key
    if ($69b5f56b6d1ac1d8$var$isDef(data) && $69b5f56b6d1ac1d8$var$isDef(data.key) && !$69b5f56b6d1ac1d8$var$isPrimitive(data.key)) $69b5f56b6d1ac1d8$var$warn$2("Avoid using non-primitive value as key, use string/number value instead.", context);
    // support single function children as default scoped slot
    if ($69b5f56b6d1ac1d8$var$isArray(children) && $69b5f56b6d1ac1d8$var$isFunction(children[0])) {
        data = data || {};
        data.scopedSlots = {
            default: children[0]
        };
        children.length = 0;
    }
    if (normalizationType === $69b5f56b6d1ac1d8$var$ALWAYS_NORMALIZE) children = $69b5f56b6d1ac1d8$var$normalizeChildren(children);
    else if (normalizationType === $69b5f56b6d1ac1d8$var$SIMPLE_NORMALIZE) children = $69b5f56b6d1ac1d8$var$simpleNormalizeChildren(children);
    let vnode, ns;
    if (typeof tag === 'string') {
        let Ctor;
        ns = context.$vnode && context.$vnode.ns || $69b5f56b6d1ac1d8$var$config.getTagNamespace(tag);
        if ($69b5f56b6d1ac1d8$var$config.isReservedTag(tag)) {
            // platform built-in elements
            if ($69b5f56b6d1ac1d8$var$isDef(data) && $69b5f56b6d1ac1d8$var$isDef(data.nativeOn) && data.tag !== 'component') $69b5f56b6d1ac1d8$var$warn$2(`The .native modifier for v-on is only valid on components but it was used on <${tag}>.`, context);
            vnode = new $69b5f56b6d1ac1d8$var$VNode($69b5f56b6d1ac1d8$var$config.parsePlatformTagName(tag), data, children, undefined, undefined, context);
        } else if ((!data || !data.pre) && $69b5f56b6d1ac1d8$var$isDef(Ctor = $69b5f56b6d1ac1d8$var$resolveAsset(context.$options, 'components', tag))) // component
        vnode = $69b5f56b6d1ac1d8$var$createComponent(Ctor, data, context, children, tag);
        else // unknown or unlisted namespaced elements
        // check at runtime because it may get assigned a namespace when its
        // parent normalizes children
        vnode = new $69b5f56b6d1ac1d8$var$VNode(tag, data, children, undefined, undefined, context);
    } else // direct component options / constructor
    vnode = $69b5f56b6d1ac1d8$var$createComponent(tag, data, context, children);
    if ($69b5f56b6d1ac1d8$var$isArray(vnode)) return vnode;
    else if ($69b5f56b6d1ac1d8$var$isDef(vnode)) {
        if ($69b5f56b6d1ac1d8$var$isDef(ns)) $69b5f56b6d1ac1d8$var$applyNS(vnode, ns);
        if ($69b5f56b6d1ac1d8$var$isDef(data)) $69b5f56b6d1ac1d8$var$registerDeepBindings(data);
        return vnode;
    } else return $69b5f56b6d1ac1d8$var$createEmptyVNode();
}
function $69b5f56b6d1ac1d8$var$applyNS(vnode, ns, force) {
    vnode.ns = ns;
    if (vnode.tag === 'foreignObject') {
        // use default namespace inside foreignObject
        ns = undefined;
        force = true;
    }
    if ($69b5f56b6d1ac1d8$var$isDef(vnode.children)) for(let i = 0, l = vnode.children.length; i < l; i++){
        const child = vnode.children[i];
        if ($69b5f56b6d1ac1d8$var$isDef(child.tag) && ($69b5f56b6d1ac1d8$var$isUndef(child.ns) || $69b5f56b6d1ac1d8$var$isTrue(force) && child.tag !== 'svg')) $69b5f56b6d1ac1d8$var$applyNS(child, ns, force);
    }
}
// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function $69b5f56b6d1ac1d8$var$registerDeepBindings(data) {
    if ($69b5f56b6d1ac1d8$var$isObject(data.style)) $69b5f56b6d1ac1d8$var$traverse(data.style);
    if ($69b5f56b6d1ac1d8$var$isObject(data.class)) $69b5f56b6d1ac1d8$var$traverse(data.class);
}
/**
 * Runtime helper for rendering v-for lists.
 */ function $69b5f56b6d1ac1d8$var$renderList(val, render) {
    let ret = null, i, l, keys, key;
    if ($69b5f56b6d1ac1d8$var$isArray(val) || typeof val === 'string') {
        ret = new Array(val.length);
        for(i = 0, l = val.length; i < l; i++)ret[i] = render(val[i], i);
    } else if (typeof val === 'number') {
        ret = new Array(val);
        for(i = 0; i < val; i++)ret[i] = render(i + 1, i);
    } else if ($69b5f56b6d1ac1d8$var$isObject(val)) {
        if ($69b5f56b6d1ac1d8$var$hasSymbol && val[Symbol.iterator]) {
            ret = [];
            const iterator = val[Symbol.iterator]();
            let result = iterator.next();
            while(!result.done){
                ret.push(render(result.value, ret.length));
                result = iterator.next();
            }
        } else {
            keys = Object.keys(val);
            ret = new Array(keys.length);
            for(i = 0, l = keys.length; i < l; i++){
                key = keys[i];
                ret[i] = render(val[key], key, i);
            }
        }
    }
    if (!$69b5f56b6d1ac1d8$var$isDef(ret)) ret = [];
    ret._isVList = true;
    return ret;
}
/**
 * Runtime helper for rendering <slot>
 */ function $69b5f56b6d1ac1d8$var$renderSlot(name, fallbackRender, props, bindObject) {
    const scopedSlotFn = this.$scopedSlots[name];
    let nodes;
    if (scopedSlotFn) {
        // scoped slot
        props = props || {};
        if (bindObject) {
            if (!$69b5f56b6d1ac1d8$var$isObject(bindObject)) $69b5f56b6d1ac1d8$var$warn$2('slot v-bind without argument expects an Object', this);
            props = $69b5f56b6d1ac1d8$var$extend($69b5f56b6d1ac1d8$var$extend({}, bindObject), props);
        }
        nodes = scopedSlotFn(props) || ($69b5f56b6d1ac1d8$var$isFunction(fallbackRender) ? fallbackRender() : fallbackRender);
    } else nodes = this.$slots[name] || ($69b5f56b6d1ac1d8$var$isFunction(fallbackRender) ? fallbackRender() : fallbackRender);
    const target = props && props.slot;
    if (target) return this.$createElement('template', {
        slot: target
    }, nodes);
    else return nodes;
}
/**
 * Runtime helper for resolving filters
 */ function $69b5f56b6d1ac1d8$var$resolveFilter(id) {
    return $69b5f56b6d1ac1d8$var$resolveAsset(this.$options, 'filters', id, true) || $69b5f56b6d1ac1d8$var$identity;
}
function $69b5f56b6d1ac1d8$var$isKeyNotMatch(expect, actual) {
    if ($69b5f56b6d1ac1d8$var$isArray(expect)) return expect.indexOf(actual) === -1;
    else return expect !== actual;
}
/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */ function $69b5f56b6d1ac1d8$var$checkKeyCodes(eventKeyCode, key, builtInKeyCode, eventKeyName, builtInKeyName) {
    const mappedKeyCode = $69b5f56b6d1ac1d8$var$config.keyCodes[key] || builtInKeyCode;
    if (builtInKeyName && eventKeyName && !$69b5f56b6d1ac1d8$var$config.keyCodes[key]) return $69b5f56b6d1ac1d8$var$isKeyNotMatch(builtInKeyName, eventKeyName);
    else if (mappedKeyCode) return $69b5f56b6d1ac1d8$var$isKeyNotMatch(mappedKeyCode, eventKeyCode);
    else if (eventKeyName) return $69b5f56b6d1ac1d8$var$hyphenate(eventKeyName) !== key;
    return eventKeyCode === undefined;
}
/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */ function $69b5f56b6d1ac1d8$var$bindObjectProps(data, tag, value, asProp, isSync) {
    if (value) {
        if (!$69b5f56b6d1ac1d8$var$isObject(value)) $69b5f56b6d1ac1d8$var$warn$2('v-bind without argument expects an Object or Array value', this);
        else {
            if ($69b5f56b6d1ac1d8$var$isArray(value)) value = $69b5f56b6d1ac1d8$var$toObject(value);
            let hash;
            for(const key in value){
                if (key === 'class' || key === 'style' || $69b5f56b6d1ac1d8$var$isReservedAttribute(key)) hash = data;
                else {
                    const type = data.attrs && data.attrs.type;
                    hash = asProp || $69b5f56b6d1ac1d8$var$config.mustUseProp(tag, type, key) ? data.domProps || (data.domProps = {}) : data.attrs || (data.attrs = {});
                }
                const camelizedKey = $69b5f56b6d1ac1d8$var$camelize(key);
                const hyphenatedKey = $69b5f56b6d1ac1d8$var$hyphenate(key);
                if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
                    hash[key] = value[key];
                    if (isSync) {
                        const on = data.on || (data.on = {});
                        on[`update:${key}`] = function($event) {
                            value[key] = $event;
                        };
                    }
                }
            }
        }
    }
    return data;
}
/**
 * Runtime helper for rendering static trees.
 */ function $69b5f56b6d1ac1d8$var$renderStatic(index, isInFor) {
    const cached = this._staticTrees || (this._staticTrees = []);
    let tree = cached[index];
    // if has already-rendered static tree and not inside v-for,
    // we can reuse the same tree.
    if (tree && !isInFor) return tree;
    // otherwise, render a fresh tree.
    tree = cached[index] = this.$options.staticRenderFns[index].call(this._renderProxy, this._c, this // for render fns generated for functional component templates
    );
    $69b5f56b6d1ac1d8$var$markStatic$1(tree, `__static__${index}`, false);
    return tree;
}
/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */ function $69b5f56b6d1ac1d8$var$markOnce(tree, index, key) {
    $69b5f56b6d1ac1d8$var$markStatic$1(tree, `__once__${index}${key ? `_${key}` : ``}`, true);
    return tree;
}
function $69b5f56b6d1ac1d8$var$markStatic$1(tree, key, isOnce) {
    if ($69b5f56b6d1ac1d8$var$isArray(tree)) {
        for(let i = 0; i < tree.length; i++)if (tree[i] && typeof tree[i] !== 'string') $69b5f56b6d1ac1d8$var$markStaticNode(tree[i], `${key}_${i}`, isOnce);
    } else $69b5f56b6d1ac1d8$var$markStaticNode(tree, key, isOnce);
}
function $69b5f56b6d1ac1d8$var$markStaticNode(node, key, isOnce) {
    node.isStatic = true;
    node.key = key;
    node.isOnce = isOnce;
}
function $69b5f56b6d1ac1d8$var$bindObjectListeners(data, value) {
    if (value) {
        if (!$69b5f56b6d1ac1d8$var$isPlainObject(value)) $69b5f56b6d1ac1d8$var$warn$2('v-on without argument expects an Object value', this);
        else {
            const on = data.on = data.on ? $69b5f56b6d1ac1d8$var$extend({}, data.on) : {};
            for(const key in value){
                const existing = on[key];
                const ours = value[key];
                on[key] = existing ? [].concat(existing, ours) : ours;
            }
        }
    }
    return data;
}
function $69b5f56b6d1ac1d8$var$resolveScopedSlots(fns, res, // the following are added in 2.6
hasDynamicKeys, contentHashKey) {
    res = res || {
        $stable: !hasDynamicKeys
    };
    for(let i = 0; i < fns.length; i++){
        const slot = fns[i];
        if ($69b5f56b6d1ac1d8$var$isArray(slot)) $69b5f56b6d1ac1d8$var$resolveScopedSlots(slot, res, hasDynamicKeys);
        else if (slot) {
            // marker for reverse proxying v-slot without scope on this.$slots
            // @ts-expect-error
            if (slot.proxy) // @ts-expect-error
            slot.fn.proxy = true;
            res[slot.key] = slot.fn;
        }
    }
    if (contentHashKey) res.$key = contentHashKey;
    return res;
}
// helper to process dynamic keys for dynamic arguments in v-bind and v-on.
function $69b5f56b6d1ac1d8$var$bindDynamicKeys(baseObj, values) {
    for(let i = 0; i < values.length; i += 2){
        const key = values[i];
        if (typeof key === 'string' && key) baseObj[values[i]] = values[i + 1];
        else if (key !== '' && key !== null) // null is a special value for explicitly removing a binding
        $69b5f56b6d1ac1d8$var$warn$2(`Invalid value for dynamic directive argument (expected string or null): ${key}`, this);
    }
    return baseObj;
}
// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function $69b5f56b6d1ac1d8$var$prependModifier(value, symbol) {
    return typeof value === 'string' ? symbol + value : value;
}
function $69b5f56b6d1ac1d8$var$installRenderHelpers(target) {
    target._o = $69b5f56b6d1ac1d8$var$markOnce;
    target._n = $69b5f56b6d1ac1d8$var$toNumber;
    target._s = $69b5f56b6d1ac1d8$var$toString;
    target._l = $69b5f56b6d1ac1d8$var$renderList;
    target._t = $69b5f56b6d1ac1d8$var$renderSlot;
    target._q = $69b5f56b6d1ac1d8$var$looseEqual;
    target._i = $69b5f56b6d1ac1d8$var$looseIndexOf;
    target._m = $69b5f56b6d1ac1d8$var$renderStatic;
    target._f = $69b5f56b6d1ac1d8$var$resolveFilter;
    target._k = $69b5f56b6d1ac1d8$var$checkKeyCodes;
    target._b = $69b5f56b6d1ac1d8$var$bindObjectProps;
    target._v = $69b5f56b6d1ac1d8$var$createTextVNode;
    target._e = $69b5f56b6d1ac1d8$var$createEmptyVNode;
    target._u = $69b5f56b6d1ac1d8$var$resolveScopedSlots;
    target._g = $69b5f56b6d1ac1d8$var$bindObjectListeners;
    target._d = $69b5f56b6d1ac1d8$var$bindDynamicKeys;
    target._p = $69b5f56b6d1ac1d8$var$prependModifier;
}
/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */ function $69b5f56b6d1ac1d8$var$resolveSlots(children, context) {
    if (!children || !children.length) return {};
    const slots = {};
    for(let i = 0, l = children.length; i < l; i++){
        const child = children[i];
        const data = child.data;
        // remove slot attribute if the node is resolved as a Vue slot node
        if (data && data.attrs && data.attrs.slot) delete data.attrs.slot;
        // named slots should only be respected if the vnode was rendered in the
        // same context.
        if ((child.context === context || child.fnContext === context) && data && data.slot != null) {
            const name = data.slot;
            const slot = slots[name] || (slots[name] = []);
            if (child.tag === 'template') slot.push.apply(slot, child.children || []);
            else slot.push(child);
        } else (slots.default || (slots.default = [])).push(child);
    }
    // ignore slots that contains only whitespace
    for(const name in slots)if (slots[name].every($69b5f56b6d1ac1d8$var$isWhitespace)) delete slots[name];
    return slots;
}
function $69b5f56b6d1ac1d8$var$isWhitespace(node) {
    return node.isComment && !node.asyncFactory || node.text === ' ';
}
function $69b5f56b6d1ac1d8$var$isAsyncPlaceholder(node) {
    // @ts-expect-error not really boolean type
    return node.isComment && node.asyncFactory;
}
function $69b5f56b6d1ac1d8$var$normalizeScopedSlots(ownerVm, scopedSlots, normalSlots, prevScopedSlots) {
    let res;
    const hasNormalSlots = Object.keys(normalSlots).length > 0;
    const isStable = scopedSlots ? !!scopedSlots.$stable : !hasNormalSlots;
    const key = scopedSlots && scopedSlots.$key;
    if (!scopedSlots) res = {};
    else if (scopedSlots._normalized) // fast path 1: child component re-render only, parent did not change
    return scopedSlots._normalized;
    else if (isStable && prevScopedSlots && prevScopedSlots !== $69b5f56b6d1ac1d8$var$emptyObject && key === prevScopedSlots.$key && !hasNormalSlots && !prevScopedSlots.$hasNormal) // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevScopedSlots;
    else {
        res = {};
        for(const key in scopedSlots)if (scopedSlots[key] && key[0] !== '$') res[key] = $69b5f56b6d1ac1d8$var$normalizeScopedSlot(ownerVm, normalSlots, key, scopedSlots[key]);
    }
    // expose normal slots on scopedSlots
    for(const key in normalSlots)if (!(key in res)) res[key] = $69b5f56b6d1ac1d8$var$proxyNormalSlot(normalSlots, key);
    // avoriaz seems to mock a non-extensible $scopedSlots object
    // and when that is passed down this would cause an error
    if (scopedSlots && Object.isExtensible(scopedSlots)) scopedSlots._normalized = res;
    $69b5f56b6d1ac1d8$var$def(res, '$stable', isStable);
    $69b5f56b6d1ac1d8$var$def(res, '$key', key);
    $69b5f56b6d1ac1d8$var$def(res, '$hasNormal', hasNormalSlots);
    return res;
}
function $69b5f56b6d1ac1d8$var$normalizeScopedSlot(vm, normalSlots, key, fn) {
    const normalized = function() {
        const cur = $69b5f56b6d1ac1d8$var$currentInstance;
        $69b5f56b6d1ac1d8$var$setCurrentInstance(vm);
        let res = arguments.length ? fn.apply(null, arguments) : fn({});
        res = res && typeof res === 'object' && !$69b5f56b6d1ac1d8$var$isArray(res) ? [
            res
        ] // single vnode
         : $69b5f56b6d1ac1d8$var$normalizeChildren(res);
        const vnode = res && res[0];
        $69b5f56b6d1ac1d8$var$setCurrentInstance(cur);
        return res && (!vnode || res.length === 1 && vnode.isComment && !$69b5f56b6d1ac1d8$var$isAsyncPlaceholder(vnode) // #9658, #10391
        ) ? undefined : res;
    };
    // this is a slot using the new v-slot syntax without scope. although it is
    // compiled as a scoped slot, render fn users would expect it to be present
    // on this.$slots because the usage is semantically a normal slot.
    if (fn.proxy) Object.defineProperty(normalSlots, key, {
        get: normalized,
        enumerable: true,
        configurable: true
    });
    return normalized;
}
function $69b5f56b6d1ac1d8$var$proxyNormalSlot(slots, key) {
    return ()=>slots[key];
}
function $69b5f56b6d1ac1d8$var$initSetup(vm) {
    const options = vm.$options;
    const setup = options.setup;
    if (setup) {
        const ctx = vm._setupContext = $69b5f56b6d1ac1d8$var$createSetupContext(vm);
        $69b5f56b6d1ac1d8$var$setCurrentInstance(vm);
        $69b5f56b6d1ac1d8$var$pushTarget();
        const setupResult = $69b5f56b6d1ac1d8$var$invokeWithErrorHandling(setup, null, [
            vm._props || $69b5f56b6d1ac1d8$var$shallowReactive({}),
            ctx
        ], vm, `setup`);
        $69b5f56b6d1ac1d8$var$popTarget();
        $69b5f56b6d1ac1d8$var$setCurrentInstance();
        if ($69b5f56b6d1ac1d8$var$isFunction(setupResult)) // render function
        // @ts-ignore
        options.render = setupResult;
        else if ($69b5f56b6d1ac1d8$var$isObject(setupResult)) {
            // bindings
            if (setupResult instanceof $69b5f56b6d1ac1d8$var$VNode) $69b5f56b6d1ac1d8$var$warn$2(`setup() should not return VNodes directly - ` + `return a render function instead.`);
            vm._setupState = setupResult;
            // __sfc indicates compiled bindings from <script setup>
            if (!setupResult.__sfc) {
                for(const key in setupResult)if (!$69b5f56b6d1ac1d8$var$isReserved(key)) $69b5f56b6d1ac1d8$var$proxyWithRefUnwrap(vm, setupResult, key);
                else $69b5f56b6d1ac1d8$var$warn$2(`Avoid using variables that start with _ or $ in setup().`);
            } else {
                // exposed for compiled render fn
                const proxy = vm._setupProxy = {};
                for(const key in setupResult)if (key !== '__sfc') $69b5f56b6d1ac1d8$var$proxyWithRefUnwrap(proxy, setupResult, key);
            }
        } else if (setupResult !== undefined) $69b5f56b6d1ac1d8$var$warn$2(`setup() should return an object. Received: ${setupResult === null ? 'null' : typeof setupResult}`);
    }
}
function $69b5f56b6d1ac1d8$var$createSetupContext(vm) {
    let exposeCalled = false;
    return {
        get attrs () {
            if (!vm._attrsProxy) {
                const proxy = vm._attrsProxy = {};
                $69b5f56b6d1ac1d8$var$def(proxy, '_v_attr_proxy', true);
                $69b5f56b6d1ac1d8$var$syncSetupProxy(proxy, vm.$attrs, $69b5f56b6d1ac1d8$var$emptyObject, vm, '$attrs');
            }
            return vm._attrsProxy;
        },
        get listeners () {
            if (!vm._listenersProxy) {
                const proxy = vm._listenersProxy = {};
                $69b5f56b6d1ac1d8$var$syncSetupProxy(proxy, vm.$listeners, $69b5f56b6d1ac1d8$var$emptyObject, vm, '$listeners');
            }
            return vm._listenersProxy;
        },
        get slots () {
            return $69b5f56b6d1ac1d8$var$initSlotsProxy(vm);
        },
        emit: $69b5f56b6d1ac1d8$var$bind$1(vm.$emit, vm),
        expose (exposed) {
            if (exposeCalled) $69b5f56b6d1ac1d8$var$warn$2(`expose() should be called only once per setup().`, vm);
            exposeCalled = true;
            if (exposed) Object.keys(exposed).forEach((key)=>$69b5f56b6d1ac1d8$var$proxyWithRefUnwrap(vm, exposed, key));
        }
    };
}
function $69b5f56b6d1ac1d8$var$syncSetupProxy(to, from, prev, instance, type) {
    let changed = false;
    for(const key in from){
        if (!(key in to)) {
            changed = true;
            $69b5f56b6d1ac1d8$var$defineProxyAttr(to, key, instance, type);
        } else if (from[key] !== prev[key]) changed = true;
    }
    for(const key in to)if (!(key in from)) {
        changed = true;
        delete to[key];
    }
    return changed;
}
function $69b5f56b6d1ac1d8$var$defineProxyAttr(proxy, key, instance, type) {
    Object.defineProperty(proxy, key, {
        enumerable: true,
        configurable: true,
        get () {
            return instance[type][key];
        }
    });
}
function $69b5f56b6d1ac1d8$var$initSlotsProxy(vm) {
    if (!vm._slotsProxy) $69b5f56b6d1ac1d8$var$syncSetupSlots(vm._slotsProxy = {}, vm.$scopedSlots);
    return vm._slotsProxy;
}
function $69b5f56b6d1ac1d8$var$syncSetupSlots(to, from) {
    for(const key in from)to[key] = from[key];
    for(const key in to)if (!(key in from)) delete to[key];
}
/**
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */ function $69b5f56b6d1ac1d8$var$useSlots() {
    return $69b5f56b6d1ac1d8$var$getContext().slots;
}
/**
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */ function $69b5f56b6d1ac1d8$var$useAttrs() {
    return $69b5f56b6d1ac1d8$var$getContext().attrs;
}
/**
 * Vue 2 only
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */ function $69b5f56b6d1ac1d8$var$useListeners() {
    return $69b5f56b6d1ac1d8$var$getContext().listeners;
}
function $69b5f56b6d1ac1d8$var$getContext() {
    if (!$69b5f56b6d1ac1d8$var$currentInstance) $69b5f56b6d1ac1d8$var$warn$2(`useContext() called without active instance.`);
    const vm = $69b5f56b6d1ac1d8$var$currentInstance;
    return vm._setupContext || (vm._setupContext = $69b5f56b6d1ac1d8$var$createSetupContext(vm));
}
/**
 * Runtime helper for merging default declarations. Imported by compiled code
 * only.
 * @internal
 */ function $69b5f56b6d1ac1d8$var$mergeDefaults(raw, defaults) {
    const props = $69b5f56b6d1ac1d8$var$isArray(raw) ? raw.reduce((normalized, p)=>(normalized[p] = {}, normalized), {}) : raw;
    for(const key in defaults){
        const opt = props[key];
        if (opt) {
            if ($69b5f56b6d1ac1d8$var$isArray(opt) || $69b5f56b6d1ac1d8$var$isFunction(opt)) props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) props[key] = {
            default: defaults[key]
        };
        else $69b5f56b6d1ac1d8$var$warn$2(`props default key "${key}" has no corresponding declaration.`);
    }
    return props;
}
function $69b5f56b6d1ac1d8$var$initRender(vm) {
    vm._vnode = null; // the root of the child tree
    vm._staticTrees = null; // v-once cached trees
    const options = vm.$options;
    const parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
    const renderContext = parentVnode && parentVnode.context;
    vm.$slots = $69b5f56b6d1ac1d8$var$resolveSlots(options._renderChildren, renderContext);
    vm.$scopedSlots = parentVnode ? $69b5f56b6d1ac1d8$var$normalizeScopedSlots(vm.$parent, parentVnode.data.scopedSlots, vm.$slots) : $69b5f56b6d1ac1d8$var$emptyObject;
    // bind the createElement fn to this instance
    // so that we get proper render context inside it.
    // args order: tag, data, children, normalizationType, alwaysNormalize
    // internal version is used by render functions compiled from templates
    // @ts-expect-error
    vm._c = (a, b, c, d)=>$69b5f56b6d1ac1d8$var$createElement$1(vm, a, b, c, d, false);
    // normalization is always applied for the public version, used in
    // user-written render functions.
    // @ts-expect-error
    vm.$createElement = (a, b, c, d)=>$69b5f56b6d1ac1d8$var$createElement$1(vm, a, b, c, d, true);
    // $attrs & $listeners are exposed for easier HOC creation.
    // they need to be reactive so that HOCs using them are always updated
    const parentData = parentVnode && parentVnode.data;
    $69b5f56b6d1ac1d8$var$defineReactive(vm, '$attrs', parentData && parentData.attrs || $69b5f56b6d1ac1d8$var$emptyObject, ()=>{
        !$69b5f56b6d1ac1d8$var$isUpdatingChildComponent && $69b5f56b6d1ac1d8$var$warn$2(`$attrs is readonly.`, vm);
    }, true);
    $69b5f56b6d1ac1d8$var$defineReactive(vm, '$listeners', options._parentListeners || $69b5f56b6d1ac1d8$var$emptyObject, ()=>{
        !$69b5f56b6d1ac1d8$var$isUpdatingChildComponent && $69b5f56b6d1ac1d8$var$warn$2(`$listeners is readonly.`, vm);
    }, true);
}
let $69b5f56b6d1ac1d8$var$currentRenderingInstance = null;
function $69b5f56b6d1ac1d8$var$renderMixin(Vue) {
    // install runtime convenience helpers
    $69b5f56b6d1ac1d8$var$installRenderHelpers(Vue.prototype);
    Vue.prototype.$nextTick = function(fn) {
        return $69b5f56b6d1ac1d8$var$nextTick(fn, this);
    };
    Vue.prototype._render = function() {
        const vm = this;
        const { render: render, _parentVnode: _parentVnode } = vm.$options;
        if (_parentVnode && vm._isMounted) {
            vm.$scopedSlots = $69b5f56b6d1ac1d8$var$normalizeScopedSlots(vm.$parent, _parentVnode.data.scopedSlots, vm.$slots, vm.$scopedSlots);
            if (vm._slotsProxy) $69b5f56b6d1ac1d8$var$syncSetupSlots(vm._slotsProxy, vm.$scopedSlots);
        }
        // set parent vnode. this allows render functions to have access
        // to the data on the placeholder node.
        vm.$vnode = _parentVnode;
        // render self
        const prevInst = $69b5f56b6d1ac1d8$var$currentInstance;
        const prevRenderInst = $69b5f56b6d1ac1d8$var$currentRenderingInstance;
        let vnode;
        try {
            $69b5f56b6d1ac1d8$var$setCurrentInstance(vm);
            $69b5f56b6d1ac1d8$var$currentRenderingInstance = vm;
            vnode = render.call(vm._renderProxy, vm.$createElement);
        } catch (e) {
            $69b5f56b6d1ac1d8$var$handleError(e, vm, `render`);
            // return error render result,
            // or previous vnode to prevent render error causing blank component
            /* istanbul ignore else */ if (vm.$options.renderError) try {
                vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
            } catch (e) {
                $69b5f56b6d1ac1d8$var$handleError(e, vm, `renderError`);
                vnode = vm._vnode;
            }
            else vnode = vm._vnode;
        } finally{
            $69b5f56b6d1ac1d8$var$currentRenderingInstance = prevRenderInst;
            $69b5f56b6d1ac1d8$var$setCurrentInstance(prevInst);
        }
        // if the returned array contains only a single node, allow it
        if ($69b5f56b6d1ac1d8$var$isArray(vnode) && vnode.length === 1) vnode = vnode[0];
        // return empty vnode in case the render function errored out
        if (!(vnode instanceof $69b5f56b6d1ac1d8$var$VNode)) {
            if ($69b5f56b6d1ac1d8$var$isArray(vnode)) $69b5f56b6d1ac1d8$var$warn$2("Multiple root nodes returned from render function. Render function should return a single root node.", vm);
            vnode = $69b5f56b6d1ac1d8$var$createEmptyVNode();
        }
        // set parent
        vnode.parent = _parentVnode;
        return vnode;
    };
}
function $69b5f56b6d1ac1d8$var$ensureCtor(comp, base) {
    if (comp.__esModule || $69b5f56b6d1ac1d8$var$hasSymbol && comp[Symbol.toStringTag] === 'Module') comp = comp.default;
    return $69b5f56b6d1ac1d8$var$isObject(comp) ? base.extend(comp) : comp;
}
function $69b5f56b6d1ac1d8$var$createAsyncPlaceholder(factory, data, context, children, tag) {
    const node = $69b5f56b6d1ac1d8$var$createEmptyVNode();
    node.asyncFactory = factory;
    node.asyncMeta = {
        data: data,
        context: context,
        children: children,
        tag: tag
    };
    return node;
}
function $69b5f56b6d1ac1d8$var$resolveAsyncComponent(factory, baseCtor) {
    if ($69b5f56b6d1ac1d8$var$isTrue(factory.error) && $69b5f56b6d1ac1d8$var$isDef(factory.errorComp)) return factory.errorComp;
    if ($69b5f56b6d1ac1d8$var$isDef(factory.resolved)) return factory.resolved;
    const owner = $69b5f56b6d1ac1d8$var$currentRenderingInstance;
    if (owner && $69b5f56b6d1ac1d8$var$isDef(factory.owners) && factory.owners.indexOf(owner) === -1) // already pending
    factory.owners.push(owner);
    if ($69b5f56b6d1ac1d8$var$isTrue(factory.loading) && $69b5f56b6d1ac1d8$var$isDef(factory.loadingComp)) return factory.loadingComp;
    if (owner && !$69b5f56b6d1ac1d8$var$isDef(factory.owners)) {
        const owners = factory.owners = [
            owner
        ];
        let sync = true;
        let timerLoading = null;
        let timerTimeout = null;
        owner.$on('hook:destroyed', ()=>$69b5f56b6d1ac1d8$var$remove$2(owners, owner));
        const forceRender = (renderCompleted)=>{
            for(let i = 0, l = owners.length; i < l; i++)owners[i].$forceUpdate();
            if (renderCompleted) {
                owners.length = 0;
                if (timerLoading !== null) {
                    clearTimeout(timerLoading);
                    timerLoading = null;
                }
                if (timerTimeout !== null) {
                    clearTimeout(timerTimeout);
                    timerTimeout = null;
                }
            }
        };
        const resolve = $69b5f56b6d1ac1d8$var$once((res)=>{
            // cache resolved
            factory.resolved = $69b5f56b6d1ac1d8$var$ensureCtor(res, baseCtor);
            // invoke callbacks only if this is not a synchronous resolve
            // (async resolves are shimmed as synchronous during SSR)
            if (!sync) forceRender(true);
            else owners.length = 0;
        });
        const reject = $69b5f56b6d1ac1d8$var$once((reason)=>{
            $69b5f56b6d1ac1d8$var$warn$2(`Failed to resolve async component: ${String(factory)}` + (reason ? `\nReason: ${reason}` : ''));
            if ($69b5f56b6d1ac1d8$var$isDef(factory.errorComp)) {
                factory.error = true;
                forceRender(true);
            }
        });
        const res = factory(resolve, reject);
        if ($69b5f56b6d1ac1d8$var$isObject(res)) {
            if ($69b5f56b6d1ac1d8$var$isPromise(res)) // () => Promise
            {
                if ($69b5f56b6d1ac1d8$var$isUndef(factory.resolved)) res.then(resolve, reject);
            } else if ($69b5f56b6d1ac1d8$var$isPromise(res.component)) {
                res.component.then(resolve, reject);
                if ($69b5f56b6d1ac1d8$var$isDef(res.error)) factory.errorComp = $69b5f56b6d1ac1d8$var$ensureCtor(res.error, baseCtor);
                if ($69b5f56b6d1ac1d8$var$isDef(res.loading)) {
                    factory.loadingComp = $69b5f56b6d1ac1d8$var$ensureCtor(res.loading, baseCtor);
                    if (res.delay === 0) factory.loading = true;
                    else // @ts-expect-error NodeJS timeout type
                    timerLoading = setTimeout(()=>{
                        timerLoading = null;
                        if ($69b5f56b6d1ac1d8$var$isUndef(factory.resolved) && $69b5f56b6d1ac1d8$var$isUndef(factory.error)) {
                            factory.loading = true;
                            forceRender(false);
                        }
                    }, res.delay || 200);
                }
                if ($69b5f56b6d1ac1d8$var$isDef(res.timeout)) // @ts-expect-error NodeJS timeout type
                timerTimeout = setTimeout(()=>{
                    timerTimeout = null;
                    if ($69b5f56b6d1ac1d8$var$isUndef(factory.resolved)) reject(`timeout (${res.timeout}ms)`);
                }, res.timeout);
            }
        }
        sync = false;
        // return in case resolved synchronously
        return factory.loading ? factory.loadingComp : factory.resolved;
    }
}
function $69b5f56b6d1ac1d8$var$getFirstComponentChild(children) {
    if ($69b5f56b6d1ac1d8$var$isArray(children)) for(let i = 0; i < children.length; i++){
        const c = children[i];
        if ($69b5f56b6d1ac1d8$var$isDef(c) && ($69b5f56b6d1ac1d8$var$isDef(c.componentOptions) || $69b5f56b6d1ac1d8$var$isAsyncPlaceholder(c))) return c;
    }
}
function $69b5f56b6d1ac1d8$var$initEvents(vm) {
    vm._events = Object.create(null);
    vm._hasHookEvent = false;
    // init parent attached events
    const listeners = vm.$options._parentListeners;
    if (listeners) $69b5f56b6d1ac1d8$var$updateComponentListeners(vm, listeners);
}
let $69b5f56b6d1ac1d8$var$target$1;
function $69b5f56b6d1ac1d8$var$add$1(event, fn) {
    $69b5f56b6d1ac1d8$var$target$1.$on(event, fn);
}
function $69b5f56b6d1ac1d8$var$remove$1(event, fn) {
    $69b5f56b6d1ac1d8$var$target$1.$off(event, fn);
}
function $69b5f56b6d1ac1d8$var$createOnceHandler$1(event, fn) {
    const _target = $69b5f56b6d1ac1d8$var$target$1;
    return function onceHandler() {
        const res = fn.apply(null, arguments);
        if (res !== null) _target.$off(event, onceHandler);
    };
}
function $69b5f56b6d1ac1d8$var$updateComponentListeners(vm, listeners, oldListeners) {
    $69b5f56b6d1ac1d8$var$target$1 = vm;
    $69b5f56b6d1ac1d8$var$updateListeners(listeners, oldListeners || {}, $69b5f56b6d1ac1d8$var$add$1, $69b5f56b6d1ac1d8$var$remove$1, $69b5f56b6d1ac1d8$var$createOnceHandler$1, vm);
    $69b5f56b6d1ac1d8$var$target$1 = undefined;
}
function $69b5f56b6d1ac1d8$var$eventsMixin(Vue) {
    const hookRE = /^hook:/;
    Vue.prototype.$on = function(event, fn) {
        const vm = this;
        if ($69b5f56b6d1ac1d8$var$isArray(event)) for(let i = 0, l = event.length; i < l; i++)vm.$on(event[i], fn);
        else {
            (vm._events[event] || (vm._events[event] = [])).push(fn);
            // optimize hook:event cost by using a boolean flag marked at registration
            // instead of a hash lookup
            if (hookRE.test(event)) vm._hasHookEvent = true;
        }
        return vm;
    };
    Vue.prototype.$once = function(event, fn) {
        const vm = this;
        function on() {
            vm.$off(event, on);
            fn.apply(vm, arguments);
        }
        on.fn = fn;
        vm.$on(event, on);
        return vm;
    };
    Vue.prototype.$off = function(event, fn) {
        const vm = this;
        // all
        if (!arguments.length) {
            vm._events = Object.create(null);
            return vm;
        }
        // array of events
        if ($69b5f56b6d1ac1d8$var$isArray(event)) {
            for(let i = 0, l = event.length; i < l; i++)vm.$off(event[i], fn);
            return vm;
        }
        // specific event
        const cbs = vm._events[event];
        if (!cbs) return vm;
        if (!fn) {
            vm._events[event] = null;
            return vm;
        }
        // specific handler
        let cb;
        let i = cbs.length;
        while(i--){
            cb = cbs[i];
            if (cb === fn || cb.fn === fn) {
                cbs.splice(i, 1);
                break;
            }
        }
        return vm;
    };
    Vue.prototype.$emit = function(event) {
        const vm = this;
        {
            const lowerCaseEvent = event.toLowerCase();
            if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) $69b5f56b6d1ac1d8$var$tip(`Event "${lowerCaseEvent}" is emitted in component ` + `${$69b5f56b6d1ac1d8$var$formatComponentName(vm)} but the handler is registered for "${event}". ` + `Note that HTML attributes are case-insensitive and you cannot use ` + `v-on to listen to camelCase events when using in-DOM templates. ` + `You should probably use "${$69b5f56b6d1ac1d8$var$hyphenate(event)}" instead of "${event}".`);
        }
        let cbs = vm._events[event];
        if (cbs) {
            cbs = cbs.length > 1 ? $69b5f56b6d1ac1d8$var$toArray(cbs) : cbs;
            const args = $69b5f56b6d1ac1d8$var$toArray(arguments, 1);
            const info = `event handler for "${event}"`;
            for(let i = 0, l = cbs.length; i < l; i++)$69b5f56b6d1ac1d8$var$invokeWithErrorHandling(cbs[i], vm, args, vm, info);
        }
        return vm;
    };
}
let $69b5f56b6d1ac1d8$var$activeEffectScope;
class $69b5f56b6d1ac1d8$var$EffectScope {
    constructor(detached = false){
        this.detached = detached;
        /**
         * @internal
         */ this.active = true;
        /**
         * @internal
         */ this.effects = [];
        /**
         * @internal
         */ this.cleanups = [];
        this.parent = $69b5f56b6d1ac1d8$var$activeEffectScope;
        if (!detached && $69b5f56b6d1ac1d8$var$activeEffectScope) this.index = ($69b5f56b6d1ac1d8$var$activeEffectScope.scopes || ($69b5f56b6d1ac1d8$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    run(fn) {
        if (this.active) {
            const currentEffectScope = $69b5f56b6d1ac1d8$var$activeEffectScope;
            try {
                $69b5f56b6d1ac1d8$var$activeEffectScope = this;
                return fn();
            } finally{
                $69b5f56b6d1ac1d8$var$activeEffectScope = currentEffectScope;
            }
        } else $69b5f56b6d1ac1d8$var$warn$2(`cannot run an inactive effect scope.`);
    }
    /**
     * This should only be called on non-detached scopes
     * @internal
     */ on() {
        $69b5f56b6d1ac1d8$var$activeEffectScope = this;
    }
    /**
     * This should only be called on non-detached scopes
     * @internal
     */ off() {
        $69b5f56b6d1ac1d8$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this.active) {
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].teardown();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            // nested scope, dereference from parent to avoid memory leaks
            if (!this.detached && this.parent && !fromParent) {
                // optimized O(1) removal
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = undefined;
            this.active = false;
        }
    }
}
function $69b5f56b6d1ac1d8$var$effectScope(detached) {
    return new $69b5f56b6d1ac1d8$var$EffectScope(detached);
}
/**
 * @internal
 */ function $69b5f56b6d1ac1d8$var$recordEffectScope(effect, scope = $69b5f56b6d1ac1d8$var$activeEffectScope) {
    if (scope && scope.active) scope.effects.push(effect);
}
function $69b5f56b6d1ac1d8$var$getCurrentScope() {
    return $69b5f56b6d1ac1d8$var$activeEffectScope;
}
function $69b5f56b6d1ac1d8$var$onScopeDispose(fn) {
    if ($69b5f56b6d1ac1d8$var$activeEffectScope) $69b5f56b6d1ac1d8$var$activeEffectScope.cleanups.push(fn);
    else $69b5f56b6d1ac1d8$var$warn$2(`onScopeDispose() is called when there is no active effect scope` + ` to be associated with.`);
}
let $69b5f56b6d1ac1d8$var$activeInstance = null;
let $69b5f56b6d1ac1d8$var$isUpdatingChildComponent = false;
function $69b5f56b6d1ac1d8$var$setActiveInstance(vm) {
    const prevActiveInstance = $69b5f56b6d1ac1d8$var$activeInstance;
    $69b5f56b6d1ac1d8$var$activeInstance = vm;
    return ()=>{
        $69b5f56b6d1ac1d8$var$activeInstance = prevActiveInstance;
    };
}
function $69b5f56b6d1ac1d8$var$initLifecycle(vm) {
    const options = vm.$options;
    // locate first non-abstract parent
    let parent = options.parent;
    if (parent && !options.abstract) {
        while(parent.$options.abstract && parent.$parent)parent = parent.$parent;
        parent.$children.push(vm);
    }
    vm.$parent = parent;
    vm.$root = parent ? parent.$root : vm;
    vm.$children = [];
    vm.$refs = {};
    vm._provided = parent ? parent._provided : Object.create(null);
    vm._watcher = null;
    vm._inactive = null;
    vm._directInactive = false;
    vm._isMounted = false;
    vm._isDestroyed = false;
    vm._isBeingDestroyed = false;
}
function $69b5f56b6d1ac1d8$var$lifecycleMixin(Vue) {
    Vue.prototype._update = function(vnode, hydrating) {
        const vm = this;
        const prevEl = vm.$el;
        const prevVnode = vm._vnode;
        const restoreActiveInstance = $69b5f56b6d1ac1d8$var$setActiveInstance(vm);
        vm._vnode = vnode;
        // Vue.prototype.__patch__ is injected in entry points
        // based on the rendering backend used.
        if (!prevVnode) // initial render
        vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false);
        else // updates
        vm.$el = vm.__patch__(prevVnode, vnode);
        restoreActiveInstance();
        // update __vue__ reference
        if (prevEl) prevEl.__vue__ = null;
        if (vm.$el) vm.$el.__vue__ = vm;
        // if parent is an HOC, update its $el as well
        let wrapper = vm;
        while(wrapper && wrapper.$vnode && wrapper.$parent && wrapper.$vnode === wrapper.$parent._vnode){
            wrapper.$parent.$el = wrapper.$el;
            wrapper = wrapper.$parent;
        }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
    };
    Vue.prototype.$forceUpdate = function() {
        const vm = this;
        if (vm._watcher) vm._watcher.update();
    };
    Vue.prototype.$destroy = function() {
        const vm = this;
        if (vm._isBeingDestroyed) return;
        $69b5f56b6d1ac1d8$var$callHook$1(vm, 'beforeDestroy');
        vm._isBeingDestroyed = true;
        // remove self from parent
        const parent = vm.$parent;
        if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) $69b5f56b6d1ac1d8$var$remove$2(parent.$children, vm);
        // teardown scope. this includes both the render watcher and other
        // watchers created
        vm._scope.stop();
        // remove reference from data ob
        // frozen object may not have observer.
        if (vm._data.__ob__) vm._data.__ob__.vmCount--;
        // call the last hook...
        vm._isDestroyed = true;
        // invoke destroy hooks on current rendered tree
        vm.__patch__(vm._vnode, null);
        // fire destroyed hook
        $69b5f56b6d1ac1d8$var$callHook$1(vm, 'destroyed');
        // turn off all instance listeners.
        vm.$off();
        // remove __vue__ reference
        if (vm.$el) vm.$el.__vue__ = null;
        // release circular reference (#6759)
        if (vm.$vnode) vm.$vnode.parent = null;
    };
}
function $69b5f56b6d1ac1d8$var$mountComponent(vm, el, hydrating) {
    vm.$el = el;
    if (!vm.$options.render) {
        // @ts-expect-error invalid type
        vm.$options.render = $69b5f56b6d1ac1d8$var$createEmptyVNode;
        /* istanbul ignore if */ if (vm.$options.template && vm.$options.template.charAt(0) !== '#' || vm.$options.el || el) $69b5f56b6d1ac1d8$var$warn$2("You are using the runtime-only build of Vue where the template compiler is not available. Either pre-compile the templates into render functions, or use the compiler-included build.", vm);
        else $69b5f56b6d1ac1d8$var$warn$2('Failed to mount component: template or render function not defined.', vm);
    }
    $69b5f56b6d1ac1d8$var$callHook$1(vm, 'beforeMount');
    let updateComponent;
    /* istanbul ignore if */ if ($69b5f56b6d1ac1d8$var$config.performance && $69b5f56b6d1ac1d8$var$mark) updateComponent = ()=>{
        const name = vm._name;
        const id = vm._uid;
        const startTag = `vue-perf-start:${id}`;
        const endTag = `vue-perf-end:${id}`;
        $69b5f56b6d1ac1d8$var$mark(startTag);
        const vnode = vm._render();
        $69b5f56b6d1ac1d8$var$mark(endTag);
        $69b5f56b6d1ac1d8$var$measure(`vue ${name} render`, startTag, endTag);
        $69b5f56b6d1ac1d8$var$mark(startTag);
        vm._update(vnode, hydrating);
        $69b5f56b6d1ac1d8$var$mark(endTag);
        $69b5f56b6d1ac1d8$var$measure(`vue ${name} patch`, startTag, endTag);
    };
    else updateComponent = ()=>{
        vm._update(vm._render(), hydrating);
    };
    const watcherOptions = {
        before () {
            if (vm._isMounted && !vm._isDestroyed) $69b5f56b6d1ac1d8$var$callHook$1(vm, 'beforeUpdate');
        }
    };
    watcherOptions.onTrack = (e)=>$69b5f56b6d1ac1d8$var$callHook$1(vm, 'renderTracked', [
            e
        ]);
    watcherOptions.onTrigger = (e)=>$69b5f56b6d1ac1d8$var$callHook$1(vm, 'renderTriggered', [
            e
        ]);
    // we set this to vm._watcher inside the watcher's constructor
    // since the watcher's initial patch may call $forceUpdate (e.g. inside child
    // component's mounted hook), which relies on vm._watcher being already defined
    new $69b5f56b6d1ac1d8$var$Watcher(vm, updateComponent, $69b5f56b6d1ac1d8$var$noop, watcherOptions, true);
    hydrating = false;
    // flush buffer for flush: "pre" watchers queued in setup()
    const preWatchers = vm._preWatchers;
    if (preWatchers) for(let i = 0; i < preWatchers.length; i++)preWatchers[i].run();
    // manually mounted instance, call mounted on self
    // mounted is called for render-created child components in its inserted hook
    if (vm.$vnode == null) {
        vm._isMounted = true;
        $69b5f56b6d1ac1d8$var$callHook$1(vm, 'mounted');
    }
    return vm;
}
function $69b5f56b6d1ac1d8$var$updateChildComponent(vm, propsData, listeners, parentVnode, renderChildren) {
    $69b5f56b6d1ac1d8$var$isUpdatingChildComponent = true;
    // determine whether component has slot children
    // we need to do this before overwriting $options._renderChildren.
    // check if there are dynamic scopedSlots (hand-written or compiled but with
    // dynamic slot names). Static scoped slots compiled from template has the
    // "$stable" marker.
    const newScopedSlots = parentVnode.data.scopedSlots;
    const oldScopedSlots = vm.$scopedSlots;
    const hasDynamicScopedSlot = !!(newScopedSlots && !newScopedSlots.$stable || oldScopedSlots !== $69b5f56b6d1ac1d8$var$emptyObject && !oldScopedSlots.$stable || newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key || !newScopedSlots && vm.$scopedSlots.$key);
    // Any static slot children from the parent may have changed during parent's
    // update. Dynamic scoped slots may also have changed. In such cases, a forced
    // update is necessary to ensure correctness.
    let needsForceUpdate = !!(renderChildren || // has new static slots
    vm.$options._renderChildren || // has old static slots
    hasDynamicScopedSlot);
    const prevVNode = vm.$vnode;
    vm.$options._parentVnode = parentVnode;
    vm.$vnode = parentVnode; // update vm's placeholder node without re-render
    if (vm._vnode) // update child tree's parent
    vm._vnode.parent = parentVnode;
    vm.$options._renderChildren = renderChildren;
    // update $attrs and $listeners hash
    // these are also reactive so they may trigger child update if the child
    // used them during render
    const attrs = parentVnode.data.attrs || $69b5f56b6d1ac1d8$var$emptyObject;
    if (vm._attrsProxy) // force update if attrs are accessed and has changed since it may be
    // passed to a child component.
    {
        if ($69b5f56b6d1ac1d8$var$syncSetupProxy(vm._attrsProxy, attrs, prevVNode.data && prevVNode.data.attrs || $69b5f56b6d1ac1d8$var$emptyObject, vm, '$attrs')) needsForceUpdate = true;
    }
    vm.$attrs = attrs;
    // update listeners
    listeners = listeners || $69b5f56b6d1ac1d8$var$emptyObject;
    const prevListeners = vm.$options._parentListeners;
    if (vm._listenersProxy) $69b5f56b6d1ac1d8$var$syncSetupProxy(vm._listenersProxy, listeners, prevListeners || $69b5f56b6d1ac1d8$var$emptyObject, vm, '$listeners');
    vm.$listeners = vm.$options._parentListeners = listeners;
    $69b5f56b6d1ac1d8$var$updateComponentListeners(vm, listeners, prevListeners);
    // update props
    if (propsData && vm.$options.props) {
        $69b5f56b6d1ac1d8$var$toggleObserving(false);
        const props = vm._props;
        const propKeys = vm.$options._propKeys || [];
        for(let i = 0; i < propKeys.length; i++){
            const key = propKeys[i];
            const propOptions = vm.$options.props; // wtf flow?
            props[key] = $69b5f56b6d1ac1d8$var$validateProp(key, propOptions, propsData, vm);
        }
        $69b5f56b6d1ac1d8$var$toggleObserving(true);
        // keep a copy of raw propsData
        vm.$options.propsData = propsData;
    }
    // resolve slots + force update if has children
    if (needsForceUpdate) {
        vm.$slots = $69b5f56b6d1ac1d8$var$resolveSlots(renderChildren, parentVnode.context);
        vm.$forceUpdate();
    }
    $69b5f56b6d1ac1d8$var$isUpdatingChildComponent = false;
}
function $69b5f56b6d1ac1d8$var$isInInactiveTree(vm) {
    while(vm && (vm = vm.$parent)){
        if (vm._inactive) return true;
    }
    return false;
}
function $69b5f56b6d1ac1d8$var$activateChildComponent(vm, direct) {
    if (direct) {
        vm._directInactive = false;
        if ($69b5f56b6d1ac1d8$var$isInInactiveTree(vm)) return;
    } else if (vm._directInactive) return;
    if (vm._inactive || vm._inactive === null) {
        vm._inactive = false;
        for(let i = 0; i < vm.$children.length; i++)$69b5f56b6d1ac1d8$var$activateChildComponent(vm.$children[i]);
        $69b5f56b6d1ac1d8$var$callHook$1(vm, 'activated');
    }
}
function $69b5f56b6d1ac1d8$var$deactivateChildComponent(vm, direct) {
    if (direct) {
        vm._directInactive = true;
        if ($69b5f56b6d1ac1d8$var$isInInactiveTree(vm)) return;
    }
    if (!vm._inactive) {
        vm._inactive = true;
        for(let i = 0; i < vm.$children.length; i++)$69b5f56b6d1ac1d8$var$deactivateChildComponent(vm.$children[i]);
        $69b5f56b6d1ac1d8$var$callHook$1(vm, 'deactivated');
    }
}
function $69b5f56b6d1ac1d8$var$callHook$1(vm, hook, args, setContext = true) {
    // #7573 disable dep collection when invoking lifecycle hooks
    $69b5f56b6d1ac1d8$var$pushTarget();
    const prevInst = $69b5f56b6d1ac1d8$var$currentInstance;
    const prevScope = $69b5f56b6d1ac1d8$var$getCurrentScope();
    setContext && $69b5f56b6d1ac1d8$var$setCurrentInstance(vm);
    const handlers = vm.$options[hook];
    const info = `${hook} hook`;
    if (handlers) for(let i = 0, j = handlers.length; i < j; i++)$69b5f56b6d1ac1d8$var$invokeWithErrorHandling(handlers[i], vm, args || null, vm, info);
    if (vm._hasHookEvent) vm.$emit('hook:' + hook);
    if (setContext) {
        $69b5f56b6d1ac1d8$var$setCurrentInstance(prevInst);
        prevScope && prevScope.on();
    }
    $69b5f56b6d1ac1d8$var$popTarget();
}
const $69b5f56b6d1ac1d8$var$MAX_UPDATE_COUNT = 100;
const $69b5f56b6d1ac1d8$var$queue = [];
const $69b5f56b6d1ac1d8$var$activatedChildren = [];
let $69b5f56b6d1ac1d8$var$has = {};
let $69b5f56b6d1ac1d8$var$circular = {};
let $69b5f56b6d1ac1d8$var$waiting = false;
let $69b5f56b6d1ac1d8$var$flushing = false;
let $69b5f56b6d1ac1d8$var$index$1 = 0;
/**
 * Reset the scheduler's state.
 */ function $69b5f56b6d1ac1d8$var$resetSchedulerState() {
    $69b5f56b6d1ac1d8$var$index$1 = $69b5f56b6d1ac1d8$var$queue.length = $69b5f56b6d1ac1d8$var$activatedChildren.length = 0;
    $69b5f56b6d1ac1d8$var$has = {};
    $69b5f56b6d1ac1d8$var$circular = {};
    $69b5f56b6d1ac1d8$var$waiting = $69b5f56b6d1ac1d8$var$flushing = false;
}
// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
let $69b5f56b6d1ac1d8$var$currentFlushTimestamp = 0;
// Async edge case fix requires storing an event listener's attach timestamp.
let $69b5f56b6d1ac1d8$var$getNow = Date.now;
// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if ($69b5f56b6d1ac1d8$var$inBrowser && !$69b5f56b6d1ac1d8$var$isIE) {
    const performance = window.performance;
    if (performance && typeof performance.now === 'function' && $69b5f56b6d1ac1d8$var$getNow() > document.createEvent('Event').timeStamp) // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    $69b5f56b6d1ac1d8$var$getNow = ()=>performance.now();
}
const $69b5f56b6d1ac1d8$var$sortCompareFn = (a, b)=>{
    if (a.post) {
        if (!b.post) return 1;
    } else if (b.post) return -1;
    return a.id - b.id;
};
/**
 * Flush both queues and run the watchers.
 */ function $69b5f56b6d1ac1d8$var$flushSchedulerQueue() {
    $69b5f56b6d1ac1d8$var$currentFlushTimestamp = $69b5f56b6d1ac1d8$var$getNow();
    $69b5f56b6d1ac1d8$var$flushing = true;
    let watcher, id;
    // Sort queue before flush.
    // This ensures that:
    // 1. Components are updated from parent to child. (because parent is always
    //    created before the child)
    // 2. A component's user watchers are run before its render watcher (because
    //    user watchers are created before the render watcher)
    // 3. If a component is destroyed during a parent component's watcher run,
    //    its watchers can be skipped.
    $69b5f56b6d1ac1d8$var$queue.sort($69b5f56b6d1ac1d8$var$sortCompareFn);
    // do not cache length because more watchers might be pushed
    // as we run existing watchers
    for($69b5f56b6d1ac1d8$var$index$1 = 0; $69b5f56b6d1ac1d8$var$index$1 < $69b5f56b6d1ac1d8$var$queue.length; $69b5f56b6d1ac1d8$var$index$1++){
        watcher = $69b5f56b6d1ac1d8$var$queue[$69b5f56b6d1ac1d8$var$index$1];
        if (watcher.before) watcher.before();
        id = watcher.id;
        $69b5f56b6d1ac1d8$var$has[id] = null;
        watcher.run();
        // in dev build, check and stop circular updates.
        if ($69b5f56b6d1ac1d8$var$has[id] != null) {
            $69b5f56b6d1ac1d8$var$circular[id] = ($69b5f56b6d1ac1d8$var$circular[id] || 0) + 1;
            if ($69b5f56b6d1ac1d8$var$circular[id] > $69b5f56b6d1ac1d8$var$MAX_UPDATE_COUNT) {
                $69b5f56b6d1ac1d8$var$warn$2('You may have an infinite update loop ' + (watcher.user ? `in watcher with expression "${watcher.expression}"` : `in a component render function.`), watcher.vm);
                break;
            }
        }
    }
    // keep copies of post queues before resetting state
    const activatedQueue = $69b5f56b6d1ac1d8$var$activatedChildren.slice();
    const updatedQueue = $69b5f56b6d1ac1d8$var$queue.slice();
    $69b5f56b6d1ac1d8$var$resetSchedulerState();
    // call component updated and activated hooks
    $69b5f56b6d1ac1d8$var$callActivatedHooks(activatedQueue);
    $69b5f56b6d1ac1d8$var$callUpdatedHooks(updatedQueue);
    $69b5f56b6d1ac1d8$var$cleanupDeps();
    // devtool hook
    /* istanbul ignore if */ if ($69b5f56b6d1ac1d8$var$devtools && $69b5f56b6d1ac1d8$var$config.devtools) $69b5f56b6d1ac1d8$var$devtools.emit('flush');
}
function $69b5f56b6d1ac1d8$var$callUpdatedHooks(queue) {
    let i = queue.length;
    while(i--){
        const watcher = queue[i];
        const vm = watcher.vm;
        if (vm && vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) $69b5f56b6d1ac1d8$var$callHook$1(vm, 'updated');
    }
}
/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */ function $69b5f56b6d1ac1d8$var$queueActivatedComponent(vm) {
    // setting _inactive to false here so that a render function can
    // rely on checking whether it's in an inactive tree (e.g. router-view)
    vm._inactive = false;
    $69b5f56b6d1ac1d8$var$activatedChildren.push(vm);
}
function $69b5f56b6d1ac1d8$var$callActivatedHooks(queue) {
    for(let i = 0; i < queue.length; i++){
        queue[i]._inactive = true;
        $69b5f56b6d1ac1d8$var$activateChildComponent(queue[i], true);
    }
}
/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */ function $69b5f56b6d1ac1d8$var$queueWatcher(watcher) {
    const id = watcher.id;
    if ($69b5f56b6d1ac1d8$var$has[id] != null) return;
    if (watcher === $69b5f56b6d1ac1d8$var$Dep.target && watcher.noRecurse) return;
    $69b5f56b6d1ac1d8$var$has[id] = true;
    if (!$69b5f56b6d1ac1d8$var$flushing) $69b5f56b6d1ac1d8$var$queue.push(watcher);
    else {
        // if already flushing, splice the watcher based on its id
        // if already past its id, it will be run next immediately.
        let i = $69b5f56b6d1ac1d8$var$queue.length - 1;
        while(i > $69b5f56b6d1ac1d8$var$index$1 && $69b5f56b6d1ac1d8$var$queue[i].id > watcher.id)i--;
        $69b5f56b6d1ac1d8$var$queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!$69b5f56b6d1ac1d8$var$waiting) {
        $69b5f56b6d1ac1d8$var$waiting = true;
        if (!$69b5f56b6d1ac1d8$var$config.async) {
            $69b5f56b6d1ac1d8$var$flushSchedulerQueue();
            return;
        }
        $69b5f56b6d1ac1d8$var$nextTick($69b5f56b6d1ac1d8$var$flushSchedulerQueue);
    }
}
const $69b5f56b6d1ac1d8$var$WATCHER = `watcher`;
const $69b5f56b6d1ac1d8$var$WATCHER_CB = `${$69b5f56b6d1ac1d8$var$WATCHER} callback`;
const $69b5f56b6d1ac1d8$var$WATCHER_GETTER = `${$69b5f56b6d1ac1d8$var$WATCHER} getter`;
const $69b5f56b6d1ac1d8$var$WATCHER_CLEANUP = `${$69b5f56b6d1ac1d8$var$WATCHER} cleanup`;
// Simple effect.
function $69b5f56b6d1ac1d8$var$watchEffect(effect, options) {
    return $69b5f56b6d1ac1d8$var$doWatch(effect, null, options);
}
function $69b5f56b6d1ac1d8$var$watchPostEffect(effect, options) {
    return $69b5f56b6d1ac1d8$var$doWatch(effect, null, Object.assign(Object.assign({}, options), {
        flush: 'post'
    }));
}
function $69b5f56b6d1ac1d8$var$watchSyncEffect(effect, options) {
    return $69b5f56b6d1ac1d8$var$doWatch(effect, null, Object.assign(Object.assign({}, options), {
        flush: 'sync'
    }));
}
// initial value for watchers to trigger on undefined initial values
const $69b5f56b6d1ac1d8$var$INITIAL_WATCHER_VALUE = {};
// implementation
function $69b5f56b6d1ac1d8$var$watch(source, cb, options) {
    if (typeof cb !== 'function') $69b5f56b6d1ac1d8$var$warn$2(`\`watch(fn, options?)\` signature has been moved to a separate API. ` + `Use \`watchEffect(fn, options?)\` instead. \`watch\` now only ` + `supports \`watch(source, cb, options?) signature.`);
    return $69b5f56b6d1ac1d8$var$doWatch(source, cb, options);
}
function $69b5f56b6d1ac1d8$var$doWatch(source, cb, { immediate: immediate, deep: deep, flush: flush = 'pre', onTrack: onTrack, onTrigger: onTrigger } = $69b5f56b6d1ac1d8$var$emptyObject) {
    if (!cb) {
        if (immediate !== undefined) $69b5f56b6d1ac1d8$var$warn$2(`watch() "immediate" option is only respected when using the ` + `watch(source, callback, options?) signature.`);
        if (deep !== undefined) $69b5f56b6d1ac1d8$var$warn$2(`watch() "deep" option is only respected when using the ` + `watch(source, callback, options?) signature.`);
    }
    const warnInvalidSource = (s)=>{
        $69b5f56b6d1ac1d8$var$warn$2(`Invalid watch source: ${s}. A watch source can only be a getter/effect ` + `function, a ref, a reactive object, or an array of these types.`);
    };
    const instance = $69b5f56b6d1ac1d8$var$currentInstance;
    const call = (fn, type, args = null)=>{
        const res = $69b5f56b6d1ac1d8$var$invokeWithErrorHandling(fn, null, args, instance, type);
        if (deep && res && res.__ob__) res.__ob__.dep.depend();
        return res;
    };
    let getter;
    let forceTrigger = false;
    let isMultiSource = false;
    if ($69b5f56b6d1ac1d8$var$isRef(source)) {
        getter = ()=>source.value;
        forceTrigger = $69b5f56b6d1ac1d8$var$isShallow(source);
    } else if ($69b5f56b6d1ac1d8$var$isReactive(source)) {
        getter = ()=>{
            source.__ob__.dep.depend();
            return source;
        };
        deep = true;
    } else if ($69b5f56b6d1ac1d8$var$isArray(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>$69b5f56b6d1ac1d8$var$isReactive(s) || $69b5f56b6d1ac1d8$var$isShallow(s));
        getter = ()=>source.map((s)=>{
                if ($69b5f56b6d1ac1d8$var$isRef(s)) return s.value;
                else if ($69b5f56b6d1ac1d8$var$isReactive(s)) {
                    s.__ob__.dep.depend();
                    return $69b5f56b6d1ac1d8$var$traverse(s);
                } else if ($69b5f56b6d1ac1d8$var$isFunction(s)) return call(s, $69b5f56b6d1ac1d8$var$WATCHER_GETTER);
                else warnInvalidSource(s);
            });
    } else if ($69b5f56b6d1ac1d8$var$isFunction(source)) {
        if (cb) // getter with cb
        getter = ()=>call(source, $69b5f56b6d1ac1d8$var$WATCHER_GETTER);
        else // no cb -> simple effect
        getter = ()=>{
            if (instance && instance._isDestroyed) return;
            if (cleanup) cleanup();
            return call(source, $69b5f56b6d1ac1d8$var$WATCHER, [
                onCleanup
            ]);
        };
    } else {
        getter = $69b5f56b6d1ac1d8$var$noop;
        warnInvalidSource(source);
    }
    if (cb && deep) {
        const baseGetter = getter;
        getter = ()=>$69b5f56b6d1ac1d8$var$traverse(baseGetter());
    }
    let cleanup;
    let onCleanup = (fn)=>{
        cleanup = watcher.onStop = ()=>{
            call(fn, $69b5f56b6d1ac1d8$var$WATCHER_CLEANUP);
        };
    };
    // in SSR there is no need to setup an actual effect, and it should be noop
    // unless it's eager
    if ($69b5f56b6d1ac1d8$var$isServerRendering()) {
        // we will also not call the invalidate callback (+ runner is not set up)
        onCleanup = $69b5f56b6d1ac1d8$var$noop;
        if (!cb) getter();
        else if (immediate) call(cb, $69b5f56b6d1ac1d8$var$WATCHER_CB, [
            getter(),
            isMultiSource ? [] : undefined,
            onCleanup
        ]);
        return $69b5f56b6d1ac1d8$var$noop;
    }
    const watcher = new $69b5f56b6d1ac1d8$var$Watcher($69b5f56b6d1ac1d8$var$currentInstance, getter, $69b5f56b6d1ac1d8$var$noop, {
        lazy: true
    });
    watcher.noRecurse = !cb;
    let oldValue = isMultiSource ? [] : $69b5f56b6d1ac1d8$var$INITIAL_WATCHER_VALUE;
    // overwrite default run
    watcher.run = ()=>{
        if (!watcher.active) return;
        if (cb) {
            // watch(source, cb)
            const newValue = watcher.get();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>$69b5f56b6d1ac1d8$var$hasChanged(v, oldValue[i])) : $69b5f56b6d1ac1d8$var$hasChanged(newValue, oldValue))) {
                // cleanup before running cb again
                if (cleanup) cleanup();
                call(cb, $69b5f56b6d1ac1d8$var$WATCHER_CB, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $69b5f56b6d1ac1d8$var$INITIAL_WATCHER_VALUE ? undefined : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else // watchEffect
        watcher.get();
    };
    if (flush === 'sync') watcher.update = watcher.run;
    else if (flush === 'post') {
        watcher.post = true;
        watcher.update = ()=>$69b5f56b6d1ac1d8$var$queueWatcher(watcher);
    } else // pre
    watcher.update = ()=>{
        if (instance && instance === $69b5f56b6d1ac1d8$var$currentInstance && !instance._isMounted) {
            // pre-watcher triggered before
            const buffer = instance._preWatchers || (instance._preWatchers = []);
            if (buffer.indexOf(watcher) < 0) buffer.push(watcher);
        } else $69b5f56b6d1ac1d8$var$queueWatcher(watcher);
    };
    watcher.onTrack = onTrack;
    watcher.onTrigger = onTrigger;
    // initial run
    if (cb) {
        if (immediate) watcher.run();
        else oldValue = watcher.get();
    } else if (flush === 'post' && instance) instance.$once('hook:mounted', ()=>watcher.get());
    else watcher.get();
    return ()=>{
        watcher.teardown();
    };
}
function $69b5f56b6d1ac1d8$var$provide(key, value) {
    if (!$69b5f56b6d1ac1d8$var$currentInstance) $69b5f56b6d1ac1d8$var$warn$2(`provide() can only be used inside setup().`);
    else // TS doesn't allow symbol as index type
    $69b5f56b6d1ac1d8$var$resolveProvided($69b5f56b6d1ac1d8$var$currentInstance)[key] = value;
}
function $69b5f56b6d1ac1d8$var$resolveProvided(vm) {
    // by default an instance inherits its parent's provides object
    // but when it needs to provide values of its own, it creates its
    // own provides object using parent provides object as prototype.
    // this way in `inject` we can simply look up injections from direct
    // parent and let the prototype chain do the work.
    const existing = vm._provided;
    const parentProvides = vm.$parent && vm.$parent._provided;
    if (parentProvides === existing) return vm._provided = Object.create(parentProvides);
    else return existing;
}
function $69b5f56b6d1ac1d8$var$inject(key, defaultValue, treatDefaultAsFactory = false) {
    // fallback to `currentRenderingInstance` so that this can be called in
    // a functional component
    const instance = $69b5f56b6d1ac1d8$var$currentInstance;
    if (instance) {
        // #2400
        // to support `app.use` plugins,
        // fallback to appContext's `provides` if the instance is at root
        const provides = instance.$parent && instance.$parent._provided;
        if (provides && key in provides) // TS doesn't allow symbol as index type
        return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && $69b5f56b6d1ac1d8$var$isFunction(defaultValue) ? defaultValue.call(instance) : defaultValue;
        else $69b5f56b6d1ac1d8$var$warn$2(`injection "${String(key)}" not found.`);
    } else $69b5f56b6d1ac1d8$var$warn$2(`inject() can only be used inside setup() or functional components.`);
}
/**
 * @internal this function needs manual public type declaration because it relies
 * on previously manually authored types from Vue 2
 */ function $69b5f56b6d1ac1d8$var$h(type, props, children) {
    if (!$69b5f56b6d1ac1d8$var$currentInstance) $69b5f56b6d1ac1d8$var$warn$2(`globally imported h() can only be invoked when there is an active ` + `component instance, e.g. synchronously in a component's render or setup function.`);
    return $69b5f56b6d1ac1d8$var$createElement$1($69b5f56b6d1ac1d8$var$currentInstance, type, props, children, 2, true);
}
function $69b5f56b6d1ac1d8$var$handleError(err, vm, info) {
    // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
    // See: https://github.com/vuejs/vuex/issues/1505
    $69b5f56b6d1ac1d8$var$pushTarget();
    try {
        if (vm) {
            let cur = vm;
            while(cur = cur.$parent){
                const hooks = cur.$options.errorCaptured;
                if (hooks) {
                    for(let i = 0; i < hooks.length; i++)try {
                        const capture = hooks[i].call(cur, err, vm, info) === false;
                        if (capture) return;
                    } catch (e) {
                        $69b5f56b6d1ac1d8$var$globalHandleError(e, cur, 'errorCaptured hook');
                    }
                }
            }
        }
        $69b5f56b6d1ac1d8$var$globalHandleError(err, vm, info);
    } finally{
        $69b5f56b6d1ac1d8$var$popTarget();
    }
}
function $69b5f56b6d1ac1d8$var$invokeWithErrorHandling(handler, context, args, vm, info) {
    let res;
    try {
        res = args ? handler.apply(context, args) : handler.call(context);
        if (res && !res._isVue && $69b5f56b6d1ac1d8$var$isPromise(res) && !res._handled) {
            res.catch((e)=>$69b5f56b6d1ac1d8$var$handleError(e, vm, info + ` (Promise/async)`));
            res._handled = true;
        }
    } catch (e) {
        $69b5f56b6d1ac1d8$var$handleError(e, vm, info);
    }
    return res;
}
function $69b5f56b6d1ac1d8$var$globalHandleError(err, vm, info) {
    if ($69b5f56b6d1ac1d8$var$config.errorHandler) try {
        return $69b5f56b6d1ac1d8$var$config.errorHandler.call(null, err, vm, info);
    } catch (e) {
        // if the user intentionally throws the original error in the handler,
        // do not log it twice
        if (e !== err) $69b5f56b6d1ac1d8$var$logError(e, null, 'config.errorHandler');
    }
    $69b5f56b6d1ac1d8$var$logError(err, vm, info);
}
function $69b5f56b6d1ac1d8$var$logError(err, vm, info) {
    $69b5f56b6d1ac1d8$var$warn$2(`Error in ${info}: "${err.toString()}"`, vm);
    /* istanbul ignore else */ if ($69b5f56b6d1ac1d8$var$inBrowser && typeof console !== 'undefined') console.error(err);
    else throw err;
}
/* globals MutationObserver */ let $69b5f56b6d1ac1d8$var$isUsingMicroTask = false;
const $69b5f56b6d1ac1d8$var$callbacks = [];
let $69b5f56b6d1ac1d8$var$pending = false;
function $69b5f56b6d1ac1d8$var$flushCallbacks() {
    $69b5f56b6d1ac1d8$var$pending = false;
    const copies = $69b5f56b6d1ac1d8$var$callbacks.slice(0);
    $69b5f56b6d1ac1d8$var$callbacks.length = 0;
    for(let i = 0; i < copies.length; i++)copies[i]();
}
// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
let $69b5f56b6d1ac1d8$var$timerFunc;
// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */ if (typeof Promise !== 'undefined' && $69b5f56b6d1ac1d8$var$isNative(Promise)) {
    const p = Promise.resolve();
    $69b5f56b6d1ac1d8$var$timerFunc = ()=>{
        p.then($69b5f56b6d1ac1d8$var$flushCallbacks);
        // In problematic UIWebViews, Promise.then doesn't completely break, but
        // it can get stuck in a weird state where callbacks are pushed into the
        // microtask queue but the queue isn't being flushed, until the browser
        // needs to do some other work, e.g. handle a timer. Therefore we can
        // "force" the microtask queue to be flushed by adding an empty timer.
        if ($69b5f56b6d1ac1d8$var$isIOS) setTimeout($69b5f56b6d1ac1d8$var$noop);
    };
    $69b5f56b6d1ac1d8$var$isUsingMicroTask = true;
} else if (!$69b5f56b6d1ac1d8$var$isIE && typeof MutationObserver !== 'undefined' && ($69b5f56b6d1ac1d8$var$isNative(MutationObserver) || // PhantomJS and iOS 7.x
MutationObserver.toString() === '[object MutationObserverConstructor]')) {
    // Use MutationObserver where native Promise is not available,
    // e.g. PhantomJS, iOS7, Android 4.4
    // (#6466 MutationObserver is unreliable in IE11)
    let counter = 1;
    const observer = new MutationObserver($69b5f56b6d1ac1d8$var$flushCallbacks);
    const textNode = document.createTextNode(String(counter));
    observer.observe(textNode, {
        characterData: true
    });
    $69b5f56b6d1ac1d8$var$timerFunc = ()=>{
        counter = (counter + 1) % 2;
        textNode.data = String(counter);
    };
    $69b5f56b6d1ac1d8$var$isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && $69b5f56b6d1ac1d8$var$isNative(setImmediate)) // Fallback to setImmediate.
// Technically it leverages the (macro) task queue,
// but it is still a better choice than setTimeout.
$69b5f56b6d1ac1d8$var$timerFunc = ()=>{
    setImmediate($69b5f56b6d1ac1d8$var$flushCallbacks);
};
else // Fallback to setTimeout.
$69b5f56b6d1ac1d8$var$timerFunc = ()=>{
    setTimeout($69b5f56b6d1ac1d8$var$flushCallbacks, 0);
};
/**
 * @internal
 */ function $69b5f56b6d1ac1d8$var$nextTick(cb, ctx) {
    let _resolve;
    $69b5f56b6d1ac1d8$var$callbacks.push(()=>{
        if (cb) try {
            cb.call(ctx);
        } catch (e) {
            $69b5f56b6d1ac1d8$var$handleError(e, ctx, 'nextTick');
        }
        else if (_resolve) _resolve(ctx);
    });
    if (!$69b5f56b6d1ac1d8$var$pending) {
        $69b5f56b6d1ac1d8$var$pending = true;
        $69b5f56b6d1ac1d8$var$timerFunc();
    }
    // $flow-disable-line
    if (!cb && typeof Promise !== 'undefined') return new Promise((resolve)=>{
        _resolve = resolve;
    });
}
function $69b5f56b6d1ac1d8$var$useCssModule(name = '$style') {
    /* istanbul ignore else */ {
        if (!$69b5f56b6d1ac1d8$var$currentInstance) {
            $69b5f56b6d1ac1d8$var$warn$2(`useCssModule must be called inside setup()`);
            return $69b5f56b6d1ac1d8$var$emptyObject;
        }
        const mod = $69b5f56b6d1ac1d8$var$currentInstance[name];
        if (!mod) {
            $69b5f56b6d1ac1d8$var$warn$2(`Current instance does not have CSS module named "${name}".`);
            return $69b5f56b6d1ac1d8$var$emptyObject;
        }
        return mod;
    }
}
/**
 * Runtime helper for SFC's CSS variable injection feature.
 * @private
 */ function $69b5f56b6d1ac1d8$var$useCssVars(getter) {
    if (!$69b5f56b6d1ac1d8$var$inBrowser && true) return;
    const instance = $69b5f56b6d1ac1d8$var$currentInstance;
    if (!instance) {
        $69b5f56b6d1ac1d8$var$warn$2(`useCssVars is called without current active component instance.`);
        return;
    }
    $69b5f56b6d1ac1d8$var$watchPostEffect(()=>{
        const el = instance.$el;
        const vars = getter(instance, instance._setupProxy);
        if (el && el.nodeType === 1) {
            const style = el.style;
            for(const key in vars)style.setProperty(`--${key}`, vars[key]);
        }
    });
}
/**
 * v3-compatible async component API.
 * @internal the type is manually declared in <root>/types/v3-define-async-component.d.ts
 * because it relies on existing manual types
 */ function $69b5f56b6d1ac1d8$var$defineAsyncComponent(source) {
    if ($69b5f56b6d1ac1d8$var$isFunction(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, timeout: timeout, suspensible: suspensible = false, onError: userOnError } = source;
    if (suspensible) $69b5f56b6d1ac1d8$var$warn$2(`The suspensible option for async components is not supported in Vue2. It is ignored.`);
    let pendingRequest = null;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (!comp) $69b5f56b6d1ac1d8$var$warn$2(`Async component loader resolved to undefined. ` + `If you are using retry(), make sure to return its return value.`);
            // interop module default
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === 'Module')) comp = comp.default;
            if (comp && !$69b5f56b6d1ac1d8$var$isObject(comp) && !$69b5f56b6d1ac1d8$var$isFunction(comp)) throw new Error(`Invalid async component load result: ${comp}`);
            return comp;
        }));
    };
    return ()=>{
        const component = load();
        return {
            component: component,
            delay: delay,
            timeout: timeout,
            error: errorComponent,
            loading: loadingComponent
        };
    };
}
function $69b5f56b6d1ac1d8$var$createLifeCycle(hookName) {
    return (fn, target = $69b5f56b6d1ac1d8$var$currentInstance)=>{
        if (!target) {
            $69b5f56b6d1ac1d8$var$warn$2(`${$69b5f56b6d1ac1d8$var$formatName(hookName)} is called when there is no active component instance to be ` + `associated with. ` + `Lifecycle injection APIs can only be used during execution of setup().`);
            return;
        }
        return $69b5f56b6d1ac1d8$var$injectHook(target, hookName, fn);
    };
}
function $69b5f56b6d1ac1d8$var$formatName(name) {
    if (name === 'beforeDestroy') name = 'beforeUnmount';
    else if (name === 'destroyed') name = 'unmounted';
    return `on${name[0].toUpperCase() + name.slice(1)}`;
}
function $69b5f56b6d1ac1d8$var$injectHook(instance, hookName, fn) {
    const options = instance.$options;
    options[hookName] = $69b5f56b6d1ac1d8$var$mergeLifecycleHook(options[hookName], fn);
}
const $69b5f56b6d1ac1d8$var$onBeforeMount = $69b5f56b6d1ac1d8$var$createLifeCycle('beforeMount');
const $69b5f56b6d1ac1d8$var$onMounted = $69b5f56b6d1ac1d8$var$createLifeCycle('mounted');
const $69b5f56b6d1ac1d8$var$onBeforeUpdate = $69b5f56b6d1ac1d8$var$createLifeCycle('beforeUpdate');
const $69b5f56b6d1ac1d8$var$onUpdated = $69b5f56b6d1ac1d8$var$createLifeCycle('updated');
const $69b5f56b6d1ac1d8$var$onBeforeUnmount = $69b5f56b6d1ac1d8$var$createLifeCycle('beforeDestroy');
const $69b5f56b6d1ac1d8$var$onUnmounted = $69b5f56b6d1ac1d8$var$createLifeCycle('destroyed');
const $69b5f56b6d1ac1d8$var$onActivated = $69b5f56b6d1ac1d8$var$createLifeCycle('activated');
const $69b5f56b6d1ac1d8$var$onDeactivated = $69b5f56b6d1ac1d8$var$createLifeCycle('deactivated');
const $69b5f56b6d1ac1d8$var$onServerPrefetch = $69b5f56b6d1ac1d8$var$createLifeCycle('serverPrefetch');
const $69b5f56b6d1ac1d8$var$onRenderTracked = $69b5f56b6d1ac1d8$var$createLifeCycle('renderTracked');
const $69b5f56b6d1ac1d8$var$onRenderTriggered = $69b5f56b6d1ac1d8$var$createLifeCycle('renderTriggered');
const $69b5f56b6d1ac1d8$var$injectErrorCapturedHook = $69b5f56b6d1ac1d8$var$createLifeCycle('errorCaptured');
function $69b5f56b6d1ac1d8$var$onErrorCaptured(hook, target = $69b5f56b6d1ac1d8$var$currentInstance) {
    $69b5f56b6d1ac1d8$var$injectErrorCapturedHook(hook, target);
}
/**
 * Note: also update dist/vue.runtime.mjs when adding new exports to this file.
 */ const $69b5f56b6d1ac1d8$var$version = '2.7.16';
/**
 * @internal type is manually declared in <root>/types/v3-define-component.d.ts
 */ function $69b5f56b6d1ac1d8$var$defineComponent(options) {
    return options;
}
var $69b5f56b6d1ac1d8$var$vca = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    version: $69b5f56b6d1ac1d8$var$version,
    defineComponent: $69b5f56b6d1ac1d8$var$defineComponent,
    ref: $69b5f56b6d1ac1d8$var$ref$1,
    shallowRef: $69b5f56b6d1ac1d8$var$shallowRef,
    isRef: $69b5f56b6d1ac1d8$var$isRef,
    toRef: $69b5f56b6d1ac1d8$var$toRef,
    toRefs: $69b5f56b6d1ac1d8$var$toRefs,
    unref: $69b5f56b6d1ac1d8$var$unref,
    proxyRefs: $69b5f56b6d1ac1d8$var$proxyRefs,
    customRef: $69b5f56b6d1ac1d8$var$customRef,
    triggerRef: $69b5f56b6d1ac1d8$var$triggerRef,
    reactive: $69b5f56b6d1ac1d8$var$reactive,
    isReactive: $69b5f56b6d1ac1d8$var$isReactive,
    isReadonly: $69b5f56b6d1ac1d8$var$isReadonly,
    isShallow: $69b5f56b6d1ac1d8$var$isShallow,
    isProxy: $69b5f56b6d1ac1d8$var$isProxy,
    shallowReactive: $69b5f56b6d1ac1d8$var$shallowReactive,
    markRaw: $69b5f56b6d1ac1d8$var$markRaw,
    toRaw: $69b5f56b6d1ac1d8$var$toRaw,
    readonly: $69b5f56b6d1ac1d8$var$readonly,
    shallowReadonly: $69b5f56b6d1ac1d8$var$shallowReadonly,
    computed: $69b5f56b6d1ac1d8$var$computed,
    watch: $69b5f56b6d1ac1d8$var$watch,
    watchEffect: $69b5f56b6d1ac1d8$var$watchEffect,
    watchPostEffect: $69b5f56b6d1ac1d8$var$watchPostEffect,
    watchSyncEffect: $69b5f56b6d1ac1d8$var$watchSyncEffect,
    EffectScope: $69b5f56b6d1ac1d8$var$EffectScope,
    effectScope: $69b5f56b6d1ac1d8$var$effectScope,
    onScopeDispose: $69b5f56b6d1ac1d8$var$onScopeDispose,
    getCurrentScope: $69b5f56b6d1ac1d8$var$getCurrentScope,
    provide: $69b5f56b6d1ac1d8$var$provide,
    inject: $69b5f56b6d1ac1d8$var$inject,
    h: $69b5f56b6d1ac1d8$var$h,
    getCurrentInstance: $69b5f56b6d1ac1d8$var$getCurrentInstance,
    useSlots: $69b5f56b6d1ac1d8$var$useSlots,
    useAttrs: $69b5f56b6d1ac1d8$var$useAttrs,
    useListeners: $69b5f56b6d1ac1d8$var$useListeners,
    mergeDefaults: $69b5f56b6d1ac1d8$var$mergeDefaults,
    nextTick: $69b5f56b6d1ac1d8$var$nextTick,
    set: $69b5f56b6d1ac1d8$var$set,
    del: $69b5f56b6d1ac1d8$var$del,
    useCssModule: $69b5f56b6d1ac1d8$var$useCssModule,
    useCssVars: $69b5f56b6d1ac1d8$var$useCssVars,
    defineAsyncComponent: $69b5f56b6d1ac1d8$var$defineAsyncComponent,
    onBeforeMount: $69b5f56b6d1ac1d8$var$onBeforeMount,
    onMounted: $69b5f56b6d1ac1d8$var$onMounted,
    onBeforeUpdate: $69b5f56b6d1ac1d8$var$onBeforeUpdate,
    onUpdated: $69b5f56b6d1ac1d8$var$onUpdated,
    onBeforeUnmount: $69b5f56b6d1ac1d8$var$onBeforeUnmount,
    onUnmounted: $69b5f56b6d1ac1d8$var$onUnmounted,
    onActivated: $69b5f56b6d1ac1d8$var$onActivated,
    onDeactivated: $69b5f56b6d1ac1d8$var$onDeactivated,
    onServerPrefetch: $69b5f56b6d1ac1d8$var$onServerPrefetch,
    onRenderTracked: $69b5f56b6d1ac1d8$var$onRenderTracked,
    onRenderTriggered: $69b5f56b6d1ac1d8$var$onRenderTriggered,
    onErrorCaptured: $69b5f56b6d1ac1d8$var$onErrorCaptured
});
const $69b5f56b6d1ac1d8$var$seenObjects = new $69b5f56b6d1ac1d8$var$_Set();
/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */ function $69b5f56b6d1ac1d8$var$traverse(val) {
    $69b5f56b6d1ac1d8$var$_traverse(val, $69b5f56b6d1ac1d8$var$seenObjects);
    $69b5f56b6d1ac1d8$var$seenObjects.clear();
    return val;
}
function $69b5f56b6d1ac1d8$var$_traverse(val, seen) {
    let i, keys;
    const isA = $69b5f56b6d1ac1d8$var$isArray(val);
    if (!isA && !$69b5f56b6d1ac1d8$var$isObject(val) || val.__v_skip /* ReactiveFlags.SKIP */  || Object.isFrozen(val) || val instanceof $69b5f56b6d1ac1d8$var$VNode) return;
    if (val.__ob__) {
        const depId = val.__ob__.dep.id;
        if (seen.has(depId)) return;
        seen.add(depId);
    }
    if (isA) {
        i = val.length;
        while(i--)$69b5f56b6d1ac1d8$var$_traverse(val[i], seen);
    } else if ($69b5f56b6d1ac1d8$var$isRef(val)) $69b5f56b6d1ac1d8$var$_traverse(val.value, seen);
    else {
        keys = Object.keys(val);
        i = keys.length;
        while(i--)$69b5f56b6d1ac1d8$var$_traverse(val[keys[i]], seen);
    }
}
let $69b5f56b6d1ac1d8$var$uid$1 = 0;
/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 * @internal
 */ class $69b5f56b6d1ac1d8$var$Watcher {
    constructor(vm, expOrFn, cb, options, isRenderWatcher){
        $69b5f56b6d1ac1d8$var$recordEffectScope(this, // if the active effect scope is manually created (not a component scope),
        // prioritize it
        $69b5f56b6d1ac1d8$var$activeEffectScope && !$69b5f56b6d1ac1d8$var$activeEffectScope._vm ? $69b5f56b6d1ac1d8$var$activeEffectScope : vm ? vm._scope : undefined);
        if ((this.vm = vm) && isRenderWatcher) vm._watcher = this;
        // options
        if (options) {
            this.deep = !!options.deep;
            this.user = !!options.user;
            this.lazy = !!options.lazy;
            this.sync = !!options.sync;
            this.before = options.before;
            this.onTrack = options.onTrack;
            this.onTrigger = options.onTrigger;
        } else this.deep = this.user = this.lazy = this.sync = false;
        this.cb = cb;
        this.id = ++$69b5f56b6d1ac1d8$var$uid$1; // uid for batching
        this.active = true;
        this.post = false;
        this.dirty = this.lazy; // for lazy watchers
        this.deps = [];
        this.newDeps = [];
        this.depIds = new $69b5f56b6d1ac1d8$var$_Set();
        this.newDepIds = new $69b5f56b6d1ac1d8$var$_Set();
        this.expression = expOrFn.toString();
        // parse expression for getter
        if ($69b5f56b6d1ac1d8$var$isFunction(expOrFn)) this.getter = expOrFn;
        else {
            this.getter = $69b5f56b6d1ac1d8$var$parsePath(expOrFn);
            if (!this.getter) {
                this.getter = $69b5f56b6d1ac1d8$var$noop;
                $69b5f56b6d1ac1d8$var$warn$2(`Failed watching path: "${expOrFn}" ` + 'Watcher only accepts simple dot-delimited paths. ' + 'For full control, use a function instead.', vm);
            }
        }
        this.value = this.lazy ? undefined : this.get();
    }
    /**
     * Evaluate the getter, and re-collect dependencies.
     */ get() {
        $69b5f56b6d1ac1d8$var$pushTarget(this);
        let value;
        const vm = this.vm;
        try {
            value = this.getter.call(vm, vm);
        } catch (e) {
            if (this.user) $69b5f56b6d1ac1d8$var$handleError(e, vm, `getter for watcher "${this.expression}"`);
            else throw e;
        } finally{
            // "touch" every property so they are all tracked as
            // dependencies for deep watching
            if (this.deep) $69b5f56b6d1ac1d8$var$traverse(value);
            $69b5f56b6d1ac1d8$var$popTarget();
            this.cleanupDeps();
        }
        return value;
    }
    /**
     * Add a dependency to this directive.
     */ addDep(dep) {
        const id = dep.id;
        if (!this.newDepIds.has(id)) {
            this.newDepIds.add(id);
            this.newDeps.push(dep);
            if (!this.depIds.has(id)) dep.addSub(this);
        }
    }
    /**
     * Clean up for dependency collection.
     */ cleanupDeps() {
        let i = this.deps.length;
        while(i--){
            const dep = this.deps[i];
            if (!this.newDepIds.has(dep.id)) dep.removeSub(this);
        }
        let tmp = this.depIds;
        this.depIds = this.newDepIds;
        this.newDepIds = tmp;
        this.newDepIds.clear();
        tmp = this.deps;
        this.deps = this.newDeps;
        this.newDeps = tmp;
        this.newDeps.length = 0;
    }
    /**
     * Subscriber interface.
     * Will be called when a dependency changes.
     */ update() {
        /* istanbul ignore else */ if (this.lazy) this.dirty = true;
        else if (this.sync) this.run();
        else $69b5f56b6d1ac1d8$var$queueWatcher(this);
    }
    /**
     * Scheduler job interface.
     * Will be called by the scheduler.
     */ run() {
        if (this.active) {
            const value = this.get();
            if (value !== this.value || // Deep watchers and watchers on Object/Arrays should fire even
            // when the value is the same, because the value may
            // have mutated.
            $69b5f56b6d1ac1d8$var$isObject(value) || this.deep) {
                // set new value
                const oldValue = this.value;
                this.value = value;
                if (this.user) {
                    const info = `callback for watcher "${this.expression}"`;
                    $69b5f56b6d1ac1d8$var$invokeWithErrorHandling(this.cb, this.vm, [
                        value,
                        oldValue
                    ], this.vm, info);
                } else this.cb.call(this.vm, value, oldValue);
            }
        }
    }
    /**
     * Evaluate the value of the watcher.
     * This only gets called for lazy watchers.
     */ evaluate() {
        this.value = this.get();
        this.dirty = false;
    }
    /**
     * Depend on all deps collected by this watcher.
     */ depend() {
        let i = this.deps.length;
        while(i--)this.deps[i].depend();
    }
    /**
     * Remove self from all dependencies' subscriber list.
     */ teardown() {
        if (this.vm && !this.vm._isBeingDestroyed) $69b5f56b6d1ac1d8$var$remove$2(this.vm._scope.effects, this);
        if (this.active) {
            let i = this.deps.length;
            while(i--)this.deps[i].removeSub(this);
            this.active = false;
            if (this.onStop) this.onStop();
        }
    }
}
const $69b5f56b6d1ac1d8$var$sharedPropertyDefinition = {
    enumerable: true,
    configurable: true,
    get: $69b5f56b6d1ac1d8$var$noop,
    set: $69b5f56b6d1ac1d8$var$noop
};
function $69b5f56b6d1ac1d8$var$proxy(target, sourceKey, key) {
    $69b5f56b6d1ac1d8$var$sharedPropertyDefinition.get = function proxyGetter() {
        return this[sourceKey][key];
    };
    $69b5f56b6d1ac1d8$var$sharedPropertyDefinition.set = function proxySetter(val) {
        this[sourceKey][key] = val;
    };
    Object.defineProperty(target, key, $69b5f56b6d1ac1d8$var$sharedPropertyDefinition);
}
function $69b5f56b6d1ac1d8$var$initState(vm) {
    const opts = vm.$options;
    if (opts.props) $69b5f56b6d1ac1d8$var$initProps$1(vm, opts.props);
    // Composition API
    $69b5f56b6d1ac1d8$var$initSetup(vm);
    if (opts.methods) $69b5f56b6d1ac1d8$var$initMethods(vm, opts.methods);
    if (opts.data) $69b5f56b6d1ac1d8$var$initData(vm);
    else {
        const ob = $69b5f56b6d1ac1d8$var$observe(vm._data = {});
        ob && ob.vmCount++;
    }
    if (opts.computed) $69b5f56b6d1ac1d8$var$initComputed$1(vm, opts.computed);
    if (opts.watch && opts.watch !== $69b5f56b6d1ac1d8$var$nativeWatch) $69b5f56b6d1ac1d8$var$initWatch(vm, opts.watch);
}
function $69b5f56b6d1ac1d8$var$initProps$1(vm, propsOptions) {
    const propsData = vm.$options.propsData || {};
    const props = vm._props = $69b5f56b6d1ac1d8$var$shallowReactive({});
    // cache prop keys so that future props updates can iterate using Array
    // instead of dynamic object key enumeration.
    const keys = vm.$options._propKeys = [];
    const isRoot = !vm.$parent;
    // root instance props should be converted
    if (!isRoot) $69b5f56b6d1ac1d8$var$toggleObserving(false);
    for(const key in propsOptions){
        keys.push(key);
        const value = $69b5f56b6d1ac1d8$var$validateProp(key, propsOptions, propsData, vm);
        /* istanbul ignore else */ {
            const hyphenatedKey = $69b5f56b6d1ac1d8$var$hyphenate(key);
            if ($69b5f56b6d1ac1d8$var$isReservedAttribute(hyphenatedKey) || $69b5f56b6d1ac1d8$var$config.isReservedAttr(hyphenatedKey)) $69b5f56b6d1ac1d8$var$warn$2(`"${hyphenatedKey}" is a reserved attribute and cannot be used as component prop.`, vm);
            $69b5f56b6d1ac1d8$var$defineReactive(props, key, value, ()=>{
                if (!isRoot && !$69b5f56b6d1ac1d8$var$isUpdatingChildComponent) $69b5f56b6d1ac1d8$var$warn$2(`Avoid mutating a prop directly since the value will be ` + `overwritten whenever the parent component re-renders. ` + `Instead, use a data or computed property based on the prop's ` + `value. Prop being mutated: "${key}"`, vm);
            }, true);
        }
        // static props are already proxied on the component's prototype
        // during Vue.extend(). We only need to proxy props defined at
        // instantiation here.
        if (!(key in vm)) $69b5f56b6d1ac1d8$var$proxy(vm, `_props`, key);
    }
    $69b5f56b6d1ac1d8$var$toggleObserving(true);
}
function $69b5f56b6d1ac1d8$var$initData(vm) {
    let data = vm.$options.data;
    data = vm._data = $69b5f56b6d1ac1d8$var$isFunction(data) ? $69b5f56b6d1ac1d8$var$getData(data, vm) : data || {};
    if (!$69b5f56b6d1ac1d8$var$isPlainObject(data)) {
        data = {};
        $69b5f56b6d1ac1d8$var$warn$2("data functions should return an object:\nhttps://v2.vuejs.org/v2/guide/components.html#data-Must-Be-a-Function", vm);
    }
    // proxy data on instance
    const keys = Object.keys(data);
    const props = vm.$options.props;
    const methods = vm.$options.methods;
    let i = keys.length;
    while(i--){
        const key = keys[i];
        if (methods && $69b5f56b6d1ac1d8$var$hasOwn(methods, key)) $69b5f56b6d1ac1d8$var$warn$2(`Method "${key}" has already been defined as a data property.`, vm);
        if (props && $69b5f56b6d1ac1d8$var$hasOwn(props, key)) $69b5f56b6d1ac1d8$var$warn$2(`The data property "${key}" is already declared as a prop. ` + `Use prop default value instead.`, vm);
        else if (!$69b5f56b6d1ac1d8$var$isReserved(key)) $69b5f56b6d1ac1d8$var$proxy(vm, `_data`, key);
    }
    // observe data
    const ob = $69b5f56b6d1ac1d8$var$observe(data);
    ob && ob.vmCount++;
}
function $69b5f56b6d1ac1d8$var$getData(data, vm) {
    // #7573 disable dep collection when invoking data getters
    $69b5f56b6d1ac1d8$var$pushTarget();
    try {
        return data.call(vm, vm);
    } catch (e) {
        $69b5f56b6d1ac1d8$var$handleError(e, vm, `data()`);
        return {};
    } finally{
        $69b5f56b6d1ac1d8$var$popTarget();
    }
}
const $69b5f56b6d1ac1d8$var$computedWatcherOptions = {
    lazy: true
};
function $69b5f56b6d1ac1d8$var$initComputed$1(vm, computed) {
    // $flow-disable-line
    const watchers = vm._computedWatchers = Object.create(null);
    // computed properties are just getters during SSR
    const isSSR = $69b5f56b6d1ac1d8$var$isServerRendering();
    for(const key in computed){
        const userDef = computed[key];
        const getter = $69b5f56b6d1ac1d8$var$isFunction(userDef) ? userDef : userDef.get;
        if (getter == null) $69b5f56b6d1ac1d8$var$warn$2(`Getter is missing for computed property "${key}".`, vm);
        if (!isSSR) // create internal watcher for the computed property.
        watchers[key] = new $69b5f56b6d1ac1d8$var$Watcher(vm, getter || $69b5f56b6d1ac1d8$var$noop, $69b5f56b6d1ac1d8$var$noop, $69b5f56b6d1ac1d8$var$computedWatcherOptions);
        // component-defined computed properties are already defined on the
        // component prototype. We only need to define computed properties defined
        // at instantiation here.
        if (!(key in vm)) $69b5f56b6d1ac1d8$var$defineComputed(vm, key, userDef);
        else {
            if (key in vm.$data) $69b5f56b6d1ac1d8$var$warn$2(`The computed property "${key}" is already defined in data.`, vm);
            else if (vm.$options.props && key in vm.$options.props) $69b5f56b6d1ac1d8$var$warn$2(`The computed property "${key}" is already defined as a prop.`, vm);
            else if (vm.$options.methods && key in vm.$options.methods) $69b5f56b6d1ac1d8$var$warn$2(`The computed property "${key}" is already defined as a method.`, vm);
        }
    }
}
function $69b5f56b6d1ac1d8$var$defineComputed(target, key, userDef) {
    const shouldCache = !$69b5f56b6d1ac1d8$var$isServerRendering();
    if ($69b5f56b6d1ac1d8$var$isFunction(userDef)) {
        $69b5f56b6d1ac1d8$var$sharedPropertyDefinition.get = shouldCache ? $69b5f56b6d1ac1d8$var$createComputedGetter(key) : $69b5f56b6d1ac1d8$var$createGetterInvoker(userDef);
        $69b5f56b6d1ac1d8$var$sharedPropertyDefinition.set = $69b5f56b6d1ac1d8$var$noop;
    } else {
        $69b5f56b6d1ac1d8$var$sharedPropertyDefinition.get = userDef.get ? shouldCache && userDef.cache !== false ? $69b5f56b6d1ac1d8$var$createComputedGetter(key) : $69b5f56b6d1ac1d8$var$createGetterInvoker(userDef.get) : $69b5f56b6d1ac1d8$var$noop;
        $69b5f56b6d1ac1d8$var$sharedPropertyDefinition.set = userDef.set || $69b5f56b6d1ac1d8$var$noop;
    }
    if ($69b5f56b6d1ac1d8$var$sharedPropertyDefinition.set === $69b5f56b6d1ac1d8$var$noop) $69b5f56b6d1ac1d8$var$sharedPropertyDefinition.set = function() {
        $69b5f56b6d1ac1d8$var$warn$2(`Computed property "${key}" was assigned to but it has no setter.`, this);
    };
    Object.defineProperty(target, key, $69b5f56b6d1ac1d8$var$sharedPropertyDefinition);
}
function $69b5f56b6d1ac1d8$var$createComputedGetter(key) {
    return function computedGetter() {
        const watcher = this._computedWatchers && this._computedWatchers[key];
        if (watcher) {
            if (watcher.dirty) watcher.evaluate();
            if ($69b5f56b6d1ac1d8$var$Dep.target) {
                if ($69b5f56b6d1ac1d8$var$Dep.target.onTrack) $69b5f56b6d1ac1d8$var$Dep.target.onTrack({
                    effect: $69b5f56b6d1ac1d8$var$Dep.target,
                    target: this,
                    type: "get" /* TrackOpTypes.GET */ ,
                    key: key
                });
                watcher.depend();
            }
            return watcher.value;
        }
    };
}
function $69b5f56b6d1ac1d8$var$createGetterInvoker(fn) {
    return function computedGetter() {
        return fn.call(this, this);
    };
}
function $69b5f56b6d1ac1d8$var$initMethods(vm, methods) {
    const props = vm.$options.props;
    for(const key in methods){
        if (typeof methods[key] !== 'function') $69b5f56b6d1ac1d8$var$warn$2(`Method "${key}" has type "${typeof methods[key]}" in the component definition. ` + `Did you reference the function correctly?`, vm);
        if (props && $69b5f56b6d1ac1d8$var$hasOwn(props, key)) $69b5f56b6d1ac1d8$var$warn$2(`Method "${key}" has already been defined as a prop.`, vm);
        if (key in vm && $69b5f56b6d1ac1d8$var$isReserved(key)) $69b5f56b6d1ac1d8$var$warn$2(`Method "${key}" conflicts with an existing Vue instance method. ` + `Avoid defining component methods that start with _ or $.`);
        vm[key] = typeof methods[key] !== 'function' ? $69b5f56b6d1ac1d8$var$noop : $69b5f56b6d1ac1d8$var$bind$1(methods[key], vm);
    }
}
function $69b5f56b6d1ac1d8$var$initWatch(vm, watch) {
    for(const key in watch){
        const handler = watch[key];
        if ($69b5f56b6d1ac1d8$var$isArray(handler)) for(let i = 0; i < handler.length; i++)$69b5f56b6d1ac1d8$var$createWatcher(vm, key, handler[i]);
        else $69b5f56b6d1ac1d8$var$createWatcher(vm, key, handler);
    }
}
function $69b5f56b6d1ac1d8$var$createWatcher(vm, expOrFn, handler, options) {
    if ($69b5f56b6d1ac1d8$var$isPlainObject(handler)) {
        options = handler;
        handler = handler.handler;
    }
    if (typeof handler === 'string') handler = vm[handler];
    return vm.$watch(expOrFn, handler, options);
}
function $69b5f56b6d1ac1d8$var$stateMixin(Vue) {
    // flow somehow has problems with directly declared definition object
    // when using Object.defineProperty, so we have to procedurally build up
    // the object here.
    const dataDef = {};
    dataDef.get = function() {
        return this._data;
    };
    const propsDef = {};
    propsDef.get = function() {
        return this._props;
    };
    dataDef.set = function() {
        $69b5f56b6d1ac1d8$var$warn$2("Avoid replacing instance root $data. Use nested data properties instead.", this);
    };
    propsDef.set = function() {
        $69b5f56b6d1ac1d8$var$warn$2(`$props is readonly.`, this);
    };
    Object.defineProperty(Vue.prototype, '$data', dataDef);
    Object.defineProperty(Vue.prototype, '$props', propsDef);
    Vue.prototype.$set = $69b5f56b6d1ac1d8$var$set;
    Vue.prototype.$delete = $69b5f56b6d1ac1d8$var$del;
    Vue.prototype.$watch = function(expOrFn, cb, options) {
        const vm = this;
        if ($69b5f56b6d1ac1d8$var$isPlainObject(cb)) return $69b5f56b6d1ac1d8$var$createWatcher(vm, expOrFn, cb, options);
        options = options || {};
        options.user = true;
        const watcher = new $69b5f56b6d1ac1d8$var$Watcher(vm, expOrFn, cb, options);
        if (options.immediate) {
            const info = `callback for immediate watcher "${watcher.expression}"`;
            $69b5f56b6d1ac1d8$var$pushTarget();
            $69b5f56b6d1ac1d8$var$invokeWithErrorHandling(cb, vm, [
                watcher.value
            ], vm, info);
            $69b5f56b6d1ac1d8$var$popTarget();
        }
        return function unwatchFn() {
            watcher.teardown();
        };
    };
}
function $69b5f56b6d1ac1d8$var$initProvide(vm) {
    const provideOption = vm.$options.provide;
    if (provideOption) {
        const provided = $69b5f56b6d1ac1d8$var$isFunction(provideOption) ? provideOption.call(vm) : provideOption;
        if (!$69b5f56b6d1ac1d8$var$isObject(provided)) return;
        const source = $69b5f56b6d1ac1d8$var$resolveProvided(vm);
        // IE9 doesn't support Object.getOwnPropertyDescriptors so we have to
        // iterate the keys ourselves.
        const keys = $69b5f56b6d1ac1d8$var$hasSymbol ? Reflect.ownKeys(provided) : Object.keys(provided);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            Object.defineProperty(source, key, Object.getOwnPropertyDescriptor(provided, key));
        }
    }
}
function $69b5f56b6d1ac1d8$var$initInjections(vm) {
    const result = $69b5f56b6d1ac1d8$var$resolveInject(vm.$options.inject, vm);
    if (result) {
        $69b5f56b6d1ac1d8$var$toggleObserving(false);
        Object.keys(result).forEach((key)=>{
            $69b5f56b6d1ac1d8$var$defineReactive(vm, key, result[key], ()=>{
                $69b5f56b6d1ac1d8$var$warn$2(`Avoid mutating an injected value directly since the changes will be ` + `overwritten whenever the provided component re-renders. ` + `injection being mutated: "${key}"`, vm);
            });
        });
        $69b5f56b6d1ac1d8$var$toggleObserving(true);
    }
}
function $69b5f56b6d1ac1d8$var$resolveInject(inject, vm) {
    if (inject) {
        // inject is :any because flow is not smart enough to figure out cached
        const result = Object.create(null);
        const keys = $69b5f56b6d1ac1d8$var$hasSymbol ? Reflect.ownKeys(inject) : Object.keys(inject);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            // #6574 in case the inject object is observed...
            if (key === '__ob__') continue;
            const provideKey = inject[key].from;
            if (provideKey in vm._provided) result[key] = vm._provided[provideKey];
            else if ('default' in inject[key]) {
                const provideDefault = inject[key].default;
                result[key] = $69b5f56b6d1ac1d8$var$isFunction(provideDefault) ? provideDefault.call(vm) : provideDefault;
            } else $69b5f56b6d1ac1d8$var$warn$2(`Injection "${key}" not found`, vm);
        }
        return result;
    }
}
let $69b5f56b6d1ac1d8$var$uid = 0;
function $69b5f56b6d1ac1d8$var$initMixin$1(Vue) {
    Vue.prototype._init = function(options) {
        const vm = this;
        // a uid
        vm._uid = $69b5f56b6d1ac1d8$var$uid++;
        let startTag, endTag;
        /* istanbul ignore if */ if ($69b5f56b6d1ac1d8$var$config.performance && $69b5f56b6d1ac1d8$var$mark) {
            startTag = `vue-perf-start:${vm._uid}`;
            endTag = `vue-perf-end:${vm._uid}`;
            $69b5f56b6d1ac1d8$var$mark(startTag);
        }
        // a flag to mark this as a Vue instance without having to do instanceof
        // check
        vm._isVue = true;
        // avoid instances from being observed
        vm.__v_skip = true;
        // effect scope
        vm._scope = new $69b5f56b6d1ac1d8$var$EffectScope(true);
        // #13134 edge case where a child component is manually created during the
        // render of a parent component
        vm._scope.parent = undefined;
        vm._scope._vm = true;
        // merge options
        if (options && options._isComponent) // optimize internal component instantiation
        // since dynamic options merging is pretty slow, and none of the
        // internal component options needs special treatment.
        $69b5f56b6d1ac1d8$var$initInternalComponent(vm, options);
        else vm.$options = $69b5f56b6d1ac1d8$var$mergeOptions($69b5f56b6d1ac1d8$var$resolveConstructorOptions(vm.constructor), options || {}, vm);
        $69b5f56b6d1ac1d8$var$initProxy(vm);
        // expose real self
        vm._self = vm;
        $69b5f56b6d1ac1d8$var$initLifecycle(vm);
        $69b5f56b6d1ac1d8$var$initEvents(vm);
        $69b5f56b6d1ac1d8$var$initRender(vm);
        $69b5f56b6d1ac1d8$var$callHook$1(vm, 'beforeCreate', undefined, false);
        $69b5f56b6d1ac1d8$var$initInjections(vm); // resolve injections before data/props
        $69b5f56b6d1ac1d8$var$initState(vm);
        $69b5f56b6d1ac1d8$var$initProvide(vm); // resolve provide after data/props
        $69b5f56b6d1ac1d8$var$callHook$1(vm, 'created');
        /* istanbul ignore if */ if ($69b5f56b6d1ac1d8$var$config.performance && $69b5f56b6d1ac1d8$var$mark) {
            vm._name = $69b5f56b6d1ac1d8$var$formatComponentName(vm, false);
            $69b5f56b6d1ac1d8$var$mark(endTag);
            $69b5f56b6d1ac1d8$var$measure(`vue ${vm._name} init`, startTag, endTag);
        }
        if (vm.$options.el) vm.$mount(vm.$options.el);
    };
}
function $69b5f56b6d1ac1d8$var$initInternalComponent(vm, options) {
    const opts = vm.$options = Object.create(vm.constructor.options);
    // doing this because it's faster than dynamic enumeration.
    const parentVnode = options._parentVnode;
    opts.parent = options.parent;
    opts._parentVnode = parentVnode;
    const vnodeComponentOptions = parentVnode.componentOptions;
    opts.propsData = vnodeComponentOptions.propsData;
    opts._parentListeners = vnodeComponentOptions.listeners;
    opts._renderChildren = vnodeComponentOptions.children;
    opts._componentTag = vnodeComponentOptions.tag;
    if (options.render) {
        opts.render = options.render;
        opts.staticRenderFns = options.staticRenderFns;
    }
}
function $69b5f56b6d1ac1d8$var$resolveConstructorOptions(Ctor) {
    let options = Ctor.options;
    if (Ctor.super) {
        const superOptions = $69b5f56b6d1ac1d8$var$resolveConstructorOptions(Ctor.super);
        const cachedSuperOptions = Ctor.superOptions;
        if (superOptions !== cachedSuperOptions) {
            // super option changed,
            // need to resolve new options.
            Ctor.superOptions = superOptions;
            // check if there are any late-modified/attached options (#4976)
            const modifiedOptions = $69b5f56b6d1ac1d8$var$resolveModifiedOptions(Ctor);
            // update base extend options
            if (modifiedOptions) $69b5f56b6d1ac1d8$var$extend(Ctor.extendOptions, modifiedOptions);
            options = Ctor.options = $69b5f56b6d1ac1d8$var$mergeOptions(superOptions, Ctor.extendOptions);
            if (options.name) options.components[options.name] = Ctor;
        }
    }
    return options;
}
function $69b5f56b6d1ac1d8$var$resolveModifiedOptions(Ctor) {
    let modified;
    const latest = Ctor.options;
    const sealed = Ctor.sealedOptions;
    for(const key in latest)if (latest[key] !== sealed[key]) {
        if (!modified) modified = {};
        modified[key] = latest[key];
    }
    return modified;
}
function $69b5f56b6d1ac1d8$var$FunctionalRenderContext(data, props, children, parent, Ctor) {
    const options = Ctor.options;
    // ensure the createElement function in functional components
    // gets a unique context - this is necessary for correct named slot check
    let contextVm;
    if ($69b5f56b6d1ac1d8$var$hasOwn(parent, '_uid')) {
        contextVm = Object.create(parent);
        contextVm._original = parent;
    } else {
        // the context vm passed in is a functional context as well.
        // in this case we want to make sure we are able to get a hold to the
        // real context instance.
        contextVm = parent;
        // @ts-ignore
        parent = parent._original;
    }
    const isCompiled = $69b5f56b6d1ac1d8$var$isTrue(options._compiled);
    const needNormalization = !isCompiled;
    this.data = data;
    this.props = props;
    this.children = children;
    this.parent = parent;
    this.listeners = data.on || $69b5f56b6d1ac1d8$var$emptyObject;
    this.injections = $69b5f56b6d1ac1d8$var$resolveInject(options.inject, parent);
    this.slots = ()=>{
        if (!this.$slots) $69b5f56b6d1ac1d8$var$normalizeScopedSlots(parent, data.scopedSlots, this.$slots = $69b5f56b6d1ac1d8$var$resolveSlots(children, parent));
        return this.$slots;
    };
    Object.defineProperty(this, 'scopedSlots', {
        enumerable: true,
        get () {
            return $69b5f56b6d1ac1d8$var$normalizeScopedSlots(parent, data.scopedSlots, this.slots());
        }
    });
    // support for compiled functional template
    if (isCompiled) {
        // exposing $options for renderStatic()
        this.$options = options;
        // pre-resolve slots for renderSlot()
        this.$slots = this.slots();
        this.$scopedSlots = $69b5f56b6d1ac1d8$var$normalizeScopedSlots(parent, data.scopedSlots, this.$slots);
    }
    if (options._scopeId) this._c = (a, b, c, d)=>{
        const vnode = $69b5f56b6d1ac1d8$var$createElement$1(contextVm, a, b, c, d, needNormalization);
        if (vnode && !$69b5f56b6d1ac1d8$var$isArray(vnode)) {
            vnode.fnScopeId = options._scopeId;
            vnode.fnContext = parent;
        }
        return vnode;
    };
    else this._c = (a, b, c, d)=>$69b5f56b6d1ac1d8$var$createElement$1(contextVm, a, b, c, d, needNormalization);
}
$69b5f56b6d1ac1d8$var$installRenderHelpers($69b5f56b6d1ac1d8$var$FunctionalRenderContext.prototype);
function $69b5f56b6d1ac1d8$var$createFunctionalComponent(Ctor, propsData, data, contextVm, children) {
    const options = Ctor.options;
    const props = {};
    const propOptions = options.props;
    if ($69b5f56b6d1ac1d8$var$isDef(propOptions)) for(const key in propOptions)props[key] = $69b5f56b6d1ac1d8$var$validateProp(key, propOptions, propsData || $69b5f56b6d1ac1d8$var$emptyObject);
    else {
        if ($69b5f56b6d1ac1d8$var$isDef(data.attrs)) $69b5f56b6d1ac1d8$var$mergeProps(props, data.attrs);
        if ($69b5f56b6d1ac1d8$var$isDef(data.props)) $69b5f56b6d1ac1d8$var$mergeProps(props, data.props);
    }
    const renderContext = new $69b5f56b6d1ac1d8$var$FunctionalRenderContext(data, props, children, contextVm, Ctor);
    const vnode = options.render.call(null, renderContext._c, renderContext);
    if (vnode instanceof $69b5f56b6d1ac1d8$var$VNode) return $69b5f56b6d1ac1d8$var$cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext);
    else if ($69b5f56b6d1ac1d8$var$isArray(vnode)) {
        const vnodes = $69b5f56b6d1ac1d8$var$normalizeChildren(vnode) || [];
        const res = new Array(vnodes.length);
        for(let i = 0; i < vnodes.length; i++)res[i] = $69b5f56b6d1ac1d8$var$cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
        return res;
    }
}
function $69b5f56b6d1ac1d8$var$cloneAndMarkFunctionalResult(vnode, data, contextVm, options, renderContext) {
    // #7817 clone node before setting fnContext, otherwise if the node is reused
    // (e.g. it was from a cached normal slot) the fnContext causes named slots
    // that should not be matched to match.
    const clone = $69b5f56b6d1ac1d8$var$cloneVNode(vnode);
    clone.fnContext = contextVm;
    clone.fnOptions = options;
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
    if (data.slot) (clone.data || (clone.data = {})).slot = data.slot;
    return clone;
}
function $69b5f56b6d1ac1d8$var$mergeProps(to, from) {
    for(const key in from)to[$69b5f56b6d1ac1d8$var$camelize(key)] = from[key];
}
function $69b5f56b6d1ac1d8$var$getComponentName(options) {
    return options.name || options.__name || options._componentTag;
}
// inline hooks to be invoked on component VNodes during patch
const $69b5f56b6d1ac1d8$var$componentVNodeHooks = {
    init (vnode, hydrating) {
        if (vnode.componentInstance && !vnode.componentInstance._isDestroyed && vnode.data.keepAlive) {
            // kept-alive components, treat as a patch
            const mountedNode = vnode; // work around flow
            $69b5f56b6d1ac1d8$var$componentVNodeHooks.prepatch(mountedNode, mountedNode);
        } else {
            const child = vnode.componentInstance = $69b5f56b6d1ac1d8$var$createComponentInstanceForVnode(vnode, $69b5f56b6d1ac1d8$var$activeInstance);
            child.$mount(hydrating ? vnode.elm : undefined, hydrating);
        }
    },
    prepatch (oldVnode, vnode) {
        const options = vnode.componentOptions;
        const child = vnode.componentInstance = oldVnode.componentInstance;
        $69b5f56b6d1ac1d8$var$updateChildComponent(child, options.propsData, options.listeners, vnode, options.children // new children
        );
    },
    insert (vnode) {
        const { context: context, componentInstance: componentInstance } = vnode;
        if (!componentInstance._isMounted) {
            componentInstance._isMounted = true;
            $69b5f56b6d1ac1d8$var$callHook$1(componentInstance, 'mounted');
        }
        if (vnode.data.keepAlive) {
            if (context._isMounted) // vue-router#1212
            // During updates, a kept-alive component's child components may
            // change, so directly walking the tree here may call activated hooks
            // on incorrect children. Instead we push them into a queue which will
            // be processed after the whole patch process ended.
            $69b5f56b6d1ac1d8$var$queueActivatedComponent(componentInstance);
            else $69b5f56b6d1ac1d8$var$activateChildComponent(componentInstance, true);
        }
    },
    destroy (vnode) {
        const { componentInstance: componentInstance } = vnode;
        if (!componentInstance._isDestroyed) {
            if (!vnode.data.keepAlive) componentInstance.$destroy();
            else $69b5f56b6d1ac1d8$var$deactivateChildComponent(componentInstance, true);
        }
    }
};
const $69b5f56b6d1ac1d8$var$hooksToMerge = Object.keys($69b5f56b6d1ac1d8$var$componentVNodeHooks);
function $69b5f56b6d1ac1d8$var$createComponent(Ctor, data, context, children, tag) {
    if ($69b5f56b6d1ac1d8$var$isUndef(Ctor)) return;
    const baseCtor = context.$options._base;
    // plain options object: turn it into a constructor
    if ($69b5f56b6d1ac1d8$var$isObject(Ctor)) Ctor = baseCtor.extend(Ctor);
    // if at this stage it's not a constructor or an async component factory,
    // reject.
    if (typeof Ctor !== 'function') {
        $69b5f56b6d1ac1d8$var$warn$2(`Invalid Component definition: ${String(Ctor)}`, context);
        return;
    }
    // async component
    let asyncFactory;
    // @ts-expect-error
    if ($69b5f56b6d1ac1d8$var$isUndef(Ctor.cid)) {
        asyncFactory = Ctor;
        Ctor = $69b5f56b6d1ac1d8$var$resolveAsyncComponent(asyncFactory, baseCtor);
        if (Ctor === undefined) // return a placeholder node for async component, which is rendered
        // as a comment node but preserves all the raw information for the node.
        // the information will be used for async server-rendering and hydration.
        return $69b5f56b6d1ac1d8$var$createAsyncPlaceholder(asyncFactory, data, context, children, tag);
    }
    data = data || {};
    // resolve constructor options in case global mixins are applied after
    // component constructor creation
    $69b5f56b6d1ac1d8$var$resolveConstructorOptions(Ctor);
    // transform component v-model data into props & events
    if ($69b5f56b6d1ac1d8$var$isDef(data.model)) // @ts-expect-error
    $69b5f56b6d1ac1d8$var$transformModel(Ctor.options, data);
    // extract props
    // @ts-expect-error
    const propsData = $69b5f56b6d1ac1d8$var$extractPropsFromVNodeData(data, Ctor, tag);
    // functional component
    // @ts-expect-error
    if ($69b5f56b6d1ac1d8$var$isTrue(Ctor.options.functional)) return $69b5f56b6d1ac1d8$var$createFunctionalComponent(Ctor, propsData, data, context, children);
    // extract listeners, since these needs to be treated as
    // child component listeners instead of DOM listeners
    const listeners = data.on;
    // replace with listeners with .native modifier
    // so it gets processed during parent component patch.
    data.on = data.nativeOn;
    // @ts-expect-error
    if ($69b5f56b6d1ac1d8$var$isTrue(Ctor.options.abstract)) {
        // abstract components do not keep anything
        // other than props & listeners & slot
        // work around flow
        const slot = data.slot;
        data = {};
        if (slot) data.slot = slot;
    }
    // install component management hooks onto the placeholder node
    $69b5f56b6d1ac1d8$var$installComponentHooks(data);
    // return a placeholder vnode
    // @ts-expect-error
    const name = $69b5f56b6d1ac1d8$var$getComponentName(Ctor.options) || tag;
    const vnode = new $69b5f56b6d1ac1d8$var$VNode(// @ts-expect-error
    `vue-component-${Ctor.cid}${name ? `-${name}` : ''}`, data, undefined, undefined, undefined, context, // @ts-expect-error
    {
        Ctor: Ctor,
        propsData: propsData,
        listeners: listeners,
        tag: tag,
        children: children
    }, asyncFactory);
    return vnode;
}
function $69b5f56b6d1ac1d8$var$createComponentInstanceForVnode(// we know it's MountedComponentVNode but flow doesn't
vnode, // activeInstance in lifecycle state
parent) {
    const options = {
        _isComponent: true,
        _parentVnode: vnode,
        parent: parent
    };
    // check inline-template render functions
    const inlineTemplate = vnode.data.inlineTemplate;
    if ($69b5f56b6d1ac1d8$var$isDef(inlineTemplate)) {
        options.render = inlineTemplate.render;
        options.staticRenderFns = inlineTemplate.staticRenderFns;
    }
    return new vnode.componentOptions.Ctor(options);
}
function $69b5f56b6d1ac1d8$var$installComponentHooks(data) {
    const hooks = data.hook || (data.hook = {});
    for(let i = 0; i < $69b5f56b6d1ac1d8$var$hooksToMerge.length; i++){
        const key = $69b5f56b6d1ac1d8$var$hooksToMerge[i];
        const existing = hooks[key];
        const toMerge = $69b5f56b6d1ac1d8$var$componentVNodeHooks[key];
        // @ts-expect-error
        if (existing !== toMerge && !(existing && existing._merged)) hooks[key] = existing ? $69b5f56b6d1ac1d8$var$mergeHook(toMerge, existing) : toMerge;
    }
}
function $69b5f56b6d1ac1d8$var$mergeHook(f1, f2) {
    const merged = (a, b)=>{
        // flow complains about extra args which is why we use any
        f1(a, b);
        f2(a, b);
    };
    merged._merged = true;
    return merged;
}
// transform component v-model info (value and callback) into
// prop and event handler respectively.
function $69b5f56b6d1ac1d8$var$transformModel(options, data) {
    const prop = options.model && options.model.prop || 'value';
    const event = options.model && options.model.event || 'input';
    (data.attrs || (data.attrs = {}))[prop] = data.model.value;
    const on = data.on || (data.on = {});
    const existing = on[event];
    const callback = data.model.callback;
    if ($69b5f56b6d1ac1d8$var$isDef(existing)) {
        if ($69b5f56b6d1ac1d8$var$isArray(existing) ? existing.indexOf(callback) === -1 : existing !== callback) on[event] = [
            callback
        ].concat(existing);
    } else on[event] = callback;
}
let $69b5f56b6d1ac1d8$var$warn$2 = $69b5f56b6d1ac1d8$var$noop;
let $69b5f56b6d1ac1d8$var$tip = $69b5f56b6d1ac1d8$var$noop;
let $69b5f56b6d1ac1d8$var$generateComponentTrace; // work around flow check
let $69b5f56b6d1ac1d8$var$formatComponentName;
{
    const hasConsole = typeof console !== 'undefined';
    const classifyRE = /(?:^|[-_])(\w)/g;
    const classify = (str)=>str.replace(classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, '');
    $69b5f56b6d1ac1d8$var$warn$2 = (msg, vm = $69b5f56b6d1ac1d8$var$currentInstance)=>{
        const trace = vm ? $69b5f56b6d1ac1d8$var$generateComponentTrace(vm) : '';
        if ($69b5f56b6d1ac1d8$var$config.warnHandler) $69b5f56b6d1ac1d8$var$config.warnHandler.call(null, msg, vm, trace);
        else if (hasConsole && !$69b5f56b6d1ac1d8$var$config.silent) console.error(`[Vue warn]: ${msg}${trace}`);
    };
    $69b5f56b6d1ac1d8$var$tip = (msg, vm)=>{
        if (hasConsole && !$69b5f56b6d1ac1d8$var$config.silent) console.warn(`[Vue tip]: ${msg}` + (vm ? $69b5f56b6d1ac1d8$var$generateComponentTrace(vm) : ''));
    };
    $69b5f56b6d1ac1d8$var$formatComponentName = (vm, includeFile)=>{
        if (vm.$root === vm) return '<Root>';
        const options = $69b5f56b6d1ac1d8$var$isFunction(vm) && vm.cid != null ? vm.options : vm._isVue ? vm.$options || vm.constructor.options : vm;
        let name = $69b5f56b6d1ac1d8$var$getComponentName(options);
        const file = options.__file;
        if (!name && file) {
            const match = file.match(/([^/\\]+)\.vue$/);
            name = match && match[1];
        }
        return (name ? `<${classify(name)}>` : `<Anonymous>`) + (file && includeFile !== false ? ` at ${file}` : '');
    };
    const repeat = (str, n)=>{
        let res = '';
        while(n){
            if (n % 2 === 1) res += str;
            if (n > 1) str += str;
            n >>= 1;
        }
        return res;
    };
    $69b5f56b6d1ac1d8$var$generateComponentTrace = (vm)=>{
        if (vm._isVue && vm.$parent) {
            const tree = [];
            let currentRecursiveSequence = 0;
            while(vm){
                if (tree.length > 0) {
                    const last = tree[tree.length - 1];
                    if (last.constructor === vm.constructor) {
                        currentRecursiveSequence++;
                        vm = vm.$parent;
                        continue;
                    } else if (currentRecursiveSequence > 0) {
                        tree[tree.length - 1] = [
                            last,
                            currentRecursiveSequence
                        ];
                        currentRecursiveSequence = 0;
                    }
                }
                tree.push(vm);
                vm = vm.$parent;
            }
            return '\n\nfound in\n\n' + tree.map((vm, i)=>`${i === 0 ? '---> ' : repeat(' ', 5 + i * 2)}${$69b5f56b6d1ac1d8$var$isArray(vm) ? `${$69b5f56b6d1ac1d8$var$formatComponentName(vm[0])}... (${vm[1]} recursive calls)` : $69b5f56b6d1ac1d8$var$formatComponentName(vm)}`).join('\n');
        } else return `\n\n(found in ${$69b5f56b6d1ac1d8$var$formatComponentName(vm)})`;
    };
}/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */ const $69b5f56b6d1ac1d8$var$strats = $69b5f56b6d1ac1d8$var$config.optionMergeStrategies;
$69b5f56b6d1ac1d8$var$strats.el = $69b5f56b6d1ac1d8$var$strats.propsData = function(parent, child, vm, key) {
    if (!vm) $69b5f56b6d1ac1d8$var$warn$2(`option "${key}" can only be used during instance ` + 'creation with the `new` keyword.');
    return $69b5f56b6d1ac1d8$var$defaultStrat(parent, child);
};
/**
 * Helper that recursively merges two data objects together.
 */ function $69b5f56b6d1ac1d8$var$mergeData(to, from, recursive = true) {
    if (!from) return to;
    let key, toVal, fromVal;
    const keys = $69b5f56b6d1ac1d8$var$hasSymbol ? Reflect.ownKeys(from) : Object.keys(from);
    for(let i = 0; i < keys.length; i++){
        key = keys[i];
        // in case the object is already observed...
        if (key === '__ob__') continue;
        toVal = to[key];
        fromVal = from[key];
        if (!recursive || !$69b5f56b6d1ac1d8$var$hasOwn(to, key)) $69b5f56b6d1ac1d8$var$set(to, key, fromVal);
        else if (toVal !== fromVal && $69b5f56b6d1ac1d8$var$isPlainObject(toVal) && $69b5f56b6d1ac1d8$var$isPlainObject(fromVal)) $69b5f56b6d1ac1d8$var$mergeData(toVal, fromVal);
    }
    return to;
}
/**
 * Data
 */ function $69b5f56b6d1ac1d8$var$mergeDataOrFn(parentVal, childVal, vm) {
    if (!vm) {
        // in a Vue.extend merge, both should be functions
        if (!childVal) return parentVal;
        if (!parentVal) return childVal;
        // when parentVal & childVal are both present,
        // we need to return a function that returns the
        // merged result of both functions... no need to
        // check if parentVal is a function here because
        // it has to be a function to pass previous merges.
        return function mergedDataFn() {
            return $69b5f56b6d1ac1d8$var$mergeData($69b5f56b6d1ac1d8$var$isFunction(childVal) ? childVal.call(this, this) : childVal, $69b5f56b6d1ac1d8$var$isFunction(parentVal) ? parentVal.call(this, this) : parentVal);
        };
    } else return function mergedInstanceDataFn() {
        // instance merge
        const instanceData = $69b5f56b6d1ac1d8$var$isFunction(childVal) ? childVal.call(vm, vm) : childVal;
        const defaultData = $69b5f56b6d1ac1d8$var$isFunction(parentVal) ? parentVal.call(vm, vm) : parentVal;
        if (instanceData) return $69b5f56b6d1ac1d8$var$mergeData(instanceData, defaultData);
        else return defaultData;
    };
}
$69b5f56b6d1ac1d8$var$strats.data = function(parentVal, childVal, vm) {
    if (!vm) {
        if (childVal && typeof childVal !== 'function') {
            $69b5f56b6d1ac1d8$var$warn$2('The "data" option should be a function that returns a per-instance value in component definitions.', vm);
            return parentVal;
        }
        return $69b5f56b6d1ac1d8$var$mergeDataOrFn(parentVal, childVal);
    }
    return $69b5f56b6d1ac1d8$var$mergeDataOrFn(parentVal, childVal, vm);
};
/**
 * Hooks and props are merged as arrays.
 */ function $69b5f56b6d1ac1d8$var$mergeLifecycleHook(parentVal, childVal) {
    const res = childVal ? parentVal ? parentVal.concat(childVal) : $69b5f56b6d1ac1d8$var$isArray(childVal) ? childVal : [
        childVal
    ] : parentVal;
    return res ? $69b5f56b6d1ac1d8$var$dedupeHooks(res) : res;
}
function $69b5f56b6d1ac1d8$var$dedupeHooks(hooks) {
    const res = [];
    for(let i = 0; i < hooks.length; i++)if (res.indexOf(hooks[i]) === -1) res.push(hooks[i]);
    return res;
}
$69b5f56b6d1ac1d8$var$LIFECYCLE_HOOKS.forEach((hook)=>{
    $69b5f56b6d1ac1d8$var$strats[hook] = $69b5f56b6d1ac1d8$var$mergeLifecycleHook;
});
/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */ function $69b5f56b6d1ac1d8$var$mergeAssets(parentVal, childVal, vm, key) {
    const res = Object.create(parentVal || null);
    if (childVal) {
        $69b5f56b6d1ac1d8$var$assertObjectType(key, childVal, vm);
        return $69b5f56b6d1ac1d8$var$extend(res, childVal);
    } else return res;
}
$69b5f56b6d1ac1d8$var$ASSET_TYPES.forEach(function(type) {
    $69b5f56b6d1ac1d8$var$strats[type + 's'] = $69b5f56b6d1ac1d8$var$mergeAssets;
});
/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */ $69b5f56b6d1ac1d8$var$strats.watch = function(parentVal, childVal, vm, key) {
    // work around Firefox's Object.prototype.watch...
    //@ts-expect-error work around
    if (parentVal === $69b5f56b6d1ac1d8$var$nativeWatch) parentVal = undefined;
    //@ts-expect-error work around
    if (childVal === $69b5f56b6d1ac1d8$var$nativeWatch) childVal = undefined;
    /* istanbul ignore if */ if (!childVal) return Object.create(parentVal || null);
    $69b5f56b6d1ac1d8$var$assertObjectType(key, childVal, vm);
    if (!parentVal) return childVal;
    const ret = {};
    $69b5f56b6d1ac1d8$var$extend(ret, parentVal);
    for(const key in childVal){
        let parent = ret[key];
        const child = childVal[key];
        if (parent && !$69b5f56b6d1ac1d8$var$isArray(parent)) parent = [
            parent
        ];
        ret[key] = parent ? parent.concat(child) : $69b5f56b6d1ac1d8$var$isArray(child) ? child : [
            child
        ];
    }
    return ret;
};
/**
 * Other object hashes.
 */ $69b5f56b6d1ac1d8$var$strats.props = $69b5f56b6d1ac1d8$var$strats.methods = $69b5f56b6d1ac1d8$var$strats.inject = $69b5f56b6d1ac1d8$var$strats.computed = function(parentVal, childVal, vm, key) {
    if (childVal && true) $69b5f56b6d1ac1d8$var$assertObjectType(key, childVal, vm);
    if (!parentVal) return childVal;
    const ret = Object.create(null);
    $69b5f56b6d1ac1d8$var$extend(ret, parentVal);
    if (childVal) $69b5f56b6d1ac1d8$var$extend(ret, childVal);
    return ret;
};
$69b5f56b6d1ac1d8$var$strats.provide = function(parentVal, childVal) {
    if (!parentVal) return childVal;
    return function() {
        const ret = Object.create(null);
        $69b5f56b6d1ac1d8$var$mergeData(ret, $69b5f56b6d1ac1d8$var$isFunction(parentVal) ? parentVal.call(this) : parentVal);
        if (childVal) $69b5f56b6d1ac1d8$var$mergeData(ret, $69b5f56b6d1ac1d8$var$isFunction(childVal) ? childVal.call(this) : childVal, false // non-recursive
        );
        return ret;
    };
};
/**
 * Default strategy.
 */ const $69b5f56b6d1ac1d8$var$defaultStrat = function(parentVal, childVal) {
    return childVal === undefined ? parentVal : childVal;
};
/**
 * Validate component names
 */ function $69b5f56b6d1ac1d8$var$checkComponents(options) {
    for(const key in options.components)$69b5f56b6d1ac1d8$var$validateComponentName(key);
}
function $69b5f56b6d1ac1d8$var$validateComponentName(name) {
    if (!new RegExp(`^[a-zA-Z][\\-\\.0-9_${$69b5f56b6d1ac1d8$var$unicodeRegExp.source}]*$`).test(name)) $69b5f56b6d1ac1d8$var$warn$2('Invalid component name: "' + name + '". Component names ' + 'should conform to valid custom element name in html5 specification.');
    if ($69b5f56b6d1ac1d8$var$isBuiltInTag(name) || $69b5f56b6d1ac1d8$var$config.isReservedTag(name)) $69b5f56b6d1ac1d8$var$warn$2("Do not use built-in or reserved HTML elements as component id: " + name);
}
/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */ function $69b5f56b6d1ac1d8$var$normalizeProps(options, vm) {
    const props = options.props;
    if (!props) return;
    const res = {};
    let i, val, name;
    if ($69b5f56b6d1ac1d8$var$isArray(props)) {
        i = props.length;
        while(i--){
            val = props[i];
            if (typeof val === 'string') {
                name = $69b5f56b6d1ac1d8$var$camelize(val);
                res[name] = {
                    type: null
                };
            } else $69b5f56b6d1ac1d8$var$warn$2('props must be strings when using array syntax.');
        }
    } else if ($69b5f56b6d1ac1d8$var$isPlainObject(props)) for(const key in props){
        val = props[key];
        name = $69b5f56b6d1ac1d8$var$camelize(key);
        res[name] = $69b5f56b6d1ac1d8$var$isPlainObject(val) ? val : {
            type: val
        };
    }
    else $69b5f56b6d1ac1d8$var$warn$2(`Invalid value for option "props": expected an Array or an Object, ` + `but got ${$69b5f56b6d1ac1d8$var$toRawType(props)}.`, vm);
    options.props = res;
}
/**
 * Normalize all injections into Object-based format
 */ function $69b5f56b6d1ac1d8$var$normalizeInject(options, vm) {
    const inject = options.inject;
    if (!inject) return;
    const normalized = options.inject = {};
    if ($69b5f56b6d1ac1d8$var$isArray(inject)) for(let i = 0; i < inject.length; i++)normalized[inject[i]] = {
        from: inject[i]
    };
    else if ($69b5f56b6d1ac1d8$var$isPlainObject(inject)) for(const key in inject){
        const val = inject[key];
        normalized[key] = $69b5f56b6d1ac1d8$var$isPlainObject(val) ? $69b5f56b6d1ac1d8$var$extend({
            from: key
        }, val) : {
            from: val
        };
    }
    else $69b5f56b6d1ac1d8$var$warn$2(`Invalid value for option "inject": expected an Array or an Object, ` + `but got ${$69b5f56b6d1ac1d8$var$toRawType(inject)}.`, vm);
}
/**
 * Normalize raw function directives into object format.
 */ function $69b5f56b6d1ac1d8$var$normalizeDirectives$1(options) {
    const dirs = options.directives;
    if (dirs) for(const key in dirs){
        const def = dirs[key];
        if ($69b5f56b6d1ac1d8$var$isFunction(def)) dirs[key] = {
            bind: def,
            update: def
        };
    }
}
function $69b5f56b6d1ac1d8$var$assertObjectType(name, value, vm) {
    if (!$69b5f56b6d1ac1d8$var$isPlainObject(value)) $69b5f56b6d1ac1d8$var$warn$2(`Invalid value for option "${name}": expected an Object, ` + `but got ${$69b5f56b6d1ac1d8$var$toRawType(value)}.`, vm);
}
/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */ function $69b5f56b6d1ac1d8$var$mergeOptions(parent, child, vm) {
    $69b5f56b6d1ac1d8$var$checkComponents(child);
    if ($69b5f56b6d1ac1d8$var$isFunction(child)) // @ts-expect-error
    child = child.options;
    $69b5f56b6d1ac1d8$var$normalizeProps(child, vm);
    $69b5f56b6d1ac1d8$var$normalizeInject(child, vm);
    $69b5f56b6d1ac1d8$var$normalizeDirectives$1(child);
    // Apply extends and mixins on the child options,
    // but only if it is a raw options object that isn't
    // the result of another mergeOptions call.
    // Only merged options has the _base property.
    if (!child._base) {
        if (child.extends) parent = $69b5f56b6d1ac1d8$var$mergeOptions(parent, child.extends, vm);
        if (child.mixins) for(let i = 0, l = child.mixins.length; i < l; i++)parent = $69b5f56b6d1ac1d8$var$mergeOptions(parent, child.mixins[i], vm);
    }
    const options = {};
    let key;
    for(key in parent)mergeField(key);
    for(key in child)if (!$69b5f56b6d1ac1d8$var$hasOwn(parent, key)) mergeField(key);
    function mergeField(key) {
        const strat = $69b5f56b6d1ac1d8$var$strats[key] || $69b5f56b6d1ac1d8$var$defaultStrat;
        options[key] = strat(parent[key], child[key], vm, key);
    }
    return options;
}
/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */ function $69b5f56b6d1ac1d8$var$resolveAsset(options, type, id, warnMissing) {
    /* istanbul ignore if */ if (typeof id !== 'string') return;
    const assets = options[type];
    // check local registration variations first
    if ($69b5f56b6d1ac1d8$var$hasOwn(assets, id)) return assets[id];
    const camelizedId = $69b5f56b6d1ac1d8$var$camelize(id);
    if ($69b5f56b6d1ac1d8$var$hasOwn(assets, camelizedId)) return assets[camelizedId];
    const PascalCaseId = $69b5f56b6d1ac1d8$var$capitalize(camelizedId);
    if ($69b5f56b6d1ac1d8$var$hasOwn(assets, PascalCaseId)) return assets[PascalCaseId];
    // fallback to prototype chain
    const res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
    if (warnMissing && !res) $69b5f56b6d1ac1d8$var$warn$2('Failed to resolve ' + type.slice(0, -1) + ': ' + id);
    return res;
}
function $69b5f56b6d1ac1d8$var$validateProp(key, propOptions, propsData, vm) {
    const prop = propOptions[key];
    const absent = !$69b5f56b6d1ac1d8$var$hasOwn(propsData, key);
    let value = propsData[key];
    // boolean casting
    const booleanIndex = $69b5f56b6d1ac1d8$var$getTypeIndex(Boolean, prop.type);
    if (booleanIndex > -1) {
        if (absent && !$69b5f56b6d1ac1d8$var$hasOwn(prop, 'default')) value = false;
        else if (value === '' || value === $69b5f56b6d1ac1d8$var$hyphenate(key)) {
            // only cast empty string / same name to boolean if
            // boolean has higher priority
            const stringIndex = $69b5f56b6d1ac1d8$var$getTypeIndex(String, prop.type);
            if (stringIndex < 0 || booleanIndex < stringIndex) value = true;
        }
    }
    // check default value
    if (value === undefined) {
        value = $69b5f56b6d1ac1d8$var$getPropDefaultValue(vm, prop, key);
        // since the default value is a fresh copy,
        // make sure to observe it.
        const prevShouldObserve = $69b5f56b6d1ac1d8$var$shouldObserve;
        $69b5f56b6d1ac1d8$var$toggleObserving(true);
        $69b5f56b6d1ac1d8$var$observe(value);
        $69b5f56b6d1ac1d8$var$toggleObserving(prevShouldObserve);
    }
    $69b5f56b6d1ac1d8$var$assertProp(prop, key, value, vm, absent);
    return value;
}
/**
 * Get the default value of a prop.
 */ function $69b5f56b6d1ac1d8$var$getPropDefaultValue(vm, prop, key) {
    // no default, return undefined
    if (!$69b5f56b6d1ac1d8$var$hasOwn(prop, 'default')) return undefined;
    const def = prop.default;
    // warn against non-factory defaults for Object & Array
    if ($69b5f56b6d1ac1d8$var$isObject(def)) $69b5f56b6d1ac1d8$var$warn$2('Invalid default value for prop "' + key + '": ' + 'Props with type Object/Array must use a factory function ' + 'to return the default value.', vm);
    // the raw prop value was also undefined from previous render,
    // return previous default value to avoid unnecessary watcher trigger
    if (vm && vm.$options.propsData && vm.$options.propsData[key] === undefined && vm._props[key] !== undefined) return vm._props[key];
    // call factory function for non-Function types
    // a value is Function if its prototype is function even across different execution context
    return $69b5f56b6d1ac1d8$var$isFunction(def) && $69b5f56b6d1ac1d8$var$getType(prop.type) !== 'Function' ? def.call(vm) : def;
}
/**
 * Assert whether a prop is valid.
 */ function $69b5f56b6d1ac1d8$var$assertProp(prop, name, value, vm, absent) {
    if (prop.required && absent) {
        $69b5f56b6d1ac1d8$var$warn$2('Missing required prop: "' + name + '"', vm);
        return;
    }
    if (value == null && !prop.required) return;
    let type = prop.type;
    let valid = !type || type === true;
    const expectedTypes = [];
    if (type) {
        if (!$69b5f56b6d1ac1d8$var$isArray(type)) type = [
            type
        ];
        for(let i = 0; i < type.length && !valid; i++){
            const assertedType = $69b5f56b6d1ac1d8$var$assertType(value, type[i], vm);
            expectedTypes.push(assertedType.expectedType || '');
            valid = assertedType.valid;
        }
    }
    const haveExpectedTypes = expectedTypes.some((t)=>t);
    if (!valid && haveExpectedTypes) {
        $69b5f56b6d1ac1d8$var$warn$2($69b5f56b6d1ac1d8$var$getInvalidTypeMessage(name, value, expectedTypes), vm);
        return;
    }
    const validator = prop.validator;
    if (validator) {
        if (!validator(value)) $69b5f56b6d1ac1d8$var$warn$2('Invalid prop: custom validator check failed for prop "' + name + '".', vm);
    }
}
const $69b5f56b6d1ac1d8$var$simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;
function $69b5f56b6d1ac1d8$var$assertType(value, type, vm) {
    let valid;
    const expectedType = $69b5f56b6d1ac1d8$var$getType(type);
    if ($69b5f56b6d1ac1d8$var$simpleCheckRE.test(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        // for primitive wrapper objects
        if (!valid && t === 'object') valid = value instanceof type;
    } else if (expectedType === 'Object') valid = $69b5f56b6d1ac1d8$var$isPlainObject(value);
    else if (expectedType === 'Array') valid = $69b5f56b6d1ac1d8$var$isArray(value);
    else try {
        valid = value instanceof type;
    } catch (e) {
        $69b5f56b6d1ac1d8$var$warn$2('Invalid prop type: "' + String(type) + '" is not a constructor', vm);
        valid = false;
    }
    return {
        valid: valid,
        expectedType: expectedType
    };
}
const $69b5f56b6d1ac1d8$var$functionTypeCheckRE = /^\s*function (\w+)/;
/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */ function $69b5f56b6d1ac1d8$var$getType(fn) {
    const match = fn && fn.toString().match($69b5f56b6d1ac1d8$var$functionTypeCheckRE);
    return match ? match[1] : '';
}
function $69b5f56b6d1ac1d8$var$isSameType(a, b) {
    return $69b5f56b6d1ac1d8$var$getType(a) === $69b5f56b6d1ac1d8$var$getType(b);
}
function $69b5f56b6d1ac1d8$var$getTypeIndex(type, expectedTypes) {
    if (!$69b5f56b6d1ac1d8$var$isArray(expectedTypes)) return $69b5f56b6d1ac1d8$var$isSameType(expectedTypes, type) ? 0 : -1;
    for(let i = 0, len = expectedTypes.length; i < len; i++){
        if ($69b5f56b6d1ac1d8$var$isSameType(expectedTypes[i], type)) return i;
    }
    return -1;
}
function $69b5f56b6d1ac1d8$var$getInvalidTypeMessage(name, value, expectedTypes) {
    let message = `Invalid prop: type check failed for prop "${name}".` + ` Expected ${expectedTypes.map($69b5f56b6d1ac1d8$var$capitalize).join(', ')}`;
    const expectedType = expectedTypes[0];
    const receivedType = $69b5f56b6d1ac1d8$var$toRawType(value);
    // check if we need to specify expected value
    if (expectedTypes.length === 1 && $69b5f56b6d1ac1d8$var$isExplicable(expectedType) && $69b5f56b6d1ac1d8$var$isExplicable(typeof value) && !$69b5f56b6d1ac1d8$var$isBoolean(expectedType, receivedType)) message += ` with value ${$69b5f56b6d1ac1d8$var$styleValue(value, expectedType)}`;
    message += `, got ${receivedType} `;
    // check if we need to specify received value
    if ($69b5f56b6d1ac1d8$var$isExplicable(receivedType)) message += `with value ${$69b5f56b6d1ac1d8$var$styleValue(value, receivedType)}.`;
    return message;
}
function $69b5f56b6d1ac1d8$var$styleValue(value, type) {
    if (type === 'String') return `"${value}"`;
    else if (type === 'Number') return `${Number(value)}`;
    else return `${value}`;
}
const $69b5f56b6d1ac1d8$var$EXPLICABLE_TYPES = [
    'string',
    'number',
    'boolean'
];
function $69b5f56b6d1ac1d8$var$isExplicable(value) {
    return $69b5f56b6d1ac1d8$var$EXPLICABLE_TYPES.some((elem)=>value.toLowerCase() === elem);
}
function $69b5f56b6d1ac1d8$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === 'boolean');
}
function $69b5f56b6d1ac1d8$var$Vue(options) {
    if (!(this instanceof $69b5f56b6d1ac1d8$var$Vue)) $69b5f56b6d1ac1d8$var$warn$2('Vue is a constructor and should be called with the `new` keyword');
    this._init(options);
}
//@ts-expect-error Vue has function type
$69b5f56b6d1ac1d8$var$initMixin$1($69b5f56b6d1ac1d8$var$Vue);
//@ts-expect-error Vue has function type
$69b5f56b6d1ac1d8$var$stateMixin($69b5f56b6d1ac1d8$var$Vue);
//@ts-expect-error Vue has function type
$69b5f56b6d1ac1d8$var$eventsMixin($69b5f56b6d1ac1d8$var$Vue);
//@ts-expect-error Vue has function type
$69b5f56b6d1ac1d8$var$lifecycleMixin($69b5f56b6d1ac1d8$var$Vue);
//@ts-expect-error Vue has function type
$69b5f56b6d1ac1d8$var$renderMixin($69b5f56b6d1ac1d8$var$Vue);
function $69b5f56b6d1ac1d8$var$initUse(Vue) {
    Vue.use = function(plugin) {
        const installedPlugins = this._installedPlugins || (this._installedPlugins = []);
        if (installedPlugins.indexOf(plugin) > -1) return this;
        // additional parameters
        const args = $69b5f56b6d1ac1d8$var$toArray(arguments, 1);
        args.unshift(this);
        if ($69b5f56b6d1ac1d8$var$isFunction(plugin.install)) plugin.install.apply(plugin, args);
        else if ($69b5f56b6d1ac1d8$var$isFunction(plugin)) plugin.apply(null, args);
        installedPlugins.push(plugin);
        return this;
    };
}
function $69b5f56b6d1ac1d8$var$initMixin(Vue) {
    Vue.mixin = function(mixin) {
        this.options = $69b5f56b6d1ac1d8$var$mergeOptions(this.options, mixin);
        return this;
    };
}
function $69b5f56b6d1ac1d8$var$initExtend(Vue) {
    /**
     * Each instance constructor, including Vue, has a unique
     * cid. This enables us to create wrapped "child
     * constructors" for prototypal inheritance and cache them.
     */ Vue.cid = 0;
    let cid = 1;
    /**
     * Class inheritance
     */ Vue.extend = function(extendOptions) {
        extendOptions = extendOptions || {};
        const Super = this;
        const SuperId = Super.cid;
        const cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
        if (cachedCtors[SuperId]) return cachedCtors[SuperId];
        const name = $69b5f56b6d1ac1d8$var$getComponentName(extendOptions) || $69b5f56b6d1ac1d8$var$getComponentName(Super.options);
        if (name) $69b5f56b6d1ac1d8$var$validateComponentName(name);
        const Sub = function VueComponent(options) {
            this._init(options);
        };
        Sub.prototype = Object.create(Super.prototype);
        Sub.prototype.constructor = Sub;
        Sub.cid = cid++;
        Sub.options = $69b5f56b6d1ac1d8$var$mergeOptions(Super.options, extendOptions);
        Sub['super'] = Super;
        // For props and computed properties, we define the proxy getters on
        // the Vue instances at extension time, on the extended prototype. This
        // avoids Object.defineProperty calls for each instance created.
        if (Sub.options.props) $69b5f56b6d1ac1d8$var$initProps(Sub);
        if (Sub.options.computed) $69b5f56b6d1ac1d8$var$initComputed(Sub);
        // allow further extension/mixin/plugin usage
        Sub.extend = Super.extend;
        Sub.mixin = Super.mixin;
        Sub.use = Super.use;
        // create asset registers, so extended classes
        // can have their private assets too.
        $69b5f56b6d1ac1d8$var$ASSET_TYPES.forEach(function(type) {
            Sub[type] = Super[type];
        });
        // enable recursive self-lookup
        if (name) Sub.options.components[name] = Sub;
        // keep a reference to the super options at extension time.
        // later at instantiation we can check if Super's options have
        // been updated.
        Sub.superOptions = Super.options;
        Sub.extendOptions = extendOptions;
        Sub.sealedOptions = $69b5f56b6d1ac1d8$var$extend({}, Sub.options);
        // cache constructor
        cachedCtors[SuperId] = Sub;
        return Sub;
    };
}
function $69b5f56b6d1ac1d8$var$initProps(Comp) {
    const props = Comp.options.props;
    for(const key in props)$69b5f56b6d1ac1d8$var$proxy(Comp.prototype, `_props`, key);
}
function $69b5f56b6d1ac1d8$var$initComputed(Comp) {
    const computed = Comp.options.computed;
    for(const key in computed)$69b5f56b6d1ac1d8$var$defineComputed(Comp.prototype, key, computed[key]);
}
function $69b5f56b6d1ac1d8$var$initAssetRegisters(Vue) {
    /**
     * Create asset registration methods.
     */ $69b5f56b6d1ac1d8$var$ASSET_TYPES.forEach((type)=>{
        // @ts-expect-error function is not exact same type
        Vue[type] = function(id, definition) {
            if (!definition) return this.options[type + 's'][id];
            else {
                /* istanbul ignore if */ if (type === 'component') $69b5f56b6d1ac1d8$var$validateComponentName(id);
                if (type === 'component' && $69b5f56b6d1ac1d8$var$isPlainObject(definition)) {
                    // @ts-expect-error
                    definition.name = definition.name || id;
                    definition = this.options._base.extend(definition);
                }
                if (type === 'directive' && $69b5f56b6d1ac1d8$var$isFunction(definition)) definition = {
                    bind: definition,
                    update: definition
                };
                this.options[type + 's'][id] = definition;
                return definition;
            }
        };
    });
}
function $69b5f56b6d1ac1d8$var$_getComponentName(opts) {
    return opts && ($69b5f56b6d1ac1d8$var$getComponentName(opts.Ctor.options) || opts.tag);
}
function $69b5f56b6d1ac1d8$var$matches(pattern, name) {
    if ($69b5f56b6d1ac1d8$var$isArray(pattern)) return pattern.indexOf(name) > -1;
    else if (typeof pattern === 'string') return pattern.split(',').indexOf(name) > -1;
    else if ($69b5f56b6d1ac1d8$var$isRegExp(pattern)) return pattern.test(name);
    /* istanbul ignore next */ return false;
}
function $69b5f56b6d1ac1d8$var$pruneCache(keepAliveInstance, filter) {
    const { cache: cache, keys: keys, _vnode: _vnode, $vnode: $vnode } = keepAliveInstance;
    for(const key in cache){
        const entry = cache[key];
        if (entry) {
            const name = entry.name;
            if (name && !filter(name)) $69b5f56b6d1ac1d8$var$pruneCacheEntry(cache, key, keys, _vnode);
        }
    }
    $vnode.componentOptions.children = undefined;
}
function $69b5f56b6d1ac1d8$var$pruneCacheEntry(cache, key, keys, current) {
    const entry = cache[key];
    if (entry && (!current || entry.tag !== current.tag)) // @ts-expect-error can be undefined
    entry.componentInstance.$destroy();
    cache[key] = null;
    $69b5f56b6d1ac1d8$var$remove$2(keys, key);
}
const $69b5f56b6d1ac1d8$var$patternTypes = [
    String,
    RegExp,
    Array
];
// TODO defineComponent
var $69b5f56b6d1ac1d8$var$KeepAlive = {
    name: 'keep-alive',
    abstract: true,
    props: {
        include: $69b5f56b6d1ac1d8$var$patternTypes,
        exclude: $69b5f56b6d1ac1d8$var$patternTypes,
        max: [
            String,
            Number
        ]
    },
    methods: {
        cacheVNode () {
            const { cache: cache, keys: keys, vnodeToCache: vnodeToCache, keyToCache: keyToCache } = this;
            if (vnodeToCache) {
                const { tag: tag, componentInstance: componentInstance, componentOptions: componentOptions } = vnodeToCache;
                cache[keyToCache] = {
                    name: $69b5f56b6d1ac1d8$var$_getComponentName(componentOptions),
                    tag: tag,
                    componentInstance: componentInstance
                };
                keys.push(keyToCache);
                // prune oldest entry
                if (this.max && keys.length > parseInt(this.max)) $69b5f56b6d1ac1d8$var$pruneCacheEntry(cache, keys[0], keys, this._vnode);
                this.vnodeToCache = null;
            }
        }
    },
    created () {
        this.cache = Object.create(null);
        this.keys = [];
    },
    destroyed () {
        for(const key in this.cache)$69b5f56b6d1ac1d8$var$pruneCacheEntry(this.cache, key, this.keys);
    },
    mounted () {
        this.cacheVNode();
        this.$watch('include', (val)=>{
            $69b5f56b6d1ac1d8$var$pruneCache(this, (name)=>$69b5f56b6d1ac1d8$var$matches(val, name));
        });
        this.$watch('exclude', (val)=>{
            $69b5f56b6d1ac1d8$var$pruneCache(this, (name)=>!$69b5f56b6d1ac1d8$var$matches(val, name));
        });
    },
    updated () {
        this.cacheVNode();
    },
    render () {
        const slot = this.$slots.default;
        const vnode = $69b5f56b6d1ac1d8$var$getFirstComponentChild(slot);
        const componentOptions = vnode && vnode.componentOptions;
        if (componentOptions) {
            // check pattern
            const name = $69b5f56b6d1ac1d8$var$_getComponentName(componentOptions);
            const { include: include, exclude: exclude } = this;
            if (// not included
            include && (!name || !$69b5f56b6d1ac1d8$var$matches(include, name)) || // excluded
            exclude && name && $69b5f56b6d1ac1d8$var$matches(exclude, name)) return vnode;
            const { cache: cache, keys: keys } = this;
            const key = vnode.key == null ? // so cid alone is not enough (#3269)
            componentOptions.Ctor.cid + (componentOptions.tag ? `::${componentOptions.tag}` : '') : vnode.key;
            if (cache[key]) {
                vnode.componentInstance = cache[key].componentInstance;
                // make current key freshest
                $69b5f56b6d1ac1d8$var$remove$2(keys, key);
                keys.push(key);
            } else {
                // delay setting the cache until update
                this.vnodeToCache = vnode;
                this.keyToCache = key;
            }
            // @ts-expect-error can vnode.data can be undefined
            vnode.data.keepAlive = true;
        }
        return vnode || slot && slot[0];
    }
};
var $69b5f56b6d1ac1d8$var$builtInComponents = {
    KeepAlive: $69b5f56b6d1ac1d8$var$KeepAlive
};
function $69b5f56b6d1ac1d8$var$initGlobalAPI(Vue) {
    // config
    const configDef = {};
    configDef.get = ()=>$69b5f56b6d1ac1d8$var$config;
    configDef.set = ()=>{
        $69b5f56b6d1ac1d8$var$warn$2('Do not replace the Vue.config object, set individual fields instead.');
    };
    Object.defineProperty(Vue, 'config', configDef);
    // exposed util methods.
    // NOTE: these are not considered part of the public API - avoid relying on
    // them unless you are aware of the risk.
    Vue.util = {
        warn: $69b5f56b6d1ac1d8$var$warn$2,
        extend: $69b5f56b6d1ac1d8$var$extend,
        mergeOptions: $69b5f56b6d1ac1d8$var$mergeOptions,
        defineReactive: $69b5f56b6d1ac1d8$var$defineReactive
    };
    Vue.set = $69b5f56b6d1ac1d8$var$set;
    Vue.delete = $69b5f56b6d1ac1d8$var$del;
    Vue.nextTick = $69b5f56b6d1ac1d8$var$nextTick;
    // 2.6 explicit observable API
    Vue.observable = (obj)=>{
        $69b5f56b6d1ac1d8$var$observe(obj);
        return obj;
    };
    Vue.options = Object.create(null);
    $69b5f56b6d1ac1d8$var$ASSET_TYPES.forEach((type)=>{
        Vue.options[type + 's'] = Object.create(null);
    });
    // this is used to identify the "base" constructor to extend all plain-object
    // components with in Weex's multi-instance scenarios.
    Vue.options._base = Vue;
    $69b5f56b6d1ac1d8$var$extend(Vue.options.components, $69b5f56b6d1ac1d8$var$builtInComponents);
    $69b5f56b6d1ac1d8$var$initUse(Vue);
    $69b5f56b6d1ac1d8$var$initMixin(Vue);
    $69b5f56b6d1ac1d8$var$initExtend(Vue);
    $69b5f56b6d1ac1d8$var$initAssetRegisters(Vue);
}
$69b5f56b6d1ac1d8$var$initGlobalAPI($69b5f56b6d1ac1d8$var$Vue);
Object.defineProperty($69b5f56b6d1ac1d8$var$Vue.prototype, '$isServer', {
    get: $69b5f56b6d1ac1d8$var$isServerRendering
});
Object.defineProperty($69b5f56b6d1ac1d8$var$Vue.prototype, '$ssrContext', {
    get () {
        /* istanbul ignore next */ return this.$vnode && this.$vnode.ssrContext;
    }
});
// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty($69b5f56b6d1ac1d8$var$Vue, 'FunctionalRenderContext', {
    value: $69b5f56b6d1ac1d8$var$FunctionalRenderContext
});
$69b5f56b6d1ac1d8$var$Vue.version = $69b5f56b6d1ac1d8$var$version;
// these are reserved for web because they are directly compiled away
// during template compilation
const $69b5f56b6d1ac1d8$var$isReservedAttr = $69b5f56b6d1ac1d8$var$makeMap('style,class');
// attributes that should be using props for binding
const $69b5f56b6d1ac1d8$var$acceptValue = $69b5f56b6d1ac1d8$var$makeMap('input,textarea,option,select,progress');
const $69b5f56b6d1ac1d8$var$mustUseProp = (tag, type, attr)=>{
    return attr === 'value' && $69b5f56b6d1ac1d8$var$acceptValue(tag) && type !== 'button' || attr === 'selected' && tag === 'option' || attr === 'checked' && tag === 'input' || attr === 'muted' && tag === 'video';
};
const $69b5f56b6d1ac1d8$var$isEnumeratedAttr = $69b5f56b6d1ac1d8$var$makeMap('contenteditable,draggable,spellcheck');
const $69b5f56b6d1ac1d8$var$isValidContentEditableValue = $69b5f56b6d1ac1d8$var$makeMap('events,caret,typing,plaintext-only');
const $69b5f56b6d1ac1d8$var$convertEnumeratedValue = (key, value)=>{
    return $69b5f56b6d1ac1d8$var$isFalsyAttrValue(value) || value === 'false' ? 'false' : key === 'contenteditable' && $69b5f56b6d1ac1d8$var$isValidContentEditableValue(value) ? value : 'true';
};
const $69b5f56b6d1ac1d8$var$isBooleanAttr = $69b5f56b6d1ac1d8$var$makeMap("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,truespeed,typemustmatch,visible");
const $69b5f56b6d1ac1d8$var$xlinkNS = 'http://www.w3.org/1999/xlink';
const $69b5f56b6d1ac1d8$var$isXlink = (name)=>{
    return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink';
};
const $69b5f56b6d1ac1d8$var$getXlinkProp = (name)=>{
    return $69b5f56b6d1ac1d8$var$isXlink(name) ? name.slice(6, name.length) : '';
};
const $69b5f56b6d1ac1d8$var$isFalsyAttrValue = (val)=>{
    return val == null || val === false;
};
function $69b5f56b6d1ac1d8$var$genClassForVnode(vnode) {
    let data = vnode.data;
    let parentNode = vnode;
    let childNode = vnode;
    while($69b5f56b6d1ac1d8$var$isDef(childNode.componentInstance)){
        childNode = childNode.componentInstance._vnode;
        if (childNode && childNode.data) data = $69b5f56b6d1ac1d8$var$mergeClassData(childNode.data, data);
    }
    // @ts-expect-error parentNode.parent not VNodeWithData
    while($69b5f56b6d1ac1d8$var$isDef(parentNode = parentNode.parent))if (parentNode && parentNode.data) data = $69b5f56b6d1ac1d8$var$mergeClassData(data, parentNode.data);
    return $69b5f56b6d1ac1d8$var$renderClass(data.staticClass, data.class);
}
function $69b5f56b6d1ac1d8$var$mergeClassData(child, parent) {
    return {
        staticClass: $69b5f56b6d1ac1d8$var$concat(child.staticClass, parent.staticClass),
        class: $69b5f56b6d1ac1d8$var$isDef(child.class) ? [
            child.class,
            parent.class
        ] : parent.class
    };
}
function $69b5f56b6d1ac1d8$var$renderClass(staticClass, dynamicClass) {
    if ($69b5f56b6d1ac1d8$var$isDef(staticClass) || $69b5f56b6d1ac1d8$var$isDef(dynamicClass)) return $69b5f56b6d1ac1d8$var$concat(staticClass, $69b5f56b6d1ac1d8$var$stringifyClass(dynamicClass));
    /* istanbul ignore next */ return '';
}
function $69b5f56b6d1ac1d8$var$concat(a, b) {
    return a ? b ? a + ' ' + b : a : b || '';
}
function $69b5f56b6d1ac1d8$var$stringifyClass(value) {
    if (Array.isArray(value)) return $69b5f56b6d1ac1d8$var$stringifyArray(value);
    if ($69b5f56b6d1ac1d8$var$isObject(value)) return $69b5f56b6d1ac1d8$var$stringifyObject(value);
    if (typeof value === 'string') return value;
    /* istanbul ignore next */ return '';
}
function $69b5f56b6d1ac1d8$var$stringifyArray(value) {
    let res = '';
    let stringified;
    for(let i = 0, l = value.length; i < l; i++)if ($69b5f56b6d1ac1d8$var$isDef(stringified = $69b5f56b6d1ac1d8$var$stringifyClass(value[i])) && stringified !== '') {
        if (res) res += ' ';
        res += stringified;
    }
    return res;
}
function $69b5f56b6d1ac1d8$var$stringifyObject(value) {
    let res = '';
    for(const key in value)if (value[key]) {
        if (res) res += ' ';
        res += key;
    }
    return res;
}
const $69b5f56b6d1ac1d8$var$namespaceMap = {
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
};
const $69b5f56b6d1ac1d8$var$isHTMLTag = $69b5f56b6d1ac1d8$var$makeMap("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot");
// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
const $69b5f56b6d1ac1d8$var$isSVG = $69b5f56b6d1ac1d8$var$makeMap("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view", true);
const $69b5f56b6d1ac1d8$var$isPreTag = (tag)=>tag === 'pre';
const $69b5f56b6d1ac1d8$var$isReservedTag = (tag)=>{
    return $69b5f56b6d1ac1d8$var$isHTMLTag(tag) || $69b5f56b6d1ac1d8$var$isSVG(tag);
};
function $69b5f56b6d1ac1d8$var$getTagNamespace(tag) {
    if ($69b5f56b6d1ac1d8$var$isSVG(tag)) return 'svg';
    // basic support for MathML
    // note it doesn't support other MathML elements being component roots
    if (tag === 'math') return 'math';
}
const $69b5f56b6d1ac1d8$var$unknownElementCache = Object.create(null);
function $69b5f56b6d1ac1d8$var$isUnknownElement(tag) {
    /* istanbul ignore if */ if (!$69b5f56b6d1ac1d8$var$inBrowser) return true;
    if ($69b5f56b6d1ac1d8$var$isReservedTag(tag)) return false;
    tag = tag.toLowerCase();
    /* istanbul ignore if */ if ($69b5f56b6d1ac1d8$var$unknownElementCache[tag] != null) return $69b5f56b6d1ac1d8$var$unknownElementCache[tag];
    const el = document.createElement(tag);
    if (tag.indexOf('-') > -1) // https://stackoverflow.com/a/28210364/1070244
    return $69b5f56b6d1ac1d8$var$unknownElementCache[tag] = el.constructor === window.HTMLUnknownElement || el.constructor === window.HTMLElement;
    else return $69b5f56b6d1ac1d8$var$unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString());
}
const $69b5f56b6d1ac1d8$var$isTextInputType = $69b5f56b6d1ac1d8$var$makeMap('text,number,password,search,email,tel,url');
/**
 * Query an element selector if it's not an element already.
 */ function $69b5f56b6d1ac1d8$var$query(el) {
    if (typeof el === 'string') {
        const selected = document.querySelector(el);
        if (!selected) {
            $69b5f56b6d1ac1d8$var$warn$2('Cannot find element: ' + el);
            return document.createElement('div');
        }
        return selected;
    } else return el;
}
function $69b5f56b6d1ac1d8$var$createElement(tagName, vnode) {
    const elm = document.createElement(tagName);
    if (tagName !== 'select') return elm;
    // false or null will remove the attribute but undefined will not
    if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) elm.setAttribute('multiple', 'multiple');
    return elm;
}
function $69b5f56b6d1ac1d8$var$createElementNS(namespace, tagName) {
    return document.createElementNS($69b5f56b6d1ac1d8$var$namespaceMap[namespace], tagName);
}
function $69b5f56b6d1ac1d8$var$createTextNode(text) {
    return document.createTextNode(text);
}
function $69b5f56b6d1ac1d8$var$createComment(text) {
    return document.createComment(text);
}
function $69b5f56b6d1ac1d8$var$insertBefore(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function $69b5f56b6d1ac1d8$var$removeChild(node, child) {
    node.removeChild(child);
}
function $69b5f56b6d1ac1d8$var$appendChild(node, child) {
    node.appendChild(child);
}
function $69b5f56b6d1ac1d8$var$parentNode(node) {
    return node.parentNode;
}
function $69b5f56b6d1ac1d8$var$nextSibling(node) {
    return node.nextSibling;
}
function $69b5f56b6d1ac1d8$var$tagName(node) {
    return node.tagName;
}
function $69b5f56b6d1ac1d8$var$setTextContent(node, text) {
    node.textContent = text;
}
function $69b5f56b6d1ac1d8$var$setStyleScope(node, scopeId) {
    node.setAttribute(scopeId, '');
}
var $69b5f56b6d1ac1d8$var$nodeOps = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    createElement: $69b5f56b6d1ac1d8$var$createElement,
    createElementNS: $69b5f56b6d1ac1d8$var$createElementNS,
    createTextNode: $69b5f56b6d1ac1d8$var$createTextNode,
    createComment: $69b5f56b6d1ac1d8$var$createComment,
    insertBefore: $69b5f56b6d1ac1d8$var$insertBefore,
    removeChild: $69b5f56b6d1ac1d8$var$removeChild,
    appendChild: $69b5f56b6d1ac1d8$var$appendChild,
    parentNode: $69b5f56b6d1ac1d8$var$parentNode,
    nextSibling: $69b5f56b6d1ac1d8$var$nextSibling,
    tagName: $69b5f56b6d1ac1d8$var$tagName,
    setTextContent: $69b5f56b6d1ac1d8$var$setTextContent,
    setStyleScope: $69b5f56b6d1ac1d8$var$setStyleScope
});
var $69b5f56b6d1ac1d8$var$ref = {
    create (_, vnode) {
        $69b5f56b6d1ac1d8$var$registerRef(vnode);
    },
    update (oldVnode, vnode) {
        if (oldVnode.data.ref !== vnode.data.ref) {
            $69b5f56b6d1ac1d8$var$registerRef(oldVnode, true);
            $69b5f56b6d1ac1d8$var$registerRef(vnode);
        }
    },
    destroy (vnode) {
        $69b5f56b6d1ac1d8$var$registerRef(vnode, true);
    }
};
function $69b5f56b6d1ac1d8$var$registerRef(vnode, isRemoval) {
    const ref = vnode.data.ref;
    if (!$69b5f56b6d1ac1d8$var$isDef(ref)) return;
    const vm = vnode.context;
    const refValue = vnode.componentInstance || vnode.elm;
    const value = isRemoval ? null : refValue;
    const $refsValue = isRemoval ? undefined : refValue;
    if ($69b5f56b6d1ac1d8$var$isFunction(ref)) {
        $69b5f56b6d1ac1d8$var$invokeWithErrorHandling(ref, vm, [
            value
        ], vm, `template ref function`);
        return;
    }
    const isFor = vnode.data.refInFor;
    const _isString = typeof ref === 'string' || typeof ref === 'number';
    const _isRef = $69b5f56b6d1ac1d8$var$isRef(ref);
    const refs = vm.$refs;
    if (_isString || _isRef) {
        if (isFor) {
            const existing = _isString ? refs[ref] : ref.value;
            if (isRemoval) $69b5f56b6d1ac1d8$var$isArray(existing) && $69b5f56b6d1ac1d8$var$remove$2(existing, refValue);
            else {
                if (!$69b5f56b6d1ac1d8$var$isArray(existing)) {
                    if (_isString) {
                        refs[ref] = [
                            refValue
                        ];
                        $69b5f56b6d1ac1d8$var$setSetupRef(vm, ref, refs[ref]);
                    } else ref.value = [
                        refValue
                    ];
                } else if (!existing.includes(refValue)) existing.push(refValue);
            }
        } else if (_isString) {
            if (isRemoval && refs[ref] !== refValue) return;
            refs[ref] = $refsValue;
            $69b5f56b6d1ac1d8$var$setSetupRef(vm, ref, value);
        } else if (_isRef) {
            if (isRemoval && ref.value !== refValue) return;
            ref.value = value;
        } else $69b5f56b6d1ac1d8$var$warn$2(`Invalid template ref type: ${typeof ref}`);
    }
}
function $69b5f56b6d1ac1d8$var$setSetupRef({ _setupState: _setupState }, key, val) {
    if (_setupState && $69b5f56b6d1ac1d8$var$hasOwn(_setupState, key)) {
        if ($69b5f56b6d1ac1d8$var$isRef(_setupState[key])) _setupState[key].value = val;
        else _setupState[key] = val;
    }
}
/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */ const $69b5f56b6d1ac1d8$var$emptyNode = new $69b5f56b6d1ac1d8$var$VNode('', {}, []);
const $69b5f56b6d1ac1d8$var$hooks = [
    'create',
    'activate',
    'update',
    'remove',
    'destroy'
];
function $69b5f56b6d1ac1d8$var$sameVnode(a, b) {
    return a.key === b.key && a.asyncFactory === b.asyncFactory && (a.tag === b.tag && a.isComment === b.isComment && $69b5f56b6d1ac1d8$var$isDef(a.data) === $69b5f56b6d1ac1d8$var$isDef(b.data) && $69b5f56b6d1ac1d8$var$sameInputType(a, b) || $69b5f56b6d1ac1d8$var$isTrue(a.isAsyncPlaceholder) && $69b5f56b6d1ac1d8$var$isUndef(b.asyncFactory.error));
}
function $69b5f56b6d1ac1d8$var$sameInputType(a, b) {
    if (a.tag !== 'input') return true;
    let i;
    const typeA = $69b5f56b6d1ac1d8$var$isDef(i = a.data) && $69b5f56b6d1ac1d8$var$isDef(i = i.attrs) && i.type;
    const typeB = $69b5f56b6d1ac1d8$var$isDef(i = b.data) && $69b5f56b6d1ac1d8$var$isDef(i = i.attrs) && i.type;
    return typeA === typeB || $69b5f56b6d1ac1d8$var$isTextInputType(typeA) && $69b5f56b6d1ac1d8$var$isTextInputType(typeB);
}
function $69b5f56b6d1ac1d8$var$createKeyToOldIdx(children, beginIdx, endIdx) {
    let i, key;
    const map = {};
    for(i = beginIdx; i <= endIdx; ++i){
        key = children[i].key;
        if ($69b5f56b6d1ac1d8$var$isDef(key)) map[key] = i;
    }
    return map;
}
function $69b5f56b6d1ac1d8$var$createPatchFunction(backend) {
    let i, j;
    const cbs = {};
    const { modules: modules, nodeOps: nodeOps } = backend;
    for(i = 0; i < $69b5f56b6d1ac1d8$var$hooks.length; ++i){
        cbs[$69b5f56b6d1ac1d8$var$hooks[i]] = [];
        for(j = 0; j < modules.length; ++j)if ($69b5f56b6d1ac1d8$var$isDef(modules[j][$69b5f56b6d1ac1d8$var$hooks[i]])) cbs[$69b5f56b6d1ac1d8$var$hooks[i]].push(modules[j][$69b5f56b6d1ac1d8$var$hooks[i]]);
    }
    function emptyNodeAt(elm) {
        return new $69b5f56b6d1ac1d8$var$VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm);
    }
    function createRmCb(childElm, listeners) {
        function remove() {
            if (--remove.listeners === 0) removeNode(childElm);
        }
        remove.listeners = listeners;
        return remove;
    }
    function removeNode(el) {
        const parent = nodeOps.parentNode(el);
        // element may have already been removed due to v-html / v-text
        if ($69b5f56b6d1ac1d8$var$isDef(parent)) nodeOps.removeChild(parent, el);
    }
    function isUnknownElement(vnode, inVPre) {
        return !inVPre && !vnode.ns && !($69b5f56b6d1ac1d8$var$config.ignoredElements.length && $69b5f56b6d1ac1d8$var$config.ignoredElements.some((ignore)=>{
            return $69b5f56b6d1ac1d8$var$isRegExp(ignore) ? ignore.test(vnode.tag) : ignore === vnode.tag;
        })) && $69b5f56b6d1ac1d8$var$config.isUnknownElement(vnode.tag);
    }
    let creatingElmInVPre = 0;
    function createElm(vnode, insertedVnodeQueue, parentElm, refElm, nested, ownerArray, index) {
        if ($69b5f56b6d1ac1d8$var$isDef(vnode.elm) && $69b5f56b6d1ac1d8$var$isDef(ownerArray)) // This vnode was used in a previous render!
        // now it's used as a new node, overwriting its elm would cause
        // potential patch errors down the road when it's used as an insertion
        // reference node. Instead, we clone the node on-demand before creating
        // associated DOM element for it.
        vnode = ownerArray[index] = $69b5f56b6d1ac1d8$var$cloneVNode(vnode);
        vnode.isRootInsert = !nested; // for transition enter check
        if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) return;
        const data = vnode.data;
        const children = vnode.children;
        const tag = vnode.tag;
        if ($69b5f56b6d1ac1d8$var$isDef(tag)) {
            if (data && data.pre) creatingElmInVPre++;
            if (isUnknownElement(vnode, creatingElmInVPre)) $69b5f56b6d1ac1d8$var$warn$2('Unknown custom element: <' + tag + '> - did you ' + 'register the component correctly? For recursive components, ' + 'make sure to provide the "name" option.', vnode.context);
            vnode.elm = vnode.ns ? nodeOps.createElementNS(vnode.ns, tag) : nodeOps.createElement(tag, vnode);
            setScope(vnode);
            createChildren(vnode, children, insertedVnodeQueue);
            if ($69b5f56b6d1ac1d8$var$isDef(data)) invokeCreateHooks(vnode, insertedVnodeQueue);
            insert(parentElm, vnode.elm, refElm);
            if (data && data.pre) creatingElmInVPre--;
        } else if ($69b5f56b6d1ac1d8$var$isTrue(vnode.isComment)) {
            vnode.elm = nodeOps.createComment(vnode.text);
            insert(parentElm, vnode.elm, refElm);
        } else {
            vnode.elm = nodeOps.createTextNode(vnode.text);
            insert(parentElm, vnode.elm, refElm);
        }
    }
    function createComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
        let i = vnode.data;
        if ($69b5f56b6d1ac1d8$var$isDef(i)) {
            const isReactivated = $69b5f56b6d1ac1d8$var$isDef(vnode.componentInstance) && i.keepAlive;
            if ($69b5f56b6d1ac1d8$var$isDef(i = i.hook) && $69b5f56b6d1ac1d8$var$isDef(i = i.init)) i(vnode, false);
            // after calling the init hook, if the vnode is a child component
            // it should've created a child instance and mounted it. the child
            // component also has set the placeholder vnode's elm.
            // in that case we can just return the element and be done.
            if ($69b5f56b6d1ac1d8$var$isDef(vnode.componentInstance)) {
                initComponent(vnode, insertedVnodeQueue);
                insert(parentElm, vnode.elm, refElm);
                if ($69b5f56b6d1ac1d8$var$isTrue(isReactivated)) reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
                return true;
            }
        }
    }
    function initComponent(vnode, insertedVnodeQueue) {
        if ($69b5f56b6d1ac1d8$var$isDef(vnode.data.pendingInsert)) {
            insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
            vnode.data.pendingInsert = null;
        }
        vnode.elm = vnode.componentInstance.$el;
        if (isPatchable(vnode)) {
            invokeCreateHooks(vnode, insertedVnodeQueue);
            setScope(vnode);
        } else {
            // empty component root.
            // skip all element-related modules except for ref (#3455)
            $69b5f56b6d1ac1d8$var$registerRef(vnode);
            // make sure to invoke the insert hook
            insertedVnodeQueue.push(vnode);
        }
    }
    function reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
        let i;
        // hack for #4339: a reactivated component with inner transition
        // does not trigger because the inner node's created hooks are not called
        // again. It's not ideal to involve module-specific logic in here but
        // there doesn't seem to be a better way to do it.
        let innerNode = vnode;
        while(innerNode.componentInstance){
            innerNode = innerNode.componentInstance._vnode;
            if ($69b5f56b6d1ac1d8$var$isDef(i = innerNode.data) && $69b5f56b6d1ac1d8$var$isDef(i = i.transition)) {
                for(i = 0; i < cbs.activate.length; ++i)cbs.activate[i]($69b5f56b6d1ac1d8$var$emptyNode, innerNode);
                insertedVnodeQueue.push(innerNode);
                break;
            }
        }
        // unlike a newly created component,
        // a reactivated keep-alive component doesn't insert itself
        insert(parentElm, vnode.elm, refElm);
    }
    function insert(parent, elm, ref) {
        if ($69b5f56b6d1ac1d8$var$isDef(parent)) {
            if ($69b5f56b6d1ac1d8$var$isDef(ref)) {
                if (nodeOps.parentNode(ref) === parent) nodeOps.insertBefore(parent, elm, ref);
            } else nodeOps.appendChild(parent, elm);
        }
    }
    function createChildren(vnode, children, insertedVnodeQueue) {
        if ($69b5f56b6d1ac1d8$var$isArray(children)) {
            checkDuplicateKeys(children);
            for(let i = 0; i < children.length; ++i)createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
        } else if ($69b5f56b6d1ac1d8$var$isPrimitive(vnode.text)) nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
    function isPatchable(vnode) {
        while(vnode.componentInstance)vnode = vnode.componentInstance._vnode;
        return $69b5f56b6d1ac1d8$var$isDef(vnode.tag);
    }
    function invokeCreateHooks(vnode, insertedVnodeQueue) {
        for(let i = 0; i < cbs.create.length; ++i)cbs.create[i]($69b5f56b6d1ac1d8$var$emptyNode, vnode);
        i = vnode.data.hook; // Reuse variable
        if ($69b5f56b6d1ac1d8$var$isDef(i)) {
            if ($69b5f56b6d1ac1d8$var$isDef(i.create)) i.create($69b5f56b6d1ac1d8$var$emptyNode, vnode);
            if ($69b5f56b6d1ac1d8$var$isDef(i.insert)) insertedVnodeQueue.push(vnode);
        }
    }
    // set scope id attribute for scoped CSS.
    // this is implemented as a special case to avoid the overhead
    // of going through the normal attribute patching process.
    function setScope(vnode) {
        let i;
        if ($69b5f56b6d1ac1d8$var$isDef(i = vnode.fnScopeId)) nodeOps.setStyleScope(vnode.elm, i);
        else {
            let ancestor = vnode;
            while(ancestor){
                if ($69b5f56b6d1ac1d8$var$isDef(i = ancestor.context) && $69b5f56b6d1ac1d8$var$isDef(i = i.$options._scopeId)) nodeOps.setStyleScope(vnode.elm, i);
                ancestor = ancestor.parent;
            }
        }
        // for slot content they should also get the scopeId from the host instance.
        if ($69b5f56b6d1ac1d8$var$isDef(i = $69b5f56b6d1ac1d8$var$activeInstance) && i !== vnode.context && i !== vnode.fnContext && $69b5f56b6d1ac1d8$var$isDef(i = i.$options._scopeId)) nodeOps.setStyleScope(vnode.elm, i);
    }
    function addVnodes(parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
        for(; startIdx <= endIdx; ++startIdx)createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
    function invokeDestroyHook(vnode) {
        let i, j;
        const data = vnode.data;
        if ($69b5f56b6d1ac1d8$var$isDef(data)) {
            if ($69b5f56b6d1ac1d8$var$isDef(i = data.hook) && $69b5f56b6d1ac1d8$var$isDef(i = i.destroy)) i(vnode);
            for(i = 0; i < cbs.destroy.length; ++i)cbs.destroy[i](vnode);
        }
        if ($69b5f56b6d1ac1d8$var$isDef(i = vnode.children)) for(j = 0; j < vnode.children.length; ++j)invokeDestroyHook(vnode.children[j]);
    }
    function removeVnodes(vnodes, startIdx, endIdx) {
        for(; startIdx <= endIdx; ++startIdx){
            const ch = vnodes[startIdx];
            if ($69b5f56b6d1ac1d8$var$isDef(ch)) {
                if ($69b5f56b6d1ac1d8$var$isDef(ch.tag)) {
                    removeAndInvokeRemoveHook(ch);
                    invokeDestroyHook(ch);
                } else // Text node
                removeNode(ch.elm);
            }
        }
    }
    function removeAndInvokeRemoveHook(vnode, rm) {
        if ($69b5f56b6d1ac1d8$var$isDef(rm) || $69b5f56b6d1ac1d8$var$isDef(vnode.data)) {
            let i;
            const listeners = cbs.remove.length + 1;
            if ($69b5f56b6d1ac1d8$var$isDef(rm)) // we have a recursively passed down rm callback
            // increase the listeners count
            rm.listeners += listeners;
            else // directly removing
            rm = createRmCb(vnode.elm, listeners);
            // recursively invoke hooks on child component root node
            if ($69b5f56b6d1ac1d8$var$isDef(i = vnode.componentInstance) && $69b5f56b6d1ac1d8$var$isDef(i = i._vnode) && $69b5f56b6d1ac1d8$var$isDef(i.data)) removeAndInvokeRemoveHook(i, rm);
            for(i = 0; i < cbs.remove.length; ++i)cbs.remove[i](vnode, rm);
            if ($69b5f56b6d1ac1d8$var$isDef(i = vnode.data.hook) && $69b5f56b6d1ac1d8$var$isDef(i = i.remove)) i(vnode, rm);
            else rm();
        } else removeNode(vnode.elm);
    }
    function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
        let oldStartIdx = 0;
        let newStartIdx = 0;
        let oldEndIdx = oldCh.length - 1;
        let oldStartVnode = oldCh[0];
        let oldEndVnode = oldCh[oldEndIdx];
        let newEndIdx = newCh.length - 1;
        let newStartVnode = newCh[0];
        let newEndVnode = newCh[newEndIdx];
        let oldKeyToIdx, idxInOld, vnodeToMove, refElm;
        // removeOnly is a special flag used only by <transition-group>
        // to ensure removed elements stay in correct relative positions
        // during leaving transitions
        const canMove = !removeOnly;
        checkDuplicateKeys(newCh);
        while(oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx){
            if ($69b5f56b6d1ac1d8$var$isUndef(oldStartVnode)) oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
            else if ($69b5f56b6d1ac1d8$var$isUndef(oldEndVnode)) oldEndVnode = oldCh[--oldEndIdx];
            else if ($69b5f56b6d1ac1d8$var$sameVnode(oldStartVnode, newStartVnode)) {
                patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                oldStartVnode = oldCh[++oldStartIdx];
                newStartVnode = newCh[++newStartIdx];
            } else if ($69b5f56b6d1ac1d8$var$sameVnode(oldEndVnode, newEndVnode)) {
                patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
                oldEndVnode = oldCh[--oldEndIdx];
                newEndVnode = newCh[--newEndIdx];
            } else if ($69b5f56b6d1ac1d8$var$sameVnode(oldStartVnode, newEndVnode)) {
                // Vnode moved right
                patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
                canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
                oldStartVnode = oldCh[++oldStartIdx];
                newEndVnode = newCh[--newEndIdx];
            } else if ($69b5f56b6d1ac1d8$var$sameVnode(oldEndVnode, newStartVnode)) {
                // Vnode moved left
                patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
                oldEndVnode = oldCh[--oldEndIdx];
                newStartVnode = newCh[++newStartIdx];
            } else {
                if ($69b5f56b6d1ac1d8$var$isUndef(oldKeyToIdx)) oldKeyToIdx = $69b5f56b6d1ac1d8$var$createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
                idxInOld = $69b5f56b6d1ac1d8$var$isDef(newStartVnode.key) ? oldKeyToIdx[newStartVnode.key] : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
                if ($69b5f56b6d1ac1d8$var$isUndef(idxInOld)) // New element
                createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
                else {
                    vnodeToMove = oldCh[idxInOld];
                    if ($69b5f56b6d1ac1d8$var$sameVnode(vnodeToMove, newStartVnode)) {
                        patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                        oldCh[idxInOld] = undefined;
                        canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
                    } else // same key but different element. treat as new element
                    createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
                }
                newStartVnode = newCh[++newStartIdx];
            }
        }
        if (oldStartIdx > oldEndIdx) {
            refElm = $69b5f56b6d1ac1d8$var$isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
            addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
        } else if (newStartIdx > newEndIdx) removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
    function checkDuplicateKeys(children) {
        const seenKeys = {};
        for(let i = 0; i < children.length; i++){
            const vnode = children[i];
            const key = vnode.key;
            if ($69b5f56b6d1ac1d8$var$isDef(key)) {
                if (seenKeys[key]) $69b5f56b6d1ac1d8$var$warn$2(`Duplicate keys detected: '${key}'. This may cause an update error.`, vnode.context);
                else seenKeys[key] = true;
            }
        }
    }
    function findIdxInOld(node, oldCh, start, end) {
        for(let i = start; i < end; i++){
            const c = oldCh[i];
            if ($69b5f56b6d1ac1d8$var$isDef(c) && $69b5f56b6d1ac1d8$var$sameVnode(node, c)) return i;
        }
    }
    function patchVnode(oldVnode, vnode, insertedVnodeQueue, ownerArray, index, removeOnly) {
        if (oldVnode === vnode) return;
        if ($69b5f56b6d1ac1d8$var$isDef(vnode.elm) && $69b5f56b6d1ac1d8$var$isDef(ownerArray)) // clone reused vnode
        vnode = ownerArray[index] = $69b5f56b6d1ac1d8$var$cloneVNode(vnode);
        const elm = vnode.elm = oldVnode.elm;
        if ($69b5f56b6d1ac1d8$var$isTrue(oldVnode.isAsyncPlaceholder)) {
            if ($69b5f56b6d1ac1d8$var$isDef(vnode.asyncFactory.resolved)) hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
            else vnode.isAsyncPlaceholder = true;
            return;
        }
        // reuse element for static trees.
        // note we only do this if the vnode is cloned -
        // if the new node is not cloned it means the render functions have been
        // reset by the hot-reload-api and we need to do a proper re-render.
        if ($69b5f56b6d1ac1d8$var$isTrue(vnode.isStatic) && $69b5f56b6d1ac1d8$var$isTrue(oldVnode.isStatic) && vnode.key === oldVnode.key && ($69b5f56b6d1ac1d8$var$isTrue(vnode.isCloned) || $69b5f56b6d1ac1d8$var$isTrue(vnode.isOnce))) {
            vnode.componentInstance = oldVnode.componentInstance;
            return;
        }
        let i;
        const data = vnode.data;
        if ($69b5f56b6d1ac1d8$var$isDef(data) && $69b5f56b6d1ac1d8$var$isDef(i = data.hook) && $69b5f56b6d1ac1d8$var$isDef(i = i.prepatch)) i(oldVnode, vnode);
        const oldCh = oldVnode.children;
        const ch = vnode.children;
        if ($69b5f56b6d1ac1d8$var$isDef(data) && isPatchable(vnode)) {
            for(i = 0; i < cbs.update.length; ++i)cbs.update[i](oldVnode, vnode);
            if ($69b5f56b6d1ac1d8$var$isDef(i = data.hook) && $69b5f56b6d1ac1d8$var$isDef(i = i.update)) i(oldVnode, vnode);
        }
        if ($69b5f56b6d1ac1d8$var$isUndef(vnode.text)) {
            if ($69b5f56b6d1ac1d8$var$isDef(oldCh) && $69b5f56b6d1ac1d8$var$isDef(ch)) {
                if (oldCh !== ch) updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly);
            } else if ($69b5f56b6d1ac1d8$var$isDef(ch)) {
                checkDuplicateKeys(ch);
                if ($69b5f56b6d1ac1d8$var$isDef(oldVnode.text)) nodeOps.setTextContent(elm, '');
                addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
            } else if ($69b5f56b6d1ac1d8$var$isDef(oldCh)) removeVnodes(oldCh, 0, oldCh.length - 1);
            else if ($69b5f56b6d1ac1d8$var$isDef(oldVnode.text)) nodeOps.setTextContent(elm, '');
        } else if (oldVnode.text !== vnode.text) nodeOps.setTextContent(elm, vnode.text);
        if ($69b5f56b6d1ac1d8$var$isDef(data)) {
            if ($69b5f56b6d1ac1d8$var$isDef(i = data.hook) && $69b5f56b6d1ac1d8$var$isDef(i = i.postpatch)) i(oldVnode, vnode);
        }
    }
    function invokeInsertHook(vnode, queue, initial) {
        // delay insert hooks for component root nodes, invoke them after the
        // element is really inserted
        if ($69b5f56b6d1ac1d8$var$isTrue(initial) && $69b5f56b6d1ac1d8$var$isDef(vnode.parent)) vnode.parent.data.pendingInsert = queue;
        else for(let i = 0; i < queue.length; ++i)queue[i].data.hook.insert(queue[i]);
    }
    let hydrationBailed = false;
    // list of modules that can skip create hook during hydration because they
    // are already rendered on the client or has no need for initialization
    // Note: style is excluded because it relies on initial clone for future
    // deep updates (#7063).
    const isRenderedModule = $69b5f56b6d1ac1d8$var$makeMap('attrs,class,staticClass,staticStyle,key');
    // Note: this is a browser-only function so we can assume elms are DOM nodes.
    function hydrate(elm, vnode, insertedVnodeQueue, inVPre) {
        let i;
        const { tag: tag, data: data, children: children } = vnode;
        inVPre = inVPre || data && data.pre;
        vnode.elm = elm;
        if ($69b5f56b6d1ac1d8$var$isTrue(vnode.isComment) && $69b5f56b6d1ac1d8$var$isDef(vnode.asyncFactory)) {
            vnode.isAsyncPlaceholder = true;
            return true;
        }
        if (!assertNodeMatch(elm, vnode, inVPre)) return false;
        if ($69b5f56b6d1ac1d8$var$isDef(data)) {
            if ($69b5f56b6d1ac1d8$var$isDef(i = data.hook) && $69b5f56b6d1ac1d8$var$isDef(i = i.init)) i(vnode, true);
            if ($69b5f56b6d1ac1d8$var$isDef(i = vnode.componentInstance)) {
                // child component. it should have hydrated its own tree.
                initComponent(vnode, insertedVnodeQueue);
                return true;
            }
        }
        if ($69b5f56b6d1ac1d8$var$isDef(tag)) {
            if ($69b5f56b6d1ac1d8$var$isDef(children)) {
                // empty element, allow client to pick up and populate children
                if (!elm.hasChildNodes()) createChildren(vnode, children, insertedVnodeQueue);
                else {
                    // v-html and domProps: innerHTML
                    if ($69b5f56b6d1ac1d8$var$isDef(i = data) && $69b5f56b6d1ac1d8$var$isDef(i = i.domProps) && $69b5f56b6d1ac1d8$var$isDef(i = i.innerHTML)) {
                        if (i !== elm.innerHTML) {
                            /* istanbul ignore if */ if (typeof console !== 'undefined' && !hydrationBailed) {
                                hydrationBailed = true;
                                console.warn('Parent: ', elm);
                                console.warn('server innerHTML: ', i);
                                console.warn('client innerHTML: ', elm.innerHTML);
                            }
                            return false;
                        }
                    } else {
                        // iterate and compare children lists
                        let childrenMatch = true;
                        let childNode = elm.firstChild;
                        for(let i = 0; i < children.length; i++){
                            if (!childNode || !hydrate(childNode, children[i], insertedVnodeQueue, inVPre)) {
                                childrenMatch = false;
                                break;
                            }
                            childNode = childNode.nextSibling;
                        }
                        // if childNode is not null, it means the actual childNodes list is
                        // longer than the virtual children list.
                        if (!childrenMatch || childNode) {
                            /* istanbul ignore if */ if (typeof console !== 'undefined' && !hydrationBailed) {
                                hydrationBailed = true;
                                console.warn('Parent: ', elm);
                                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
                            }
                            return false;
                        }
                    }
                }
            }
            if ($69b5f56b6d1ac1d8$var$isDef(data)) {
                let fullInvoke = false;
                for(const key in data)if (!isRenderedModule(key)) {
                    fullInvoke = true;
                    invokeCreateHooks(vnode, insertedVnodeQueue);
                    break;
                }
                if (!fullInvoke && data['class']) // ensure collecting deps for deep class bindings for future updates
                $69b5f56b6d1ac1d8$var$traverse(data['class']);
            }
        } else if (elm.data !== vnode.text) elm.data = vnode.text;
        return true;
    }
    function assertNodeMatch(node, vnode, inVPre) {
        if ($69b5f56b6d1ac1d8$var$isDef(vnode.tag)) return vnode.tag.indexOf('vue-component') === 0 || !isUnknownElement(vnode, inVPre) && vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase());
        else return node.nodeType === (vnode.isComment ? 8 : 3);
    }
    return function patch(oldVnode, vnode, hydrating, removeOnly) {
        if ($69b5f56b6d1ac1d8$var$isUndef(vnode)) {
            if ($69b5f56b6d1ac1d8$var$isDef(oldVnode)) invokeDestroyHook(oldVnode);
            return;
        }
        let isInitialPatch = false;
        const insertedVnodeQueue = [];
        if ($69b5f56b6d1ac1d8$var$isUndef(oldVnode)) {
            // empty mount (likely as component), create new root element
            isInitialPatch = true;
            createElm(vnode, insertedVnodeQueue);
        } else {
            const isRealElement = $69b5f56b6d1ac1d8$var$isDef(oldVnode.nodeType);
            if (!isRealElement && $69b5f56b6d1ac1d8$var$sameVnode(oldVnode, vnode)) // patch existing root node
            patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
            else {
                if (isRealElement) {
                    // mounting to a real element
                    // check if this is server-rendered content and if we can perform
                    // a successful hydration.
                    if (oldVnode.nodeType === 1 && oldVnode.hasAttribute($69b5f56b6d1ac1d8$var$SSR_ATTR)) {
                        oldVnode.removeAttribute($69b5f56b6d1ac1d8$var$SSR_ATTR);
                        hydrating = true;
                    }
                    if ($69b5f56b6d1ac1d8$var$isTrue(hydrating)) {
                        if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
                            invokeInsertHook(vnode, insertedVnodeQueue, true);
                            return oldVnode;
                        } else $69b5f56b6d1ac1d8$var$warn$2("The client-side rendered virtual DOM tree is not matching server-rendered content. This is likely caused by incorrect HTML markup, for example nesting block-level elements inside <p>, or missing <tbody>. Bailing hydration and performing full client-side render.");
                    }
                    // either not server-rendered, or hydration failed.
                    // create an empty node and replace it
                    oldVnode = emptyNodeAt(oldVnode);
                }
                // replacing existing element
                const oldElm = oldVnode.elm;
                const parentElm = nodeOps.parentNode(oldElm);
                // create new node
                createElm(vnode, insertedVnodeQueue, // extremely rare edge case: do not insert if old element is in a
                // leaving transition. Only happens when combining transition +
                // keep-alive + HOCs. (#4590)
                oldElm._leaveCb ? null : parentElm, nodeOps.nextSibling(oldElm));
                // update parent placeholder node element, recursively
                if ($69b5f56b6d1ac1d8$var$isDef(vnode.parent)) {
                    let ancestor = vnode.parent;
                    const patchable = isPatchable(vnode);
                    while(ancestor){
                        for(let i = 0; i < cbs.destroy.length; ++i)cbs.destroy[i](ancestor);
                        ancestor.elm = vnode.elm;
                        if (patchable) {
                            for(let i = 0; i < cbs.create.length; ++i)cbs.create[i]($69b5f56b6d1ac1d8$var$emptyNode, ancestor);
                            // #6513
                            // invoke insert hooks that may have been merged by create hooks.
                            // e.g. for directives that uses the "inserted" hook.
                            const insert = ancestor.data.hook.insert;
                            if (insert.merged) {
                                // start at index 1 to avoid re-invoking component mounted hook
                                // clone insert hooks to avoid being mutated during iteration.
                                // e.g. for customed directives under transition group.
                                const cloned = insert.fns.slice(1);
                                for(let i = 0; i < cloned.length; i++)cloned[i]();
                            }
                        } else $69b5f56b6d1ac1d8$var$registerRef(ancestor);
                        ancestor = ancestor.parent;
                    }
                }
                // destroy old node
                if ($69b5f56b6d1ac1d8$var$isDef(parentElm)) removeVnodes([
                    oldVnode
                ], 0, 0);
                else if ($69b5f56b6d1ac1d8$var$isDef(oldVnode.tag)) invokeDestroyHook(oldVnode);
            }
        }
        invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
        return vnode.elm;
    };
}
var $69b5f56b6d1ac1d8$var$directives$1 = {
    create: $69b5f56b6d1ac1d8$var$updateDirectives,
    update: $69b5f56b6d1ac1d8$var$updateDirectives,
    destroy: function unbindDirectives(vnode) {
        // @ts-expect-error emptyNode is not VNodeWithData
        $69b5f56b6d1ac1d8$var$updateDirectives(vnode, $69b5f56b6d1ac1d8$var$emptyNode);
    }
};
function $69b5f56b6d1ac1d8$var$updateDirectives(oldVnode, vnode) {
    if (oldVnode.data.directives || vnode.data.directives) $69b5f56b6d1ac1d8$var$_update(oldVnode, vnode);
}
function $69b5f56b6d1ac1d8$var$_update(oldVnode, vnode) {
    const isCreate = oldVnode === $69b5f56b6d1ac1d8$var$emptyNode;
    const isDestroy = vnode === $69b5f56b6d1ac1d8$var$emptyNode;
    const oldDirs = $69b5f56b6d1ac1d8$var$normalizeDirectives(oldVnode.data.directives, oldVnode.context);
    const newDirs = $69b5f56b6d1ac1d8$var$normalizeDirectives(vnode.data.directives, vnode.context);
    const dirsWithInsert = [];
    const dirsWithPostpatch = [];
    let key, oldDir, dir;
    for(key in newDirs){
        oldDir = oldDirs[key];
        dir = newDirs[key];
        if (!oldDir) {
            // new directive, bind
            $69b5f56b6d1ac1d8$var$callHook(dir, 'bind', vnode, oldVnode);
            if (dir.def && dir.def.inserted) dirsWithInsert.push(dir);
        } else {
            // existing directive, update
            dir.oldValue = oldDir.value;
            dir.oldArg = oldDir.arg;
            $69b5f56b6d1ac1d8$var$callHook(dir, 'update', vnode, oldVnode);
            if (dir.def && dir.def.componentUpdated) dirsWithPostpatch.push(dir);
        }
    }
    if (dirsWithInsert.length) {
        const callInsert = ()=>{
            for(let i = 0; i < dirsWithInsert.length; i++)$69b5f56b6d1ac1d8$var$callHook(dirsWithInsert[i], 'inserted', vnode, oldVnode);
        };
        if (isCreate) $69b5f56b6d1ac1d8$var$mergeVNodeHook(vnode, 'insert', callInsert);
        else callInsert();
    }
    if (dirsWithPostpatch.length) $69b5f56b6d1ac1d8$var$mergeVNodeHook(vnode, 'postpatch', ()=>{
        for(let i = 0; i < dirsWithPostpatch.length; i++)$69b5f56b6d1ac1d8$var$callHook(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
    });
    if (!isCreate) {
        for(key in oldDirs)if (!newDirs[key]) // no longer present, unbind
        $69b5f56b6d1ac1d8$var$callHook(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
    }
}
const $69b5f56b6d1ac1d8$var$emptyModifiers = Object.create(null);
function $69b5f56b6d1ac1d8$var$normalizeDirectives(dirs, vm) {
    const res = Object.create(null);
    if (!dirs) // $flow-disable-line
    return res;
    let i, dir;
    for(i = 0; i < dirs.length; i++){
        dir = dirs[i];
        if (!dir.modifiers) // $flow-disable-line
        dir.modifiers = $69b5f56b6d1ac1d8$var$emptyModifiers;
        res[$69b5f56b6d1ac1d8$var$getRawDirName(dir)] = dir;
        if (vm._setupState && vm._setupState.__sfc) {
            const setupDef = dir.def || $69b5f56b6d1ac1d8$var$resolveAsset(vm, '_setupState', 'v-' + dir.name);
            if (typeof setupDef === 'function') dir.def = {
                bind: setupDef,
                update: setupDef
            };
            else dir.def = setupDef;
        }
        dir.def = dir.def || $69b5f56b6d1ac1d8$var$resolveAsset(vm.$options, 'directives', dir.name, true);
    }
    // $flow-disable-line
    return res;
}
function $69b5f56b6d1ac1d8$var$getRawDirName(dir) {
    return dir.rawName || `${dir.name}.${Object.keys(dir.modifiers || {}).join('.')}`;
}
function $69b5f56b6d1ac1d8$var$callHook(dir, hook, vnode, oldVnode, isDestroy) {
    const fn = dir.def && dir.def[hook];
    if (fn) try {
        fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
        $69b5f56b6d1ac1d8$var$handleError(e, vnode.context, `directive ${dir.name} ${hook} hook`);
    }
}
var $69b5f56b6d1ac1d8$var$baseModules = [
    $69b5f56b6d1ac1d8$var$ref,
    $69b5f56b6d1ac1d8$var$directives$1
];
function $69b5f56b6d1ac1d8$var$updateAttrs(oldVnode, vnode) {
    const opts = vnode.componentOptions;
    if ($69b5f56b6d1ac1d8$var$isDef(opts) && opts.Ctor.options.inheritAttrs === false) return;
    if ($69b5f56b6d1ac1d8$var$isUndef(oldVnode.data.attrs) && $69b5f56b6d1ac1d8$var$isUndef(vnode.data.attrs)) return;
    let key, cur, old;
    const elm = vnode.elm;
    const oldAttrs = oldVnode.data.attrs || {};
    let attrs = vnode.data.attrs || {};
    // clone observed objects, as the user probably wants to mutate it
    if ($69b5f56b6d1ac1d8$var$isDef(attrs.__ob__) || $69b5f56b6d1ac1d8$var$isTrue(attrs._v_attr_proxy)) attrs = vnode.data.attrs = $69b5f56b6d1ac1d8$var$extend({}, attrs);
    for(key in attrs){
        cur = attrs[key];
        old = oldAttrs[key];
        if (old !== cur) $69b5f56b6d1ac1d8$var$setAttr(elm, key, cur, vnode.data.pre);
    }
    // #4391: in IE9, setting type can reset value for input[type=radio]
    // #6666: IE/Edge forces progress value down to 1 before setting a max
    /* istanbul ignore if */ if (($69b5f56b6d1ac1d8$var$isIE || $69b5f56b6d1ac1d8$var$isEdge) && attrs.value !== oldAttrs.value) $69b5f56b6d1ac1d8$var$setAttr(elm, 'value', attrs.value);
    for(key in oldAttrs)if ($69b5f56b6d1ac1d8$var$isUndef(attrs[key])) {
        if ($69b5f56b6d1ac1d8$var$isXlink(key)) elm.removeAttributeNS($69b5f56b6d1ac1d8$var$xlinkNS, $69b5f56b6d1ac1d8$var$getXlinkProp(key));
        else if (!$69b5f56b6d1ac1d8$var$isEnumeratedAttr(key)) elm.removeAttribute(key);
    }
}
function $69b5f56b6d1ac1d8$var$setAttr(el, key, value, isInPre) {
    if (isInPre || el.tagName.indexOf('-') > -1) $69b5f56b6d1ac1d8$var$baseSetAttr(el, key, value);
    else if ($69b5f56b6d1ac1d8$var$isBooleanAttr(key)) {
        // set attribute for blank value
        // e.g. <option disabled>Select one</option>
        if ($69b5f56b6d1ac1d8$var$isFalsyAttrValue(value)) el.removeAttribute(key);
        else {
            // technically allowfullscreen is a boolean attribute for <iframe>,
            // but Flash expects a value of "true" when used on <embed> tag
            value = key === 'allowfullscreen' && el.tagName === 'EMBED' ? 'true' : key;
            el.setAttribute(key, value);
        }
    } else if ($69b5f56b6d1ac1d8$var$isEnumeratedAttr(key)) el.setAttribute(key, $69b5f56b6d1ac1d8$var$convertEnumeratedValue(key, value));
    else if ($69b5f56b6d1ac1d8$var$isXlink(key)) {
        if ($69b5f56b6d1ac1d8$var$isFalsyAttrValue(value)) el.removeAttributeNS($69b5f56b6d1ac1d8$var$xlinkNS, $69b5f56b6d1ac1d8$var$getXlinkProp(key));
        else el.setAttributeNS($69b5f56b6d1ac1d8$var$xlinkNS, key, value);
    } else $69b5f56b6d1ac1d8$var$baseSetAttr(el, key, value);
}
function $69b5f56b6d1ac1d8$var$baseSetAttr(el, key, value) {
    if ($69b5f56b6d1ac1d8$var$isFalsyAttrValue(value)) el.removeAttribute(key);
    else {
        // #7138: IE10 & 11 fires input event when setting placeholder on
        // <textarea>... block the first input event and remove the blocker
        // immediately.
        /* istanbul ignore if */ if ($69b5f56b6d1ac1d8$var$isIE && !$69b5f56b6d1ac1d8$var$isIE9 && el.tagName === 'TEXTAREA' && key === 'placeholder' && value !== '' && !el.__ieph) {
            const blocker = (e)=>{
                e.stopImmediatePropagation();
                el.removeEventListener('input', blocker);
            };
            el.addEventListener('input', blocker);
            // $flow-disable-line
            el.__ieph = true; /* IE placeholder patched */ 
        }
        el.setAttribute(key, value);
    }
}
var $69b5f56b6d1ac1d8$var$attrs = {
    create: $69b5f56b6d1ac1d8$var$updateAttrs,
    update: $69b5f56b6d1ac1d8$var$updateAttrs
};
function $69b5f56b6d1ac1d8$var$updateClass(oldVnode, vnode) {
    const el = vnode.elm;
    const data = vnode.data;
    const oldData = oldVnode.data;
    if ($69b5f56b6d1ac1d8$var$isUndef(data.staticClass) && $69b5f56b6d1ac1d8$var$isUndef(data.class) && ($69b5f56b6d1ac1d8$var$isUndef(oldData) || $69b5f56b6d1ac1d8$var$isUndef(oldData.staticClass) && $69b5f56b6d1ac1d8$var$isUndef(oldData.class))) return;
    let cls = $69b5f56b6d1ac1d8$var$genClassForVnode(vnode);
    // handle transition classes
    const transitionClass = el._transitionClasses;
    if ($69b5f56b6d1ac1d8$var$isDef(transitionClass)) cls = $69b5f56b6d1ac1d8$var$concat(cls, $69b5f56b6d1ac1d8$var$stringifyClass(transitionClass));
    // set the class
    if (cls !== el._prevClass) {
        el.setAttribute('class', cls);
        el._prevClass = cls;
    }
}
var $69b5f56b6d1ac1d8$var$klass$1 = {
    create: $69b5f56b6d1ac1d8$var$updateClass,
    update: $69b5f56b6d1ac1d8$var$updateClass
};
const $69b5f56b6d1ac1d8$var$validDivisionCharRE = /[\w).+\-_$\]]/;
function $69b5f56b6d1ac1d8$var$parseFilters(exp) {
    let inSingle = false;
    let inDouble = false;
    let inTemplateString = false;
    let inRegex = false;
    let curly = 0;
    let square = 0;
    let paren = 0;
    let lastFilterIndex = 0;
    let c, prev, i, expression, filters;
    for(i = 0; i < exp.length; i++){
        prev = c;
        c = exp.charCodeAt(i);
        if (inSingle) {
            if (c === 0x27 && prev !== 0x5c) inSingle = false;
        } else if (inDouble) {
            if (c === 0x22 && prev !== 0x5c) inDouble = false;
        } else if (inTemplateString) {
            if (c === 0x60 && prev !== 0x5c) inTemplateString = false;
        } else if (inRegex) {
            if (c === 0x2f && prev !== 0x5c) inRegex = false;
        } else if (c === 0x7c && // pipe
        exp.charCodeAt(i + 1) !== 0x7c && exp.charCodeAt(i - 1) !== 0x7c && !curly && !square && !paren) {
            if (expression === undefined) {
                // first filter, end of expression
                lastFilterIndex = i + 1;
                expression = exp.slice(0, i).trim();
            } else pushFilter();
        } else {
            switch(c){
                case 0x22:
                    inDouble = true;
                    break; // "
                case 0x27:
                    inSingle = true;
                    break; // '
                case 0x60:
                    inTemplateString = true;
                    break; // `
                case 0x28:
                    paren++;
                    break; // (
                case 0x29:
                    paren--;
                    break; // )
                case 0x5b:
                    square++;
                    break; // [
                case 0x5d:
                    square--;
                    break; // ]
                case 0x7b:
                    curly++;
                    break; // {
                case 0x7d:
                    curly--;
                    break; // }
            }
            if (c === 0x2f) {
                // /
                let j = i - 1;
                let p;
                // find first non-whitespace prev char
                for(; j >= 0; j--){
                    p = exp.charAt(j);
                    if (p !== ' ') break;
                }
                if (!p || !$69b5f56b6d1ac1d8$var$validDivisionCharRE.test(p)) inRegex = true;
            }
        }
    }
    if (expression === undefined) expression = exp.slice(0, i).trim();
    else if (lastFilterIndex !== 0) pushFilter();
    function pushFilter() {
        (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
        lastFilterIndex = i + 1;
    }
    if (filters) for(i = 0; i < filters.length; i++)expression = $69b5f56b6d1ac1d8$var$wrapFilter(expression, filters[i]);
    return expression;
}
function $69b5f56b6d1ac1d8$var$wrapFilter(exp, filter) {
    const i = filter.indexOf('(');
    if (i < 0) // _f: resolveFilter
    return `_f("${filter}")(${exp})`;
    else {
        const name = filter.slice(0, i);
        const args = filter.slice(i + 1);
        return `_f("${name}")(${exp}${args !== ')' ? ',' + args : args}`;
    }
}
/* eslint-disable no-unused-vars */ function $69b5f56b6d1ac1d8$var$baseWarn(msg, range) {
    console.error(`[Vue compiler]: ${msg}`);
}
/* eslint-enable no-unused-vars */ function $69b5f56b6d1ac1d8$var$pluckModuleFunction(modules, key) {
    return modules ? modules.map((m)=>m[key]).filter((_)=>_) : [];
}
function $69b5f56b6d1ac1d8$var$addProp(el, name, value, range, dynamic) {
    (el.props || (el.props = [])).push($69b5f56b6d1ac1d8$var$rangeSetItem({
        name: name,
        value: value,
        dynamic: dynamic
    }, range));
    el.plain = false;
}
function $69b5f56b6d1ac1d8$var$addAttr(el, name, value, range, dynamic) {
    const attrs = dynamic ? el.dynamicAttrs || (el.dynamicAttrs = []) : el.attrs || (el.attrs = []);
    attrs.push($69b5f56b6d1ac1d8$var$rangeSetItem({
        name: name,
        value: value,
        dynamic: dynamic
    }, range));
    el.plain = false;
}
// add a raw attr (use this in preTransforms)
function $69b5f56b6d1ac1d8$var$addRawAttr(el, name, value, range) {
    el.attrsMap[name] = value;
    el.attrsList.push($69b5f56b6d1ac1d8$var$rangeSetItem({
        name: name,
        value: value
    }, range));
}
function $69b5f56b6d1ac1d8$var$addDirective(el, name, rawName, value, arg, isDynamicArg, modifiers, range) {
    (el.directives || (el.directives = [])).push($69b5f56b6d1ac1d8$var$rangeSetItem({
        name: name,
        rawName: rawName,
        value: value,
        arg: arg,
        isDynamicArg: isDynamicArg,
        modifiers: modifiers
    }, range));
    el.plain = false;
}
function $69b5f56b6d1ac1d8$var$prependModifierMarker(symbol, name, dynamic) {
    return dynamic ? `_p(${name},"${symbol}")` : symbol + name; // mark the event as captured
}
function $69b5f56b6d1ac1d8$var$addHandler(el, name, value, modifiers, important, warn, range, dynamic) {
    modifiers = modifiers || $69b5f56b6d1ac1d8$var$emptyObject;
    // warn prevent and passive modifier
    /* istanbul ignore if */ if (warn && modifiers.prevent && modifiers.passive) warn("passive and prevent can't be used together. Passive handler can't prevent default event.", range);
    // normalize click.right and click.middle since they don't actually fire
    // this is technically browser-specific, but at least for now browsers are
    // the only target envs that have right/middle clicks.
    if (modifiers.right) {
        if (dynamic) name = `(${name})==='click'?'contextmenu':(${name})`;
        else if (name === 'click') {
            name = 'contextmenu';
            delete modifiers.right;
        }
    } else if (modifiers.middle) {
        if (dynamic) name = `(${name})==='click'?'mouseup':(${name})`;
        else if (name === 'click') name = 'mouseup';
    }
    // check capture modifier
    if (modifiers.capture) {
        delete modifiers.capture;
        name = $69b5f56b6d1ac1d8$var$prependModifierMarker('!', name, dynamic);
    }
    if (modifiers.once) {
        delete modifiers.once;
        name = $69b5f56b6d1ac1d8$var$prependModifierMarker('~', name, dynamic);
    }
    /* istanbul ignore if */ if (modifiers.passive) {
        delete modifiers.passive;
        name = $69b5f56b6d1ac1d8$var$prependModifierMarker('&', name, dynamic);
    }
    let events;
    if (modifiers.native) {
        delete modifiers.native;
        events = el.nativeEvents || (el.nativeEvents = {});
    } else events = el.events || (el.events = {});
    const newHandler = $69b5f56b6d1ac1d8$var$rangeSetItem({
        value: value.trim(),
        dynamic: dynamic
    }, range);
    if (modifiers !== $69b5f56b6d1ac1d8$var$emptyObject) newHandler.modifiers = modifiers;
    const handlers = events[name];
    /* istanbul ignore if */ if (Array.isArray(handlers)) important ? handlers.unshift(newHandler) : handlers.push(newHandler);
    else if (handlers) events[name] = important ? [
        newHandler,
        handlers
    ] : [
        handlers,
        newHandler
    ];
    else events[name] = newHandler;
    el.plain = false;
}
function $69b5f56b6d1ac1d8$var$getRawBindingAttr(el, name) {
    return el.rawAttrsMap[':' + name] || el.rawAttrsMap['v-bind:' + name] || el.rawAttrsMap[name];
}
function $69b5f56b6d1ac1d8$var$getBindingAttr(el, name, getStatic) {
    const dynamicValue = $69b5f56b6d1ac1d8$var$getAndRemoveAttr(el, ':' + name) || $69b5f56b6d1ac1d8$var$getAndRemoveAttr(el, 'v-bind:' + name);
    if (dynamicValue != null) return $69b5f56b6d1ac1d8$var$parseFilters(dynamicValue);
    else if (getStatic !== false) {
        const staticValue = $69b5f56b6d1ac1d8$var$getAndRemoveAttr(el, name);
        if (staticValue != null) return JSON.stringify(staticValue);
    }
}
// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function $69b5f56b6d1ac1d8$var$getAndRemoveAttr(el, name, removeFromMap) {
    let val;
    if ((val = el.attrsMap[name]) != null) {
        const list = el.attrsList;
        for(let i = 0, l = list.length; i < l; i++)if (list[i].name === name) {
            list.splice(i, 1);
            break;
        }
    }
    if (removeFromMap) delete el.attrsMap[name];
    return val;
}
function $69b5f56b6d1ac1d8$var$getAndRemoveAttrByRegex(el, name) {
    const list = el.attrsList;
    for(let i = 0, l = list.length; i < l; i++){
        const attr = list[i];
        if (name.test(attr.name)) {
            list.splice(i, 1);
            return attr;
        }
    }
}
function $69b5f56b6d1ac1d8$var$rangeSetItem(item, range) {
    if (range) {
        if (range.start != null) item.start = range.start;
        if (range.end != null) item.end = range.end;
    }
    return item;
}
/**
 * Cross-platform code generation for component v-model
 */ function $69b5f56b6d1ac1d8$var$genComponentModel(el, value, modifiers) {
    const { number: number, trim: trim } = modifiers || {};
    const baseValueExpression = '$$v';
    let valueExpression = baseValueExpression;
    if (trim) valueExpression = `(typeof ${baseValueExpression} === 'string'` + `? ${baseValueExpression}.trim()` + `: ${baseValueExpression})`;
    if (number) valueExpression = `_n(${valueExpression})`;
    const assignment = $69b5f56b6d1ac1d8$var$genAssignmentCode(value, valueExpression);
    el.model = {
        value: `(${value})`,
        expression: JSON.stringify(value),
        callback: `function (${baseValueExpression}) {${assignment}}`
    };
}
/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */ function $69b5f56b6d1ac1d8$var$genAssignmentCode(value, assignment) {
    const res = $69b5f56b6d1ac1d8$var$parseModel(value);
    if (res.key === null) return `${value}=${assignment}`;
    else return `$set(${res.exp}, ${res.key}, ${assignment})`;
}
/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */ let $69b5f56b6d1ac1d8$var$len, $69b5f56b6d1ac1d8$var$str, $69b5f56b6d1ac1d8$var$chr, $69b5f56b6d1ac1d8$var$index, $69b5f56b6d1ac1d8$var$expressionPos, $69b5f56b6d1ac1d8$var$expressionEndPos;
function $69b5f56b6d1ac1d8$var$parseModel(val) {
    // Fix https://github.com/vuejs/vue/pull/7730
    // allow v-model="obj.val " (trailing whitespace)
    val = val.trim();
    $69b5f56b6d1ac1d8$var$len = val.length;
    if (val.indexOf('[') < 0 || val.lastIndexOf(']') < $69b5f56b6d1ac1d8$var$len - 1) {
        $69b5f56b6d1ac1d8$var$index = val.lastIndexOf('.');
        if ($69b5f56b6d1ac1d8$var$index > -1) return {
            exp: val.slice(0, $69b5f56b6d1ac1d8$var$index),
            key: '"' + val.slice($69b5f56b6d1ac1d8$var$index + 1) + '"'
        };
        else return {
            exp: val,
            key: null
        };
    }
    $69b5f56b6d1ac1d8$var$str = val;
    $69b5f56b6d1ac1d8$var$index = $69b5f56b6d1ac1d8$var$expressionPos = $69b5f56b6d1ac1d8$var$expressionEndPos = 0;
    while(!$69b5f56b6d1ac1d8$var$eof()){
        $69b5f56b6d1ac1d8$var$chr = $69b5f56b6d1ac1d8$var$next();
        /* istanbul ignore if */ if ($69b5f56b6d1ac1d8$var$isStringStart($69b5f56b6d1ac1d8$var$chr)) $69b5f56b6d1ac1d8$var$parseString($69b5f56b6d1ac1d8$var$chr);
        else if ($69b5f56b6d1ac1d8$var$chr === 0x5b) $69b5f56b6d1ac1d8$var$parseBracket($69b5f56b6d1ac1d8$var$chr);
    }
    return {
        exp: val.slice(0, $69b5f56b6d1ac1d8$var$expressionPos),
        key: val.slice($69b5f56b6d1ac1d8$var$expressionPos + 1, $69b5f56b6d1ac1d8$var$expressionEndPos)
    };
}
function $69b5f56b6d1ac1d8$var$next() {
    return $69b5f56b6d1ac1d8$var$str.charCodeAt(++$69b5f56b6d1ac1d8$var$index);
}
function $69b5f56b6d1ac1d8$var$eof() {
    return $69b5f56b6d1ac1d8$var$index >= $69b5f56b6d1ac1d8$var$len;
}
function $69b5f56b6d1ac1d8$var$isStringStart(chr) {
    return chr === 0x22 || chr === 0x27;
}
function $69b5f56b6d1ac1d8$var$parseBracket(chr) {
    let inBracket = 1;
    $69b5f56b6d1ac1d8$var$expressionPos = $69b5f56b6d1ac1d8$var$index;
    while(!$69b5f56b6d1ac1d8$var$eof()){
        chr = $69b5f56b6d1ac1d8$var$next();
        if ($69b5f56b6d1ac1d8$var$isStringStart(chr)) {
            $69b5f56b6d1ac1d8$var$parseString(chr);
            continue;
        }
        if (chr === 0x5b) inBracket++;
        if (chr === 0x5d) inBracket--;
        if (inBracket === 0) {
            $69b5f56b6d1ac1d8$var$expressionEndPos = $69b5f56b6d1ac1d8$var$index;
            break;
        }
    }
}
function $69b5f56b6d1ac1d8$var$parseString(chr) {
    const stringQuote = chr;
    while(!$69b5f56b6d1ac1d8$var$eof()){
        chr = $69b5f56b6d1ac1d8$var$next();
        if (chr === stringQuote) break;
    }
}
let $69b5f56b6d1ac1d8$var$warn$1;
// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
const $69b5f56b6d1ac1d8$var$RANGE_TOKEN = '__r';
const $69b5f56b6d1ac1d8$var$CHECKBOX_RADIO_TOKEN = '__c';
function $69b5f56b6d1ac1d8$var$model$1(el, dir, _warn) {
    $69b5f56b6d1ac1d8$var$warn$1 = _warn;
    const value = dir.value;
    const modifiers = dir.modifiers;
    const tag = el.tag;
    const type = el.attrsMap.type;
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') $69b5f56b6d1ac1d8$var$warn$1(`<${el.tag} v-model="${value}" type="file">:\n` + `File inputs are read only. Use a v-on:change listener instead.`, el.rawAttrsMap['v-model']);
    if (el.component) {
        $69b5f56b6d1ac1d8$var$genComponentModel(el, value, modifiers);
        // component v-model doesn't need extra runtime
        return false;
    } else if (tag === 'select') $69b5f56b6d1ac1d8$var$genSelect(el, value, modifiers);
    else if (tag === 'input' && type === 'checkbox') $69b5f56b6d1ac1d8$var$genCheckboxModel(el, value, modifiers);
    else if (tag === 'input' && type === 'radio') $69b5f56b6d1ac1d8$var$genRadioModel(el, value, modifiers);
    else if (tag === 'input' || tag === 'textarea') $69b5f56b6d1ac1d8$var$genDefaultModel(el, value, modifiers);
    else if (!$69b5f56b6d1ac1d8$var$config.isReservedTag(tag)) {
        $69b5f56b6d1ac1d8$var$genComponentModel(el, value, modifiers);
        // component v-model doesn't need extra runtime
        return false;
    } else $69b5f56b6d1ac1d8$var$warn$1(`<${el.tag} v-model="${value}">: ` + `v-model is not supported on this element type. ` + "If you are working with contenteditable, it's recommended to " + 'wrap a library dedicated for that purpose inside a custom component.', el.rawAttrsMap['v-model']);
    // ensure runtime directive metadata
    return true;
}
function $69b5f56b6d1ac1d8$var$genCheckboxModel(el, value, modifiers) {
    const number = modifiers && modifiers.number;
    const valueBinding = $69b5f56b6d1ac1d8$var$getBindingAttr(el, 'value') || 'null';
    const trueValueBinding = $69b5f56b6d1ac1d8$var$getBindingAttr(el, 'true-value') || 'true';
    const falseValueBinding = $69b5f56b6d1ac1d8$var$getBindingAttr(el, 'false-value') || 'false';
    $69b5f56b6d1ac1d8$var$addProp(el, 'checked', `Array.isArray(${value})` + `?_i(${value},${valueBinding})>-1` + (trueValueBinding === 'true' ? `:(${value})` : `:_q(${value},${trueValueBinding})`));
    $69b5f56b6d1ac1d8$var$addHandler(el, 'change', `var $$a=${value},` + '$$el=$event.target,' + `$$c=$$el.checked?(${trueValueBinding}):(${falseValueBinding});` + 'if(Array.isArray($$a)){' + `var $$v=${number ? '_n(' + valueBinding + ')' : valueBinding},` + '$$i=_i($$a,$$v);' + `if($$el.checked){$$i<0&&(${$69b5f56b6d1ac1d8$var$genAssignmentCode(value, '$$a.concat([$$v])')})}` + `else{$$i>-1&&(${$69b5f56b6d1ac1d8$var$genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')})}` + `}else{${$69b5f56b6d1ac1d8$var$genAssignmentCode(value, '$$c')}}`, null, true);
}
function $69b5f56b6d1ac1d8$var$genRadioModel(el, value, modifiers) {
    const number = modifiers && modifiers.number;
    let valueBinding = $69b5f56b6d1ac1d8$var$getBindingAttr(el, 'value') || 'null';
    valueBinding = number ? `_n(${valueBinding})` : valueBinding;
    $69b5f56b6d1ac1d8$var$addProp(el, 'checked', `_q(${value},${valueBinding})`);
    $69b5f56b6d1ac1d8$var$addHandler(el, 'change', $69b5f56b6d1ac1d8$var$genAssignmentCode(value, valueBinding), null, true);
}
function $69b5f56b6d1ac1d8$var$genSelect(el, value, modifiers) {
    const number = modifiers && modifiers.number;
    const selectedVal = `Array.prototype.filter` + `.call($event.target.options,function(o){return o.selected})` + `.map(function(o){var val = "_value" in o ? o._value : o.value;` + `return ${number ? '_n(val)' : 'val'}})`;
    const assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
    let code = `var $$selectedVal = ${selectedVal};`;
    code = `${code} ${$69b5f56b6d1ac1d8$var$genAssignmentCode(value, assignment)}`;
    $69b5f56b6d1ac1d8$var$addHandler(el, 'change', code, null, true);
}
function $69b5f56b6d1ac1d8$var$genDefaultModel(el, value, modifiers) {
    const type = el.attrsMap.type;
    // warn if v-bind:value conflicts with v-model
    // except for inputs with v-bind:type
    {
        const value = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
        const typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
        if (value && !typeBinding) {
            const binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
            $69b5f56b6d1ac1d8$var$warn$1(`${binding}="${value}" conflicts with v-model on the same element ` + 'because the latter already expands to a value binding internally', el.rawAttrsMap[binding]);
        }
    }
    const { lazy: lazy, number: number, trim: trim } = modifiers || {};
    const needCompositionGuard = !lazy && type !== 'range';
    const event = lazy ? 'change' : type === 'range' ? $69b5f56b6d1ac1d8$var$RANGE_TOKEN : 'input';
    let valueExpression = '$event.target.value';
    if (trim) valueExpression = `$event.target.value.trim()`;
    if (number) valueExpression = `_n(${valueExpression})`;
    let code = $69b5f56b6d1ac1d8$var$genAssignmentCode(value, valueExpression);
    if (needCompositionGuard) code = `if($event.target.composing)return;${code}`;
    $69b5f56b6d1ac1d8$var$addProp(el, 'value', `(${value})`);
    $69b5f56b6d1ac1d8$var$addHandler(el, event, code, null, true);
    if (trim || number) $69b5f56b6d1ac1d8$var$addHandler(el, 'blur', '$forceUpdate()');
}
// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function $69b5f56b6d1ac1d8$var$normalizeEvents(on) {
    /* istanbul ignore if */ if ($69b5f56b6d1ac1d8$var$isDef(on[$69b5f56b6d1ac1d8$var$RANGE_TOKEN])) {
        // IE input[type=range] only supports `change` event
        const event = $69b5f56b6d1ac1d8$var$isIE ? 'change' : 'input';
        on[event] = [].concat(on[$69b5f56b6d1ac1d8$var$RANGE_TOKEN], on[event] || []);
        delete on[$69b5f56b6d1ac1d8$var$RANGE_TOKEN];
    }
    // This was originally intended to fix #4521 but no longer necessary
    // after 2.5. Keeping it for backwards compat with generated code from < 2.4
    /* istanbul ignore if */ if ($69b5f56b6d1ac1d8$var$isDef(on[$69b5f56b6d1ac1d8$var$CHECKBOX_RADIO_TOKEN])) {
        on.change = [].concat(on[$69b5f56b6d1ac1d8$var$CHECKBOX_RADIO_TOKEN], on.change || []);
        delete on[$69b5f56b6d1ac1d8$var$CHECKBOX_RADIO_TOKEN];
    }
}
let $69b5f56b6d1ac1d8$var$target;
function $69b5f56b6d1ac1d8$var$createOnceHandler(event, handler, capture) {
    const _target = $69b5f56b6d1ac1d8$var$target; // save current target element in closure
    return function onceHandler() {
        const res = handler.apply(null, arguments);
        if (res !== null) $69b5f56b6d1ac1d8$var$remove(event, onceHandler, capture, _target);
    };
}
// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
const $69b5f56b6d1ac1d8$var$useMicrotaskFix = $69b5f56b6d1ac1d8$var$isUsingMicroTask && !($69b5f56b6d1ac1d8$var$isFF && Number($69b5f56b6d1ac1d8$var$isFF[1]) <= 53);
function $69b5f56b6d1ac1d8$var$add(name, handler, capture, passive) {
    // async edge case #6566: inner click event triggers patch, event handler
    // attached to outer element during patch, and triggered again. This
    // happens because browsers fire microtask ticks between event propagation.
    // the solution is simple: we save the timestamp when a handler is attached,
    // and the handler would only fire if the event passed to it was fired
    // AFTER it was attached.
    if ($69b5f56b6d1ac1d8$var$useMicrotaskFix) {
        const attachedTimestamp = $69b5f56b6d1ac1d8$var$currentFlushTimestamp;
        const original = handler;
        //@ts-expect-error
        handler = original._wrapper = function(e) {
            if (// no bubbling, should always fire.
            // this is just a safety net in case event.timeStamp is unreliable in
            // certain weird environments...
            e.target === e.currentTarget || // event is fired after handler attachment
            e.timeStamp >= attachedTimestamp || // bail for environments that have buggy event.timeStamp implementations
            // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
            // #9681 QtWebEngine event.timeStamp is negative value
            e.timeStamp <= 0 || // #9448 bail if event is fired in another document in a multi-page
            // electron/nw.js app, since event.timeStamp will be using a different
            // starting reference
            e.target.ownerDocument !== document) return original.apply(this, arguments);
        };
    }
    $69b5f56b6d1ac1d8$var$target.addEventListener(name, handler, $69b5f56b6d1ac1d8$var$supportsPassive ? {
        capture: capture,
        passive: passive
    } : capture);
}
function $69b5f56b6d1ac1d8$var$remove(name, handler, capture, _target) {
    (_target || $69b5f56b6d1ac1d8$var$target).removeEventListener(name, //@ts-expect-error
    handler._wrapper || handler, capture);
}
function $69b5f56b6d1ac1d8$var$updateDOMListeners(oldVnode, vnode) {
    if ($69b5f56b6d1ac1d8$var$isUndef(oldVnode.data.on) && $69b5f56b6d1ac1d8$var$isUndef(vnode.data.on)) return;
    const on = vnode.data.on || {};
    const oldOn = oldVnode.data.on || {};
    // vnode is empty when removing all listeners,
    // and use old vnode dom element
    $69b5f56b6d1ac1d8$var$target = vnode.elm || oldVnode.elm;
    $69b5f56b6d1ac1d8$var$normalizeEvents(on);
    $69b5f56b6d1ac1d8$var$updateListeners(on, oldOn, $69b5f56b6d1ac1d8$var$add, $69b5f56b6d1ac1d8$var$remove, $69b5f56b6d1ac1d8$var$createOnceHandler, vnode.context);
    $69b5f56b6d1ac1d8$var$target = undefined;
}
var $69b5f56b6d1ac1d8$var$events = {
    create: $69b5f56b6d1ac1d8$var$updateDOMListeners,
    update: $69b5f56b6d1ac1d8$var$updateDOMListeners,
    // @ts-expect-error emptyNode has actually data
    destroy: (vnode)=>$69b5f56b6d1ac1d8$var$updateDOMListeners(vnode, $69b5f56b6d1ac1d8$var$emptyNode)
};
let $69b5f56b6d1ac1d8$var$svgContainer;
function $69b5f56b6d1ac1d8$var$updateDOMProps(oldVnode, vnode) {
    if ($69b5f56b6d1ac1d8$var$isUndef(oldVnode.data.domProps) && $69b5f56b6d1ac1d8$var$isUndef(vnode.data.domProps)) return;
    let key, cur;
    const elm = vnode.elm;
    const oldProps = oldVnode.data.domProps || {};
    let props = vnode.data.domProps || {};
    // clone observed objects, as the user probably wants to mutate it
    if ($69b5f56b6d1ac1d8$var$isDef(props.__ob__) || $69b5f56b6d1ac1d8$var$isTrue(props._v_attr_proxy)) props = vnode.data.domProps = $69b5f56b6d1ac1d8$var$extend({}, props);
    for(key in oldProps)if (!(key in props)) elm[key] = '';
    for(key in props){
        cur = props[key];
        // ignore children if the node has textContent or innerHTML,
        // as these will throw away existing DOM nodes and cause removal errors
        // on subsequent patches (#3360)
        if (key === 'textContent' || key === 'innerHTML') {
            if (vnode.children) vnode.children.length = 0;
            if (cur === oldProps[key]) continue;
            // #6601 work around Chrome version <= 55 bug where single textNode
            // replaced by innerHTML/textContent retains its parentNode property
            if (elm.childNodes.length === 1) elm.removeChild(elm.childNodes[0]);
        }
        if (key === 'value' && elm.tagName !== 'PROGRESS') {
            // store value as _value as well since
            // non-string values will be stringified
            elm._value = cur;
            // avoid resetting cursor position when value is the same
            const strCur = $69b5f56b6d1ac1d8$var$isUndef(cur) ? '' : String(cur);
            if ($69b5f56b6d1ac1d8$var$shouldUpdateValue(elm, strCur)) elm.value = strCur;
        } else if (key === 'innerHTML' && $69b5f56b6d1ac1d8$var$isSVG(elm.tagName) && $69b5f56b6d1ac1d8$var$isUndef(elm.innerHTML)) {
            // IE doesn't support innerHTML for SVG elements
            $69b5f56b6d1ac1d8$var$svgContainer = $69b5f56b6d1ac1d8$var$svgContainer || document.createElement('div');
            $69b5f56b6d1ac1d8$var$svgContainer.innerHTML = `<svg>${cur}</svg>`;
            const svg = $69b5f56b6d1ac1d8$var$svgContainer.firstChild;
            while(elm.firstChild)elm.removeChild(elm.firstChild);
            while(svg.firstChild)elm.appendChild(svg.firstChild);
        } else if (// skip the update if old and new VDOM state is the same.
        // `value` is handled separately because the DOM value may be temporarily
        // out of sync with VDOM state due to focus, composition and modifiers.
        // This  #4521 by skipping the unnecessary `checked` update.
        cur !== oldProps[key]) // some property updates can throw
        // e.g. `value` on <progress> w/ non-finite value
        try {
            elm[key] = cur;
        } catch (e) {}
    }
}
function $69b5f56b6d1ac1d8$var$shouldUpdateValue(elm, checkVal) {
    return(//@ts-expect-error
    !elm.composing && (elm.tagName === 'OPTION' || $69b5f56b6d1ac1d8$var$isNotInFocusAndDirty(elm, checkVal) || $69b5f56b6d1ac1d8$var$isDirtyWithModifiers(elm, checkVal)));
}
function $69b5f56b6d1ac1d8$var$isNotInFocusAndDirty(elm, checkVal) {
    // return true when textbox (.number and .trim) loses focus and its value is
    // not equal to the updated value
    let notInFocus = true;
    // #6157
    // work around IE bug when accessing document.activeElement in an iframe
    try {
        notInFocus = document.activeElement !== elm;
    } catch (e) {}
    return notInFocus && elm.value !== checkVal;
}
function $69b5f56b6d1ac1d8$var$isDirtyWithModifiers(elm, newVal1) {
    const value = elm.value;
    const modifiers = elm._vModifiers; // injected by v-model runtime
    if ($69b5f56b6d1ac1d8$var$isDef(modifiers)) {
        if (modifiers.number) return $69b5f56b6d1ac1d8$var$toNumber(value) !== $69b5f56b6d1ac1d8$var$toNumber(newVal1);
        if (modifiers.trim) return value.trim() !== newVal1.trim();
    }
    return value !== newVal1;
}
var $69b5f56b6d1ac1d8$var$domProps = {
    create: $69b5f56b6d1ac1d8$var$updateDOMProps,
    update: $69b5f56b6d1ac1d8$var$updateDOMProps
};
const $69b5f56b6d1ac1d8$var$parseStyleText = $69b5f56b6d1ac1d8$var$cached(function(cssText) {
    const res = {};
    const listDelimiter = /;(?![^(]*\))/g;
    const propertyDelimiter = /:(.+)/;
    cssText.split(listDelimiter).forEach(function(item) {
        if (item) {
            const tmp = item.split(propertyDelimiter);
            tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return res;
});
// merge static and dynamic style data on the same vnode
function $69b5f56b6d1ac1d8$var$normalizeStyleData(data) {
    const style = $69b5f56b6d1ac1d8$var$normalizeStyleBinding(data.style);
    // static style is pre-processed into an object during compilation
    // and is always a fresh object, so it's safe to merge into it
    return data.staticStyle ? $69b5f56b6d1ac1d8$var$extend(data.staticStyle, style) : style;
}
// normalize possible array / string values into Object
function $69b5f56b6d1ac1d8$var$normalizeStyleBinding(bindingStyle) {
    if (Array.isArray(bindingStyle)) return $69b5f56b6d1ac1d8$var$toObject(bindingStyle);
    if (typeof bindingStyle === 'string') return $69b5f56b6d1ac1d8$var$parseStyleText(bindingStyle);
    return bindingStyle;
}
/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */ function $69b5f56b6d1ac1d8$var$getStyle(vnode, checkChild) {
    const res = {};
    let styleData;
    if (checkChild) {
        let childNode = vnode;
        while(childNode.componentInstance){
            childNode = childNode.componentInstance._vnode;
            if (childNode && childNode.data && (styleData = $69b5f56b6d1ac1d8$var$normalizeStyleData(childNode.data))) $69b5f56b6d1ac1d8$var$extend(res, styleData);
        }
    }
    if (styleData = $69b5f56b6d1ac1d8$var$normalizeStyleData(vnode.data)) $69b5f56b6d1ac1d8$var$extend(res, styleData);
    let parentNode = vnode;
    // @ts-expect-error parentNode.parent not VNodeWithData
    while(parentNode = parentNode.parent)if (parentNode.data && (styleData = $69b5f56b6d1ac1d8$var$normalizeStyleData(parentNode.data))) $69b5f56b6d1ac1d8$var$extend(res, styleData);
    return res;
}
const $69b5f56b6d1ac1d8$var$cssVarRE = /^--/;
const $69b5f56b6d1ac1d8$var$importantRE = /\s*!important$/;
const $69b5f56b6d1ac1d8$var$setProp = (el, name, val)=>{
    /* istanbul ignore if */ if ($69b5f56b6d1ac1d8$var$cssVarRE.test(name)) el.style.setProperty(name, val);
    else if ($69b5f56b6d1ac1d8$var$importantRE.test(val)) el.style.setProperty($69b5f56b6d1ac1d8$var$hyphenate(name), val.replace($69b5f56b6d1ac1d8$var$importantRE, ''), 'important');
    else {
        const normalizedName = $69b5f56b6d1ac1d8$var$normalize(name);
        if (Array.isArray(val)) // Support values array created by autoprefixer, e.g.
        // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
        // Set them one by one, and the browser will only set those it can recognize
        for(let i = 0, len = val.length; i < len; i++)el.style[normalizedName] = val[i];
        else el.style[normalizedName] = val;
    }
};
const $69b5f56b6d1ac1d8$var$vendorNames = [
    'Webkit',
    'Moz',
    'ms'
];
let $69b5f56b6d1ac1d8$var$emptyStyle;
const $69b5f56b6d1ac1d8$var$normalize = $69b5f56b6d1ac1d8$var$cached(function(prop) {
    $69b5f56b6d1ac1d8$var$emptyStyle = $69b5f56b6d1ac1d8$var$emptyStyle || document.createElement('div').style;
    prop = $69b5f56b6d1ac1d8$var$camelize(prop);
    if (prop !== 'filter' && prop in $69b5f56b6d1ac1d8$var$emptyStyle) return prop;
    const capName = prop.charAt(0).toUpperCase() + prop.slice(1);
    for(let i = 0; i < $69b5f56b6d1ac1d8$var$vendorNames.length; i++){
        const name = $69b5f56b6d1ac1d8$var$vendorNames[i] + capName;
        if (name in $69b5f56b6d1ac1d8$var$emptyStyle) return name;
    }
});
function $69b5f56b6d1ac1d8$var$updateStyle(oldVnode, vnode) {
    const data = vnode.data;
    const oldData = oldVnode.data;
    if ($69b5f56b6d1ac1d8$var$isUndef(data.staticStyle) && $69b5f56b6d1ac1d8$var$isUndef(data.style) && $69b5f56b6d1ac1d8$var$isUndef(oldData.staticStyle) && $69b5f56b6d1ac1d8$var$isUndef(oldData.style)) return;
    let cur, name;
    const el = vnode.elm;
    const oldStaticStyle = oldData.staticStyle;
    const oldStyleBinding = oldData.normalizedStyle || oldData.style || {};
    // if static style exists, stylebinding already merged into it when doing normalizeStyleData
    const oldStyle = oldStaticStyle || oldStyleBinding;
    const style = $69b5f56b6d1ac1d8$var$normalizeStyleBinding(vnode.data.style) || {};
    // store normalized style under a different key for next diff
    // make sure to clone it if it's reactive, since the user likely wants
    // to mutate it.
    vnode.data.normalizedStyle = $69b5f56b6d1ac1d8$var$isDef(style.__ob__) ? $69b5f56b6d1ac1d8$var$extend({}, style) : style;
    const newStyle = $69b5f56b6d1ac1d8$var$getStyle(vnode, true);
    for(name in oldStyle)if ($69b5f56b6d1ac1d8$var$isUndef(newStyle[name])) $69b5f56b6d1ac1d8$var$setProp(el, name, '');
    for(name in newStyle){
        cur = newStyle[name];
        // ie9 setting to null has no effect, must use empty string
        $69b5f56b6d1ac1d8$var$setProp(el, name, cur == null ? '' : cur);
    }
}
var $69b5f56b6d1ac1d8$var$style$1 = {
    create: $69b5f56b6d1ac1d8$var$updateStyle,
    update: $69b5f56b6d1ac1d8$var$updateStyle
};
const $69b5f56b6d1ac1d8$var$whitespaceRE$1 = /\s+/;
/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */ function $69b5f56b6d1ac1d8$var$addClass(el, cls) {
    /* istanbul ignore if */ if (!cls || !(cls = cls.trim())) return;
    /* istanbul ignore else */ if (el.classList) {
        if (cls.indexOf(' ') > -1) cls.split($69b5f56b6d1ac1d8$var$whitespaceRE$1).forEach((c)=>el.classList.add(c));
        else el.classList.add(cls);
    } else {
        const cur = ` ${el.getAttribute('class') || ''} `;
        if (cur.indexOf(' ' + cls + ' ') < 0) el.setAttribute('class', (cur + cls).trim());
    }
}
/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */ function $69b5f56b6d1ac1d8$var$removeClass(el, cls) {
    /* istanbul ignore if */ if (!cls || !(cls = cls.trim())) return;
    /* istanbul ignore else */ if (el.classList) {
        if (cls.indexOf(' ') > -1) cls.split($69b5f56b6d1ac1d8$var$whitespaceRE$1).forEach((c)=>el.classList.remove(c));
        else el.classList.remove(cls);
        if (!el.classList.length) el.removeAttribute('class');
    } else {
        let cur = ` ${el.getAttribute('class') || ''} `;
        const tar = ' ' + cls + ' ';
        while(cur.indexOf(tar) >= 0)cur = cur.replace(tar, ' ');
        cur = cur.trim();
        if (cur) el.setAttribute('class', cur);
        else el.removeAttribute('class');
    }
}
function $69b5f56b6d1ac1d8$var$resolveTransition(def) {
    if (!def) return;
    /* istanbul ignore else */ if (typeof def === 'object') {
        const res = {};
        if (def.css !== false) $69b5f56b6d1ac1d8$var$extend(res, $69b5f56b6d1ac1d8$var$autoCssTransition(def.name || 'v'));
        $69b5f56b6d1ac1d8$var$extend(res, def);
        return res;
    } else if (typeof def === 'string') return $69b5f56b6d1ac1d8$var$autoCssTransition(def);
}
const $69b5f56b6d1ac1d8$var$autoCssTransition = $69b5f56b6d1ac1d8$var$cached((name)=>{
    return {
        enterClass: `${name}-enter`,
        enterToClass: `${name}-enter-to`,
        enterActiveClass: `${name}-enter-active`,
        leaveClass: `${name}-leave`,
        leaveToClass: `${name}-leave-to`,
        leaveActiveClass: `${name}-leave-active`
    };
});
const $69b5f56b6d1ac1d8$var$hasTransition = $69b5f56b6d1ac1d8$var$inBrowser && !$69b5f56b6d1ac1d8$var$isIE9;
const $69b5f56b6d1ac1d8$var$TRANSITION = 'transition';
const $69b5f56b6d1ac1d8$var$ANIMATION = 'animation';
// Transition property/event sniffing
let $69b5f56b6d1ac1d8$var$transitionProp = 'transition';
let $69b5f56b6d1ac1d8$var$transitionEndEvent = 'transitionend';
let $69b5f56b6d1ac1d8$var$animationProp = 'animation';
let $69b5f56b6d1ac1d8$var$animationEndEvent = 'animationend';
if ($69b5f56b6d1ac1d8$var$hasTransition) {
    /* istanbul ignore if */ if (window.ontransitionend === undefined && window.onwebkittransitionend !== undefined) {
        $69b5f56b6d1ac1d8$var$transitionProp = 'WebkitTransition';
        $69b5f56b6d1ac1d8$var$transitionEndEvent = 'webkitTransitionEnd';
    }
    if (window.onanimationend === undefined && window.onwebkitanimationend !== undefined) {
        $69b5f56b6d1ac1d8$var$animationProp = 'WebkitAnimation';
        $69b5f56b6d1ac1d8$var$animationEndEvent = 'webkitAnimationEnd';
    }
}
// binding to window is necessary to make hot reload work in IE in strict mode
const $69b5f56b6d1ac1d8$var$raf = $69b5f56b6d1ac1d8$var$inBrowser ? window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : setTimeout : /* istanbul ignore next */ /* istanbul ignore next */ (fn)=>fn();
function $69b5f56b6d1ac1d8$var$nextFrame(fn) {
    $69b5f56b6d1ac1d8$var$raf(()=>{
        // @ts-expect-error
        $69b5f56b6d1ac1d8$var$raf(fn);
    });
}
function $69b5f56b6d1ac1d8$var$addTransitionClass(el, cls) {
    const transitionClasses = el._transitionClasses || (el._transitionClasses = []);
    if (transitionClasses.indexOf(cls) < 0) {
        transitionClasses.push(cls);
        $69b5f56b6d1ac1d8$var$addClass(el, cls);
    }
}
function $69b5f56b6d1ac1d8$var$removeTransitionClass(el, cls) {
    if (el._transitionClasses) $69b5f56b6d1ac1d8$var$remove$2(el._transitionClasses, cls);
    $69b5f56b6d1ac1d8$var$removeClass(el, cls);
}
function $69b5f56b6d1ac1d8$var$whenTransitionEnds(el, expectedType, cb) {
    const { type: type, timeout: timeout, propCount: propCount } = $69b5f56b6d1ac1d8$var$getTransitionInfo(el, expectedType);
    if (!type) return cb();
    const event = type === $69b5f56b6d1ac1d8$var$TRANSITION ? $69b5f56b6d1ac1d8$var$transitionEndEvent : $69b5f56b6d1ac1d8$var$animationEndEvent;
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(event, onEnd);
        cb();
    };
    const onEnd = (e)=>{
        if (e.target === el) {
            if (++ended >= propCount) end();
        }
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(event, onEnd);
}
const $69b5f56b6d1ac1d8$var$transformRE = /\b(transform|all)(,|$)/;
function $69b5f56b6d1ac1d8$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    // JSDOM may return undefined for transition properties
    const transitionDelays = (styles[$69b5f56b6d1ac1d8$var$transitionProp + 'Delay'] || '').split(', ');
    const transitionDurations = (styles[$69b5f56b6d1ac1d8$var$transitionProp + 'Duration'] || '').split(', ');
    const transitionTimeout = $69b5f56b6d1ac1d8$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = (styles[$69b5f56b6d1ac1d8$var$animationProp + 'Delay'] || '').split(', ');
    const animationDurations = (styles[$69b5f56b6d1ac1d8$var$animationProp + 'Duration'] || '').split(', ');
    const animationTimeout = $69b5f56b6d1ac1d8$var$getTimeout(animationDelays, animationDurations);
    let type;
    let timeout = 0;
    let propCount = 0;
    /* istanbul ignore if */ if (expectedType === $69b5f56b6d1ac1d8$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $69b5f56b6d1ac1d8$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $69b5f56b6d1ac1d8$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $69b5f56b6d1ac1d8$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $69b5f56b6d1ac1d8$var$TRANSITION : $69b5f56b6d1ac1d8$var$ANIMATION : null;
        propCount = type ? type === $69b5f56b6d1ac1d8$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $69b5f56b6d1ac1d8$var$TRANSITION && $69b5f56b6d1ac1d8$var$transformRE.test(styles[$69b5f56b6d1ac1d8$var$transitionProp + 'Property']);
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $69b5f56b6d1ac1d8$var$getTimeout(delays, durations) {
    /* istanbul ignore next */ while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max.apply(null, durations.map((d, i)=>{
        return $69b5f56b6d1ac1d8$var$toMs(d) + $69b5f56b6d1ac1d8$var$toMs(delays[i]);
    }));
}
// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function $69b5f56b6d1ac1d8$var$toMs(s) {
    return Number(s.slice(0, -1).replace(',', '.')) * 1000;
}
function $69b5f56b6d1ac1d8$var$enter(vnode, toggleDisplay) {
    const el = vnode.elm;
    // call leave callback now
    if ($69b5f56b6d1ac1d8$var$isDef(el._leaveCb)) {
        el._leaveCb.cancelled = true;
        el._leaveCb();
    }
    const data = $69b5f56b6d1ac1d8$var$resolveTransition(vnode.data.transition);
    if ($69b5f56b6d1ac1d8$var$isUndef(data)) return;
    /* istanbul ignore if */ if ($69b5f56b6d1ac1d8$var$isDef(el._enterCb) || el.nodeType !== 1) return;
    const { css: css, type: type, enterClass: enterClass, enterToClass: enterToClass, enterActiveClass: enterActiveClass, appearClass: appearClass, appearToClass: appearToClass, appearActiveClass: appearActiveClass, beforeEnter: beforeEnter, enter: enter, afterEnter: afterEnter, enterCancelled: enterCancelled, beforeAppear: beforeAppear, appear: appear, afterAppear: afterAppear, appearCancelled: appearCancelled, duration: duration } = data;
    // activeInstance will always be the <transition> component managing this
    // transition. One edge case to check is when the <transition> is placed
    // as the root node of a child component. In that case we need to check
    // <transition>'s parent for appear check.
    let context = $69b5f56b6d1ac1d8$var$activeInstance;
    let transitionNode = $69b5f56b6d1ac1d8$var$activeInstance.$vnode;
    while(transitionNode && transitionNode.parent){
        context = transitionNode.context;
        transitionNode = transitionNode.parent;
    }
    const isAppear = !context._isMounted || !vnode.isRootInsert;
    if (isAppear && !appear && appear !== '') return;
    const startClass = isAppear && appearClass ? appearClass : enterClass;
    const activeClass = isAppear && appearActiveClass ? appearActiveClass : enterActiveClass;
    const toClass = isAppear && appearToClass ? appearToClass : enterToClass;
    const beforeEnterHook = isAppear ? beforeAppear || beforeEnter : beforeEnter;
    const enterHook = isAppear ? $69b5f56b6d1ac1d8$var$isFunction(appear) ? appear : enter : enter;
    const afterEnterHook = isAppear ? afterAppear || afterEnter : afterEnter;
    const enterCancelledHook = isAppear ? appearCancelled || enterCancelled : enterCancelled;
    const explicitEnterDuration = $69b5f56b6d1ac1d8$var$toNumber($69b5f56b6d1ac1d8$var$isObject(duration) ? duration.enter : duration);
    if (explicitEnterDuration != null) $69b5f56b6d1ac1d8$var$checkDuration(explicitEnterDuration, 'enter', vnode);
    const expectsCSS = css !== false && !$69b5f56b6d1ac1d8$var$isIE9;
    const userWantsControl = $69b5f56b6d1ac1d8$var$getHookArgumentsLength(enterHook);
    const cb = el._enterCb = $69b5f56b6d1ac1d8$var$once(()=>{
        if (expectsCSS) {
            $69b5f56b6d1ac1d8$var$removeTransitionClass(el, toClass);
            $69b5f56b6d1ac1d8$var$removeTransitionClass(el, activeClass);
        }
        // @ts-expect-error
        if (cb.cancelled) {
            if (expectsCSS) $69b5f56b6d1ac1d8$var$removeTransitionClass(el, startClass);
            enterCancelledHook && enterCancelledHook(el);
        } else afterEnterHook && afterEnterHook(el);
        el._enterCb = null;
    });
    if (!vnode.data.show) // remove pending leave element on enter by injecting an insert hook
    $69b5f56b6d1ac1d8$var$mergeVNodeHook(vnode, 'insert', ()=>{
        const parent = el.parentNode;
        const pendingNode = parent && parent._pending && parent._pending[vnode.key];
        if (pendingNode && pendingNode.tag === vnode.tag && pendingNode.elm._leaveCb) pendingNode.elm._leaveCb();
        enterHook && enterHook(el, cb);
    });
    // start enter transition
    beforeEnterHook && beforeEnterHook(el);
    if (expectsCSS) {
        $69b5f56b6d1ac1d8$var$addTransitionClass(el, startClass);
        $69b5f56b6d1ac1d8$var$addTransitionClass(el, activeClass);
        $69b5f56b6d1ac1d8$var$nextFrame(()=>{
            $69b5f56b6d1ac1d8$var$removeTransitionClass(el, startClass);
            // @ts-expect-error
            if (!cb.cancelled) {
                $69b5f56b6d1ac1d8$var$addTransitionClass(el, toClass);
                if (!userWantsControl) {
                    if ($69b5f56b6d1ac1d8$var$isValidDuration(explicitEnterDuration)) setTimeout(cb, explicitEnterDuration);
                    else $69b5f56b6d1ac1d8$var$whenTransitionEnds(el, type, cb);
                }
            }
        });
    }
    if (vnode.data.show) {
        toggleDisplay && toggleDisplay();
        enterHook && enterHook(el, cb);
    }
    if (!expectsCSS && !userWantsControl) cb();
}
function $69b5f56b6d1ac1d8$var$leave(vnode, rm) {
    const el = vnode.elm;
    // call enter callback now
    if ($69b5f56b6d1ac1d8$var$isDef(el._enterCb)) {
        el._enterCb.cancelled = true;
        el._enterCb();
    }
    const data = $69b5f56b6d1ac1d8$var$resolveTransition(vnode.data.transition);
    if ($69b5f56b6d1ac1d8$var$isUndef(data) || el.nodeType !== 1) return rm();
    /* istanbul ignore if */ if ($69b5f56b6d1ac1d8$var$isDef(el._leaveCb)) return;
    const { css: css, type: type, leaveClass: leaveClass, leaveToClass: leaveToClass, leaveActiveClass: leaveActiveClass, beforeLeave: beforeLeave, leave: leave, afterLeave: afterLeave, leaveCancelled: leaveCancelled, delayLeave: delayLeave, duration: duration } = data;
    const expectsCSS = css !== false && !$69b5f56b6d1ac1d8$var$isIE9;
    const userWantsControl = $69b5f56b6d1ac1d8$var$getHookArgumentsLength(leave);
    const explicitLeaveDuration = $69b5f56b6d1ac1d8$var$toNumber($69b5f56b6d1ac1d8$var$isObject(duration) ? duration.leave : duration);
    if ($69b5f56b6d1ac1d8$var$isDef(explicitLeaveDuration)) $69b5f56b6d1ac1d8$var$checkDuration(explicitLeaveDuration, 'leave', vnode);
    const cb = el._leaveCb = $69b5f56b6d1ac1d8$var$once(()=>{
        if (el.parentNode && el.parentNode._pending) el.parentNode._pending[vnode.key] = null;
        if (expectsCSS) {
            $69b5f56b6d1ac1d8$var$removeTransitionClass(el, leaveToClass);
            $69b5f56b6d1ac1d8$var$removeTransitionClass(el, leaveActiveClass);
        }
        // @ts-expect-error
        if (cb.cancelled) {
            if (expectsCSS) $69b5f56b6d1ac1d8$var$removeTransitionClass(el, leaveClass);
            leaveCancelled && leaveCancelled(el);
        } else {
            rm();
            afterLeave && afterLeave(el);
        }
        el._leaveCb = null;
    });
    if (delayLeave) delayLeave(performLeave);
    else performLeave();
    function performLeave() {
        // the delayed leave may have already been cancelled
        // @ts-expect-error
        if (cb.cancelled) return;
        // record leaving element
        if (!vnode.data.show && el.parentNode) (el.parentNode._pending || (el.parentNode._pending = {}))[vnode.key] = vnode;
        beforeLeave && beforeLeave(el);
        if (expectsCSS) {
            $69b5f56b6d1ac1d8$var$addTransitionClass(el, leaveClass);
            $69b5f56b6d1ac1d8$var$addTransitionClass(el, leaveActiveClass);
            $69b5f56b6d1ac1d8$var$nextFrame(()=>{
                $69b5f56b6d1ac1d8$var$removeTransitionClass(el, leaveClass);
                // @ts-expect-error
                if (!cb.cancelled) {
                    $69b5f56b6d1ac1d8$var$addTransitionClass(el, leaveToClass);
                    if (!userWantsControl) {
                        if ($69b5f56b6d1ac1d8$var$isValidDuration(explicitLeaveDuration)) setTimeout(cb, explicitLeaveDuration);
                        else $69b5f56b6d1ac1d8$var$whenTransitionEnds(el, type, cb);
                    }
                }
            });
        }
        leave && leave(el, cb);
        if (!expectsCSS && !userWantsControl) cb();
    }
}
// only used in dev mode
function $69b5f56b6d1ac1d8$var$checkDuration(val, name, vnode) {
    if (typeof val !== 'number') $69b5f56b6d1ac1d8$var$warn$2(`<transition> explicit ${name} duration is not a valid number - ` + `got ${JSON.stringify(val)}.`, vnode.context);
    else if (isNaN(val)) $69b5f56b6d1ac1d8$var$warn$2(`<transition> explicit ${name} duration is NaN - ` + 'the duration expression might be incorrect.', vnode.context);
}
function $69b5f56b6d1ac1d8$var$isValidDuration(val) {
    return typeof val === 'number' && !isNaN(val);
}
/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */ function $69b5f56b6d1ac1d8$var$getHookArgumentsLength(fn) {
    if ($69b5f56b6d1ac1d8$var$isUndef(fn)) return false;
    // @ts-expect-error
    const invokerFns = fn.fns;
    if ($69b5f56b6d1ac1d8$var$isDef(invokerFns)) // invoker
    return $69b5f56b6d1ac1d8$var$getHookArgumentsLength(Array.isArray(invokerFns) ? invokerFns[0] : invokerFns);
    else // @ts-expect-error
    return (fn._length || fn.length) > 1;
}
function $69b5f56b6d1ac1d8$var$_enter(_, vnode) {
    if (vnode.data.show !== true) $69b5f56b6d1ac1d8$var$enter(vnode);
}
var $69b5f56b6d1ac1d8$var$transition = $69b5f56b6d1ac1d8$var$inBrowser ? {
    create: $69b5f56b6d1ac1d8$var$_enter,
    activate: $69b5f56b6d1ac1d8$var$_enter,
    remove (vnode, rm) {
        /* istanbul ignore else */ if (vnode.data.show !== true) // @ts-expect-error
        $69b5f56b6d1ac1d8$var$leave(vnode, rm);
        else rm();
    }
} : {};
var $69b5f56b6d1ac1d8$var$platformModules = [
    $69b5f56b6d1ac1d8$var$attrs,
    $69b5f56b6d1ac1d8$var$klass$1,
    $69b5f56b6d1ac1d8$var$events,
    $69b5f56b6d1ac1d8$var$domProps,
    $69b5f56b6d1ac1d8$var$style$1,
    $69b5f56b6d1ac1d8$var$transition
];
// the directive module should be applied last, after all
// built-in modules have been applied.
const $69b5f56b6d1ac1d8$var$modules$1 = $69b5f56b6d1ac1d8$var$platformModules.concat($69b5f56b6d1ac1d8$var$baseModules);
const $69b5f56b6d1ac1d8$var$patch = $69b5f56b6d1ac1d8$var$createPatchFunction({
    nodeOps: $69b5f56b6d1ac1d8$var$nodeOps,
    modules: $69b5f56b6d1ac1d8$var$modules$1
});
/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */ /* istanbul ignore if */ if ($69b5f56b6d1ac1d8$var$isIE9) // http://www.matts411.com/post/internet-explorer-9-oninput/
document.addEventListener('selectionchange', ()=>{
    const el = document.activeElement;
    // @ts-expect-error
    if (el && el.vmodel) $69b5f56b6d1ac1d8$var$trigger(el, 'input');
});
const $69b5f56b6d1ac1d8$var$directive = {
    inserted (el, binding, vnode, oldVnode) {
        if (vnode.tag === 'select') {
            // #6903
            if (oldVnode.elm && !oldVnode.elm._vOptions) $69b5f56b6d1ac1d8$var$mergeVNodeHook(vnode, 'postpatch', ()=>{
                $69b5f56b6d1ac1d8$var$directive.componentUpdated(el, binding, vnode);
            });
            else $69b5f56b6d1ac1d8$var$setSelected(el, binding, vnode.context);
            el._vOptions = [].map.call(el.options, $69b5f56b6d1ac1d8$var$getValue);
        } else if (vnode.tag === 'textarea' || $69b5f56b6d1ac1d8$var$isTextInputType(el.type)) {
            el._vModifiers = binding.modifiers;
            if (!binding.modifiers.lazy) {
                el.addEventListener('compositionstart', $69b5f56b6d1ac1d8$var$onCompositionStart);
                el.addEventListener('compositionend', $69b5f56b6d1ac1d8$var$onCompositionEnd);
                // Safari < 10.2 & UIWebView doesn't fire compositionend when
                // switching focus before confirming composition choice
                // this also fixes the issue where some browsers e.g. iOS Chrome
                // fires "change" instead of "input" on autocomplete.
                el.addEventListener('change', $69b5f56b6d1ac1d8$var$onCompositionEnd);
                /* istanbul ignore if */ if ($69b5f56b6d1ac1d8$var$isIE9) el.vmodel = true;
            }
        }
    },
    componentUpdated (el, binding, vnode) {
        if (vnode.tag === 'select') {
            $69b5f56b6d1ac1d8$var$setSelected(el, binding, vnode.context);
            // in case the options rendered by v-for have changed,
            // it's possible that the value is out-of-sync with the rendered options.
            // detect such cases and filter out values that no longer has a matching
            // option in the DOM.
            const prevOptions = el._vOptions;
            const curOptions = el._vOptions = [].map.call(el.options, $69b5f56b6d1ac1d8$var$getValue);
            if (curOptions.some((o, i)=>!$69b5f56b6d1ac1d8$var$looseEqual(o, prevOptions[i]))) {
                // trigger change event if
                // no matching option found for at least one value
                const needReset = el.multiple ? binding.value.some((v)=>$69b5f56b6d1ac1d8$var$hasNoMatchingOption(v, curOptions)) : binding.value !== binding.oldValue && $69b5f56b6d1ac1d8$var$hasNoMatchingOption(binding.value, curOptions);
                if (needReset) $69b5f56b6d1ac1d8$var$trigger(el, 'change');
            }
        }
    }
};
function $69b5f56b6d1ac1d8$var$setSelected(el, binding, vm) {
    $69b5f56b6d1ac1d8$var$actuallySetSelected(el, binding, vm);
    /* istanbul ignore if */ if ($69b5f56b6d1ac1d8$var$isIE || $69b5f56b6d1ac1d8$var$isEdge) setTimeout(()=>{
        $69b5f56b6d1ac1d8$var$actuallySetSelected(el, binding, vm);
    }, 0);
}
function $69b5f56b6d1ac1d8$var$actuallySetSelected(el, binding, vm) {
    const value = binding.value;
    const isMultiple = el.multiple;
    if (isMultiple && !Array.isArray(value)) {
        $69b5f56b6d1ac1d8$var$warn$2(`<select multiple v-model="${binding.expression}"> ` + `expects an Array value for its binding, but got ${Object.prototype.toString.call(value).slice(8, -1)}`, vm);
        return;
    }
    let selected, option;
    for(let i = 0, l = el.options.length; i < l; i++){
        option = el.options[i];
        if (isMultiple) {
            selected = $69b5f56b6d1ac1d8$var$looseIndexOf(value, $69b5f56b6d1ac1d8$var$getValue(option)) > -1;
            if (option.selected !== selected) option.selected = selected;
        } else if ($69b5f56b6d1ac1d8$var$looseEqual($69b5f56b6d1ac1d8$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple) el.selectedIndex = -1;
}
function $69b5f56b6d1ac1d8$var$hasNoMatchingOption(value, options) {
    return options.every((o)=>!$69b5f56b6d1ac1d8$var$looseEqual(o, value));
}
function $69b5f56b6d1ac1d8$var$getValue(option) {
    return '_value' in option ? option._value : option.value;
}
function $69b5f56b6d1ac1d8$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $69b5f56b6d1ac1d8$var$onCompositionEnd(e) {
    // prevent triggering an input event for no reason
    if (!e.target.composing) return;
    e.target.composing = false;
    $69b5f56b6d1ac1d8$var$trigger(e.target, 'input');
}
function $69b5f56b6d1ac1d8$var$trigger(el, type) {
    const e = document.createEvent('HTMLEvents');
    e.initEvent(type, true, true);
    el.dispatchEvent(e);
}
// recursively search for possible transition defined inside the component root
function $69b5f56b6d1ac1d8$var$locateNode(vnode) {
    // @ts-expect-error
    return vnode.componentInstance && (!vnode.data || !vnode.data.transition) ? $69b5f56b6d1ac1d8$var$locateNode(vnode.componentInstance._vnode) : vnode;
}
var $69b5f56b6d1ac1d8$var$show = {
    bind (el, { value: value }, vnode) {
        vnode = $69b5f56b6d1ac1d8$var$locateNode(vnode);
        const transition = vnode.data && vnode.data.transition;
        const originalDisplay = el.__vOriginalDisplay = el.style.display === 'none' ? '' : el.style.display;
        if (value && transition) {
            vnode.data.show = true;
            $69b5f56b6d1ac1d8$var$enter(vnode, ()=>{
                el.style.display = originalDisplay;
            });
        } else el.style.display = value ? originalDisplay : 'none';
    },
    update (el, { value: value, oldValue: oldValue }, vnode) {
        /* istanbul ignore if */ if (!value === !oldValue) return;
        vnode = $69b5f56b6d1ac1d8$var$locateNode(vnode);
        const transition = vnode.data && vnode.data.transition;
        if (transition) {
            vnode.data.show = true;
            if (value) $69b5f56b6d1ac1d8$var$enter(vnode, ()=>{
                el.style.display = el.__vOriginalDisplay;
            });
            else $69b5f56b6d1ac1d8$var$leave(vnode, ()=>{
                el.style.display = 'none';
            });
        } else el.style.display = value ? el.__vOriginalDisplay : 'none';
    },
    unbind (el, binding, vnode, oldVnode, isDestroy) {
        if (!isDestroy) el.style.display = el.__vOriginalDisplay;
    }
};
var $69b5f56b6d1ac1d8$var$platformDirectives = {
    model: $69b5f56b6d1ac1d8$var$directive,
    show: $69b5f56b6d1ac1d8$var$show
};
// Provides transition support for a single element/component.
const $69b5f56b6d1ac1d8$var$transitionProps = {
    name: String,
    appear: Boolean,
    css: Boolean,
    mode: String,
    type: String,
    enterClass: String,
    leaveClass: String,
    enterToClass: String,
    leaveToClass: String,
    enterActiveClass: String,
    leaveActiveClass: String,
    appearClass: String,
    appearActiveClass: String,
    appearToClass: String,
    duration: [
        Number,
        String,
        Object
    ]
};
// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function $69b5f56b6d1ac1d8$var$getRealChild(vnode) {
    const compOptions = vnode && vnode.componentOptions;
    if (compOptions && compOptions.Ctor.options.abstract) return $69b5f56b6d1ac1d8$var$getRealChild($69b5f56b6d1ac1d8$var$getFirstComponentChild(compOptions.children));
    else return vnode;
}
function $69b5f56b6d1ac1d8$var$extractTransitionData(comp) {
    const data = {};
    const options = comp.$options;
    // props
    for(const key in options.propsData)data[key] = comp[key];
    // events.
    // extract listeners and pass them directly to the transition methods
    const listeners = options._parentListeners;
    for(const key in listeners)data[$69b5f56b6d1ac1d8$var$camelize(key)] = listeners[key];
    return data;
}
function $69b5f56b6d1ac1d8$var$placeholder(h, rawChild) {
    // @ts-expect-error
    if (/\d-keep-alive$/.test(rawChild.tag)) return h('keep-alive', {
        props: rawChild.componentOptions.propsData
    });
}
function $69b5f56b6d1ac1d8$var$hasParentTransition(vnode) {
    while(vnode = vnode.parent){
        if (vnode.data.transition) return true;
    }
}
function $69b5f56b6d1ac1d8$var$isSameChild(child, oldChild) {
    return oldChild.key === child.key && oldChild.tag === child.tag;
}
const $69b5f56b6d1ac1d8$var$isNotTextNode = (c)=>c.tag || $69b5f56b6d1ac1d8$var$isAsyncPlaceholder(c);
const $69b5f56b6d1ac1d8$var$isVShowDirective = (d)=>d.name === 'show';
var $69b5f56b6d1ac1d8$var$Transition = {
    name: 'transition',
    props: $69b5f56b6d1ac1d8$var$transitionProps,
    abstract: true,
    render (h) {
        let children = this.$slots.default;
        if (!children) return;
        // filter out text nodes (possible whitespaces)
        children = children.filter($69b5f56b6d1ac1d8$var$isNotTextNode);
        /* istanbul ignore if */ if (!children.length) return;
        // warn multiple elements
        if (children.length > 1) $69b5f56b6d1ac1d8$var$warn$2("<transition> can only be used on a single element. Use <transition-group> for lists.", this.$parent);
        const mode = this.mode;
        // warn invalid mode
        if (mode && mode !== 'in-out' && mode !== 'out-in') $69b5f56b6d1ac1d8$var$warn$2('invalid <transition> mode: ' + mode, this.$parent);
        const rawChild = children[0];
        // if this is a component root node and the component's
        // parent container node also has transition, skip.
        if ($69b5f56b6d1ac1d8$var$hasParentTransition(this.$vnode)) return rawChild;
        // apply transition data to child
        // use getRealChild() to ignore abstract components e.g. keep-alive
        const child = $69b5f56b6d1ac1d8$var$getRealChild(rawChild);
        /* istanbul ignore if */ if (!child) return rawChild;
        if (this._leaving) return $69b5f56b6d1ac1d8$var$placeholder(h, rawChild);
        // ensure a key that is unique to the vnode type and to this transition
        // component instance. This key will be used to remove pending leaving nodes
        // during entering.
        const id = `__transition-${this._uid}-`;
        child.key = child.key == null ? child.isComment ? id + 'comment' : id + child.tag : $69b5f56b6d1ac1d8$var$isPrimitive(child.key) ? String(child.key).indexOf(id) === 0 ? child.key : id + child.key : child.key;
        const data = (child.data || (child.data = {})).transition = $69b5f56b6d1ac1d8$var$extractTransitionData(this);
        const oldRawChild = this._vnode;
        const oldChild = $69b5f56b6d1ac1d8$var$getRealChild(oldRawChild);
        // mark v-show
        // so that the transition module can hand over the control to the directive
        if (child.data.directives && child.data.directives.some($69b5f56b6d1ac1d8$var$isVShowDirective)) child.data.show = true;
        if (oldChild && oldChild.data && !$69b5f56b6d1ac1d8$var$isSameChild(child, oldChild) && !$69b5f56b6d1ac1d8$var$isAsyncPlaceholder(oldChild) && // #6687 component root is a comment node
        !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)) {
            // replace old child transition data with fresh one
            // important for dynamic transitions!
            const oldData = oldChild.data.transition = $69b5f56b6d1ac1d8$var$extend({}, data);
            // handle transition mode
            if (mode === 'out-in') {
                // return placeholder node and queue update when leave finishes
                this._leaving = true;
                $69b5f56b6d1ac1d8$var$mergeVNodeHook(oldData, 'afterLeave', ()=>{
                    this._leaving = false;
                    this.$forceUpdate();
                });
                return $69b5f56b6d1ac1d8$var$placeholder(h, rawChild);
            } else if (mode === 'in-out') {
                if ($69b5f56b6d1ac1d8$var$isAsyncPlaceholder(child)) return oldRawChild;
                let delayedLeave;
                const performLeave = ()=>{
                    delayedLeave();
                };
                $69b5f56b6d1ac1d8$var$mergeVNodeHook(data, 'afterEnter', performLeave);
                $69b5f56b6d1ac1d8$var$mergeVNodeHook(data, 'enterCancelled', performLeave);
                $69b5f56b6d1ac1d8$var$mergeVNodeHook(oldData, 'delayLeave', (leave)=>{
                    delayedLeave = leave;
                });
            }
        }
        return rawChild;
    }
};
// Provides transition support for list items.
const $69b5f56b6d1ac1d8$var$props = $69b5f56b6d1ac1d8$var$extend({
    tag: String,
    moveClass: String
}, $69b5f56b6d1ac1d8$var$transitionProps);
delete $69b5f56b6d1ac1d8$var$props.mode;
var $69b5f56b6d1ac1d8$var$TransitionGroup = {
    props: $69b5f56b6d1ac1d8$var$props,
    beforeMount () {
        const update = this._update;
        this._update = (vnode, hydrating)=>{
            const restoreActiveInstance = $69b5f56b6d1ac1d8$var$setActiveInstance(this);
            // force removing pass
            this.__patch__(this._vnode, this.kept, false, true // removeOnly (!important, avoids unnecessary moves)
            );
            this._vnode = this.kept;
            restoreActiveInstance();
            update.call(this, vnode, hydrating);
        };
    },
    render (h) {
        const tag = this.tag || this.$vnode.data.tag || 'span';
        const map = Object.create(null);
        const prevChildren = this.prevChildren = this.children;
        const rawChildren = this.$slots.default || [];
        const children = this.children = [];
        const transitionData = $69b5f56b6d1ac1d8$var$extractTransitionData(this);
        for(let i = 0; i < rawChildren.length; i++){
            const c = rawChildren[i];
            if (c.tag) {
                if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
                    children.push(c);
                    map[c.key] = c;
                    (c.data || (c.data = {})).transition = transitionData;
                } else {
                    const opts = c.componentOptions;
                    const name = opts ? $69b5f56b6d1ac1d8$var$getComponentName(opts.Ctor.options) || opts.tag || '' : c.tag;
                    $69b5f56b6d1ac1d8$var$warn$2(`<transition-group> children must be keyed: <${name}>`);
                }
            }
        }
        if (prevChildren) {
            const kept = [];
            const removed = [];
            for(let i = 0; i < prevChildren.length; i++){
                const c = prevChildren[i];
                c.data.transition = transitionData;
                // @ts-expect-error .getBoundingClientRect is not typed in Node
                c.data.pos = c.elm.getBoundingClientRect();
                if (map[c.key]) kept.push(c);
                else removed.push(c);
            }
            this.kept = h(tag, null, kept);
            this.removed = removed;
        }
        return h(tag, null, children);
    },
    updated () {
        const children = this.prevChildren;
        const moveClass = this.moveClass || (this.name || 'v') + '-move';
        if (!children.length || !this.hasMove(children[0].elm, moveClass)) return;
        // we divide the work into three loops to avoid mixing DOM reads and writes
        // in each iteration - which helps prevent layout thrashing.
        children.forEach($69b5f56b6d1ac1d8$var$callPendingCbs);
        children.forEach($69b5f56b6d1ac1d8$var$recordPosition);
        children.forEach($69b5f56b6d1ac1d8$var$applyTranslation);
        // force reflow to put everything in position
        // assign to this to avoid being removed in tree-shaking
        // $flow-disable-line
        this._reflow = document.body.offsetHeight;
        children.forEach((c)=>{
            if (c.data.moved) {
                const el = c.elm;
                const s = el.style;
                $69b5f56b6d1ac1d8$var$addTransitionClass(el, moveClass);
                s.transform = s.WebkitTransform = s.transitionDuration = '';
                el.addEventListener($69b5f56b6d1ac1d8$var$transitionEndEvent, el._moveCb = function cb(e) {
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener($69b5f56b6d1ac1d8$var$transitionEndEvent, cb);
                        el._moveCb = null;
                        $69b5f56b6d1ac1d8$var$removeTransitionClass(el, moveClass);
                    }
                });
            }
        });
    },
    methods: {
        hasMove (el, moveClass) {
            /* istanbul ignore if */ if (!$69b5f56b6d1ac1d8$var$hasTransition) return false;
            /* istanbul ignore if */ if (this._hasMove) return this._hasMove;
            // Detect whether an element with the move class applied has
            // CSS transitions. Since the element may be inside an entering
            // transition at this very moment, we make a clone of it and remove
            // all other transition classes applied to ensure only the move class
            // is applied.
            const clone = el.cloneNode();
            if (el._transitionClasses) el._transitionClasses.forEach((cls)=>{
                $69b5f56b6d1ac1d8$var$removeClass(clone, cls);
            });
            $69b5f56b6d1ac1d8$var$addClass(clone, moveClass);
            clone.style.display = 'none';
            this.$el.appendChild(clone);
            const info = $69b5f56b6d1ac1d8$var$getTransitionInfo(clone);
            this.$el.removeChild(clone);
            return this._hasMove = info.hasTransform;
        }
    }
};
function $69b5f56b6d1ac1d8$var$callPendingCbs(c) {
    /* istanbul ignore if */ if (c.elm._moveCb) c.elm._moveCb();
    /* istanbul ignore if */ if (c.elm._enterCb) c.elm._enterCb();
}
function $69b5f56b6d1ac1d8$var$recordPosition(c) {
    c.data.newPos = c.elm.getBoundingClientRect();
}
function $69b5f56b6d1ac1d8$var$applyTranslation(c) {
    const oldPos = c.data.pos;
    const newPos = c.data.newPos;
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        c.data.moved = true;
        const s = c.elm.style;
        s.transform = s.WebkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = '0s';
    }
}
var $69b5f56b6d1ac1d8$var$platformComponents = {
    Transition: $69b5f56b6d1ac1d8$var$Transition,
    TransitionGroup: $69b5f56b6d1ac1d8$var$TransitionGroup
};
// install platform specific utils
$69b5f56b6d1ac1d8$var$Vue.config.mustUseProp = $69b5f56b6d1ac1d8$var$mustUseProp;
$69b5f56b6d1ac1d8$var$Vue.config.isReservedTag = $69b5f56b6d1ac1d8$var$isReservedTag;
$69b5f56b6d1ac1d8$var$Vue.config.isReservedAttr = $69b5f56b6d1ac1d8$var$isReservedAttr;
$69b5f56b6d1ac1d8$var$Vue.config.getTagNamespace = $69b5f56b6d1ac1d8$var$getTagNamespace;
$69b5f56b6d1ac1d8$var$Vue.config.isUnknownElement = $69b5f56b6d1ac1d8$var$isUnknownElement;
// install platform runtime directives & components
$69b5f56b6d1ac1d8$var$extend($69b5f56b6d1ac1d8$var$Vue.options.directives, $69b5f56b6d1ac1d8$var$platformDirectives);
$69b5f56b6d1ac1d8$var$extend($69b5f56b6d1ac1d8$var$Vue.options.components, $69b5f56b6d1ac1d8$var$platformComponents);
// install platform patch function
$69b5f56b6d1ac1d8$var$Vue.prototype.__patch__ = $69b5f56b6d1ac1d8$var$inBrowser ? $69b5f56b6d1ac1d8$var$patch : $69b5f56b6d1ac1d8$var$noop;
// public mount method
$69b5f56b6d1ac1d8$var$Vue.prototype.$mount = function(el, hydrating) {
    el = el && $69b5f56b6d1ac1d8$var$inBrowser ? $69b5f56b6d1ac1d8$var$query(el) : undefined;
    return $69b5f56b6d1ac1d8$var$mountComponent(this, el, hydrating);
};
// devtools global hook
/* istanbul ignore next */ if ($69b5f56b6d1ac1d8$var$inBrowser) setTimeout(()=>{
    if ($69b5f56b6d1ac1d8$var$config.devtools) {
        if ($69b5f56b6d1ac1d8$var$devtools) $69b5f56b6d1ac1d8$var$devtools.emit('init', $69b5f56b6d1ac1d8$var$Vue);
        else // @ts-expect-error
        console[console.info ? 'info' : 'log']("Download the Vue Devtools extension for a better development experience:\nhttps://github.com/vuejs/vue-devtools");
    }
    if ($69b5f56b6d1ac1d8$var$config.productionTip !== false && typeof console !== 'undefined') // @ts-expect-error
    console[console.info ? 'info' : 'log'](`You are running Vue in development mode.\n` + `Make sure to turn on production mode when deploying for production.\n` + `See more tips at https://vuejs.org/guide/deployment.html`);
}, 0);
const $69b5f56b6d1ac1d8$var$defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
const $69b5f56b6d1ac1d8$var$regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
const $69b5f56b6d1ac1d8$var$buildRegex = $69b5f56b6d1ac1d8$var$cached((delimiters)=>{
    const open = delimiters[0].replace($69b5f56b6d1ac1d8$var$regexEscapeRE, '\\$&');
    const close = delimiters[1].replace($69b5f56b6d1ac1d8$var$regexEscapeRE, '\\$&');
    return new RegExp(open + '((?:.|\\n)+?)' + close, 'g');
});
function $69b5f56b6d1ac1d8$var$parseText(text, delimiters) {
    //@ts-expect-error
    const tagRE = delimiters ? $69b5f56b6d1ac1d8$var$buildRegex(delimiters) : $69b5f56b6d1ac1d8$var$defaultTagRE;
    if (!tagRE.test(text)) return;
    const tokens = [];
    const rawTokens = [];
    let lastIndex = tagRE.lastIndex = 0;
    let match, index, tokenValue;
    while(match = tagRE.exec(text)){
        index = match.index;
        // push text token
        if (index > lastIndex) {
            rawTokens.push(tokenValue = text.slice(lastIndex, index));
            tokens.push(JSON.stringify(tokenValue));
        }
        // tag token
        const exp = $69b5f56b6d1ac1d8$var$parseFilters(match[1].trim());
        tokens.push(`_s(${exp})`);
        rawTokens.push({
            '@binding': exp
        });
        lastIndex = index + match[0].length;
    }
    if (lastIndex < text.length) {
        rawTokens.push(tokenValue = text.slice(lastIndex));
        tokens.push(JSON.stringify(tokenValue));
    }
    return {
        expression: tokens.join('+'),
        tokens: rawTokens
    };
}
function $69b5f56b6d1ac1d8$var$transformNode$1(el, options) {
    const warn = options.warn || $69b5f56b6d1ac1d8$var$baseWarn;
    const staticClass = $69b5f56b6d1ac1d8$var$getAndRemoveAttr(el, 'class');
    if (staticClass) {
        const res = $69b5f56b6d1ac1d8$var$parseText(staticClass, options.delimiters);
        if (res) warn(`class="${staticClass}": ` + 'Interpolation inside attributes has been removed. ' + 'Use v-bind or the colon shorthand instead. For example, ' + 'instead of <div class="{{ val }}">, use <div :class="val">.', el.rawAttrsMap['class']);
    }
    if (staticClass) el.staticClass = JSON.stringify(staticClass.replace(/\s+/g, ' ').trim());
    const classBinding = $69b5f56b6d1ac1d8$var$getBindingAttr(el, 'class', false);
    if (classBinding) el.classBinding = classBinding;
}
function $69b5f56b6d1ac1d8$var$genData$2(el) {
    let data = '';
    if (el.staticClass) data += `staticClass:${el.staticClass},`;
    if (el.classBinding) data += `class:${el.classBinding},`;
    return data;
}
var $69b5f56b6d1ac1d8$var$klass = {
    staticKeys: [
        'staticClass'
    ],
    transformNode: $69b5f56b6d1ac1d8$var$transformNode$1,
    genData: $69b5f56b6d1ac1d8$var$genData$2
};
function $69b5f56b6d1ac1d8$var$transformNode(el, options) {
    const warn = options.warn || $69b5f56b6d1ac1d8$var$baseWarn;
    const staticStyle = $69b5f56b6d1ac1d8$var$getAndRemoveAttr(el, 'style');
    if (staticStyle) {
        /* istanbul ignore if */ {
            const res = $69b5f56b6d1ac1d8$var$parseText(staticStyle, options.delimiters);
            if (res) warn(`style="${staticStyle}": ` + 'Interpolation inside attributes has been removed. ' + 'Use v-bind or the colon shorthand instead. For example, ' + 'instead of <div style="{{ val }}">, use <div :style="val">.', el.rawAttrsMap['style']);
        }
        el.staticStyle = JSON.stringify($69b5f56b6d1ac1d8$var$parseStyleText(staticStyle));
    }
    const styleBinding = $69b5f56b6d1ac1d8$var$getBindingAttr(el, 'style', false);
    if (styleBinding) el.styleBinding = styleBinding;
}
function $69b5f56b6d1ac1d8$var$genData$1(el) {
    let data = '';
    if (el.staticStyle) data += `staticStyle:${el.staticStyle},`;
    if (el.styleBinding) data += `style:(${el.styleBinding}),`;
    return data;
}
var $69b5f56b6d1ac1d8$var$style = {
    staticKeys: [
        'staticStyle'
    ],
    transformNode: $69b5f56b6d1ac1d8$var$transformNode,
    genData: $69b5f56b6d1ac1d8$var$genData$1
};
let $69b5f56b6d1ac1d8$var$decoder;
var $69b5f56b6d1ac1d8$var$he = {
    decode (html) {
        $69b5f56b6d1ac1d8$var$decoder = $69b5f56b6d1ac1d8$var$decoder || document.createElement('div');
        $69b5f56b6d1ac1d8$var$decoder.innerHTML = html;
        return $69b5f56b6d1ac1d8$var$decoder.textContent;
    }
};
const $69b5f56b6d1ac1d8$var$isUnaryTag = $69b5f56b6d1ac1d8$var$makeMap("area,base,br,col,embed,frame,hr,img,input,isindex,keygen,link,meta,param,source,track,wbr");
// Elements that you can, intentionally, leave open
// (and which close themselves)
const $69b5f56b6d1ac1d8$var$canBeLeftOpenTag = $69b5f56b6d1ac1d8$var$makeMap('colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source');
// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
const $69b5f56b6d1ac1d8$var$isNonPhrasingTag = $69b5f56b6d1ac1d8$var$makeMap("address,article,aside,base,blockquote,body,caption,col,colgroup,dd,details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,title,tr,track");
/**
 * Not type-checking this file because it's mostly vendor code.
 */ // Regular Expressions for parsing tags and attributes
const $69b5f56b6d1ac1d8$var$attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
const $69b5f56b6d1ac1d8$var$dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
const $69b5f56b6d1ac1d8$var$ncname = `[a-zA-Z_][\\-\\.0-9_a-zA-Z${$69b5f56b6d1ac1d8$var$unicodeRegExp.source}]*`;
const $69b5f56b6d1ac1d8$var$qnameCapture = `((?:${$69b5f56b6d1ac1d8$var$ncname}\\:)?${$69b5f56b6d1ac1d8$var$ncname})`;
const $69b5f56b6d1ac1d8$var$startTagOpen = new RegExp(`^<${$69b5f56b6d1ac1d8$var$qnameCapture}`);
const $69b5f56b6d1ac1d8$var$startTagClose = /^\s*(\/?)>/;
const $69b5f56b6d1ac1d8$var$endTag = new RegExp(`^<\\/${$69b5f56b6d1ac1d8$var$qnameCapture}[^>]*>`);
const $69b5f56b6d1ac1d8$var$doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
const $69b5f56b6d1ac1d8$var$comment = /^<!\--/;
const $69b5f56b6d1ac1d8$var$conditionalComment = /^<!\[/;
// Special Elements (can contain anything)
const $69b5f56b6d1ac1d8$var$isPlainTextElement = $69b5f56b6d1ac1d8$var$makeMap('script,style,textarea', true);
const $69b5f56b6d1ac1d8$var$reCache = {};
const $69b5f56b6d1ac1d8$var$decodingMap = {
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&amp;': '&',
    '&#10;': '\n',
    '&#9;': '\t',
    '&#39;': "'"
};
const $69b5f56b6d1ac1d8$var$encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
const $69b5f56b6d1ac1d8$var$encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;
// #5992
const $69b5f56b6d1ac1d8$var$isIgnoreNewlineTag = $69b5f56b6d1ac1d8$var$makeMap('pre,textarea', true);
const $69b5f56b6d1ac1d8$var$shouldIgnoreFirstNewline = (tag, html)=>tag && $69b5f56b6d1ac1d8$var$isIgnoreNewlineTag(tag) && html[0] === '\n';
function $69b5f56b6d1ac1d8$var$decodeAttr(value, shouldDecodeNewlines) {
    const re = shouldDecodeNewlines ? $69b5f56b6d1ac1d8$var$encodedAttrWithNewLines : $69b5f56b6d1ac1d8$var$encodedAttr;
    return value.replace(re, (match)=>$69b5f56b6d1ac1d8$var$decodingMap[match]);
}
function $69b5f56b6d1ac1d8$var$parseHTML(html, options) {
    const stack = [];
    const expectHTML = options.expectHTML;
    const isUnaryTag = options.isUnaryTag || $69b5f56b6d1ac1d8$var$no;
    const canBeLeftOpenTag = options.canBeLeftOpenTag || $69b5f56b6d1ac1d8$var$no;
    let index = 0;
    let last, lastTag;
    while(html){
        last = html;
        // Make sure we're not in a plaintext content element like script/style
        if (!lastTag || !$69b5f56b6d1ac1d8$var$isPlainTextElement(lastTag)) {
            let textEnd = html.indexOf('<');
            if (textEnd === 0) {
                // Comment:
                if ($69b5f56b6d1ac1d8$var$comment.test(html)) {
                    const commentEnd = html.indexOf('-->');
                    if (commentEnd >= 0) {
                        if (options.shouldKeepComment && options.comment) options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
                        advance(commentEnd + 3);
                        continue;
                    }
                }
                // https://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
                if ($69b5f56b6d1ac1d8$var$conditionalComment.test(html)) {
                    const conditionalEnd = html.indexOf(']>');
                    if (conditionalEnd >= 0) {
                        advance(conditionalEnd + 2);
                        continue;
                    }
                }
                // Doctype:
                const doctypeMatch = html.match($69b5f56b6d1ac1d8$var$doctype);
                if (doctypeMatch) {
                    advance(doctypeMatch[0].length);
                    continue;
                }
                // End tag:
                const endTagMatch = html.match($69b5f56b6d1ac1d8$var$endTag);
                if (endTagMatch) {
                    const curIndex = index;
                    advance(endTagMatch[0].length);
                    parseEndTag(endTagMatch[1], curIndex, index);
                    continue;
                }
                // Start tag:
                const startTagMatch = parseStartTag();
                if (startTagMatch) {
                    handleStartTag(startTagMatch);
                    if ($69b5f56b6d1ac1d8$var$shouldIgnoreFirstNewline(startTagMatch.tagName, html)) advance(1);
                    continue;
                }
            }
            let text, rest, next;
            if (textEnd >= 0) {
                rest = html.slice(textEnd);
                while(!$69b5f56b6d1ac1d8$var$endTag.test(rest) && !$69b5f56b6d1ac1d8$var$startTagOpen.test(rest) && !$69b5f56b6d1ac1d8$var$comment.test(rest) && !$69b5f56b6d1ac1d8$var$conditionalComment.test(rest)){
                    // < in plain text, be forgiving and treat it as text
                    next = rest.indexOf('<', 1);
                    if (next < 0) break;
                    textEnd += next;
                    rest = html.slice(textEnd);
                }
                text = html.substring(0, textEnd);
            }
            if (textEnd < 0) text = html;
            if (text) advance(text.length);
            if (options.chars && text) options.chars(text, index - text.length, index);
        } else {
            let endTagLength = 0;
            const stackedTag = lastTag.toLowerCase();
            const reStackedTag = $69b5f56b6d1ac1d8$var$reCache[stackedTag] || ($69b5f56b6d1ac1d8$var$reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
            const rest = html.replace(reStackedTag, function(all, text, endTag) {
                endTagLength = endTag.length;
                if (!$69b5f56b6d1ac1d8$var$isPlainTextElement(stackedTag) && stackedTag !== 'noscript') text = text.replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
                .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
                if ($69b5f56b6d1ac1d8$var$shouldIgnoreFirstNewline(stackedTag, text)) text = text.slice(1);
                if (options.chars) options.chars(text);
                return '';
            });
            index += html.length - rest.length;
            html = rest;
            parseEndTag(stackedTag, index - endTagLength, index);
        }
        if (html === last) {
            options.chars && options.chars(html);
            if (!stack.length && options.warn) options.warn(`Mal-formatted tag at end of template: "${html}"`, {
                start: index + html.length
            });
            break;
        }
    }
    // Clean up any remaining tags
    parseEndTag();
    function advance(n) {
        index += n;
        html = html.substring(n);
    }
    function parseStartTag() {
        const start = html.match($69b5f56b6d1ac1d8$var$startTagOpen);
        if (start) {
            const match = {
                tagName: start[1],
                attrs: [],
                start: index
            };
            advance(start[0].length);
            let end, attr;
            while(!(end = html.match($69b5f56b6d1ac1d8$var$startTagClose)) && (attr = html.match($69b5f56b6d1ac1d8$var$dynamicArgAttribute) || html.match($69b5f56b6d1ac1d8$var$attribute))){
                attr.start = index;
                advance(attr[0].length);
                attr.end = index;
                match.attrs.push(attr);
            }
            if (end) {
                match.unarySlash = end[1];
                advance(end[0].length);
                match.end = index;
                return match;
            }
        }
    }
    function handleStartTag(match) {
        const tagName = match.tagName;
        const unarySlash = match.unarySlash;
        if (expectHTML) {
            if (lastTag === 'p' && $69b5f56b6d1ac1d8$var$isNonPhrasingTag(tagName)) parseEndTag(lastTag);
            if (canBeLeftOpenTag(tagName) && lastTag === tagName) parseEndTag(tagName);
        }
        const unary = isUnaryTag(tagName) || !!unarySlash;
        const l = match.attrs.length;
        const attrs = new Array(l);
        for(let i = 0; i < l; i++){
            const args = match.attrs[i];
            const value = args[3] || args[4] || args[5] || '';
            const shouldDecodeNewlines = tagName === 'a' && args[1] === 'href' ? options.shouldDecodeNewlinesForHref : options.shouldDecodeNewlines;
            attrs[i] = {
                name: args[1],
                value: $69b5f56b6d1ac1d8$var$decodeAttr(value, shouldDecodeNewlines)
            };
            if (options.outputSourceRange) {
                attrs[i].start = args.start + args[0].match(/^\s*/).length;
                attrs[i].end = args.end;
            }
        }
        if (!unary) {
            stack.push({
                tag: tagName,
                lowerCasedTag: tagName.toLowerCase(),
                attrs: attrs,
                start: match.start,
                end: match.end
            });
            lastTag = tagName;
        }
        if (options.start) options.start(tagName, attrs, unary, match.start, match.end);
    }
    function parseEndTag(tagName, start, end) {
        let pos, lowerCasedTagName;
        if (start == null) start = index;
        if (end == null) end = index;
        // Find the closest opened tag of the same type
        if (tagName) {
            lowerCasedTagName = tagName.toLowerCase();
            for(pos = stack.length - 1; pos >= 0; pos--){
                if (stack[pos].lowerCasedTag === lowerCasedTagName) break;
            }
        } else // If no tag name is provided, clean shop
        pos = 0;
        if (pos >= 0) {
            // Close all the open elements, up the stack
            for(let i = stack.length - 1; i >= pos; i--){
                if ((i > pos || !tagName) && options.warn) options.warn(`tag <${stack[i].tag}> has no matching end tag.`, {
                    start: stack[i].start,
                    end: stack[i].end
                });
                if (options.end) options.end(stack[i].tag, start, end);
            }
            // Remove the open elements from the stack
            stack.length = pos;
            lastTag = pos && stack[pos - 1].tag;
        } else if (lowerCasedTagName === 'br') {
            if (options.start) options.start(tagName, [], true, start, end);
        } else if (lowerCasedTagName === 'p') {
            if (options.start) options.start(tagName, [], false, start, end);
            if (options.end) options.end(tagName, start, end);
        }
    }
}
const $69b5f56b6d1ac1d8$var$onRE = /^@|^v-on:/;
const $69b5f56b6d1ac1d8$var$dirRE = /^v-|^@|^:|^#/;
const $69b5f56b6d1ac1d8$var$forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
const $69b5f56b6d1ac1d8$var$forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
const $69b5f56b6d1ac1d8$var$stripParensRE = /^\(|\)$/g;
const $69b5f56b6d1ac1d8$var$dynamicArgRE = /^\[.*\]$/;
const $69b5f56b6d1ac1d8$var$argRE = /:(.*)$/;
const $69b5f56b6d1ac1d8$var$bindRE = /^:|^\.|^v-bind:/;
const $69b5f56b6d1ac1d8$var$modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;
const $69b5f56b6d1ac1d8$var$slotRE = /^v-slot(:|$)|^#/;
const $69b5f56b6d1ac1d8$var$lineBreakRE = /[\r\n]/;
const $69b5f56b6d1ac1d8$var$whitespaceRE = /[ \f\t\r\n]+/g;
const $69b5f56b6d1ac1d8$var$invalidAttributeRE = /[\s"'<>\/=]/;
const $69b5f56b6d1ac1d8$var$decodeHTMLCached = $69b5f56b6d1ac1d8$var$cached($69b5f56b6d1ac1d8$var$he.decode);
const $69b5f56b6d1ac1d8$var$emptySlotScopeToken = `_empty_`;
// configurable state
let $69b5f56b6d1ac1d8$var$warn;
let $69b5f56b6d1ac1d8$var$delimiters;
let $69b5f56b6d1ac1d8$var$transforms;
let $69b5f56b6d1ac1d8$var$preTransforms;
let $69b5f56b6d1ac1d8$var$postTransforms;
let $69b5f56b6d1ac1d8$var$platformIsPreTag;
let $69b5f56b6d1ac1d8$var$platformMustUseProp;
let $69b5f56b6d1ac1d8$var$platformGetTagNamespace;
let $69b5f56b6d1ac1d8$var$maybeComponent;
function $69b5f56b6d1ac1d8$var$createASTElement(tag, attrs, parent) {
    return {
        type: 1,
        tag: tag,
        attrsList: attrs,
        attrsMap: $69b5f56b6d1ac1d8$var$makeAttrsMap(attrs),
        rawAttrsMap: {},
        parent: parent,
        children: []
    };
}
/**
 * Convert HTML string to AST.
 */ function $69b5f56b6d1ac1d8$var$parse(template, options) {
    $69b5f56b6d1ac1d8$var$warn = options.warn || $69b5f56b6d1ac1d8$var$baseWarn;
    $69b5f56b6d1ac1d8$var$platformIsPreTag = options.isPreTag || $69b5f56b6d1ac1d8$var$no;
    $69b5f56b6d1ac1d8$var$platformMustUseProp = options.mustUseProp || $69b5f56b6d1ac1d8$var$no;
    $69b5f56b6d1ac1d8$var$platformGetTagNamespace = options.getTagNamespace || $69b5f56b6d1ac1d8$var$no;
    const isReservedTag = options.isReservedTag || $69b5f56b6d1ac1d8$var$no;
    $69b5f56b6d1ac1d8$var$maybeComponent = (el)=>!!(el.component || el.attrsMap[':is'] || el.attrsMap['v-bind:is'] || !(el.attrsMap.is ? isReservedTag(el.attrsMap.is) : isReservedTag(el.tag)));
    $69b5f56b6d1ac1d8$var$transforms = $69b5f56b6d1ac1d8$var$pluckModuleFunction(options.modules, 'transformNode');
    $69b5f56b6d1ac1d8$var$preTransforms = $69b5f56b6d1ac1d8$var$pluckModuleFunction(options.modules, 'preTransformNode');
    $69b5f56b6d1ac1d8$var$postTransforms = $69b5f56b6d1ac1d8$var$pluckModuleFunction(options.modules, 'postTransformNode');
    $69b5f56b6d1ac1d8$var$delimiters = options.delimiters;
    const stack = [];
    const preserveWhitespace = options.preserveWhitespace !== false;
    const whitespaceOption = options.whitespace;
    let root;
    let currentParent;
    let inVPre = false;
    let inPre = false;
    let warned = false;
    function warnOnce(msg, range) {
        if (!warned) {
            warned = true;
            $69b5f56b6d1ac1d8$var$warn(msg, range);
        }
    }
    function closeElement(element) {
        trimEndingWhitespace(element);
        if (!inVPre && !element.processed) element = $69b5f56b6d1ac1d8$var$processElement(element, options);
        // tree management
        if (!stack.length && element !== root) {
            // allow root elements with v-if, v-else-if and v-else
            if (root.if && (element.elseif || element.else)) {
                checkRootConstraints(element);
                $69b5f56b6d1ac1d8$var$addIfCondition(root, {
                    exp: element.elseif,
                    block: element
                });
            } else warnOnce(`Component template should contain exactly one root element. ` + `If you are using v-if on multiple elements, ` + `use v-else-if to chain them instead.`, {
                start: element.start
            });
        }
        if (currentParent && !element.forbidden) {
            if (element.elseif || element.else) $69b5f56b6d1ac1d8$var$processIfConditions(element, currentParent);
            else {
                if (element.slotScope) {
                    // scoped slot
                    // keep it in the children list so that v-else(-if) conditions can
                    // find it as the prev node.
                    const name = element.slotTarget || '"default"';
                    (currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
                }
                currentParent.children.push(element);
                element.parent = currentParent;
            }
        }
        // final children cleanup
        // filter out scoped slots
        element.children = element.children.filter((c)=>!c.slotScope);
        // remove trailing whitespace node again
        trimEndingWhitespace(element);
        // check pre state
        if (element.pre) inVPre = false;
        if ($69b5f56b6d1ac1d8$var$platformIsPreTag(element.tag)) inPre = false;
        // apply post-transforms
        for(let i = 0; i < $69b5f56b6d1ac1d8$var$postTransforms.length; i++)$69b5f56b6d1ac1d8$var$postTransforms[i](element, options);
    }
    function trimEndingWhitespace(el) {
        // remove trailing whitespace node
        if (!inPre) {
            let lastNode;
            while((lastNode = el.children[el.children.length - 1]) && lastNode.type === 3 && lastNode.text === ' ')el.children.pop();
        }
    }
    function checkRootConstraints(el) {
        if (el.tag === 'slot' || el.tag === 'template') warnOnce(`Cannot use <${el.tag}> as component root element because it may ` + 'contain multiple nodes.', {
            start: el.start
        });
        if (el.attrsMap.hasOwnProperty('v-for')) warnOnce("Cannot use v-for on stateful component root element because it renders multiple elements.", el.rawAttrsMap['v-for']);
    }
    $69b5f56b6d1ac1d8$var$parseHTML(template, {
        warn: $69b5f56b6d1ac1d8$var$warn,
        expectHTML: options.expectHTML,
        isUnaryTag: options.isUnaryTag,
        canBeLeftOpenTag: options.canBeLeftOpenTag,
        shouldDecodeNewlines: options.shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
        shouldKeepComment: options.comments,
        outputSourceRange: options.outputSourceRange,
        start (tag, attrs, unary, start, end) {
            // check namespace.
            // inherit parent ns if there is one
            const ns = currentParent && currentParent.ns || $69b5f56b6d1ac1d8$var$platformGetTagNamespace(tag);
            // handle IE svg bug
            /* istanbul ignore if */ if ($69b5f56b6d1ac1d8$var$isIE && ns === 'svg') attrs = $69b5f56b6d1ac1d8$var$guardIESVGBug(attrs);
            let element = $69b5f56b6d1ac1d8$var$createASTElement(tag, attrs, currentParent);
            if (ns) element.ns = ns;
            if (options.outputSourceRange) {
                element.start = start;
                element.end = end;
                element.rawAttrsMap = element.attrsList.reduce((cumulated, attr)=>{
                    cumulated[attr.name] = attr;
                    return cumulated;
                }, {});
            }
            attrs.forEach((attr)=>{
                if ($69b5f56b6d1ac1d8$var$invalidAttributeRE.test(attr.name)) $69b5f56b6d1ac1d8$var$warn(`Invalid dynamic argument expression: attribute names cannot contain ` + `spaces, quotes, <, >, / or =.`, options.outputSourceRange ? {
                    start: attr.start + attr.name.indexOf(`[`),
                    end: attr.start + attr.name.length
                } : undefined);
            });
            if ($69b5f56b6d1ac1d8$var$isForbiddenTag(element) && !$69b5f56b6d1ac1d8$var$isServerRendering()) {
                element.forbidden = true;
                $69b5f56b6d1ac1d8$var$warn("Templates should only be responsible for mapping the state to the UI. Avoid placing tags with side-effects in your templates, such as " + `<${tag}>` + ', as they will not be parsed.', {
                    start: element.start
                });
            }
            // apply pre-transforms
            for(let i = 0; i < $69b5f56b6d1ac1d8$var$preTransforms.length; i++)element = $69b5f56b6d1ac1d8$var$preTransforms[i](element, options) || element;
            if (!inVPre) {
                $69b5f56b6d1ac1d8$var$processPre(element);
                if (element.pre) inVPre = true;
            }
            if ($69b5f56b6d1ac1d8$var$platformIsPreTag(element.tag)) inPre = true;
            if (inVPre) $69b5f56b6d1ac1d8$var$processRawAttrs(element);
            else if (!element.processed) {
                // structural directives
                $69b5f56b6d1ac1d8$var$processFor(element);
                $69b5f56b6d1ac1d8$var$processIf(element);
                $69b5f56b6d1ac1d8$var$processOnce(element);
            }
            if (!root) {
                root = element;
                checkRootConstraints(root);
            }
            if (!unary) {
                currentParent = element;
                stack.push(element);
            } else closeElement(element);
        },
        end (tag, start, end) {
            const element = stack[stack.length - 1];
            // pop stack
            stack.length -= 1;
            currentParent = stack[stack.length - 1];
            if (options.outputSourceRange) element.end = end;
            closeElement(element);
        },
        chars (text, start, end) {
            if (!currentParent) {
                if (text === template) warnOnce('Component template requires a root element, rather than just text.', {
                    start: start
                });
                else if (text = text.trim()) warnOnce(`text "${text}" outside root element will be ignored.`, {
                    start: start
                });
                return;
            }
            // IE textarea placeholder bug
            /* istanbul ignore if */ if ($69b5f56b6d1ac1d8$var$isIE && currentParent.tag === 'textarea' && currentParent.attrsMap.placeholder === text) return;
            const children = currentParent.children;
            if (inPre || text.trim()) text = $69b5f56b6d1ac1d8$var$isTextTag(currentParent) ? text : $69b5f56b6d1ac1d8$var$decodeHTMLCached(text);
            else if (!children.length) // remove the whitespace-only node right after an opening tag
            text = '';
            else if (whitespaceOption) {
                if (whitespaceOption === 'condense') // in condense mode, remove the whitespace node if it contains
                // line break, otherwise condense to a single space
                text = $69b5f56b6d1ac1d8$var$lineBreakRE.test(text) ? '' : ' ';
                else text = ' ';
            } else text = preserveWhitespace ? ' ' : '';
            if (text) {
                if (!inPre && whitespaceOption === 'condense') // condense consecutive whitespaces into single space
                text = text.replace($69b5f56b6d1ac1d8$var$whitespaceRE, ' ');
                let res;
                let child;
                if (!inVPre && text !== ' ' && (res = $69b5f56b6d1ac1d8$var$parseText(text, $69b5f56b6d1ac1d8$var$delimiters))) child = {
                    type: 2,
                    expression: res.expression,
                    tokens: res.tokens,
                    text: text
                };
                else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') child = {
                    type: 3,
                    text: text
                };
                if (child) {
                    if (options.outputSourceRange) {
                        child.start = start;
                        child.end = end;
                    }
                    children.push(child);
                }
            }
        },
        comment (text, start, end) {
            // adding anything as a sibling to the root node is forbidden
            // comments should still be allowed, but ignored
            if (currentParent) {
                const child = {
                    type: 3,
                    text: text,
                    isComment: true
                };
                if (options.outputSourceRange) {
                    child.start = start;
                    child.end = end;
                }
                currentParent.children.push(child);
            }
        }
    });
    return root;
}
function $69b5f56b6d1ac1d8$var$processPre(el) {
    if ($69b5f56b6d1ac1d8$var$getAndRemoveAttr(el, 'v-pre') != null) el.pre = true;
}
function $69b5f56b6d1ac1d8$var$processRawAttrs(el) {
    const list = el.attrsList;
    const len = list.length;
    if (len) {
        const attrs = el.attrs = new Array(len);
        for(let i = 0; i < len; i++){
            attrs[i] = {
                name: list[i].name,
                value: JSON.stringify(list[i].value)
            };
            if (list[i].start != null) {
                attrs[i].start = list[i].start;
                attrs[i].end = list[i].end;
            }
        }
    } else if (!el.pre) // non root node in pre blocks with no attributes
    el.plain = true;
}
function $69b5f56b6d1ac1d8$var$processElement(element, options) {
    $69b5f56b6d1ac1d8$var$processKey(element);
    // determine whether this is a plain element after
    // removing structural attributes
    element.plain = !element.key && !element.scopedSlots && !element.attrsList.length;
    $69b5f56b6d1ac1d8$var$processRef(element);
    $69b5f56b6d1ac1d8$var$processSlotContent(element);
    $69b5f56b6d1ac1d8$var$processSlotOutlet(element);
    $69b5f56b6d1ac1d8$var$processComponent(element);
    for(let i = 0; i < $69b5f56b6d1ac1d8$var$transforms.length; i++)element = $69b5f56b6d1ac1d8$var$transforms[i](element, options) || element;
    $69b5f56b6d1ac1d8$var$processAttrs(element);
    return element;
}
function $69b5f56b6d1ac1d8$var$processKey(el) {
    const exp = $69b5f56b6d1ac1d8$var$getBindingAttr(el, 'key');
    if (exp) {
        if (el.tag === 'template') $69b5f56b6d1ac1d8$var$warn(`<template> cannot be keyed. Place the key on real elements instead.`, $69b5f56b6d1ac1d8$var$getRawBindingAttr(el, 'key'));
        if (el.for) {
            const iterator = el.iterator2 || el.iterator1;
            const parent = el.parent;
            if (iterator && iterator === exp && parent && parent.tag === 'transition-group') $69b5f56b6d1ac1d8$var$warn(`Do not use v-for index as key on <transition-group> children, ` + `this is the same as not using keys.`, $69b5f56b6d1ac1d8$var$getRawBindingAttr(el, 'key'), true);
        }
        el.key = exp;
    }
}
function $69b5f56b6d1ac1d8$var$processRef(el) {
    const ref = $69b5f56b6d1ac1d8$var$getBindingAttr(el, 'ref');
    if (ref) {
        el.ref = ref;
        el.refInFor = $69b5f56b6d1ac1d8$var$checkInFor(el);
    }
}
function $69b5f56b6d1ac1d8$var$processFor(el) {
    let exp;
    if (exp = $69b5f56b6d1ac1d8$var$getAndRemoveAttr(el, 'v-for')) {
        const res = $69b5f56b6d1ac1d8$var$parseFor(exp);
        if (res) $69b5f56b6d1ac1d8$var$extend(el, res);
        else $69b5f56b6d1ac1d8$var$warn(`Invalid v-for expression: ${exp}`, el.rawAttrsMap['v-for']);
    }
}
function $69b5f56b6d1ac1d8$var$parseFor(exp) {
    const inMatch = exp.match($69b5f56b6d1ac1d8$var$forAliasRE);
    if (!inMatch) return;
    const res = {};
    res.for = inMatch[2].trim();
    const alias = inMatch[1].trim().replace($69b5f56b6d1ac1d8$var$stripParensRE, '');
    const iteratorMatch = alias.match($69b5f56b6d1ac1d8$var$forIteratorRE);
    if (iteratorMatch) {
        res.alias = alias.replace($69b5f56b6d1ac1d8$var$forIteratorRE, '').trim();
        res.iterator1 = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.iterator2 = iteratorMatch[2].trim();
    } else res.alias = alias;
    return res;
}
function $69b5f56b6d1ac1d8$var$processIf(el) {
    const exp = $69b5f56b6d1ac1d8$var$getAndRemoveAttr(el, 'v-if');
    if (exp) {
        el.if = exp;
        $69b5f56b6d1ac1d8$var$addIfCondition(el, {
            exp: exp,
            block: el
        });
    } else {
        if ($69b5f56b6d1ac1d8$var$getAndRemoveAttr(el, 'v-else') != null) el.else = true;
        const elseif = $69b5f56b6d1ac1d8$var$getAndRemoveAttr(el, 'v-else-if');
        if (elseif) el.elseif = elseif;
    }
}
function $69b5f56b6d1ac1d8$var$processIfConditions(el, parent) {
    const prev = $69b5f56b6d1ac1d8$var$findPrevElement(parent.children);
    if (prev && prev.if) $69b5f56b6d1ac1d8$var$addIfCondition(prev, {
        exp: el.elseif,
        block: el
    });
    else $69b5f56b6d1ac1d8$var$warn(`v-${el.elseif ? 'else-if="' + el.elseif + '"' : 'else'} ` + `used on element <${el.tag}> without corresponding v-if.`, el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']);
}
function $69b5f56b6d1ac1d8$var$findPrevElement(children) {
    let i = children.length;
    while(i--){
        if (children[i].type === 1) return children[i];
        else {
            if (children[i].text !== ' ') $69b5f56b6d1ac1d8$var$warn(`text "${children[i].text.trim()}" between v-if and v-else(-if) ` + `will be ignored.`, children[i]);
            children.pop();
        }
    }
}
function $69b5f56b6d1ac1d8$var$addIfCondition(el, condition) {
    if (!el.ifConditions) el.ifConditions = [];
    el.ifConditions.push(condition);
}
function $69b5f56b6d1ac1d8$var$processOnce(el) {
    const once = $69b5f56b6d1ac1d8$var$getAndRemoveAttr(el, 'v-once');
    if (once != null) el.once = true;
}
// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function $69b5f56b6d1ac1d8$var$processSlotContent(el) {
    let slotScope;
    if (el.tag === 'template') {
        slotScope = $69b5f56b6d1ac1d8$var$getAndRemoveAttr(el, 'scope');
        /* istanbul ignore if */ if (slotScope) $69b5f56b6d1ac1d8$var$warn(`the "scope" attribute for scoped slots have been deprecated and ` + `replaced by "slot-scope" since 2.5. The new "slot-scope" attribute ` + `can also be used on plain elements in addition to <template> to ` + `denote scoped slots.`, el.rawAttrsMap['scope'], true);
        el.slotScope = slotScope || $69b5f56b6d1ac1d8$var$getAndRemoveAttr(el, 'slot-scope');
    } else if (slotScope = $69b5f56b6d1ac1d8$var$getAndRemoveAttr(el, 'slot-scope')) {
        /* istanbul ignore if */ if (el.attrsMap['v-for']) $69b5f56b6d1ac1d8$var$warn(`Ambiguous combined usage of slot-scope and v-for on <${el.tag}> ` + `(v-for takes higher priority). Use a wrapper <template> for the ` + `scoped slot to make it clearer.`, el.rawAttrsMap['slot-scope'], true);
        el.slotScope = slotScope;
    }
    // slot="xxx"
    const slotTarget = $69b5f56b6d1ac1d8$var$getBindingAttr(el, 'slot');
    if (slotTarget) {
        el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
        el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
        // preserve slot as an attribute for native shadow DOM compat
        // only for non-scoped slots.
        if (el.tag !== 'template' && !el.slotScope) $69b5f56b6d1ac1d8$var$addAttr(el, 'slot', slotTarget, $69b5f56b6d1ac1d8$var$getRawBindingAttr(el, 'slot'));
    }
    if (el.tag === 'template') {
        // v-slot on <template>
        const slotBinding = $69b5f56b6d1ac1d8$var$getAndRemoveAttrByRegex(el, $69b5f56b6d1ac1d8$var$slotRE);
        if (slotBinding) {
            if (el.slotTarget || el.slotScope) $69b5f56b6d1ac1d8$var$warn(`Unexpected mixed usage of different slot syntaxes.`, el);
            if (el.parent && !$69b5f56b6d1ac1d8$var$maybeComponent(el.parent)) $69b5f56b6d1ac1d8$var$warn(`<template v-slot> can only appear at the root level inside ` + `the receiving component`, el);
            const { name: name, dynamic: dynamic } = $69b5f56b6d1ac1d8$var$getSlotName(slotBinding);
            el.slotTarget = name;
            el.slotTargetDynamic = dynamic;
            el.slotScope = slotBinding.value || $69b5f56b6d1ac1d8$var$emptySlotScopeToken; // force it into a scoped slot for perf
        }
    } else {
        // v-slot on component, denotes default slot
        const slotBinding = $69b5f56b6d1ac1d8$var$getAndRemoveAttrByRegex(el, $69b5f56b6d1ac1d8$var$slotRE);
        if (slotBinding) {
            if (!$69b5f56b6d1ac1d8$var$maybeComponent(el)) $69b5f56b6d1ac1d8$var$warn(`v-slot can only be used on components or <template>.`, slotBinding);
            if (el.slotScope || el.slotTarget) $69b5f56b6d1ac1d8$var$warn(`Unexpected mixed usage of different slot syntaxes.`, el);
            if (el.scopedSlots) $69b5f56b6d1ac1d8$var$warn(`To avoid scope ambiguity, the default slot should also use ` + `<template> syntax when there are other named slots.`, slotBinding);
            // add the component's children to its default slot
            const slots = el.scopedSlots || (el.scopedSlots = {});
            const { name: name, dynamic: dynamic } = $69b5f56b6d1ac1d8$var$getSlotName(slotBinding);
            const slotContainer = slots[name] = $69b5f56b6d1ac1d8$var$createASTElement('template', [], el);
            slotContainer.slotTarget = name;
            slotContainer.slotTargetDynamic = dynamic;
            slotContainer.children = el.children.filter((c)=>{
                if (!c.slotScope) {
                    c.parent = slotContainer;
                    return true;
                }
            });
            slotContainer.slotScope = slotBinding.value || $69b5f56b6d1ac1d8$var$emptySlotScopeToken;
            // remove children as they are returned from scopedSlots now
            el.children = [];
            // mark el non-plain so data gets generated
            el.plain = false;
        }
    }
}
function $69b5f56b6d1ac1d8$var$getSlotName(binding) {
    let name = binding.name.replace($69b5f56b6d1ac1d8$var$slotRE, '');
    if (!name) {
        if (binding.name[0] !== '#') name = 'default';
        else $69b5f56b6d1ac1d8$var$warn(`v-slot shorthand syntax requires a slot name.`, binding);
    }
    return $69b5f56b6d1ac1d8$var$dynamicArgRE.test(name) ? {
        name: name.slice(1, -1),
        dynamic: true
    } : {
        name: `"${name}"`,
        dynamic: false
    };
}
// handle <slot/> outlets
function $69b5f56b6d1ac1d8$var$processSlotOutlet(el) {
    if (el.tag === 'slot') {
        el.slotName = $69b5f56b6d1ac1d8$var$getBindingAttr(el, 'name');
        if (el.key) $69b5f56b6d1ac1d8$var$warn(`\`key\` does not work on <slot> because slots are abstract outlets ` + `and can possibly expand into multiple elements. ` + `Use the key on a wrapping element instead.`, $69b5f56b6d1ac1d8$var$getRawBindingAttr(el, 'key'));
    }
}
function $69b5f56b6d1ac1d8$var$processComponent(el) {
    let binding;
    if (binding = $69b5f56b6d1ac1d8$var$getBindingAttr(el, 'is')) el.component = binding;
    if ($69b5f56b6d1ac1d8$var$getAndRemoveAttr(el, 'inline-template') != null) el.inlineTemplate = true;
}
function $69b5f56b6d1ac1d8$var$processAttrs(el) {
    const list = el.attrsList;
    let i, l, name, rawName, value, modifiers, syncGen, isDynamic;
    for(i = 0, l = list.length; i < l; i++){
        name = rawName = list[i].name;
        value = list[i].value;
        if ($69b5f56b6d1ac1d8$var$dirRE.test(name)) {
            // mark element as dynamic
            el.hasBindings = true;
            // modifiers
            modifiers = $69b5f56b6d1ac1d8$var$parseModifiers(name.replace($69b5f56b6d1ac1d8$var$dirRE, ''));
            // support .foo shorthand syntax for the .prop modifier
            if (modifiers) name = name.replace($69b5f56b6d1ac1d8$var$modifierRE, '');
            if ($69b5f56b6d1ac1d8$var$bindRE.test(name)) {
                // v-bind
                name = name.replace($69b5f56b6d1ac1d8$var$bindRE, '');
                value = $69b5f56b6d1ac1d8$var$parseFilters(value);
                isDynamic = $69b5f56b6d1ac1d8$var$dynamicArgRE.test(name);
                if (isDynamic) name = name.slice(1, -1);
                if (value.trim().length === 0) $69b5f56b6d1ac1d8$var$warn(`The value for a v-bind expression cannot be empty. Found in "v-bind:${name}"`);
                if (modifiers) {
                    if (modifiers.prop && !isDynamic) {
                        name = $69b5f56b6d1ac1d8$var$camelize(name);
                        if (name === 'innerHtml') name = 'innerHTML';
                    }
                    if (modifiers.camel && !isDynamic) name = $69b5f56b6d1ac1d8$var$camelize(name);
                    if (modifiers.sync) {
                        syncGen = $69b5f56b6d1ac1d8$var$genAssignmentCode(value, `$event`);
                        if (!isDynamic) {
                            $69b5f56b6d1ac1d8$var$addHandler(el, `update:${$69b5f56b6d1ac1d8$var$camelize(name)}`, syncGen, null, false, $69b5f56b6d1ac1d8$var$warn, list[i]);
                            if ($69b5f56b6d1ac1d8$var$hyphenate(name) !== $69b5f56b6d1ac1d8$var$camelize(name)) $69b5f56b6d1ac1d8$var$addHandler(el, `update:${$69b5f56b6d1ac1d8$var$hyphenate(name)}`, syncGen, null, false, $69b5f56b6d1ac1d8$var$warn, list[i]);
                        } else // handler w/ dynamic event name
                        $69b5f56b6d1ac1d8$var$addHandler(el, `"update:"+(${name})`, syncGen, null, false, $69b5f56b6d1ac1d8$var$warn, list[i], true // dynamic
                        );
                    }
                }
                if (modifiers && modifiers.prop || !el.component && $69b5f56b6d1ac1d8$var$platformMustUseProp(el.tag, el.attrsMap.type, name)) $69b5f56b6d1ac1d8$var$addProp(el, name, value, list[i], isDynamic);
                else $69b5f56b6d1ac1d8$var$addAttr(el, name, value, list[i], isDynamic);
            } else if ($69b5f56b6d1ac1d8$var$onRE.test(name)) {
                // v-on
                name = name.replace($69b5f56b6d1ac1d8$var$onRE, '');
                isDynamic = $69b5f56b6d1ac1d8$var$dynamicArgRE.test(name);
                if (isDynamic) name = name.slice(1, -1);
                $69b5f56b6d1ac1d8$var$addHandler(el, name, value, modifiers, false, $69b5f56b6d1ac1d8$var$warn, list[i], isDynamic);
            } else {
                // normal directives
                name = name.replace($69b5f56b6d1ac1d8$var$dirRE, '');
                // parse arg
                const argMatch = name.match($69b5f56b6d1ac1d8$var$argRE);
                let arg = argMatch && argMatch[1];
                isDynamic = false;
                if (arg) {
                    name = name.slice(0, -(arg.length + 1));
                    if ($69b5f56b6d1ac1d8$var$dynamicArgRE.test(arg)) {
                        arg = arg.slice(1, -1);
                        isDynamic = true;
                    }
                }
                $69b5f56b6d1ac1d8$var$addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
                if (name === 'model') $69b5f56b6d1ac1d8$var$checkForAliasModel(el, value);
            }
        } else {
            // literal attribute
            {
                const res = $69b5f56b6d1ac1d8$var$parseText(value, $69b5f56b6d1ac1d8$var$delimiters);
                if (res) $69b5f56b6d1ac1d8$var$warn(`${name}="${value}": ` + 'Interpolation inside attributes has been removed. ' + 'Use v-bind or the colon shorthand instead. For example, ' + 'instead of <div id="{{ val }}">, use <div :id="val">.', list[i]);
            }
            $69b5f56b6d1ac1d8$var$addAttr(el, name, JSON.stringify(value), list[i]);
            // #6887 firefox doesn't update muted state if set via attribute
            // even immediately after element creation
            if (!el.component && name === 'muted' && $69b5f56b6d1ac1d8$var$platformMustUseProp(el.tag, el.attrsMap.type, name)) $69b5f56b6d1ac1d8$var$addProp(el, name, 'true', list[i]);
        }
    }
}
function $69b5f56b6d1ac1d8$var$checkInFor(el) {
    let parent = el;
    while(parent){
        if (parent.for !== undefined) return true;
        parent = parent.parent;
    }
    return false;
}
function $69b5f56b6d1ac1d8$var$parseModifiers(name) {
    const match = name.match($69b5f56b6d1ac1d8$var$modifierRE);
    if (match) {
        const ret = {};
        match.forEach((m)=>{
            ret[m.slice(1)] = true;
        });
        return ret;
    }
}
function $69b5f56b6d1ac1d8$var$makeAttrsMap(attrs) {
    const map = {};
    for(let i = 0, l = attrs.length; i < l; i++){
        if (map[attrs[i].name] && !$69b5f56b6d1ac1d8$var$isIE && !$69b5f56b6d1ac1d8$var$isEdge) $69b5f56b6d1ac1d8$var$warn('duplicate attribute: ' + attrs[i].name, attrs[i]);
        map[attrs[i].name] = attrs[i].value;
    }
    return map;
}
// for script (e.g. type="x/template") or style, do not decode content
function $69b5f56b6d1ac1d8$var$isTextTag(el) {
    return el.tag === 'script' || el.tag === 'style';
}
function $69b5f56b6d1ac1d8$var$isForbiddenTag(el) {
    return el.tag === 'style' || el.tag === 'script' && (!el.attrsMap.type || el.attrsMap.type === 'text/javascript');
}
const $69b5f56b6d1ac1d8$var$ieNSBug = /^xmlns:NS\d+/;
const $69b5f56b6d1ac1d8$var$ieNSPrefix = /^NS\d+:/;
/* istanbul ignore next */ function $69b5f56b6d1ac1d8$var$guardIESVGBug(attrs) {
    const res = [];
    for(let i = 0; i < attrs.length; i++){
        const attr = attrs[i];
        if (!$69b5f56b6d1ac1d8$var$ieNSBug.test(attr.name)) {
            attr.name = attr.name.replace($69b5f56b6d1ac1d8$var$ieNSPrefix, '');
            res.push(attr);
        }
    }
    return res;
}
function $69b5f56b6d1ac1d8$var$checkForAliasModel(el, value) {
    let _el = el;
    while(_el){
        if (_el.for && _el.alias === value) $69b5f56b6d1ac1d8$var$warn(`<${el.tag} v-model="${value}">: ` + `You are binding v-model directly to a v-for iteration alias. ` + `This will not be able to modify the v-for source array because ` + `writing to the alias is like modifying a function local variable. ` + `Consider using an array of objects and use v-model on an object property instead.`, el.rawAttrsMap['v-model']);
        _el = _el.parent;
    }
}
/**
 * Expand input[v-model] with dynamic type bindings into v-if-else chains
 * Turn this:
 *   <input v-model="data[type]" :type="type">
 * into this:
 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
 *   <input v-else :type="type" v-model="data[type]">
 */ function $69b5f56b6d1ac1d8$var$preTransformNode(el, options) {
    if (el.tag === 'input') {
        const map = el.attrsMap;
        if (!map['v-model']) return;
        let typeBinding;
        if (map[':type'] || map['v-bind:type']) typeBinding = $69b5f56b6d1ac1d8$var$getBindingAttr(el, 'type');
        if (!map.type && !typeBinding && map['v-bind']) typeBinding = `(${map['v-bind']}).type`;
        if (typeBinding) {
            const ifCondition = $69b5f56b6d1ac1d8$var$getAndRemoveAttr(el, 'v-if', true);
            const ifConditionExtra = ifCondition ? `&&(${ifCondition})` : ``;
            const hasElse = $69b5f56b6d1ac1d8$var$getAndRemoveAttr(el, 'v-else', true) != null;
            const elseIfCondition = $69b5f56b6d1ac1d8$var$getAndRemoveAttr(el, 'v-else-if', true);
            // 1. checkbox
            const branch0 = $69b5f56b6d1ac1d8$var$cloneASTElement(el);
            // process for on the main node
            $69b5f56b6d1ac1d8$var$processFor(branch0);
            $69b5f56b6d1ac1d8$var$addRawAttr(branch0, 'type', 'checkbox');
            $69b5f56b6d1ac1d8$var$processElement(branch0, options);
            branch0.processed = true; // prevent it from double-processed
            branch0.if = `(${typeBinding})==='checkbox'` + ifConditionExtra;
            $69b5f56b6d1ac1d8$var$addIfCondition(branch0, {
                exp: branch0.if,
                block: branch0
            });
            // 2. add radio else-if condition
            const branch1 = $69b5f56b6d1ac1d8$var$cloneASTElement(el);
            $69b5f56b6d1ac1d8$var$getAndRemoveAttr(branch1, 'v-for', true);
            $69b5f56b6d1ac1d8$var$addRawAttr(branch1, 'type', 'radio');
            $69b5f56b6d1ac1d8$var$processElement(branch1, options);
            $69b5f56b6d1ac1d8$var$addIfCondition(branch0, {
                exp: `(${typeBinding})==='radio'` + ifConditionExtra,
                block: branch1
            });
            // 3. other
            const branch2 = $69b5f56b6d1ac1d8$var$cloneASTElement(el);
            $69b5f56b6d1ac1d8$var$getAndRemoveAttr(branch2, 'v-for', true);
            $69b5f56b6d1ac1d8$var$addRawAttr(branch2, ':type', typeBinding);
            $69b5f56b6d1ac1d8$var$processElement(branch2, options);
            $69b5f56b6d1ac1d8$var$addIfCondition(branch0, {
                exp: ifCondition,
                block: branch2
            });
            if (hasElse) branch0.else = true;
            else if (elseIfCondition) branch0.elseif = elseIfCondition;
            return branch0;
        }
    }
}
function $69b5f56b6d1ac1d8$var$cloneASTElement(el) {
    return $69b5f56b6d1ac1d8$var$createASTElement(el.tag, el.attrsList.slice(), el.parent);
}
var $69b5f56b6d1ac1d8$var$model = {
    preTransformNode: $69b5f56b6d1ac1d8$var$preTransformNode
};
var $69b5f56b6d1ac1d8$var$modules = [
    $69b5f56b6d1ac1d8$var$klass,
    $69b5f56b6d1ac1d8$var$style,
    $69b5f56b6d1ac1d8$var$model
];
function $69b5f56b6d1ac1d8$var$text(el, dir) {
    if (dir.value) $69b5f56b6d1ac1d8$var$addProp(el, 'textContent', `_s(${dir.value})`, dir);
}
function $69b5f56b6d1ac1d8$var$html(el, dir) {
    if (dir.value) $69b5f56b6d1ac1d8$var$addProp(el, 'innerHTML', `_s(${dir.value})`, dir);
}
var $69b5f56b6d1ac1d8$var$directives = {
    model: $69b5f56b6d1ac1d8$var$model$1,
    text: $69b5f56b6d1ac1d8$var$text,
    html: $69b5f56b6d1ac1d8$var$html
};
const $69b5f56b6d1ac1d8$var$baseOptions = {
    expectHTML: true,
    modules: $69b5f56b6d1ac1d8$var$modules,
    directives: $69b5f56b6d1ac1d8$var$directives,
    isPreTag: $69b5f56b6d1ac1d8$var$isPreTag,
    isUnaryTag: $69b5f56b6d1ac1d8$var$isUnaryTag,
    mustUseProp: $69b5f56b6d1ac1d8$var$mustUseProp,
    canBeLeftOpenTag: $69b5f56b6d1ac1d8$var$canBeLeftOpenTag,
    isReservedTag: $69b5f56b6d1ac1d8$var$isReservedTag,
    getTagNamespace: $69b5f56b6d1ac1d8$var$getTagNamespace,
    staticKeys: $69b5f56b6d1ac1d8$var$genStaticKeys$1($69b5f56b6d1ac1d8$var$modules)
};
let $69b5f56b6d1ac1d8$var$isStaticKey;
let $69b5f56b6d1ac1d8$var$isPlatformReservedTag;
const $69b5f56b6d1ac1d8$var$genStaticKeysCached = $69b5f56b6d1ac1d8$var$cached($69b5f56b6d1ac1d8$var$genStaticKeys);
/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */ function $69b5f56b6d1ac1d8$var$optimize(root, options) {
    if (!root) return;
    $69b5f56b6d1ac1d8$var$isStaticKey = $69b5f56b6d1ac1d8$var$genStaticKeysCached(options.staticKeys || '');
    $69b5f56b6d1ac1d8$var$isPlatformReservedTag = options.isReservedTag || $69b5f56b6d1ac1d8$var$no;
    // first pass: mark all non-static nodes.
    $69b5f56b6d1ac1d8$var$markStatic(root);
    // second pass: mark static roots.
    $69b5f56b6d1ac1d8$var$markStaticRoots(root, false);
}
function $69b5f56b6d1ac1d8$var$genStaticKeys(keys) {
    return $69b5f56b6d1ac1d8$var$makeMap('type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' + (keys ? ',' + keys : ''));
}
function $69b5f56b6d1ac1d8$var$markStatic(node) {
    node.static = $69b5f56b6d1ac1d8$var$isStatic(node);
    if (node.type === 1) {
        // do not make component slot content static. this avoids
        // 1. components not able to mutate slot nodes
        // 2. static slot content fails for hot-reloading
        if (!$69b5f56b6d1ac1d8$var$isPlatformReservedTag(node.tag) && node.tag !== 'slot' && node.attrsMap['inline-template'] == null) return;
        for(let i = 0, l = node.children.length; i < l; i++){
            const child = node.children[i];
            $69b5f56b6d1ac1d8$var$markStatic(child);
            if (!child.static) node.static = false;
        }
        if (node.ifConditions) for(let i = 1, l = node.ifConditions.length; i < l; i++){
            const block = node.ifConditions[i].block;
            $69b5f56b6d1ac1d8$var$markStatic(block);
            if (!block.static) node.static = false;
        }
    }
}
function $69b5f56b6d1ac1d8$var$markStaticRoots(node, isInFor) {
    if (node.type === 1) {
        if (node.static || node.once) node.staticInFor = isInFor;
        // For a node to qualify as a static root, it should have children that
        // are not just static text. Otherwise the cost of hoisting out will
        // outweigh the benefits and it's better off to just always render it fresh.
        if (node.static && node.children.length && !(node.children.length === 1 && node.children[0].type === 3)) {
            node.staticRoot = true;
            return;
        } else node.staticRoot = false;
        if (node.children) for(let i = 0, l = node.children.length; i < l; i++)$69b5f56b6d1ac1d8$var$markStaticRoots(node.children[i], isInFor || !!node.for);
        if (node.ifConditions) for(let i = 1, l = node.ifConditions.length; i < l; i++)$69b5f56b6d1ac1d8$var$markStaticRoots(node.ifConditions[i].block, isInFor);
    }
}
function $69b5f56b6d1ac1d8$var$isStatic(node) {
    if (node.type === 2) // expression
    return false;
    if (node.type === 3) // text
    return true;
    return !!(node.pre || !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !$69b5f56b6d1ac1d8$var$isBuiltInTag(node.tag) && // not a built-in
    $69b5f56b6d1ac1d8$var$isPlatformReservedTag(node.tag) && // not a component
    !$69b5f56b6d1ac1d8$var$isDirectChildOfTemplateFor(node) && Object.keys(node).every($69b5f56b6d1ac1d8$var$isStaticKey));
}
function $69b5f56b6d1ac1d8$var$isDirectChildOfTemplateFor(node) {
    while(node.parent){
        node = node.parent;
        if (node.tag !== 'template') return false;
        if (node.for) return true;
    }
    return false;
}
const $69b5f56b6d1ac1d8$var$fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
const $69b5f56b6d1ac1d8$var$fnInvokeRE = /\([^)]*?\);*$/;
const $69b5f56b6d1ac1d8$var$simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;
// KeyboardEvent.keyCode aliases
const $69b5f56b6d1ac1d8$var$keyCodes = {
    esc: 27,
    tab: 9,
    enter: 13,
    space: 32,
    up: 38,
    left: 37,
    right: 39,
    down: 40,
    delete: [
        8,
        46
    ]
};
// KeyboardEvent.key aliases
const $69b5f56b6d1ac1d8$var$keyNames = {
    // #7880: IE11 and Edge use `Esc` for Escape key name.
    esc: [
        'Esc',
        'Escape'
    ],
    tab: 'Tab',
    enter: 'Enter',
    // #9112: IE11 uses `Spacebar` for Space key name.
    space: [
        ' ',
        'Spacebar'
    ],
    // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
    up: [
        'Up',
        'ArrowUp'
    ],
    left: [
        'Left',
        'ArrowLeft'
    ],
    right: [
        'Right',
        'ArrowRight'
    ],
    down: [
        'Down',
        'ArrowDown'
    ],
    // #9112: IE11 uses `Del` for Delete key name.
    delete: [
        'Backspace',
        'Delete',
        'Del'
    ]
};
// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
const $69b5f56b6d1ac1d8$var$genGuard = (condition)=>`if(${condition})return null;`;
const $69b5f56b6d1ac1d8$var$modifierCode = {
    stop: '$event.stopPropagation();',
    prevent: '$event.preventDefault();',
    self: $69b5f56b6d1ac1d8$var$genGuard(`$event.target !== $event.currentTarget`),
    ctrl: $69b5f56b6d1ac1d8$var$genGuard(`!$event.ctrlKey`),
    shift: $69b5f56b6d1ac1d8$var$genGuard(`!$event.shiftKey`),
    alt: $69b5f56b6d1ac1d8$var$genGuard(`!$event.altKey`),
    meta: $69b5f56b6d1ac1d8$var$genGuard(`!$event.metaKey`),
    left: $69b5f56b6d1ac1d8$var$genGuard(`'button' in $event && $event.button !== 0`),
    middle: $69b5f56b6d1ac1d8$var$genGuard(`'button' in $event && $event.button !== 1`),
    right: $69b5f56b6d1ac1d8$var$genGuard(`'button' in $event && $event.button !== 2`)
};
function $69b5f56b6d1ac1d8$var$genHandlers(events, isNative) {
    const prefix = isNative ? 'nativeOn:' : 'on:';
    let staticHandlers = ``;
    let dynamicHandlers = ``;
    for(const name in events){
        const handlerCode = $69b5f56b6d1ac1d8$var$genHandler(events[name]);
        //@ts-expect-error
        if (events[name] && events[name].dynamic) dynamicHandlers += `${name},${handlerCode},`;
        else staticHandlers += `"${name}":${handlerCode},`;
    }
    staticHandlers = `{${staticHandlers.slice(0, -1)}}`;
    if (dynamicHandlers) return prefix + `_d(${staticHandlers},[${dynamicHandlers.slice(0, -1)}])`;
    else return prefix + staticHandlers;
}
function $69b5f56b6d1ac1d8$var$genHandler(handler) {
    if (!handler) return 'function(){}';
    if (Array.isArray(handler)) return `[${handler.map((handler)=>$69b5f56b6d1ac1d8$var$genHandler(handler)).join(',')}]`;
    const isMethodPath = $69b5f56b6d1ac1d8$var$simplePathRE.test(handler.value);
    const isFunctionExpression = $69b5f56b6d1ac1d8$var$fnExpRE.test(handler.value);
    const isFunctionInvocation = $69b5f56b6d1ac1d8$var$simplePathRE.test(handler.value.replace($69b5f56b6d1ac1d8$var$fnInvokeRE, ''));
    if (!handler.modifiers) {
        if (isMethodPath || isFunctionExpression) return handler.value;
        return `function($event){${isFunctionInvocation ? `return ${handler.value}` : handler.value}}`; // inline statement
    } else {
        let code = '';
        let genModifierCode = '';
        const keys = [];
        for(const key in handler.modifiers){
            if ($69b5f56b6d1ac1d8$var$modifierCode[key]) {
                genModifierCode += $69b5f56b6d1ac1d8$var$modifierCode[key];
                // left/right
                if ($69b5f56b6d1ac1d8$var$keyCodes[key]) keys.push(key);
            } else if (key === 'exact') {
                const modifiers = handler.modifiers;
                genModifierCode += $69b5f56b6d1ac1d8$var$genGuard([
                    'ctrl',
                    'shift',
                    'alt',
                    'meta'
                ].filter((keyModifier)=>!modifiers[keyModifier]).map((keyModifier)=>`$event.${keyModifier}Key`).join('||'));
            } else keys.push(key);
        }
        if (keys.length) code += $69b5f56b6d1ac1d8$var$genKeyFilter(keys);
        // Make sure modifiers like prevent and stop get executed after key filtering
        if (genModifierCode) code += genModifierCode;
        const handlerCode = isMethodPath ? `return ${handler.value}.apply(null, arguments)` : isFunctionExpression ? `return (${handler.value}).apply(null, arguments)` : isFunctionInvocation ? `return ${handler.value}` : handler.value;
        return `function($event){${code}${handlerCode}}`;
    }
}
function $69b5f56b6d1ac1d8$var$genKeyFilter(keys) {
    return(// make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    `if(!$event.type.indexOf('key')&&` + `${keys.map($69b5f56b6d1ac1d8$var$genFilterCode).join('&&')})return null;`);
}
function $69b5f56b6d1ac1d8$var$genFilterCode(key) {
    const keyVal = parseInt(key, 10);
    if (keyVal) return `$event.keyCode!==${keyVal}`;
    const keyCode = $69b5f56b6d1ac1d8$var$keyCodes[key];
    const keyName = $69b5f56b6d1ac1d8$var$keyNames[key];
    return `_k($event.keyCode,` + `${JSON.stringify(key)},` + `${JSON.stringify(keyCode)},` + `$event.key,` + `${JSON.stringify(keyName)}` + `)`;
}
function $69b5f56b6d1ac1d8$var$on(el, dir) {
    if (dir.modifiers) $69b5f56b6d1ac1d8$var$warn$2(`v-on without argument does not support modifiers.`);
    el.wrapListeners = (code)=>`_g(${code},${dir.value})`;
}
function $69b5f56b6d1ac1d8$var$bind(el, dir) {
    el.wrapData = (code)=>{
        return `_b(${code},'${el.tag}',${dir.value},${dir.modifiers && dir.modifiers.prop ? 'true' : 'false'}${dir.modifiers && dir.modifiers.sync ? ',true' : ''})`;
    };
}
var $69b5f56b6d1ac1d8$var$baseDirectives = {
    on: $69b5f56b6d1ac1d8$var$on,
    bind: $69b5f56b6d1ac1d8$var$bind,
    cloak: $69b5f56b6d1ac1d8$var$noop
};
class $69b5f56b6d1ac1d8$var$CodegenState {
    constructor(options){
        this.options = options;
        this.warn = options.warn || $69b5f56b6d1ac1d8$var$baseWarn;
        this.transforms = $69b5f56b6d1ac1d8$var$pluckModuleFunction(options.modules, 'transformCode');
        this.dataGenFns = $69b5f56b6d1ac1d8$var$pluckModuleFunction(options.modules, 'genData');
        this.directives = $69b5f56b6d1ac1d8$var$extend($69b5f56b6d1ac1d8$var$extend({}, $69b5f56b6d1ac1d8$var$baseDirectives), options.directives);
        const isReservedTag = options.isReservedTag || $69b5f56b6d1ac1d8$var$no;
        this.maybeComponent = (el)=>!!el.component || !isReservedTag(el.tag);
        this.onceId = 0;
        this.staticRenderFns = [];
        this.pre = false;
    }
}
function $69b5f56b6d1ac1d8$var$generate(ast, options) {
    const state = new $69b5f56b6d1ac1d8$var$CodegenState(options);
    // fix #11483, Root level <script> tags should not be rendered.
    const code = ast ? ast.tag === 'script' ? 'null' : $69b5f56b6d1ac1d8$var$genElement(ast, state) : '_c("div")';
    return {
        render: `with(this){return ${code}}`,
        staticRenderFns: state.staticRenderFns
    };
}
function $69b5f56b6d1ac1d8$var$genElement(el, state) {
    if (el.parent) el.pre = el.pre || el.parent.pre;
    if (el.staticRoot && !el.staticProcessed) return $69b5f56b6d1ac1d8$var$genStatic(el, state);
    else if (el.once && !el.onceProcessed) return $69b5f56b6d1ac1d8$var$genOnce(el, state);
    else if (el.for && !el.forProcessed) return $69b5f56b6d1ac1d8$var$genFor(el, state);
    else if (el.if && !el.ifProcessed) return $69b5f56b6d1ac1d8$var$genIf(el, state);
    else if (el.tag === 'template' && !el.slotTarget && !state.pre) return $69b5f56b6d1ac1d8$var$genChildren(el, state) || 'void 0';
    else if (el.tag === 'slot') return $69b5f56b6d1ac1d8$var$genSlot(el, state);
    else {
        // component or element
        let code;
        if (el.component) code = $69b5f56b6d1ac1d8$var$genComponent(el.component, el, state);
        else {
            let data;
            const maybeComponent = state.maybeComponent(el);
            if (!el.plain || el.pre && maybeComponent) data = $69b5f56b6d1ac1d8$var$genData(el, state);
            let tag;
            // check if this is a component in <script setup>
            const bindings = state.options.bindings;
            if (maybeComponent && bindings && bindings.__isScriptSetup !== false) tag = $69b5f56b6d1ac1d8$var$checkBindingType(bindings, el.tag);
            if (!tag) tag = `'${el.tag}'`;
            const children = el.inlineTemplate ? null : $69b5f56b6d1ac1d8$var$genChildren(el, state, true);
            code = `_c(${tag}${data ? `,${data}` : '' // data
            }${children ? `,${children}` : '' // children
            })`;
        }
        // module transforms
        for(let i = 0; i < state.transforms.length; i++)code = state.transforms[i](el, code);
        return code;
    }
}
function $69b5f56b6d1ac1d8$var$checkBindingType(bindings, key) {
    const camelName = $69b5f56b6d1ac1d8$var$camelize(key);
    const PascalName = $69b5f56b6d1ac1d8$var$capitalize(camelName);
    const checkType = (type)=>{
        if (bindings[key] === type) return key;
        if (bindings[camelName] === type) return camelName;
        if (bindings[PascalName] === type) return PascalName;
    };
    const fromConst = checkType("setup-const" /* BindingTypes.SETUP_CONST */ ) || checkType("setup-reactive-const" /* BindingTypes.SETUP_REACTIVE_CONST */ );
    if (fromConst) return fromConst;
    const fromMaybeRef = checkType("setup-let" /* BindingTypes.SETUP_LET */ ) || checkType("setup-ref" /* BindingTypes.SETUP_REF */ ) || checkType("setup-maybe-ref" /* BindingTypes.SETUP_MAYBE_REF */ );
    if (fromMaybeRef) return fromMaybeRef;
}
// hoist static sub-trees out
function $69b5f56b6d1ac1d8$var$genStatic(el, state) {
    el.staticProcessed = true;
    // Some elements (templates) need to behave differently inside of a v-pre
    // node.  All pre nodes are static roots, so we can use this as a location to
    // wrap a state change and reset it upon exiting the pre node.
    const originalPreState = state.pre;
    if (el.pre) state.pre = el.pre;
    state.staticRenderFns.push(`with(this){return ${$69b5f56b6d1ac1d8$var$genElement(el, state)}}`);
    state.pre = originalPreState;
    return `_m(${state.staticRenderFns.length - 1}${el.staticInFor ? ',true' : ''})`;
}
// v-once
function $69b5f56b6d1ac1d8$var$genOnce(el, state) {
    el.onceProcessed = true;
    if (el.if && !el.ifProcessed) return $69b5f56b6d1ac1d8$var$genIf(el, state);
    else if (el.staticInFor) {
        let key = '';
        let parent = el.parent;
        while(parent){
            if (parent.for) {
                key = parent.key;
                break;
            }
            parent = parent.parent;
        }
        if (!key) {
            state.warn(`v-once can only be used inside v-for that is keyed. `, el.rawAttrsMap['v-once']);
            return $69b5f56b6d1ac1d8$var$genElement(el, state);
        }
        return `_o(${$69b5f56b6d1ac1d8$var$genElement(el, state)},${state.onceId++},${key})`;
    } else return $69b5f56b6d1ac1d8$var$genStatic(el, state);
}
function $69b5f56b6d1ac1d8$var$genIf(el, state, altGen, altEmpty) {
    el.ifProcessed = true; // avoid recursion
    return $69b5f56b6d1ac1d8$var$genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty);
}
function $69b5f56b6d1ac1d8$var$genIfConditions(conditions, state, altGen, altEmpty) {
    if (!conditions.length) return altEmpty || '_e()';
    const condition = conditions.shift();
    if (condition.exp) return `(${condition.exp})?${genTernaryExp(condition.block)}:${$69b5f56b6d1ac1d8$var$genIfConditions(conditions, state, altGen, altEmpty)}`;
    else return `${genTernaryExp(condition.block)}`;
    // v-if with v-once should generate code like (a)?_m(0):_m(1)
    function genTernaryExp(el) {
        return altGen ? altGen(el, state) : el.once ? $69b5f56b6d1ac1d8$var$genOnce(el, state) : $69b5f56b6d1ac1d8$var$genElement(el, state);
    }
}
function $69b5f56b6d1ac1d8$var$genFor(el, state, altGen, altHelper) {
    const exp = el.for;
    const alias = el.alias;
    const iterator1 = el.iterator1 ? `,${el.iterator1}` : '';
    const iterator2 = el.iterator2 ? `,${el.iterator2}` : '';
    if (state.maybeComponent(el) && el.tag !== 'slot' && el.tag !== 'template' && !el.key) state.warn(`<${el.tag} v-for="${alias} in ${exp}">: component lists rendered with ` + `v-for should have explicit keys. ` + `See https://v2.vuejs.org/v2/guide/list.html#key for more info.`, el.rawAttrsMap['v-for'], true);
    el.forProcessed = true; // avoid recursion
    return `${altHelper || '_l'}((${exp}),` + `function(${alias}${iterator1}${iterator2}){` + `return ${(altGen || $69b5f56b6d1ac1d8$var$genElement)(el, state)}` + '})';
}
function $69b5f56b6d1ac1d8$var$genData(el, state) {
    let data = '{';
    // directives first.
    // directives may mutate the el's other properties before they are generated.
    const dirs = $69b5f56b6d1ac1d8$var$genDirectives(el, state);
    if (dirs) data += dirs + ',';
    // key
    if (el.key) data += `key:${el.key},`;
    // ref
    if (el.ref) data += `ref:${el.ref},`;
    if (el.refInFor) data += `refInFor:true,`;
    // pre
    if (el.pre) data += `pre:true,`;
    // record original tag name for components using "is" attribute
    if (el.component) data += `tag:"${el.tag}",`;
    // module data generation functions
    for(let i = 0; i < state.dataGenFns.length; i++)data += state.dataGenFns[i](el);
    // attributes
    if (el.attrs) data += `attrs:${$69b5f56b6d1ac1d8$var$genProps(el.attrs)},`;
    // DOM props
    if (el.props) data += `domProps:${$69b5f56b6d1ac1d8$var$genProps(el.props)},`;
    // event handlers
    if (el.events) data += `${$69b5f56b6d1ac1d8$var$genHandlers(el.events, false)},`;
    if (el.nativeEvents) data += `${$69b5f56b6d1ac1d8$var$genHandlers(el.nativeEvents, true)},`;
    // slot target
    // only for non-scoped slots
    if (el.slotTarget && !el.slotScope) data += `slot:${el.slotTarget},`;
    // scoped slots
    if (el.scopedSlots) data += `${$69b5f56b6d1ac1d8$var$genScopedSlots(el, el.scopedSlots, state)},`;
    // component v-model
    if (el.model) data += `model:{value:${el.model.value},callback:${el.model.callback},expression:${el.model.expression}},`;
    // inline-template
    if (el.inlineTemplate) {
        const inlineTemplate = $69b5f56b6d1ac1d8$var$genInlineTemplate(el, state);
        if (inlineTemplate) data += `${inlineTemplate},`;
    }
    data = data.replace(/,$/, '') + '}';
    // v-bind dynamic argument wrap
    // v-bind with dynamic arguments must be applied using the same v-bind object
    // merge helper so that class/style/mustUseProp attrs are handled correctly.
    if (el.dynamicAttrs) data = `_b(${data},"${el.tag}",${$69b5f56b6d1ac1d8$var$genProps(el.dynamicAttrs)})`;
    // v-bind data wrap
    if (el.wrapData) data = el.wrapData(data);
    // v-on data wrap
    if (el.wrapListeners) data = el.wrapListeners(data);
    return data;
}
function $69b5f56b6d1ac1d8$var$genDirectives(el, state) {
    const dirs = el.directives;
    if (!dirs) return;
    let res = 'directives:[';
    let hasRuntime = false;
    let i, l, dir, needRuntime;
    for(i = 0, l = dirs.length; i < l; i++){
        dir = dirs[i];
        needRuntime = true;
        const gen = state.directives[dir.name];
        if (gen) // compile-time directive that manipulates AST.
        // returns true if it also needs a runtime counterpart.
        needRuntime = !!gen(el, dir, state.warn);
        if (needRuntime) {
            hasRuntime = true;
            res += `{name:"${dir.name}",rawName:"${dir.rawName}"${dir.value ? `,value:(${dir.value}),expression:${JSON.stringify(dir.value)}` : ''}${dir.arg ? `,arg:${dir.isDynamicArg ? dir.arg : `"${dir.arg}"`}` : ''}${dir.modifiers ? `,modifiers:${JSON.stringify(dir.modifiers)}` : ''}},`;
        }
    }
    if (hasRuntime) return res.slice(0, -1) + ']';
}
function $69b5f56b6d1ac1d8$var$genInlineTemplate(el, state) {
    const ast = el.children[0];
    if (el.children.length !== 1 || ast.type !== 1) state.warn('Inline-template components must have exactly one child element.', {
        start: el.start
    });
    if (ast && ast.type === 1) {
        const inlineRenderFns = $69b5f56b6d1ac1d8$var$generate(ast, state.options);
        return `inlineTemplate:{render:function(){${inlineRenderFns.render}},staticRenderFns:[${inlineRenderFns.staticRenderFns.map((code)=>`function(){${code}}`).join(',')}]}`;
    }
}
function $69b5f56b6d1ac1d8$var$genScopedSlots(el, slots, state) {
    // by default scoped slots are considered "stable", this allows child
    // components with only scoped slots to skip forced updates from parent.
    // but in some cases we have to bail-out of this optimization
    // for example if the slot contains dynamic names, has v-if or v-for on them...
    let needsForceUpdate = el.for || Object.keys(slots).some((key)=>{
        const slot = slots[key];
        return slot.slotTargetDynamic || slot.if || slot.for || $69b5f56b6d1ac1d8$var$containsSlotChild(slot) // is passing down slot from parent which may be dynamic
        ;
    });
    // #9534: if a component with scoped slots is inside a conditional branch,
    // it's possible for the same component to be reused but with different
    // compiled slot content. To avoid that, we generate a unique key based on
    // the generated code of all the slot contents.
    let needsKey = !!el.if;
    // OR when it is inside another scoped slot or v-for (the reactivity may be
    // disconnected due to the intermediate scope variable)
    // #9438, #9506
    // TODO: this can be further optimized by properly analyzing in-scope bindings
    // and skip force updating ones that do not actually use scope variables.
    if (!needsForceUpdate) {
        let parent = el.parent;
        while(parent){
            if (parent.slotScope && parent.slotScope !== $69b5f56b6d1ac1d8$var$emptySlotScopeToken || parent.for) {
                needsForceUpdate = true;
                break;
            }
            if (parent.if) needsKey = true;
            parent = parent.parent;
        }
    }
    const generatedSlots = Object.keys(slots).map((key)=>$69b5f56b6d1ac1d8$var$genScopedSlot(slots[key], state)).join(',');
    return `scopedSlots:_u([${generatedSlots}]${needsForceUpdate ? `,null,true` : ``}${!needsForceUpdate && needsKey ? `,null,false,${$69b5f56b6d1ac1d8$var$hash(generatedSlots)}` : ``})`;
}
function $69b5f56b6d1ac1d8$var$hash(str) {
    let hash = 5381;
    let i = str.length;
    while(i)hash = hash * 33 ^ str.charCodeAt(--i);
    return hash >>> 0;
}
function $69b5f56b6d1ac1d8$var$containsSlotChild(el) {
    if (el.type === 1) {
        if (el.tag === 'slot') return true;
        return el.children.some($69b5f56b6d1ac1d8$var$containsSlotChild);
    }
    return false;
}
function $69b5f56b6d1ac1d8$var$genScopedSlot(el, state) {
    const isLegacySyntax = el.attrsMap['slot-scope'];
    if (el.if && !el.ifProcessed && !isLegacySyntax) return $69b5f56b6d1ac1d8$var$genIf(el, state, $69b5f56b6d1ac1d8$var$genScopedSlot, `null`);
    if (el.for && !el.forProcessed) return $69b5f56b6d1ac1d8$var$genFor(el, state, $69b5f56b6d1ac1d8$var$genScopedSlot);
    const slotScope = el.slotScope === $69b5f56b6d1ac1d8$var$emptySlotScopeToken ? `` : String(el.slotScope);
    const fn = `function(${slotScope}){` + `return ${el.tag === 'template' ? el.if && isLegacySyntax ? `(${el.if})?${$69b5f56b6d1ac1d8$var$genChildren(el, state) || 'undefined'}:undefined` : $69b5f56b6d1ac1d8$var$genChildren(el, state) || 'undefined' : $69b5f56b6d1ac1d8$var$genElement(el, state)}}`;
    // reverse proxy v-slot without scope on this.$slots
    const reverseProxy = slotScope ? `` : `,proxy:true`;
    return `{key:${el.slotTarget || `"default"`},fn:${fn}${reverseProxy}}`;
}
function $69b5f56b6d1ac1d8$var$genChildren(el, state, checkSkip, altGenElement, altGenNode) {
    const children = el.children;
    if (children.length) {
        const el = children[0];
        // optimize single v-for
        if (children.length === 1 && el.for && el.tag !== 'template' && el.tag !== 'slot') {
            const normalizationType = checkSkip ? state.maybeComponent(el) ? `,1` : `,0` : ``;
            return `${(altGenElement || $69b5f56b6d1ac1d8$var$genElement)(el, state)}${normalizationType}`;
        }
        const normalizationType = checkSkip ? $69b5f56b6d1ac1d8$var$getNormalizationType(children, state.maybeComponent) : 0;
        const gen = altGenNode || $69b5f56b6d1ac1d8$var$genNode;
        return `[${children.map((c)=>gen(c, state)).join(',')}]${normalizationType ? `,${normalizationType}` : ''}`;
    }
}
// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function $69b5f56b6d1ac1d8$var$getNormalizationType(children, maybeComponent) {
    let res = 0;
    for(let i = 0; i < children.length; i++){
        const el = children[i];
        if (el.type !== 1) continue;
        if ($69b5f56b6d1ac1d8$var$needsNormalization(el) || el.ifConditions && el.ifConditions.some((c)=>$69b5f56b6d1ac1d8$var$needsNormalization(c.block))) {
            res = 2;
            break;
        }
        if (maybeComponent(el) || el.ifConditions && el.ifConditions.some((c)=>maybeComponent(c.block))) res = 1;
    }
    return res;
}
function $69b5f56b6d1ac1d8$var$needsNormalization(el) {
    return el.for !== undefined || el.tag === 'template' || el.tag === 'slot';
}
function $69b5f56b6d1ac1d8$var$genNode(node, state) {
    if (node.type === 1) return $69b5f56b6d1ac1d8$var$genElement(node, state);
    else if (node.type === 3 && node.isComment) return $69b5f56b6d1ac1d8$var$genComment(node);
    else return $69b5f56b6d1ac1d8$var$genText(node);
}
function $69b5f56b6d1ac1d8$var$genText(text) {
    return `_v(${text.type === 2 ? text.expression // no need for () because already wrapped in _s()
     : $69b5f56b6d1ac1d8$var$transformSpecialNewlines(JSON.stringify(text.text))})`;
}
function $69b5f56b6d1ac1d8$var$genComment(comment) {
    return `_e(${JSON.stringify(comment.text)})`;
}
function $69b5f56b6d1ac1d8$var$genSlot(el, state) {
    const slotName = el.slotName || '"default"';
    const children = $69b5f56b6d1ac1d8$var$genChildren(el, state);
    let res = `_t(${slotName}${children ? `,function(){return ${children}}` : ''}`;
    const attrs = el.attrs || el.dynamicAttrs ? $69b5f56b6d1ac1d8$var$genProps((el.attrs || []).concat(el.dynamicAttrs || []).map((attr)=>({
            // slot props are camelized
            name: $69b5f56b6d1ac1d8$var$camelize(attr.name),
            value: attr.value,
            dynamic: attr.dynamic
        }))) : null;
    const bind = el.attrsMap['v-bind'];
    if ((attrs || bind) && !children) res += `,null`;
    if (attrs) res += `,${attrs}`;
    if (bind) res += `${attrs ? '' : ',null'},${bind}`;
    return res + ')';
}
// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function $69b5f56b6d1ac1d8$var$genComponent(componentName, el, state) {
    const children = el.inlineTemplate ? null : $69b5f56b6d1ac1d8$var$genChildren(el, state, true);
    return `_c(${componentName},${$69b5f56b6d1ac1d8$var$genData(el, state)}${children ? `,${children}` : ''})`;
}
function $69b5f56b6d1ac1d8$var$genProps(props) {
    let staticProps = ``;
    let dynamicProps = ``;
    for(let i = 0; i < props.length; i++){
        const prop = props[i];
        const value = $69b5f56b6d1ac1d8$var$transformSpecialNewlines(prop.value);
        if (prop.dynamic) dynamicProps += `${prop.name},${value},`;
        else staticProps += `"${prop.name}":${value},`;
    }
    staticProps = `{${staticProps.slice(0, -1)}}`;
    if (dynamicProps) return `_d(${staticProps},[${dynamicProps.slice(0, -1)}])`;
    else return staticProps;
}
// #3895, #4268
function $69b5f56b6d1ac1d8$var$transformSpecialNewlines(text) {
    return text.replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
}
// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
const $69b5f56b6d1ac1d8$var$prohibitedKeywordRE = new RegExp('\\b' + "do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,super,throw,while,yield,delete,export,import,return,switch,default,extends,finally,continue,debugger,function,arguments".split(',').join('\\b|\\b') + '\\b');
// these unary operators should not be used as property/method names
const $69b5f56b6d1ac1d8$var$unaryOperatorsRE = new RegExp('\\b' + 'delete,typeof,void'.split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');
// strip strings in expressions
const $69b5f56b6d1ac1d8$var$stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
// detect problematic expressions in a template
function $69b5f56b6d1ac1d8$var$detectErrors(ast, warn) {
    if (ast) $69b5f56b6d1ac1d8$var$checkNode(ast, warn);
}
function $69b5f56b6d1ac1d8$var$checkNode(node, warn) {
    if (node.type === 1) {
        for(const name in node.attrsMap)if ($69b5f56b6d1ac1d8$var$dirRE.test(name)) {
            const value = node.attrsMap[name];
            if (value) {
                const range = node.rawAttrsMap[name];
                if (name === 'v-for') $69b5f56b6d1ac1d8$var$checkFor(node, `v-for="${value}"`, warn, range);
                else if (name === 'v-slot' || name[0] === '#') $69b5f56b6d1ac1d8$var$checkFunctionParameterExpression(value, `${name}="${value}"`, warn, range);
                else if ($69b5f56b6d1ac1d8$var$onRE.test(name)) $69b5f56b6d1ac1d8$var$checkEvent(value, `${name}="${value}"`, warn, range);
                else $69b5f56b6d1ac1d8$var$checkExpression(value, `${name}="${value}"`, warn, range);
            }
        }
        if (node.children) for(let i = 0; i < node.children.length; i++)$69b5f56b6d1ac1d8$var$checkNode(node.children[i], warn);
    } else if (node.type === 2) $69b5f56b6d1ac1d8$var$checkExpression(node.expression, node.text, warn, node);
}
function $69b5f56b6d1ac1d8$var$checkEvent(exp, text, warn, range) {
    const stripped = exp.replace($69b5f56b6d1ac1d8$var$stripStringRE, '');
    const keywordMatch = stripped.match($69b5f56b6d1ac1d8$var$unaryOperatorsRE);
    if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') warn(`avoid using JavaScript unary operator as property name: ` + `"${keywordMatch[0]}" in expression ${text.trim()}`, range);
    $69b5f56b6d1ac1d8$var$checkExpression(exp, text, warn, range);
}
function $69b5f56b6d1ac1d8$var$checkFor(node, text, warn, range) {
    $69b5f56b6d1ac1d8$var$checkExpression(node.for || '', text, warn, range);
    $69b5f56b6d1ac1d8$var$checkIdentifier(node.alias, 'v-for alias', text, warn, range);
    $69b5f56b6d1ac1d8$var$checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
    $69b5f56b6d1ac1d8$var$checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}
function $69b5f56b6d1ac1d8$var$checkIdentifier(ident, type, text, warn, range) {
    if (typeof ident === 'string') try {
        new Function(`var ${ident}=_`);
    } catch (e) {
        warn(`invalid ${type} "${ident}" in expression: ${text.trim()}`, range);
    }
}
function $69b5f56b6d1ac1d8$var$checkExpression(exp, text, warn, range) {
    try {
        new Function(`return ${exp}`);
    } catch (e) {
        const keywordMatch = exp.replace($69b5f56b6d1ac1d8$var$stripStringRE, '').match($69b5f56b6d1ac1d8$var$prohibitedKeywordRE);
        if (keywordMatch) warn(`avoid using JavaScript keyword as property name: ` + `"${keywordMatch[0]}"\n  Raw expression: ${text.trim()}`, range);
        else warn(`invalid expression: ${e.message} in\n\n` + `    ${exp}\n\n` + `  Raw expression: ${text.trim()}\n`, range);
    }
}
function $69b5f56b6d1ac1d8$var$checkFunctionParameterExpression(exp, text, warn, range) {
    try {
        new Function(exp, '');
    } catch (e) {
        warn(`invalid function parameter expression: ${e.message} in\n\n` + `    ${exp}\n\n` + `  Raw expression: ${text.trim()}\n`, range);
    }
}
const $69b5f56b6d1ac1d8$var$range = 2;
function $69b5f56b6d1ac1d8$var$generateCodeFrame(source, start = 0, end = source.length) {
    const lines = source.split(/\r?\n/);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + 1;
        if (count >= start) {
            for(let j = i - $69b5f56b6d1ac1d8$var$range; j <= i + $69b5f56b6d1ac1d8$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                res.push(`${j + 1}${$69b5f56b6d1ac1d8$var$repeat(` `, 3 - String(j + 1).length)}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                if (j === i) {
                    // push underline
                    const pad = start - (count - lineLength) + 1;
                    const length = end > count ? lineLength - pad : end - start;
                    res.push(`   |  ` + $69b5f56b6d1ac1d8$var$repeat(` `, pad) + $69b5f56b6d1ac1d8$var$repeat(`^`, length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.min(end - count, lineLength);
                        res.push(`   |  ` + $69b5f56b6d1ac1d8$var$repeat(`^`, length));
                    }
                    count += lineLength + 1;
                }
            }
            break;
        }
    }
    return res.join('\n');
}
function $69b5f56b6d1ac1d8$var$repeat(str, n) {
    let result = '';
    if (n > 0) // eslint-disable-next-line no-constant-condition
    while(true){
        // eslint-disable-line
        if (n & 1) result += str;
        n >>>= 1;
        if (n <= 0) break;
        str += str;
    }
    return result;
}
function $69b5f56b6d1ac1d8$var$createFunction(code, errors) {
    try {
        return new Function(code);
    } catch (err) {
        errors.push({
            err: err,
            code: code
        });
        return $69b5f56b6d1ac1d8$var$noop;
    }
}
function $69b5f56b6d1ac1d8$var$createCompileToFunctionFn(compile) {
    const cache = Object.create(null);
    return function compileToFunctions(template, options, vm) {
        options = $69b5f56b6d1ac1d8$var$extend({}, options);
        const warn = options.warn || $69b5f56b6d1ac1d8$var$warn$2;
        delete options.warn;
        // detect possible CSP restriction
        try {
            new Function('return 1');
        } catch (e) {
            if (e.toString().match(/unsafe-eval|CSP/)) warn("It seems you are using the standalone build of Vue.js in an environment with Content Security Policy that prohibits unsafe-eval. The template compiler cannot work in this environment. Consider relaxing the policy to allow unsafe-eval or pre-compiling your templates into render functions.");
        }
        // check cache
        const key = options.delimiters ? String(options.delimiters) + template : template;
        if (cache[key]) return cache[key];
        // compile
        const compiled = compile(template, options);
        if (compiled.errors && compiled.errors.length) {
            if (options.outputSourceRange) compiled.errors.forEach((e)=>{
                warn(`Error compiling template:\n\n${e.msg}\n\n` + $69b5f56b6d1ac1d8$var$generateCodeFrame(template, e.start, e.end), vm);
            });
            else warn(`Error compiling template:\n\n${template}\n\n` + compiled.errors.map((e)=>`- ${e}`).join('\n') + '\n', vm);
        }
        if (compiled.tips && compiled.tips.length) {
            if (options.outputSourceRange) compiled.tips.forEach((e)=>$69b5f56b6d1ac1d8$var$tip(e.msg, vm));
            else compiled.tips.forEach((msg)=>$69b5f56b6d1ac1d8$var$tip(msg, vm));
        }
        // turn code into functions
        const res = {};
        const fnGenErrors = [];
        res.render = $69b5f56b6d1ac1d8$var$createFunction(compiled.render, fnGenErrors);
        res.staticRenderFns = compiled.staticRenderFns.map((code)=>{
            return $69b5f56b6d1ac1d8$var$createFunction(code, fnGenErrors);
        });
        if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) warn(`Failed to generate render function:\n\n` + fnGenErrors.map(({ err: err, code: code })=>`${err.toString()} in\n\n${code}\n`).join('\n'), vm);
        return cache[key] = res;
    };
}
function $69b5f56b6d1ac1d8$var$createCompilerCreator(baseCompile) {
    return function createCompiler(baseOptions) {
        function compile(template, options) {
            const finalOptions = Object.create(baseOptions);
            const errors = [];
            const tips = [];
            let warn = (msg, range, tip)=>{
                (tip ? tips : errors).push(msg);
            };
            if (options) {
                if (options.outputSourceRange) {
                    // $flow-disable-line
                    const leadingSpaceLength = template.match(/^\s*/)[0].length;
                    warn = (msg, range, tip)=>{
                        const data = typeof msg === 'string' ? {
                            msg: msg
                        } : msg;
                        if (range) {
                            if (range.start != null) data.start = range.start + leadingSpaceLength;
                            if (range.end != null) data.end = range.end + leadingSpaceLength;
                        }
                        (tip ? tips : errors).push(data);
                    };
                }
                // merge custom modules
                if (options.modules) finalOptions.modules = (baseOptions.modules || []).concat(options.modules);
                // merge custom directives
                if (options.directives) finalOptions.directives = $69b5f56b6d1ac1d8$var$extend(Object.create(baseOptions.directives || null), options.directives);
                // copy other options
                for(const key in options)if (key !== 'modules' && key !== 'directives') finalOptions[key] = options[key];
            }
            finalOptions.warn = warn;
            const compiled = baseCompile(template.trim(), finalOptions);
            $69b5f56b6d1ac1d8$var$detectErrors(compiled.ast, warn);
            compiled.errors = errors;
            compiled.tips = tips;
            return compiled;
        }
        return {
            compile: compile,
            compileToFunctions: $69b5f56b6d1ac1d8$var$createCompileToFunctionFn(compile)
        };
    };
}
// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
const $69b5f56b6d1ac1d8$var$createCompiler = $69b5f56b6d1ac1d8$var$createCompilerCreator(function baseCompile(template, options) {
    const ast = $69b5f56b6d1ac1d8$var$parse(template.trim(), options);
    if (options.optimize !== false) $69b5f56b6d1ac1d8$var$optimize(ast, options);
    const code = $69b5f56b6d1ac1d8$var$generate(ast, options);
    return {
        ast: ast,
        render: code.render,
        staticRenderFns: code.staticRenderFns
    };
});
const { compile: $69b5f56b6d1ac1d8$var$compile, compileToFunctions: $69b5f56b6d1ac1d8$var$compileToFunctions } = $69b5f56b6d1ac1d8$var$createCompiler($69b5f56b6d1ac1d8$var$baseOptions);
// check whether current browser encodes a char inside attribute values
let $69b5f56b6d1ac1d8$var$div;
function $69b5f56b6d1ac1d8$var$getShouldDecode(href) {
    $69b5f56b6d1ac1d8$var$div = $69b5f56b6d1ac1d8$var$div || document.createElement('div');
    $69b5f56b6d1ac1d8$var$div.innerHTML = href ? `<a href="\n"/>` : `<div a="\n"/>`;
    return $69b5f56b6d1ac1d8$var$div.innerHTML.indexOf('&#10;') > 0;
}
// #3663: IE encodes newlines inside attribute values while other browsers don't
const $69b5f56b6d1ac1d8$var$shouldDecodeNewlines = $69b5f56b6d1ac1d8$var$inBrowser ? $69b5f56b6d1ac1d8$var$getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
const $69b5f56b6d1ac1d8$var$shouldDecodeNewlinesForHref = $69b5f56b6d1ac1d8$var$inBrowser ? $69b5f56b6d1ac1d8$var$getShouldDecode(true) : false;
const $69b5f56b6d1ac1d8$var$idToTemplate = $69b5f56b6d1ac1d8$var$cached((id)=>{
    const el = $69b5f56b6d1ac1d8$var$query(id);
    return el && el.innerHTML;
});
const $69b5f56b6d1ac1d8$var$mount = $69b5f56b6d1ac1d8$var$Vue.prototype.$mount;
$69b5f56b6d1ac1d8$var$Vue.prototype.$mount = function(el, hydrating) {
    el = el && $69b5f56b6d1ac1d8$var$query(el);
    /* istanbul ignore if */ if (el === document.body || el === document.documentElement) {
        $69b5f56b6d1ac1d8$var$warn$2(`Do not mount Vue to <html> or <body> - mount to normal elements instead.`);
        return this;
    }
    const options = this.$options;
    // resolve template/el and convert to render function
    if (!options.render) {
        let template = options.template;
        if (template) {
            if (typeof template === 'string') {
                if (template.charAt(0) === '#') {
                    template = $69b5f56b6d1ac1d8$var$idToTemplate(template);
                    /* istanbul ignore if */ if (!template) $69b5f56b6d1ac1d8$var$warn$2(`Template element not found or is empty: ${options.template}`, this);
                }
            } else if (template.nodeType) template = template.innerHTML;
            else {
                $69b5f56b6d1ac1d8$var$warn$2('invalid template option:' + template, this);
                return this;
            }
        } else if (el) // @ts-expect-error
        template = $69b5f56b6d1ac1d8$var$getOuterHTML(el);
        if (template) {
            /* istanbul ignore if */ if ($69b5f56b6d1ac1d8$var$config.performance && $69b5f56b6d1ac1d8$var$mark) $69b5f56b6d1ac1d8$var$mark('compile');
            const { render: render, staticRenderFns: staticRenderFns } = $69b5f56b6d1ac1d8$var$compileToFunctions(template, {
                outputSourceRange: true,
                shouldDecodeNewlines: $69b5f56b6d1ac1d8$var$shouldDecodeNewlines,
                shouldDecodeNewlinesForHref: $69b5f56b6d1ac1d8$var$shouldDecodeNewlinesForHref,
                delimiters: options.delimiters,
                comments: options.comments
            }, this);
            options.render = render;
            options.staticRenderFns = staticRenderFns;
            /* istanbul ignore if */ if ($69b5f56b6d1ac1d8$var$config.performance && $69b5f56b6d1ac1d8$var$mark) {
                $69b5f56b6d1ac1d8$var$mark('compile end');
                $69b5f56b6d1ac1d8$var$measure(`vue ${this._name} compile`, 'compile', 'compile end');
            }
        }
    }
    return $69b5f56b6d1ac1d8$var$mount.call(this, el, hydrating);
};
/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */ function $69b5f56b6d1ac1d8$var$getOuterHTML(el) {
    if (el.outerHTML) return el.outerHTML;
    else {
        const container = document.createElement('div');
        container.appendChild(el.cloneNode(true));
        return container.innerHTML;
    }
}
$69b5f56b6d1ac1d8$var$Vue.compile = $69b5f56b6d1ac1d8$var$compileToFunctions;
// export type EffectScheduler = (...args: any[]) => any
/**
 * @internal since we are not exposing this in Vue 2, it's used only for
 * internal testing.
 */ function $69b5f56b6d1ac1d8$var$effect(fn, scheduler) {
    const watcher = new $69b5f56b6d1ac1d8$var$Watcher($69b5f56b6d1ac1d8$var$currentInstance, fn, $69b5f56b6d1ac1d8$var$noop, {
        sync: true
    });
    if (scheduler) watcher.update = ()=>{
        scheduler(()=>watcher.run());
    };
}
$69b5f56b6d1ac1d8$var$extend($69b5f56b6d1ac1d8$var$Vue, $69b5f56b6d1ac1d8$var$vca);
$69b5f56b6d1ac1d8$var$Vue.effect = $69b5f56b6d1ac1d8$var$effect;
module.exports = $69b5f56b6d1ac1d8$var$Vue;

});

parcelRegister("2hMr9", function(module, exports) {




/*!
 * Outlayer v2.1.1
 * the brains and guts of a layout library
 * MIT license
 */ (function(window1, factory) {
    'use strict';
    // universal module definition
    /* jshint strict: false */ /* globals define, module, require */ if (typeof define == 'function' && define.amd) // AMD - RequireJS
    define([
        'ev-emitter/ev-emitter',
        'get-size/get-size',
        'fizzy-ui-utils/utils',
        './item'
    ], function(EvEmitter, getSize, utils, Item) {
        return factory(window1, EvEmitter, getSize, utils, Item);
    });
    else if (0, module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory(window1, (parcelRequire("kWDtA")), (parcelRequire("lDySy")), (parcelRequire("22N8l")), (parcelRequire("2BL98")));
    else // browser global
    window1.Outlayer = factory(window1, window1.EvEmitter, window1.getSize, window1.fizzyUIUtils, window1.Outlayer.Item);
})(window, function factory(window1, EvEmitter, getSize, utils, Item) {
    'use strict';
    // ----- vars ----- //
    var console = window1.console;
    var jQuery = window1.jQuery;
    var noop = function() {};
    // -------------------------- Outlayer -------------------------- //
    // globally unique identifiers
    var GUID = 0;
    // internal store of all Outlayer intances
    var instances = {};
    /**
 * @param {Element, String} element
 * @param {Object} options
 * @constructor
 */ function Outlayer(element, options) {
        var queryElement = utils.getQueryElement(element);
        if (!queryElement) {
            if (console) console.error('Bad element for ' + this.constructor.namespace + ': ' + (queryElement || element));
            return;
        }
        this.element = queryElement;
        // add jQuery
        if (jQuery) this.$element = jQuery(this.element);
        // options
        this.options = utils.extend({}, this.constructor.defaults);
        this.option(options);
        // add id for Outlayer.getFromElement
        var id = ++GUID;
        this.element.outlayerGUID = id; // expando
        instances[id] = this; // associate via id
        // kick it off
        this._create();
        var isInitLayout = this._getOption('initLayout');
        if (isInitLayout) this.layout();
    }
    // settings are for internal use only
    Outlayer.namespace = 'outlayer';
    Outlayer.Item = Item;
    // default options
    Outlayer.defaults = {
        containerStyle: {
            position: 'relative'
        },
        initLayout: true,
        originLeft: true,
        originTop: true,
        resize: true,
        resizeContainer: true,
        // item options
        transitionDuration: '0.4s',
        hiddenStyle: {
            opacity: 0,
            transform: 'scale(0.001)'
        },
        visibleStyle: {
            opacity: 1,
            transform: 'scale(1)'
        }
    };
    var proto = Outlayer.prototype;
    // inherit EvEmitter
    utils.extend(proto, EvEmitter.prototype);
    /**
 * set options
 * @param {Object} opts
 */ proto.option = function(opts) {
        utils.extend(this.options, opts);
    };
    /**
 * get backwards compatible option value, check old name
 */ proto._getOption = function(option) {
        var oldOption = this.constructor.compatOptions[option];
        return oldOption && this.options[oldOption] !== undefined ? this.options[oldOption] : this.options[option];
    };
    Outlayer.compatOptions = {
        // currentName: oldName
        initLayout: 'isInitLayout',
        horizontal: 'isHorizontal',
        layoutInstant: 'isLayoutInstant',
        originLeft: 'isOriginLeft',
        originTop: 'isOriginTop',
        resize: 'isResizeBound',
        resizeContainer: 'isResizingContainer'
    };
    proto._create = function() {
        // get items from children
        this.reloadItems();
        // elements that affect layout, but are not laid out
        this.stamps = [];
        this.stamp(this.options.stamp);
        // set container style
        utils.extend(this.element.style, this.options.containerStyle);
        // bind resize method
        var canBindResize = this._getOption('resize');
        if (canBindResize) this.bindResize();
    };
    // goes through all children again and gets bricks in proper order
    proto.reloadItems = function() {
        // collection of item elements
        this.items = this._itemize(this.element.children);
    };
    /**
 * turn elements into Outlayer.Items to be used in layout
 * @param {Array or NodeList or HTMLElement} elems
 * @returns {Array} items - collection of new Outlayer Items
 */ proto._itemize = function(elems) {
        var itemElems = this._filterFindItemElements(elems);
        var Item = this.constructor.Item;
        // create new Outlayer Items for collection
        var items = [];
        for(var i = 0; i < itemElems.length; i++){
            var elem = itemElems[i];
            var item = new Item(elem, this);
            items.push(item);
        }
        return items;
    };
    /**
 * get item elements to be used in layout
 * @param {Array or NodeList or HTMLElement} elems
 * @returns {Array} items - item elements
 */ proto._filterFindItemElements = function(elems) {
        return utils.filterFindElements(elems, this.options.itemSelector);
    };
    /**
 * getter method for getting item elements
 * @returns {Array} elems - collection of item elements
 */ proto.getItemElements = function() {
        return this.items.map(function(item) {
            return item.element;
        });
    };
    // ----- init & layout ----- //
    /**
 * lays out all items
 */ proto.layout = function() {
        this._resetLayout();
        this._manageStamps();
        // don't animate first layout
        var layoutInstant = this._getOption('layoutInstant');
        var isInstant = layoutInstant !== undefined ? layoutInstant : !this._isLayoutInited;
        this.layoutItems(this.items, isInstant);
        // flag for initalized
        this._isLayoutInited = true;
    };
    // _init is alias for layout
    proto._init = proto.layout;
    /**
 * logic before any new layout
 */ proto._resetLayout = function() {
        this.getSize();
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
    };
    /**
 * get measurement from option, for columnWidth, rowHeight, gutter
 * if option is String -> get element from selector string, & get size of element
 * if option is Element -> get size of element
 * else use option as a number
 *
 * @param {String} measurement
 * @param {String} size - width or height
 * @private
 */ proto._getMeasurement = function(measurement, size) {
        var option = this.options[measurement];
        var elem;
        if (!option) // default to 0
        this[measurement] = 0;
        else {
            // use option as an element
            if (typeof option == 'string') elem = this.element.querySelector(option);
            else if (option instanceof HTMLElement) elem = option;
            // use size of element, if element
            this[measurement] = elem ? getSize(elem)[size] : option;
        }
    };
    /**
 * layout a collection of item elements
 * @api public
 */ proto.layoutItems = function(items, isInstant) {
        items = this._getItemsForLayout(items);
        this._layoutItems(items, isInstant);
        this._postLayout();
    };
    /**
 * get the items to be laid out
 * you may want to skip over some items
 * @param {Array} items
 * @returns {Array} items
 */ proto._getItemsForLayout = function(items) {
        return items.filter(function(item) {
            return !item.isIgnored;
        });
    };
    /**
 * layout items
 * @param {Array} items
 * @param {Boolean} isInstant
 */ proto._layoutItems = function(items, isInstant) {
        this._emitCompleteOnItems('layout', items);
        if (!items || !items.length) // no items, emit event with empty array
        return;
        var queue = [];
        items.forEach(function(item) {
            // get x/y object from method
            var position = this._getItemLayoutPosition(item);
            // enqueue
            position.item = item;
            position.isInstant = isInstant || item.isLayoutInstant;
            queue.push(position);
        }, this);
        this._processLayoutQueue(queue);
    };
    /**
 * get item layout position
 * @param {Outlayer.Item} item
 * @returns {Object} x and y position
 */ proto._getItemLayoutPosition = function() {
        return {
            x: 0,
            y: 0
        };
    };
    /**
 * iterate over array and position each item
 * Reason being - separating this logic prevents 'layout invalidation'
 * thx @paul_irish
 * @param {Array} queue
 */ proto._processLayoutQueue = function(queue) {
        this.updateStagger();
        queue.forEach(function(obj, i) {
            this._positionItem(obj.item, obj.x, obj.y, obj.isInstant, i);
        }, this);
    };
    // set stagger from option in milliseconds number
    proto.updateStagger = function() {
        var stagger = this.options.stagger;
        if (stagger === null || stagger === undefined) {
            this.stagger = 0;
            return;
        }
        this.stagger = getMilliseconds(stagger);
        return this.stagger;
    };
    /**
 * Sets position of item in DOM
 * @param {Outlayer.Item} item
 * @param {Number} x - horizontal position
 * @param {Number} y - vertical position
 * @param {Boolean} isInstant - disables transitions
 */ proto._positionItem = function(item, x, y, isInstant, i) {
        if (isInstant) // if not transition, just set CSS
        item.goTo(x, y);
        else {
            item.stagger(i * this.stagger);
            item.moveTo(x, y);
        }
    };
    /**
 * Any logic you want to do after each layout,
 * i.e. size the container
 */ proto._postLayout = function() {
        this.resizeContainer();
    };
    proto.resizeContainer = function() {
        var isResizingContainer = this._getOption('resizeContainer');
        if (!isResizingContainer) return;
        var size = this._getContainerSize();
        if (size) {
            this._setContainerMeasure(size.width, true);
            this._setContainerMeasure(size.height, false);
        }
    };
    /**
 * Sets width or height of container if returned
 * @returns {Object} size
 *   @param {Number} width
 *   @param {Number} height
 */ proto._getContainerSize = noop;
    /**
 * @param {Number} measure - size of width or height
 * @param {Boolean} isWidth
 */ proto._setContainerMeasure = function(measure, isWidth) {
        if (measure === undefined) return;
        var elemSize = this.size;
        // add padding and border width if border box
        if (elemSize.isBorderBox) measure += isWidth ? elemSize.paddingLeft + elemSize.paddingRight + elemSize.borderLeftWidth + elemSize.borderRightWidth : elemSize.paddingBottom + elemSize.paddingTop + elemSize.borderTopWidth + elemSize.borderBottomWidth;
        measure = Math.max(measure, 0);
        this.element.style[isWidth ? 'width' : 'height'] = measure + 'px';
    };
    /**
 * emit eventComplete on a collection of items events
 * @param {String} eventName
 * @param {Array} items - Outlayer.Items
 */ proto._emitCompleteOnItems = function(eventName, items) {
        var _this = this;
        function onComplete() {
            _this.dispatchEvent(eventName + 'Complete', null, [
                items
            ]);
        }
        var count = items.length;
        if (!items || !count) {
            onComplete();
            return;
        }
        var doneCount = 0;
        function tick() {
            doneCount++;
            if (doneCount == count) onComplete();
        }
        // bind callback
        items.forEach(function(item) {
            item.once(eventName, tick);
        });
    };
    /**
 * emits events via EvEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */ proto.dispatchEvent = function(type, event, args) {
        // add original event to arguments
        var emitArgs = event ? [
            event
        ].concat(args) : args;
        this.emitEvent(type, emitArgs);
        if (jQuery) {
            // set this.$element
            this.$element = this.$element || jQuery(this.element);
            if (event) {
                // create jQuery event
                var $event = jQuery.Event(event);
                $event.type = type;
                this.$element.trigger($event, args);
            } else // just trigger with type if no event available
            this.$element.trigger(type, args);
        }
    };
    // -------------------------- ignore & stamps -------------------------- //
    /**
 * keep item in collection, but do not lay it out
 * ignored items do not get skipped in layout
 * @param {Element} elem
 */ proto.ignore = function(elem) {
        var item = this.getItem(elem);
        if (item) item.isIgnored = true;
    };
    /**
 * return item to layout collection
 * @param {Element} elem
 */ proto.unignore = function(elem) {
        var item = this.getItem(elem);
        if (item) delete item.isIgnored;
    };
    /**
 * adds elements to stamps
 * @param {NodeList, Array, Element, or String} elems
 */ proto.stamp = function(elems) {
        elems = this._find(elems);
        if (!elems) return;
        this.stamps = this.stamps.concat(elems);
        // ignore
        elems.forEach(this.ignore, this);
    };
    /**
 * removes elements to stamps
 * @param {NodeList, Array, or Element} elems
 */ proto.unstamp = function(elems) {
        elems = this._find(elems);
        if (!elems) return;
        elems.forEach(function(elem) {
            // filter out removed stamp elements
            utils.removeFrom(this.stamps, elem);
            this.unignore(elem);
        }, this);
    };
    /**
 * finds child elements
 * @param {NodeList, Array, Element, or String} elems
 * @returns {Array} elems
 */ proto._find = function(elems) {
        if (!elems) return;
        // if string, use argument as selector string
        if (typeof elems == 'string') elems = this.element.querySelectorAll(elems);
        elems = utils.makeArray(elems);
        return elems;
    };
    proto._manageStamps = function() {
        if (!this.stamps || !this.stamps.length) return;
        this._getBoundingRect();
        this.stamps.forEach(this._manageStamp, this);
    };
    // update boundingLeft / Top
    proto._getBoundingRect = function() {
        // get bounding rect for container element
        var boundingRect = this.element.getBoundingClientRect();
        var size = this.size;
        this._boundingRect = {
            left: boundingRect.left + size.paddingLeft + size.borderLeftWidth,
            top: boundingRect.top + size.paddingTop + size.borderTopWidth,
            right: boundingRect.right - (size.paddingRight + size.borderRightWidth),
            bottom: boundingRect.bottom - (size.paddingBottom + size.borderBottomWidth)
        };
    };
    /**
 * @param {Element} stamp
**/ proto._manageStamp = noop;
    /**
 * get x/y position of element relative to container element
 * @param {Element} elem
 * @returns {Object} offset - has left, top, right, bottom
 */ proto._getElementOffset = function(elem) {
        var boundingRect = elem.getBoundingClientRect();
        var thisRect = this._boundingRect;
        var size = getSize(elem);
        var offset = {
            left: boundingRect.left - thisRect.left - size.marginLeft,
            top: boundingRect.top - thisRect.top - size.marginTop,
            right: thisRect.right - boundingRect.right - size.marginRight,
            bottom: thisRect.bottom - boundingRect.bottom - size.marginBottom
        };
        return offset;
    };
    // -------------------------- resize -------------------------- //
    // enable event handlers for listeners
    // i.e. resize -> onresize
    proto.handleEvent = utils.handleEvent;
    /**
 * Bind layout to window resizing
 */ proto.bindResize = function() {
        window1.addEventListener('resize', this);
        this.isResizeBound = true;
    };
    /**
 * Unbind layout to window resizing
 */ proto.unbindResize = function() {
        window1.removeEventListener('resize', this);
        this.isResizeBound = false;
    };
    proto.onresize = function() {
        this.resize();
    };
    utils.debounceMethod(Outlayer, 'onresize', 100);
    proto.resize = function() {
        // don't trigger if size did not change
        // or if resize was unbound. See #9
        if (!this.isResizeBound || !this.needsResizeLayout()) return;
        this.layout();
    };
    /**
 * check if layout is needed post layout
 * @returns Boolean
 */ proto.needsResizeLayout = function() {
        var size = getSize(this.element);
        // check that this.size and size are there
        // IE8 triggers resize on body size change, so they might not be
        var hasSizes = this.size && size;
        return hasSizes && size.innerWidth !== this.size.innerWidth;
    };
    // -------------------------- methods -------------------------- //
    /**
 * add items to Outlayer instance
 * @param {Array or NodeList or Element} elems
 * @returns {Array} items - Outlayer.Items
**/ proto.addItems = function(elems) {
        var items = this._itemize(elems);
        // add items to collection
        if (items.length) this.items = this.items.concat(items);
        return items;
    };
    /**
 * Layout newly-appended item elements
 * @param {Array or NodeList or Element} elems
 */ proto.appended = function(elems) {
        var items = this.addItems(elems);
        if (!items.length) return;
        // layout and reveal just the new items
        this.layoutItems(items, true);
        this.reveal(items);
    };
    /**
 * Layout prepended elements
 * @param {Array or NodeList or Element} elems
 */ proto.prepended = function(elems) {
        var items = this._itemize(elems);
        if (!items.length) return;
        // add items to beginning of collection
        var previousItems = this.items.slice(0);
        this.items = items.concat(previousItems);
        // start new layout
        this._resetLayout();
        this._manageStamps();
        // layout new stuff without transition
        this.layoutItems(items, true);
        this.reveal(items);
        // layout previous items
        this.layoutItems(previousItems);
    };
    /**
 * reveal a collection of items
 * @param {Array of Outlayer.Items} items
 */ proto.reveal = function(items) {
        this._emitCompleteOnItems('reveal', items);
        if (!items || !items.length) return;
        var stagger = this.updateStagger();
        items.forEach(function(item, i) {
            item.stagger(i * stagger);
            item.reveal();
        });
    };
    /**
 * hide a collection of items
 * @param {Array of Outlayer.Items} items
 */ proto.hide = function(items) {
        this._emitCompleteOnItems('hide', items);
        if (!items || !items.length) return;
        var stagger = this.updateStagger();
        items.forEach(function(item, i) {
            item.stagger(i * stagger);
            item.hide();
        });
    };
    /**
 * reveal item elements
 * @param {Array}, {Element}, {NodeList} items
 */ proto.revealItemElements = function(elems) {
        var items = this.getItems(elems);
        this.reveal(items);
    };
    /**
 * hide item elements
 * @param {Array}, {Element}, {NodeList} items
 */ proto.hideItemElements = function(elems) {
        var items = this.getItems(elems);
        this.hide(items);
    };
    /**
 * get Outlayer.Item, given an Element
 * @param {Element} elem
 * @param {Function} callback
 * @returns {Outlayer.Item} item
 */ proto.getItem = function(elem) {
        // loop through items to get the one that matches
        for(var i = 0; i < this.items.length; i++){
            var item = this.items[i];
            if (item.element == elem) // return item
            return item;
        }
    };
    /**
 * get collection of Outlayer.Items, given Elements
 * @param {Array} elems
 * @returns {Array} items - Outlayer.Items
 */ proto.getItems = function(elems) {
        elems = utils.makeArray(elems);
        var items = [];
        elems.forEach(function(elem) {
            var item = this.getItem(elem);
            if (item) items.push(item);
        }, this);
        return items;
    };
    /**
 * remove element(s) from instance and DOM
 * @param {Array or NodeList or Element} elems
 */ proto.remove = function(elems) {
        var removeItems = this.getItems(elems);
        this._emitCompleteOnItems('remove', removeItems);
        // bail if no items to remove
        if (!removeItems || !removeItems.length) return;
        removeItems.forEach(function(item) {
            item.remove();
            // remove item from collection
            utils.removeFrom(this.items, item);
        }, this);
    };
    // ----- destroy ----- //
    // remove and disable Outlayer instance
    proto.destroy = function() {
        // clean up dynamic styles
        var style = this.element.style;
        style.height = '';
        style.position = '';
        style.width = '';
        // destroy items
        this.items.forEach(function(item) {
            item.destroy();
        });
        this.unbindResize();
        var id = this.element.outlayerGUID;
        delete instances[id]; // remove reference to instance by id
        delete this.element.outlayerGUID;
        // remove data for jQuery
        if (jQuery) jQuery.removeData(this.element, this.constructor.namespace);
    };
    // -------------------------- data -------------------------- //
    /**
 * get Outlayer instance from element
 * @param {Element} elem
 * @returns {Outlayer}
 */ Outlayer.data = function(elem) {
        elem = utils.getQueryElement(elem);
        var id = elem && elem.outlayerGUID;
        return id && instances[id];
    };
    // -------------------------- create Outlayer class -------------------------- //
    /**
 * create a layout class
 * @param {String} namespace
 */ Outlayer.create = function(namespace, options) {
        // sub-class Outlayer
        var Layout = subclass(Outlayer);
        // apply new options and compatOptions
        Layout.defaults = utils.extend({}, Outlayer.defaults);
        utils.extend(Layout.defaults, options);
        Layout.compatOptions = utils.extend({}, Outlayer.compatOptions);
        Layout.namespace = namespace;
        Layout.data = Outlayer.data;
        // sub-class Item
        Layout.Item = subclass(Item);
        // -------------------------- declarative -------------------------- //
        utils.htmlInit(Layout, namespace);
        // -------------------------- jQuery bridge -------------------------- //
        // make into jQuery plugin
        if (jQuery && jQuery.bridget) jQuery.bridget(namespace, Layout);
        return Layout;
    };
    function subclass(Parent) {
        function SubClass() {
            Parent.apply(this, arguments);
        }
        SubClass.prototype = Object.create(Parent.prototype);
        SubClass.prototype.constructor = SubClass;
        return SubClass;
    }
    // ----- helpers ----- //
    // how many milliseconds are in each unit
    var msUnits = {
        ms: 1,
        s: 1000
    };
    // munge time-like parameter into millisecond number
    // '0.4s' -> 40
    function getMilliseconds(time) {
        if (typeof time == 'number') return time;
        var matches = time.match(/(^\d*\.?\d*)(\w*)/);
        var num = matches && matches[1];
        var unit = matches && matches[2];
        if (!num.length) return 0;
        num = parseFloat(num);
        var mult = msUnits[unit] || 1;
        return num * mult;
    }
    // ----- fin ----- //
    // back in global
    Outlayer.Item = Item;
    return Outlayer;
});

});
parcelRegister("kWDtA", function(module, exports) {
/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */ /* jshint unused: true, undef: true, strict: true */ (function(global, factory) {
    // universal module definition
    /* jshint strict: false */ /* globals define, module, window */ if (typeof define == 'function' && define.amd) // AMD - RequireJS
    define(factory);
    else if (0, module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory();
    else // Browser globals
    global.EvEmitter = factory();
})(typeof window != 'undefined' ? window : module.exports, function() {
    "use strict";
    function EvEmitter() {}
    var proto = EvEmitter.prototype;
    proto.on = function(eventName, listener) {
        if (!eventName || !listener) return;
        // set events hash
        var events = this._events = this._events || {};
        // set listeners array
        var listeners = events[eventName] = events[eventName] || [];
        // only add once
        if (listeners.indexOf(listener) == -1) listeners.push(listener);
        return this;
    };
    proto.once = function(eventName, listener) {
        if (!eventName || !listener) return;
        // add event
        this.on(eventName, listener);
        // set once flag
        // set onceEvents hash
        var onceEvents = this._onceEvents = this._onceEvents || {};
        // set onceListeners object
        var onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        // set flag
        onceListeners[listener] = true;
        return this;
    };
    proto.off = function(eventName, listener) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return;
        var index = listeners.indexOf(listener);
        if (index != -1) listeners.splice(index, 1);
        return this;
    };
    proto.emitEvent = function(eventName, args) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return;
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        var onceListeners = this._onceEvents && this._onceEvents[eventName];
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            var isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off(eventName, listener);
                // unset once flag
                delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
        }
        return this;
    };
    proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
    };
    return EvEmitter;
});

});

parcelRegister("lDySy", function(module, exports) {
/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */ /* jshint browser: true, strict: true, undef: true, unused: true */ /* globals console: false */ (function(window1, factory) {
    /* jshint strict: false */ /* globals define, module */ if (typeof define == 'function' && define.amd) // AMD
    define(factory);
    else if (0, module.exports) // CommonJS
    module.exports = factory();
    else // browser global
    window1.getSize = factory();
})(window, function factory() {
    'use strict';
    // -------------------------- helpers -------------------------- //
    // get a number from a string, not a percentage
    function getStyleSize(value) {
        var num = parseFloat(value);
        // not a percent like '100%', and a number
        var isValid = value.indexOf('%') == -1 && !isNaN(num);
        return isValid && num;
    }
    function noop() {}
    var logError = typeof console == 'undefined' ? noop : function(message) {
        console.error(message);
    };
    // -------------------------- measurements -------------------------- //
    var measurements = [
        'paddingLeft',
        'paddingRight',
        'paddingTop',
        'paddingBottom',
        'marginLeft',
        'marginRight',
        'marginTop',
        'marginBottom',
        'borderLeftWidth',
        'borderRightWidth',
        'borderTopWidth',
        'borderBottomWidth'
    ];
    var measurementsLength = measurements.length;
    function getZeroSize() {
        var size = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
        };
        for(var i = 0; i < measurementsLength; i++){
            var measurement = measurements[i];
            size[measurement] = 0;
        }
        return size;
    }
    // -------------------------- getStyle -------------------------- //
    /**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */ function getStyle(elem) {
        var style = getComputedStyle(elem);
        if (!style) logError('Style returned ' + style + '. Are you running this code in a hidden iframe on Firefox? ' + 'See https://bit.ly/getsizebug1');
        return style;
    }
    // -------------------------- setup -------------------------- //
    var isSetup = false;
    var isBoxSizeOuter;
    /**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */ function setup() {
        // setup once
        if (isSetup) return;
        isSetup = true;
        // -------------------------- box sizing -------------------------- //
        /**
   * Chrome & Safari measure the outer-width on style.width on border-box elems
   * IE11 & Firefox<29 measures the inner-width
   */ var div = document.createElement('div');
        div.style.width = '200px';
        div.style.padding = '1px 2px 3px 4px';
        div.style.borderStyle = 'solid';
        div.style.borderWidth = '1px 2px 3px 4px';
        div.style.boxSizing = 'border-box';
        var body = document.body || document.documentElement;
        body.appendChild(div);
        var style = getStyle(div);
        // round value for browser zoom. desandro/masonry#928
        isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
        getSize.isBoxSizeOuter = isBoxSizeOuter;
        body.removeChild(div);
    }
    // -------------------------- getSize -------------------------- //
    function getSize(elem) {
        setup();
        // use querySeletor if elem is string
        if (typeof elem == 'string') elem = document.querySelector(elem);
        // do not proceed on non-objects
        if (!elem || typeof elem != 'object' || !elem.nodeType) return;
        var style = getStyle(elem);
        // if hidden, everything is 0
        if (style.display == 'none') return getZeroSize();
        var size = {};
        size.width = elem.offsetWidth;
        size.height = elem.offsetHeight;
        var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';
        // get all measurements
        for(var i = 0; i < measurementsLength; i++){
            var measurement = measurements[i];
            var value = style[measurement];
            var num = parseFloat(value);
            // any 'auto', 'medium' value will be 0
            size[measurement] = !isNaN(num) ? num : 0;
        }
        var paddingWidth = size.paddingLeft + size.paddingRight;
        var paddingHeight = size.paddingTop + size.paddingBottom;
        var marginWidth = size.marginLeft + size.marginRight;
        var marginHeight = size.marginTop + size.marginBottom;
        var borderWidth = size.borderLeftWidth + size.borderRightWidth;
        var borderHeight = size.borderTopWidth + size.borderBottomWidth;
        var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;
        // overwrite width and height if we can get it from style
        var styleWidth = getStyleSize(style.width);
        if (styleWidth !== false) size.width = styleWidth + // add padding and border unless it's already including it
        (isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
        var styleHeight = getStyleSize(style.height);
        if (styleHeight !== false) size.height = styleHeight + // add padding and border unless it's already including it
        (isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
        size.innerWidth = size.width - (paddingWidth + borderWidth);
        size.innerHeight = size.height - (paddingHeight + borderHeight);
        size.outerWidth = size.width + marginWidth;
        size.outerHeight = size.height + marginHeight;
        return size;
    }
    return getSize;
});

});

parcelRegister("22N8l", function(module, exports) {

/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */ /*jshint browser: true, undef: true, unused: true, strict: true */ (function(window1, factory) {
    // universal module definition
    /*jshint strict: false */ /*globals define, module, require */ if (typeof define == 'function' && define.amd) // AMD
    define([
        'desandro-matches-selector/matches-selector'
    ], function(matchesSelector) {
        return factory(window1, matchesSelector);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("7Farg")));
    else // browser global
    window1.fizzyUIUtils = factory(window1, window1.matchesSelector);
})(window, function factory(window1, matchesSelector) {
    'use strict';
    var utils = {};
    // ----- extend ----- //
    // extends objects
    utils.extend = function(a, b) {
        for(var prop in b)a[prop] = b[prop];
        return a;
    };
    // ----- modulo ----- //
    utils.modulo = function(num, div) {
        return (num % div + div) % div;
    };
    // ----- makeArray ----- //
    var arraySlice = Array.prototype.slice;
    // turn element or nodeList into an array
    utils.makeArray = function(obj) {
        if (Array.isArray(obj)) // use object if already an array
        return obj;
        // return empty array if undefined or null. #6
        if (obj === null || obj === undefined) return [];
        var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
        if (isArrayLike) // convert nodeList to array
        return arraySlice.call(obj);
        // array of single index
        return [
            obj
        ];
    };
    // ----- removeFrom ----- //
    utils.removeFrom = function(ary, obj) {
        var index = ary.indexOf(obj);
        if (index != -1) ary.splice(index, 1);
    };
    // ----- getParent ----- //
    utils.getParent = function(elem, selector) {
        while(elem.parentNode && elem != document.body){
            elem = elem.parentNode;
            if (matchesSelector(elem, selector)) return elem;
        }
    };
    // ----- getQueryElement ----- //
    // use element as selector string
    utils.getQueryElement = function(elem) {
        if (typeof elem == 'string') return document.querySelector(elem);
        return elem;
    };
    // ----- handleEvent ----- //
    // enable .ontype to trigger from .addEventListener( elem, 'type' )
    utils.handleEvent = function(event) {
        var method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    // ----- filterFindElements ----- //
    utils.filterFindElements = function(elems, selector) {
        // make array of elems
        elems = utils.makeArray(elems);
        var ffElems = [];
        elems.forEach(function(elem) {
            // check that elem is an actual element
            if (!(elem instanceof HTMLElement)) return;
            // add elem if no selector
            if (!selector) {
                ffElems.push(elem);
                return;
            }
            // filter & find items if we have a selector
            // filter
            if (matchesSelector(elem, selector)) ffElems.push(elem);
            // find children
            var childElems = elem.querySelectorAll(selector);
            // concat childElems to filterFound array
            for(var i = 0; i < childElems.length; i++)ffElems.push(childElems[i]);
        });
        return ffElems;
    };
    // ----- debounceMethod ----- //
    utils.debounceMethod = function(_class, methodName, threshold) {
        threshold = threshold || 100;
        // original method
        var method = _class.prototype[methodName];
        var timeoutName = methodName + 'Timeout';
        _class.prototype[methodName] = function() {
            var timeout = this[timeoutName];
            clearTimeout(timeout);
            var args = arguments;
            var _this = this;
            this[timeoutName] = setTimeout(function() {
                method.apply(_this, args);
                delete _this[timeoutName];
            }, threshold);
        };
    };
    // ----- docReady ----- //
    utils.docReady = function(callback) {
        var readyState = document.readyState;
        if (readyState == 'complete' || readyState == 'interactive') // do async to allow for other scripts to run. metafizzy/flickity#441
        setTimeout(callback);
        else document.addEventListener('DOMContentLoaded', callback);
    };
    // ----- htmlInit ----- //
    // http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
    utils.toDashed = function(str) {
        return str.replace(/(.)([A-Z])/g, function(match, $1, $2) {
            return $1 + '-' + $2;
        }).toLowerCase();
    };
    var console = window1.console;
    /**
 * allow user to initialize classes via [data-namespace] or .js-namespace class
 * htmlInit( Widget, 'widgetName' )
 * options are parsed from data-namespace-options
 */ utils.htmlInit = function(WidgetClass, namespace) {
        utils.docReady(function() {
            var dashedNamespace = utils.toDashed(namespace);
            var dataAttr = 'data-' + dashedNamespace;
            var dataAttrElems = document.querySelectorAll('[' + dataAttr + ']');
            var jsDashElems = document.querySelectorAll('.js-' + dashedNamespace);
            var elems = utils.makeArray(dataAttrElems).concat(utils.makeArray(jsDashElems));
            var dataOptionsAttr = dataAttr + '-options';
            var jQuery = window1.jQuery;
            elems.forEach(function(elem) {
                var attr = elem.getAttribute(dataAttr) || elem.getAttribute(dataOptionsAttr);
                var options;
                try {
                    options = attr && JSON.parse(attr);
                } catch (error) {
                    // log error, do not initialize
                    if (console) console.error('Error parsing ' + dataAttr + ' on ' + elem.className + ': ' + error);
                    return;
                }
                // initialize
                var instance = new WidgetClass(elem, options);
                // make available via $().data('namespace')
                if (jQuery) jQuery.data(elem, namespace, instance);
            });
        });
    };
    // -----  ----- //
    return utils;
});

});
parcelRegister("7Farg", function(module, exports) {
/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */ /*jshint browser: true, strict: true, undef: true, unused: true */ (function(window1, factory) {
    /*global define: false, module: false */ 'use strict';
    // universal module definition
    if (typeof define == 'function' && define.amd) // AMD
    define(factory);
    else if (0, module.exports) // CommonJS
    module.exports = factory();
    else // browser global
    window1.matchesSelector = factory();
})(window, function factory() {
    'use strict';
    var matchesMethod = function() {
        var ElemProto = window.Element.prototype;
        // check for the standard method name first
        if (ElemProto.matches) return 'matches';
        // check un-prefixed
        if (ElemProto.matchesSelector) return 'matchesSelector';
        // check vendor prefixes
        var prefixes = [
            'webkit',
            'moz',
            'ms',
            'o'
        ];
        for(var i = 0; i < prefixes.length; i++){
            var prefix = prefixes[i];
            var method = prefix + 'MatchesSelector';
            if (ElemProto[method]) return method;
        }
    }();
    return function matchesSelector(elem, selector) {
        return elem[matchesMethod](selector);
    };
});

});


parcelRegister("2BL98", function(module, exports) {


/**
 * Outlayer Item
 */ (function(window1, factory) {
    // universal module definition
    /* jshint strict: false */ /* globals define, module, require */ if (typeof define == 'function' && define.amd) // AMD - RequireJS
    define([
        'ev-emitter/ev-emitter',
        'get-size/get-size'
    ], factory);
    else if (0, module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory((parcelRequire("kWDtA")), (parcelRequire("lDySy")));
    else {
        // browser global
        window1.Outlayer = {};
        window1.Outlayer.Item = factory(window1.EvEmitter, window1.getSize);
    }
})(window, function factory(EvEmitter, getSize) {
    'use strict';
    // ----- helpers ----- //
    function isEmptyObj(obj) {
        for(var prop in obj)return false;
        prop = null;
        return true;
    }
    // -------------------------- CSS3 support -------------------------- //
    var docElemStyle = document.documentElement.style;
    var transitionProperty = typeof docElemStyle.transition == 'string' ? 'transition' : 'WebkitTransition';
    var transformProperty = typeof docElemStyle.transform == 'string' ? 'transform' : 'WebkitTransform';
    var transitionEndEvent = {
        WebkitTransition: 'webkitTransitionEnd',
        transition: 'transitionend'
    }[transitionProperty];
    // cache all vendor properties that could have vendor prefix
    var vendorProperties = {
        transform: transformProperty,
        transition: transitionProperty,
        transitionDuration: transitionProperty + 'Duration',
        transitionProperty: transitionProperty + 'Property',
        transitionDelay: transitionProperty + 'Delay'
    };
    // -------------------------- Item -------------------------- //
    function Item(element, layout) {
        if (!element) return;
        this.element = element;
        // parent layout class, i.e. Masonry, Isotope, or Packery
        this.layout = layout;
        this.position = {
            x: 0,
            y: 0
        };
        this._create();
    }
    // inherit EvEmitter
    var proto = Item.prototype = Object.create(EvEmitter.prototype);
    proto.constructor = Item;
    proto._create = function() {
        // transition objects
        this._transn = {
            ingProperties: {},
            clean: {},
            onEnd: {}
        };
        this.css({
            position: 'absolute'
        });
    };
    // trigger specified handler for event type
    proto.handleEvent = function(event) {
        var method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
    };
    /**
 * apply CSS styles to element
 * @param {Object} style
 */ proto.css = function(style) {
        var elemStyle = this.element.style;
        for(var prop in style){
            // use vendor property if available
            var supportedProp = vendorProperties[prop] || prop;
            elemStyle[supportedProp] = style[prop];
        }
    };
    // measure position, and sets it
    proto.getPosition = function() {
        var style = getComputedStyle(this.element);
        var isOriginLeft = this.layout._getOption('originLeft');
        var isOriginTop = this.layout._getOption('originTop');
        var xValue = style[isOriginLeft ? 'left' : 'right'];
        var yValue = style[isOriginTop ? 'top' : 'bottom'];
        var x = parseFloat(xValue);
        var y = parseFloat(yValue);
        // convert percent to pixels
        var layoutSize = this.layout.size;
        if (xValue.indexOf('%') != -1) x = x / 100 * layoutSize.width;
        if (yValue.indexOf('%') != -1) y = y / 100 * layoutSize.height;
        // clean up 'auto' or other non-integer values
        x = isNaN(x) ? 0 : x;
        y = isNaN(y) ? 0 : y;
        // remove padding from measurement
        x -= isOriginLeft ? layoutSize.paddingLeft : layoutSize.paddingRight;
        y -= isOriginTop ? layoutSize.paddingTop : layoutSize.paddingBottom;
        this.position.x = x;
        this.position.y = y;
    };
    // set settled position, apply padding
    proto.layoutPosition = function() {
        var layoutSize = this.layout.size;
        var style = {};
        var isOriginLeft = this.layout._getOption('originLeft');
        var isOriginTop = this.layout._getOption('originTop');
        // x
        var xPadding = isOriginLeft ? 'paddingLeft' : 'paddingRight';
        var xProperty = isOriginLeft ? 'left' : 'right';
        var xResetProperty = isOriginLeft ? 'right' : 'left';
        var x = this.position.x + layoutSize[xPadding];
        // set in percentage or pixels
        style[xProperty] = this.getXValue(x);
        // reset other property
        style[xResetProperty] = '';
        // y
        var yPadding = isOriginTop ? 'paddingTop' : 'paddingBottom';
        var yProperty = isOriginTop ? 'top' : 'bottom';
        var yResetProperty = isOriginTop ? 'bottom' : 'top';
        var y = this.position.y + layoutSize[yPadding];
        // set in percentage or pixels
        style[yProperty] = this.getYValue(y);
        // reset other property
        style[yResetProperty] = '';
        this.css(style);
        this.emitEvent('layout', [
            this
        ]);
    };
    proto.getXValue = function(x) {
        var isHorizontal = this.layout._getOption('horizontal');
        return this.layout.options.percentPosition && !isHorizontal ? x / this.layout.size.width * 100 + '%' : x + 'px';
    };
    proto.getYValue = function(y) {
        var isHorizontal = this.layout._getOption('horizontal');
        return this.layout.options.percentPosition && isHorizontal ? y / this.layout.size.height * 100 + '%' : y + 'px';
    };
    proto._transitionTo = function(x, y) {
        this.getPosition();
        // get current x & y from top/left
        var curX = this.position.x;
        var curY = this.position.y;
        var didNotMove = x == this.position.x && y == this.position.y;
        // save end position
        this.setPosition(x, y);
        // if did not move and not transitioning, just go to layout
        if (didNotMove && !this.isTransitioning) {
            this.layoutPosition();
            return;
        }
        var transX = x - curX;
        var transY = y - curY;
        var transitionStyle = {};
        transitionStyle.transform = this.getTranslate(transX, transY);
        this.transition({
            to: transitionStyle,
            onTransitionEnd: {
                transform: this.layoutPosition
            },
            isCleaning: true
        });
    };
    proto.getTranslate = function(x, y) {
        // flip cooridinates if origin on right or bottom
        var isOriginLeft = this.layout._getOption('originLeft');
        var isOriginTop = this.layout._getOption('originTop');
        x = isOriginLeft ? x : -x;
        y = isOriginTop ? y : -y;
        return 'translate3d(' + x + 'px, ' + y + 'px, 0)';
    };
    // non transition + transform support
    proto.goTo = function(x, y) {
        this.setPosition(x, y);
        this.layoutPosition();
    };
    proto.moveTo = proto._transitionTo;
    proto.setPosition = function(x, y) {
        this.position.x = parseFloat(x);
        this.position.y = parseFloat(y);
    };
    // ----- transition ----- //
    /**
 * @param {Object} style - CSS
 * @param {Function} onTransitionEnd
 */ // non transition, just trigger callback
    proto._nonTransition = function(args) {
        this.css(args.to);
        if (args.isCleaning) this._removeStyles(args.to);
        for(var prop in args.onTransitionEnd)args.onTransitionEnd[prop].call(this);
    };
    /**
 * proper transition
 * @param {Object} args - arguments
 *   @param {Object} to - style to transition to
 *   @param {Object} from - style to start transition from
 *   @param {Boolean} isCleaning - removes transition styles after transition
 *   @param {Function} onTransitionEnd - callback
 */ proto.transition = function(args) {
        // redirect to nonTransition if no transition duration
        if (!parseFloat(this.layout.options.transitionDuration)) {
            this._nonTransition(args);
            return;
        }
        var _transition = this._transn;
        // keep track of onTransitionEnd callback by css property
        for(var prop in args.onTransitionEnd)_transition.onEnd[prop] = args.onTransitionEnd[prop];
        // keep track of properties that are transitioning
        for(prop in args.to){
            _transition.ingProperties[prop] = true;
            // keep track of properties to clean up when transition is done
            if (args.isCleaning) _transition.clean[prop] = true;
        }
        // set from styles
        if (args.from) {
            this.css(args.from);
            // force redraw. http://blog.alexmaccaw.com/css-transitions
            var h = this.element.offsetHeight;
            // hack for JSHint to hush about unused var
            h = null;
        }
        // enable transition
        this.enableTransition(args.to);
        // set styles that are transitioning
        this.css(args.to);
        this.isTransitioning = true;
    };
    // dash before all cap letters, including first for
    // WebkitTransform => -webkit-transform
    function toDashedAll(str) {
        return str.replace(/([A-Z])/g, function($1) {
            return '-' + $1.toLowerCase();
        });
    }
    var transitionProps = 'opacity,' + toDashedAll(transformProperty);
    proto.enableTransition = function() {
        // HACK changing transitionProperty during a transition
        // will cause transition to jump
        if (this.isTransitioning) return;
        // make `transition: foo, bar, baz` from style object
        // HACK un-comment this when enableTransition can work
        // while a transition is happening
        // var transitionValues = [];
        // for ( var prop in style ) {
        //   // dash-ify camelCased properties like WebkitTransition
        //   prop = vendorProperties[ prop ] || prop;
        //   transitionValues.push( toDashedAll( prop ) );
        // }
        // munge number to millisecond, to match stagger
        var duration = this.layout.options.transitionDuration;
        duration = typeof duration == 'number' ? duration + 'ms' : duration;
        // enable transition styles
        this.css({
            transitionProperty: transitionProps,
            transitionDuration: duration,
            transitionDelay: this.staggerDelay || 0
        });
        // listen for transition end event
        this.element.addEventListener(transitionEndEvent, this, false);
    };
    // ----- events ----- //
    proto.onwebkitTransitionEnd = function(event) {
        this.ontransitionend(event);
    };
    proto.onotransitionend = function(event) {
        this.ontransitionend(event);
    };
    // properties that I munge to make my life easier
    var dashedVendorProperties = {
        '-webkit-transform': 'transform'
    };
    proto.ontransitionend = function(event) {
        // disregard bubbled events from children
        if (event.target !== this.element) return;
        var _transition = this._transn;
        // get property name of transitioned property, convert to prefix-free
        var propertyName = dashedVendorProperties[event.propertyName] || event.propertyName;
        // remove property that has completed transitioning
        delete _transition.ingProperties[propertyName];
        // check if any properties are still transitioning
        if (isEmptyObj(_transition.ingProperties)) // all properties have completed transitioning
        this.disableTransition();
        // clean style
        if (propertyName in _transition.clean) {
            // clean up style
            this.element.style[event.propertyName] = '';
            delete _transition.clean[propertyName];
        }
        // trigger onTransitionEnd callback
        if (propertyName in _transition.onEnd) {
            var onTransitionEnd = _transition.onEnd[propertyName];
            onTransitionEnd.call(this);
            delete _transition.onEnd[propertyName];
        }
        this.emitEvent('transitionEnd', [
            this
        ]);
    };
    proto.disableTransition = function() {
        this.removeTransitionStyles();
        this.element.removeEventListener(transitionEndEvent, this, false);
        this.isTransitioning = false;
    };
    /**
 * removes style property from element
 * @param {Object} style
**/ proto._removeStyles = function(style) {
        // clean up transition styles
        var cleanStyle = {};
        for(var prop in style)cleanStyle[prop] = '';
        this.css(cleanStyle);
    };
    var cleanTransitionStyle = {
        transitionProperty: '',
        transitionDuration: '',
        transitionDelay: ''
    };
    proto.removeTransitionStyles = function() {
        // remove transition
        this.css(cleanTransitionStyle);
    };
    // ----- stagger ----- //
    proto.stagger = function(delay) {
        delay = isNaN(delay) ? 0 : delay;
        this.staggerDelay = delay + 'ms';
    };
    // ----- show/hide/remove ----- //
    // remove element from DOM
    proto.removeElem = function() {
        this.element.parentNode.removeChild(this.element);
        // remove display: none
        this.css({
            display: ''
        });
        this.emitEvent('remove', [
            this
        ]);
    };
    proto.remove = function() {
        // just remove element if no transition support or no transition
        if (!transitionProperty || !parseFloat(this.layout.options.transitionDuration)) {
            this.removeElem();
            return;
        }
        // start transition
        this.once('transitionEnd', function() {
            this.removeElem();
        });
        this.hide();
    };
    proto.reveal = function() {
        delete this.isHidden;
        // remove display: none
        this.css({
            display: ''
        });
        var options = this.layout.options;
        var onTransitionEnd = {};
        var transitionEndProperty = this.getHideRevealTransitionEndProperty('visibleStyle');
        onTransitionEnd[transitionEndProperty] = this.onRevealTransitionEnd;
        this.transition({
            from: options.hiddenStyle,
            to: options.visibleStyle,
            isCleaning: true,
            onTransitionEnd: onTransitionEnd
        });
    };
    proto.onRevealTransitionEnd = function() {
        // check if still visible
        // during transition, item may have been hidden
        if (!this.isHidden) this.emitEvent('reveal');
    };
    /**
 * get style property use for hide/reveal transition end
 * @param {String} styleProperty - hiddenStyle/visibleStyle
 * @returns {String}
 */ proto.getHideRevealTransitionEndProperty = function(styleProperty) {
        var optionStyle = this.layout.options[styleProperty];
        // use opacity
        if (optionStyle.opacity) return 'opacity';
        // get first property
        for(var prop in optionStyle)return prop;
    };
    proto.hide = function() {
        // set flag
        this.isHidden = true;
        // remove display: none
        this.css({
            display: ''
        });
        var options = this.layout.options;
        var onTransitionEnd = {};
        var transitionEndProperty = this.getHideRevealTransitionEndProperty('hiddenStyle');
        onTransitionEnd[transitionEndProperty] = this.onHideTransitionEnd;
        this.transition({
            from: options.visibleStyle,
            to: options.hiddenStyle,
            // keep hidden stuff hidden
            isCleaning: true,
            onTransitionEnd: onTransitionEnd
        });
    };
    proto.onHideTransitionEnd = function() {
        // check if still hidden
        // during transition, item may have been un-hidden
        if (this.isHidden) {
            this.css({
                display: 'none'
            });
            this.emitEvent('hide');
        }
    };
    proto.destroy = function() {
        this.css({
            position: '',
            left: '',
            right: '',
            top: '',
            bottom: '',
            transition: '',
            transform: ''
        });
    };
    return Item;
});

});


/**
 * This is the entry file for the frontend application.
 */ var $4a179cfc48fad9ca$exports = {};
'use strict';

var $0f348e0908f3f1bb$var$$at = (parcelRequire("369XB"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("hCjYU"))(String, 'String', function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $0f348e0908f3f1bb$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});


'use strict';

var $h2rcp = parcelRequire("h2rcp");

var $7XiCc = parcelRequire("7XiCc");

var $ezwWl = parcelRequire("ezwWl");
var $cc97ba93eeb9ce84$exports = {};
// call something on iterator step with safe closing on error

var $kamYu = parcelRequire("kamYu");
$cc97ba93eeb9ce84$exports = function(iterator, fn, value, entries) {
    try {
        return entries ? fn($kamYu(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
    } catch (e) {
        var ret = iterator['return'];
        if (ret !== undefined) $kamYu(ret.call(iterator));
        throw e;
    }
};


var $8bacf5fc5be29fd8$exports = {};
// check on default Array iterator

var $afDmW = parcelRequire("afDmW");

var $8bacf5fc5be29fd8$var$ITERATOR = (parcelRequire("3KDgq"))('iterator');
var $8bacf5fc5be29fd8$var$ArrayProto = Array.prototype;
$8bacf5fc5be29fd8$exports = function(it) {
    return it !== undefined && ($afDmW.Array === it || $8bacf5fc5be29fd8$var$ArrayProto[$8bacf5fc5be29fd8$var$ITERATOR] === it);
};



var $dZ2Pj = parcelRequire("dZ2Pj");
var $4513765d22600791$exports = {};
'use strict';

var $yXi7N = parcelRequire("yXi7N");

var $1SVLC = parcelRequire("1SVLC");
$4513765d22600791$exports = function(object, index, value) {
    if (index in object) $yXi7N.f(object, index, $1SVLC(0, value));
    else object[index] = value;
};


var $d926f3e8dea01b87$exports = {};
var $d143579f7aee7c35$exports = {};
// getting tag from 19.1.3.6 Object.prototype.toString()

var $lk5ZL = parcelRequire("lk5ZL");

var $d143579f7aee7c35$var$TAG = (parcelRequire("3KDgq"))('toStringTag');
// ES3 wrong here
var $d143579f7aee7c35$var$ARG = $lk5ZL(function() {
    return arguments;
}()) == 'Arguments';
// fallback for IE11 Script Access Denied error
var $d143579f7aee7c35$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (e) {}
};
$d143579f7aee7c35$exports = function(it) {
    var O, T, B;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (T = $d143579f7aee7c35$var$tryGet(O = Object(it), $d143579f7aee7c35$var$TAG)) == 'string' ? T : $d143579f7aee7c35$var$ARG ? $lk5ZL(O) : (B = $lk5ZL(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};



var $d926f3e8dea01b87$var$ITERATOR = (parcelRequire("3KDgq"))('iterator');

var $afDmW = parcelRequire("afDmW");

$d926f3e8dea01b87$exports = (parcelRequire("kLmzM")).getIteratorMethod = function(it) {
    if (it != undefined) return it[$d926f3e8dea01b87$var$ITERATOR] || it['@@iterator'] || $afDmW[$d143579f7aee7c35$exports(it)];
};



$7XiCc($7XiCc.S + $7XiCc.F * !(parcelRequire("eepmO"))(function(iter) {
    Array.from(iter);
}), 'Array', {
    // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
    from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
        var O = $ezwWl(arrayLike);
        var C = typeof this == 'function' ? this : Array;
        var aLen = arguments.length;
        var mapfn = aLen > 1 ? arguments[1] : undefined;
        var mapping = mapfn !== undefined;
        var index = 0;
        var iterFn = $d926f3e8dea01b87$exports(O);
        var length, result, step, iterator;
        if (mapping) mapfn = $h2rcp(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
        // if object isn't iterable or it's array with default iterator - use simple case
        if (iterFn != undefined && !(C == Array && $8bacf5fc5be29fd8$exports(iterFn))) for(iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++)$4513765d22600791$exports(result, index, mapping ? $cc97ba93eeb9ce84$exports(iterator, mapfn, [
            step.value,
            index
        ], true) : step.value);
        else {
            length = $dZ2Pj(O.length);
            for(result = new C(length); length > index; index++)$4513765d22600791$exports(result, index, mapping ? mapfn(O[index], index) : O[index]);
        }
        result.length = index;
        return result;
    }
});



$4a179cfc48fad9ca$exports = (parcelRequire("kLmzM")).Array.from;


var $6864c77144058b67$exports = {};
'use strict';

var $7XiCc = parcelRequire("7XiCc");
var $0c2b33d2d417cf77$exports = {};

var $l2Ctg = parcelRequire("l2Ctg");

var $ezwWl = parcelRequire("ezwWl");

var $b9ATX = parcelRequire("b9ATX");

var $dZ2Pj = parcelRequire("dZ2Pj");
$0c2b33d2d417cf77$exports = function(that, callbackfn, aLen, memo, isRight) {
    $l2Ctg(callbackfn);
    var O = $ezwWl(that);
    var self = $b9ATX(O);
    var length = $dZ2Pj(O.length);
    var index = isRight ? length - 1 : 0;
    var i = isRight ? -1 : 1;
    if (aLen < 2) for(;;){
        if (index in self) {
            memo = self[index];
            index += i;
            break;
        }
        index += i;
        if (isRight ? index < 0 : length <= index) throw TypeError('Reduce of empty array with no initial value');
    }
    for(; isRight ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
    return memo;
};



$7XiCc($7XiCc.P + $7XiCc.F * !(parcelRequire("hpsD3"))([].reduce, true), 'Array', {
    // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        return $0c2b33d2d417cf77$exports(this, callbackfn, arguments.length, arguments[1], false);
    }
});



$6864c77144058b67$exports = (parcelRequire("kLmzM")).Array.reduce;


var $8b7530f29033c094$exports = {};
// 19.1.3.1 Object.assign(target, source)

var $7XiCc = parcelRequire("7XiCc");

$7XiCc($7XiCc.S + $7XiCc.F, 'Object', {
    assign: (parcelRequire("iwRi4"))
});



$8b7530f29033c094$exports = (parcelRequire("kLmzM")).Object.assign;


var $f6563e1934a399e1$exports = {};
// https://github.com/tc39/proposal-object-values-entries

var $7XiCc = parcelRequire("7XiCc");

var $c863706760f9cffa$var$$values = (parcelRequire("2bavT"))(false);
$7XiCc($7XiCc.S, 'Object', {
    values: function values(it) {
        return $c863706760f9cffa$var$$values(it);
    }
});



$f6563e1934a399e1$exports = (parcelRequire("kLmzM")).Object.values;


var $6db9d435a4b7ca46$exports = {};
/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2018 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */ /**
 * bluebird build version 3.7.2
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
*/ var $4acf49f6c3e67aec$exports = {};
// shim for using process in browser
var $4acf49f6c3e67aec$var$process = $4acf49f6c3e67aec$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4acf49f6c3e67aec$var$cachedSetTimeout;
var $4acf49f6c3e67aec$var$cachedClearTimeout;
function $4acf49f6c3e67aec$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $4acf49f6c3e67aec$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        else $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        else $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    }
})();
function $4acf49f6c3e67aec$var$runTimeout(fun) {
    if ($4acf49f6c3e67aec$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedSetTimeout === $4acf49f6c3e67aec$var$defaultSetTimout || !$4acf49f6c3e67aec$var$cachedSetTimeout) && setTimeout) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4acf49f6c3e67aec$var$runClearTimeout(marker) {
    if ($4acf49f6c3e67aec$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedClearTimeout === $4acf49f6c3e67aec$var$defaultClearTimeout || !$4acf49f6c3e67aec$var$cachedClearTimeout) && clearTimeout) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4acf49f6c3e67aec$var$queue = [];
var $4acf49f6c3e67aec$var$draining = false;
var $4acf49f6c3e67aec$var$currentQueue;
var $4acf49f6c3e67aec$var$queueIndex = -1;
function $4acf49f6c3e67aec$var$cleanUpNextTick() {
    if (!$4acf49f6c3e67aec$var$draining || !$4acf49f6c3e67aec$var$currentQueue) return;
    $4acf49f6c3e67aec$var$draining = false;
    if ($4acf49f6c3e67aec$var$currentQueue.length) $4acf49f6c3e67aec$var$queue = $4acf49f6c3e67aec$var$currentQueue.concat($4acf49f6c3e67aec$var$queue);
    else $4acf49f6c3e67aec$var$queueIndex = -1;
    if ($4acf49f6c3e67aec$var$queue.length) $4acf49f6c3e67aec$var$drainQueue();
}
function $4acf49f6c3e67aec$var$drainQueue() {
    if ($4acf49f6c3e67aec$var$draining) return;
    var timeout = $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$cleanUpNextTick);
    $4acf49f6c3e67aec$var$draining = true;
    var len = $4acf49f6c3e67aec$var$queue.length;
    while(len){
        $4acf49f6c3e67aec$var$currentQueue = $4acf49f6c3e67aec$var$queue;
        $4acf49f6c3e67aec$var$queue = [];
        while(++$4acf49f6c3e67aec$var$queueIndex < len)if ($4acf49f6c3e67aec$var$currentQueue) $4acf49f6c3e67aec$var$currentQueue[$4acf49f6c3e67aec$var$queueIndex].run();
        $4acf49f6c3e67aec$var$queueIndex = -1;
        len = $4acf49f6c3e67aec$var$queue.length;
    }
    $4acf49f6c3e67aec$var$currentQueue = null;
    $4acf49f6c3e67aec$var$draining = false;
    $4acf49f6c3e67aec$var$runClearTimeout(timeout);
}
$4acf49f6c3e67aec$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4acf49f6c3e67aec$var$queue.push(new $4acf49f6c3e67aec$var$Item(fun, args));
    if ($4acf49f6c3e67aec$var$queue.length === 1 && !$4acf49f6c3e67aec$var$draining) $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$drainQueue);
};
// v8 likes predictible objects
function $4acf49f6c3e67aec$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4acf49f6c3e67aec$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4acf49f6c3e67aec$var$process.title = 'browser';
$4acf49f6c3e67aec$var$process.browser = true;
$4acf49f6c3e67aec$var$process.env = {};
$4acf49f6c3e67aec$var$process.argv = [];
$4acf49f6c3e67aec$var$process.version = ''; // empty string to avoid regexp issues
$4acf49f6c3e67aec$var$process.versions = {};
function $4acf49f6c3e67aec$var$noop() {}
$4acf49f6c3e67aec$var$process.on = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.addListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.once = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.off = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeAllListeners = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.emit = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependOnceListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.listeners = function(name) {
    return [];
};
$4acf49f6c3e67aec$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$4acf49f6c3e67aec$var$process.cwd = function() {
    return '/';
};
$4acf49f6c3e67aec$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$4acf49f6c3e67aec$var$process.umask = function() {
    return 0;
};


!function(e) {
    var f;
    $6db9d435a4b7ca46$exports = e();
}(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = typeof _dereq_ == "function" && _dereq_;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(_e) {
                    var n = t[o][1][_e];
                    return s(n ? n : _e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = typeof _dereq_ == "function" && _dereq_;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    var SomePromiseArray = Promise1._SomePromiseArray;
                    function any(promises) {
                        var ret = new SomePromiseArray(promises);
                        var promise = ret.promise();
                        ret.setHowMany(1);
                        ret.setUnwrap();
                        ret.init();
                        return promise;
                    }
                    Promise1.any = function(promises) {
                        return any(promises);
                    };
                    Promise1.prototype.any = function() {
                        return any(this);
                    };
                };
            },
            {}
        ],
        2: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var firstLineError;
                try {
                    throw new Error();
                } catch (e) {
                    firstLineError = e;
                }
                var schedule = _dereq_1("./schedule");
                var Queue = _dereq_1("./queue");
                function Async() {
                    this._customScheduler = false;
                    this._isTickUsed = false;
                    this._lateQueue = new Queue(16);
                    this._normalQueue = new Queue(16);
                    this._haveDrainedQueues = false;
                    var self1 = this;
                    this.drainQueues = function() {
                        self1._drainQueues();
                    };
                    this._schedule = schedule;
                }
                Async.prototype.setScheduler = function(fn) {
                    var prev = this._schedule;
                    this._schedule = fn;
                    this._customScheduler = true;
                    return prev;
                };
                Async.prototype.hasCustomScheduler = function() {
                    return this._customScheduler;
                };
                Async.prototype.haveItemsQueued = function() {
                    return this._isTickUsed || this._haveDrainedQueues;
                };
                Async.prototype.fatalError = function(e, isNode) {
                    if (isNode) {
                        $4acf49f6c3e67aec$exports.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) + "\n");
                        $4acf49f6c3e67aec$exports.exit(2);
                    } else this.throwLater(e);
                };
                Async.prototype.throwLater = function(fn, arg) {
                    if (arguments.length === 1) {
                        arg = fn;
                        fn = function() {
                            throw arg;
                        };
                    }
                    if (typeof setTimeout !== "undefined") setTimeout(function() {
                        fn(arg);
                    }, 0);
                    else try {
                        this._schedule(function() {
                            fn(arg);
                        });
                    } catch (e) {
                        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                    }
                };
                function AsyncInvokeLater(fn, receiver, arg) {
                    this._lateQueue.push(fn, receiver, arg);
                    this._queueTick();
                }
                function AsyncInvoke(fn, receiver, arg) {
                    this._normalQueue.push(fn, receiver, arg);
                    this._queueTick();
                }
                function AsyncSettlePromises(promise) {
                    this._normalQueue._pushOne(promise);
                    this._queueTick();
                }
                Async.prototype.invokeLater = AsyncInvokeLater;
                Async.prototype.invoke = AsyncInvoke;
                Async.prototype.settlePromises = AsyncSettlePromises;
                function _drainQueue(queue) {
                    while(queue.length() > 0)_drainQueueStep(queue);
                }
                function _drainQueueStep(queue) {
                    var fn = queue.shift();
                    if (typeof fn !== "function") fn._settlePromises();
                    else {
                        var receiver = queue.shift();
                        var arg = queue.shift();
                        fn.call(receiver, arg);
                    }
                }
                Async.prototype._drainQueues = function() {
                    _drainQueue(this._normalQueue);
                    this._reset();
                    this._haveDrainedQueues = true;
                    _drainQueue(this._lateQueue);
                };
                Async.prototype._queueTick = function() {
                    if (!this._isTickUsed) {
                        this._isTickUsed = true;
                        this._schedule(this.drainQueues);
                    }
                };
                Async.prototype._reset = function() {
                    this._isTickUsed = false;
                };
                module1.exports = Async;
                module1.exports.firstLineError = firstLineError;
            },
            {
                "./queue": 26,
                "./schedule": 29
            }
        ],
        3: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, tryConvertToPromise, debug) {
                    var calledBind = false;
                    var rejectThis = function(_, e) {
                        this._reject(e);
                    };
                    var targetRejected = function(e, context) {
                        context.promiseRejectionQueued = true;
                        context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
                    };
                    var bindingResolved = function(thisArg, context) {
                        if ((this._bitField & 50397184) === 0) this._resolveCallback(context.target);
                    };
                    var bindingRejected = function(e, context) {
                        if (!context.promiseRejectionQueued) this._reject(e);
                    };
                    Promise1.prototype.bind = function(thisArg) {
                        if (!calledBind) {
                            calledBind = true;
                            Promise1.prototype._propagateFrom = debug.propagateFromFunction();
                            Promise1.prototype._boundValue = debug.boundValueFunction();
                        }
                        var maybePromise = tryConvertToPromise(thisArg);
                        var ret = new Promise1(INTERNAL);
                        ret._propagateFrom(this, 1);
                        var target = this._target();
                        ret._setBoundTo(maybePromise);
                        if (maybePromise instanceof Promise1) {
                            var context = {
                                promiseRejectionQueued: false,
                                promise: ret,
                                target: target,
                                bindingPromise: maybePromise
                            };
                            target._then(INTERNAL, targetRejected, undefined, ret, context);
                            maybePromise._then(bindingResolved, bindingRejected, undefined, ret, context);
                            ret._setOnCancel(maybePromise);
                        } else ret._resolveCallback(target);
                        return ret;
                    };
                    Promise1.prototype._setBoundTo = function(obj) {
                        if (obj !== undefined) {
                            this._bitField = this._bitField | 2097152;
                            this._boundTo = obj;
                        } else this._bitField = this._bitField & -2097153;
                    };
                    Promise1.prototype._isBound = function() {
                        return (this._bitField & 2097152) === 2097152;
                    };
                    Promise1.bind = function(thisArg, value) {
                        return Promise1.resolve(value).bind(thisArg);
                    };
                };
            },
            {}
        ],
        4: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var old;
                if (typeof Promise !== "undefined") old = Promise;
                function noConflict() {
                    try {
                        if (Promise === bluebird) Promise = old;
                    } catch (e) {}
                    return bluebird;
                }
                var bluebird = _dereq_1("./promise")();
                bluebird.noConflict = noConflict;
                module1.exports = bluebird;
            },
            {
                "./promise": 22
            }
        ],
        5: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var cr = Object.create;
                if (cr) {
                    var callerCache = cr(null);
                    var getterCache = cr(null);
                    callerCache[" size"] = getterCache[" size"] = 0;
                }
                module1.exports = function(Promise1) {
                    var util = _dereq_1("./util");
                    var canEvaluate = util.canEvaluate;
                    var isIdentifier = util.isIdentifier;
                    var getMethodCaller;
                    var getGetter;
                    var makeMethodCaller, makeGetter, getCompiled;
                    function ensureMethod(obj, methodName) {
                        var fn;
                        if (obj != null) fn = obj[methodName];
                        if (typeof fn !== "function") {
                            var message = "Object " + util.classString(obj) + " has no method '" + util.toString(methodName) + "'";
                            throw new Promise1.TypeError(message);
                        }
                        return fn;
                    }
                    function caller(obj) {
                        var methodName = this.pop();
                        var fn = ensureMethod(obj, methodName);
                        return fn.apply(obj, this);
                    }
                    Promise1.prototype.call = function(methodName) {
                        var args = [].slice.call(arguments, 1);
                        var maybeCaller;
                        args.push(methodName);
                        return this._then(caller, undefined, undefined, args, undefined);
                    };
                    function namedGetter(obj) {
                        return obj[this];
                    }
                    function indexedGetter(obj) {
                        var index = +this;
                        if (index < 0) index = Math.max(0, index + obj.length);
                        return obj[index];
                    }
                    Promise1.prototype.get = function(propertyName) {
                        var isIndex = typeof propertyName === "number";
                        var getter;
                        if (!isIndex) {
                            if (canEvaluate) {
                                var maybeGetter = getGetter(propertyName);
                                getter = maybeGetter !== null ? maybeGetter : namedGetter;
                            } else getter = namedGetter;
                        } else getter = indexedGetter;
                        return this._then(getter, undefined, undefined, propertyName, undefined);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        6: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, apiRejection, debug) {
                    var util = _dereq_1("./util");
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    var async = Promise1._async;
                    Promise1.prototype["break"] = Promise1.prototype.cancel = function() {
                        if (!debug.cancellation()) return this._warn("cancellation is disabled");
                        var promise = this;
                        var child = promise;
                        while(promise._isCancellable()){
                            if (!promise._cancelBy(child)) {
                                if (child._isFollowing()) child._followee().cancel();
                                else child._cancelBranched();
                                break;
                            }
                            var parent = promise._cancellationParent;
                            if (parent == null || !parent._isCancellable()) {
                                if (promise._isFollowing()) promise._followee().cancel();
                                else promise._cancelBranched();
                                break;
                            } else {
                                if (promise._isFollowing()) promise._followee().cancel();
                                promise._setWillBeCancelled();
                                child = promise;
                                promise = parent;
                            }
                        }
                    };
                    Promise1.prototype._branchHasCancelled = function() {
                        this._branchesRemainingToCancel--;
                    };
                    Promise1.prototype._enoughBranchesHaveCancelled = function() {
                        return this._branchesRemainingToCancel === undefined || this._branchesRemainingToCancel <= 0;
                    };
                    Promise1.prototype._cancelBy = function(canceller) {
                        if (canceller === this) {
                            this._branchesRemainingToCancel = 0;
                            this._invokeOnCancel();
                            return true;
                        } else {
                            this._branchHasCancelled();
                            if (this._enoughBranchesHaveCancelled()) {
                                this._invokeOnCancel();
                                return true;
                            }
                        }
                        return false;
                    };
                    Promise1.prototype._cancelBranched = function() {
                        if (this._enoughBranchesHaveCancelled()) this._cancel();
                    };
                    Promise1.prototype._cancel = function() {
                        if (!this._isCancellable()) return;
                        this._setCancelled();
                        async.invoke(this._cancelPromises, this, undefined);
                    };
                    Promise1.prototype._cancelPromises = function() {
                        if (this._length() > 0) this._settlePromises();
                    };
                    Promise1.prototype._unsetOnCancel = function() {
                        this._onCancelField = undefined;
                    };
                    Promise1.prototype._isCancellable = function() {
                        return this.isPending() && !this._isCancelled();
                    };
                    Promise1.prototype.isCancellable = function() {
                        return this.isPending() && !this.isCancelled();
                    };
                    Promise1.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
                        if (util.isArray(onCancelCallback)) for(var i = 0; i < onCancelCallback.length; ++i)this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
                        else if (onCancelCallback !== undefined) {
                            if (typeof onCancelCallback === "function") {
                                if (!internalOnly) {
                                    var e = tryCatch(onCancelCallback).call(this._boundValue());
                                    if (e === errorObj) {
                                        this._attachExtraTrace(e.e);
                                        async.throwLater(e.e);
                                    }
                                }
                            } else onCancelCallback._resultCancelled(this);
                        }
                    };
                    Promise1.prototype._invokeOnCancel = function() {
                        var onCancelCallback = this._onCancel();
                        this._unsetOnCancel();
                        async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
                    };
                    Promise1.prototype._invokeInternalOnCancel = function() {
                        if (this._isCancellable()) {
                            this._doInvokeOnCancel(this._onCancel(), true);
                            this._unsetOnCancel();
                        }
                    };
                    Promise1.prototype._resultCancelled = function() {
                        this.cancel();
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        7: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(NEXT_FILTER) {
                    var util = _dereq_1("./util");
                    var getKeys = _dereq_1("./es5").keys;
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    function catchFilter(instances, cb, promise) {
                        return function(e) {
                            var boundTo = promise._boundValue();
                            predicateLoop: for(var i = 0; i < instances.length; ++i){
                                var item = instances[i];
                                if (item === Error || item != null && item.prototype instanceof Error) {
                                    if (e instanceof item) return tryCatch(cb).call(boundTo, e);
                                } else if (typeof item === "function") {
                                    var matchesPredicate = tryCatch(item).call(boundTo, e);
                                    if (matchesPredicate === errorObj) return matchesPredicate;
                                    else if (matchesPredicate) return tryCatch(cb).call(boundTo, e);
                                } else if (util.isObject(e)) {
                                    var keys = getKeys(item);
                                    for(var j = 0; j < keys.length; ++j){
                                        var key = keys[j];
                                        if (item[key] != e[key]) continue predicateLoop;
                                    }
                                    return tryCatch(cb).call(boundTo, e);
                                }
                            }
                            return NEXT_FILTER;
                        };
                    }
                    return catchFilter;
                };
            },
            {
                "./es5": 13,
                "./util": 36
            }
        ],
        8: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    var longStackTraces = false;
                    var contextStack = [];
                    Promise1.prototype._promiseCreated = function() {};
                    Promise1.prototype._pushContext = function() {};
                    Promise1.prototype._popContext = function() {
                        return null;
                    };
                    Promise1._peekContext = Promise1.prototype._peekContext = function() {};
                    function Context() {
                        this._trace = new Context.CapturedTrace(peekContext());
                    }
                    Context.prototype._pushContext = function() {
                        if (this._trace !== undefined) {
                            this._trace._promiseCreated = null;
                            contextStack.push(this._trace);
                        }
                    };
                    Context.prototype._popContext = function() {
                        if (this._trace !== undefined) {
                            var trace = contextStack.pop();
                            var ret = trace._promiseCreated;
                            trace._promiseCreated = null;
                            return ret;
                        }
                        return null;
                    };
                    function createContext() {
                        if (longStackTraces) return new Context();
                    }
                    function peekContext() {
                        var lastIndex = contextStack.length - 1;
                        if (lastIndex >= 0) return contextStack[lastIndex];
                        return undefined;
                    }
                    Context.CapturedTrace = null;
                    Context.create = createContext;
                    Context.deactivateLongStackTraces = function() {};
                    Context.activateLongStackTraces = function() {
                        var Promise_pushContext = Promise1.prototype._pushContext;
                        var Promise_popContext = Promise1.prototype._popContext;
                        var Promise_PeekContext = Promise1._peekContext;
                        var Promise_peekContext = Promise1.prototype._peekContext;
                        var Promise_promiseCreated = Promise1.prototype._promiseCreated;
                        Context.deactivateLongStackTraces = function() {
                            Promise1.prototype._pushContext = Promise_pushContext;
                            Promise1.prototype._popContext = Promise_popContext;
                            Promise1._peekContext = Promise_PeekContext;
                            Promise1.prototype._peekContext = Promise_peekContext;
                            Promise1.prototype._promiseCreated = Promise_promiseCreated;
                            longStackTraces = false;
                        };
                        longStackTraces = true;
                        Promise1.prototype._pushContext = Context.prototype._pushContext;
                        Promise1.prototype._popContext = Context.prototype._popContext;
                        Promise1._peekContext = Promise1.prototype._peekContext = peekContext;
                        Promise1.prototype._promiseCreated = function() {
                            var ctx = this._peekContext();
                            if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
                        };
                    };
                    return Context;
                };
            },
            {}
        ],
        9: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, Context, enableAsyncHooks, disableAsyncHooks) {
                    var async = Promise1._async;
                    var Warning = _dereq_1("./errors").Warning;
                    var util = _dereq_1("./util");
                    var es5 = _dereq_1("./es5");
                    var canAttachTrace = util.canAttachTrace;
                    var unhandledRejectionHandled;
                    var possiblyUnhandledRejection;
                    var bluebirdFramePattern = /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
                    var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
                    var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
                    var stackFramePattern = null;
                    var formatStack = null;
                    var indentStackFrames = false;
                    var printWarning;
                    var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 && true);
                    var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 && (debugging || util.env("BLUEBIRD_WARNINGS")));
                    var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 && (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
                    var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 && (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
                    var deferUnhandledRejectionCheck;
                    (function() {
                        var promises = [];
                        function unhandledRejectionCheck() {
                            for(var i = 0; i < promises.length; ++i)promises[i]._notifyUnhandledRejection();
                            unhandledRejectionClear();
                        }
                        function unhandledRejectionClear() {
                            promises.length = 0;
                        }
                        deferUnhandledRejectionCheck = function(promise) {
                            promises.push(promise);
                            setTimeout(unhandledRejectionCheck, 1);
                        };
                        es5.defineProperty(Promise1, "_unhandledRejectionCheck", {
                            value: unhandledRejectionCheck
                        });
                        es5.defineProperty(Promise1, "_unhandledRejectionClear", {
                            value: unhandledRejectionClear
                        });
                    })();
                    Promise1.prototype.suppressUnhandledRejections = function() {
                        var target = this._target();
                        target._bitField = target._bitField & -1048577 | 524288;
                    };
                    Promise1.prototype._ensurePossibleRejectionHandled = function() {
                        if ((this._bitField & 524288) !== 0) return;
                        this._setRejectionIsUnhandled();
                        deferUnhandledRejectionCheck(this);
                    };
                    Promise1.prototype._notifyUnhandledRejectionIsHandled = function() {
                        fireRejectionEvent("rejectionHandled", unhandledRejectionHandled, undefined, this);
                    };
                    Promise1.prototype._setReturnedNonUndefined = function() {
                        this._bitField = this._bitField | 268435456;
                    };
                    Promise1.prototype._returnedNonUndefined = function() {
                        return (this._bitField & 268435456) !== 0;
                    };
                    Promise1.prototype._notifyUnhandledRejection = function() {
                        if (this._isRejectionUnhandled()) {
                            var reason = this._settledValue();
                            this._setUnhandledRejectionIsNotified();
                            fireRejectionEvent("unhandledRejection", possiblyUnhandledRejection, reason, this);
                        }
                    };
                    Promise1.prototype._setUnhandledRejectionIsNotified = function() {
                        this._bitField = this._bitField | 262144;
                    };
                    Promise1.prototype._unsetUnhandledRejectionIsNotified = function() {
                        this._bitField = this._bitField & -262145;
                    };
                    Promise1.prototype._isUnhandledRejectionNotified = function() {
                        return (this._bitField & 262144) > 0;
                    };
                    Promise1.prototype._setRejectionIsUnhandled = function() {
                        this._bitField = this._bitField | 1048576;
                    };
                    Promise1.prototype._unsetRejectionIsUnhandled = function() {
                        this._bitField = this._bitField & -1048577;
                        if (this._isUnhandledRejectionNotified()) {
                            this._unsetUnhandledRejectionIsNotified();
                            this._notifyUnhandledRejectionIsHandled();
                        }
                    };
                    Promise1.prototype._isRejectionUnhandled = function() {
                        return (this._bitField & 1048576) > 0;
                    };
                    Promise1.prototype._warn = function(message, shouldUseOwnTrace, promise) {
                        return warn(message, shouldUseOwnTrace, promise || this);
                    };
                    Promise1.onPossiblyUnhandledRejection = function(fn) {
                        var context = Promise1._getContext();
                        possiblyUnhandledRejection = util.contextBind(context, fn);
                    };
                    Promise1.onUnhandledRejectionHandled = function(fn) {
                        var context = Promise1._getContext();
                        unhandledRejectionHandled = util.contextBind(context, fn);
                    };
                    var disableLongStackTraces = function() {};
                    Promise1.longStackTraces = function() {
                        if (async.haveItemsQueued() && !config.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        if (!config.longStackTraces && longStackTracesIsSupported()) {
                            var Promise_captureStackTrace = Promise1.prototype._captureStackTrace;
                            var Promise_attachExtraTrace = Promise1.prototype._attachExtraTrace;
                            var Promise_dereferenceTrace = Promise1.prototype._dereferenceTrace;
                            config.longStackTraces = true;
                            disableLongStackTraces = function() {
                                if (async.haveItemsQueued() && !config.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                                Promise1.prototype._captureStackTrace = Promise_captureStackTrace;
                                Promise1.prototype._attachExtraTrace = Promise_attachExtraTrace;
                                Promise1.prototype._dereferenceTrace = Promise_dereferenceTrace;
                                Context.deactivateLongStackTraces();
                                config.longStackTraces = false;
                            };
                            Promise1.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
                            Promise1.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
                            Promise1.prototype._dereferenceTrace = longStackTracesDereferenceTrace;
                            Context.activateLongStackTraces();
                        }
                    };
                    Promise1.hasLongStackTraces = function() {
                        return config.longStackTraces && longStackTracesIsSupported();
                    };
                    var legacyHandlers = {
                        unhandledrejection: {
                            before: function() {
                                var ret = util.global.onunhandledrejection;
                                util.global.onunhandledrejection = null;
                                return ret;
                            },
                            after: function(fn) {
                                util.global.onunhandledrejection = fn;
                            }
                        },
                        rejectionhandled: {
                            before: function() {
                                var ret = util.global.onrejectionhandled;
                                util.global.onrejectionhandled = null;
                                return ret;
                            },
                            after: function(fn) {
                                util.global.onrejectionhandled = fn;
                            }
                        }
                    };
                    var fireDomEvent = function() {
                        var dispatch = function(legacy, e) {
                            if (legacy) {
                                var fn;
                                try {
                                    fn = legacy.before();
                                    return !util.global.dispatchEvent(e);
                                } finally{
                                    legacy.after(fn);
                                }
                            } else return !util.global.dispatchEvent(e);
                        };
                        try {
                            if (typeof CustomEvent === "function") {
                                var event = new CustomEvent("CustomEvent");
                                util.global.dispatchEvent(event);
                                return function(name, event) {
                                    name = name.toLowerCase();
                                    var eventData = {
                                        detail: event,
                                        cancelable: true
                                    };
                                    var domEvent = new CustomEvent(name, eventData);
                                    es5.defineProperty(domEvent, "promise", {
                                        value: event.promise
                                    });
                                    es5.defineProperty(domEvent, "reason", {
                                        value: event.reason
                                    });
                                    return dispatch(legacyHandlers[name], domEvent);
                                };
                            } else if (typeof Event === "function") {
                                var event = new Event("CustomEvent");
                                util.global.dispatchEvent(event);
                                return function(name, event) {
                                    name = name.toLowerCase();
                                    var domEvent = new Event(name, {
                                        cancelable: true
                                    });
                                    domEvent.detail = event;
                                    es5.defineProperty(domEvent, "promise", {
                                        value: event.promise
                                    });
                                    es5.defineProperty(domEvent, "reason", {
                                        value: event.reason
                                    });
                                    return dispatch(legacyHandlers[name], domEvent);
                                };
                            } else {
                                var event = document.createEvent("CustomEvent");
                                event.initCustomEvent("testingtheevent", false, true, {});
                                util.global.dispatchEvent(event);
                                return function(name, event) {
                                    name = name.toLowerCase();
                                    var domEvent = document.createEvent("CustomEvent");
                                    domEvent.initCustomEvent(name, false, true, event);
                                    return dispatch(legacyHandlers[name], domEvent);
                                };
                            }
                        } catch (e) {}
                        return function() {
                            return false;
                        };
                    }();
                    var fireGlobalEvent = function() {
                        if (util.isNode) return function() {
                            return $4acf49f6c3e67aec$exports.emit.apply($4acf49f6c3e67aec$exports, arguments);
                        };
                        else {
                            if (!util.global) return function() {
                                return false;
                            };
                            return function(name) {
                                var methodName = "on" + name.toLowerCase();
                                var method = util.global[methodName];
                                if (!method) return false;
                                method.apply(util.global, [].slice.call(arguments, 1));
                                return true;
                            };
                        }
                    }();
                    function generatePromiseLifecycleEventObject(name, promise) {
                        return {
                            promise: promise
                        };
                    }
                    var eventToObjectGenerator = {
                        promiseCreated: generatePromiseLifecycleEventObject,
                        promiseFulfilled: generatePromiseLifecycleEventObject,
                        promiseRejected: generatePromiseLifecycleEventObject,
                        promiseResolved: generatePromiseLifecycleEventObject,
                        promiseCancelled: generatePromiseLifecycleEventObject,
                        promiseChained: function(name, promise, child) {
                            return {
                                promise: promise,
                                child: child
                            };
                        },
                        warning: function(name, warning) {
                            return {
                                warning: warning
                            };
                        },
                        unhandledRejection: function(name, reason, promise) {
                            return {
                                reason: reason,
                                promise: promise
                            };
                        },
                        rejectionHandled: generatePromiseLifecycleEventObject
                    };
                    var activeFireEvent = function(name) {
                        var globalEventFired = false;
                        try {
                            globalEventFired = fireGlobalEvent.apply(null, arguments);
                        } catch (e) {
                            async.throwLater(e);
                            globalEventFired = true;
                        }
                        var domEventFired = false;
                        try {
                            domEventFired = fireDomEvent(name, eventToObjectGenerator[name].apply(null, arguments));
                        } catch (e) {
                            async.throwLater(e);
                            domEventFired = true;
                        }
                        return domEventFired || globalEventFired;
                    };
                    Promise1.config = function(opts) {
                        opts = Object(opts);
                        if ("longStackTraces" in opts) {
                            if (opts.longStackTraces) Promise1.longStackTraces();
                            else if (!opts.longStackTraces && Promise1.hasLongStackTraces()) disableLongStackTraces();
                        }
                        if ("warnings" in opts) {
                            var warningsOption = opts.warnings;
                            config.warnings = !!warningsOption;
                            wForgottenReturn = config.warnings;
                            if (util.isObject(warningsOption)) {
                                if ("wForgottenReturn" in warningsOption) wForgottenReturn = !!warningsOption.wForgottenReturn;
                            }
                        }
                        if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
                            if (async.haveItemsQueued()) throw new Error("cannot enable cancellation after promises are in use");
                            Promise1.prototype._clearCancellationData = cancellationClearCancellationData;
                            Promise1.prototype._propagateFrom = cancellationPropagateFrom;
                            Promise1.prototype._onCancel = cancellationOnCancel;
                            Promise1.prototype._setOnCancel = cancellationSetOnCancel;
                            Promise1.prototype._attachCancellationCallback = cancellationAttachCancellationCallback;
                            Promise1.prototype._execute = cancellationExecute;
                            propagateFromFunction = cancellationPropagateFrom;
                            config.cancellation = true;
                        }
                        if ("monitoring" in opts) {
                            if (opts.monitoring && !config.monitoring) {
                                config.monitoring = true;
                                Promise1.prototype._fireEvent = activeFireEvent;
                            } else if (!opts.monitoring && config.monitoring) {
                                config.monitoring = false;
                                Promise1.prototype._fireEvent = defaultFireEvent;
                            }
                        }
                        if ("asyncHooks" in opts && util.nodeSupportsAsyncResource) {
                            var prev = config.asyncHooks;
                            var cur = !!opts.asyncHooks;
                            if (prev !== cur) {
                                config.asyncHooks = cur;
                                if (cur) enableAsyncHooks();
                                else disableAsyncHooks();
                            }
                        }
                        return Promise1;
                    };
                    function defaultFireEvent() {
                        return false;
                    }
                    Promise1.prototype._fireEvent = defaultFireEvent;
                    Promise1.prototype._execute = function(executor, resolve, reject) {
                        try {
                            executor(resolve, reject);
                        } catch (e) {
                            return e;
                        }
                    };
                    Promise1.prototype._onCancel = function() {};
                    Promise1.prototype._setOnCancel = function(handler) {};
                    Promise1.prototype._attachCancellationCallback = function(onCancel) {};
                    Promise1.prototype._captureStackTrace = function() {};
                    Promise1.prototype._attachExtraTrace = function() {};
                    Promise1.prototype._dereferenceTrace = function() {};
                    Promise1.prototype._clearCancellationData = function() {};
                    Promise1.prototype._propagateFrom = function(parent, flags) {};
                    function cancellationExecute(executor, resolve, reject) {
                        var promise = this;
                        try {
                            executor(resolve, reject, function(onCancel) {
                                if (typeof onCancel !== "function") throw new TypeError("onCancel must be a function, got: " + util.toString(onCancel));
                                promise._attachCancellationCallback(onCancel);
                            });
                        } catch (e) {
                            return e;
                        }
                    }
                    function cancellationAttachCancellationCallback(onCancel) {
                        if (!this._isCancellable()) return this;
                        var previousOnCancel = this._onCancel();
                        if (previousOnCancel !== undefined) {
                            if (util.isArray(previousOnCancel)) previousOnCancel.push(onCancel);
                            else this._setOnCancel([
                                previousOnCancel,
                                onCancel
                            ]);
                        } else this._setOnCancel(onCancel);
                    }
                    function cancellationOnCancel() {
                        return this._onCancelField;
                    }
                    function cancellationSetOnCancel(onCancel) {
                        this._onCancelField = onCancel;
                    }
                    function cancellationClearCancellationData() {
                        this._cancellationParent = undefined;
                        this._onCancelField = undefined;
                    }
                    function cancellationPropagateFrom(parent, flags) {
                        if ((flags & 1) !== 0) {
                            this._cancellationParent = parent;
                            var branchesRemainingToCancel = parent._branchesRemainingToCancel;
                            if (branchesRemainingToCancel === undefined) branchesRemainingToCancel = 0;
                            parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
                        }
                        if ((flags & 2) !== 0 && parent._isBound()) this._setBoundTo(parent._boundTo);
                    }
                    function bindingPropagateFrom(parent, flags) {
                        if ((flags & 2) !== 0 && parent._isBound()) this._setBoundTo(parent._boundTo);
                    }
                    var propagateFromFunction = bindingPropagateFrom;
                    function boundValueFunction() {
                        var ret = this._boundTo;
                        if (ret !== undefined) {
                            if (ret instanceof Promise1) {
                                if (ret.isFulfilled()) return ret.value();
                                else return undefined;
                            }
                        }
                        return ret;
                    }
                    function longStackTracesCaptureStackTrace() {
                        this._trace = new CapturedTrace(this._peekContext());
                    }
                    function longStackTracesAttachExtraTrace(error, ignoreSelf) {
                        if (canAttachTrace(error)) {
                            var trace = this._trace;
                            if (trace !== undefined) {
                                if (ignoreSelf) trace = trace._parent;
                            }
                            if (trace !== undefined) trace.attachExtraTrace(error);
                            else if (!error.__stackCleaned__) {
                                var parsed = parseStackAndMessage(error);
                                util.notEnumerableProp(error, "stack", parsed.message + "\n" + parsed.stack.join("\n"));
                                util.notEnumerableProp(error, "__stackCleaned__", true);
                            }
                        }
                    }
                    function longStackTracesDereferenceTrace() {
                        this._trace = undefined;
                    }
                    function checkForgottenReturns(returnValue, promiseCreated, name, promise, parent) {
                        if (returnValue === undefined && promiseCreated !== null && wForgottenReturn) {
                            if (parent !== undefined && parent._returnedNonUndefined()) return;
                            if ((promise._bitField & 65535) === 0) return;
                            if (name) name = name + " ";
                            var handlerLine = "";
                            var creatorLine = "";
                            if (promiseCreated._trace) {
                                var traceLines = promiseCreated._trace.stack.split("\n");
                                var stack = cleanStack(traceLines);
                                for(var i = stack.length - 1; i >= 0; --i){
                                    var line = stack[i];
                                    if (!nodeFramePattern.test(line)) {
                                        var lineMatches = line.match(parseLinePattern);
                                        if (lineMatches) handlerLine = "at " + lineMatches[1] + ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                                        break;
                                    }
                                }
                                if (stack.length > 0) {
                                    var firstUserLine = stack[0];
                                    for(var i = 0; i < traceLines.length; ++i)if (traceLines[i] === firstUserLine) {
                                        if (i > 0) creatorLine = "\n" + traceLines[i - 1];
                                        break;
                                    }
                                }
                            }
                            var msg = "a promise was created in a " + name + "handler " + handlerLine + "but was not returned from it, " + "see http://goo.gl/rRqMUw" + creatorLine;
                            promise._warn(msg, true, promiseCreated);
                        }
                    }
                    function deprecated(name, replacement) {
                        var message = name + " is deprecated and will be removed in a future version.";
                        if (replacement) message += " Use " + replacement + " instead.";
                        return warn(message);
                    }
                    function warn(message, shouldUseOwnTrace, promise) {
                        if (!config.warnings) return;
                        var warning = new Warning(message);
                        var ctx;
                        if (shouldUseOwnTrace) promise._attachExtraTrace(warning);
                        else if (config.longStackTraces && (ctx = Promise1._peekContext())) ctx.attachExtraTrace(warning);
                        else {
                            var parsed = parseStackAndMessage(warning);
                            warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
                        }
                        if (!activeFireEvent("warning", warning)) formatAndLogError(warning, "", true);
                    }
                    function reconstructStack(message, stacks) {
                        for(var i = 0; i < stacks.length - 1; ++i){
                            stacks[i].push("From previous event:");
                            stacks[i] = stacks[i].join("\n");
                        }
                        if (i < stacks.length) stacks[i] = stacks[i].join("\n");
                        return message + "\n" + stacks.join("\n");
                    }
                    function removeDuplicateOrEmptyJumps(stacks) {
                        for(var i = 0; i < stacks.length; ++i)if (stacks[i].length === 0 || i + 1 < stacks.length && stacks[i][0] === stacks[i + 1][0]) {
                            stacks.splice(i, 1);
                            i--;
                        }
                    }
                    function removeCommonRoots(stacks) {
                        var current = stacks[0];
                        for(var i = 1; i < stacks.length; ++i){
                            var prev = stacks[i];
                            var currentLastIndex = current.length - 1;
                            var currentLastLine = current[currentLastIndex];
                            var commonRootMeetPoint = -1;
                            for(var j = prev.length - 1; j >= 0; --j)if (prev[j] === currentLastLine) {
                                commonRootMeetPoint = j;
                                break;
                            }
                            for(var j = commonRootMeetPoint; j >= 0; --j){
                                var line = prev[j];
                                if (current[currentLastIndex] === line) {
                                    current.pop();
                                    currentLastIndex--;
                                } else break;
                            }
                            current = prev;
                        }
                    }
                    function cleanStack(stack) {
                        var ret = [];
                        for(var i = 0; i < stack.length; ++i){
                            var line = stack[i];
                            var isTraceLine = "    (No stack trace)" === line || stackFramePattern.test(line);
                            var isInternalFrame = isTraceLine && shouldIgnore(line);
                            if (isTraceLine && !isInternalFrame) {
                                if (indentStackFrames && line.charAt(0) !== " ") line = "    " + line;
                                ret.push(line);
                            }
                        }
                        return ret;
                    }
                    function stackFramesAsArray(error) {
                        var stack = error.stack.replace(/\s+$/g, "").split("\n");
                        for(var i = 0; i < stack.length; ++i){
                            var line = stack[i];
                            if ("    (No stack trace)" === line || stackFramePattern.test(line)) break;
                        }
                        if (i > 0 && error.name != "SyntaxError") stack = stack.slice(i);
                        return stack;
                    }
                    function parseStackAndMessage(error) {
                        var stack = error.stack;
                        var message = error.toString();
                        stack = typeof stack === "string" && stack.length > 0 ? stackFramesAsArray(error) : [
                            "    (No stack trace)"
                        ];
                        return {
                            message: message,
                            stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
                        };
                    }
                    function formatAndLogError(error, title, isSoft) {
                        if (typeof console !== "undefined") {
                            var message;
                            if (util.isObject(error)) {
                                var stack = error.stack;
                                message = title + formatStack(stack, error);
                            } else message = title + String(error);
                            if (typeof printWarning === "function") printWarning(message, isSoft);
                            else if (typeof console.log === "function" || typeof console.log === "object") console.log(message);
                        }
                    }
                    function fireRejectionEvent(name, localHandler, reason, promise) {
                        var localEventFired = false;
                        try {
                            if (typeof localHandler === "function") {
                                localEventFired = true;
                                if (name === "rejectionHandled") localHandler(promise);
                                else localHandler(reason, promise);
                            }
                        } catch (e) {
                            async.throwLater(e);
                        }
                        if (name === "unhandledRejection") {
                            if (!activeFireEvent(name, reason, promise) && !localEventFired) formatAndLogError(reason, "Unhandled rejection ");
                        } else activeFireEvent(name, promise);
                    }
                    function formatNonError(obj) {
                        var str;
                        if (typeof obj === "function") str = "[function " + (obj.name || "anonymous") + "]";
                        else {
                            str = obj && typeof obj.toString === "function" ? obj.toString() : util.toString(obj);
                            var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
                            if (ruselessToString.test(str)) try {
                                var newStr = JSON.stringify(obj);
                                str = newStr;
                            } catch (e) {}
                            if (str.length === 0) str = "(empty array)";
                        }
                        return "(<" + snip(str) + ">, no stack trace)";
                    }
                    function snip(str) {
                        var maxChars = 41;
                        if (str.length < maxChars) return str;
                        return str.substr(0, maxChars - 3) + "...";
                    }
                    function longStackTracesIsSupported() {
                        return typeof captureStackTrace === "function";
                    }
                    var shouldIgnore = function() {
                        return false;
                    };
                    var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
                    function parseLineInfo(line) {
                        var matches = line.match(parseLineInfoRegex);
                        if (matches) return {
                            fileName: matches[1],
                            line: parseInt(matches[2], 10)
                        };
                    }
                    function setBounds(firstLineError, lastLineError) {
                        if (!longStackTracesIsSupported()) return;
                        var firstStackLines = (firstLineError.stack || "").split("\n");
                        var lastStackLines = (lastLineError.stack || "").split("\n");
                        var firstIndex = -1;
                        var lastIndex = -1;
                        var firstFileName;
                        var lastFileName;
                        for(var i = 0; i < firstStackLines.length; ++i){
                            var result = parseLineInfo(firstStackLines[i]);
                            if (result) {
                                firstFileName = result.fileName;
                                firstIndex = result.line;
                                break;
                            }
                        }
                        for(var i = 0; i < lastStackLines.length; ++i){
                            var result = parseLineInfo(lastStackLines[i]);
                            if (result) {
                                lastFileName = result.fileName;
                                lastIndex = result.line;
                                break;
                            }
                        }
                        if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName || firstFileName !== lastFileName || firstIndex >= lastIndex) return;
                        shouldIgnore = function(line) {
                            if (bluebirdFramePattern.test(line)) return true;
                            var info = parseLineInfo(line);
                            if (info) {
                                if (info.fileName === firstFileName && firstIndex <= info.line && info.line <= lastIndex) return true;
                            }
                            return false;
                        };
                    }
                    function CapturedTrace(parent) {
                        this._parent = parent;
                        this._promisesCreated = 0;
                        var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
                        captureStackTrace(this, CapturedTrace);
                        if (length > 32) this.uncycle();
                    }
                    util.inherits(CapturedTrace, Error);
                    Context.CapturedTrace = CapturedTrace;
                    CapturedTrace.prototype.uncycle = function() {
                        var length = this._length;
                        if (length < 2) return;
                        var nodes = [];
                        var stackToIndex = {};
                        for(var i = 0, node = this; node !== undefined; ++i){
                            nodes.push(node);
                            node = node._parent;
                        }
                        length = this._length = i;
                        for(var i = length - 1; i >= 0; --i){
                            var stack = nodes[i].stack;
                            if (stackToIndex[stack] === undefined) stackToIndex[stack] = i;
                        }
                        for(var i = 0; i < length; ++i){
                            var currentStack = nodes[i].stack;
                            var index = stackToIndex[currentStack];
                            if (index !== undefined && index !== i) {
                                if (index > 0) {
                                    nodes[index - 1]._parent = undefined;
                                    nodes[index - 1]._length = 1;
                                }
                                nodes[i]._parent = undefined;
                                nodes[i]._length = 1;
                                var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
                                if (index < length - 1) {
                                    cycleEdgeNode._parent = nodes[index + 1];
                                    cycleEdgeNode._parent.uncycle();
                                    cycleEdgeNode._length = cycleEdgeNode._parent._length + 1;
                                } else {
                                    cycleEdgeNode._parent = undefined;
                                    cycleEdgeNode._length = 1;
                                }
                                var currentChildLength = cycleEdgeNode._length + 1;
                                for(var j = i - 2; j >= 0; --j){
                                    nodes[j]._length = currentChildLength;
                                    currentChildLength++;
                                }
                                return;
                            }
                        }
                    };
                    CapturedTrace.prototype.attachExtraTrace = function(error) {
                        if (error.__stackCleaned__) return;
                        this.uncycle();
                        var parsed = parseStackAndMessage(error);
                        var message = parsed.message;
                        var stacks = [
                            parsed.stack
                        ];
                        var trace = this;
                        while(trace !== undefined){
                            stacks.push(cleanStack(trace.stack.split("\n")));
                            trace = trace._parent;
                        }
                        removeCommonRoots(stacks);
                        removeDuplicateOrEmptyJumps(stacks);
                        util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
                        util.notEnumerableProp(error, "__stackCleaned__", true);
                    };
                    var captureStackTrace = function stackDetection() {
                        var v8stackFramePattern = /^\s*at\s*/;
                        var v8stackFormatter = function(stack, error) {
                            if (typeof stack === "string") return stack;
                            if (error.name !== undefined && error.message !== undefined) return error.toString();
                            return formatNonError(error);
                        };
                        if (typeof Error.stackTraceLimit === "number" && typeof Error.captureStackTrace === "function") {
                            Error.stackTraceLimit += 6;
                            stackFramePattern = v8stackFramePattern;
                            formatStack = v8stackFormatter;
                            var captureStackTrace = Error.captureStackTrace;
                            shouldIgnore = function(line) {
                                return bluebirdFramePattern.test(line);
                            };
                            return function(receiver, ignoreUntil) {
                                Error.stackTraceLimit += 6;
                                captureStackTrace(receiver, ignoreUntil);
                                Error.stackTraceLimit -= 6;
                            };
                        }
                        var err = new Error();
                        if (typeof err.stack === "string" && err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
                            stackFramePattern = /@/;
                            formatStack = v8stackFormatter;
                            indentStackFrames = true;
                            return function captureStackTrace(o) {
                                o.stack = new Error().stack;
                            };
                        }
                        var hasStackAfterThrow;
                        try {
                            throw new Error();
                        } catch (e) {
                            hasStackAfterThrow = "stack" in e;
                        }
                        if (!("stack" in err) && hasStackAfterThrow && typeof Error.stackTraceLimit === "number") {
                            stackFramePattern = v8stackFramePattern;
                            formatStack = v8stackFormatter;
                            return function captureStackTrace(o) {
                                Error.stackTraceLimit += 6;
                                try {
                                    throw new Error();
                                } catch (e) {
                                    o.stack = e.stack;
                                }
                                Error.stackTraceLimit -= 6;
                            };
                        }
                        formatStack = function(stack, error) {
                            if (typeof stack === "string") return stack;
                            if ((typeof error === "object" || typeof error === "function") && error.name !== undefined && error.message !== undefined) return error.toString();
                            return formatNonError(error);
                        };
                        return null;
                    }([]);
                    if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
                        printWarning = function(message) {
                            console.warn(message);
                        };
                        if (util.isNode && $4acf49f6c3e67aec$exports.stderr.isTTY) printWarning = function(message, isSoft) {
                            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
                            console.warn(color + message + "\u001b[0m\n");
                        };
                        else if (!util.isNode && typeof new Error().stack === "string") printWarning = function(message, isSoft) {
                            console.warn("%c" + message, isSoft ? "color: darkorange" : "color: red");
                        };
                    }
                    var config = {
                        warnings: warnings,
                        longStackTraces: false,
                        cancellation: false,
                        monitoring: false,
                        asyncHooks: false
                    };
                    if (longStackTraces) Promise1.longStackTraces();
                    return {
                        asyncHooks: function() {
                            return config.asyncHooks;
                        },
                        longStackTraces: function() {
                            return config.longStackTraces;
                        },
                        warnings: function() {
                            return config.warnings;
                        },
                        cancellation: function() {
                            return config.cancellation;
                        },
                        monitoring: function() {
                            return config.monitoring;
                        },
                        propagateFromFunction: function() {
                            return propagateFromFunction;
                        },
                        boundValueFunction: function() {
                            return boundValueFunction;
                        },
                        checkForgottenReturns: checkForgottenReturns,
                        setBounds: setBounds,
                        warn: warn,
                        deprecated: deprecated,
                        CapturedTrace: CapturedTrace,
                        fireDomEvent: fireDomEvent,
                        fireGlobalEvent: fireGlobalEvent
                    };
                };
            },
            {
                "./errors": 12,
                "./es5": 13,
                "./util": 36
            }
        ],
        10: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    function returner() {
                        return this.value;
                    }
                    function thrower() {
                        throw this.reason;
                    }
                    Promise1.prototype["return"] = Promise1.prototype.thenReturn = function(value) {
                        if (value instanceof Promise1) value.suppressUnhandledRejections();
                        return this._then(returner, undefined, undefined, {
                            value: value
                        }, undefined);
                    };
                    Promise1.prototype["throw"] = Promise1.prototype.thenThrow = function(reason) {
                        return this._then(thrower, undefined, undefined, {
                            reason: reason
                        }, undefined);
                    };
                    Promise1.prototype.catchThrow = function(reason) {
                        if (arguments.length <= 1) return this._then(undefined, thrower, undefined, {
                            reason: reason
                        }, undefined);
                        else {
                            var _reason = arguments[1];
                            var handler = function() {
                                throw _reason;
                            };
                            return this.caught(reason, handler);
                        }
                    };
                    Promise1.prototype.catchReturn = function(value) {
                        if (arguments.length <= 1) {
                            if (value instanceof Promise1) value.suppressUnhandledRejections();
                            return this._then(undefined, returner, undefined, {
                                value: value
                            }, undefined);
                        } else {
                            var _value = arguments[1];
                            if (_value instanceof Promise1) _value.suppressUnhandledRejections();
                            var handler = function() {
                                return _value;
                            };
                            return this.caught(value, handler);
                        }
                    };
                };
            },
            {}
        ],
        11: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL) {
                    var PromiseReduce = Promise1.reduce;
                    var PromiseAll = Promise1.all;
                    function promiseAllThis() {
                        return PromiseAll(this);
                    }
                    function PromiseMapSeries(promises, fn) {
                        return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
                    }
                    Promise1.prototype.each = function(fn) {
                        return PromiseReduce(this, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, this, undefined);
                    };
                    Promise1.prototype.mapSeries = function(fn) {
                        return PromiseReduce(this, fn, INTERNAL, INTERNAL);
                    };
                    Promise1.each = function(promises, fn) {
                        return PromiseReduce(promises, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, promises, undefined);
                    };
                    Promise1.mapSeries = PromiseMapSeries;
                };
            },
            {}
        ],
        12: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var es5 = _dereq_1("./es5");
                var Objectfreeze = es5.freeze;
                var util = _dereq_1("./util");
                var inherits = util.inherits;
                var notEnumerableProp = util.notEnumerableProp;
                function subError(nameProperty, defaultMessage) {
                    function SubError(message) {
                        if (!(this instanceof SubError)) return new SubError(message);
                        notEnumerableProp(this, "message", typeof message === "string" ? message : defaultMessage);
                        notEnumerableProp(this, "name", nameProperty);
                        if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
                        else Error.call(this);
                    }
                    inherits(SubError, Error);
                    return SubError;
                }
                var _TypeError, _RangeError;
                var Warning = subError("Warning", "warning");
                var CancellationError = subError("CancellationError", "cancellation error");
                var TimeoutError = subError("TimeoutError", "timeout error");
                var AggregateError = subError("AggregateError", "aggregate error");
                try {
                    _TypeError = TypeError;
                    _RangeError = RangeError;
                } catch (e) {
                    _TypeError = subError("TypeError", "type error");
                    _RangeError = subError("RangeError", "range error");
                }
                var methods = "join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" ");
                for(var i = 0; i < methods.length; ++i)if (typeof Array.prototype[methods[i]] === "function") AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
                es5.defineProperty(AggregateError.prototype, "length", {
                    value: 0,
                    configurable: false,
                    writable: true,
                    enumerable: true
                });
                AggregateError.prototype["isOperational"] = true;
                var level = 0;
                AggregateError.prototype.toString = function() {
                    var indent = Array(level * 4 + 1).join(" ");
                    var ret = "\n" + indent + "AggregateError of:" + "\n";
                    level++;
                    indent = Array(level * 4 + 1).join(" ");
                    for(var i = 0; i < this.length; ++i){
                        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
                        var lines = str.split("\n");
                        for(var j = 0; j < lines.length; ++j)lines[j] = indent + lines[j];
                        str = lines.join("\n");
                        ret += str + "\n";
                    }
                    level--;
                    return ret;
                };
                function OperationalError(message) {
                    if (!(this instanceof OperationalError)) return new OperationalError(message);
                    notEnumerableProp(this, "name", "OperationalError");
                    notEnumerableProp(this, "message", message);
                    this.cause = message;
                    this["isOperational"] = true;
                    if (message instanceof Error) {
                        notEnumerableProp(this, "message", message.message);
                        notEnumerableProp(this, "stack", message.stack);
                    } else if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
                }
                inherits(OperationalError, Error);
                var errorTypes = Error["__BluebirdErrorTypes__"];
                if (!errorTypes) {
                    errorTypes = Objectfreeze({
                        CancellationError: CancellationError,
                        TimeoutError: TimeoutError,
                        OperationalError: OperationalError,
                        RejectionError: OperationalError,
                        AggregateError: AggregateError
                    });
                    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
                        value: errorTypes,
                        writable: false,
                        enumerable: false,
                        configurable: false
                    });
                }
                module1.exports = {
                    Error: Error,
                    TypeError: _TypeError,
                    RangeError: _RangeError,
                    CancellationError: errorTypes.CancellationError,
                    OperationalError: errorTypes.OperationalError,
                    TimeoutError: errorTypes.TimeoutError,
                    AggregateError: errorTypes.AggregateError,
                    Warning: Warning
                };
            },
            {
                "./es5": 13,
                "./util": 36
            }
        ],
        13: [
            function(_dereq_1, module1, exports) {
                var isES5 = function() {
                    "use strict";
                    return this === undefined;
                }();
                if (isES5) module1.exports = {
                    freeze: Object.freeze,
                    defineProperty: Object.defineProperty,
                    getDescriptor: Object.getOwnPropertyDescriptor,
                    keys: Object.keys,
                    names: Object.getOwnPropertyNames,
                    getPrototypeOf: Object.getPrototypeOf,
                    isArray: Array.isArray,
                    isES5: isES5,
                    propertyIsWritable: function(obj, prop) {
                        var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
                        return !!(!descriptor || descriptor.writable || descriptor.set);
                    }
                };
                else {
                    var has = {}.hasOwnProperty;
                    var str = {}.toString;
                    var proto = {}.constructor.prototype;
                    var ObjectKeys = function(o) {
                        var ret = [];
                        for(var key in o)if (has.call(o, key)) ret.push(key);
                        return ret;
                    };
                    var ObjectGetDescriptor = function(o, key) {
                        return {
                            value: o[key]
                        };
                    };
                    var ObjectDefineProperty = function(o, key, desc) {
                        o[key] = desc.value;
                        return o;
                    };
                    var ObjectFreeze = function(obj) {
                        return obj;
                    };
                    var ObjectGetPrototypeOf = function(obj) {
                        try {
                            return Object(obj).constructor.prototype;
                        } catch (e) {
                            return proto;
                        }
                    };
                    var ArrayIsArray = function(obj) {
                        try {
                            return str.call(obj) === "[object Array]";
                        } catch (e) {
                            return false;
                        }
                    };
                    module1.exports = {
                        isArray: ArrayIsArray,
                        keys: ObjectKeys,
                        names: ObjectKeys,
                        defineProperty: ObjectDefineProperty,
                        getDescriptor: ObjectGetDescriptor,
                        freeze: ObjectFreeze,
                        getPrototypeOf: ObjectGetPrototypeOf,
                        isES5: isES5,
                        propertyIsWritable: function() {
                            return true;
                        }
                    };
                }
            },
            {}
        ],
        14: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL) {
                    var PromiseMap = Promise1.map;
                    Promise1.prototype.filter = function(fn, options) {
                        return PromiseMap(this, fn, options, INTERNAL);
                    };
                    Promise1.filter = function(promises, fn, options) {
                        return PromiseMap(promises, fn, options, INTERNAL);
                    };
                };
            },
            {}
        ],
        15: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, tryConvertToPromise, NEXT_FILTER) {
                    var util = _dereq_1("./util");
                    var CancellationError = Promise1.CancellationError;
                    var errorObj = util.errorObj;
                    var catchFilter = _dereq_1("./catch_filter")(NEXT_FILTER);
                    function PassThroughHandlerContext(promise, type, handler) {
                        this.promise = promise;
                        this.type = type;
                        this.handler = handler;
                        this.called = false;
                        this.cancelPromise = null;
                    }
                    PassThroughHandlerContext.prototype.isFinallyHandler = function() {
                        return this.type === 0;
                    };
                    function FinallyHandlerCancelReaction(finallyHandler) {
                        this.finallyHandler = finallyHandler;
                    }
                    FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
                        checkCancel(this.finallyHandler);
                    };
                    function checkCancel(ctx, reason) {
                        if (ctx.cancelPromise != null) {
                            if (arguments.length > 1) ctx.cancelPromise._reject(reason);
                            else ctx.cancelPromise._cancel();
                            ctx.cancelPromise = null;
                            return true;
                        }
                        return false;
                    }
                    function succeed() {
                        return finallyHandler.call(this, this.promise._target()._settledValue());
                    }
                    function fail(reason) {
                        if (checkCancel(this, reason)) return;
                        errorObj.e = reason;
                        return errorObj;
                    }
                    function finallyHandler(reasonOrValue) {
                        var promise = this.promise;
                        var handler = this.handler;
                        if (!this.called) {
                            this.called = true;
                            var ret = this.isFinallyHandler() ? handler.call(promise._boundValue()) : handler.call(promise._boundValue(), reasonOrValue);
                            if (ret === NEXT_FILTER) return ret;
                            else if (ret !== undefined) {
                                promise._setReturnedNonUndefined();
                                var maybePromise = tryConvertToPromise(ret, promise);
                                if (maybePromise instanceof Promise1) {
                                    if (this.cancelPromise != null) {
                                        if (maybePromise._isCancelled()) {
                                            var reason = new CancellationError("late cancellation observer");
                                            promise._attachExtraTrace(reason);
                                            errorObj.e = reason;
                                            return errorObj;
                                        } else if (maybePromise.isPending()) maybePromise._attachCancellationCallback(new FinallyHandlerCancelReaction(this));
                                    }
                                    return maybePromise._then(succeed, fail, undefined, this, undefined);
                                }
                            }
                        }
                        if (promise.isRejected()) {
                            checkCancel(this);
                            errorObj.e = reasonOrValue;
                            return errorObj;
                        } else {
                            checkCancel(this);
                            return reasonOrValue;
                        }
                    }
                    Promise1.prototype._passThrough = function(handler, type, success, fail) {
                        if (typeof handler !== "function") return this.then();
                        return this._then(success, fail, undefined, new PassThroughHandlerContext(this, type, handler), undefined);
                    };
                    Promise1.prototype.lastly = Promise1.prototype["finally"] = function(handler) {
                        return this._passThrough(handler, 0, finallyHandler, finallyHandler);
                    };
                    Promise1.prototype.tap = function(handler) {
                        return this._passThrough(handler, 1, finallyHandler);
                    };
                    Promise1.prototype.tapCatch = function(handlerOrPredicate) {
                        var len = arguments.length;
                        if (len === 1) return this._passThrough(handlerOrPredicate, 1, undefined, finallyHandler);
                        else {
                            var catchInstances = new Array(len - 1), j = 0, i;
                            for(i = 0; i < len - 1; ++i){
                                var item = arguments[i];
                                if (util.isObject(item)) catchInstances[j++] = item;
                                else return Promise1.reject(new TypeError("tapCatch statement predicate: expecting an object but got " + util.classString(item)));
                            }
                            catchInstances.length = j;
                            var handler = arguments[i];
                            return this._passThrough(catchFilter(catchInstances, handler, this), 1, undefined, finallyHandler);
                        }
                    };
                    return PassThroughHandlerContext;
                };
            },
            {
                "./catch_filter": 7,
                "./util": 36
            }
        ],
        16: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug) {
                    var errors = _dereq_1("./errors");
                    var TypeError1 = errors.TypeError;
                    var util = _dereq_1("./util");
                    var errorObj = util.errorObj;
                    var tryCatch = util.tryCatch;
                    var yieldHandlers = [];
                    function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
                        for(var i = 0; i < yieldHandlers.length; ++i){
                            traceParent._pushContext();
                            var result = tryCatch(yieldHandlers[i])(value);
                            traceParent._popContext();
                            if (result === errorObj) {
                                traceParent._pushContext();
                                var ret = Promise1.reject(errorObj.e);
                                traceParent._popContext();
                                return ret;
                            }
                            var maybePromise = tryConvertToPromise(result, traceParent);
                            if (maybePromise instanceof Promise1) return maybePromise;
                        }
                        return null;
                    }
                    function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
                        if (debug.cancellation()) {
                            var internal = new Promise1(INTERNAL);
                            var _finallyPromise = this._finallyPromise = new Promise1(INTERNAL);
                            this._promise = internal.lastly(function() {
                                return _finallyPromise;
                            });
                            internal._captureStackTrace();
                            internal._setOnCancel(this);
                        } else {
                            var promise = this._promise = new Promise1(INTERNAL);
                            promise._captureStackTrace();
                        }
                        this._stack = stack;
                        this._generatorFunction = generatorFunction;
                        this._receiver = receiver;
                        this._generator = undefined;
                        this._yieldHandlers = typeof yieldHandler === "function" ? [
                            yieldHandler
                        ].concat(yieldHandlers) : yieldHandlers;
                        this._yieldedPromise = null;
                        this._cancellationPhase = false;
                    }
                    util.inherits(PromiseSpawn, Proxyable);
                    PromiseSpawn.prototype._isResolved = function() {
                        return this._promise === null;
                    };
                    PromiseSpawn.prototype._cleanup = function() {
                        this._promise = this._generator = null;
                        if (debug.cancellation() && this._finallyPromise !== null) {
                            this._finallyPromise._fulfill();
                            this._finallyPromise = null;
                        }
                    };
                    PromiseSpawn.prototype._promiseCancelled = function() {
                        if (this._isResolved()) return;
                        var implementsReturn = typeof this._generator["return"] !== "undefined";
                        var result;
                        if (!implementsReturn) {
                            var reason = new Promise1.CancellationError("generator .return() sentinel");
                            Promise1.coroutine.returnSentinel = reason;
                            this._promise._attachExtraTrace(reason);
                            this._promise._pushContext();
                            result = tryCatch(this._generator["throw"]).call(this._generator, reason);
                            this._promise._popContext();
                        } else {
                            this._promise._pushContext();
                            result = tryCatch(this._generator["return"]).call(this._generator, undefined);
                            this._promise._popContext();
                        }
                        this._cancellationPhase = true;
                        this._yieldedPromise = null;
                        this._continue(result);
                    };
                    PromiseSpawn.prototype._promiseFulfilled = function(value) {
                        this._yieldedPromise = null;
                        this._promise._pushContext();
                        var result = tryCatch(this._generator.next).call(this._generator, value);
                        this._promise._popContext();
                        this._continue(result);
                    };
                    PromiseSpawn.prototype._promiseRejected = function(reason) {
                        this._yieldedPromise = null;
                        this._promise._attachExtraTrace(reason);
                        this._promise._pushContext();
                        var result = tryCatch(this._generator["throw"]).call(this._generator, reason);
                        this._promise._popContext();
                        this._continue(result);
                    };
                    PromiseSpawn.prototype._resultCancelled = function() {
                        if (this._yieldedPromise instanceof Promise1) {
                            var promise = this._yieldedPromise;
                            this._yieldedPromise = null;
                            promise.cancel();
                        }
                    };
                    PromiseSpawn.prototype.promise = function() {
                        return this._promise;
                    };
                    PromiseSpawn.prototype._run = function() {
                        this._generator = this._generatorFunction.call(this._receiver);
                        this._receiver = this._generatorFunction = undefined;
                        this._promiseFulfilled(undefined);
                    };
                    PromiseSpawn.prototype._continue = function(result) {
                        var promise = this._promise;
                        if (result === errorObj) {
                            this._cleanup();
                            if (this._cancellationPhase) return promise.cancel();
                            else return promise._rejectCallback(result.e, false);
                        }
                        var value = result.value;
                        if (result.done === true) {
                            this._cleanup();
                            if (this._cancellationPhase) return promise.cancel();
                            else return promise._resolveCallback(value);
                        } else {
                            var maybePromise = tryConvertToPromise(value, this._promise);
                            if (!(maybePromise instanceof Promise1)) {
                                maybePromise = promiseFromYieldHandler(maybePromise, this._yieldHandlers, this._promise);
                                if (maybePromise === null) {
                                    this._promiseRejected(new TypeError1("A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", String(value)) + "From coroutine:\u000a" + this._stack.split("\n").slice(1, -7).join("\n")));
                                    return;
                                }
                            }
                            maybePromise = maybePromise._target();
                            var bitField = maybePromise._bitField;
                            if ((bitField & 50397184) === 0) {
                                this._yieldedPromise = maybePromise;
                                maybePromise._proxy(this, null);
                            } else if ((bitField & 33554432) !== 0) Promise1._async.invoke(this._promiseFulfilled, this, maybePromise._value());
                            else if ((bitField & 16777216) !== 0) Promise1._async.invoke(this._promiseRejected, this, maybePromise._reason());
                            else this._promiseCancelled();
                        }
                    };
                    Promise1.coroutine = function(generatorFunction, options) {
                        if (typeof generatorFunction !== "function") throw new TypeError1("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        var yieldHandler = Object(options).yieldHandler;
                        var PromiseSpawn$ = PromiseSpawn;
                        var stack = new Error().stack;
                        return function() {
                            var generator = generatorFunction.apply(this, arguments);
                            var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler, stack);
                            var ret = spawn.promise();
                            spawn._generator = generator;
                            spawn._promiseFulfilled(undefined);
                            return ret;
                        };
                    };
                    Promise1.coroutine.addYieldHandler = function(fn) {
                        if (typeof fn !== "function") throw new TypeError1("expecting a function but got " + util.classString(fn));
                        yieldHandlers.push(fn);
                    };
                    Promise1.spawn = function(generatorFunction) {
                        debug.deprecated("Promise.spawn()", "Promise.coroutine()");
                        if (typeof generatorFunction !== "function") return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        var spawn = new PromiseSpawn(generatorFunction, this);
                        var ret = spawn.promise();
                        spawn._run(Promise1.spawn);
                        return ret;
                    };
                };
            },
            {
                "./errors": 12,
                "./util": 36
            }
        ],
        17: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, tryConvertToPromise, INTERNAL, async) {
                    var util = _dereq_1("./util");
                    var canEvaluate = util.canEvaluate;
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    var reject;
                    var thenCallback, promiseSetter, generateHolderClass, holderClasses, thenCallbacks, promiseSetters, i;
                    Promise1.join = function() {
                        var last = arguments.length - 1;
                        var fn;
                        if (last > 0 && typeof arguments[last] === "function") {
                            fn = arguments[last];
                            var ret, HolderClass, holder, callbacks, i, maybePromise, bitField, context;
                        }
                        var args = [].slice.call(arguments);
                        if (fn) args.pop();
                        var ret = new PromiseArray(args).promise();
                        return fn !== undefined ? ret.spread(fn) : ret;
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        18: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
                    var util = _dereq_1("./util");
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    var async = Promise1._async;
                    function MappingPromiseArray(promises, fn, limit, _filter) {
                        this.constructor$(promises);
                        this._promise._captureStackTrace();
                        var context = Promise1._getContext();
                        this._callback = util.contextBind(context, fn);
                        this._preservedValues = _filter === INTERNAL ? new Array(this.length()) : null;
                        this._limit = limit;
                        this._inFlight = 0;
                        this._queue = [];
                        async.invoke(this._asyncInit, this, undefined);
                        if (util.isArray(promises)) for(var i = 0; i < promises.length; ++i){
                            var maybePromise = promises[i];
                            if (maybePromise instanceof Promise1) maybePromise.suppressUnhandledRejections();
                        }
                    }
                    util.inherits(MappingPromiseArray, PromiseArray);
                    MappingPromiseArray.prototype._asyncInit = function() {
                        this._init$(undefined, -2);
                    };
                    MappingPromiseArray.prototype._init = function() {};
                    MappingPromiseArray.prototype._promiseFulfilled = function(value, index) {
                        var values = this._values;
                        var length = this.length();
                        var preservedValues = this._preservedValues;
                        var limit = this._limit;
                        if (index < 0) {
                            index = index * -1 - 1;
                            values[index] = value;
                            if (limit >= 1) {
                                this._inFlight--;
                                this._drainQueue();
                                if (this._isResolved()) return true;
                            }
                        } else {
                            if (limit >= 1 && this._inFlight >= limit) {
                                values[index] = value;
                                this._queue.push(index);
                                return false;
                            }
                            if (preservedValues !== null) preservedValues[index] = value;
                            var promise = this._promise;
                            var callback = this._callback;
                            var receiver = promise._boundValue();
                            promise._pushContext();
                            var ret = tryCatch(callback).call(receiver, value, index, length);
                            var promiseCreated = promise._popContext();
                            debug.checkForgottenReturns(ret, promiseCreated, preservedValues !== null ? "Promise.filter" : "Promise.map", promise);
                            if (ret === errorObj) {
                                this._reject(ret.e);
                                return true;
                            }
                            var maybePromise = tryConvertToPromise(ret, this._promise);
                            if (maybePromise instanceof Promise1) {
                                maybePromise = maybePromise._target();
                                var bitField = maybePromise._bitField;
                                if ((bitField & 50397184) === 0) {
                                    if (limit >= 1) this._inFlight++;
                                    values[index] = maybePromise;
                                    maybePromise._proxy(this, (index + 1) * -1);
                                    return false;
                                } else if ((bitField & 33554432) !== 0) ret = maybePromise._value();
                                else if ((bitField & 16777216) !== 0) {
                                    this._reject(maybePromise._reason());
                                    return true;
                                } else {
                                    this._cancel();
                                    return true;
                                }
                            }
                            values[index] = ret;
                        }
                        var totalResolved = ++this._totalResolved;
                        if (totalResolved >= length) {
                            if (preservedValues !== null) this._filter(values, preservedValues);
                            else this._resolve(values);
                            return true;
                        }
                        return false;
                    };
                    MappingPromiseArray.prototype._drainQueue = function() {
                        var queue = this._queue;
                        var limit = this._limit;
                        var values = this._values;
                        while(queue.length > 0 && this._inFlight < limit){
                            if (this._isResolved()) return;
                            var index = queue.pop();
                            this._promiseFulfilled(values[index], index);
                        }
                    };
                    MappingPromiseArray.prototype._filter = function(booleans, values) {
                        var len = values.length;
                        var ret = new Array(len);
                        var j = 0;
                        for(var i = 0; i < len; ++i)if (booleans[i]) ret[j++] = values[i];
                        ret.length = j;
                        this._resolve(ret);
                    };
                    MappingPromiseArray.prototype.preservedValues = function() {
                        return this._preservedValues;
                    };
                    function map(promises, fn, options, _filter) {
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        var limit = 0;
                        if (options !== undefined) {
                            if (typeof options === "object" && options !== null) {
                                if (typeof options.concurrency !== "number") return Promise1.reject(new TypeError("'concurrency' must be a number but it is " + util.classString(options.concurrency)));
                                limit = options.concurrency;
                            } else return Promise1.reject(new TypeError("options argument must be an object but it is " + util.classString(options)));
                        }
                        limit = typeof limit === "number" && isFinite(limit) && limit >= 1 ? limit : 0;
                        return new MappingPromiseArray(promises, fn, limit, _filter).promise();
                    }
                    Promise1.prototype.map = function(fn, options) {
                        return map(this, fn, options, null);
                    };
                    Promise1.map = function(promises, fn, options, _filter) {
                        return map(promises, fn, options, _filter);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        19: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, tryConvertToPromise, apiRejection, debug) {
                    var util = _dereq_1("./util");
                    var tryCatch = util.tryCatch;
                    Promise1.method = function(fn) {
                        if (typeof fn !== "function") throw new Promise1.TypeError("expecting a function but got " + util.classString(fn));
                        return function() {
                            var ret = new Promise1(INTERNAL);
                            ret._captureStackTrace();
                            ret._pushContext();
                            var value = tryCatch(fn).apply(this, arguments);
                            var promiseCreated = ret._popContext();
                            debug.checkForgottenReturns(value, promiseCreated, "Promise.method", ret);
                            ret._resolveFromSyncValue(value);
                            return ret;
                        };
                    };
                    Promise1.attempt = Promise1["try"] = function(fn) {
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        var ret = new Promise1(INTERNAL);
                        ret._captureStackTrace();
                        ret._pushContext();
                        var value;
                        if (arguments.length > 1) {
                            debug.deprecated("calling Promise.try with more than 1 argument");
                            var arg = arguments[1];
                            var ctx = arguments[2];
                            value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg) : tryCatch(fn).call(ctx, arg);
                        } else value = tryCatch(fn)();
                        var promiseCreated = ret._popContext();
                        debug.checkForgottenReturns(value, promiseCreated, "Promise.try", ret);
                        ret._resolveFromSyncValue(value);
                        return ret;
                    };
                    Promise1.prototype._resolveFromSyncValue = function(value) {
                        if (value === util.errorObj) this._rejectCallback(value.e, false);
                        else this._resolveCallback(value, true);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        20: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var util = _dereq_1("./util");
                var maybeWrapAsError = util.maybeWrapAsError;
                var errors = _dereq_1("./errors");
                var OperationalError = errors.OperationalError;
                var es5 = _dereq_1("./es5");
                function isUntypedError(obj) {
                    return obj instanceof Error && es5.getPrototypeOf(obj) === Error.prototype;
                }
                var rErrorKey = /^(?:name|message|stack|cause)$/;
                function wrapAsOperationalError(obj) {
                    var ret;
                    if (isUntypedError(obj)) {
                        ret = new OperationalError(obj);
                        ret.name = obj.name;
                        ret.message = obj.message;
                        ret.stack = obj.stack;
                        var keys = es5.keys(obj);
                        for(var i = 0; i < keys.length; ++i){
                            var key = keys[i];
                            if (!rErrorKey.test(key)) ret[key] = obj[key];
                        }
                        return ret;
                    }
                    util.markAsOriginatingFromRejection(obj);
                    return obj;
                }
                function nodebackForPromise(promise, multiArgs) {
                    return function(err, value) {
                        if (promise === null) return;
                        if (err) {
                            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
                            promise._attachExtraTrace(wrapped);
                            promise._reject(wrapped);
                        } else if (!multiArgs) promise._fulfill(value);
                        else {
                            var args = [].slice.call(arguments, 1);
                            promise._fulfill(args);
                        }
                        promise = null;
                    };
                }
                module1.exports = nodebackForPromise;
            },
            {
                "./errors": 12,
                "./es5": 13,
                "./util": 36
            }
        ],
        21: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    var util = _dereq_1("./util");
                    var async = Promise1._async;
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    function spreadAdapter(val, nodeback) {
                        var promise = this;
                        if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
                        var ret = tryCatch(nodeback).apply(promise._boundValue(), [
                            null
                        ].concat(val));
                        if (ret === errorObj) async.throwLater(ret.e);
                    }
                    function successAdapter(val, nodeback) {
                        var promise = this;
                        var receiver = promise._boundValue();
                        var ret = val === undefined ? tryCatch(nodeback).call(receiver, null) : tryCatch(nodeback).call(receiver, null, val);
                        if (ret === errorObj) async.throwLater(ret.e);
                    }
                    function errorAdapter(reason, nodeback) {
                        var promise = this;
                        if (!reason) {
                            var newReason = new Error(reason + "");
                            newReason.cause = reason;
                            reason = newReason;
                        }
                        var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
                        if (ret === errorObj) async.throwLater(ret.e);
                    }
                    Promise1.prototype.asCallback = Promise1.prototype.nodeify = function(nodeback, options) {
                        if (typeof nodeback == "function") {
                            var adapter = successAdapter;
                            if (options !== undefined && Object(options).spread) adapter = spreadAdapter;
                            this._then(adapter, errorAdapter, undefined, this, nodeback);
                        }
                        return this;
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        22: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function() {
                    var makeSelfResolutionError = function() {
                        return new TypeError1("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                    };
                    var reflectHandler = function() {
                        return new Promise1.PromiseInspection(this._target());
                    };
                    var apiRejection = function(msg) {
                        return Promise1.reject(new TypeError1(msg));
                    };
                    function Proxyable() {}
                    var UNDEFINED_BINDING = {};
                    var util = _dereq_1("./util");
                    util.setReflectHandler(reflectHandler);
                    var getDomain = function() {
                        var domain = $4acf49f6c3e67aec$exports.domain;
                        if (domain === undefined) return null;
                        return domain;
                    };
                    var getContextDefault = function() {
                        return null;
                    };
                    var getContextDomain = function() {
                        return {
                            domain: getDomain(),
                            async: null
                        };
                    };
                    var AsyncResource = util.isNode && util.nodeSupportsAsyncResource ? _dereq_1("async_hooks").AsyncResource : null;
                    var getContextAsyncHooks = function() {
                        return {
                            domain: getDomain(),
                            async: new AsyncResource("Bluebird::Promise")
                        };
                    };
                    var getContext = util.isNode ? getContextDomain : getContextDefault;
                    util.notEnumerableProp(Promise1, "_getContext", getContext);
                    var enableAsyncHooks = function() {
                        getContext = getContextAsyncHooks;
                        util.notEnumerableProp(Promise1, "_getContext", getContextAsyncHooks);
                    };
                    var disableAsyncHooks = function() {
                        getContext = getContextDomain;
                        util.notEnumerableProp(Promise1, "_getContext", getContextDomain);
                    };
                    var es5 = _dereq_1("./es5");
                    var Async = _dereq_1("./async");
                    var async = new Async();
                    es5.defineProperty(Promise1, "_async", {
                        value: async
                    });
                    var errors = _dereq_1("./errors");
                    var TypeError1 = Promise1.TypeError = errors.TypeError;
                    Promise1.RangeError = errors.RangeError;
                    var CancellationError = Promise1.CancellationError = errors.CancellationError;
                    Promise1.TimeoutError = errors.TimeoutError;
                    Promise1.OperationalError = errors.OperationalError;
                    Promise1.RejectionError = errors.OperationalError;
                    Promise1.AggregateError = errors.AggregateError;
                    var INTERNAL = function() {};
                    var APPLY = {};
                    var NEXT_FILTER = {};
                    var tryConvertToPromise = _dereq_1("./thenables")(Promise1, INTERNAL);
                    var PromiseArray = _dereq_1("./promise_array")(Promise1, INTERNAL, tryConvertToPromise, apiRejection, Proxyable);
                    var Context = _dereq_1("./context")(Promise1);
                    /*jshint unused:false*/ var createContext = Context.create;
                    var debug = _dereq_1("./debuggability")(Promise1, Context, enableAsyncHooks, disableAsyncHooks);
                    var CapturedTrace = debug.CapturedTrace;
                    var PassThroughHandlerContext = _dereq_1("./finally")(Promise1, tryConvertToPromise, NEXT_FILTER);
                    var catchFilter = _dereq_1("./catch_filter")(NEXT_FILTER);
                    var nodebackForPromise = _dereq_1("./nodeback");
                    var errorObj = util.errorObj;
                    var tryCatch = util.tryCatch;
                    function check(self1, executor) {
                        if (self1 == null || self1.constructor !== Promise1) throw new TypeError1("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        if (typeof executor !== "function") throw new TypeError1("expecting a function but got " + util.classString(executor));
                    }
                    function Promise1(executor) {
                        if (executor !== INTERNAL) check(this, executor);
                        this._bitField = 0;
                        this._fulfillmentHandler0 = undefined;
                        this._rejectionHandler0 = undefined;
                        this._promise0 = undefined;
                        this._receiver0 = undefined;
                        this._resolveFromExecutor(executor);
                        this._promiseCreated();
                        this._fireEvent("promiseCreated", this);
                    }
                    Promise1.prototype.toString = function() {
                        return "[object Promise]";
                    };
                    Promise1.prototype.caught = Promise1.prototype["catch"] = function(fn) {
                        var len = arguments.length;
                        if (len > 1) {
                            var catchInstances = new Array(len - 1), j = 0, i;
                            for(i = 0; i < len - 1; ++i){
                                var item = arguments[i];
                                if (util.isObject(item)) catchInstances[j++] = item;
                                else return apiRejection("Catch statement predicate: expecting an object but got " + util.classString(item));
                            }
                            catchInstances.length = j;
                            fn = arguments[i];
                            if (typeof fn !== "function") throw new TypeError1("The last argument to .catch() must be a function, got " + util.toString(fn));
                            return this.then(undefined, catchFilter(catchInstances, fn, this));
                        }
                        return this.then(undefined, fn);
                    };
                    Promise1.prototype.reflect = function() {
                        return this._then(reflectHandler, reflectHandler, undefined, this, undefined);
                    };
                    Promise1.prototype.then = function(didFulfill, didReject) {
                        if (debug.warnings() && arguments.length > 0 && typeof didFulfill !== "function" && typeof didReject !== "function") {
                            var msg = ".then() only accepts functions but was passed: " + util.classString(didFulfill);
                            if (arguments.length > 1) msg += ", " + util.classString(didReject);
                            this._warn(msg);
                        }
                        return this._then(didFulfill, didReject, undefined, undefined, undefined);
                    };
                    Promise1.prototype.done = function(didFulfill, didReject) {
                        var promise = this._then(didFulfill, didReject, undefined, undefined, undefined);
                        promise._setIsFinal();
                    };
                    Promise1.prototype.spread = function(fn) {
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        return this.all()._then(fn, undefined, undefined, APPLY, undefined);
                    };
                    Promise1.prototype.toJSON = function() {
                        var ret = {
                            isFulfilled: false,
                            isRejected: false,
                            fulfillmentValue: undefined,
                            rejectionReason: undefined
                        };
                        if (this.isFulfilled()) {
                            ret.fulfillmentValue = this.value();
                            ret.isFulfilled = true;
                        } else if (this.isRejected()) {
                            ret.rejectionReason = this.reason();
                            ret.isRejected = true;
                        }
                        return ret;
                    };
                    Promise1.prototype.all = function() {
                        if (arguments.length > 0) this._warn(".all() was passed arguments but it does not take any");
                        return new PromiseArray(this).promise();
                    };
                    Promise1.prototype.error = function(fn) {
                        return this.caught(util.originatesFromRejection, fn);
                    };
                    Promise1.getNewLibraryCopy = module1.exports;
                    Promise1.is = function(val) {
                        return val instanceof Promise1;
                    };
                    Promise1.fromNode = Promise1.fromCallback = function(fn) {
                        var ret = new Promise1(INTERNAL);
                        ret._captureStackTrace();
                        var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs : false;
                        var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
                        if (result === errorObj) ret._rejectCallback(result.e, true);
                        if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
                        return ret;
                    };
                    Promise1.all = function(promises) {
                        return new PromiseArray(promises).promise();
                    };
                    Promise1.cast = function(obj) {
                        var ret = tryConvertToPromise(obj);
                        if (!(ret instanceof Promise1)) {
                            ret = new Promise1(INTERNAL);
                            ret._captureStackTrace();
                            ret._setFulfilled();
                            ret._rejectionHandler0 = obj;
                        }
                        return ret;
                    };
                    Promise1.resolve = Promise1.fulfilled = Promise1.cast;
                    Promise1.reject = Promise1.rejected = function(reason) {
                        var ret = new Promise1(INTERNAL);
                        ret._captureStackTrace();
                        ret._rejectCallback(reason, true);
                        return ret;
                    };
                    Promise1.setScheduler = function(fn) {
                        if (typeof fn !== "function") throw new TypeError1("expecting a function but got " + util.classString(fn));
                        return async.setScheduler(fn);
                    };
                    Promise1.prototype._then = function(didFulfill, didReject, _, receiver, internalData) {
                        var haveInternalData = internalData !== undefined;
                        var promise = haveInternalData ? internalData : new Promise1(INTERNAL);
                        var target = this._target();
                        var bitField = target._bitField;
                        if (!haveInternalData) {
                            promise._propagateFrom(this, 3);
                            promise._captureStackTrace();
                            if (receiver === undefined && (this._bitField & 2097152) !== 0) {
                                if (!((bitField & 50397184) === 0)) receiver = this._boundValue();
                                else receiver = target === this ? undefined : this._boundTo;
                            }
                            this._fireEvent("promiseChained", this, promise);
                        }
                        var context = getContext();
                        if (!((bitField & 50397184) === 0)) {
                            var handler, value, settler = target._settlePromiseCtx;
                            if ((bitField & 33554432) !== 0) {
                                value = target._rejectionHandler0;
                                handler = didFulfill;
                            } else if ((bitField & 16777216) !== 0) {
                                value = target._fulfillmentHandler0;
                                handler = didReject;
                                target._unsetRejectionIsUnhandled();
                            } else {
                                settler = target._settlePromiseLateCancellationObserver;
                                value = new CancellationError("late cancellation observer");
                                target._attachExtraTrace(value);
                                handler = didReject;
                            }
                            async.invoke(settler, target, {
                                handler: util.contextBind(context, handler),
                                promise: promise,
                                receiver: receiver,
                                value: value
                            });
                        } else target._addCallbacks(didFulfill, didReject, promise, receiver, context);
                        return promise;
                    };
                    Promise1.prototype._length = function() {
                        return this._bitField & 65535;
                    };
                    Promise1.prototype._isFateSealed = function() {
                        return (this._bitField & 117506048) !== 0;
                    };
                    Promise1.prototype._isFollowing = function() {
                        return (this._bitField & 67108864) === 67108864;
                    };
                    Promise1.prototype._setLength = function(len) {
                        this._bitField = this._bitField & -65536 | len & 65535;
                    };
                    Promise1.prototype._setFulfilled = function() {
                        this._bitField = this._bitField | 33554432;
                        this._fireEvent("promiseFulfilled", this);
                    };
                    Promise1.prototype._setRejected = function() {
                        this._bitField = this._bitField | 16777216;
                        this._fireEvent("promiseRejected", this);
                    };
                    Promise1.prototype._setFollowing = function() {
                        this._bitField = this._bitField | 67108864;
                        this._fireEvent("promiseResolved", this);
                    };
                    Promise1.prototype._setIsFinal = function() {
                        this._bitField = this._bitField | 4194304;
                    };
                    Promise1.prototype._isFinal = function() {
                        return (this._bitField & 4194304) > 0;
                    };
                    Promise1.prototype._unsetCancelled = function() {
                        this._bitField = this._bitField & -65537;
                    };
                    Promise1.prototype._setCancelled = function() {
                        this._bitField = this._bitField | 65536;
                        this._fireEvent("promiseCancelled", this);
                    };
                    Promise1.prototype._setWillBeCancelled = function() {
                        this._bitField = this._bitField | 8388608;
                    };
                    Promise1.prototype._setAsyncGuaranteed = function() {
                        if (async.hasCustomScheduler()) return;
                        var bitField = this._bitField;
                        this._bitField = bitField | (bitField & 536870912) >> 2 ^ 134217728;
                    };
                    Promise1.prototype._setNoAsyncGuarantee = function() {
                        this._bitField = (this._bitField | 536870912) & -134217729;
                    };
                    Promise1.prototype._receiverAt = function(index) {
                        var ret = index === 0 ? this._receiver0 : this[index * 4 - 4 + 3];
                        if (ret === UNDEFINED_BINDING) return undefined;
                        else if (ret === undefined && this._isBound()) return this._boundValue();
                        return ret;
                    };
                    Promise1.prototype._promiseAt = function(index) {
                        return this[index * 4 - 4 + 2];
                    };
                    Promise1.prototype._fulfillmentHandlerAt = function(index) {
                        return this[index * 4 - 4 + 0];
                    };
                    Promise1.prototype._rejectionHandlerAt = function(index) {
                        return this[index * 4 - 4 + 1];
                    };
                    Promise1.prototype._boundValue = function() {};
                    Promise1.prototype._migrateCallback0 = function(follower) {
                        var bitField = follower._bitField;
                        var fulfill = follower._fulfillmentHandler0;
                        var reject = follower._rejectionHandler0;
                        var promise = follower._promise0;
                        var receiver = follower._receiverAt(0);
                        if (receiver === undefined) receiver = UNDEFINED_BINDING;
                        this._addCallbacks(fulfill, reject, promise, receiver, null);
                    };
                    Promise1.prototype._migrateCallbackAt = function(follower, index) {
                        var fulfill = follower._fulfillmentHandlerAt(index);
                        var reject = follower._rejectionHandlerAt(index);
                        var promise = follower._promiseAt(index);
                        var receiver = follower._receiverAt(index);
                        if (receiver === undefined) receiver = UNDEFINED_BINDING;
                        this._addCallbacks(fulfill, reject, promise, receiver, null);
                    };
                    Promise1.prototype._addCallbacks = function(fulfill, reject, promise, receiver, context) {
                        var index = this._length();
                        if (index >= 65531) {
                            index = 0;
                            this._setLength(0);
                        }
                        if (index === 0) {
                            this._promise0 = promise;
                            this._receiver0 = receiver;
                            if (typeof fulfill === "function") this._fulfillmentHandler0 = util.contextBind(context, fulfill);
                            if (typeof reject === "function") this._rejectionHandler0 = util.contextBind(context, reject);
                        } else {
                            var base = index * 4 - 4;
                            this[base + 2] = promise;
                            this[base + 3] = receiver;
                            if (typeof fulfill === "function") this[base + 0] = util.contextBind(context, fulfill);
                            if (typeof reject === "function") this[base + 1] = util.contextBind(context, reject);
                        }
                        this._setLength(index + 1);
                        return index;
                    };
                    Promise1.prototype._proxy = function(proxyable, arg) {
                        this._addCallbacks(undefined, undefined, arg, proxyable, null);
                    };
                    Promise1.prototype._resolveCallback = function(value, shouldBind) {
                        if ((this._bitField & 117506048) !== 0) return;
                        if (value === this) return this._rejectCallback(makeSelfResolutionError(), false);
                        var maybePromise = tryConvertToPromise(value, this);
                        if (!(maybePromise instanceof Promise1)) return this._fulfill(value);
                        if (shouldBind) this._propagateFrom(maybePromise, 2);
                        var promise = maybePromise._target();
                        if (promise === this) {
                            this._reject(makeSelfResolutionError());
                            return;
                        }
                        var bitField = promise._bitField;
                        if ((bitField & 50397184) === 0) {
                            var len = this._length();
                            if (len > 0) promise._migrateCallback0(this);
                            for(var i = 1; i < len; ++i)promise._migrateCallbackAt(this, i);
                            this._setFollowing();
                            this._setLength(0);
                            this._setFollowee(maybePromise);
                        } else if ((bitField & 33554432) !== 0) this._fulfill(promise._value());
                        else if ((bitField & 16777216) !== 0) this._reject(promise._reason());
                        else {
                            var reason = new CancellationError("late cancellation observer");
                            promise._attachExtraTrace(reason);
                            this._reject(reason);
                        }
                    };
                    Promise1.prototype._rejectCallback = function(reason, synchronous, ignoreNonErrorWarnings) {
                        var trace = util.ensureErrorObject(reason);
                        var hasStack = trace === reason;
                        if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
                            var message = "a promise was rejected with a non-error: " + util.classString(reason);
                            this._warn(message, true);
                        }
                        this._attachExtraTrace(trace, synchronous ? hasStack : false);
                        this._reject(reason);
                    };
                    Promise1.prototype._resolveFromExecutor = function(executor) {
                        if (executor === INTERNAL) return;
                        var promise = this;
                        this._captureStackTrace();
                        this._pushContext();
                        var synchronous = true;
                        var r = this._execute(executor, function(value) {
                            promise._resolveCallback(value);
                        }, function(reason) {
                            promise._rejectCallback(reason, synchronous);
                        });
                        synchronous = false;
                        this._popContext();
                        if (r !== undefined) promise._rejectCallback(r, true);
                    };
                    Promise1.prototype._settlePromiseFromHandler = function(handler, receiver, value, promise) {
                        var bitField = promise._bitField;
                        if ((bitField & 65536) !== 0) return;
                        promise._pushContext();
                        var x;
                        if (receiver === APPLY) {
                            if (!value || typeof value.length !== "number") {
                                x = errorObj;
                                x.e = new TypeError1("cannot .spread() a non-array: " + util.classString(value));
                            } else x = tryCatch(handler).apply(this._boundValue(), value);
                        } else x = tryCatch(handler).call(receiver, value);
                        var promiseCreated = promise._popContext();
                        bitField = promise._bitField;
                        if ((bitField & 65536) !== 0) return;
                        if (x === NEXT_FILTER) promise._reject(value);
                        else if (x === errorObj) promise._rejectCallback(x.e, false);
                        else {
                            debug.checkForgottenReturns(x, promiseCreated, "", promise, this);
                            promise._resolveCallback(x);
                        }
                    };
                    Promise1.prototype._target = function() {
                        var ret = this;
                        while(ret._isFollowing())ret = ret._followee();
                        return ret;
                    };
                    Promise1.prototype._followee = function() {
                        return this._rejectionHandler0;
                    };
                    Promise1.prototype._setFollowee = function(promise) {
                        this._rejectionHandler0 = promise;
                    };
                    Promise1.prototype._settlePromise = function(promise, handler, receiver, value) {
                        var isPromise = promise instanceof Promise1;
                        var bitField = this._bitField;
                        var asyncGuaranteed = (bitField & 134217728) !== 0;
                        if ((bitField & 65536) !== 0) {
                            if (isPromise) promise._invokeInternalOnCancel();
                            if (receiver instanceof PassThroughHandlerContext && receiver.isFinallyHandler()) {
                                receiver.cancelPromise = promise;
                                if (tryCatch(handler).call(receiver, value) === errorObj) promise._reject(errorObj.e);
                            } else if (handler === reflectHandler) promise._fulfill(reflectHandler.call(receiver));
                            else if (receiver instanceof Proxyable) receiver._promiseCancelled(promise);
                            else if (isPromise || promise instanceof PromiseArray) promise._cancel();
                            else receiver.cancel();
                        } else if (typeof handler === "function") {
                            if (!isPromise) handler.call(receiver, value, promise);
                            else {
                                if (asyncGuaranteed) promise._setAsyncGuaranteed();
                                this._settlePromiseFromHandler(handler, receiver, value, promise);
                            }
                        } else if (receiver instanceof Proxyable) {
                            if (!receiver._isResolved()) {
                                if ((bitField & 33554432) !== 0) receiver._promiseFulfilled(value, promise);
                                else receiver._promiseRejected(value, promise);
                            }
                        } else if (isPromise) {
                            if (asyncGuaranteed) promise._setAsyncGuaranteed();
                            if ((bitField & 33554432) !== 0) promise._fulfill(value);
                            else promise._reject(value);
                        }
                    };
                    Promise1.prototype._settlePromiseLateCancellationObserver = function(ctx) {
                        var handler = ctx.handler;
                        var promise = ctx.promise;
                        var receiver = ctx.receiver;
                        var value = ctx.value;
                        if (typeof handler === "function") {
                            if (!(promise instanceof Promise1)) handler.call(receiver, value, promise);
                            else this._settlePromiseFromHandler(handler, receiver, value, promise);
                        } else if (promise instanceof Promise1) promise._reject(value);
                    };
                    Promise1.prototype._settlePromiseCtx = function(ctx) {
                        this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
                    };
                    Promise1.prototype._settlePromise0 = function(handler, value, bitField) {
                        var promise = this._promise0;
                        var receiver = this._receiverAt(0);
                        this._promise0 = undefined;
                        this._receiver0 = undefined;
                        this._settlePromise(promise, handler, receiver, value);
                    };
                    Promise1.prototype._clearCallbackDataAtIndex = function(index) {
                        var base = index * 4 - 4;
                        this[base + 2] = this[base + 3] = this[base + 0] = this[base + 1] = undefined;
                    };
                    Promise1.prototype._fulfill = function(value) {
                        var bitField = this._bitField;
                        if ((bitField & 117506048) >>> 16) return;
                        if (value === this) {
                            var err = makeSelfResolutionError();
                            this._attachExtraTrace(err);
                            return this._reject(err);
                        }
                        this._setFulfilled();
                        this._rejectionHandler0 = value;
                        if ((bitField & 65535) > 0) {
                            if ((bitField & 134217728) !== 0) this._settlePromises();
                            else async.settlePromises(this);
                            this._dereferenceTrace();
                        }
                    };
                    Promise1.prototype._reject = function(reason) {
                        var bitField = this._bitField;
                        if ((bitField & 117506048) >>> 16) return;
                        this._setRejected();
                        this._fulfillmentHandler0 = reason;
                        if (this._isFinal()) return async.fatalError(reason, util.isNode);
                        if ((bitField & 65535) > 0) async.settlePromises(this);
                        else this._ensurePossibleRejectionHandled();
                    };
                    Promise1.prototype._fulfillPromises = function(len, value) {
                        for(var i = 1; i < len; i++){
                            var handler = this._fulfillmentHandlerAt(i);
                            var promise = this._promiseAt(i);
                            var receiver = this._receiverAt(i);
                            this._clearCallbackDataAtIndex(i);
                            this._settlePromise(promise, handler, receiver, value);
                        }
                    };
                    Promise1.prototype._rejectPromises = function(len, reason) {
                        for(var i = 1; i < len; i++){
                            var handler = this._rejectionHandlerAt(i);
                            var promise = this._promiseAt(i);
                            var receiver = this._receiverAt(i);
                            this._clearCallbackDataAtIndex(i);
                            this._settlePromise(promise, handler, receiver, reason);
                        }
                    };
                    Promise1.prototype._settlePromises = function() {
                        var bitField = this._bitField;
                        var len = bitField & 65535;
                        if (len > 0) {
                            if ((bitField & 16842752) !== 0) {
                                var reason = this._fulfillmentHandler0;
                                this._settlePromise0(this._rejectionHandler0, reason, bitField);
                                this._rejectPromises(len, reason);
                            } else {
                                var value = this._rejectionHandler0;
                                this._settlePromise0(this._fulfillmentHandler0, value, bitField);
                                this._fulfillPromises(len, value);
                            }
                            this._setLength(0);
                        }
                        this._clearCancellationData();
                    };
                    Promise1.prototype._settledValue = function() {
                        var bitField = this._bitField;
                        if ((bitField & 33554432) !== 0) return this._rejectionHandler0;
                        else if ((bitField & 16777216) !== 0) return this._fulfillmentHandler0;
                    };
                    if (typeof Symbol !== "undefined" && Symbol.toStringTag) es5.defineProperty(Promise1.prototype, Symbol.toStringTag, {
                        get: function() {
                            return "Object";
                        }
                    });
                    function deferResolve(v) {
                        this.promise._resolveCallback(v);
                    }
                    function deferReject(v) {
                        this.promise._rejectCallback(v, false);
                    }
                    Promise1.defer = Promise1.pending = function() {
                        debug.deprecated("Promise.defer", "new Promise");
                        var promise = new Promise1(INTERNAL);
                        return {
                            promise: promise,
                            resolve: deferResolve,
                            reject: deferReject
                        };
                    };
                    util.notEnumerableProp(Promise1, "_makeSelfResolutionError", makeSelfResolutionError);
                    _dereq_1("./method")(Promise1, INTERNAL, tryConvertToPromise, apiRejection, debug);
                    _dereq_1("./bind")(Promise1, INTERNAL, tryConvertToPromise, debug);
                    _dereq_1("./cancel")(Promise1, PromiseArray, apiRejection, debug);
                    _dereq_1("./direct_resolve")(Promise1);
                    _dereq_1("./synchronous_inspection")(Promise1);
                    _dereq_1("./join")(Promise1, PromiseArray, tryConvertToPromise, INTERNAL, async);
                    Promise1.Promise = Promise1;
                    Promise1.version = "3.7.2";
                    _dereq_1('./call_get.js')(Promise1);
                    _dereq_1('./generators.js')(Promise1, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
                    _dereq_1('./map.js')(Promise1, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
                    _dereq_1('./nodeify.js')(Promise1);
                    _dereq_1('./promisify.js')(Promise1, INTERNAL);
                    _dereq_1('./props.js')(Promise1, PromiseArray, tryConvertToPromise, apiRejection);
                    _dereq_1('./race.js')(Promise1, INTERNAL, tryConvertToPromise, apiRejection);
                    _dereq_1('./reduce.js')(Promise1, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
                    _dereq_1('./settle.js')(Promise1, PromiseArray, debug);
                    _dereq_1('./some.js')(Promise1, PromiseArray, apiRejection);
                    _dereq_1('./timers.js')(Promise1, INTERNAL, debug);
                    _dereq_1('./using.js')(Promise1, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
                    _dereq_1('./any.js')(Promise1);
                    _dereq_1('./each.js')(Promise1, INTERNAL);
                    _dereq_1('./filter.js')(Promise1, INTERNAL);
                    util.toFastProperties(Promise1);
                    util.toFastProperties(Promise1.prototype);
                    function fillTypes(value) {
                        var p = new Promise1(INTERNAL);
                        p._fulfillmentHandler0 = value;
                        p._rejectionHandler0 = value;
                        p._promise0 = value;
                        p._receiver0 = value;
                    }
                    // Complete slack tracking, opt out of field-type tracking and           
                    // stabilize map                                                         
                    fillTypes({
                        a: 1
                    });
                    fillTypes({
                        b: 2
                    });
                    fillTypes({
                        c: 3
                    });
                    fillTypes(1);
                    fillTypes(function() {});
                    fillTypes(undefined);
                    fillTypes(false);
                    fillTypes(new Promise1(INTERNAL));
                    debug.setBounds(Async.firstLineError, util.lastLineError);
                    return Promise1;
                };
            },
            {
                "./any.js": 1,
                "./async": 2,
                "./bind": 3,
                "./call_get.js": 5,
                "./cancel": 6,
                "./catch_filter": 7,
                "./context": 8,
                "./debuggability": 9,
                "./direct_resolve": 10,
                "./each.js": 11,
                "./errors": 12,
                "./es5": 13,
                "./filter.js": 14,
                "./finally": 15,
                "./generators.js": 16,
                "./join": 17,
                "./map.js": 18,
                "./method": 19,
                "./nodeback": 20,
                "./nodeify.js": 21,
                "./promise_array": 23,
                "./promisify.js": 24,
                "./props.js": 25,
                "./race.js": 27,
                "./reduce.js": 28,
                "./settle.js": 30,
                "./some.js": 31,
                "./synchronous_inspection": 32,
                "./thenables": 33,
                "./timers.js": 34,
                "./using.js": 35,
                "./util": 36,
                "async_hooks": undefined
            }
        ],
        23: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, tryConvertToPromise, apiRejection, Proxyable) {
                    var util = _dereq_1("./util");
                    var isArray = util.isArray;
                    function toResolutionValue(val) {
                        switch(val){
                            case -2:
                                return [];
                            case -3:
                                return {};
                            case -6:
                                return new Map();
                        }
                    }
                    function PromiseArray(values) {
                        var promise = this._promise = new Promise1(INTERNAL);
                        if (values instanceof Promise1) {
                            promise._propagateFrom(values, 3);
                            values.suppressUnhandledRejections();
                        }
                        promise._setOnCancel(this);
                        this._values = values;
                        this._length = 0;
                        this._totalResolved = 0;
                        this._init(undefined, -2);
                    }
                    util.inherits(PromiseArray, Proxyable);
                    PromiseArray.prototype.length = function() {
                        return this._length;
                    };
                    PromiseArray.prototype.promise = function() {
                        return this._promise;
                    };
                    PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
                        var values = tryConvertToPromise(this._values, this._promise);
                        if (values instanceof Promise1) {
                            values = values._target();
                            var bitField = values._bitField;
                            this._values = values;
                            if ((bitField & 50397184) === 0) {
                                this._promise._setAsyncGuaranteed();
                                return values._then(init, this._reject, undefined, this, resolveValueIfEmpty);
                            } else if ((bitField & 33554432) !== 0) values = values._value();
                            else if ((bitField & 16777216) !== 0) return this._reject(values._reason());
                            else return this._cancel();
                        }
                        values = util.asArray(values);
                        if (values === null) {
                            var err = apiRejection("expecting an array or an iterable object but got " + util.classString(values)).reason();
                            this._promise._rejectCallback(err, false);
                            return;
                        }
                        if (values.length === 0) {
                            if (resolveValueIfEmpty === -5) this._resolveEmptyArray();
                            else this._resolve(toResolutionValue(resolveValueIfEmpty));
                            return;
                        }
                        this._iterate(values);
                    };
                    PromiseArray.prototype._iterate = function(values) {
                        var len = this.getActualLength(values.length);
                        this._length = len;
                        this._values = this.shouldCopyValues() ? new Array(len) : this._values;
                        var result = this._promise;
                        var isResolved = false;
                        var bitField = null;
                        for(var i = 0; i < len; ++i){
                            var maybePromise = tryConvertToPromise(values[i], result);
                            if (maybePromise instanceof Promise1) {
                                maybePromise = maybePromise._target();
                                bitField = maybePromise._bitField;
                            } else bitField = null;
                            if (isResolved) {
                                if (bitField !== null) maybePromise.suppressUnhandledRejections();
                            } else if (bitField !== null) {
                                if ((bitField & 50397184) === 0) {
                                    maybePromise._proxy(this, i);
                                    this._values[i] = maybePromise;
                                } else if ((bitField & 33554432) !== 0) isResolved = this._promiseFulfilled(maybePromise._value(), i);
                                else if ((bitField & 16777216) !== 0) isResolved = this._promiseRejected(maybePromise._reason(), i);
                                else isResolved = this._promiseCancelled(i);
                            } else isResolved = this._promiseFulfilled(maybePromise, i);
                        }
                        if (!isResolved) result._setAsyncGuaranteed();
                    };
                    PromiseArray.prototype._isResolved = function() {
                        return this._values === null;
                    };
                    PromiseArray.prototype._resolve = function(value) {
                        this._values = null;
                        this._promise._fulfill(value);
                    };
                    PromiseArray.prototype._cancel = function() {
                        if (this._isResolved() || !this._promise._isCancellable()) return;
                        this._values = null;
                        this._promise._cancel();
                    };
                    PromiseArray.prototype._reject = function(reason) {
                        this._values = null;
                        this._promise._rejectCallback(reason, false);
                    };
                    PromiseArray.prototype._promiseFulfilled = function(value, index) {
                        this._values[index] = value;
                        var totalResolved = ++this._totalResolved;
                        if (totalResolved >= this._length) {
                            this._resolve(this._values);
                            return true;
                        }
                        return false;
                    };
                    PromiseArray.prototype._promiseCancelled = function() {
                        this._cancel();
                        return true;
                    };
                    PromiseArray.prototype._promiseRejected = function(reason) {
                        this._totalResolved++;
                        this._reject(reason);
                        return true;
                    };
                    PromiseArray.prototype._resultCancelled = function() {
                        if (this._isResolved()) return;
                        var values = this._values;
                        this._cancel();
                        if (values instanceof Promise1) values.cancel();
                        else {
                            for(var i = 0; i < values.length; ++i)if (values[i] instanceof Promise1) values[i].cancel();
                        }
                    };
                    PromiseArray.prototype.shouldCopyValues = function() {
                        return true;
                    };
                    PromiseArray.prototype.getActualLength = function(len) {
                        return len;
                    };
                    return PromiseArray;
                };
            },
            {
                "./util": 36
            }
        ],
        24: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL) {
                    var THIS = {};
                    var util = _dereq_1("./util");
                    var nodebackForPromise = _dereq_1("./nodeback");
                    var withAppended = util.withAppended;
                    var maybeWrapAsError = util.maybeWrapAsError;
                    var canEvaluate = util.canEvaluate;
                    var TypeError1 = _dereq_1("./errors").TypeError;
                    var defaultSuffix = "Async";
                    var defaultPromisified = {
                        __isPromisified__: true
                    };
                    var noCopyProps = [
                        "arity",
                        "length",
                        "name",
                        "arguments",
                        "caller",
                        "callee",
                        "prototype",
                        "__isPromisified__"
                    ];
                    var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
                    var defaultFilter = function(name) {
                        return util.isIdentifier(name) && name.charAt(0) !== "_" && name !== "constructor";
                    };
                    function propsFilter(key) {
                        return !noCopyPropsPattern.test(key);
                    }
                    function isPromisified(fn) {
                        try {
                            return fn.__isPromisified__ === true;
                        } catch (e) {
                            return false;
                        }
                    }
                    function hasPromisified(obj, key, suffix) {
                        var val = util.getDataPropertyOrDefault(obj, key + suffix, defaultPromisified);
                        return val ? isPromisified(val) : false;
                    }
                    function checkValid(ret, suffix, suffixRegexp) {
                        for(var i = 0; i < ret.length; i += 2){
                            var key = ret[i];
                            if (suffixRegexp.test(key)) {
                                var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
                                for(var j = 0; j < ret.length; j += 2){
                                    if (ret[j] === keyWithoutAsyncSuffix) throw new TypeError1("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a".replace("%s", suffix));
                                }
                            }
                        }
                    }
                    function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
                        var keys = util.inheritedDataKeys(obj);
                        var ret = [];
                        for(var i = 0; i < keys.length; ++i){
                            var key = keys[i];
                            var value = obj[key];
                            var passesDefaultFilter = filter === defaultFilter ? true : defaultFilter(key, value, obj);
                            if (typeof value === "function" && !isPromisified(value) && !hasPromisified(obj, key, suffix) && filter(key, value, obj, passesDefaultFilter)) ret.push(key, value);
                        }
                        checkValid(ret, suffix, suffixRegexp);
                        return ret;
                    }
                    var escapeIdentRegex = function(str) {
                        return str.replace(/([$])/, "\\$");
                    };
                    var makeNodePromisifiedEval;
                    var switchCaseArgumentOrder, argumentSequence, parameterDeclaration, parameterCount;
                    function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
                        var defaultThis = function() {
                            return this;
                        }();
                        var method = callback;
                        if (typeof method === "string") callback = fn;
                        function promisified() {
                            var _receiver = receiver;
                            if (receiver === THIS) _receiver = this;
                            var promise = new Promise1(INTERNAL);
                            promise._captureStackTrace();
                            var cb = typeof method === "string" && this !== defaultThis ? this[method] : callback;
                            var fn = nodebackForPromise(promise, multiArgs);
                            try {
                                cb.apply(_receiver, withAppended(arguments, fn));
                            } catch (e) {
                                promise._rejectCallback(maybeWrapAsError(e), true, true);
                            }
                            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
                            return promise;
                        }
                        util.notEnumerableProp(promisified, "__isPromisified__", true);
                        return promisified;
                    }
                    var makeNodePromisified = canEvaluate ? makeNodePromisifiedEval : makeNodePromisifiedClosure;
                    function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
                        var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
                        var methods = promisifiableMethods(obj, suffix, suffixRegexp, filter);
                        for(var i = 0, len = methods.length; i < len; i += 2){
                            var key = methods[i];
                            var fn = methods[i + 1];
                            var promisifiedKey = key + suffix;
                            if (promisifier === makeNodePromisified) obj[promisifiedKey] = makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
                            else {
                                var promisified = promisifier(fn, function() {
                                    return makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
                                });
                                util.notEnumerableProp(promisified, "__isPromisified__", true);
                                obj[promisifiedKey] = promisified;
                            }
                        }
                        util.toFastProperties(obj);
                        return obj;
                    }
                    function promisify(callback, receiver, multiArgs) {
                        return makeNodePromisified(callback, receiver, undefined, callback, null, multiArgs);
                    }
                    Promise1.promisify = function(fn, options) {
                        if (typeof fn !== "function") throw new TypeError1("expecting a function but got " + util.classString(fn));
                        if (isPromisified(fn)) return fn;
                        options = Object(options);
                        var receiver = options.context === undefined ? THIS : options.context;
                        var multiArgs = !!options.multiArgs;
                        var ret = promisify(fn, receiver, multiArgs);
                        util.copyDescriptors(fn, ret, propsFilter);
                        return ret;
                    };
                    Promise1.promisifyAll = function(target, options) {
                        if (typeof target !== "function" && typeof target !== "object") throw new TypeError1("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        options = Object(options);
                        var multiArgs = !!options.multiArgs;
                        var suffix = options.suffix;
                        if (typeof suffix !== "string") suffix = defaultSuffix;
                        var filter = options.filter;
                        if (typeof filter !== "function") filter = defaultFilter;
                        var promisifier = options.promisifier;
                        if (typeof promisifier !== "function") promisifier = makeNodePromisified;
                        if (!util.isIdentifier(suffix)) throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        var keys = util.inheritedDataKeys(target);
                        for(var i = 0; i < keys.length; ++i){
                            var value = target[keys[i]];
                            if (keys[i] !== "constructor" && util.isClass(value)) {
                                promisifyAll(value.prototype, suffix, filter, promisifier, multiArgs);
                                promisifyAll(value, suffix, filter, promisifier, multiArgs);
                            }
                        }
                        return promisifyAll(target, suffix, filter, promisifier, multiArgs);
                    };
                };
            },
            {
                "./errors": 12,
                "./nodeback": 20,
                "./util": 36
            }
        ],
        25: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, tryConvertToPromise, apiRejection) {
                    var util = _dereq_1("./util");
                    var isObject = util.isObject;
                    var es5 = _dereq_1("./es5");
                    var Es6Map;
                    if (typeof Map === "function") Es6Map = Map;
                    var mapToEntries = function() {
                        var index = 0;
                        var size = 0;
                        function extractEntry(value, key) {
                            this[index] = value;
                            this[index + size] = key;
                            index++;
                        }
                        return function mapToEntries(map) {
                            size = map.size;
                            index = 0;
                            var ret = new Array(map.size * 2);
                            map.forEach(extractEntry, ret);
                            return ret;
                        };
                    }();
                    var entriesToMap = function(entries) {
                        var ret = new Es6Map();
                        var length = entries.length / 2 | 0;
                        for(var i = 0; i < length; ++i){
                            var key = entries[length + i];
                            var value = entries[i];
                            ret.set(key, value);
                        }
                        return ret;
                    };
                    function PropertiesPromiseArray(obj) {
                        var isMap = false;
                        var entries;
                        if (Es6Map !== undefined && obj instanceof Es6Map) {
                            entries = mapToEntries(obj);
                            isMap = true;
                        } else {
                            var keys = es5.keys(obj);
                            var len = keys.length;
                            entries = new Array(len * 2);
                            for(var i = 0; i < len; ++i){
                                var key = keys[i];
                                entries[i] = obj[key];
                                entries[i + len] = key;
                            }
                        }
                        this.constructor$(entries);
                        this._isMap = isMap;
                        this._init$(undefined, isMap ? -6 : -3);
                    }
                    util.inherits(PropertiesPromiseArray, PromiseArray);
                    PropertiesPromiseArray.prototype._init = function() {};
                    PropertiesPromiseArray.prototype._promiseFulfilled = function(value, index) {
                        this._values[index] = value;
                        var totalResolved = ++this._totalResolved;
                        if (totalResolved >= this._length) {
                            var val;
                            if (this._isMap) val = entriesToMap(this._values);
                            else {
                                val = {};
                                var keyOffset = this.length();
                                for(var i = 0, len = this.length(); i < len; ++i)val[this._values[i + keyOffset]] = this._values[i];
                            }
                            this._resolve(val);
                            return true;
                        }
                        return false;
                    };
                    PropertiesPromiseArray.prototype.shouldCopyValues = function() {
                        return false;
                    };
                    PropertiesPromiseArray.prototype.getActualLength = function(len) {
                        return len >> 1;
                    };
                    function props(promises) {
                        var ret;
                        var castValue = tryConvertToPromise(promises);
                        if (!isObject(castValue)) return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        else if (castValue instanceof Promise1) ret = castValue._then(Promise1.props, undefined, undefined, undefined, undefined);
                        else ret = new PropertiesPromiseArray(castValue).promise();
                        if (castValue instanceof Promise1) ret._propagateFrom(castValue, 2);
                        return ret;
                    }
                    Promise1.prototype.props = function() {
                        return props(this);
                    };
                    Promise1.props = function(promises) {
                        return props(promises);
                    };
                };
            },
            {
                "./es5": 13,
                "./util": 36
            }
        ],
        26: [
            function(_dereq_1, module1, exports) {
                "use strict";
                function arrayMove(src, srcIndex, dst, dstIndex, len) {
                    for(var j = 0; j < len; ++j){
                        dst[j + dstIndex] = src[j + srcIndex];
                        src[j + srcIndex] = void 0;
                    }
                }
                function Queue(capacity) {
                    this._capacity = capacity;
                    this._length = 0;
                    this._front = 0;
                }
                Queue.prototype._willBeOverCapacity = function(size) {
                    return this._capacity < size;
                };
                Queue.prototype._pushOne = function(arg) {
                    var length = this.length();
                    this._checkCapacity(length + 1);
                    var i = this._front + length & this._capacity - 1;
                    this[i] = arg;
                    this._length = length + 1;
                };
                Queue.prototype.push = function(fn, receiver, arg) {
                    var length = this.length() + 3;
                    if (this._willBeOverCapacity(length)) {
                        this._pushOne(fn);
                        this._pushOne(receiver);
                        this._pushOne(arg);
                        return;
                    }
                    var j = this._front + length - 3;
                    this._checkCapacity(length);
                    var wrapMask = this._capacity - 1;
                    this[j + 0 & wrapMask] = fn;
                    this[j + 1 & wrapMask] = receiver;
                    this[j + 2 & wrapMask] = arg;
                    this._length = length;
                };
                Queue.prototype.shift = function() {
                    var front = this._front, ret = this[front];
                    this[front] = undefined;
                    this._front = front + 1 & this._capacity - 1;
                    this._length--;
                    return ret;
                };
                Queue.prototype.length = function() {
                    return this._length;
                };
                Queue.prototype._checkCapacity = function(size) {
                    if (this._capacity < size) this._resizeTo(this._capacity << 1);
                };
                Queue.prototype._resizeTo = function(capacity) {
                    var oldCapacity = this._capacity;
                    this._capacity = capacity;
                    var front = this._front;
                    var length = this._length;
                    var moveItemsCount = front + length & oldCapacity - 1;
                    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
                };
                module1.exports = Queue;
            },
            {}
        ],
        27: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, tryConvertToPromise, apiRejection) {
                    var util = _dereq_1("./util");
                    var raceLater = function(promise) {
                        return promise.then(function(array) {
                            return race(array, promise);
                        });
                    };
                    function race(promises, parent) {
                        var maybePromise = tryConvertToPromise(promises);
                        if (maybePromise instanceof Promise1) return raceLater(maybePromise);
                        else {
                            promises = util.asArray(promises);
                            if (promises === null) return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
                        }
                        var ret = new Promise1(INTERNAL);
                        if (parent !== undefined) ret._propagateFrom(parent, 3);
                        var fulfill = ret._fulfill;
                        var reject = ret._reject;
                        for(var i = 0, len = promises.length; i < len; ++i){
                            var val = promises[i];
                            if (val === undefined && !(i in promises)) continue;
                            Promise1.cast(val)._then(fulfill, reject, undefined, ret, null);
                        }
                        return ret;
                    }
                    Promise1.race = function(promises) {
                        return race(promises, undefined);
                    };
                    Promise1.prototype.race = function() {
                        return race(this, undefined);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        28: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
                    var util = _dereq_1("./util");
                    var tryCatch = util.tryCatch;
                    function ReductionPromiseArray(promises, fn, initialValue, _each) {
                        this.constructor$(promises);
                        var context = Promise1._getContext();
                        this._fn = util.contextBind(context, fn);
                        if (initialValue !== undefined) {
                            initialValue = Promise1.resolve(initialValue);
                            initialValue._attachCancellationCallback(this);
                        }
                        this._initialValue = initialValue;
                        this._currentCancellable = null;
                        if (_each === INTERNAL) this._eachValues = Array(this._length);
                        else if (_each === 0) this._eachValues = null;
                        else this._eachValues = undefined;
                        this._promise._captureStackTrace();
                        this._init$(undefined, -5);
                    }
                    util.inherits(ReductionPromiseArray, PromiseArray);
                    ReductionPromiseArray.prototype._gotAccum = function(accum) {
                        if (this._eachValues !== undefined && this._eachValues !== null && accum !== INTERNAL) this._eachValues.push(accum);
                    };
                    ReductionPromiseArray.prototype._eachComplete = function(value) {
                        if (this._eachValues !== null) this._eachValues.push(value);
                        return this._eachValues;
                    };
                    ReductionPromiseArray.prototype._init = function() {};
                    ReductionPromiseArray.prototype._resolveEmptyArray = function() {
                        this._resolve(this._eachValues !== undefined ? this._eachValues : this._initialValue);
                    };
                    ReductionPromiseArray.prototype.shouldCopyValues = function() {
                        return false;
                    };
                    ReductionPromiseArray.prototype._resolve = function(value) {
                        this._promise._resolveCallback(value);
                        this._values = null;
                    };
                    ReductionPromiseArray.prototype._resultCancelled = function(sender) {
                        if (sender === this._initialValue) return this._cancel();
                        if (this._isResolved()) return;
                        this._resultCancelled$();
                        if (this._currentCancellable instanceof Promise1) this._currentCancellable.cancel();
                        if (this._initialValue instanceof Promise1) this._initialValue.cancel();
                    };
                    ReductionPromiseArray.prototype._iterate = function(values) {
                        this._values = values;
                        var value;
                        var i;
                        var length = values.length;
                        if (this._initialValue !== undefined) {
                            value = this._initialValue;
                            i = 0;
                        } else {
                            value = Promise1.resolve(values[0]);
                            i = 1;
                        }
                        this._currentCancellable = value;
                        for(var j = i; j < length; ++j){
                            var maybePromise = values[j];
                            if (maybePromise instanceof Promise1) maybePromise.suppressUnhandledRejections();
                        }
                        if (!value.isRejected()) for(; i < length; ++i){
                            var ctx = {
                                accum: null,
                                value: values[i],
                                index: i,
                                length: length,
                                array: this
                            };
                            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
                            if ((i & 127) === 0) value._setNoAsyncGuarantee();
                        }
                        if (this._eachValues !== undefined) value = value._then(this._eachComplete, undefined, undefined, this, undefined);
                        value._then(completed, completed, undefined, value, this);
                    };
                    Promise1.prototype.reduce = function(fn, initialValue) {
                        return reduce(this, fn, initialValue, null);
                    };
                    Promise1.reduce = function(promises, fn, initialValue, _each) {
                        return reduce(promises, fn, initialValue, _each);
                    };
                    function completed(valueOrReason, array) {
                        if (this.isFulfilled()) array._resolve(valueOrReason);
                        else array._reject(valueOrReason);
                    }
                    function reduce(promises, fn, initialValue, _each) {
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
                        return array.promise();
                    }
                    function gotAccum(accum) {
                        this.accum = accum;
                        this.array._gotAccum(accum);
                        var value = tryConvertToPromise(this.value, this.array._promise);
                        if (value instanceof Promise1) {
                            this.array._currentCancellable = value;
                            return value._then(gotValue, undefined, undefined, this, undefined);
                        } else return gotValue.call(this, value);
                    }
                    function gotValue(value) {
                        var array = this.array;
                        var promise = array._promise;
                        var fn = tryCatch(array._fn);
                        promise._pushContext();
                        var ret;
                        if (array._eachValues !== undefined) ret = fn.call(promise._boundValue(), value, this.index, this.length);
                        else ret = fn.call(promise._boundValue(), this.accum, value, this.index, this.length);
                        if (ret instanceof Promise1) array._currentCancellable = ret;
                        var promiseCreated = promise._popContext();
                        debug.checkForgottenReturns(ret, promiseCreated, array._eachValues !== undefined ? "Promise.each" : "Promise.reduce", promise);
                        return ret;
                    }
                };
            },
            {
                "./util": 36
            }
        ],
        29: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var util = _dereq_1("./util");
                var schedule;
                var noAsyncScheduler = function() {
                    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                };
                var NativePromise = util.getNativePromise();
                if (util.isNode && typeof MutationObserver === "undefined") {
                    var GlobalSetImmediate = $parcel$global.setImmediate;
                    var ProcessNextTick = $4acf49f6c3e67aec$exports.nextTick;
                    schedule = util.isRecentNode ? function(fn) {
                        GlobalSetImmediate.call($parcel$global, fn);
                    } : function(fn) {
                        ProcessNextTick.call($4acf49f6c3e67aec$exports, fn);
                    };
                } else if (typeof NativePromise === "function" && typeof NativePromise.resolve === "function") {
                    var nativePromise = NativePromise.resolve();
                    schedule = function(fn) {
                        nativePromise.then(fn);
                    };
                } else if (typeof MutationObserver !== "undefined" && !(typeof window !== "undefined" && window.navigator && (window.navigator.standalone || window.cordova)) && "classList" in document.documentElement) schedule = function() {
                    var div = document.createElement("div");
                    var opts = {
                        attributes: true
                    };
                    var toggleScheduled = false;
                    var div2 = document.createElement("div");
                    var o2 = new MutationObserver(function() {
                        div.classList.toggle("foo");
                        toggleScheduled = false;
                    });
                    o2.observe(div2, opts);
                    var scheduleToggle = function() {
                        if (toggleScheduled) return;
                        toggleScheduled = true;
                        div2.classList.toggle("foo");
                    };
                    return function schedule(fn) {
                        var o = new MutationObserver(function() {
                            o.disconnect();
                            fn();
                        });
                        o.observe(div, opts);
                        scheduleToggle();
                    };
                }();
                else if (typeof setImmediate !== "undefined") schedule = function(fn) {
                    setImmediate(fn);
                };
                else if (typeof setTimeout !== "undefined") schedule = function(fn) {
                    setTimeout(fn, 0);
                };
                else schedule = noAsyncScheduler;
                module1.exports = schedule;
            },
            {
                "./util": 36
            }
        ],
        30: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, debug) {
                    var PromiseInspection = Promise1.PromiseInspection;
                    var util = _dereq_1("./util");
                    function SettledPromiseArray(values) {
                        this.constructor$(values);
                    }
                    util.inherits(SettledPromiseArray, PromiseArray);
                    SettledPromiseArray.prototype._promiseResolved = function(index, inspection) {
                        this._values[index] = inspection;
                        var totalResolved = ++this._totalResolved;
                        if (totalResolved >= this._length) {
                            this._resolve(this._values);
                            return true;
                        }
                        return false;
                    };
                    SettledPromiseArray.prototype._promiseFulfilled = function(value, index) {
                        var ret = new PromiseInspection();
                        ret._bitField = 33554432;
                        ret._settledValueField = value;
                        return this._promiseResolved(index, ret);
                    };
                    SettledPromiseArray.prototype._promiseRejected = function(reason, index) {
                        var ret = new PromiseInspection();
                        ret._bitField = 16777216;
                        ret._settledValueField = reason;
                        return this._promiseResolved(index, ret);
                    };
                    Promise1.settle = function(promises) {
                        debug.deprecated(".settle()", ".reflect()");
                        return new SettledPromiseArray(promises).promise();
                    };
                    Promise1.allSettled = function(promises) {
                        return new SettledPromiseArray(promises).promise();
                    };
                    Promise1.prototype.settle = function() {
                        return Promise1.settle(this);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        31: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, apiRejection) {
                    var util = _dereq_1("./util");
                    var RangeError1 = _dereq_1("./errors").RangeError;
                    var AggregateError = _dereq_1("./errors").AggregateError;
                    var isArray = util.isArray;
                    var CANCELLATION = {};
                    function SomePromiseArray(values) {
                        this.constructor$(values);
                        this._howMany = 0;
                        this._unwrap = false;
                        this._initialized = false;
                    }
                    util.inherits(SomePromiseArray, PromiseArray);
                    SomePromiseArray.prototype._init = function() {
                        if (!this._initialized) return;
                        if (this._howMany === 0) {
                            this._resolve([]);
                            return;
                        }
                        this._init$(undefined, -5);
                        var isArrayResolved = isArray(this._values);
                        if (!this._isResolved() && isArrayResolved && this._howMany > this._canPossiblyFulfill()) this._reject(this._getRangeError(this.length()));
                    };
                    SomePromiseArray.prototype.init = function() {
                        this._initialized = true;
                        this._init();
                    };
                    SomePromiseArray.prototype.setUnwrap = function() {
                        this._unwrap = true;
                    };
                    SomePromiseArray.prototype.howMany = function() {
                        return this._howMany;
                    };
                    SomePromiseArray.prototype.setHowMany = function(count) {
                        this._howMany = count;
                    };
                    SomePromiseArray.prototype._promiseFulfilled = function(value) {
                        this._addFulfilled(value);
                        if (this._fulfilled() === this.howMany()) {
                            this._values.length = this.howMany();
                            if (this.howMany() === 1 && this._unwrap) this._resolve(this._values[0]);
                            else this._resolve(this._values);
                            return true;
                        }
                        return false;
                    };
                    SomePromiseArray.prototype._promiseRejected = function(reason) {
                        this._addRejected(reason);
                        return this._checkOutcome();
                    };
                    SomePromiseArray.prototype._promiseCancelled = function() {
                        if (this._values instanceof Promise1 || this._values == null) return this._cancel();
                        this._addRejected(CANCELLATION);
                        return this._checkOutcome();
                    };
                    SomePromiseArray.prototype._checkOutcome = function() {
                        if (this.howMany() > this._canPossiblyFulfill()) {
                            var e = new AggregateError();
                            for(var i = this.length(); i < this._values.length; ++i)if (this._values[i] !== CANCELLATION) e.push(this._values[i]);
                            if (e.length > 0) this._reject(e);
                            else this._cancel();
                            return true;
                        }
                        return false;
                    };
                    SomePromiseArray.prototype._fulfilled = function() {
                        return this._totalResolved;
                    };
                    SomePromiseArray.prototype._rejected = function() {
                        return this._values.length - this.length();
                    };
                    SomePromiseArray.prototype._addRejected = function(reason) {
                        this._values.push(reason);
                    };
                    SomePromiseArray.prototype._addFulfilled = function(value) {
                        this._values[this._totalResolved++] = value;
                    };
                    SomePromiseArray.prototype._canPossiblyFulfill = function() {
                        return this.length() - this._rejected();
                    };
                    SomePromiseArray.prototype._getRangeError = function(count) {
                        var message = "Input array must contain at least " + this._howMany + " items but contains only " + count + " items";
                        return new RangeError1(message);
                    };
                    SomePromiseArray.prototype._resolveEmptyArray = function() {
                        this._reject(this._getRangeError(0));
                    };
                    function some(promises, howMany) {
                        if ((howMany | 0) !== howMany || howMany < 0) return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        var ret = new SomePromiseArray(promises);
                        var promise = ret.promise();
                        ret.setHowMany(howMany);
                        ret.init();
                        return promise;
                    }
                    Promise1.some = function(promises, howMany) {
                        return some(promises, howMany);
                    };
                    Promise1.prototype.some = function(howMany) {
                        return some(this, howMany);
                    };
                    Promise1._SomePromiseArray = SomePromiseArray;
                };
            },
            {
                "./errors": 12,
                "./util": 36
            }
        ],
        32: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    function PromiseInspection(promise) {
                        if (promise !== undefined) {
                            promise = promise._target();
                            this._bitField = promise._bitField;
                            this._settledValueField = promise._isFateSealed() ? promise._settledValue() : undefined;
                        } else {
                            this._bitField = 0;
                            this._settledValueField = undefined;
                        }
                    }
                    PromiseInspection.prototype._settledValue = function() {
                        return this._settledValueField;
                    };
                    var value = PromiseInspection.prototype.value = function() {
                        if (!this.isFulfilled()) throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        return this._settledValue();
                    };
                    var reason = PromiseInspection.prototype.error = PromiseInspection.prototype.reason = function() {
                        if (!this.isRejected()) throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        return this._settledValue();
                    };
                    var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
                        return (this._bitField & 33554432) !== 0;
                    };
                    var isRejected = PromiseInspection.prototype.isRejected = function() {
                        return (this._bitField & 16777216) !== 0;
                    };
                    var isPending = PromiseInspection.prototype.isPending = function() {
                        return (this._bitField & 50397184) === 0;
                    };
                    var isResolved = PromiseInspection.prototype.isResolved = function() {
                        return (this._bitField & 50331648) !== 0;
                    };
                    PromiseInspection.prototype.isCancelled = function() {
                        return (this._bitField & 8454144) !== 0;
                    };
                    Promise1.prototype.__isCancelled = function() {
                        return (this._bitField & 65536) === 65536;
                    };
                    Promise1.prototype._isCancelled = function() {
                        return this._target().__isCancelled();
                    };
                    Promise1.prototype.isCancelled = function() {
                        return (this._target()._bitField & 8454144) !== 0;
                    };
                    Promise1.prototype.isPending = function() {
                        return isPending.call(this._target());
                    };
                    Promise1.prototype.isRejected = function() {
                        return isRejected.call(this._target());
                    };
                    Promise1.prototype.isFulfilled = function() {
                        return isFulfilled.call(this._target());
                    };
                    Promise1.prototype.isResolved = function() {
                        return isResolved.call(this._target());
                    };
                    Promise1.prototype.value = function() {
                        return value.call(this._target());
                    };
                    Promise1.prototype.reason = function() {
                        var target = this._target();
                        target._unsetRejectionIsUnhandled();
                        return reason.call(target);
                    };
                    Promise1.prototype._value = function() {
                        return this._settledValue();
                    };
                    Promise1.prototype._reason = function() {
                        this._unsetRejectionIsUnhandled();
                        return this._settledValue();
                    };
                    Promise1.PromiseInspection = PromiseInspection;
                };
            },
            {}
        ],
        33: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL) {
                    var util = _dereq_1("./util");
                    var errorObj = util.errorObj;
                    var isObject = util.isObject;
                    function tryConvertToPromise(obj, context) {
                        if (isObject(obj)) {
                            if (obj instanceof Promise1) return obj;
                            var then = getThen(obj);
                            if (then === errorObj) {
                                if (context) context._pushContext();
                                var ret = Promise1.reject(then.e);
                                if (context) context._popContext();
                                return ret;
                            } else if (typeof then === "function") {
                                if (isAnyBluebirdPromise(obj)) {
                                    var ret = new Promise1(INTERNAL);
                                    obj._then(ret._fulfill, ret._reject, undefined, ret, null);
                                    return ret;
                                }
                                return doThenable(obj, then, context);
                            }
                        }
                        return obj;
                    }
                    function doGetThen(obj) {
                        return obj.then;
                    }
                    function getThen(obj) {
                        try {
                            return doGetThen(obj);
                        } catch (e) {
                            errorObj.e = e;
                            return errorObj;
                        }
                    }
                    var hasProp = {}.hasOwnProperty;
                    function isAnyBluebirdPromise(obj) {
                        try {
                            return hasProp.call(obj, "_promise0");
                        } catch (e) {
                            return false;
                        }
                    }
                    function doThenable(x, then, context) {
                        var promise = new Promise1(INTERNAL);
                        var ret = promise;
                        if (context) context._pushContext();
                        promise._captureStackTrace();
                        if (context) context._popContext();
                        var synchronous = true;
                        var result = util.tryCatch(then).call(x, resolve, reject);
                        synchronous = false;
                        if (promise && result === errorObj) {
                            promise._rejectCallback(result.e, true, true);
                            promise = null;
                        }
                        function resolve(value) {
                            if (!promise) return;
                            promise._resolveCallback(value);
                            promise = null;
                        }
                        function reject(reason) {
                            if (!promise) return;
                            promise._rejectCallback(reason, synchronous, true);
                            promise = null;
                        }
                        return ret;
                    }
                    return tryConvertToPromise;
                };
            },
            {
                "./util": 36
            }
        ],
        34: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, debug) {
                    var util = _dereq_1("./util");
                    var TimeoutError = Promise1.TimeoutError;
                    function HandleWrapper(handle) {
                        this.handle = handle;
                    }
                    HandleWrapper.prototype._resultCancelled = function() {
                        clearTimeout(this.handle);
                    };
                    var afterValue = function(value) {
                        return delay(+this).thenReturn(value);
                    };
                    var delay = Promise1.delay = function(ms, value) {
                        var ret;
                        var handle;
                        if (value !== undefined) {
                            ret = Promise1.resolve(value)._then(afterValue, null, null, ms, undefined);
                            if (debug.cancellation() && value instanceof Promise1) ret._setOnCancel(value);
                        } else {
                            ret = new Promise1(INTERNAL);
                            handle = setTimeout(function() {
                                ret._fulfill();
                            }, +ms);
                            if (debug.cancellation()) ret._setOnCancel(new HandleWrapper(handle));
                            ret._captureStackTrace();
                        }
                        ret._setAsyncGuaranteed();
                        return ret;
                    };
                    Promise1.prototype.delay = function(ms) {
                        return delay(ms, this);
                    };
                    var afterTimeout = function(promise, message, parent) {
                        var err;
                        if (typeof message !== "string") {
                            if (message instanceof Error) err = message;
                            else err = new TimeoutError("operation timed out");
                        } else err = new TimeoutError(message);
                        util.markAsOriginatingFromRejection(err);
                        promise._attachExtraTrace(err);
                        promise._reject(err);
                        if (parent != null) parent.cancel();
                    };
                    function successClear(value) {
                        clearTimeout(this.handle);
                        return value;
                    }
                    function failureClear(reason) {
                        clearTimeout(this.handle);
                        throw reason;
                    }
                    Promise1.prototype.timeout = function(ms, message) {
                        ms = +ms;
                        var ret, parent;
                        var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
                            if (ret.isPending()) afterTimeout(ret, message, parent);
                        }, ms));
                        if (debug.cancellation()) {
                            parent = this.then();
                            ret = parent._then(successClear, failureClear, undefined, handleWrapper, undefined);
                            ret._setOnCancel(handleWrapper);
                        } else ret = this._then(successClear, failureClear, undefined, handleWrapper, undefined);
                        return ret;
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        35: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug) {
                    var util = _dereq_1("./util");
                    var TypeError1 = _dereq_1("./errors").TypeError;
                    var inherits = _dereq_1("./util").inherits;
                    var errorObj = util.errorObj;
                    var tryCatch = util.tryCatch;
                    var NULL = {};
                    function thrower(e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                    function castPreservingDisposable(thenable) {
                        var maybePromise = tryConvertToPromise(thenable);
                        if (maybePromise !== thenable && typeof thenable._isDisposable === "function" && typeof thenable._getDisposer === "function" && thenable._isDisposable()) maybePromise._setDisposable(thenable._getDisposer());
                        return maybePromise;
                    }
                    function dispose(resources, inspection) {
                        var i = 0;
                        var len = resources.length;
                        var ret = new Promise1(INTERNAL);
                        function iterator() {
                            if (i >= len) return ret._fulfill();
                            var maybePromise = castPreservingDisposable(resources[i++]);
                            if (maybePromise instanceof Promise1 && maybePromise._isDisposable()) {
                                try {
                                    maybePromise = tryConvertToPromise(maybePromise._getDisposer().tryDispose(inspection), resources.promise);
                                } catch (e) {
                                    return thrower(e);
                                }
                                if (maybePromise instanceof Promise1) return maybePromise._then(iterator, thrower, null, null, null);
                            }
                            iterator();
                        }
                        iterator();
                        return ret;
                    }
                    function Disposer(data, promise, context) {
                        this._data = data;
                        this._promise = promise;
                        this._context = context;
                    }
                    Disposer.prototype.data = function() {
                        return this._data;
                    };
                    Disposer.prototype.promise = function() {
                        return this._promise;
                    };
                    Disposer.prototype.resource = function() {
                        if (this.promise().isFulfilled()) return this.promise().value();
                        return NULL;
                    };
                    Disposer.prototype.tryDispose = function(inspection) {
                        var resource = this.resource();
                        var context = this._context;
                        if (context !== undefined) context._pushContext();
                        var ret = resource !== NULL ? this.doDispose(resource, inspection) : null;
                        if (context !== undefined) context._popContext();
                        this._promise._unsetDisposable();
                        this._data = null;
                        return ret;
                    };
                    Disposer.isDisposer = function(d) {
                        return d != null && typeof d.resource === "function" && typeof d.tryDispose === "function";
                    };
                    function FunctionDisposer(fn, promise, context) {
                        this.constructor$(fn, promise, context);
                    }
                    inherits(FunctionDisposer, Disposer);
                    FunctionDisposer.prototype.doDispose = function(resource, inspection) {
                        var fn = this.data();
                        return fn.call(resource, resource, inspection);
                    };
                    function maybeUnwrapDisposer(value) {
                        if (Disposer.isDisposer(value)) {
                            this.resources[this.index]._setDisposable(value);
                            return value.promise();
                        }
                        return value;
                    }
                    function ResourceList(length) {
                        this.length = length;
                        this.promise = null;
                        this[length - 1] = null;
                    }
                    ResourceList.prototype._resultCancelled = function() {
                        var len = this.length;
                        for(var i = 0; i < len; ++i){
                            var item = this[i];
                            if (item instanceof Promise1) item.cancel();
                        }
                    };
                    Promise1.using = function() {
                        var len = arguments.length;
                        if (len < 2) return apiRejection("you must pass at least 2 arguments to Promise.using");
                        var fn = arguments[len - 1];
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        var input;
                        var spreadArgs = true;
                        if (len === 2 && Array.isArray(arguments[0])) {
                            input = arguments[0];
                            len = input.length;
                            spreadArgs = false;
                        } else {
                            input = arguments;
                            len--;
                        }
                        var resources = new ResourceList(len);
                        for(var i = 0; i < len; ++i){
                            var resource = input[i];
                            if (Disposer.isDisposer(resource)) {
                                var disposer = resource;
                                resource = resource.promise();
                                resource._setDisposable(disposer);
                            } else {
                                var maybePromise = tryConvertToPromise(resource);
                                if (maybePromise instanceof Promise1) resource = maybePromise._then(maybeUnwrapDisposer, null, null, {
                                    resources: resources,
                                    index: i
                                }, undefined);
                            }
                            resources[i] = resource;
                        }
                        var reflectedResources = new Array(resources.length);
                        for(var i = 0; i < reflectedResources.length; ++i)reflectedResources[i] = Promise1.resolve(resources[i]).reflect();
                        var resultPromise = Promise1.all(reflectedResources).then(function(inspections) {
                            for(var i = 0; i < inspections.length; ++i){
                                var inspection = inspections[i];
                                if (inspection.isRejected()) {
                                    errorObj.e = inspection.error();
                                    return errorObj;
                                } else if (!inspection.isFulfilled()) {
                                    resultPromise.cancel();
                                    return;
                                }
                                inspections[i] = inspection.value();
                            }
                            promise._pushContext();
                            fn = tryCatch(fn);
                            var ret = spreadArgs ? fn.apply(undefined, inspections) : fn(inspections);
                            var promiseCreated = promise._popContext();
                            debug.checkForgottenReturns(ret, promiseCreated, "Promise.using", promise);
                            return ret;
                        });
                        var promise = resultPromise.lastly(function() {
                            var inspection = new Promise1.PromiseInspection(resultPromise);
                            return dispose(resources, inspection);
                        });
                        resources.promise = promise;
                        promise._setOnCancel(resources);
                        return promise;
                    };
                    Promise1.prototype._setDisposable = function(disposer) {
                        this._bitField = this._bitField | 131072;
                        this._disposer = disposer;
                    };
                    Promise1.prototype._isDisposable = function() {
                        return (this._bitField & 131072) > 0;
                    };
                    Promise1.prototype._getDisposer = function() {
                        return this._disposer;
                    };
                    Promise1.prototype._unsetDisposable = function() {
                        this._bitField = this._bitField & -131073;
                        this._disposer = undefined;
                    };
                    Promise1.prototype.disposer = function(fn) {
                        if (typeof fn === "function") return new FunctionDisposer(fn, this, createContext());
                        throw new TypeError1();
                    };
                };
            },
            {
                "./errors": 12,
                "./util": 36
            }
        ],
        36: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var es5 = _dereq_1("./es5");
                var canEvaluate = typeof navigator == "undefined";
                var errorObj = {
                    e: {}
                };
                var tryCatchTarget;
                var globalObject = typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : this !== undefined ? this : null;
                function tryCatcher() {
                    try {
                        var target = tryCatchTarget;
                        tryCatchTarget = null;
                        return target.apply(this, arguments);
                    } catch (e) {
                        errorObj.e = e;
                        return errorObj;
                    }
                }
                function tryCatch(fn) {
                    tryCatchTarget = fn;
                    return tryCatcher;
                }
                var inherits = function(Child, Parent) {
                    var hasProp = {}.hasOwnProperty;
                    function T() {
                        this.constructor = Child;
                        this.constructor$ = Parent;
                        for(var propertyName in Parent.prototype)if (hasProp.call(Parent.prototype, propertyName) && propertyName.charAt(propertyName.length - 1) !== "$") this[propertyName + "$"] = Parent.prototype[propertyName];
                    }
                    T.prototype = Parent.prototype;
                    Child.prototype = new T();
                    return Child.prototype;
                };
                function isPrimitive(val) {
                    return val == null || val === true || val === false || typeof val === "string" || typeof val === "number";
                }
                function isObject(value) {
                    return typeof value === "function" || typeof value === "object" && value !== null;
                }
                function maybeWrapAsError(maybeError) {
                    if (!isPrimitive(maybeError)) return maybeError;
                    return new Error(safeToString(maybeError));
                }
                function withAppended(target, appendee) {
                    var len = target.length;
                    var ret = new Array(len + 1);
                    var i;
                    for(i = 0; i < len; ++i)ret[i] = target[i];
                    ret[i] = appendee;
                    return ret;
                }
                function getDataPropertyOrDefault(obj, key, defaultValue) {
                    if (es5.isES5) {
                        var desc = Object.getOwnPropertyDescriptor(obj, key);
                        if (desc != null) return desc.get == null && desc.set == null ? desc.value : defaultValue;
                    } else return ({}).hasOwnProperty.call(obj, key) ? obj[key] : undefined;
                }
                function notEnumerableProp(obj, name, value) {
                    if (isPrimitive(obj)) return obj;
                    var descriptor = {
                        value: value,
                        configurable: true,
                        enumerable: false,
                        writable: true
                    };
                    es5.defineProperty(obj, name, descriptor);
                    return obj;
                }
                function thrower(r) {
                    throw r;
                }
                var inheritedDataKeys = function() {
                    var excludedPrototypes = [
                        Array.prototype,
                        Object.prototype,
                        Function.prototype
                    ];
                    var isExcludedProto = function(val) {
                        for(var i = 0; i < excludedPrototypes.length; ++i){
                            if (excludedPrototypes[i] === val) return true;
                        }
                        return false;
                    };
                    if (es5.isES5) {
                        var getKeys = Object.getOwnPropertyNames;
                        return function(obj) {
                            var ret = [];
                            var visitedKeys = Object.create(null);
                            while(obj != null && !isExcludedProto(obj)){
                                var keys;
                                try {
                                    keys = getKeys(obj);
                                } catch (e) {
                                    return ret;
                                }
                                for(var i = 0; i < keys.length; ++i){
                                    var key = keys[i];
                                    if (visitedKeys[key]) continue;
                                    visitedKeys[key] = true;
                                    var desc = Object.getOwnPropertyDescriptor(obj, key);
                                    if (desc != null && desc.get == null && desc.set == null) ret.push(key);
                                }
                                obj = es5.getPrototypeOf(obj);
                            }
                            return ret;
                        };
                    } else {
                        var hasProp = {}.hasOwnProperty;
                        return function(obj) {
                            if (isExcludedProto(obj)) return [];
                            var ret = [];
                            /*jshint forin:false */ enumeration: for(var key in obj)if (hasProp.call(obj, key)) ret.push(key);
                            else {
                                for(var i = 0; i < excludedPrototypes.length; ++i){
                                    if (hasProp.call(excludedPrototypes[i], key)) continue enumeration;
                                }
                                ret.push(key);
                            }
                            return ret;
                        };
                    }
                }();
                var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
                function isClass(fn) {
                    try {
                        if (typeof fn === "function") {
                            var keys = es5.names(fn.prototype);
                            var hasMethods = es5.isES5 && keys.length > 1;
                            var hasMethodsOtherThanConstructor = keys.length > 0 && !(keys.length === 1 && keys[0] === "constructor");
                            var hasThisAssignmentAndStaticMethods = thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
                            if (hasMethods || hasMethodsOtherThanConstructor || hasThisAssignmentAndStaticMethods) return true;
                        }
                        return false;
                    } catch (e) {
                        return false;
                    }
                }
                function toFastProperties(obj) {
                    /*jshint -W027,-W055,-W031*/ function FakeConstructor() {}
                    FakeConstructor.prototype = obj;
                    var receiver = new FakeConstructor();
                    function ic() {
                        return typeof receiver.foo;
                    }
                    ic();
                    ic();
                    return obj;
                }
                var rident = /^[a-z$_][a-z$_0-9]*$/i;
                function isIdentifier(str) {
                    return rident.test(str);
                }
                function filledRange(count, prefix, suffix) {
                    var ret = new Array(count);
                    for(var i = 0; i < count; ++i)ret[i] = prefix + i + suffix;
                    return ret;
                }
                function safeToString(obj) {
                    try {
                        return obj + "";
                    } catch (e) {
                        return "[no string representation]";
                    }
                }
                function isError(obj) {
                    return obj instanceof Error || obj !== null && typeof obj === "object" && typeof obj.message === "string" && typeof obj.name === "string";
                }
                function markAsOriginatingFromRejection(e) {
                    try {
                        notEnumerableProp(e, "isOperational", true);
                    } catch (ignore) {}
                }
                function originatesFromRejection(e) {
                    if (e == null) return false;
                    return e instanceof Error["__BluebirdErrorTypes__"].OperationalError || e["isOperational"] === true;
                }
                function canAttachTrace(obj) {
                    return isError(obj) && es5.propertyIsWritable(obj, "stack");
                }
                var ensureErrorObject = function() {
                    if (!("stack" in new Error())) return function(value) {
                        if (canAttachTrace(value)) return value;
                        try {
                            throw new Error(safeToString(value));
                        } catch (err) {
                            return err;
                        }
                    };
                    else return function(value) {
                        if (canAttachTrace(value)) return value;
                        return new Error(safeToString(value));
                    };
                }();
                function classString(obj) {
                    return ({}).toString.call(obj);
                }
                function copyDescriptors(from, to, filter) {
                    var keys = es5.names(from);
                    for(var i = 0; i < keys.length; ++i){
                        var key = keys[i];
                        if (filter(key)) try {
                            es5.defineProperty(to, key, es5.getDescriptor(from, key));
                        } catch (ignore) {}
                    }
                }
                var asArray = function(v) {
                    if (es5.isArray(v)) return v;
                    return null;
                };
                if (typeof Symbol !== "undefined" && Symbol.iterator) {
                    var ArrayFrom = typeof Array.from === "function" ? function(v) {
                        return Array.from(v);
                    } : function(v) {
                        var ret = [];
                        var it = v[Symbol.iterator]();
                        var itResult;
                        while(!(itResult = it.next()).done)ret.push(itResult.value);
                        return ret;
                    };
                    asArray = function(v) {
                        if (es5.isArray(v)) return v;
                        else if (v != null && typeof v[Symbol.iterator] === "function") return ArrayFrom(v);
                        return null;
                    };
                }
                var isNode = typeof $4acf49f6c3e67aec$exports !== "undefined" && classString($4acf49f6c3e67aec$exports).toLowerCase() === "[object process]";
                var hasEnvVariables = typeof $4acf49f6c3e67aec$exports !== "undefined" && typeof $4acf49f6c3e67aec$exports.env !== "undefined";
                function env(key) {
                    return hasEnvVariables ? $4acf49f6c3e67aec$exports.env[key] : undefined;
                }
                function getNativePromise() {
                    if (typeof Promise === "function") try {
                        var promise = new Promise(function() {});
                        if (classString(promise) === "[object Promise]") return Promise;
                    } catch (e) {}
                }
                var reflectHandler;
                function contextBind(ctx, cb) {
                    if (ctx === null || typeof cb !== "function" || cb === reflectHandler) return cb;
                    if (ctx.domain !== null) cb = ctx.domain.bind(cb);
                    var async = ctx.async;
                    if (async !== null) {
                        var old = cb;
                        cb = function() {
                            var args = new Array(2).concat([].slice.call(arguments));
                            args[0] = old;
                            args[1] = this;
                            return async.runInAsyncScope.apply(async, args);
                        };
                    }
                    return cb;
                }
                var ret = {
                    setReflectHandler: function(fn) {
                        reflectHandler = fn;
                    },
                    isClass: isClass,
                    isIdentifier: isIdentifier,
                    inheritedDataKeys: inheritedDataKeys,
                    getDataPropertyOrDefault: getDataPropertyOrDefault,
                    thrower: thrower,
                    isArray: es5.isArray,
                    asArray: asArray,
                    notEnumerableProp: notEnumerableProp,
                    isPrimitive: isPrimitive,
                    isObject: isObject,
                    isError: isError,
                    canEvaluate: canEvaluate,
                    errorObj: errorObj,
                    tryCatch: tryCatch,
                    inherits: inherits,
                    withAppended: withAppended,
                    maybeWrapAsError: maybeWrapAsError,
                    toFastProperties: toFastProperties,
                    filledRange: filledRange,
                    toString: safeToString,
                    canAttachTrace: canAttachTrace,
                    ensureErrorObject: ensureErrorObject,
                    originatesFromRejection: originatesFromRejection,
                    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
                    classString: classString,
                    copyDescriptors: copyDescriptors,
                    isNode: isNode,
                    hasEnvVariables: hasEnvVariables,
                    env: env,
                    global: globalObject,
                    getNativePromise: getNativePromise,
                    contextBind: contextBind
                };
                ret.isRecentNode = ret.isNode && function() {
                    var version;
                    if ($4acf49f6c3e67aec$exports.versions && $4acf49f6c3e67aec$exports.versions.node) version = $4acf49f6c3e67aec$exports.versions.node.split(".").map(Number);
                    else if ($4acf49f6c3e67aec$exports.version) version = $4acf49f6c3e67aec$exports.version.split(".").map(Number);
                    return version[0] === 0 && version[1] > 10 || version[0] > 0;
                }();
                ret.nodeSupportsAsyncResource = ret.isNode && function() {
                    var supportsAsync = false;
                    try {
                        var res = _dereq_1("async_hooks").AsyncResource;
                        supportsAsync = typeof res.prototype.runInAsyncScope === "function";
                    } catch (e) {
                        supportsAsync = false;
                    }
                    return supportsAsync;
                }();
                if (ret.isNode) ret.toFastProperties($4acf49f6c3e67aec$exports);
                try {
                    throw new Error();
                } catch (e) {
                    ret.lastLineError = e;
                }
                module1.exports = ret;
            },
            {
                "./es5": 13,
                "async_hooks": undefined
            }
        ]
    }, {}, [
        4
    ])(4);
});
if (typeof window !== 'undefined' && window !== null) window.P = window.Promise;
else if (typeof self !== 'undefined' && self !== null) self.P = self.Promise;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $24f87a6f86a8996f$export$a143d493d941bafc;
var $24f87a6f86a8996f$export$e4cf37d7f6fb9e0a;
var $24f87a6f86a8996f$export$f99ded8fe4b79145;
var $24f87a6f86a8996f$export$599f31c3813fae4d;
'use strict';
var $3caef5c332c7293f$export$a48f0734ac7c2329;
var $3caef5c332c7293f$export$d622b2ad8d90c771;
var $3caef5c332c7293f$export$6100ba28696e12de;
'use strict';
$3caef5c332c7293f$export$a48f0734ac7c2329 = $3caef5c332c7293f$var$byteLength;
$3caef5c332c7293f$export$d622b2ad8d90c771 = $3caef5c332c7293f$var$toByteArray;
$3caef5c332c7293f$export$6100ba28696e12de = $3caef5c332c7293f$var$fromByteArray;
var $3caef5c332c7293f$var$lookup = [];
var $3caef5c332c7293f$var$revLookup = [];
var $3caef5c332c7293f$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $3caef5c332c7293f$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $3caef5c332c7293f$var$i = 0, $3caef5c332c7293f$var$len = $3caef5c332c7293f$var$code.length; $3caef5c332c7293f$var$i < $3caef5c332c7293f$var$len; ++$3caef5c332c7293f$var$i){
    $3caef5c332c7293f$var$lookup[$3caef5c332c7293f$var$i] = $3caef5c332c7293f$var$code[$3caef5c332c7293f$var$i];
    $3caef5c332c7293f$var$revLookup[$3caef5c332c7293f$var$code.charCodeAt($3caef5c332c7293f$var$i)] = $3caef5c332c7293f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3caef5c332c7293f$var$revLookup['-'.charCodeAt(0)] = 62;
$3caef5c332c7293f$var$revLookup['_'.charCodeAt(0)] = 63;
function $3caef5c332c7293f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $3caef5c332c7293f$var$byteLength(b64) {
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$toByteArray(b64) {
    var tmp;
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3caef5c332c7293f$var$Arr($3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 18 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 2 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 10 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3caef5c332c7293f$var$tripletToBase64(num) {
    return $3caef5c332c7293f$var$lookup[num >> 18 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 12 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 6 & 0x3F] + $3caef5c332c7293f$var$lookup[num & 0x3F];
}
function $3caef5c332c7293f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3caef5c332c7293f$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $3caef5c332c7293f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3caef5c332c7293f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 2] + $3caef5c332c7293f$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 10] + $3caef5c332c7293f$var$lookup[tmp >> 4 & 0x3F] + $3caef5c332c7293f$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $56a54f6ebabce67d$export$aafa59e2e03f2942;
var $56a54f6ebabce67d$export$68d8715fc104d294;
$56a54f6ebabce67d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$56a54f6ebabce67d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $24f87a6f86a8996f$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$24f87a6f86a8996f$export$a143d493d941bafc = $24f87a6f86a8996f$var$Buffer;
$24f87a6f86a8996f$export$e4cf37d7f6fb9e0a = $24f87a6f86a8996f$var$SlowBuffer;
$24f87a6f86a8996f$export$f99ded8fe4b79145 = 50;
const $24f87a6f86a8996f$var$K_MAX_LENGTH = 0x7fffffff;
$24f87a6f86a8996f$export$599f31c3813fae4d = $24f87a6f86a8996f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT = $24f87a6f86a8996f$var$typedArraySupport();
if (!$24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $24f87a6f86a8996f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $24f87a6f86a8996f$var$createBuffer(length) {
    if (length > $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $24f87a6f86a8996f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $24f87a6f86a8996f$var$allocUnsafe(arg);
    }
    return $24f87a6f86a8996f$var$from(arg, encodingOrOffset, length);
}
$24f87a6f86a8996f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $24f87a6f86a8996f$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $24f87a6f86a8996f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $24f87a6f86a8996f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($24f87a6f86a8996f$var$isInstance(value, ArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, ArrayBuffer)) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($24f87a6f86a8996f$var$isInstance(value, SharedArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, SharedArrayBuffer))) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $24f87a6f86a8996f$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $24f87a6f86a8996f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $24f87a6f86a8996f$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $24f87a6f86a8996f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $24f87a6f86a8996f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer, Uint8Array);
function $24f87a6f86a8996f$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $24f87a6f86a8996f$var$alloc(size, fill, encoding) {
    $24f87a6f86a8996f$var$assertSize(size);
    if (size <= 0) return $24f87a6f86a8996f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $24f87a6f86a8996f$var$createBuffer(size).fill(fill, encoding) : $24f87a6f86a8996f$var$createBuffer(size).fill(fill);
    return $24f87a6f86a8996f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $24f87a6f86a8996f$var$Buffer.alloc = function(size, fill, encoding) {
    return $24f87a6f86a8996f$var$alloc(size, fill, encoding);
};
function $24f87a6f86a8996f$var$allocUnsafe(size) {
    $24f87a6f86a8996f$var$assertSize(size);
    return $24f87a6f86a8996f$var$createBuffer(size < 0 ? 0 : $24f87a6f86a8996f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $24f87a6f86a8996f$var$Buffer.allocUnsafe = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $24f87a6f86a8996f$var$Buffer.allocUnsafeSlow = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
function $24f87a6f86a8996f$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $24f87a6f86a8996f$var$byteLength(string, encoding) | 0;
    let buf = $24f87a6f86a8996f$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $24f87a6f86a8996f$var$checked(array.length) | 0;
    const buf = $24f87a6f86a8996f$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayView(arrayView) {
    if ($24f87a6f86a8996f$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $24f87a6f86a8996f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $24f87a6f86a8996f$var$fromArrayLike(arrayView);
}
function $24f87a6f86a8996f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
function $24f87a6f86a8996f$var$fromObject(obj) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(obj)) {
        const len = $24f87a6f86a8996f$var$checked(obj.length) | 0;
        const buf = $24f87a6f86a8996f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $24f87a6f86a8996f$var$numberIsNaN(obj.length)) return $24f87a6f86a8996f$var$createBuffer(0);
        return $24f87a6f86a8996f$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $24f87a6f86a8996f$var$fromArrayLike(obj.data);
}
function $24f87a6f86a8996f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $24f87a6f86a8996f$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $24f87a6f86a8996f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $24f87a6f86a8996f$var$Buffer.alloc(+length);
}
$24f87a6f86a8996f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $24f87a6f86a8996f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$24f87a6f86a8996f$var$Buffer.compare = function compare(a, b) {
    if ($24f87a6f86a8996f$var$isInstance(a, Uint8Array)) a = $24f87a6f86a8996f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($24f87a6f86a8996f$var$isInstance(b, Uint8Array)) b = $24f87a6f86a8996f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(a) || !$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$24f87a6f86a8996f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$24f87a6f86a8996f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $24f87a6f86a8996f$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $24f87a6f86a8996f$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($24f87a6f86a8996f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) buf = $24f87a6f86a8996f$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $24f87a6f86a8996f$var$byteLength(string, encoding) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $24f87a6f86a8996f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $24f87a6f86a8996f$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $24f87a6f86a8996f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $24f87a6f86a8996f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$24f87a6f86a8996f$var$Buffer.byteLength = $24f87a6f86a8996f$var$byteLength;
function $24f87a6f86a8996f$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $24f87a6f86a8996f$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $24f87a6f86a8996f$var$utf8Slice(this, start, end);
        case 'ascii':
            return $24f87a6f86a8996f$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $24f87a6f86a8996f$var$latin1Slice(this, start, end);
        case 'base64':
            return $24f87a6f86a8996f$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $24f87a6f86a8996f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$24f87a6f86a8996f$var$Buffer.prototype._isBuffer = true;
function $24f87a6f86a8996f$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$24f87a6f86a8996f$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$24f87a6f86a8996f$var$swap(this, i, i + 1);
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $24f87a6f86a8996f$var$swap(this, i, i + 3);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $24f87a6f86a8996f$var$swap(this, i, i + 7);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 6);
        $24f87a6f86a8996f$var$swap(this, i + 2, i + 5);
        $24f87a6f86a8996f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $24f87a6f86a8996f$var$utf8Slice(this, 0, length);
    return $24f87a6f86a8996f$var$slowToString.apply(this, arguments);
};
$24f87a6f86a8996f$var$Buffer.prototype.toLocaleString = $24f87a6f86a8996f$var$Buffer.prototype.toString;
$24f87a6f86a8996f$var$Buffer.prototype.equals = function equals(b) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $24f87a6f86a8996f$var$Buffer.compare(this, b) === 0;
};
$24f87a6f86a8996f$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $24f87a6f86a8996f$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($24f87a6f86a8996f$var$customInspectSymbol) $24f87a6f86a8996f$var$Buffer.prototype[$24f87a6f86a8996f$var$customInspectSymbol] = $24f87a6f86a8996f$var$Buffer.prototype.inspect;
$24f87a6f86a8996f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($24f87a6f86a8996f$var$isInstance(target, Uint8Array)) target = $24f87a6f86a8996f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $24f87a6f86a8996f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($24f87a6f86a8996f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $24f87a6f86a8996f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $24f87a6f86a8996f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$24f87a6f86a8996f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$24f87a6f86a8996f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $24f87a6f86a8996f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($24f87a6f86a8996f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $24f87a6f86a8996f$var$utf8Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $24f87a6f86a8996f$var$asciiWrite(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$asciiToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$base64Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$base64ToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$ucs2Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$24f87a6f86a8996f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $24f87a6f86a8996f$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $24f87a6f86a8996f$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $24f87a6f86a8996f$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $24f87a6f86a8996f$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $24f87a6f86a8996f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$24f87a6f86a8996f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $24f87a6f86a8996f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $3caef5c332c7293f$export$6100ba28696e12de(buf);
    else return $3caef5c332c7293f$export$6100ba28696e12de(buf.slice(start, end));
}
function $24f87a6f86a8996f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $24f87a6f86a8996f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $24f87a6f86a8996f$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $24f87a6f86a8996f$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $24f87a6f86a8996f$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $24f87a6f86a8996f$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $24f87a6f86a8996f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $24f87a6f86a8996f$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$24f87a6f86a8996f$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $24f87a6f86a8996f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $24f87a6f86a8996f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$24f87a6f86a8996f$var$Buffer.prototype.readUintLE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUintBE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint8 = $24f87a6f86a8996f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$24f87a6f86a8996f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$24f87a6f86a8996f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $24f87a6f86a8996f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$24f87a6f86a8996f$var$Buffer.prototype.writeUintLE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUintBE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint8 = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $24f87a6f86a8996f$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $24f87a6f86a8996f$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $24f87a6f86a8996f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $56a54f6ebabce67d$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, false, noAssert);
};
function $24f87a6f86a8996f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $56a54f6ebabce67d$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$24f87a6f86a8996f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$24f87a6f86a8996f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $24f87a6f86a8996f$var$Buffer.isBuffer(val) ? val : $24f87a6f86a8996f$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $24f87a6f86a8996f$var$errors = {};
function $24f87a6f86a8996f$var$E(sym, getMessage, Base) {
    $24f87a6f86a8996f$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$24f87a6f86a8996f$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$24f87a6f86a8996f$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$24f87a6f86a8996f$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $24f87a6f86a8996f$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $24f87a6f86a8996f$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $24f87a6f86a8996f$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength) {
    $24f87a6f86a8996f$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $24f87a6f86a8996f$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength);
}
function $24f87a6f86a8996f$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $24f87a6f86a8996f$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $24f87a6f86a8996f$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $24f87a6f86a8996f$var$validateNumber(value, type);
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $24f87a6f86a8996f$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $24f87a6f86a8996f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $24f87a6f86a8996f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($24f87a6f86a8996f$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $24f87a6f86a8996f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $24f87a6f86a8996f$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $24f87a6f86a8996f$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $24f87a6f86a8996f$var$base64ToBytes(str) {
    return $3caef5c332c7293f$export$d622b2ad8d90c771($24f87a6f86a8996f$var$base64clean(str));
}
function $24f87a6f86a8996f$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $24f87a6f86a8996f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $24f87a6f86a8996f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $24f87a6f86a8996f$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $24f87a6f86a8996f$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $24f87a6f86a8996f$var$BufferBigIntNotDefined : fn;
}
function $24f87a6f86a8996f$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $49c4be87a5e25114$exports = {};
'use strict';
Object.defineProperty($49c4be87a5e25114$exports, "__esModule", {
    value: true
});
var $990c75d6119809c3$exports = {};

$parcel$defineInteropFlag($990c75d6119809c3$exports);

$parcel$export($990c75d6119809c3$exports, "__esModule", function () { return $990c75d6119809c3$export$1e511d4a378977f5; }, function (v) { return $990c75d6119809c3$export$1e511d4a378977f5 = v; });
$parcel$export($990c75d6119809c3$exports, "default", function () { return $990c75d6119809c3$export$2e2bcd8739ae039; }, function (v) { return $990c75d6119809c3$export$2e2bcd8739ae039 = v; });
var $990c75d6119809c3$export$1e511d4a378977f5;
var $990c75d6119809c3$export$2e2bcd8739ae039;
"use strict";
$990c75d6119809c3$export$1e511d4a378977f5 = true;
$990c75d6119809c3$export$2e2bcd8739ae039 = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};


var $49c4be87a5e25114$var$_classCallCheck3 = $49c4be87a5e25114$var$_interopRequireDefault($990c75d6119809c3$exports);
var $eb4247c285077bb9$exports = {};

$parcel$defineInteropFlag($eb4247c285077bb9$exports);

$parcel$export($eb4247c285077bb9$exports, "__esModule", function () { return $eb4247c285077bb9$export$1e511d4a378977f5; }, function (v) { return $eb4247c285077bb9$export$1e511d4a378977f5 = v; });
$parcel$export($eb4247c285077bb9$exports, "default", function () { return $eb4247c285077bb9$export$2e2bcd8739ae039; }, function (v) { return $eb4247c285077bb9$export$2e2bcd8739ae039 = v; });
var $eb4247c285077bb9$export$1e511d4a378977f5;
var $eb4247c285077bb9$export$2e2bcd8739ae039;
"use strict";
$eb4247c285077bb9$export$1e511d4a378977f5 = true;
var $06c68f525506e753$exports = {};

$06c68f525506e753$exports = {
    "default": (parcelRequire("9u6t1")),
    __esModule: true
};


var $eb4247c285077bb9$var$_defineProperty2 = $eb4247c285077bb9$var$_interopRequireDefault($06c68f525506e753$exports);
function $eb4247c285077bb9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$eb4247c285077bb9$export$2e2bcd8739ae039 = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            (0, $eb4247c285077bb9$var$_defineProperty2.default)(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();


var $49c4be87a5e25114$var$_createClass3 = $49c4be87a5e25114$var$_interopRequireDefault($eb4247c285077bb9$exports);
var $38dabb85bcfa43e2$exports = {};

$38dabb85bcfa43e2$exports = {
    "default": (parcelRequire("gTRtf")),
    __esModule: true
};


var $49c4be87a5e25114$var$_weakMap2 = $49c4be87a5e25114$var$_interopRequireDefault($38dabb85bcfa43e2$exports);
function $49c4be87a5e25114$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $49c4be87a5e25114$var$emitter = new $49c4be87a5e25114$var$_weakMap2.default();
var $49c4be87a5e25114$var$Emitter = function() {
    function Emitter() {
        (0, $49c4be87a5e25114$var$_classCallCheck3.default)(this, Emitter);
        $49c4be87a5e25114$var$emitter.set(this, {
            events: {}
        });
        this.eventLength = 0;
    }
    (0, $49c4be87a5e25114$var$_createClass3.default)(Emitter, [
        {
            key: 'on',
            value: function on(event, cb) {
                var once = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                if (typeof cb === 'undefined') throw new Error('You must provide a callback method.');
                if (typeof cb !== 'function') throw new TypeError('Listener must be a function');
                this.events[event] = this.events[event] || [];
                this.events[event].push({
                    cb: cb,
                    once: once
                });
                this.eventLength++;
                return this;
            }
        },
        {
            key: 'off',
            value: function off(event, cb) {
                if (typeof cb === 'undefined') throw new Error('You must provide a callback method.');
                if (typeof cb !== 'function') throw new TypeError('Listener must be a function');
                if (typeof this.events[event] === 'undefined') throw new Error('Event not found - the event you provided is: ' + event);
                var listeners = this.events[event];
                listeners.forEach(function(v, i) {
                    if (v.cb === cb) listeners.splice(i, 1);
                });
                if (listeners.length === 0) {
                    delete this.events[event];
                    this.eventLength--;
                }
                return this;
            }
        },
        {
            key: 'trigger',
            value: function trigger(event) {
                var _this = this;
                for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (typeof event === 'undefined') throw new Error('You must provide an event to trigger.');
                var listeners = this.events[event];
                var onceListeners = [];
                if (typeof listeners !== 'undefined') listeners.forEach(function(v, k) {
                    v.cb.apply(_this, args);
                    if (v.once) onceListeners.unshift(k);
                    onceListeners.forEach(function(v, k) {
                        listeners.splice(k, 1);
                    });
                });
                return this;
            }
        },
        {
            key: 'once',
            value: function once(event, cb) {
                this.on(event, cb, true);
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                $49c4be87a5e25114$var$emitter.delete(this);
                this.eventLength = 0;
            }
        },
        {
            key: 'events',
            get: function get() {
                return $49c4be87a5e25114$var$emitter.get(this).events;
            }
        }
    ]);
    return Emitter;
}();
$49c4be87a5e25114$exports.default = $49c4be87a5e25114$var$Emitter;


const $fdd5849d34dcc375$export$8b4395497d8b4223 = 'change_state';
const $fdd5849d34dcc375$export$dc7e8c09bf56e28f = 'state_changed';
class $fdd5849d34dcc375$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($49c4be87a5e25114$exports))) {
    constructor(){
        super();
        this.changeState = this.changeState.bind(this);
        this._state = {};
    }
    changeState(state) {
        const previous = {
            ...this._state
        };
        this._state = {
            ...this._state,
            ...state
        };
        this.trigger($fdd5849d34dcc375$export$dc7e8c09bf56e28f, this._state, previous);
    }
}


var $4cde099517bdf0a6$exports = {};
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    $4cde099517bdf0a6$exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = extend({
                path: '/'
            }, api.defaults, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = key + '=' + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === 'undefined') return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, '', extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});


var $e9f4f9da5e4741bc$exports = {};
// Snap.svg 0.5.0
//
// Copyright (c) 2013 – 2017 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
//
// build: 2017-02-06

!function(a) {
    var b, c, d = "0.5.0", e = "hasOwnProperty", f = /[\.\/]/, g1 = /\s*,\s*/, h = "*", i = function(a, b) {
        return a - b;
    }, j = {
        n: {}
    }, k = function() {
        for(var a = 0, b = this.length; b > a; a++)if ("undefined" != typeof this[a]) return this[a];
    }, l = function() {
        for(var a = this.length; --a;)if ("undefined" != typeof this[a]) return this[a];
    }, m = Object.prototype.toString, n = String, o = Array.isArray || function(a) {
        return a instanceof Array || "[object Array]" == m.call(a);
    };
    eve = function(a, d) {
        var e, f = c, g1 = Array.prototype.slice.call(arguments, 2), h = eve.listeners(a), j = 0, m = [], n = {}, o = [], p = b;
        o.firstDefined = k, o.lastDefined = l, b = a, c = 0;
        for(var q = 0, r = h.length; r > q; q++)"zIndex" in h[q] && (m.push(h[q].zIndex), h[q].zIndex < 0 && (n[h[q].zIndex] = h[q]));
        for(m.sort(i); m[j] < 0;)if (e = n[m[j++]], o.push(e.apply(d, g1)), c) return c = f, o;
        for(q = 0; r > q; q++)if (e = h[q], "zIndex" in e) {
            if (e.zIndex == m[j]) {
                if (o.push(e.apply(d, g1)), c) break;
                do if (j++, e = n[m[j]], e && o.push(e.apply(d, g1)), c) break;
                while (e);
            } else n[e.zIndex] = e;
        } else if (o.push(e.apply(d, g1)), c) break;
        return c = f, b = p, o;
    }, eve._events = j, eve.listeners = function(a) {
        var b, c, d, e, g1, i, k, l, m = o(a) ? a : a.split(f), n = j, p = [
            n
        ], q = [];
        for(e = 0, g1 = m.length; g1 > e; e++){
            for(l = [], i = 0, k = p.length; k > i; i++)for(n = p[i].n, c = [
                n[m[e]],
                n[h]
            ], d = 2; d--;)b = c[d], b && (l.push(b), q = q.concat(b.f || []));
            p = l;
        }
        return q;
    }, eve.separator = function(a) {
        a ? (a = n(a).replace(/(?=[\.\^\]\[\-])/g, "\\"), a = "[" + a + "]", f = new RegExp(a)) : f = /[\.\/]/;
    }, eve.on = function(a, b) {
        if ("function" != typeof b) return function() {};
        for(var c = o(a) ? o(a[0]) ? a : [
            a
        ] : n(a).split(g1), d = 0, e = c.length; e > d; d++)!function(a) {
            for(var c, d = o(a) ? a : n(a).split(f), e = j, g1 = 0, h = d.length; h > g1; g1++)e = e.n, e = e.hasOwnProperty(d[g1]) && e[d[g1]] || (e[d[g1]] = {
                n: {}
            });
            for(e.f = e.f || [], g1 = 0, h = e.f.length; h > g1; g1++)if (e.f[g1] == b) {
                c = !0;
                break;
            }
            !c && e.f.push(b);
        }(c[d]);
        return function(a) {
            +a == +a && (b.zIndex = +a);
        };
    }, eve.f = function(a) {
        var b = [].slice.call(arguments, 1);
        return function() {
            eve.apply(null, [
                a,
                null
            ].concat(b).concat([].slice.call(arguments, 0)));
        };
    }, eve.stop = function() {
        c = 1;
    }, eve.nt = function(a) {
        var c = o(b) ? b.join(".") : b;
        return a ? new RegExp("(?:\\.|\\/|^)" + a + "(?:\\.|\\/|$)").test(c) : c;
    }, eve.nts = function() {
        return o(b) ? b : b.split(f);
    }, eve.off = eve.unbind = function(a, b) {
        if (!a) return void (eve._events = j = {
            n: {}
        });
        var c = o(a) ? o(a[0]) ? a : [
            a
        ] : n(a).split(g1);
        if (c.length > 1) for(var d = 0, i = c.length; i > d; d++)eve.off(c[d], b);
        else {
            c = o(a) ? a : n(a).split(f);
            var k, l, m, d, i, p, q, r = [
                j
            ], s = [];
            for(d = 0, i = c.length; i > d; d++)for(p = 0; p < r.length; p += m.length - 2){
                if (m = [
                    p,
                    1
                ], k = r[p].n, c[d] != h) k[c[d]] && (m.push(k[c[d]]), s.unshift({
                    n: k,
                    name: c[d]
                }));
                else for(l in k)k[e](l) && (m.push(k[l]), s.unshift({
                    n: k,
                    name: l
                }));
                r.splice.apply(r, m);
            }
            for(d = 0, i = r.length; i > d; d++)for(k = r[d]; k.n;){
                if (b) {
                    if (k.f) {
                        for(p = 0, q = k.f.length; q > p; p++)if (k.f[p] == b) {
                            k.f.splice(p, 1);
                            break;
                        }
                        !k.f.length && delete k.f;
                    }
                    for(l in k.n)if (k.n[e](l) && k.n[l].f) {
                        var t = k.n[l].f;
                        for(p = 0, q = t.length; q > p; p++)if (t[p] == b) {
                            t.splice(p, 1);
                            break;
                        }
                        !t.length && delete k.n[l].f;
                    }
                } else {
                    delete k.f;
                    for(l in k.n)k.n[e](l) && k.n[l].f && delete k.n[l].f;
                }
                k = k.n;
            }
            a: for(d = 0, i = s.length; i > d; d++){
                k = s[d];
                for(l in k.n[k.name].f)continue a;
                for(l in k.n[k.name].n)continue a;
                delete k.n[k.name];
            }
        }
    }, eve.once = function(a, b) {
        var c = function() {
            return eve.off(a, c), b.apply(this, arguments);
        };
        return eve.on(a, c);
    }, eve.version = d, eve.toString = function() {
        return "You are running Eve " + d;
    }, (0, $e9f4f9da5e4741bc$exports) ? $e9f4f9da5e4741bc$exports = eve : "function" == typeof define && define.amd ? define("eve", [], function() {
        return eve;
    }) : a.eve = eve;
}($e9f4f9da5e4741bc$exports), function(a, b) {
    if ("function" == typeof define && define.amd) define([
        "eve"
    ], function(c) {
        return b(a, c);
    });
    else {
        var c = (parcelRequire("1LXZS"));
        $e9f4f9da5e4741bc$exports = b(a, c);
    }
}(window || $e9f4f9da5e4741bc$exports, function(a, b) {
    var c = function(b) {
        var c, d = {}, e = a.requestAnimationFrame || a.webkitRequestAnimationFrame || a.mozRequestAnimationFrame || a.oRequestAnimationFrame || a.msRequestAnimationFrame || function(a) {
            return setTimeout(a, 16, (new Date).getTime()), !0;
        }, f = Array.isArray || function(a) {
            return a instanceof Array || "[object Array]" == Object.prototype.toString.call(a);
        }, g1 = 0, h = "M" + (+new Date).toString(36), i = function() {
            return h + (g1++).toString(36);
        }, j = Date.now || function() {
            return +new Date;
        }, k = function(a) {
            var b = this;
            if (null == a) return b.s;
            var c = b.s - a;
            b.b += b.dur * c, b.B += b.dur * c, b.s = a;
        }, l = function(a) {
            var b = this;
            return null == a ? b.spd : void (b.spd = a);
        }, m = function(a) {
            var b = this;
            return null == a ? b.dur : (b.s = b.s * a / b.dur, void (b.dur = a));
        }, n = function() {
            var a = this;
            delete d[a.id], a.update(), b("mina.stop." + a.id, a);
        }, o = function() {
            var a = this;
            a.pdif || (delete d[a.id], a.update(), a.pdif = a.get() - a.b);
        }, p = function() {
            var a = this;
            a.pdif && (a.b = a.get() - a.pdif, delete a.pdif, d[a.id] = a, r());
        }, q = function() {
            var a, b = this;
            if (f(b.start)) {
                a = [];
                for(var c = 0, d = b.start.length; d > c; c++)a[c] = +b.start[c] + (b.end[c] - b.start[c]) * b.easing(b.s);
            } else a = +b.start + (b.end - b.start) * b.easing(b.s);
            b.set(a);
        }, r = function(a) {
            if (!a) return void (c || (c = e(r)));
            var f = 0;
            for(var g1 in d)if (d.hasOwnProperty(g1)) {
                var h = d[g1], i = h.get();
                f++, h.s = (i - h.b) / (h.dur / h.spd), h.s >= 1 && (delete d[g1], h.s = 1, f--, function(a) {
                    setTimeout(function() {
                        b("mina.finish." + a.id, a);
                    });
                }(h)), h.update();
            }
            c = f ? e(r) : !1;
        }, s = function(a, b, c, e, f, g1, h) {
            var j = {
                id: i(),
                start: a,
                end: b,
                b: c,
                s: 0,
                dur: e - c,
                spd: 1,
                get: f,
                set: g1,
                easing: h || s.linear,
                status: k,
                speed: l,
                duration: m,
                stop: n,
                pause: o,
                resume: p,
                update: q
            };
            d[j.id] = j;
            var t, u = 0;
            for(t in d)if (d.hasOwnProperty(t) && (u++, 2 == u)) break;
            return 1 == u && r(), j;
        };
        return s.time = j, s.getById = function(a) {
            return d[a] || null;
        }, s.linear = function(a) {
            return a;
        }, s.easeout = function(a) {
            return Math.pow(a, 1.7);
        }, s.easein = function(a) {
            return Math.pow(a, .48);
        }, s.easeinout = function(a) {
            if (1 == a) return 1;
            if (0 == a) return 0;
            var b = .48 - a / 1.04, c = Math.sqrt(.1734 + b * b), d = c - b, e = Math.pow(Math.abs(d), 1 / 3) * (0 > d ? -1 : 1), f = -c - b, g1 = Math.pow(Math.abs(f), 1 / 3) * (0 > f ? -1 : 1), h = e + g1 + .5;
            return 3 * (1 - h) * h * h + h * h * h;
        }, s.backin = function(a) {
            if (1 == a) return 1;
            var b = 1.70158;
            return a * a * ((b + 1) * a - b);
        }, s.backout = function(a) {
            if (0 == a) return 0;
            a -= 1;
            var b = 1.70158;
            return a * a * ((b + 1) * a + b) + 1;
        }, s.elastic = function(a) {
            return a == !!a ? a : Math.pow(2, -10 * a) * Math.sin((a - .075) * (2 * Math.PI) / .3) + 1;
        }, s.bounce = function(a) {
            var b, c = 7.5625, d = 2.75;
            return 1 / d > a ? b = c * a * a : 2 / d > a ? (a -= 1.5 / d, b = c * a * a + .75) : 2.5 / d > a ? (a -= 2.25 / d, b = c * a * a + .9375) : (a -= 2.625 / d, b = c * a * a + .984375), b;
        }, a.mina = s, s;
    }("undefined" == typeof b ? function() {} : b), d = function(a) {
        function c(a, b) {
            if (a) {
                if (a.nodeType) return w(a);
                if (e(a, "array") && c.set) return c.set.apply(c, a);
                if (a instanceof s) return a;
                if (null == b) return a = y.doc.querySelector(String(a)), w(a);
            }
            return a = null == a ? "100%" : a, b = null == b ? "100%" : b, new v(a, b);
        }
        function d(a, b) {
            if (b) {
                if ("#text" == a && (a = y.doc.createTextNode(b.text || b["#text"] || "")), "#comment" == a && (a = y.doc.createComment(b.text || b["#text"] || "")), "string" == typeof a && (a = d(a)), "string" == typeof b) return 1 == a.nodeType ? "xlink:" == b.substring(0, 6) ? a.getAttributeNS(T, b.substring(6)) : "xml:" == b.substring(0, 4) ? a.getAttributeNS(U, b.substring(4)) : a.getAttribute(b) : "text" == b ? a.nodeValue : null;
                if (1 == a.nodeType) {
                    for(var c in b)if (b[z](c)) {
                        var e = A(b[c]);
                        e ? "xlink:" == c.substring(0, 6) ? a.setAttributeNS(T, c.substring(6), e) : "xml:" == c.substring(0, 4) ? a.setAttributeNS(U, c.substring(4), e) : a.setAttribute(c, e) : a.removeAttribute(c);
                    }
                } else "text" in b && (a.nodeValue = b.text);
            } else a = y.doc.createElementNS(U, a);
            return a;
        }
        function e(a, b) {
            return b = A.prototype.toLowerCase.call(b), "finite" == b ? isFinite(a) : "array" == b && (a instanceof Array || Array.isArray && Array.isArray(a)) ? !0 : "null" == b && null === a || b == typeof a && null !== a || "object" == b && a === Object(a) || J.call(a).slice(8, -1).toLowerCase() == b;
        }
        function f(a) {
            if ("function" == typeof a || Object(a) !== a) return a;
            var b = new a.constructor;
            for(var c in a)a[z](c) && (b[c] = f(a[c]));
            return b;
        }
        function h(a, b) {
            for(var c = 0, d = a.length; d > c; c++)if (a[c] === b) return a.push(a.splice(c, 1)[0]);
        }
        function i(a, b, c) {
            function d() {
                var e = Array.prototype.slice.call(arguments, 0), f = e.join("\u2400"), g1 = d.cache = d.cache || {}, i = d.count = d.count || [];
                return g1[z](f) ? (h(i, f), c ? c(g1[f]) : g1[f]) : (i.length >= 1e3 && delete g1[i.shift()], i.push(f), g1[f] = a.apply(b, e), c ? c(g1[f]) : g1[f]);
            }
            return d;
        }
        function j(a, b, c, d, e, f) {
            if (null == e) {
                var g1 = a - c, h = b - d;
                return g1 || h ? (180 + 180 * D.atan2(-h, -g1) / H + 360) % 360 : 0;
            }
            return j(a, b, e, f) - j(c, d, e, f);
        }
        function k(a) {
            return a % 360 * H / 180;
        }
        function l(a) {
            return 180 * a / H % 360;
        }
        function m(a) {
            var b = [];
            return a = a.replace(/(?:^|\s)(\w+)\(([^)]+)\)/g, function(a, c, d) {
                return d = d.split(/\s*,\s*|\s+/), "rotate" == c && 1 == d.length && d.push(0, 0), "scale" == c && (d.length > 2 ? d = d.slice(0, 2) : 2 == d.length && d.push(0, 0), 1 == d.length && d.push(d[0], 0, 0)), "skewX" == c ? b.push([
                    "m",
                    1,
                    0,
                    D.tan(k(d[0])),
                    1,
                    0,
                    0
                ]) : "skewY" == c ? b.push([
                    "m",
                    1,
                    D.tan(k(d[0])),
                    0,
                    1,
                    0,
                    0
                ]) : b.push([
                    c.charAt(0)
                ].concat(d)), a;
            }), b;
        }
        function n(a, b) {
            var d = aa(a), e = new c.Matrix;
            if (d) for(var f = 0, g1 = d.length; g1 > f; f++){
                var h, i, j, k, l, m = d[f], n = m.length, o = A(m[0]).toLowerCase(), p = m[0] != o, q = p ? e.invert() : 0;
                "t" == o && 2 == n ? e.translate(m[1], 0) : "t" == o && 3 == n ? p ? (h = q.x(0, 0), i = q.y(0, 0), j = q.x(m[1], m[2]), k = q.y(m[1], m[2]), e.translate(j - h, k - i)) : e.translate(m[1], m[2]) : "r" == o ? 2 == n ? (l = l || b, e.rotate(m[1], l.x + l.width / 2, l.y + l.height / 2)) : 4 == n && (p ? (j = q.x(m[2], m[3]), k = q.y(m[2], m[3]), e.rotate(m[1], j, k)) : e.rotate(m[1], m[2], m[3])) : "s" == o ? 2 == n || 3 == n ? (l = l || b, e.scale(m[1], m[n - 1], l.x + l.width / 2, l.y + l.height / 2)) : 4 == n ? p ? (j = q.x(m[2], m[3]), k = q.y(m[2], m[3]), e.scale(m[1], m[1], j, k)) : e.scale(m[1], m[1], m[2], m[3]) : 5 == n && (p ? (j = q.x(m[3], m[4]), k = q.y(m[3], m[4]), e.scale(m[1], m[2], j, k)) : e.scale(m[1], m[2], m[3], m[4])) : "m" == o && 7 == n && e.add(m[1], m[2], m[3], m[4], m[5], m[6]);
            }
            return e;
        }
        function o(a) {
            var b = a.node.ownerSVGElement && w(a.node.ownerSVGElement) || a.node.parentNode && w(a.node.parentNode) || c.select("svg") || c(0, 0), d = b.select("defs"), e = null == d ? !1 : d.node;
            return e || (e = u("defs", b.node).node), e;
        }
        function p(a) {
            return a.node.ownerSVGElement && w(a.node.ownerSVGElement) || c.select("svg");
        }
        function q(a, b, c) {
            function e(a) {
                if (null == a) return I;
                if (a == +a) return a;
                d(j, {
                    width: a
                });
                try {
                    return j.getBBox().width;
                } catch (b) {
                    return 0;
                }
            }
            function f(a) {
                if (null == a) return I;
                if (a == +a) return a;
                d(j, {
                    height: a
                });
                try {
                    return j.getBBox().height;
                } catch (b) {
                    return 0;
                }
            }
            function g1(d, e) {
                null == b ? i[d] = e(a.attr(d) || 0) : d == b && (i = e(null == c ? a.attr(d) || 0 : c));
            }
            var h = p(a).node, i = {}, j = h.querySelector(".svg---mgr");
            switch(j || (j = d("rect"), d(j, {
                x: -9000000000,
                y: -9000000000,
                width: 10,
                height: 10,
                "class": "svg---mgr",
                fill: "none"
            }), h.appendChild(j)), a.type){
                case "rect":
                    g1("rx", e), g1("ry", f);
                case "image":
                    g1("width", e), g1("height", f);
                case "text":
                    g1("x", e), g1("y", f);
                    break;
                case "circle":
                    g1("cx", e), g1("cy", f), g1("r", e);
                    break;
                case "ellipse":
                    g1("cx", e), g1("cy", f), g1("rx", e), g1("ry", f);
                    break;
                case "line":
                    g1("x1", e), g1("x2", e), g1("y1", f), g1("y2", f);
                    break;
                case "marker":
                    g1("refX", e), g1("markerWidth", e), g1("refY", f), g1("markerHeight", f);
                    break;
                case "radialGradient":
                    g1("fx", e), g1("fy", f);
                    break;
                case "tspan":
                    g1("dx", e), g1("dy", f);
                    break;
                default:
                    g1(b, e);
            }
            return h.removeChild(j), i;
        }
        function r(a) {
            e(a, "array") || (a = Array.prototype.slice.call(arguments, 0));
            for(var b = 0, c = 0, d = this.node; this[b];)delete this[b++];
            for(b = 0; b < a.length; b++)"set" == a[b].type ? a[b].forEach(function(a) {
                d.appendChild(a.node);
            }) : d.appendChild(a[b].node);
            var f = d.childNodes;
            for(b = 0; b < f.length; b++)this[c++] = w(f[b]);
            return this;
        }
        function s(a) {
            if (a.snap in V) return V[a.snap];
            var b;
            try {
                b = a.ownerSVGElement;
            } catch (c) {}
            this.node = a, b && (this.paper = new v(b)), this.type = a.tagName || a.nodeName;
            var d = this.id = S(this);
            if (this.anims = {}, this._ = {
                transform: []
            }, a.snap = d, V[d] = this, "g" == this.type && (this.add = r), this.type in {
                g: 1,
                mask: 1,
                pattern: 1,
                symbol: 1
            }) for(var e in v.prototype)v.prototype[z](e) && (this[e] = v.prototype[e]);
        }
        function t(a) {
            this.node = a;
        }
        function u(a, b) {
            var c = d(a);
            b.appendChild(c);
            var e = w(c);
            return e;
        }
        function v(a, b) {
            var c, e, f, g1 = v.prototype;
            if (a && a.tagName && "svg" == a.tagName.toLowerCase()) {
                if (a.snap in V) return V[a.snap];
                var h = a.ownerDocument;
                c = new s(a), e = a.getElementsByTagName("desc")[0], f = a.getElementsByTagName("defs")[0], e || (e = d("desc"), e.appendChild(h.createTextNode("Created with Snap")), c.node.appendChild(e)), f || (f = d("defs"), c.node.appendChild(f)), c.defs = f;
                for(var i in g1)g1[z](i) && (c[i] = g1[i]);
                c.paper = c.root = c;
            } else c = u("svg", y.doc.body), d(c.node, {
                height: b,
                version: 1.1,
                width: a,
                xmlns: U
            });
            return c;
        }
        function w(a) {
            return a ? a instanceof s || a instanceof t ? a : a.tagName && "svg" == a.tagName.toLowerCase() ? new v(a) : a.tagName && "object" == a.tagName.toLowerCase() && "image/svg+xml" == a.type ? new v(a.contentDocument.getElementsByTagName("svg")[0]) : new s(a) : a;
        }
        function x(a, b) {
            for(var c = 0, d = a.length; d > c; c++){
                var e = {
                    type: a[c].type,
                    attr: a[c].attr()
                }, f = a[c].children();
                b.push(e), f.length && x(f, e.childNodes = []);
            }
        }
        c.version = "0.5.1", c.toString = function() {
            return "Snap v" + this.version;
        }, c._ = {};
        var y = {
            win: a.window,
            doc: a.window.document
        };
        c._.glob = y;
        var z = "hasOwnProperty", A = String, B = parseFloat, C = parseInt, D = Math, E = D.max, F = D.min, G = D.abs, H = (D.pow, D.PI), I = (D.round, ""), J = Object.prototype.toString, K = /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\))\s*$/i, L = (c._.separator = /[,\s]+/, /[\s]*,[\s]*/), M = {
            hs: 1,
            rg: 1
        }, N = /([a-z])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/gi, O = /([rstm])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/gi, P = /(-?\d*\.?\d*(?:e[\-+]?\d+)?)[\s]*,?[\s]*/gi, Q = 0, R = "S" + (+new Date).toString(36), S = function(a) {
            return (a && a.type ? a.type : I) + R + (Q++).toString(36);
        }, T = "http://www.w3.org/1999/xlink", U = "http://www.w3.org/2000/svg", V = {};
        c.url = function(a) {
            return "url('#" + a + "')";
        };
        c._.$ = d, c._.id = S, c.format = function() {
            var a = /\{([^\}]+)\}/g, b = /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g, c = function(a, c, d) {
                var e = d;
                return c.replace(b, function(a, b, c, d, f) {
                    b = b || d, e && (b in e && (e = e[b]), "function" == typeof e && f && (e = e()));
                }), e = (null == e || e == d ? a : e) + "";
            };
            return function(b, d) {
                return A(b).replace(a, function(a, b) {
                    return c(a, b, d);
                });
            };
        }(), c._.clone = f, c._.cacher = i, c.rad = k, c.deg = l, c.sin = function(a) {
            return D.sin(c.rad(a));
        }, c.tan = function(a) {
            return D.tan(c.rad(a));
        }, c.cos = function(a) {
            return D.cos(c.rad(a));
        }, c.asin = function(a) {
            return c.deg(D.asin(a));
        }, c.acos = function(a) {
            return c.deg(D.acos(a));
        }, c.atan = function(a) {
            return c.deg(D.atan(a));
        }, c.atan2 = function(a) {
            return c.deg(D.atan2(a));
        }, c.angle = j, c.len = function(a, b, d, e) {
            return Math.sqrt(c.len2(a, b, d, e));
        }, c.len2 = function(a, b, c, d) {
            return (a - c) * (a - c) + (b - d) * (b - d);
        }, c.closestPoint = function(a, b, c) {
            function d(a) {
                var d = a.x - b, e = a.y - c;
                return d * d + e * e;
            }
            for(var e, f, g1, h, i = a.node, j = i.getTotalLength(), k = j / i.pathSegList.numberOfItems * .125, l = 1 / 0, m = 0; j >= m; m += k)(h = d(g1 = i.getPointAtLength(m))) < l && (e = g1, f = m, l = h);
            for(k *= .5; k > .5;){
                var n, o, p, q, r, s;
                (p = f - k) >= 0 && (r = d(n = i.getPointAtLength(p))) < l ? (e = n, f = p, l = r) : (q = f + k) <= j && (s = d(o = i.getPointAtLength(q))) < l ? (e = o, f = q, l = s) : k *= .5;
            }
            return e = {
                x: e.x,
                y: e.y,
                length: f,
                distance: Math.sqrt(l)
            };
        }, c.is = e, c.snapTo = function(a, b, c) {
            if (c = e(c, "finite") ? c : 10, e(a, "array")) {
                for(var d = a.length; d--;)if (G(a[d] - b) <= c) return a[d];
            } else {
                a = +a;
                var f = b % a;
                if (c > f) return b - f;
                if (f > a - c) return b - f + a;
            }
            return b;
        }, c.getRGB = i(function(a) {
            if (!a || (a = A(a)).indexOf("-") + 1) return {
                r: -1,
                g: -1,
                b: -1,
                hex: "none",
                error: 1,
                toString: Z
            };
            if ("none" == a) return {
                r: -1,
                g: -1,
                b: -1,
                hex: "none",
                toString: Z
            };
            if (!(M[z](a.toLowerCase().substring(0, 2)) || "#" == a.charAt()) && (a = W(a)), !a) return {
                r: -1,
                g: -1,
                b: -1,
                hex: "none",
                error: 1,
                toString: Z
            };
            var b, d, f, g1, h, i, j = a.match(K);
            return j ? (j[2] && (f = C(j[2].substring(5), 16), d = C(j[2].substring(3, 5), 16), b = C(j[2].substring(1, 3), 16)), j[3] && (f = C((h = j[3].charAt(3)) + h, 16), d = C((h = j[3].charAt(2)) + h, 16), b = C((h = j[3].charAt(1)) + h, 16)), j[4] && (i = j[4].split(L), b = B(i[0]), "%" == i[0].slice(-1) && (b *= 2.55), d = B(i[1]), "%" == i[1].slice(-1) && (d *= 2.55), f = B(i[2]), "%" == i[2].slice(-1) && (f *= 2.55), "rgba" == j[1].toLowerCase().slice(0, 4) && (g1 = B(i[3])), i[3] && "%" == i[3].slice(-1) && (g1 /= 100)), j[5] ? (i = j[5].split(L), b = B(i[0]), "%" == i[0].slice(-1) && (b /= 100), d = B(i[1]), "%" == i[1].slice(-1) && (d /= 100), f = B(i[2]), "%" == i[2].slice(-1) && (f /= 100), ("deg" == i[0].slice(-3) || "\xb0" == i[0].slice(-1)) && (b /= 360), "hsba" == j[1].toLowerCase().slice(0, 4) && (g1 = B(i[3])), i[3] && "%" == i[3].slice(-1) && (g1 /= 100), c.hsb2rgb(b, d, f, g1)) : j[6] ? (i = j[6].split(L), b = B(i[0]), "%" == i[0].slice(-1) && (b /= 100), d = B(i[1]), "%" == i[1].slice(-1) && (d /= 100), f = B(i[2]), "%" == i[2].slice(-1) && (f /= 100), ("deg" == i[0].slice(-3) || "\xb0" == i[0].slice(-1)) && (b /= 360), "hsla" == j[1].toLowerCase().slice(0, 4) && (g1 = B(i[3])), i[3] && "%" == i[3].slice(-1) && (g1 /= 100), c.hsl2rgb(b, d, f, g1)) : (b = F(D.round(b), 255), d = F(D.round(d), 255), f = F(D.round(f), 255), g1 = F(E(g1, 0), 1), j = {
                r: b,
                g: d,
                b: f,
                toString: Z
            }, j.hex = "#" + (16777216 | f | d << 8 | b << 16).toString(16).slice(1), j.opacity = e(g1, "finite") ? g1 : 1, j)) : {
                r: -1,
                g: -1,
                b: -1,
                hex: "none",
                error: 1,
                toString: Z
            };
        }, c), c.hsb = i(function(a, b, d) {
            return c.hsb2rgb(a, b, d).hex;
        }), c.hsl = i(function(a, b, d) {
            return c.hsl2rgb(a, b, d).hex;
        }), c.rgb = i(function(a, b, c, d) {
            if (e(d, "finite")) {
                var f = D.round;
                return "rgba(" + [
                    f(a),
                    f(b),
                    f(c),
                    +d.toFixed(2)
                ] + ")";
            }
            return "#" + (16777216 | c | b << 8 | a << 16).toString(16).slice(1);
        });
        var W = function(a) {
            var b = y.doc.getElementsByTagName("head")[0] || y.doc.getElementsByTagName("svg")[0], c = "rgb(255, 0, 0)";
            return (W = i(function(a) {
                if ("red" == a.toLowerCase()) return c;
                b.style.color = c, b.style.color = a;
                var d = y.doc.defaultView.getComputedStyle(b, I).getPropertyValue("color");
                return d == c ? null : d;
            }))(a);
        }, X = function() {
            return "hsb(" + [
                this.h,
                this.s,
                this.b
            ] + ")";
        }, Y = function() {
            return "hsl(" + [
                this.h,
                this.s,
                this.l
            ] + ")";
        }, Z = function() {
            return 1 == this.opacity || null == this.opacity ? this.hex : "rgba(" + [
                this.r,
                this.g,
                this.b,
                this.opacity
            ] + ")";
        }, $ = function(a, b, d) {
            if (null == b && e(a, "object") && "r" in a && "g" in a && "b" in a && (d = a.b, b = a.g, a = a.r), null == b && e(a, string)) {
                var f = c.getRGB(a);
                a = f.r, b = f.g, d = f.b;
            }
            return (a > 1 || b > 1 || d > 1) && (a /= 255, b /= 255, d /= 255), [
                a,
                b,
                d
            ];
        }, _ = function(a, b, d, f) {
            a = D.round(255 * a), b = D.round(255 * b), d = D.round(255 * d);
            var g1 = {
                r: a,
                g: b,
                b: d,
                opacity: e(f, "finite") ? f : 1,
                hex: c.rgb(a, b, d),
                toString: Z
            };
            return e(f, "finite") && (g1.opacity = f), g1;
        };
        c.color = function(a) {
            var b;
            return e(a, "object") && "h" in a && "s" in a && "b" in a ? (b = c.hsb2rgb(a), a.r = b.r, a.g = b.g, a.b = b.b, a.opacity = 1, a.hex = b.hex) : e(a, "object") && "h" in a && "s" in a && "l" in a ? (b = c.hsl2rgb(a), a.r = b.r, a.g = b.g, a.b = b.b, a.opacity = 1, a.hex = b.hex) : (e(a, "string") && (a = c.getRGB(a)), e(a, "object") && "r" in a && "g" in a && "b" in a && !("error" in a) ? (b = c.rgb2hsl(a), a.h = b.h, a.s = b.s, a.l = b.l, b = c.rgb2hsb(a), a.v = b.b) : (a = {
                hex: "none"
            }, a.r = a.g = a.b = a.h = a.s = a.v = a.l = -1, a.error = 1)), a.toString = Z, a;
        }, c.hsb2rgb = function(a, b, c, d) {
            e(a, "object") && "h" in a && "s" in a && "b" in a && (c = a.b, b = a.s, d = a.o, a = a.h), a *= 360;
            var f, g1, h, i, j;
            return a = a % 360 / 60, j = c * b, i = j * (1 - G(a % 2 - 1)), f = g1 = h = c - j, a = ~~a, f += [
                j,
                i,
                0,
                0,
                i,
                j
            ][a], g1 += [
                i,
                j,
                j,
                i,
                0,
                0
            ][a], h += [
                0,
                0,
                i,
                j,
                j,
                i
            ][a], _(f, g1, h, d);
        }, c.hsl2rgb = function(a, b, c, d) {
            e(a, "object") && "h" in a && "s" in a && "l" in a && (c = a.l, b = a.s, a = a.h), (a > 1 || b > 1 || c > 1) && (a /= 360, b /= 100, c /= 100), a *= 360;
            var f, g1, h, i, j;
            return a = a % 360 / 60, j = 2 * b * (.5 > c ? c : 1 - c), i = j * (1 - G(a % 2 - 1)), f = g1 = h = c - j / 2, a = ~~a, f += [
                j,
                i,
                0,
                0,
                i,
                j
            ][a], g1 += [
                i,
                j,
                j,
                i,
                0,
                0
            ][a], h += [
                0,
                0,
                i,
                j,
                j,
                i
            ][a], _(f, g1, h, d);
        }, c.rgb2hsb = function(a, b, c) {
            c = $(a, b, c), a = c[0], b = c[1], c = c[2];
            var d, e, f, g1;
            return f = E(a, b, c), g1 = f - F(a, b, c), d = 0 == g1 ? null : f == a ? (b - c) / g1 : f == b ? (c - a) / g1 + 2 : (a - b) / g1 + 4, d = (d + 360) % 6 * 60 / 360, e = 0 == g1 ? 0 : g1 / f, {
                h: d,
                s: e,
                b: f,
                toString: X
            };
        }, c.rgb2hsl = function(a, b, c) {
            c = $(a, b, c), a = c[0], b = c[1], c = c[2];
            var d, e, f, g1, h, i;
            return g1 = E(a, b, c), h = F(a, b, c), i = g1 - h, d = 0 == i ? null : g1 == a ? (b - c) / i : g1 == b ? (c - a) / i + 2 : (a - b) / i + 4, d = (d + 360) % 6 * 60 / 360, f = (g1 + h) / 2, e = 0 == i ? 0 : .5 > f ? i / (2 * f) : i / (2 - 2 * f), {
                h: d,
                s: e,
                l: f,
                toString: Y
            };
        }, c.parsePathString = function(a) {
            if (!a) return null;
            var b = c.path(a);
            if (b.arr) return c.path.clone(b.arr);
            var d = {
                a: 7,
                c: 6,
                o: 2,
                h: 1,
                l: 2,
                m: 2,
                r: 4,
                q: 4,
                s: 4,
                t: 2,
                v: 1,
                u: 3,
                z: 0
            }, f = [];
            return e(a, "array") && e(a[0], "array") && (f = c.path.clone(a)), f.length || A(a).replace(N, function(a, b, c) {
                var e = [], g1 = b.toLowerCase();
                if (c.replace(P, function(a, b) {
                    b && e.push(+b);
                }), "m" == g1 && e.length > 2 && (f.push([
                    b
                ].concat(e.splice(0, 2))), g1 = "l", b = "m" == b ? "l" : "L"), "o" == g1 && 1 == e.length && f.push([
                    b,
                    e[0]
                ]), "r" == g1) f.push([
                    b
                ].concat(e));
                else for(; e.length >= d[g1] && (f.push([
                    b
                ].concat(e.splice(0, d[g1]))), d[g1]););
            }), f.toString = c.path.toString, b.arr = c.path.clone(f), f;
        };
        var aa = c.parseTransformString = function(a) {
            if (!a) return null;
            var b = [];
            return e(a, "array") && e(a[0], "array") && (b = c.path.clone(a)), b.length || A(a).replace(O, function(a, c, d) {
                var e = [];
                c.toLowerCase();
                d.replace(P, function(a, b) {
                    b && e.push(+b);
                }), b.push([
                    c
                ].concat(e));
            }), b.toString = c.path.toString, b;
        };
        c._.svgTransform2string = m, c._.rgTransform = /^[a-z][\s]*-?\.?\d/i, c._.transform2matrix = n, c._unit2px = q;
        y.doc.contains || y.doc.compareDocumentPosition;
        c._.getSomeDefs = o, c._.getSomeSVG = p, c.select = function(a) {
            return a = A(a).replace(/([^\\]):/g, "$1\\:"), w(y.doc.querySelector(a));
        }, c.selectAll = function(a) {
            for(var b = y.doc.querySelectorAll(a), d = (c.set || Array)(), e = 0; e < b.length; e++)d.push(w(b[e]));
            return d;
        }, setInterval(function() {
            for(var a in V)if (V[z](a)) {
                var b = V[a], c = b.node;
                ("svg" != b.type && !c.ownerSVGElement || "svg" == b.type && (!c.parentNode || "ownerSVGElement" in c.parentNode && !c.ownerSVGElement)) && delete V[a];
            }
        }, 1e4), s.prototype.attr = function(a, c) {
            var d = this, f = d.node;
            if (!a) {
                if (1 != f.nodeType) return {
                    text: f.nodeValue
                };
                for(var g1 = f.attributes, h = {}, i = 0, j = g1.length; j > i; i++)h[g1[i].nodeName] = g1[i].nodeValue;
                return h;
            }
            if (e(a, "string")) {
                if (!(arguments.length > 1)) return b("snap.util.getattr." + a, d).firstDefined();
                var k = {};
                k[a] = c, a = k;
            }
            for(var l in a)a[z](l) && b("snap.util.attr." + l, d, a[l]);
            return d;
        }, c.parse = function(a) {
            var b = y.doc.createDocumentFragment(), c = !0, d = y.doc.createElement("div");
            if (a = A(a), a.match(/^\s*<\s*svg(?:\s|>)/) || (a = "<svg>" + a + "</svg>", c = !1), d.innerHTML = a, a = d.getElementsByTagName("svg")[0]) {
                if (c) b = a;
                else for(; a.firstChild;)b.appendChild(a.firstChild);
            }
            return new t(b);
        }, c.fragment = function() {
            for(var a = Array.prototype.slice.call(arguments, 0), b = y.doc.createDocumentFragment(), d = 0, e = a.length; e > d; d++){
                var f = a[d];
                f.node && f.node.nodeType && b.appendChild(f.node), f.nodeType && b.appendChild(f), "string" == typeof f && b.appendChild(c.parse(f).node);
            }
            return new t(b);
        }, c._.make = u, c._.wrap = w, v.prototype.el = function(a, b) {
            var c = u(a, this.node);
            return b && c.attr(b), c;
        }, s.prototype.children = function() {
            for(var a = [], b = this.node.childNodes, d = 0, e = b.length; e > d; d++)a[d] = c(b[d]);
            return a;
        }, s.prototype.toJSON = function() {
            var a = [];
            return x([
                this
            ], a), a[0];
        }, b.on("snap.util.getattr", function() {
            var a = b.nt();
            a = a.substring(a.lastIndexOf(".") + 1);
            var c = a.replace(/[A-Z]/g, function(a) {
                return "-" + a.toLowerCase();
            });
            return ba[z](c) ? this.node.ownerDocument.defaultView.getComputedStyle(this.node, null).getPropertyValue(c) : d(this.node, a);
        });
        var ba = {
            "alignment-baseline": 0,
            "baseline-shift": 0,
            clip: 0,
            "clip-path": 0,
            "clip-rule": 0,
            color: 0,
            "color-interpolation": 0,
            "color-interpolation-filters": 0,
            "color-profile": 0,
            "color-rendering": 0,
            cursor: 0,
            direction: 0,
            display: 0,
            "dominant-baseline": 0,
            "enable-background": 0,
            fill: 0,
            "fill-opacity": 0,
            "fill-rule": 0,
            filter: 0,
            "flood-color": 0,
            "flood-opacity": 0,
            font: 0,
            "font-family": 0,
            "font-size": 0,
            "font-size-adjust": 0,
            "font-stretch": 0,
            "font-style": 0,
            "font-variant": 0,
            "font-weight": 0,
            "glyph-orientation-horizontal": 0,
            "glyph-orientation-vertical": 0,
            "image-rendering": 0,
            kerning: 0,
            "letter-spacing": 0,
            "lighting-color": 0,
            marker: 0,
            "marker-end": 0,
            "marker-mid": 0,
            "marker-start": 0,
            mask: 0,
            opacity: 0,
            overflow: 0,
            "pointer-events": 0,
            "shape-rendering": 0,
            "stop-color": 0,
            "stop-opacity": 0,
            stroke: 0,
            "stroke-dasharray": 0,
            "stroke-dashoffset": 0,
            "stroke-linecap": 0,
            "stroke-linejoin": 0,
            "stroke-miterlimit": 0,
            "stroke-opacity": 0,
            "stroke-width": 0,
            "text-anchor": 0,
            "text-decoration": 0,
            "text-rendering": 0,
            "unicode-bidi": 0,
            visibility: 0,
            "word-spacing": 0,
            "writing-mode": 0
        };
        b.on("snap.util.attr", function(a) {
            var c = b.nt(), e = {};
            c = c.substring(c.lastIndexOf(".") + 1), e[c] = a;
            var f = c.replace(/-(\w)/gi, function(a, b) {
                return b.toUpperCase();
            }), g1 = c.replace(/[A-Z]/g, function(a) {
                return "-" + a.toLowerCase();
            });
            ba[z](g1) ? this.node.style[f] = null == a ? I : a : d(this.node, e);
        }), v.prototype, c.ajax = function(a, c, d, f) {
            var g1 = new XMLHttpRequest, h = S();
            if (g1) {
                if (e(c, "function")) f = d, d = c, c = null;
                else if (e(c, "object")) {
                    var i = [];
                    for(var j in c)c.hasOwnProperty(j) && i.push(encodeURIComponent(j) + "=" + encodeURIComponent(c[j]));
                    c = i.join("&");
                }
                return g1.open(c ? "POST" : "GET", a, !0), c && (g1.setRequestHeader("X-Requested-With", "XMLHttpRequest"), g1.setRequestHeader("Content-type", "application/x-www-form-urlencoded")), d && (b.once("snap.ajax." + h + ".0", d), b.once("snap.ajax." + h + ".200", d), b.once("snap.ajax." + h + ".304", d)), g1.onreadystatechange = function() {
                    4 == g1.readyState && b("snap.ajax." + h + "." + g1.status, f, g1);
                }, 4 == g1.readyState ? g1 : (g1.send(c), g1);
            }
        }, c.load = function(a, b, d) {
            c.ajax(a, function(a) {
                var e = c.parse(a.responseText);
                d ? b.call(d, e) : b(e);
            });
        };
        var ca = function(a) {
            var b = a.getBoundingClientRect(), c = a.ownerDocument, d = c.body, e = c.documentElement, f = e.clientTop || d.clientTop || 0, h = e.clientLeft || d.clientLeft || 0, i = b.top + (g.win.pageYOffset || e.scrollTop || d.scrollTop) - f, j = b.left + (g.win.pageXOffset || e.scrollLeft || d.scrollLeft) - h;
            return {
                y: i,
                x: j
            };
        };
        return c.getElementByPoint = function(a, b) {
            var c = this, d = (c.canvas, y.doc.elementFromPoint(a, b));
            if (y.win.opera && "svg" == d.tagName) {
                var e = ca(d), f = d.createSVGRect();
                f.x = a - e.x, f.y = b - e.y, f.width = f.height = 1;
                var g1 = d.getIntersectionList(f, null);
                g1.length && (d = g1[g1.length - 1]);
            }
            return d ? w(d) : null;
        }, c.plugin = function(a) {
            a(c, s, v, y, t);
        }, y.win.Snap = c, c;
    }(a || this);
    return d.plugin(function(c, d, e, f, g1) {
        function h(a, b) {
            if (null == b) {
                var d = !0;
                if (b = "linearGradient" == a.type || "radialGradient" == a.type ? a.node.getAttribute("gradientTransform") : "pattern" == a.type ? a.node.getAttribute("patternTransform") : a.node.getAttribute("transform"), !b) return new c.Matrix;
                b = c._.svgTransform2string(b);
            } else b = c._.rgTransform.test(b) ? m(b).replace(/\.{3}|\u2026/g, a._.transform || "") : c._.svgTransform2string(b), l(b, "array") && (b = c.path ? c.path.toString.call(b) : m(b)), a._.transform = b;
            var e = c._.transform2matrix(b, a.getBBox(1));
            return d ? e : void (a.matrix = e);
        }
        function i(a) {
            function b(a, b) {
                var d = o(a.node, b);
                d = d && d.match(g1), d = d && d[2], d && "#" == d.charAt() && (d = d.substring(1), d && (i[d] = (i[d] || []).concat(function(d) {
                    var e = {};
                    e[b] = c.url(d), o(a.node, e);
                })));
            }
            function d(a) {
                var b = o(a.node, "xlink:href");
                b && "#" == b.charAt() && (b = b.substring(1), b && (i[b] = (i[b] || []).concat(function(b) {
                    a.attr("xlink:href", "#" + b);
                })));
            }
            for(var e, f = a.selectAll("*"), g1 = /^\s*url\(("|'|)(.*)\1\)\s*$/, h = [], i = {}, j = 0, k = f.length; k > j; j++){
                e = f[j], b(e, "fill"), b(e, "stroke"), b(e, "filter"), b(e, "mask"), b(e, "clip-path"), d(e);
                var l = o(e.node, "id");
                l && (o(e.node, {
                    id: e.id
                }), h.push({
                    old: l,
                    id: e.id
                }));
            }
            for(j = 0, k = h.length; k > j; j++){
                var m = i[h[j].old];
                if (m) for(var n = 0, p = m.length; p > n; n++)m[n](h[j].id);
            }
        }
        function j(a) {
            return function() {
                var b = a ? "<" + this.type : "", c = this.node.attributes, d = this.node.childNodes;
                if (a) for(var e = 0, f = c.length; f > e; e++)b += " " + c[e].name + '="' + c[e].value.replace(/"/g, '\\"') + '"';
                if (d.length) {
                    for(a && (b += ">"), e = 0, f = d.length; f > e; e++)3 == d[e].nodeType ? b += d[e].nodeValue : 1 == d[e].nodeType && (b += s(d[e]).toString());
                    a && (b += "</" + this.type + ">");
                } else a && (b += "/>");
                return b;
            };
        }
        var k = d.prototype, l = c.is, m = String, n = c._unit2px, o = c._.$, p = c._.make, q = c._.getSomeDefs, r = "hasOwnProperty", s = c._.wrap;
        k.getBBox = function(a) {
            if ("tspan" == this.type) return c._.box(this.node.getClientRects().item(0));
            if (!c.Matrix || !c.path) return this.node.getBBox();
            var b = this, d = new c.Matrix;
            if (b.removed) return c._.box();
            for(; "use" == b.type;)if (a || (d = d.add(b.transform().localMatrix.translate(b.attr("x") || 0, b.attr("y") || 0))), b.original) b = b.original;
            else {
                var e = b.attr("xlink:href");
                b = b.original = b.node.ownerDocument.getElementById(e.substring(e.indexOf("#") + 1));
            }
            var f = b._, g1 = c.path.get[b.type] || c.path.get.deflt;
            try {
                return a ? (f.bboxwt = g1 ? c.path.getBBox(b.realPath = g1(b)) : c._.box(b.node.getBBox()), c._.box(f.bboxwt)) : (b.realPath = g1(b), b.matrix = b.transform().localMatrix, f.bbox = c.path.getBBox(c.path.map(b.realPath, d.add(b.matrix))), c._.box(f.bbox));
            } catch (h) {
                return c._.box();
            }
        };
        var t = function() {
            return this.string;
        };
        k.transform = function(a) {
            var b = this._;
            if (null == a) {
                for(var d, e = this, f = new c.Matrix(this.node.getCTM()), g1 = h(this), i = [
                    g1
                ], j = new c.Matrix, k = g1.toTransformString(), l = m(g1) == m(this.matrix) ? m(b.transform) : k; "svg" != e.type && (e = e.parent());)i.push(h(e));
                for(d = i.length; d--;)j.add(i[d]);
                return {
                    string: l,
                    globalMatrix: f,
                    totalMatrix: j,
                    localMatrix: g1,
                    diffMatrix: f.clone().add(g1.invert()),
                    global: f.toTransformString(),
                    total: j.toTransformString(),
                    local: k,
                    toString: t
                };
            }
            return a instanceof c.Matrix ? (this.matrix = a, this._.transform = a.toTransformString()) : h(this, a), this.node && ("linearGradient" == this.type || "radialGradient" == this.type ? o(this.node, {
                gradientTransform: this.matrix
            }) : "pattern" == this.type ? o(this.node, {
                patternTransform: this.matrix
            }) : o(this.node, {
                transform: this.matrix
            })), this;
        }, k.parent = function() {
            return s(this.node.parentNode);
        }, k.append = k.add = function(a) {
            if (a) {
                if ("set" == a.type) {
                    var b = this;
                    return a.forEach(function(a) {
                        b.add(a);
                    }), this;
                }
                a = s(a), this.node.appendChild(a.node), a.paper = this.paper;
            }
            return this;
        }, k.appendTo = function(a) {
            return a && (a = s(a), a.append(this)), this;
        }, k.prepend = function(a) {
            if (a) {
                if ("set" == a.type) {
                    var b, c = this;
                    return a.forEach(function(a) {
                        b ? b.after(a) : c.prepend(a), b = a;
                    }), this;
                }
                a = s(a);
                var d = a.parent();
                this.node.insertBefore(a.node, this.node.firstChild), this.add && this.add(), a.paper = this.paper, this.parent() && this.parent().add(), d && d.add();
            }
            return this;
        }, k.prependTo = function(a) {
            return a = s(a), a.prepend(this), this;
        }, k.before = function(a) {
            if ("set" == a.type) {
                var b = this;
                return a.forEach(function(a) {
                    var c = a.parent();
                    b.node.parentNode.insertBefore(a.node, b.node), c && c.add();
                }), this.parent().add(), this;
            }
            a = s(a);
            var c = a.parent();
            return this.node.parentNode.insertBefore(a.node, this.node), this.parent() && this.parent().add(), c && c.add(), a.paper = this.paper, this;
        }, k.after = function(a) {
            a = s(a);
            var b = a.parent();
            return this.node.nextSibling ? this.node.parentNode.insertBefore(a.node, this.node.nextSibling) : this.node.parentNode.appendChild(a.node), this.parent() && this.parent().add(), b && b.add(), a.paper = this.paper, this;
        }, k.insertBefore = function(a) {
            a = s(a);
            var b = this.parent();
            return a.node.parentNode.insertBefore(this.node, a.node), this.paper = a.paper, b && b.add(), a.parent() && a.parent().add(), this;
        }, k.insertAfter = function(a) {
            a = s(a);
            var b = this.parent();
            return a.node.parentNode.insertBefore(this.node, a.node.nextSibling), this.paper = a.paper, b && b.add(), a.parent() && a.parent().add(), this;
        }, k.remove = function() {
            var a = this.parent();
            return this.node.parentNode && this.node.parentNode.removeChild(this.node), delete this.paper, this.removed = !0, a && a.add(), this;
        }, k.select = function(a) {
            return s(this.node.querySelector(a));
        }, k.selectAll = function(a) {
            for(var b = this.node.querySelectorAll(a), d = (c.set || Array)(), e = 0; e < b.length; e++)d.push(s(b[e]));
            return d;
        }, k.asPX = function(a, b) {
            return null == b && (b = this.attr(a)), +n(this, a, b);
        }, k.use = function() {
            var a, b = this.node.id;
            return b || (b = this.id, o(this.node, {
                id: b
            })), a = "linearGradient" == this.type || "radialGradient" == this.type || "pattern" == this.type ? p(this.type, this.node.parentNode) : p("use", this.node.parentNode), o(a.node, {
                "xlink:href": "#" + b
            }), a.original = this, a;
        }, k.clone = function() {
            var a = s(this.node.cloneNode(!0));
            return o(a.node, "id") && o(a.node, {
                id: a.id
            }), i(a), a.insertAfter(this), a;
        }, k.toDefs = function() {
            var a = q(this);
            return a.appendChild(this.node), this;
        }, k.pattern = k.toPattern = function(a, b, c, d) {
            var e = p("pattern", q(this));
            return null == a && (a = this.getBBox()), l(a, "object") && "x" in a && (b = a.y, c = a.width, d = a.height, a = a.x), o(e.node, {
                x: a,
                y: b,
                width: c,
                height: d,
                patternUnits: "userSpaceOnUse",
                id: e.id,
                viewBox: [
                    a,
                    b,
                    c,
                    d
                ].join(" ")
            }), e.node.appendChild(this.node), e;
        }, k.marker = function(a, b, c, d, e, f) {
            var g1 = p("marker", q(this));
            return null == a && (a = this.getBBox()), l(a, "object") && "x" in a && (b = a.y, c = a.width, d = a.height, e = a.refX || a.cx, f = a.refY || a.cy, a = a.x), o(g1.node, {
                viewBox: [
                    a,
                    b,
                    c,
                    d
                ].join(" "),
                markerWidth: c,
                markerHeight: d,
                orient: "auto",
                refX: e || 0,
                refY: f || 0,
                id: g1.id
            }), g1.node.appendChild(this.node), g1;
        };
        var u = {};
        k.data = function(a, d) {
            var e = u[this.id] = u[this.id] || {};
            if (0 == arguments.length) return b("snap.data.get." + this.id, this, e, null), e;
            if (1 == arguments.length) {
                if (c.is(a, "object")) {
                    for(var f in a)a[r](f) && this.data(f, a[f]);
                    return this;
                }
                return b("snap.data.get." + this.id, this, e[a], a), e[a];
            }
            return e[a] = d, b("snap.data.set." + this.id, this, d, a), this;
        }, k.removeData = function(a) {
            return null == a ? u[this.id] = {} : u[this.id] && delete u[this.id][a], this;
        }, k.outerSVG = k.toString = j(1), k.innerSVG = j(), k.toDataURL = function() {
            if (a && a.btoa) {
                var b = this.getBBox(), d = c.format('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="{width}" height="{height}" viewBox="{x} {y} {width} {height}">{contents}</svg>', {
                    x: +b.x.toFixed(3),
                    y: +b.y.toFixed(3),
                    width: +b.width.toFixed(3),
                    height: +b.height.toFixed(3),
                    contents: this.outerSVG()
                });
                return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(d)));
            }
        }, g1.prototype.select = k.select, g1.prototype.selectAll = k.selectAll;
    }), d.plugin(function(a, d, e, f, g1) {
        function h(a, b, c) {
            return function(d) {
                var e = d.slice(a, b);
                return 1 == e.length && (e = e[0]), c ? c(e) : e;
            };
        }
        var i = d.prototype, j = a.is, k = String, l = "hasOwnProperty", m = function(a, b, d, e) {
            "function" != typeof d || d.length || (e = d, d = c.linear), this.attr = a, this.dur = b, d && (this.easing = d), e && (this.callback = e);
        };
        a._.Animation = m, a.animation = function(a, b, c, d) {
            return new m(a, b, c, d);
        }, i.inAnim = function() {
            var a = this, b = [];
            for(var c in a.anims)a.anims[l](c) && !function(a) {
                b.push({
                    anim: new m(a._attrs, a.dur, a.easing, a._callback),
                    mina: a,
                    curStatus: a.status(),
                    status: function(b) {
                        return a.status(b);
                    },
                    stop: function() {
                        a.stop();
                    }
                });
            }(a.anims[c]);
            return b;
        }, a.animate = function(a, d, e, f, g1, h) {
            "function" != typeof g1 || g1.length || (h = g1, g1 = c.linear);
            var i = c.time(), j = c(a, d, i, i + f, c.time, e, g1);
            return h && b.once("mina.finish." + j.id, h), j;
        }, i.stop = function() {
            for(var a = this.inAnim(), b = 0, c = a.length; c > b; b++)a[b].stop();
            return this;
        }, i.animate = function(a, d, e, f) {
            "function" != typeof e || e.length || (f = e, e = c.linear), a instanceof m && (f = a.callback, e = a.easing, d = a.dur, a = a.attr);
            var g1, i, n, o, p = [], q = [], r = {}, s = this;
            for(var t in a)if (a[l](t)) {
                s.equal ? (o = s.equal(t, k(a[t])), g1 = o.from, i = o.to, n = o.f) : (g1 = +s.attr(t), i = +a[t]);
                var u = j(g1, "array") ? g1.length : 1;
                r[t] = h(p.length, p.length + u, n), p = p.concat(g1), q = q.concat(i);
            }
            var v = c.time(), w = c(p, q, v, v + d, c.time, function(a) {
                var b = {};
                for(var c in r)r[l](c) && (b[c] = r[c](a));
                s.attr(b);
            }, e);
            return s.anims[w.id] = w, w._attrs = a, w._callback = f, b("snap.animcreated." + s.id, w), b.once("mina.finish." + w.id, function() {
                b.off("mina.*." + w.id), delete s.anims[w.id], f && f.call(s);
            }), b.once("mina.stop." + w.id, function() {
                b.off("mina.*." + w.id), delete s.anims[w.id];
            }), s;
        };
    }), d.plugin(function(a, b, c, d, e) {
        function f(a, b, c, d, e, f) {
            return null == b && "[object SVGMatrix]" == g1.call(a) ? (this.a = a.a, this.b = a.b, this.c = a.c, this.d = a.d, this.e = a.e, void (this.f = a.f)) : void (null != a ? (this.a = +a, this.b = +b, this.c = +c, this.d = +d, this.e = +e, this.f = +f) : (this.a = 1, this.b = 0, this.c = 0, this.d = 1, this.e = 0, this.f = 0));
        }
        var g1 = Object.prototype.toString, h = String, i = Math, j = "";
        !function(b) {
            function c(a) {
                return a[0] * a[0] + a[1] * a[1];
            }
            function d(a) {
                var b = i.sqrt(c(a));
                a[0] && (a[0] /= b), a[1] && (a[1] /= b);
            }
            b.add = function(a, b, c, d, e, g1) {
                if (a && a instanceof f) return this.add(a.a, a.b, a.c, a.d, a.e, a.f);
                var h = a * this.a + b * this.c, i = a * this.b + b * this.d;
                return this.e += e * this.a + g1 * this.c, this.f += e * this.b + g1 * this.d, this.c = c * this.a + d * this.c, this.d = c * this.b + d * this.d, this.a = h, this.b = i, this;
            }, f.prototype.multLeft = function(a, b, c, d, e, g1) {
                if (a && a instanceof f) return this.multLeft(a.a, a.b, a.c, a.d, a.e, a.f);
                var h = a * this.a + c * this.b, i = a * this.c + c * this.d, j = a * this.e + c * this.f + e;
                return this.b = b * this.a + d * this.b, this.d = b * this.c + d * this.d, this.f = b * this.e + d * this.f + g1, this.a = h, this.c = i, this.e = j, this;
            }, b.invert = function() {
                var a = this, b = a.a * a.d - a.b * a.c;
                return new f(a.d / b, -a.b / b, -a.c / b, a.a / b, (a.c * a.f - a.d * a.e) / b, (a.b * a.e - a.a * a.f) / b);
            }, b.clone = function() {
                return new f(this.a, this.b, this.c, this.d, this.e, this.f);
            }, b.translate = function(a, b) {
                return this.e += a * this.a + b * this.c, this.f += a * this.b + b * this.d, this;
            }, b.scale = function(a, b, c, d) {
                return null == b && (b = a), (c || d) && this.translate(c, d), this.a *= a, this.b *= a, this.c *= b, this.d *= b, (c || d) && this.translate(-c, -d), this;
            }, b.rotate = function(b, c, d) {
                b = a.rad(b), c = c || 0, d = d || 0;
                var e = +i.cos(b).toFixed(9), f = +i.sin(b).toFixed(9);
                return this.add(e, f, -f, e, c, d), this.add(1, 0, 0, 1, -c, -d);
            }, b.skewX = function(a) {
                return this.skew(a, 0);
            }, b.skewY = function(a) {
                return this.skew(0, a);
            }, b.skew = function(b, c) {
                b = b || 0, c = c || 0, b = a.rad(b), c = a.rad(c);
                var d = i.tan(b).toFixed(9), e = i.tan(c).toFixed(9);
                return this.add(1, e, d, 1, 0, 0);
            }, b.x = function(a, b) {
                return a * this.a + b * this.c + this.e;
            }, b.y = function(a, b) {
                return a * this.b + b * this.d + this.f;
            }, b.get = function(a) {
                return +this[h.fromCharCode(97 + a)].toFixed(4);
            }, b.toString = function() {
                return "matrix(" + [
                    this.get(0),
                    this.get(1),
                    this.get(2),
                    this.get(3),
                    this.get(4),
                    this.get(5)
                ].join() + ")";
            }, b.offset = function() {
                return [
                    this.e.toFixed(4),
                    this.f.toFixed(4)
                ];
            }, b.determinant = function() {
                return this.a * this.d - this.b * this.c;
            }, b.split = function() {
                var b = {};
                b.dx = this.e, b.dy = this.f;
                var e = [
                    [
                        this.a,
                        this.b
                    ],
                    [
                        this.c,
                        this.d
                    ]
                ];
                b.scalex = i.sqrt(c(e[0])), d(e[0]), b.shear = e[0][0] * e[1][0] + e[0][1] * e[1][1], e[1] = [
                    e[1][0] - e[0][0] * b.shear,
                    e[1][1] - e[0][1] * b.shear
                ], b.scaley = i.sqrt(c(e[1])), d(e[1]), b.shear /= b.scaley, this.determinant() < 0 && (b.scalex = -b.scalex);
                var f = e[0][1], g1 = e[1][1];
                return 0 > g1 ? (b.rotate = a.deg(i.acos(g1)), 0 > f && (b.rotate = 360 - b.rotate)) : b.rotate = a.deg(i.asin(f)), b.isSimple = !(+b.shear.toFixed(9) || b.scalex.toFixed(9) != b.scaley.toFixed(9) && b.rotate), b.isSuperSimple = !+b.shear.toFixed(9) && b.scalex.toFixed(9) == b.scaley.toFixed(9) && !b.rotate, b.noRotation = !+b.shear.toFixed(9) && !b.rotate, b;
            }, b.toTransformString = function(a) {
                var b = a || this.split();
                return +b.shear.toFixed(9) ? "m" + [
                    this.get(0),
                    this.get(1),
                    this.get(2),
                    this.get(3),
                    this.get(4),
                    this.get(5)
                ] : (b.scalex = +b.scalex.toFixed(4), b.scaley = +b.scaley.toFixed(4), b.rotate = +b.rotate.toFixed(4), (b.dx || b.dy ? "t" + [
                    +b.dx.toFixed(4),
                    +b.dy.toFixed(4)
                ] : j) + (b.rotate ? "r" + [
                    +b.rotate.toFixed(4),
                    0,
                    0
                ] : j) + (1 != b.scalex || 1 != b.scaley ? "s" + [
                    b.scalex,
                    b.scaley,
                    0,
                    0
                ] : j));
            };
        }(f.prototype), a.Matrix = f, a.matrix = function(a, b, c, d, e, g1) {
            return new f(a, b, c, d, e, g1);
        };
    }), d.plugin(function(a, c, d, e, f) {
        function g1(d) {
            return function(e) {
                if (b.stop(), e instanceof f && 1 == e.node.childNodes.length && ("radialGradient" == e.node.firstChild.tagName || "linearGradient" == e.node.firstChild.tagName || "pattern" == e.node.firstChild.tagName) && (e = e.node.firstChild, n(this).appendChild(e), e = l(e)), e instanceof c) {
                    if ("radialGradient" == e.type || "linearGradient" == e.type || "pattern" == e.type) {
                        e.node.id || p(e.node, {
                            id: e.id
                        });
                        var g1 = q(e.node.id);
                    } else g1 = e.attr(d);
                } else if (g1 = a.color(e), g1.error) {
                    var h = a(n(this).ownerSVGElement).gradient(e);
                    h ? (h.node.id || p(h.node, {
                        id: h.id
                    }), g1 = q(h.node.id)) : g1 = e;
                } else g1 = r(g1);
                var i = {};
                i[d] = g1, p(this.node, i), this.node.style[d] = t;
            };
        }
        function h(a) {
            b.stop(), a == +a && (a += "px"), this.node.style.fontSize = a;
        }
        function i(a) {
            for(var b = [], c = a.childNodes, d = 0, e = c.length; e > d; d++){
                var f = c[d];
                3 == f.nodeType && b.push(f.nodeValue), "tspan" == f.tagName && (1 == f.childNodes.length && 3 == f.firstChild.nodeType ? b.push(f.firstChild.nodeValue) : b.push(i(f)));
            }
            return b;
        }
        function j() {
            return b.stop(), this.node.style.fontSize;
        }
        var k = a._.make, l = a._.wrap, m = a.is, n = a._.getSomeDefs, o = /^url\((['"]?)([^)]+)\1\)$/, p = a._.$, q = a.url, r = String, s = a._.separator, t = "";
        a.deurl = function(a) {
            var b = String(a).match(o);
            return b ? b[2] : a;
        }, b.on("snap.util.attr.mask", function(a) {
            if (a instanceof c || a instanceof f) {
                if (b.stop(), a instanceof f && 1 == a.node.childNodes.length && (a = a.node.firstChild, n(this).appendChild(a), a = l(a)), "mask" == a.type) var d = a;
                else d = k("mask", n(this)), d.node.appendChild(a.node);
                !d.node.id && p(d.node, {
                    id: d.id
                }), p(this.node, {
                    mask: q(d.id)
                });
            }
        }), function(a) {
            b.on("snap.util.attr.clip", a), b.on("snap.util.attr.clip-path", a), b.on("snap.util.attr.clipPath", a);
        }(function(a) {
            if (a instanceof c || a instanceof f) {
                b.stop();
                for(var d, e = a.node; e;){
                    if ("clipPath" === e.nodeName) {
                        d = new c(e);
                        break;
                    }
                    if ("svg" === e.nodeName) {
                        d = void 0;
                        break;
                    }
                    e = e.parentNode;
                }
                d || (d = k("clipPath", n(this)), d.node.appendChild(a.node), !d.node.id && p(d.node, {
                    id: d.id
                })), p(this.node, {
                    "clip-path": q(d.node.id || d.id)
                });
            }
        }), b.on("snap.util.attr.fill", g1("fill")), b.on("snap.util.attr.stroke", g1("stroke"));
        var u = /^([lr])(?:\(([^)]*)\))?(.*)$/i;
        b.on("snap.util.grad.parse", function(a) {
            function b(a, b) {
                for(var c = (b - h) / (a - i), d = i; a > d; d++)f[d].offset = +(+h + c * (d - i)).toFixed(2);
                i = a, h = b;
            }
            a = r(a);
            var c = a.match(u);
            if (!c) return null;
            var d = c[1], e = c[2], f = c[3];
            e = e.split(/\s*,\s*/).map(function(a) {
                return +a == a ? +a : a;
            }), 1 == e.length && 0 == e[0] && (e = []), f = f.split("-"), f = f.map(function(a) {
                a = a.split(":");
                var b = {
                    color: a[0]
                };
                return a[1] && (b.offset = parseFloat(a[1])), b;
            });
            var g1 = f.length, h = 0, i = 0;
            g1--;
            for(var j = 0; g1 > j; j++)"offset" in f[j] && b(j, f[j].offset);
            return f[g1].offset = f[g1].offset || 100, b(g1, f[g1].offset), {
                type: d,
                params: e,
                stops: f
            };
        }), b.on("snap.util.attr.d", function(c) {
            b.stop(), m(c, "array") && m(c[0], "array") && (c = a.path.toString.call(c)), c = r(c), c.match(/[ruo]/i) && (c = a.path.toAbsolute(c)), p(this.node, {
                d: c
            });
        })(-1), b.on("snap.util.attr.#text", function(a) {
            b.stop(), a = r(a);
            for(var c = e.doc.createTextNode(a); this.node.firstChild;)this.node.removeChild(this.node.firstChild);
            this.node.appendChild(c);
        })(-1), b.on("snap.util.attr.path", function(a) {
            b.stop(), this.attr({
                d: a
            });
        })(-1), b.on("snap.util.attr.class", function(a) {
            b.stop(), this.node.className.baseVal = a;
        })(-1), b.on("snap.util.attr.viewBox", function(a) {
            var c;
            c = m(a, "object") && "x" in a ? [
                a.x,
                a.y,
                a.width,
                a.height
            ].join(" ") : m(a, "array") ? a.join(" ") : a, p(this.node, {
                viewBox: c
            }), b.stop();
        })(-1), b.on("snap.util.attr.transform", function(a) {
            this.transform(a), b.stop();
        })(-1), b.on("snap.util.attr.r", function(a) {
            "rect" == this.type && (b.stop(), p(this.node, {
                rx: a,
                ry: a
            }));
        })(-1), b.on("snap.util.attr.textpath", function(a) {
            if (b.stop(), "text" == this.type) {
                var d, e, f;
                if (!a && this.textPath) {
                    for(e = this.textPath; e.node.firstChild;)this.node.appendChild(e.node.firstChild);
                    return e.remove(), void delete this.textPath;
                }
                if (m(a, "string")) {
                    var g1 = n(this), h = l(g1.parentNode).path(a);
                    g1.appendChild(h.node), d = h.id, h.attr({
                        id: d
                    });
                } else a = l(a), a instanceof c && (d = a.attr("id"), d || (d = a.id, a.attr({
                    id: d
                })));
                if (d) {
                    if (e = this.textPath, f = this.node, e) e.attr({
                        "xlink:href": "#" + d
                    });
                    else {
                        for(e = p("textPath", {
                            "xlink:href": "#" + d
                        }); f.firstChild;)e.appendChild(f.firstChild);
                        f.appendChild(e), this.textPath = l(e);
                    }
                }
            }
        })(-1), b.on("snap.util.attr.text", function(a) {
            if ("text" == this.type) {
                for(var c = this.node, d = function(a) {
                    var b = p("tspan");
                    if (m(a, "array")) for(var c = 0; c < a.length; c++)b.appendChild(d(a[c]));
                    else b.appendChild(e.doc.createTextNode(a));
                    return b.normalize && b.normalize(), b;
                }; c.firstChild;)c.removeChild(c.firstChild);
                for(var f = d(a); f.firstChild;)c.appendChild(f.firstChild);
            }
            b.stop();
        })(-1), b.on("snap.util.attr.fontSize", h)(-1), b.on("snap.util.attr.font-size", h)(-1), b.on("snap.util.getattr.transform", function() {
            return b.stop(), this.transform();
        })(-1), b.on("snap.util.getattr.textpath", function() {
            return b.stop(), this.textPath;
        })(-1), function() {
            function c(c) {
                return function() {
                    b.stop();
                    var d = e.doc.defaultView.getComputedStyle(this.node, null).getPropertyValue("marker-" + c);
                    return "none" == d ? d : a(e.doc.getElementById(d.match(o)[1]));
                };
            }
            function d(a) {
                return function(c) {
                    b.stop();
                    var d = "marker" + a.charAt(0).toUpperCase() + a.substring(1);
                    if ("" == c || !c) return void (this.node.style[d] = "none");
                    if ("marker" == c.type) {
                        var e = c.node.id;
                        return e || p(c.node, {
                            id: c.id
                        }), void (this.node.style[d] = q(e));
                    }
                };
            }
            b.on("snap.util.getattr.marker-end", c("end"))(-1), b.on("snap.util.getattr.markerEnd", c("end"))(-1), b.on("snap.util.getattr.marker-start", c("start"))(-1), b.on("snap.util.getattr.markerStart", c("start"))(-1), b.on("snap.util.getattr.marker-mid", c("mid"))(-1), b.on("snap.util.getattr.markerMid", c("mid"))(-1), b.on("snap.util.attr.marker-end", d("end"))(-1), b.on("snap.util.attr.markerEnd", d("end"))(-1), b.on("snap.util.attr.marker-start", d("start"))(-1), b.on("snap.util.attr.markerStart", d("start"))(-1), b.on("snap.util.attr.marker-mid", d("mid"))(-1), b.on("snap.util.attr.markerMid", d("mid"))(-1);
        }(), b.on("snap.util.getattr.r", function() {
            return "rect" == this.type && p(this.node, "rx") == p(this.node, "ry") ? (b.stop(), p(this.node, "rx")) : void 0;
        })(-1), b.on("snap.util.getattr.text", function() {
            if ("text" == this.type || "tspan" == this.type) {
                b.stop();
                var a = i(this.node);
                return 1 == a.length ? a[0] : a;
            }
        })(-1), b.on("snap.util.getattr.#text", function() {
            return this.node.textContent;
        })(-1), b.on("snap.util.getattr.fill", function(c) {
            if (!c) {
                b.stop();
                var d = b("snap.util.getattr.fill", this, !0).firstDefined();
                return a(a.deurl(d)) || d;
            }
        })(-1), b.on("snap.util.getattr.stroke", function(c) {
            if (!c) {
                b.stop();
                var d = b("snap.util.getattr.stroke", this, !0).firstDefined();
                return a(a.deurl(d)) || d;
            }
        })(-1), b.on("snap.util.getattr.viewBox", function() {
            b.stop();
            var c = p(this.node, "viewBox");
            return c ? (c = c.split(s), a._.box(+c[0], +c[1], +c[2], +c[3])) : void 0;
        })(-1), b.on("snap.util.getattr.points", function() {
            var a = p(this.node, "points");
            return b.stop(), a ? a.split(s) : void 0;
        })(-1), b.on("snap.util.getattr.path", function() {
            var a = p(this.node, "d");
            return b.stop(), a;
        })(-1), b.on("snap.util.getattr.class", function() {
            return this.node.className.baseVal;
        })(-1), b.on("snap.util.getattr.fontSize", j)(-1), b.on("snap.util.getattr.font-size", j)(-1);
    }), d.plugin(function(a, b, c, d, e) {
        var f = /\S+/g, g1 = String, h = b.prototype;
        h.addClass = function(a) {
            var b, c, d, e, h = g1(a || "").match(f) || [], i = this.node, j = i.className.baseVal, k = j.match(f) || [];
            if (h.length) {
                for(b = 0; d = h[b++];)c = k.indexOf(d), ~c || k.push(d);
                e = k.join(" "), j != e && (i.className.baseVal = e);
            }
            return this;
        }, h.removeClass = function(a) {
            var b, c, d, e, h = g1(a || "").match(f) || [], i = this.node, j = i.className.baseVal, k = j.match(f) || [];
            if (k.length) {
                for(b = 0; d = h[b++];)c = k.indexOf(d), ~c && k.splice(c, 1);
                e = k.join(" "), j != e && (i.className.baseVal = e);
            }
            return this;
        }, h.hasClass = function(a) {
            var b = this.node, c = b.className.baseVal, d = c.match(f) || [];
            return !!~d.indexOf(a);
        }, h.toggleClass = function(a, b) {
            if (null != b) return b ? this.addClass(a) : this.removeClass(a);
            var c, d, e, g1, h = (a || "").match(f) || [], i = this.node, j = i.className.baseVal, k = j.match(f) || [];
            for(c = 0; e = h[c++];)d = k.indexOf(e), ~d ? k.splice(d, 1) : k.push(e);
            return g1 = k.join(" "), j != g1 && (i.className.baseVal = g1), this;
        };
    }), d.plugin(function(a, c, d, e, f) {
        function g1(a) {
            return a;
        }
        function h(a) {
            return function(b) {
                return +b.toFixed(3) + a;
            };
        }
        var i = {
            "+": function(a, b) {
                return a + b;
            },
            "-": function(a, b) {
                return a - b;
            },
            "/": function(a, b) {
                return a / b;
            },
            "*": function(a, b) {
                return a * b;
            }
        }, j = String, k = /[a-z]+$/i, l = /^\s*([+\-\/*])\s*=\s*([\d.eE+\-]+)\s*([^\d\s]+)?\s*$/;
        b.on("snap.util.attr", function(a) {
            var c = j(a).match(l);
            if (c) {
                var d = b.nt(), e = d.substring(d.lastIndexOf(".") + 1), f = this.attr(e), g1 = {};
                b.stop();
                var h = c[3] || "", m = f.match(k), n = i[c[1]];
                if (m && m == h ? a = n(parseFloat(f), +c[2]) : (f = this.asPX(e), a = n(this.asPX(e), this.asPX(e, c[2] + h))), isNaN(f) || isNaN(a)) return;
                g1[e] = a, this.attr(g1);
            }
        })(-10), b.on("snap.util.equal", function(a, c) {
            var d = j(this.attr(a) || ""), e = j(c).match(l);
            if (e) {
                b.stop();
                var f = e[3] || "", m = d.match(k), n = i[e[1]];
                return m && m == f ? {
                    from: parseFloat(d),
                    to: n(parseFloat(d), +e[2]),
                    f: h(m)
                } : (d = this.asPX(a), {
                    from: d,
                    to: n(d, this.asPX(a, e[2] + f)),
                    f: g1
                });
            }
        })(-10);
    }), d.plugin(function(c, d, e, f, g1) {
        var h = e.prototype, i = c.is;
        h.rect = function(a, b, c, d, e, f) {
            var g1;
            return null == f && (f = e), i(a, "object") && "[object Object]" == a ? g1 = a : null != a && (g1 = {
                x: a,
                y: b,
                width: c,
                height: d
            }, null != e && (g1.rx = e, g1.ry = f)), this.el("rect", g1);
        }, h.circle = function(a, b, c) {
            var d;
            return i(a, "object") && "[object Object]" == a ? d = a : null != a && (d = {
                cx: a,
                cy: b,
                r: c
            }), this.el("circle", d);
        };
        var j = function() {
            function a() {
                this.parentNode.removeChild(this);
            }
            return function(b, c) {
                var d = f.doc.createElement("img"), e = f.doc.body;
                d.style.cssText = "position:absolute;left:-9999em;top:-9999em", d.onload = function() {
                    c.call(d), d.onload = d.onerror = null, e.removeChild(d);
                }, d.onerror = a, e.appendChild(d), d.src = b;
            };
        }();
        h.image = function(a, b, d, e, f) {
            var g1 = this.el("image");
            if (i(a, "object") && "src" in a) g1.attr(a);
            else if (null != a) {
                var h = {
                    "xlink:href": a,
                    preserveAspectRatio: "none"
                };
                null != b && null != d && (h.x = b, h.y = d), null != e && null != f ? (h.width = e, h.height = f) : j(a, function() {
                    c._.$(g1.node, {
                        width: this.offsetWidth,
                        height: this.offsetHeight
                    });
                }), c._.$(g1.node, h);
            }
            return g1;
        }, h.ellipse = function(a, b, c, d) {
            var e;
            return i(a, "object") && "[object Object]" == a ? e = a : null != a && (e = {
                cx: a,
                cy: b,
                rx: c,
                ry: d
            }), this.el("ellipse", e);
        }, h.path = function(a) {
            var b;
            return i(a, "object") && !i(a, "array") ? b = a : a && (b = {
                d: a
            }), this.el("path", b);
        }, h.group = h.g = function(a) {
            var b = this.el("g");
            return 1 == arguments.length && a && !a.type ? b.attr(a) : arguments.length && b.add(Array.prototype.slice.call(arguments, 0)), b;
        }, h.svg = function(a, b, c, d, e, f, g1, h) {
            var j = {};
            return i(a, "object") && null == b ? j = a : (null != a && (j.x = a), null != b && (j.y = b), null != c && (j.width = c), null != d && (j.height = d), null != e && null != f && null != g1 && null != h && (j.viewBox = [
                e,
                f,
                g1,
                h
            ])), this.el("svg", j);
        }, h.mask = function(a) {
            var b = this.el("mask");
            return 1 == arguments.length && a && !a.type ? b.attr(a) : arguments.length && b.add(Array.prototype.slice.call(arguments, 0)), b;
        }, h.ptrn = function(a, b, c, d, e, f, g1, h) {
            if (i(a, "object")) var j = a;
            else j = {
                patternUnits: "userSpaceOnUse"
            }, a && (j.x = a), b && (j.y = b), null != c && (j.width = c), null != d && (j.height = d), null != e && null != f && null != g1 && null != h ? j.viewBox = [
                e,
                f,
                g1,
                h
            ] : j.viewBox = [
                a || 0,
                b || 0,
                c || 0,
                d || 0
            ];
            return this.el("pattern", j);
        }, h.use = function(a) {
            return null != a ? (a instanceof d && (a.attr("id") || a.attr({
                id: c._.id(a)
            }), a = a.attr("id")), "#" == String(a).charAt() && (a = a.substring(1)), this.el("use", {
                "xlink:href": "#" + a
            })) : d.prototype.use.call(this);
        }, h.symbol = function(a, b, c, d) {
            var e = {};
            return null != a && null != b && null != c && null != d && (e.viewBox = [
                a,
                b,
                c,
                d
            ]), this.el("symbol", e);
        }, h.text = function(a, b, c) {
            var d = {};
            return i(a, "object") ? d = a : null != a && (d = {
                x: a,
                y: b,
                text: c || ""
            }), this.el("text", d);
        }, h.line = function(a, b, c, d) {
            var e = {};
            return i(a, "object") ? e = a : null != a && (e = {
                x1: a,
                x2: c,
                y1: b,
                y2: d
            }), this.el("line", e);
        }, h.polyline = function(a) {
            arguments.length > 1 && (a = Array.prototype.slice.call(arguments, 0));
            var b = {};
            return i(a, "object") && !i(a, "array") ? b = a : null != a && (b = {
                points: a
            }), this.el("polyline", b);
        }, h.polygon = function(a) {
            arguments.length > 1 && (a = Array.prototype.slice.call(arguments, 0));
            var b = {};
            return i(a, "object") && !i(a, "array") ? b = a : null != a && (b = {
                points: a
            }), this.el("polygon", b);
        }, function() {
            function d() {
                return this.selectAll("stop");
            }
            function e(a, b) {
                var d = l("stop"), e = {
                    offset: +b + "%"
                };
                a = c.color(a), e["stop-color"] = a.hex, a.opacity < 1 && (e["stop-opacity"] = a.opacity), l(d, e);
                for(var f, g1 = this.stops(), h = 0; h < g1.length; h++){
                    var i = parseFloat(g1[h].attr("offset"));
                    if (i > b) {
                        this.node.insertBefore(d, g1[h].node), f = !0;
                        break;
                    }
                }
                return f || this.node.appendChild(d), this;
            }
            function f() {
                if ("linearGradient" == this.type) {
                    var a = l(this.node, "x1") || 0, b = l(this.node, "x2") || 1, d = l(this.node, "y1") || 0, e = l(this.node, "y2") || 0;
                    return c._.box(a, d, math.abs(b - a), math.abs(e - d));
                }
                var f = this.node.cx || .5, g1 = this.node.cy || .5, h = this.node.r || 0;
                return c._.box(f - h, g1 - h, 2 * h, 2 * h);
            }
            function g1(a) {
                var d = a, e = this.stops();
                if ("string" == typeof a && (d = b("snap.util.grad.parse", null, "l(0,0,0,1)" + a).firstDefined().stops), c.is(d, "array")) {
                    for(var f = 0; f < e.length; f++)if (d[f]) {
                        var g1 = c.color(d[f].color), h = {
                            offset: d[f].offset + "%"
                        };
                        h["stop-color"] = g1.hex, g1.opacity < 1 && (h["stop-opacity"] = g1.opacity), e[f].attr(h);
                    } else e[f].remove();
                    for(f = e.length; f < d.length; f++)this.addStop(d[f].color, d[f].offset);
                    return this;
                }
            }
            function i(a, c) {
                var d, e = b("snap.util.grad.parse", null, c).firstDefined();
                if (!e) return null;
                e.params.unshift(a), d = "l" == e.type.toLowerCase() ? j.apply(0, e.params) : k.apply(0, e.params), e.type != e.type.toLowerCase() && l(d.node, {
                    gradientUnits: "userSpaceOnUse"
                });
                for(var f = e.stops, g1 = f.length, h = 0; g1 > h; h++){
                    var i = f[h];
                    d.addStop(i.color, i.offset);
                }
                return d;
            }
            function j(a, b, h, i, j) {
                var k = c._.make("linearGradient", a);
                return k.stops = d, k.addStop = e, k.getBBox = f, k.setStops = g1, null != b && l(k.node, {
                    x1: b,
                    y1: h,
                    x2: i,
                    y2: j
                }), k;
            }
            function k(a, b, g1, h, i, j) {
                var k = c._.make("radialGradient", a);
                return k.stops = d, k.addStop = e, k.getBBox = f, null != b && l(k.node, {
                    cx: b,
                    cy: g1,
                    r: h
                }), null != i && null != j && l(k.node, {
                    fx: i,
                    fy: j
                }), k;
            }
            var l = c._.$;
            h.gradient = function(a) {
                return i(this.defs, a);
            }, h.gradientLinear = function(a, b, c, d) {
                return j(this.defs, a, b, c, d);
            }, h.gradientRadial = function(a, b, c, d, e) {
                return k(this.defs, a, b, c, d, e);
            }, h.toString = function() {
                var a, b = this.node.ownerDocument, d = b.createDocumentFragment(), e = b.createElement("div"), f = this.node.cloneNode(!0);
                return d.appendChild(e), e.appendChild(f), c._.$(f, {
                    xmlns: "http://www.w3.org/2000/svg"
                }), a = e.innerHTML, d.removeChild(d.firstChild), a;
            }, h.toDataURL = function() {
                return a && a.btoa ? "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(this))) : void 0;
            }, h.clear = function() {
                for(var a, b = this.node.firstChild; b;)a = b.nextSibling, "defs" != b.tagName ? b.parentNode.removeChild(b) : h.clear.call({
                    node: b
                }), b = a;
            };
        }();
    }), d.plugin(function(a, b, c, d) {
        function e(a) {
            var b = e.ps = e.ps || {};
            return b[a] ? b[a].sleep = 100 : b[a] = {
                sleep: 100
            }, setTimeout(function() {
                for(var c in b)b[M](c) && c != a && (b[c].sleep--, !b[c].sleep && delete b[c]);
            }), b[a];
        }
        function f(a, b, c, d) {
            return null == a && (a = b = c = d = 0), null == b && (b = a.y, c = a.width, d = a.height, a = a.x), {
                x: a,
                y: b,
                width: c,
                w: c,
                height: d,
                h: d,
                x2: a + c,
                y2: b + d,
                cx: a + c / 2,
                cy: b + d / 2,
                r1: P.min(c, d) / 2,
                r2: P.max(c, d) / 2,
                r0: P.sqrt(c * c + d * d) / 2,
                path: y(a, b, c, d),
                vb: [
                    a,
                    b,
                    c,
                    d
                ].join(" ")
            };
        }
        function g1() {
            return this.join(",").replace(N, "$1");
        }
        function h(a) {
            var b = L(a);
            return b.toString = g1, b;
        }
        function i(a, b, c, d, e, f, g1, h, i) {
            return null == i ? p(a, b, c, d, e, f, g1, h) : k(a, b, c, d, e, f, g1, h, q(a, b, c, d, e, f, g1, h, i));
        }
        function j(c, d) {
            function e(a) {
                return +(+a).toFixed(3);
            }
            return a._.cacher(function(a, f, g1) {
                a instanceof b && (a = a.attr("d")), a = G(a);
                for(var h, j, l, m, n, o = "", p = {}, q = 0, r = 0, s = a.length; s > r; r++){
                    if (l = a[r], "M" == l[0]) h = +l[1], j = +l[2];
                    else {
                        if (m = i(h, j, l[1], l[2], l[3], l[4], l[5], l[6]), q + m > f) {
                            if (d && !p.start) {
                                if (n = i(h, j, l[1], l[2], l[3], l[4], l[5], l[6], f - q), o += [
                                    "C" + e(n.start.x),
                                    e(n.start.y),
                                    e(n.m.x),
                                    e(n.m.y),
                                    e(n.x),
                                    e(n.y)
                                ], g1) return o;
                                p.start = o, o = [
                                    "M" + e(n.x),
                                    e(n.y) + "C" + e(n.n.x),
                                    e(n.n.y),
                                    e(n.end.x),
                                    e(n.end.y),
                                    e(l[5]),
                                    e(l[6])
                                ].join(), q += m, h = +l[5], j = +l[6];
                                continue;
                            }
                            if (!c && !d) return n = i(h, j, l[1], l[2], l[3], l[4], l[5], l[6], f - q);
                        }
                        q += m, h = +l[5], j = +l[6];
                    }
                    o += l.shift() + l;
                }
                return p.end = o, n = c ? q : d ? p : k(h, j, l[0], l[1], l[2], l[3], l[4], l[5], 1);
            }, null, a._.clone);
        }
        function k(a, b, c, d, e, f, g1, h, i) {
            var j = 1 - i, k = T(j, 3), l = T(j, 2), m = i * i, n = m * i, o = k * a + 3 * l * i * c + 3 * j * i * i * e + n * g1, p = k * b + 3 * l * i * d + 3 * j * i * i * f + n * h, q = a + 2 * i * (c - a) + m * (e - 2 * c + a), r = b + 2 * i * (d - b) + m * (f - 2 * d + b), s = c + 2 * i * (e - c) + m * (g1 - 2 * e + c), t = d + 2 * i * (f - d) + m * (h - 2 * f + d), u = j * a + i * c, v = j * b + i * d, w = j * e + i * g1, x = j * f + i * h, y = 90 - 180 * P.atan2(q - s, r - t) / Q;
            return {
                x: o,
                y: p,
                m: {
                    x: q,
                    y: r
                },
                n: {
                    x: s,
                    y: t
                },
                start: {
                    x: u,
                    y: v
                },
                end: {
                    x: w,
                    y: x
                },
                alpha: y
            };
        }
        function l(b, c, d, e, g1, h, i, j) {
            a.is(b, "array") || (b = [
                b,
                c,
                d,
                e,
                g1,
                h,
                i,
                j
            ]);
            var k = F.apply(null, b);
            return f(k.min.x, k.min.y, k.max.x - k.min.x, k.max.y - k.min.y);
        }
        function m(a, b, c) {
            return b >= a.x && b <= a.x + a.width && c >= a.y && c <= a.y + a.height;
        }
        function n(a, b) {
            return a = f(a), b = f(b), m(b, a.x, a.y) || m(b, a.x2, a.y) || m(b, a.x, a.y2) || m(b, a.x2, a.y2) || m(a, b.x, b.y) || m(a, b.x2, b.y) || m(a, b.x, b.y2) || m(a, b.x2, b.y2) || (a.x < b.x2 && a.x > b.x || b.x < a.x2 && b.x > a.x) && (a.y < b.y2 && a.y > b.y || b.y < a.y2 && b.y > a.y);
        }
        function o(a, b, c, d, e) {
            var f = -3 * b + 9 * c - 9 * d + 3 * e, g1 = a * f + 6 * b - 12 * c + 6 * d;
            return a * g1 - 3 * b + 3 * c;
        }
        function p(a, b, c, d, e, f, g1, h, i) {
            null == i && (i = 1), i = i > 1 ? 1 : 0 > i ? 0 : i;
            for(var j = i / 2, k = 12, l = [
                -0.1252,
                .1252,
                -0.3678,
                .3678,
                -0.5873,
                .5873,
                -0.7699,
                .7699,
                -0.9041,
                .9041,
                -0.9816,
                .9816
            ], m = [
                .2491,
                .2491,
                .2335,
                .2335,
                .2032,
                .2032,
                .1601,
                .1601,
                .1069,
                .1069,
                .0472,
                .0472
            ], n = 0, p = 0; k > p; p++){
                var q = j * l[p] + j, r = o(q, a, c, e, g1), s = o(q, b, d, f, h), t = r * r + s * s;
                n += m[p] * P.sqrt(t);
            }
            return j * n;
        }
        function q(a, b, c, d, e, f, g1, h, i) {
            if (!(0 > i || p(a, b, c, d, e, f, g1, h) < i)) {
                var j, k = 1, l = k / 2, m = k - l, n = .01;
                for(j = p(a, b, c, d, e, f, g1, h, m); U(j - i) > n;)l /= 2, m += (i > j ? 1 : -1) * l, j = p(a, b, c, d, e, f, g1, h, m);
                return m;
            }
        }
        function r(a, b, c, d, e, f, g1, h) {
            if (!(S(a, c) < R(e, g1) || R(a, c) > S(e, g1) || S(b, d) < R(f, h) || R(b, d) > S(f, h))) {
                var i = (a * d - b * c) * (e - g1) - (a - c) * (e * h - f * g1), j = (a * d - b * c) * (f - h) - (b - d) * (e * h - f * g1), k = (a - c) * (f - h) - (b - d) * (e - g1);
                if (k) {
                    var l = i / k, m = j / k, n = +l.toFixed(2), o = +m.toFixed(2);
                    if (!(n < +R(a, c).toFixed(2) || n > +S(a, c).toFixed(2) || n < +R(e, g1).toFixed(2) || n > +S(e, g1).toFixed(2) || o < +R(b, d).toFixed(2) || o > +S(b, d).toFixed(2) || o < +R(f, h).toFixed(2) || o > +S(f, h).toFixed(2))) return {
                        x: l,
                        y: m
                    };
                }
            }
        }
        function s(a, b, c) {
            var d = l(a), e = l(b);
            if (!n(d, e)) return c ? 0 : [];
            for(var f = p.apply(0, a), g1 = p.apply(0, b), h = ~~(f / 8), i = ~~(g1 / 8), j = [], m = [], o = {}, q = c ? 0 : [], s = 0; h + 1 > s; s++){
                var t = k.apply(0, a.concat(s / h));
                j.push({
                    x: t.x,
                    y: t.y,
                    t: s / h
                });
            }
            for(s = 0; i + 1 > s; s++)t = k.apply(0, b.concat(s / i)), m.push({
                x: t.x,
                y: t.y,
                t: s / i
            });
            for(s = 0; h > s; s++)for(var u = 0; i > u; u++){
                var v = j[s], w = j[s + 1], x = m[u], y = m[u + 1], z = U(w.x - v.x) < .001 ? "y" : "x", A = U(y.x - x.x) < .001 ? "y" : "x", B = r(v.x, v.y, w.x, w.y, x.x, x.y, y.x, y.y);
                if (B) {
                    if (o[B.x.toFixed(4)] == B.y.toFixed(4)) continue;
                    o[B.x.toFixed(4)] = B.y.toFixed(4);
                    var C = v.t + U((B[z] - v[z]) / (w[z] - v[z])) * (w.t - v.t), D = x.t + U((B[A] - x[A]) / (y[A] - x[A])) * (y.t - x.t);
                    C >= 0 && 1 >= C && D >= 0 && 1 >= D && (c ? q++ : q.push({
                        x: B.x,
                        y: B.y,
                        t1: C,
                        t2: D
                    }));
                }
            }
            return q;
        }
        function t(a, b) {
            return v(a, b);
        }
        function u(a, b) {
            return v(a, b, 1);
        }
        function v(a, b, c) {
            a = G(a), b = G(b);
            for(var d, e, f, g1, h, i, j, k, l, m, n = c ? 0 : [], o = 0, p = a.length; p > o; o++){
                var q = a[o];
                if ("M" == q[0]) d = h = q[1], e = i = q[2];
                else {
                    "C" == q[0] ? (l = [
                        d,
                        e
                    ].concat(q.slice(1)), d = l[6], e = l[7]) : (l = [
                        d,
                        e,
                        d,
                        e,
                        h,
                        i,
                        h,
                        i
                    ], d = h, e = i);
                    for(var r = 0, t = b.length; t > r; r++){
                        var u = b[r];
                        if ("M" == u[0]) f = j = u[1], g1 = k = u[2];
                        else {
                            "C" == u[0] ? (m = [
                                f,
                                g1
                            ].concat(u.slice(1)), f = m[6], g1 = m[7]) : (m = [
                                f,
                                g1,
                                f,
                                g1,
                                j,
                                k,
                                j,
                                k
                            ], f = j, g1 = k);
                            var v = s(l, m, c);
                            if (c) n += v;
                            else {
                                for(var w = 0, x = v.length; x > w; w++)v[w].segment1 = o, v[w].segment2 = r, v[w].bez1 = l, v[w].bez2 = m;
                                n = n.concat(v);
                            }
                        }
                    }
                }
            }
            return n;
        }
        function w(a, b, c) {
            var d = x(a);
            return m(d, b, c) && v(a, [
                [
                    "M",
                    b,
                    c
                ],
                [
                    "H",
                    d.x2 + 10
                ]
            ], 1) % 2 == 1;
        }
        function x(a) {
            var b = e(a);
            if (b.bbox) return L(b.bbox);
            if (!a) return f();
            a = G(a);
            for(var c, d = 0, g1 = 0, h = [], i = [], j = 0, k = a.length; k > j; j++)if (c = a[j], "M" == c[0]) d = c[1], g1 = c[2], h.push(d), i.push(g1);
            else {
                var l = F(d, g1, c[1], c[2], c[3], c[4], c[5], c[6]);
                h = h.concat(l.min.x, l.max.x), i = i.concat(l.min.y, l.max.y), d = c[5], g1 = c[6];
            }
            var m = R.apply(0, h), n = R.apply(0, i), o = S.apply(0, h), p = S.apply(0, i), q = f(m, n, o - m, p - n);
            return b.bbox = L(q), q;
        }
        function y(a, b, c, d, e) {
            if (e) return [
                [
                    "M",
                    +a + +e,
                    b
                ],
                [
                    "l",
                    c - 2 * e,
                    0
                ],
                [
                    "a",
                    e,
                    e,
                    0,
                    0,
                    1,
                    e,
                    e
                ],
                [
                    "l",
                    0,
                    d - 2 * e
                ],
                [
                    "a",
                    e,
                    e,
                    0,
                    0,
                    1,
                    -e,
                    e
                ],
                [
                    "l",
                    2 * e - c,
                    0
                ],
                [
                    "a",
                    e,
                    e,
                    0,
                    0,
                    1,
                    -e,
                    -e
                ],
                [
                    "l",
                    0,
                    2 * e - d
                ],
                [
                    "a",
                    e,
                    e,
                    0,
                    0,
                    1,
                    e,
                    -e
                ],
                [
                    "z"
                ]
            ];
            var f = [
                [
                    "M",
                    a,
                    b
                ],
                [
                    "l",
                    c,
                    0
                ],
                [
                    "l",
                    0,
                    d
                ],
                [
                    "l",
                    -c,
                    0
                ],
                [
                    "z"
                ]
            ];
            return f.toString = g1, f;
        }
        function z(a, b, c, d, e) {
            if (null == e && null == d && (d = c), a = +a, b = +b, c = +c, d = +d, null != e) var f = Math.PI / 180, h = a + c * Math.cos(-d * f), i = a + c * Math.cos(-e * f), j = b + c * Math.sin(-d * f), k = b + c * Math.sin(-e * f), l = [
                [
                    "M",
                    h,
                    j
                ],
                [
                    "A",
                    c,
                    c,
                    0,
                    +(e - d > 180),
                    0,
                    i,
                    k
                ]
            ];
            else l = [
                [
                    "M",
                    a,
                    b
                ],
                [
                    "m",
                    0,
                    -d
                ],
                [
                    "a",
                    c,
                    d,
                    0,
                    1,
                    1,
                    0,
                    2 * d
                ],
                [
                    "a",
                    c,
                    d,
                    0,
                    1,
                    1,
                    0,
                    -2 * d
                ],
                [
                    "z"
                ]
            ];
            return l.toString = g1, l;
        }
        function A(b) {
            var c = e(b), d = String.prototype.toLowerCase;
            if (c.rel) return h(c.rel);
            a.is(b, "array") && a.is(b && b[0], "array") || (b = a.parsePathString(b));
            var f = [], i = 0, j = 0, k = 0, l = 0, m = 0;
            "M" == b[0][0] && (i = b[0][1], j = b[0][2], k = i, l = j, m++, f.push([
                "M",
                i,
                j
            ]));
            for(var n = m, o = b.length; o > n; n++){
                var p = f[n] = [], q = b[n];
                if (q[0] != d.call(q[0])) switch(p[0] = d.call(q[0]), p[0]){
                    case "a":
                        p[1] = q[1], p[2] = q[2], p[3] = q[3], p[4] = q[4], p[5] = q[5], p[6] = +(q[6] - i).toFixed(3), p[7] = +(q[7] - j).toFixed(3);
                        break;
                    case "v":
                        p[1] = +(q[1] - j).toFixed(3);
                        break;
                    case "m":
                        k = q[1], l = q[2];
                    default:
                        for(var r = 1, s = q.length; s > r; r++)p[r] = +(q[r] - (r % 2 ? i : j)).toFixed(3);
                }
                else {
                    p = f[n] = [], "m" == q[0] && (k = q[1] + i, l = q[2] + j);
                    for(var t = 0, u = q.length; u > t; t++)f[n][t] = q[t];
                }
                var v = f[n].length;
                switch(f[n][0]){
                    case "z":
                        i = k, j = l;
                        break;
                    case "h":
                        i += +f[n][v - 1];
                        break;
                    case "v":
                        j += +f[n][v - 1];
                        break;
                    default:
                        i += +f[n][v - 2], j += +f[n][v - 1];
                }
            }
            return f.toString = g1, c.rel = h(f), f;
        }
        function B(b) {
            var c = e(b);
            if (c.abs) return h(c.abs);
            if (K(b, "array") && K(b && b[0], "array") || (b = a.parsePathString(b)), !b || !b.length) return [
                [
                    "M",
                    0,
                    0
                ]
            ];
            var d, f = [], i = 0, j = 0, k = 0, l = 0, m = 0;
            "M" == b[0][0] && (i = +b[0][1], j = +b[0][2], k = i, l = j, m++, f[0] = [
                "M",
                i,
                j
            ]);
            for(var n, o, p = 3 == b.length && "M" == b[0][0] && "R" == b[1][0].toUpperCase() && "Z" == b[2][0].toUpperCase(), q = m, r = b.length; r > q; q++){
                if (f.push(n = []), o = b[q], d = o[0], d != d.toUpperCase()) switch(n[0] = d.toUpperCase(), n[0]){
                    case "A":
                        n[1] = o[1], n[2] = o[2], n[3] = o[3], n[4] = o[4], n[5] = o[5], n[6] = +o[6] + i, n[7] = +o[7] + j;
                        break;
                    case "V":
                        n[1] = +o[1] + j;
                        break;
                    case "H":
                        n[1] = +o[1] + i;
                        break;
                    case "R":
                        for(var s = [
                            i,
                            j
                        ].concat(o.slice(1)), t = 2, u = s.length; u > t; t++)s[t] = +s[t] + i, s[++t] = +s[t] + j;
                        f.pop(), f = f.concat(I(s, p));
                        break;
                    case "O":
                        f.pop(), s = z(i, j, o[1], o[2]), s.push(s[0]), f = f.concat(s);
                        break;
                    case "U":
                        f.pop(), f = f.concat(z(i, j, o[1], o[2], o[3])), n = [
                            "U"
                        ].concat(f[f.length - 1].slice(-2));
                        break;
                    case "M":
                        k = +o[1] + i, l = +o[2] + j;
                    default:
                        for(t = 1, u = o.length; u > t; t++)n[t] = +o[t] + (t % 2 ? i : j);
                }
                else if ("R" == d) s = [
                    i,
                    j
                ].concat(o.slice(1)), f.pop(), f = f.concat(I(s, p)), n = [
                    "R"
                ].concat(o.slice(-2));
                else if ("O" == d) f.pop(), s = z(i, j, o[1], o[2]), s.push(s[0]), f = f.concat(s);
                else if ("U" == d) f.pop(), f = f.concat(z(i, j, o[1], o[2], o[3])), n = [
                    "U"
                ].concat(f[f.length - 1].slice(-2));
                else for(var v = 0, w = o.length; w > v; v++)n[v] = o[v];
                if (d = d.toUpperCase(), "O" != d) switch(n[0]){
                    case "Z":
                        i = +k, j = +l;
                        break;
                    case "H":
                        i = n[1];
                        break;
                    case "V":
                        j = n[1];
                        break;
                    case "M":
                        k = n[n.length - 2], l = n[n.length - 1];
                    default:
                        i = n[n.length - 2], j = n[n.length - 1];
                }
            }
            return f.toString = g1, c.abs = h(f), f;
        }
        function C(a, b, c, d) {
            return [
                a,
                b,
                c,
                d,
                c,
                d
            ];
        }
        function D(a, b, c, d, e, f) {
            var g1 = 1 / 3, h = 2 / 3;
            return [
                g1 * a + h * c,
                g1 * b + h * d,
                g1 * e + h * c,
                g1 * f + h * d,
                e,
                f
            ];
        }
        function E(b, c, d, e, f, g1, h, i, j, k) {
            var l, m = 120 * Q / 180, n = Q / 180 * (+f || 0), o = [], p = a._.cacher(function(a, b, c) {
                var d = a * P.cos(c) - b * P.sin(c), e = a * P.sin(c) + b * P.cos(c);
                return {
                    x: d,
                    y: e
                };
            });
            if (!d || !e) return [
                b,
                c,
                i,
                j,
                i,
                j
            ];
            if (k) y = k[0], z = k[1], w = k[2], x = k[3];
            else {
                l = p(b, c, -n), b = l.x, c = l.y, l = p(i, j, -n), i = l.x, j = l.y;
                var q = (P.cos(Q / 180 * f), P.sin(Q / 180 * f), (b - i) / 2), r = (c - j) / 2, s = q * q / (d * d) + r * r / (e * e);
                s > 1 && (s = P.sqrt(s), d = s * d, e = s * e);
                var t = d * d, u = e * e, v = (g1 == h ? -1 : 1) * P.sqrt(U((t * u - t * r * r - u * q * q) / (t * r * r + u * q * q))), w = v * d * r / e + (b + i) / 2, x = v * -e * q / d + (c + j) / 2, y = P.asin(((c - x) / e).toFixed(9)), z = P.asin(((j - x) / e).toFixed(9));
                y = w > b ? Q - y : y, z = w > i ? Q - z : z, 0 > y && (y = 2 * Q + y), 0 > z && (z = 2 * Q + z), h && y > z && (y -= 2 * Q), !h && z > y && (z -= 2 * Q);
            }
            var A = z - y;
            if (U(A) > m) {
                var B = z, C = i, D = j;
                z = y + m * (h && z > y ? 1 : -1), i = w + d * P.cos(z), j = x + e * P.sin(z), o = E(i, j, d, e, f, 0, h, C, D, [
                    z,
                    B,
                    w,
                    x
                ]);
            }
            A = z - y;
            var F = P.cos(y), G = P.sin(y), H = P.cos(z), I = P.sin(z), J = P.tan(A / 4), K = 4 / 3 * d * J, L = 4 / 3 * e * J, M = [
                b,
                c
            ], N = [
                b + K * G,
                c - L * F
            ], O = [
                i + K * I,
                j - L * H
            ], R = [
                i,
                j
            ];
            if (N[0] = 2 * M[0] - N[0], N[1] = 2 * M[1] - N[1], k) return [
                N,
                O,
                R
            ].concat(o);
            o = [
                N,
                O,
                R
            ].concat(o).join().split(",");
            for(var S = [], T = 0, V = o.length; V > T; T++)S[T] = T % 2 ? p(o[T - 1], o[T], n).y : p(o[T], o[T + 1], n).x;
            return S;
        }
        function F(a, b, c, d, e, f, g1, h) {
            for(var i, j, k, l, m, n, o, p, q = [], r = [
                [],
                []
            ], s = 0; 2 > s; ++s)if (0 == s ? (j = 6 * a - 12 * c + 6 * e, i = -3 * a + 9 * c - 9 * e + 3 * g1, k = 3 * c - 3 * a) : (j = 6 * b - 12 * d + 6 * f, i = -3 * b + 9 * d - 9 * f + 3 * h, k = 3 * d - 3 * b), U(i) < 1e-12) {
                if (U(j) < 1e-12) continue;
                l = -k / j, l > 0 && 1 > l && q.push(l);
            } else o = j * j - 4 * k * i, p = P.sqrt(o), 0 > o || (m = (-j + p) / (2 * i), m > 0 && 1 > m && q.push(m), n = (-j - p) / (2 * i), n > 0 && 1 > n && q.push(n));
            for(var t, u = q.length, v = u; u--;)l = q[u], t = 1 - l, r[0][u] = t * t * t * a + 3 * t * t * l * c + 3 * t * l * l * e + l * l * l * g1, r[1][u] = t * t * t * b + 3 * t * t * l * d + 3 * t * l * l * f + l * l * l * h;
            return r[0][v] = a, r[1][v] = b, r[0][v + 1] = g1, r[1][v + 1] = h, r[0].length = r[1].length = v + 2, {
                min: {
                    x: R.apply(0, r[0]),
                    y: R.apply(0, r[1])
                },
                max: {
                    x: S.apply(0, r[0]),
                    y: S.apply(0, r[1])
                }
            };
        }
        function G(a, b) {
            var c = !b && e(a);
            if (!b && c.curve) return h(c.curve);
            for(var d = B(a), f = b && B(b), g1 = {
                x: 0,
                y: 0,
                bx: 0,
                by: 0,
                X: 0,
                Y: 0,
                qx: null,
                qy: null
            }, i = {
                x: 0,
                y: 0,
                bx: 0,
                by: 0,
                X: 0,
                Y: 0,
                qx: null,
                qy: null
            }, j = function(a, b, c) {
                var d, e;
                if (!a) return [
                    "C",
                    b.x,
                    b.y,
                    b.x,
                    b.y,
                    b.x,
                    b.y
                ];
                switch(!(a[0] in {
                    T: 1,
                    Q: 1
                }) && (b.qx = b.qy = null), a[0]){
                    case "M":
                        b.X = a[1], b.Y = a[2];
                        break;
                    case "A":
                        a = [
                            "C"
                        ].concat(E.apply(0, [
                            b.x,
                            b.y
                        ].concat(a.slice(1))));
                        break;
                    case "S":
                        "C" == c || "S" == c ? (d = 2 * b.x - b.bx, e = 2 * b.y - b.by) : (d = b.x, e = b.y), a = [
                            "C",
                            d,
                            e
                        ].concat(a.slice(1));
                        break;
                    case "T":
                        "Q" == c || "T" == c ? (b.qx = 2 * b.x - b.qx, b.qy = 2 * b.y - b.qy) : (b.qx = b.x, b.qy = b.y), a = [
                            "C"
                        ].concat(D(b.x, b.y, b.qx, b.qy, a[1], a[2]));
                        break;
                    case "Q":
                        b.qx = a[1], b.qy = a[2], a = [
                            "C"
                        ].concat(D(b.x, b.y, a[1], a[2], a[3], a[4]));
                        break;
                    case "L":
                        a = [
                            "C"
                        ].concat(C(b.x, b.y, a[1], a[2]));
                        break;
                    case "H":
                        a = [
                            "C"
                        ].concat(C(b.x, b.y, a[1], b.y));
                        break;
                    case "V":
                        a = [
                            "C"
                        ].concat(C(b.x, b.y, b.x, a[1]));
                        break;
                    case "Z":
                        a = [
                            "C"
                        ].concat(C(b.x, b.y, b.X, b.Y));
                }
                return a;
            }, k = function(a, b) {
                if (a[b].length > 7) {
                    a[b].shift();
                    for(var c = a[b]; c.length;)m[b] = "A", f && (n[b] = "A"), a.splice(b++, 0, [
                        "C"
                    ].concat(c.splice(0, 6)));
                    a.splice(b, 1), r = S(d.length, f && f.length || 0);
                }
            }, l = function(a, b, c, e, g1) {
                a && b && "M" == a[g1][0] && "M" != b[g1][0] && (b.splice(g1, 0, [
                    "M",
                    e.x,
                    e.y
                ]), c.bx = 0, c.by = 0, c.x = a[g1][1], c.y = a[g1][2], r = S(d.length, f && f.length || 0));
            }, m = [], n = [], o = "", p = "", q = 0, r = S(d.length, f && f.length || 0); r > q; q++){
                d[q] && (o = d[q][0]), "C" != o && (m[q] = o, q && (p = m[q - 1])), d[q] = j(d[q], g1, p), "A" != m[q] && "C" == o && (m[q] = "C"), k(d, q), f && (f[q] && (o = f[q][0]), "C" != o && (n[q] = o, q && (p = n[q - 1])), f[q] = j(f[q], i, p), "A" != n[q] && "C" == o && (n[q] = "C"), k(f, q)), l(d, f, g1, i, q), l(f, d, i, g1, q);
                var s = d[q], t = f && f[q], u = s.length, v = f && t.length;
                g1.x = s[u - 2], g1.y = s[u - 1], g1.bx = O(s[u - 4]) || g1.x, g1.by = O(s[u - 3]) || g1.y, i.bx = f && (O(t[v - 4]) || i.x), i.by = f && (O(t[v - 3]) || i.y), i.x = f && t[v - 2], i.y = f && t[v - 1];
            }
            return f || (c.curve = h(d)), f ? [
                d,
                f
            ] : d;
        }
        function H(a, b) {
            if (!b) return a;
            var c, d, e, f, g1, h, i;
            for(a = G(a), e = 0, g1 = a.length; g1 > e; e++)for(i = a[e], f = 1, h = i.length; h > f; f += 2)c = b.x(i[f], i[f + 1]), d = b.y(i[f], i[f + 1]), i[f] = c, i[f + 1] = d;
            return a;
        }
        function I(a, b) {
            for(var c = [], d = 0, e = a.length; e - 2 * !b > d; d += 2){
                var f = [
                    {
                        x: +a[d - 2],
                        y: +a[d - 1]
                    },
                    {
                        x: +a[d],
                        y: +a[d + 1]
                    },
                    {
                        x: +a[d + 2],
                        y: +a[d + 3]
                    },
                    {
                        x: +a[d + 4],
                        y: +a[d + 5]
                    }
                ];
                b ? d ? e - 4 == d ? f[3] = {
                    x: +a[0],
                    y: +a[1]
                } : e - 2 == d && (f[2] = {
                    x: +a[0],
                    y: +a[1]
                }, f[3] = {
                    x: +a[2],
                    y: +a[3]
                }) : f[0] = {
                    x: +a[e - 2],
                    y: +a[e - 1]
                } : e - 4 == d ? f[3] = f[2] : d || (f[0] = {
                    x: +a[d],
                    y: +a[d + 1]
                }), c.push([
                    "C",
                    (-f[0].x + 6 * f[1].x + f[2].x) / 6,
                    (-f[0].y + 6 * f[1].y + f[2].y) / 6,
                    (f[1].x + 6 * f[2].x - f[3].x) / 6,
                    (f[1].y + 6 * f[2].y - f[3].y) / 6,
                    f[2].x,
                    f[2].y
                ]);
            }
            return c;
        }
        var J = b.prototype, K = a.is, L = a._.clone, M = "hasOwnProperty", N = /,?([a-z]),?/gi, O = parseFloat, P = Math, Q = P.PI, R = P.min, S = P.max, T = P.pow, U = P.abs, V = j(1), W = j(), X = j(0, 1), Y = a._unit2px, Z = {
            path: function(a) {
                return a.attr("path");
            },
            circle: function(a) {
                var b = Y(a);
                return z(b.cx, b.cy, b.r);
            },
            ellipse: function(a) {
                var b = Y(a);
                return z(b.cx || 0, b.cy || 0, b.rx, b.ry);
            },
            rect: function(a) {
                var b = Y(a);
                return y(b.x || 0, b.y || 0, b.width, b.height, b.rx, b.ry);
            },
            image: function(a) {
                var b = Y(a);
                return y(b.x || 0, b.y || 0, b.width, b.height);
            },
            line: function(a) {
                return "M" + [
                    a.attr("x1") || 0,
                    a.attr("y1") || 0,
                    a.attr("x2"),
                    a.attr("y2")
                ];
            },
            polyline: function(a) {
                return "M" + a.attr("points");
            },
            polygon: function(a) {
                return "M" + a.attr("points") + "z";
            },
            deflt: function(a) {
                var b = a.node.getBBox();
                return y(b.x, b.y, b.width, b.height);
            }
        };
        a.path = e, a.path.getTotalLength = V, a.path.getPointAtLength = W, a.path.getSubpath = function(a, b, c) {
            if (this.getTotalLength(a) - c < 1e-6) return X(a, b).end;
            var d = X(a, c, 1);
            return b ? X(d, b).end : d;
        }, J.getTotalLength = function() {
            return this.node.getTotalLength ? this.node.getTotalLength() : void 0;
        }, J.getPointAtLength = function(a) {
            return W(this.attr("d"), a);
        }, J.getSubpath = function(b, c) {
            return a.path.getSubpath(this.attr("d"), b, c);
        }, a._.box = f, a.path.findDotsAtSegment = k, a.path.bezierBBox = l, a.path.isPointInsideBBox = m, a.closest = function(b, c, d, e) {
            for(var g1 = 100, h = f(b - g1 / 2, c - g1 / 2, g1, g1), i = [], j = d[0].hasOwnProperty("x") ? function(a) {
                return {
                    x: d[a].x,
                    y: d[a].y
                };
            } : function(a) {
                return {
                    x: d[a],
                    y: e[a]
                };
            }, k = 0; 1e6 >= g1 && !k;){
                for(var l = 0, n = d.length; n > l; l++){
                    var o = j(l);
                    if (m(h, o.x, o.y)) {
                        k++, i.push(o);
                        break;
                    }
                }
                k || (g1 *= 2, h = f(b - g1 / 2, c - g1 / 2, g1, g1));
            }
            if (1e6 != g1) {
                var p, q = 1 / 0;
                for(l = 0, n = i.length; n > l; l++){
                    var r = a.len(b, c, i[l].x, i[l].y);
                    q > r && (q = r, i[l].len = r, p = i[l]);
                }
                return p;
            }
        }, a.path.isBBoxIntersect = n, a.path.intersection = t, a.path.intersectionNumber = u, a.path.isPointInside = w, a.path.getBBox = x, a.path.get = Z, a.path.toRelative = A, a.path.toAbsolute = B, a.path.toCubic = G, a.path.map = H, a.path.toString = g1, a.path.clone = h;
    }), d.plugin(function(a, d, e, f) {
        var g1 = Math.max, h = Math.min, i = function(a) {
            if (this.items = [], this.bindings = {}, this.length = 0, this.type = "set", a) for(var b = 0, c = a.length; c > b; b++)a[b] && (this[this.items.length] = this.items[this.items.length] = a[b], this.length++);
        }, j = i.prototype;
        j.push = function() {
            for(var a, b, c = 0, d = arguments.length; d > c; c++)a = arguments[c], a && (b = this.items.length, this[b] = this.items[b] = a, this.length++);
            return this;
        }, j.pop = function() {
            return this.length && delete this[this.length--], this.items.pop();
        }, j.forEach = function(a, b) {
            for(var c = 0, d = this.items.length; d > c; c++)if (a.call(b, this.items[c], c) === !1) return this;
            return this;
        }, j.animate = function(d, e, f, g1) {
            "function" != typeof f || f.length || (g1 = f, f = c.linear), d instanceof a._.Animation && (g1 = d.callback, f = d.easing, e = f.dur, d = d.attr);
            var h = arguments;
            if (a.is(d, "array") && a.is(h[h.length - 1], "array")) var i = !0;
            var j, k = function() {
                j ? this.b = j : j = this.b;
            }, l = 0, m = this, n = g1 && function() {
                ++l == m.length && g1.call(this);
            };
            return this.forEach(function(a, c) {
                b.once("snap.animcreated." + a.id, k), i ? h[c] && a.animate.apply(a, h[c]) : a.animate(d, e, f, n);
            });
        }, j.remove = function() {
            for(; this.length;)this.pop().remove();
            return this;
        }, j.bind = function(a, b, c) {
            var d = {};
            if ("function" == typeof b) this.bindings[a] = b;
            else {
                var e = c || a;
                this.bindings[a] = function(a) {
                    d[e] = a, b.attr(d);
                };
            }
            return this;
        }, j.attr = function(a) {
            var b = {};
            for(var c in a)this.bindings[c] ? this.bindings[c](a[c]) : b[c] = a[c];
            for(var d = 0, e = this.items.length; e > d; d++)this.items[d].attr(b);
            return this;
        }, j.clear = function() {
            for(; this.length;)this.pop();
        }, j.splice = function(a, b, c) {
            a = 0 > a ? g1(this.length + a, 0) : a, b = g1(0, h(this.length - a, b));
            var d, e = [], f = [], j = [];
            for(d = 2; d < arguments.length; d++)j.push(arguments[d]);
            for(d = 0; b > d; d++)f.push(this[a + d]);
            for(; d < this.length - a; d++)e.push(this[a + d]);
            var k = j.length;
            for(d = 0; d < k + e.length; d++)this.items[a + d] = this[a + d] = k > d ? j[d] : e[d - k];
            for(d = this.items.length = this.length -= b - k; this[d];)delete this[d++];
            return new i(f);
        }, j.exclude = function(a) {
            for(var b = 0, c = this.length; c > b; b++)if (this[b] == a) return this.splice(b, 1), !0;
            return !1;
        }, j.insertAfter = function(a) {
            for(var b = this.items.length; b--;)this.items[b].insertAfter(a);
            return this;
        }, j.getBBox = function() {
            for(var a = [], b = [], c = [], d = [], e = this.items.length; e--;)if (!this.items[e].removed) {
                var f = this.items[e].getBBox();
                a.push(f.x), b.push(f.y), c.push(f.x + f.width), d.push(f.y + f.height);
            }
            return a = h.apply(0, a), b = h.apply(0, b), c = g1.apply(0, c), d = g1.apply(0, d), {
                x: a,
                y: b,
                x2: c,
                y2: d,
                width: c - a,
                height: d - b,
                cx: a + (c - a) / 2,
                cy: b + (d - b) / 2
            };
        }, j.clone = function(a) {
            a = new i;
            for(var b = 0, c = this.items.length; c > b; b++)a.push(this.items[b].clone());
            return a;
        }, j.toString = function() {
            return "Snap\u2018s set";
        }, j.type = "set", a.Set = i, a.set = function() {
            var a = new i;
            return arguments.length && a.push.apply(a, Array.prototype.slice.call(arguments, 0)), a;
        };
    }), d.plugin(function(a, c, d, e) {
        function f(a) {
            var b = a[0];
            switch(b.toLowerCase()){
                case "t":
                    return [
                        b,
                        0,
                        0
                    ];
                case "m":
                    return [
                        b,
                        1,
                        0,
                        0,
                        1,
                        0,
                        0
                    ];
                case "r":
                    return 4 == a.length ? [
                        b,
                        0,
                        a[2],
                        a[3]
                    ] : [
                        b,
                        0
                    ];
                case "s":
                    return 5 == a.length ? [
                        b,
                        1,
                        1,
                        a[3],
                        a[4]
                    ] : 3 == a.length ? [
                        b,
                        1,
                        1
                    ] : [
                        b,
                        1
                    ];
            }
        }
        function g1(b, c, d) {
            b = b || new a.Matrix, c = c || new a.Matrix, b = a.parseTransformString(b.toTransformString()) || [], c = a.parseTransformString(c.toTransformString()) || [];
            for(var e, g1, h, i, j = Math.max(b.length, c.length), k = [], n = [], o = 0; j > o; o++){
                if (h = b[o] || f(c[o]), i = c[o] || f(h), h[0] != i[0] || "r" == h[0].toLowerCase() && (h[2] != i[2] || h[3] != i[3]) || "s" == h[0].toLowerCase() && (h[3] != i[3] || h[4] != i[4])) {
                    b = a._.transform2matrix(b, d()), c = a._.transform2matrix(c, d()), k = [
                        [
                            "m",
                            b.a,
                            b.b,
                            b.c,
                            b.d,
                            b.e,
                            b.f
                        ]
                    ], n = [
                        [
                            "m",
                            c.a,
                            c.b,
                            c.c,
                            c.d,
                            c.e,
                            c.f
                        ]
                    ];
                    break;
                }
                for(k[o] = [], n[o] = [], e = 0, g1 = Math.max(h.length, i.length); g1 > e; e++)e in h && (k[o][e] = h[e]), e in i && (n[o][e] = i[e]);
            }
            return {
                from: m(k),
                to: m(n),
                f: l(k)
            };
        }
        function h(a) {
            return a;
        }
        function i(a) {
            return function(b) {
                return +b.toFixed(3) + a;
            };
        }
        function j(a) {
            return a.join(" ");
        }
        function k(b) {
            return a.rgb(b[0], b[1], b[2], b[3]);
        }
        function l(a) {
            var b, c, d, e, f, g1, h = 0, i = [];
            for(b = 0, c = a.length; c > b; b++){
                for(f = "[", g1 = [
                    '"' + a[b][0] + '"'
                ], d = 1, e = a[b].length; e > d; d++)g1[d] = "val[" + h++ + "]";
                f += g1 + "]", i[b] = f;
            }
            return Function("val", "return Snap.path.toString.call([" + i + "])");
        }
        function m(a) {
            for(var b = [], c = 0, d = a.length; d > c; c++)for(var e = 1, f = a[c].length; f > e; e++)b.push(a[c][e]);
            return b;
        }
        function n(a) {
            return isFinite(a);
        }
        function o(b, c) {
            return a.is(b, "array") && a.is(c, "array") ? b.toString() == c.toString() : !1;
        }
        var p = {}, q = /[%a-z]+$/i, r = String;
        p.stroke = p.fill = "colour", c.prototype.equal = function(a, c) {
            return b("snap.util.equal", this, a, c).firstDefined();
        }, b.on("snap.util.equal", function(b, c) {
            var d, e, f = r(this.attr(b) || ""), s = this;
            if ("colour" == p[b]) return d = a.color(f), e = a.color(c), {
                from: [
                    d.r,
                    d.g,
                    d.b,
                    d.opacity
                ],
                to: [
                    e.r,
                    e.g,
                    e.b,
                    e.opacity
                ],
                f: k
            };
            if ("viewBox" == b) return d = this.attr(b).vb.split(" ").map(Number), e = c.split(" ").map(Number), {
                from: d,
                to: e,
                f: j
            };
            if ("transform" == b || "gradientTransform" == b || "patternTransform" == b) return "string" == typeof c && (c = r(c).replace(/\.{3}|\u2026/g, f)), f = this.matrix, c = a._.rgTransform.test(c) ? a._.transform2matrix(c, this.getBBox()) : a._.transform2matrix(a._.svgTransform2string(c), this.getBBox()), g1(f, c, function() {
                return s.getBBox(1);
            });
            if ("d" == b || "path" == b) return d = a.path.toCubic(f, c), {
                from: m(d[0]),
                to: m(d[1]),
                f: l(d[0])
            };
            if ("points" == b) return d = r(f).split(a._.separator), e = r(c).split(a._.separator), {
                from: d,
                to: e,
                f: function(a) {
                    return a;
                }
            };
            if (n(f) && n(c)) return {
                from: parseFloat(f),
                to: parseFloat(c),
                f: h
            };
            var t = f.match(q), u = r(c).match(q);
            return t && o(t, u) ? {
                from: parseFloat(f),
                to: parseFloat(c),
                f: i(t)
            } : {
                from: this.asPX(b),
                to: this.asPX(b, c),
                f: h
            };
        });
    }), d.plugin(function(a, c, d, e) {
        for(var f = c.prototype, g1 = "hasOwnProperty", h = ("createTouch" in e.doc), i = [
            "click",
            "dblclick",
            "mousedown",
            "mousemove",
            "mouseout",
            "mouseover",
            "mouseup",
            "touchstart",
            "touchmove",
            "touchend",
            "touchcancel"
        ], j = {
            mousedown: "touchstart",
            mousemove: "touchmove",
            mouseup: "touchend"
        }, k = function(a, b) {
            var c = "y" == a ? "scrollTop" : "scrollLeft", d = b && b.node ? b.node.ownerDocument : e.doc;
            return d[c in d.documentElement ? "documentElement" : "body"][c];
        }, l = function() {
            return this.originalEvent.preventDefault();
        }, m = function() {
            return this.originalEvent.stopPropagation();
        }, n = function(a, b, c, d) {
            var e = h && j[b] ? j[b] : b, f = function(e) {
                var f = k("y", d), i = k("x", d);
                if (h && j[g1](b)) {
                    for(var n = 0, o = e.targetTouches && e.targetTouches.length; o > n; n++)if (e.targetTouches[n].target == a || a.contains(e.targetTouches[n].target)) {
                        var p = e;
                        e = e.targetTouches[n], e.originalEvent = p, e.preventDefault = l, e.stopPropagation = m;
                        break;
                    }
                }
                var q = e.clientX + i, r = e.clientY + f;
                return c.call(d, e, q, r);
            };
            return b !== e && a.addEventListener(b, f, !1), a.addEventListener(e, f, !1), function() {
                return b !== e && a.removeEventListener(b, f, !1), a.removeEventListener(e, f, !1), !0;
            };
        }, o = [], p = function(a) {
            for(var c, d = a.clientX, e = a.clientY, f = k("y"), g1 = k("x"), i = o.length; i--;){
                if (c = o[i], h) {
                    for(var j, l = a.touches && a.touches.length; l--;)if (j = a.touches[l], j.identifier == c.el._drag.id || c.el.node.contains(j.target)) {
                        d = j.clientX, e = j.clientY, (a.originalEvent ? a.originalEvent : a).preventDefault();
                        break;
                    }
                } else a.preventDefault();
                var m = c.el.node;
                m.nextSibling, m.parentNode, m.style.display;
                d += g1, e += f, b("snap.drag.move." + c.el.id, c.move_scope || c.el, d - c.el._drag.x, e - c.el._drag.y, d, e, a);
            }
        }, q = function(c) {
            a.unmousemove(p).unmouseup(q);
            for(var d, e = o.length; e--;)d = o[e], d.el._drag = {}, b("snap.drag.end." + d.el.id, d.end_scope || d.start_scope || d.move_scope || d.el, c), b.off("snap.drag.*." + d.el.id);
            o = [];
        }, r = i.length; r--;)!function(b) {
            a[b] = f[b] = function(c, d) {
                if (a.is(c, "function")) this.events = this.events || [], this.events.push({
                    name: b,
                    f: c,
                    unbind: n(this.node || document, b, c, d || this)
                });
                else for(var e = 0, f = this.events.length; f > e; e++)if (this.events[e].name == b) try {
                    this.events[e].f.call(this);
                } catch (g1) {}
                return this;
            }, a["un" + b] = f["un" + b] = function(a) {
                for(var c = this.events || [], d = c.length; d--;)if (c[d].name == b && (c[d].f == a || !a)) return c[d].unbind(), c.splice(d, 1), !c.length && delete this.events, this;
                return this;
            };
        }(i[r]);
        f.hover = function(a, b, c, d) {
            return this.mouseover(a, c).mouseout(b, d || c);
        }, f.unhover = function(a, b) {
            return this.unmouseover(a).unmouseout(b);
        };
        var s = [];
        f.drag = function(c, d, e, f, g1, h) {
            function i(i, j, l) {
                (i.originalEvent || i).preventDefault(), k._drag.x = j, k._drag.y = l, k._drag.id = i.identifier, !o.length && a.mousemove(p).mouseup(q), o.push({
                    el: k,
                    move_scope: f,
                    start_scope: g1,
                    end_scope: h
                }), d && b.on("snap.drag.start." + k.id, d), c && b.on("snap.drag.move." + k.id, c), e && b.on("snap.drag.end." + k.id, e), b("snap.drag.start." + k.id, g1 || f || k, j, l, i);
            }
            function j(a, c, d) {
                b("snap.draginit." + k.id, k, a, c, d);
            }
            var k = this;
            if (!arguments.length) {
                var l;
                return k.drag(function(a, b) {
                    this.attr({
                        transform: l + (l ? "T" : "t") + [
                            a,
                            b
                        ]
                    });
                }, function() {
                    l = this.transform().local;
                });
            }
            return b.on("snap.draginit." + k.id, i), k._drag = {}, s.push({
                el: k,
                start: i,
                init: j
            }), k.mousedown(j), k;
        }, f.undrag = function() {
            for(var c = s.length; c--;)s[c].el == this && (this.unmousedown(s[c].init), s.splice(c, 1), b.unbind("snap.drag.*." + this.id), b.unbind("snap.draginit." + this.id));
            return !s.length && a.unmousemove(p).unmouseup(q), this;
        };
    }), d.plugin(function(a, c, d, e) {
        var f = (c.prototype, d.prototype), g1 = /^\s*url\((.+)\)/, h = String, i = a._.$;
        a.filter = {}, f.filter = function(b) {
            var d = this;
            "svg" != d.type && (d = d.paper);
            var e = a.parse(h(b)), f = a._.id(), g1 = (d.node.offsetWidth, d.node.offsetHeight, i("filter"));
            return i(g1, {
                id: f,
                filterUnits: "userSpaceOnUse"
            }), g1.appendChild(e.node), d.defs.appendChild(g1), new c(g1);
        }, b.on("snap.util.getattr.filter", function() {
            b.stop();
            var c = i(this.node, "filter");
            if (c) {
                var d = h(c).match(g1);
                return d && a.select(d[1]);
            }
        }), b.on("snap.util.attr.filter", function(d) {
            if (d instanceof c && "filter" == d.type) {
                b.stop();
                var e = d.node.id;
                e || (i(d.node, {
                    id: d.id
                }), e = d.id), i(this.node, {
                    filter: a.url(e)
                });
            }
            d && "none" != d || (b.stop(), this.node.removeAttribute("filter"));
        }), a.filter.blur = function(b, c) {
            null == b && (b = 2);
            var d = null == c ? b : [
                b,
                c
            ];
            return a.format('<feGaussianBlur stdDeviation="{def}"/>', {
                def: d
            });
        }, a.filter.blur.toString = function() {
            return this();
        }, a.filter.shadow = function(b, c, d, e, f) {
            return null == f && (null == e ? (f = d, d = 4, e = "#000") : (f = e, e = d, d = 4)), null == d && (d = 4), null == f && (f = 1), null == b && (b = 0, c = 2), null == c && (c = b), e = a.color(e), a.format('<feGaussianBlur in="SourceAlpha" stdDeviation="{blur}"/><feOffset dx="{dx}" dy="{dy}" result="offsetblur"/><feFlood flood-color="{color}"/><feComposite in2="offsetblur" operator="in"/><feComponentTransfer><feFuncA type="linear" slope="{opacity}"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>', {
                color: e,
                dx: b,
                dy: c,
                blur: d,
                opacity: f
            });
        }, a.filter.shadow.toString = function() {
            return this();
        }, a.filter.grayscale = function(b) {
            return null == b && (b = 1), a.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {b} {h} 0 0 0 0 0 1 0"/>', {
                a: .2126 + .7874 * (1 - b),
                b: .7152 - .7152 * (1 - b),
                c: .0722 - .0722 * (1 - b),
                d: .2126 - .2126 * (1 - b),
                e: .7152 + .2848 * (1 - b),
                f: .0722 - .0722 * (1 - b),
                g: .2126 - .2126 * (1 - b),
                h: .0722 + .9278 * (1 - b)
            });
        }, a.filter.grayscale.toString = function() {
            return this();
        }, a.filter.sepia = function(b) {
            return null == b && (b = 1), a.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {h} {i} 0 0 0 0 0 1 0"/>', {
                a: .393 + .607 * (1 - b),
                b: .769 - .769 * (1 - b),
                c: .189 - .189 * (1 - b),
                d: .349 - .349 * (1 - b),
                e: .686 + .314 * (1 - b),
                f: .168 - .168 * (1 - b),
                g: .272 - .272 * (1 - b),
                h: .534 - .534 * (1 - b),
                i: .131 + .869 * (1 - b)
            });
        }, a.filter.sepia.toString = function() {
            return this();
        }, a.filter.saturate = function(b) {
            return null == b && (b = 1), a.format('<feColorMatrix type="saturate" values="{amount}"/>', {
                amount: 1 - b
            });
        }, a.filter.saturate.toString = function() {
            return this();
        }, a.filter.hueRotate = function(b) {
            return b = b || 0, a.format('<feColorMatrix type="hueRotate" values="{angle}"/>', {
                angle: b
            });
        }, a.filter.hueRotate.toString = function() {
            return this();
        }, a.filter.invert = function(b) {
            return null == b && (b = 1), a.format('<feComponentTransfer><feFuncR type="table" tableValues="{amount} {amount2}"/><feFuncG type="table" tableValues="{amount} {amount2}"/><feFuncB type="table" tableValues="{amount} {amount2}"/></feComponentTransfer>', {
                amount: b,
                amount2: 1 - b
            });
        }, a.filter.invert.toString = function() {
            return this();
        }, a.filter.brightness = function(b) {
            return null == b && (b = 1), a.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}"/><feFuncG type="linear" slope="{amount}"/><feFuncB type="linear" slope="{amount}"/></feComponentTransfer>', {
                amount: b
            });
        }, a.filter.brightness.toString = function() {
            return this();
        }, a.filter.contrast = function(b) {
            return null == b && (b = 1), a.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}" intercept="{amount2}"/><feFuncG type="linear" slope="{amount}" intercept="{amount2}"/><feFuncB type="linear" slope="{amount}" intercept="{amount2}"/></feComponentTransfer>', {
                amount: b,
                amount2: .5 - b / 2
            });
        }, a.filter.contrast.toString = function() {
            return this();
        };
    }), d.plugin(function(a, b, c, d, e) {
        var f = a._.box, g1 = a.is, h = /^[^a-z]*([tbmlrc])/i, i = function() {
            return "T" + this.dx + "," + this.dy;
        };
        b.prototype.getAlign = function(a, b) {
            null == b && g1(a, "string") && (b = a, a = null), a = a || this.paper;
            var c = a.getBBox ? a.getBBox() : f(a), d = this.getBBox(), e = {};
            switch(b = b && b.match(h), b = b ? b[1].toLowerCase() : "c"){
                case "t":
                    e.dx = 0, e.dy = c.y - d.y;
                    break;
                case "b":
                    e.dx = 0, e.dy = c.y2 - d.y2;
                    break;
                case "m":
                    e.dx = 0, e.dy = c.cy - d.cy;
                    break;
                case "l":
                    e.dx = c.x - d.x, e.dy = 0;
                    break;
                case "r":
                    e.dx = c.x2 - d.x2, e.dy = 0;
                    break;
                default:
                    e.dx = c.cx - d.cx, e.dy = 0;
            }
            return e.toString = i, e;
        }, b.prototype.align = function(a, b) {
            return this.transform("..." + this.getAlign(a, b));
        };
    }), d.plugin(function(b, c, d, e) {
        function f(a) {
            a = a.split(/(?=#)/);
            var b = new String(a[5]);
            return b[50] = a[0], b[100] = a[1], b[200] = a[2], b[300] = a[3], b[400] = a[4], b[500] = a[5], b[600] = a[6], b[700] = a[7], b[800] = a[8], b[900] = a[9], a[10] && (b.A100 = a[10], b.A200 = a[11], b.A400 = a[12], b.A700 = a[13]), b;
        }
        var g1 = "#ffebee#ffcdd2#ef9a9a#e57373#ef5350#f44336#e53935#d32f2f#c62828#b71c1c#ff8a80#ff5252#ff1744#d50000", h = "#FCE4EC#F8BBD0#F48FB1#F06292#EC407A#E91E63#D81B60#C2185B#AD1457#880E4F#FF80AB#FF4081#F50057#C51162", i = "#F3E5F5#E1BEE7#CE93D8#BA68C8#AB47BC#9C27B0#8E24AA#7B1FA2#6A1B9A#4A148C#EA80FC#E040FB#D500F9#AA00FF", j = "#EDE7F6#D1C4E9#B39DDB#9575CD#7E57C2#673AB7#5E35B1#512DA8#4527A0#311B92#B388FF#7C4DFF#651FFF#6200EA", k = "#E8EAF6#C5CAE9#9FA8DA#7986CB#5C6BC0#3F51B5#3949AB#303F9F#283593#1A237E#8C9EFF#536DFE#3D5AFE#304FFE", l = "#E3F2FD#BBDEFB#90CAF9#64B5F6#64B5F6#2196F3#1E88E5#1976D2#1565C0#0D47A1#82B1FF#448AFF#2979FF#2962FF", m = "#E1F5FE#B3E5FC#81D4FA#4FC3F7#29B6F6#03A9F4#039BE5#0288D1#0277BD#01579B#80D8FF#40C4FF#00B0FF#0091EA", n = "#E0F7FA#B2EBF2#80DEEA#4DD0E1#26C6DA#00BCD4#00ACC1#0097A7#00838F#006064#84FFFF#18FFFF#00E5FF#00B8D4", o = "#E0F2F1#B2DFDB#80CBC4#4DB6AC#26A69A#009688#00897B#00796B#00695C#004D40#A7FFEB#64FFDA#1DE9B6#00BFA5", p = "#E8F5E9#C8E6C9#A5D6A7#81C784#66BB6A#4CAF50#43A047#388E3C#2E7D32#1B5E20#B9F6CA#69F0AE#00E676#00C853", q = "#F1F8E9#DCEDC8#C5E1A5#AED581#9CCC65#8BC34A#7CB342#689F38#558B2F#33691E#CCFF90#B2FF59#76FF03#64DD17", r = "#F9FBE7#F0F4C3#E6EE9C#DCE775#D4E157#CDDC39#C0CA33#AFB42B#9E9D24#827717#F4FF81#EEFF41#C6FF00#AEEA00", s = "#FFFDE7#FFF9C4#FFF59D#FFF176#FFEE58#FFEB3B#FDD835#FBC02D#F9A825#F57F17#FFFF8D#FFFF00#FFEA00#FFD600", t = "#FFF8E1#FFECB3#FFE082#FFD54F#FFCA28#FFC107#FFB300#FFA000#FF8F00#FF6F00#FFE57F#FFD740#FFC400#FFAB00", u = "#FFF3E0#FFE0B2#FFCC80#FFB74D#FFA726#FF9800#FB8C00#F57C00#EF6C00#E65100#FFD180#FFAB40#FF9100#FF6D00", v = "#FBE9E7#FFCCBC#FFAB91#FF8A65#FF7043#FF5722#F4511E#E64A19#D84315#BF360C#FF9E80#FF6E40#FF3D00#DD2C00", w = "#EFEBE9#D7CCC8#BCAAA4#A1887F#8D6E63#795548#6D4C41#5D4037#4E342E#3E2723", x = "#FAFAFA#F5F5F5#EEEEEE#E0E0E0#BDBDBD#9E9E9E#757575#616161#424242#212121", y = "#ECEFF1#CFD8DC#B0BEC5#90A4AE#78909C#607D8B#546E7A#455A64#37474F#263238";
        b.mui = {}, b.flat = {}, b.mui.red = f(g1), b.mui.pink = f(h), b.mui.purple = f(i), b.mui.deeppurple = f(j), b.mui.indigo = f(k), b.mui.blue = f(l), b.mui.lightblue = f(m), b.mui.cyan = f(n), b.mui.teal = f(o), b.mui.green = f(p), b.mui.lightgreen = f(q), b.mui.lime = f(r), b.mui.yellow = f(s), b.mui.amber = f(t), b.mui.orange = f(u), b.mui.deeporange = f(v), b.mui.brown = f(w), b.mui.grey = f(x), b.mui.bluegrey = f(y), b.flat.turquoise = "#1abc9c", b.flat.greensea = "#16a085", b.flat.sunflower = "#f1c40f", b.flat.orange = "#f39c12", b.flat.emerland = "#2ecc71", b.flat.nephritis = "#27ae60", b.flat.carrot = "#e67e22", b.flat.pumpkin = "#d35400", b.flat.peterriver = "#3498db", b.flat.belizehole = "#2980b9", b.flat.alizarin = "#e74c3c", b.flat.pomegranate = "#c0392b", b.flat.amethyst = "#9b59b6", b.flat.wisteria = "#8e44ad", b.flat.clouds = "#ecf0f1", b.flat.silver = "#bdc3c7", b.flat.wetasphalt = "#34495e", b.flat.midnightblue = "#2c3e50", b.flat.concrete = "#95a5a6", b.flat.asbestos = "#7f8c8d", b.importMUIColors = function() {
            for(var c in b.mui)b.mui.hasOwnProperty(c) && (a[c] = b.mui[c]);
        };
    }), d;
});


var $0322fe2c8531baee$exports = {};

/*!
 * imagesLoaded v5.0.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */ (function(window1, factory) {
    // universal module definition
    if (0, $0322fe2c8531baee$exports) // CommonJS
    $0322fe2c8531baee$exports = factory(window1, (parcelRequire("3BvQE")));
    else // browser global
    window1.imagesLoaded = factory(window1, window1.EvEmitter);
})(typeof window !== 'undefined' ? window : $0322fe2c8531baee$exports, function factory(window1, EvEmitter) {
    let $ = window1.jQuery;
    let console = window1.console;
    // -------------------------- helpers -------------------------- //
    // turn element or nodeList into an array
    function makeArray(obj) {
        // use object if already an array
        if (Array.isArray(obj)) return obj;
        let isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
        // convert nodeList to array
        if (isArrayLike) return [
            ...obj
        ];
        // array of single index
        return [
            obj
        ];
    }
    // -------------------------- imagesLoaded -------------------------- //
    /**
 * @param {[Array, Element, NodeList, String]} elem
 * @param {[Object, Function]} options - if function, use as callback
 * @param {Function} onAlways - callback function
 * @returns {ImagesLoaded}
 */ function ImagesLoaded(elem, options, onAlways) {
        // coerce ImagesLoaded() without new, to be new ImagesLoaded()
        if (!(this instanceof ImagesLoaded)) return new ImagesLoaded(elem, options, onAlways);
        // use elem as selector string
        let queryElem = elem;
        if (typeof elem == 'string') queryElem = document.querySelectorAll(elem);
        // bail if bad element
        if (!queryElem) {
            console.error(`Bad element for imagesLoaded ${queryElem || elem}`);
            return;
        }
        this.elements = makeArray(queryElem);
        this.options = {};
        // shift arguments if no options set
        if (typeof options == 'function') onAlways = options;
        else Object.assign(this.options, options);
        if (onAlways) this.on('always', onAlways);
        this.getImages();
        // add jQuery Deferred object
        if ($) this.jqDeferred = new $.Deferred();
        // HACK check async to allow time to bind listeners
        setTimeout(this.check.bind(this));
    }
    ImagesLoaded.prototype = Object.create(EvEmitter.prototype);
    ImagesLoaded.prototype.getImages = function() {
        this.images = [];
        // filter & find items if we have an item selector
        this.elements.forEach(this.addElementImages, this);
    };
    const elementNodeTypes = [
        1,
        9,
        11
    ];
    /**
 * @param {Node} elem
 */ ImagesLoaded.prototype.addElementImages = function(elem) {
        // filter siblings
        if (elem.nodeName === 'IMG') this.addImage(elem);
        // get background image on element
        if (this.options.background === true) this.addElementBackgroundImages(elem);
        // find children
        // no non-element nodes, #143
        let { nodeType: nodeType } = elem;
        if (!nodeType || !elementNodeTypes.includes(nodeType)) return;
        let childImgs = elem.querySelectorAll('img');
        // concat childElems to filterFound array
        for (let img of childImgs)this.addImage(img);
        // get child background images
        if (typeof this.options.background == 'string') {
            let children = elem.querySelectorAll(this.options.background);
            for (let child of children)this.addElementBackgroundImages(child);
        }
    };
    const reURL = /url\((['"])?(.*?)\1\)/gi;
    ImagesLoaded.prototype.addElementBackgroundImages = function(elem) {
        let style = getComputedStyle(elem);
        // Firefox returns null if in a hidden iframe https://bugzil.la/548397
        if (!style) return;
        // get url inside url("...")
        let matches = reURL.exec(style.backgroundImage);
        while(matches !== null){
            let url = matches && matches[2];
            if (url) this.addBackground(url, elem);
            matches = reURL.exec(style.backgroundImage);
        }
    };
    /**
 * @param {Image} img
 */ ImagesLoaded.prototype.addImage = function(img) {
        let loadingImage = new LoadingImage(img);
        this.images.push(loadingImage);
    };
    ImagesLoaded.prototype.addBackground = function(url, elem) {
        let background = new Background(url, elem);
        this.images.push(background);
    };
    ImagesLoaded.prototype.check = function() {
        this.progressedCount = 0;
        this.hasAnyBroken = false;
        // complete if no images
        if (!this.images.length) {
            this.complete();
            return;
        }
        /* eslint-disable-next-line func-style */ let onProgress = (image, elem, message)=>{
            // HACK - Chrome triggers event before object properties have changed. #83
            setTimeout(()=>{
                this.progress(image, elem, message);
            });
        };
        this.images.forEach(function(loadingImage) {
            loadingImage.once('progress', onProgress);
            loadingImage.check();
        });
    };
    ImagesLoaded.prototype.progress = function(image, elem, message) {
        this.progressedCount++;
        this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
        // progress event
        this.emitEvent('progress', [
            this,
            image,
            elem
        ]);
        if (this.jqDeferred && this.jqDeferred.notify) this.jqDeferred.notify(this, image);
        // check if completed
        if (this.progressedCount === this.images.length) this.complete();
        if (this.options.debug && console) console.log(`progress: ${message}`, image, elem);
    };
    ImagesLoaded.prototype.complete = function() {
        let eventName = this.hasAnyBroken ? 'fail' : 'done';
        this.isComplete = true;
        this.emitEvent(eventName, [
            this
        ]);
        this.emitEvent('always', [
            this
        ]);
        if (this.jqDeferred) {
            let jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
            this.jqDeferred[jqMethod](this);
        }
    };
    // --------------------------  -------------------------- //
    function LoadingImage(img) {
        this.img = img;
    }
    LoadingImage.prototype = Object.create(EvEmitter.prototype);
    LoadingImage.prototype.check = function() {
        // If complete is true and browser supports natural sizes,
        // try to check for image status manually.
        let isComplete = this.getIsImageComplete();
        if (isComplete) {
            // report based on naturalWidth
            this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
            return;
        }
        // If none of the checks above matched, simulate loading on detached element.
        this.proxyImage = new Image();
        // add crossOrigin attribute. #204
        if (this.img.crossOrigin) this.proxyImage.crossOrigin = this.img.crossOrigin;
        this.proxyImage.addEventListener('load', this);
        this.proxyImage.addEventListener('error', this);
        // bind to image as well for Firefox. #191
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        this.proxyImage.src = this.img.currentSrc || this.img.src;
    };
    LoadingImage.prototype.getIsImageComplete = function() {
        // check for non-zero, non-undefined naturalWidth
        // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
        return this.img.complete && this.img.naturalWidth;
    };
    LoadingImage.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        let { parentNode: parentNode } = this.img;
        // emit progress with parent <picture> or self <img>
        let elem = parentNode.nodeName === 'PICTURE' ? parentNode : this.img;
        this.emitEvent('progress', [
            this,
            elem,
            message
        ]);
    };
    // ----- events ----- //
    // trigger specified handler for event type
    LoadingImage.prototype.handleEvent = function(event) {
        let method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    LoadingImage.prototype.onload = function() {
        this.confirm(true, 'onload');
        this.unbindEvents();
    };
    LoadingImage.prototype.onerror = function() {
        this.confirm(false, 'onerror');
        this.unbindEvents();
    };
    LoadingImage.prototype.unbindEvents = function() {
        this.proxyImage.removeEventListener('load', this);
        this.proxyImage.removeEventListener('error', this);
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
    };
    // -------------------------- Background -------------------------- //
    function Background(url, element) {
        this.url = url;
        this.element = element;
        this.img = new Image();
    }
    // inherit LoadingImage prototype
    Background.prototype = Object.create(LoadingImage.prototype);
    Background.prototype.check = function() {
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        this.img.src = this.url;
        // check if image is already complete
        let isComplete = this.getIsImageComplete();
        if (isComplete) {
            this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
            this.unbindEvents();
        }
    };
    Background.prototype.unbindEvents = function() {
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
    };
    Background.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        this.emitEvent('progress', [
            this,
            this.element,
            message
        ]);
    };
    // -------------------------- jQuery -------------------------- //
    ImagesLoaded.makeJQueryPlugin = function(jQuery) {
        jQuery = jQuery || window1.jQuery;
        if (!jQuery) return;
        // set local variable
        $ = jQuery;
        // $().imagesLoaded()
        $.fn.imagesLoaded = function(options, onAlways) {
            let instance = new ImagesLoaded(this, options, onAlways);
            return instance.jqDeferred.promise($(this));
        };
    };
    // try making plugin
    ImagesLoaded.makeJQueryPlugin();
    // --------------------------  -------------------------- //
    return ImagesLoaded;
});


class $3270094ceade3b50$export$2e2bcd8739ae039 {
    constructor(){
        // Array.map
        if (!Array.prototype.map) Array.prototype.map = function(r) {
            var n, t, o;
            if (null == this) throw new TypeError("this is null or not defined");
            var e = Object(this), i = e.length >>> 0;
            if ("function" != typeof r) throw new TypeError(r + " is not a function");
            for(arguments.length > 1 && (n = arguments[1]), t = new Array(i), o = 0; o < i;){
                var a, f;
                o in e && (a = e[o], f = r.call(n, a, o, e), t[o] = f), o++;
            }
            return t;
        };
    }
}


class $772783048621dbd5$export$2e2bcd8739ae039 {
    constructor(){}
    dispatchEventsOnPageLoad(state, eventValue) {
        this.dispatchAnalyticsEvent(state, eventValue);
    }
    dispatchAnalyticsEvent(state, eventValue) {
        if (window && window.dataLayer && window.dataLayer.push && state && eventValue) window.dataLayer.push({
            event: eventValue
        });
    }
}



class $cbac11af7bfe1dad$export$2e2bcd8739ae039 {
    constructor(){
        this.checkboxIdAttr = 'data-persistent-checkbox-id';
        this.checkboxSelector = '[' + this.checkboxIdAttr + ']';
        this.buttonInactiveClass = 'button--unchecked';
        this.buttonActiveClass = 'button--checked';
        this.cookieName = 'persistent-checkbox';
        this.reflectState();
        this.setupEvents();
    }
    reflectState() {
        let state = (0, (/*@__PURE__*/$parcel$interopDefault($4cde099517bdf0a6$exports))).getJSON(this.cookieName) || [];
        for(var i = 0; i < state.length; i++){
            let targets = document.querySelectorAll('[' + this.checkboxIdAttr + '=' + state[i].id + ']');
            targets.forEach((el)=>{
                if (state[i].checked === true) el.setAttribute('aria-pressed', 'true');
                else el.setAttribute('aria-pressed', 'false');
                if (el.tagName === 'INPUT') el.checked = state[i].checked;
                else if (el.classList.contains('button')) {
                    if (state[i].checked) {
                        el.classList.remove(this.buttonInactiveClass);
                        el.classList.add(this.buttonActiveClass);
                    } else {
                        el.classList.remove(this.buttonActiveClass);
                        el.classList.add(this.buttonInactiveClass);
                    }
                }
            });
        }
    }
    setupEvents() {
        document.body.addEventListener('change', (ev)=>{
            if (ev.target.matches(this.checkboxSelector)) this.checkboxChange(ev);
        });
        // Make input id, name and label for attributes unique to avoid checkbox bug.
        const checkboxes = document.querySelectorAll(this.checkboxSelector);
        checkboxes.forEach((el, i)=>{
            let inputId = el.id;
            let inputName = el.name;
            let nextSibling = el.nextElementSibling;
            inputId = inputId ? inputId : 'persistent-checkbox';
            inputName = inputName ? inputName : 'persistent-checkbox';
            el.id = inputId + '-' + i;
            el.name = inputName + '-' + i;
            if (nextSibling) {
                let labelFor = nextSibling.getAttribute('for');
                labelFor = labelFor ? labelFor : 'persistent-checkbox';
                nextSibling.setAttribute('for', labelFor + '-' + i);
            }
        });
    }
    storeCheckboxState(id, checked) {
        let state = (0, (/*@__PURE__*/$parcel$interopDefault($4cde099517bdf0a6$exports))).getJSON(this.cookieName) || [];
        let item = false;
        for(let i = 0; i < state.length; i++)if (state[i].id == id) item = state[i];
        if (!item) {
            item = {};
            state.push(item);
        }
        item.id = id;
        item.checked = checked;
        (0, (/*@__PURE__*/$parcel$interopDefault($4cde099517bdf0a6$exports))).set(this.cookieName, state);
    }
    getCheckedForId(id) {
        let state = (0, (/*@__PURE__*/$parcel$interopDefault($4cde099517bdf0a6$exports))).getJSON(this.cookieName) || [];
        for(var i = 0; i < state.length; i++){
            if (state[i].id === id) return state[i].checked;
        }
        return null;
    }
    checkboxChange(ev) {
        const target = ev.target;
        const targetId = target.getAttribute(this.checkboxIdAttr);
        const isChecked = target.checked;
        this.storeCheckboxState(targetId, isChecked);
        this.reflectState();
    }
}



const $262f4dc95c26964e$export$16639f4b488a4ee6 = 'animations-active-change';
class $262f4dc95c26964e$export$2e2bcd8739ae039 {
    constructor(stateHandler){
        this.stateHandler = stateHandler;
        this.persistentCheckbox = new (0, $cbac11af7bfe1dad$export$2e2bcd8739ae039)();
        this.persistentCheckboxId = 'animation-controller';
        this.animationControllerSelector = '[data-animation-controller]';
        this.isAnimationsActive = false;
        this.updateValue();
        this.setupEvents();
    }
    updateValue(ev) {
        let checkboxValue = this.persistentCheckbox.getCheckedForId(this.persistentCheckboxId);
        // null == not previously set, should be "on" per default
        if (checkboxValue === null) checkboxValue = true;
        this.isAnimationsActive = checkboxValue;
        if (this.isAnimationsActive) document.body.classList.add('animations-active');
        else document.body.classList.remove('animations-active');
        this.stateHandler.trigger($262f4dc95c26964e$export$16639f4b488a4ee6, this.isAnimationsActive);
    }
    setupEvents() {
        const controller = document.querySelector(this.animationControllerSelector);
        if (!controller) return;
        controller.addEventListener('change', ()=>{
            setTimeout(this.updateValue.bind(this), 10);
        });
    }
}




class $49bb30ae7944f01e$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($49c4be87a5e25114$exports))) {
    constructor(stateHandler){
        super();
        this.containerSelector = '.animated-background-image';
        this.imageSelector = '.animated-background-image__item';
        this.imagePxWidth = 200;
        this.imagePxHeight = 200;
        this.animatedClass = 'animated-background-image__item--animated';
        this.desktopBreakpointPx = '500';
        stateHandler.on((0, $262f4dc95c26964e$export$16639f4b488a4ee6), (isActive)=>{
            this.isActive = isActive;
            this.resize();
        });
        this.setupEvents();
    }
    setupEvents() {
        window.addEventListener('resize', ()=>this.resize());
        this.resize();
    }
    resize() {
        if (this.shouldAnimate()) {
            this.destructElements();
            this.constructElements();
        } else this.destructElements();
    }
    setNewPosition(width, height) {
        const container = document.querySelector(this.containerSelector);
        const maxX = container.offsetWidth - width;
        const maxY = container.offsetHeight - height;
        const x = Math.floor(Math.random() * maxX);
        const y = Math.floor(Math.random() * maxY);
        return 'translate(' + x + 'px,' + y + 'px)';
    }
    animate(ele) {
        if (!this.shouldAnimate()) return;
        ele.classList.add(this.animatedClass);
        ele.style.transform = this.setNewPosition(ele.offsetWidth, ele.offsetHeight);
    }
    onTransitionEnd(ele) {
        this.animate(ele);
    }
    constructElements() {
        const images = document.querySelectorAll(this.imageSelector);
        images.forEach((ele)=>{
            ele.style.transform = this.setNewPosition(ele.offsetWidth, ele.offsetHeight);
            ele.addEventListener('transitionend', this.onTransitionEnd.bind(this, ele));
            setTimeout(this.animate.bind(this, ele), 0);
        });
    }
    destructElements() {
        const images = document.querySelectorAll(this.imageSelector);
        images.forEach((ele)=>{
            ele.classList.remove(this.animatedClass);
        });
    }
    getRandomArbitrary(min, max) {
        return Math.round(Math.random() * (max - min) + min);
    }
    isDesktop() {
        const mq = window.matchMedia('(min-width: ' + this.desktopBreakpointPx + 'px)');
        return mq.matches ? true : false;
    }
    shouldAnimate() {
        return this.isDesktop() && this.isActive;
    }
}


var $1d141b3a2199ca13$exports = {};

$1d141b3a2199ca13$exports = (parcelRequire("94H9l"));




class $b969aba65d155e20$export$2e2bcd8739ae039 {
    constructor(cookieBarHandler){
        this.analytics = new (0, $772783048621dbd5$export$2e2bcd8739ae039)();
        this.cookieBarHandler = cookieBarHandler;
        this.acceptedCookieName = '';
        this.onStatusChange = this.onStatusChange.bind(this);
        this.setup();
    }
    setup() {
        const componentClass = '.js--cookiesettings';
        const element = document.querySelector(componentClass);
        if (!element) return;
        this.acceptedCookieName = element.attributes['data-cookie-notice-dismissed-name'].value;
        this.defaultCookieGroup = element.attributes['data-default-cookie-group'].value;
        this.setCookieGroups;
        // read back set cookie
        var existingCookie = $4cde099517bdf0a6$exports.get(this.acceptedCookieName);
        if (existingCookie) this.setCookieGroups = existingCookie.split(",");
        if (element) this._component = new (0, (/*@__PURE__*/$parcel$interopDefault($1d141b3a2199ca13$exports)))({
            el: element,
            data: ()=>({
                    checkedGroups: this.setCookieGroups ? this.setCookieGroups : [
                        this.defaultCookieGroup
                    ] //default value
                }),
            methods: {
                changeStatusChange: this.onStatusChange
            }
        });
    }
    onStatusChange(e) {
        const cookieGroups = this._component.checkedGroups.join(',').replace('"', '');
        $4cde099517bdf0a6$exports.set(this.acceptedCookieName, cookieGroups, {
            expires: 365
        });
        if (this.analytics) this.analytics.dispatchAnalyticsEvent(true, 'has_ga_cookie_consent');
        if (cookieGroups.includes(this.defaultCookieGroup)) this.cookieBarHandler.hideCookieBar();
        this.cookieBarHandler.updateAccepted();
    }
    updateCheckedGroups(cookieGroupName) {
        console.log('update cookie groups', cookieGroupName);
        if (this._component) this._component.checkedGroups = cookieGroupName.split(",");
    }
}





class $662aa7ffe8e46681$export$2e2bcd8739ae039 {
    constructor(cookieSettingsHandler){
        this.analytics = new (0, $772783048621dbd5$export$2e2bcd8739ae039)();
        this.cookieSettingsHandler = cookieSettingsHandler;
        this.onAccept = this.onAccept.bind(this);
        this.acceptedCookieName = '';
        this.defaultCookieGroup = '';
        this.setup();
    }
    setup() {
        const componentClass = '.js--cookiebar';
        const element = document.querySelector(componentClass);
        if (!element) return;
        this.acceptedCookieName = element.attributes['data-cookie-notice-dismissed-name'].value;
        this.defaultCookieGroup = element.attributes['data-default-cookie-group'].value;
        const accepted = $4cde099517bdf0a6$exports.get(this.acceptedCookieName);
        if (!accepted && element) this._component = new (0, (/*@__PURE__*/$parcel$interopDefault($1d141b3a2199ca13$exports)))({
            el: element,
            data: ()=>({
                    visible: true
                }),
            methods: {
                clickAccept: this.onAccept
            }
        });
    }
    onAccept(e) {
        var cookieGroupName = e.target.attributes['data-cookie-allowed-group-name'].value;
        // add default cookie group if not selected
        if (cookieGroupName !== this.defaultCookieGroup) cookieGroupName = [
            this.defaultCookieGroup,
            cookieGroupName
        ].join(',').replace('"', '');
        e.preventDefault();
        this._component.visible = false;
        $4cde099517bdf0a6$exports.set(this.acceptedCookieName, cookieGroupName, {
            expires: 365
        });
        if (this.analytics) this.analytics.dispatchAnalyticsEvent(true, 'has_cookie_consent');
        // Call updateCheckedGroups from CookieSettingsHandler
        this.cookieSettingsHandler.updateCheckedGroups(cookieGroupName);
    }
    hideCookieBar() {
        if (this._component) {
            this._component.visible = false;
            this._component.$el.classList.remove('cookiebar--visible');
        }
    }
    updateAccepted() {
        const accepted = $4cde099517bdf0a6$exports.get(this.acceptedCookieName);
        if (!accepted && this._component) this._component.visible = true;
        else if (this._component) this._component.visible = false;
    }
}


class $22f8a7b52501b877$export$2e2bcd8739ae039 {
    constructor(){
        this.setup();
        this.keyDownListener = this.keyDownListener.bind(this);
    }
    setup() {
        this.popups = document.querySelectorAll('.popup');
        this.openButtons = document.querySelectorAll('.button--open-popup');
        this.closeButtons = document.querySelectorAll('.js--button--close-popup');
        this.popups.forEach((popup)=>{
            popup.classList.add('popup--closed');
        });
        this.openButtons.forEach((button)=>{
            button.addEventListener('click', (e)=>{
                e.preventDefault();
                const id = e.currentTarget.dataset.popupId;
                this.openPopup(id);
            });
        });
        this.closeButtons.forEach((button)=>{
            button.addEventListener('click', (e)=>{
                e.preventDefault();
                const id = e.currentTarget.closest('.popup').dataset.id;
                this.closePopup(id);
            });
        });
    }
    // trap focus in modal
    enableTrapFocus() {
        const closeButton = document.querySelector('.js--button--close-popup');
        closeButton.focus(); // add initial focus
        const popup = document.querySelector('.popup'); // select the modal by class
        const focusableElements = 'button, [href], a';
        const focusableContent = popup.querySelectorAll(focusableElements);
        this.firstFocusableElement = focusableContent[0]; // get first element to be focused inside modal
        this.lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal
        document.addEventListener('keydown', this.keyDownListener);
    }
    keyDownListener(event) {
        const isTabPressed = event.key === 'Tab' || event.keyCode === 9;
        if (!isTabPressed) return;
        if (event.shiftKey) // if shift key pressed for shift + tab combination
        {
            if (document.activeElement === this.firstFocusableElement) {
                const closeButton = document.querySelector('.js--button--close-popup');
                closeButton.focus(); // add focus for the last focusable element
                event.preventDefault();
            }
        } else // if tab key is pressed
        if (document.activeElement === this.lastFocusableElement) {
            // if focused has reached to last focusable element then focus first focusable element after pressing tab
            const closeButton = document.querySelector('.js--button--close-popup');
            closeButton.focus();
            event.preventDefault();
        }
    }
    disableTrapFocus() {
        const openButton = document.querySelector('.button--open-popup');
        openButton.focus();
        document.removeEventListener('keydown', this.keyDownListener);
    }
    openPopup(id) {
        const popup = document.querySelector(`.popup[data-id="${id}"]`);
        popup.classList.remove('popup--closed');
        popup.classList.add('popup--opened');
        document.documentElement.classList.add('has-popup');
        this.enableTrapFocus();
    }
    closePopup(id) {
        const popup = document.querySelector(`.popup[data-id="${id}"]`);
        popup.classList.remove('popup--opened');
        popup.classList.add('popup--closed');
        document.documentElement.classList.remove('has-popup');
        this.disableTrapFocus();
    }
}


'use strict';
function $fc8f2e2c969d032f$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}



'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $8ca3655f37d9652c$var$toString } = Object.prototype;
const { getPrototypeOf: $8ca3655f37d9652c$var$getPrototypeOf } = Object;
const $8ca3655f37d9652c$var$kindOf = ((cache)=>(thing)=>{
        const str = $8ca3655f37d9652c$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $8ca3655f37d9652c$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$8ca3655f37d9652c$var$kindOf(thing) === type;
};
const $8ca3655f37d9652c$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $8ca3655f37d9652c$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $8ca3655f37d9652c$var$isUndefined = $8ca3655f37d9652c$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $8ca3655f37d9652c$var$isBuffer(val) {
    return val !== null && !$8ca3655f37d9652c$var$isUndefined(val) && val.constructor !== null && !$8ca3655f37d9652c$var$isUndefined(val.constructor) && $8ca3655f37d9652c$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $8ca3655f37d9652c$var$isArrayBuffer = $8ca3655f37d9652c$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $8ca3655f37d9652c$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $8ca3655f37d9652c$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $8ca3655f37d9652c$var$isString = $8ca3655f37d9652c$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $8ca3655f37d9652c$var$isFunction = $8ca3655f37d9652c$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $8ca3655f37d9652c$var$isNumber = $8ca3655f37d9652c$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $8ca3655f37d9652c$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $8ca3655f37d9652c$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $8ca3655f37d9652c$var$isPlainObject = (val)=>{
    if ($8ca3655f37d9652c$var$kindOf(val) !== 'object') return false;
    const prototype = $8ca3655f37d9652c$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $8ca3655f37d9652c$var$isDate = $8ca3655f37d9652c$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $8ca3655f37d9652c$var$isFile = $8ca3655f37d9652c$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $8ca3655f37d9652c$var$isBlob = $8ca3655f37d9652c$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $8ca3655f37d9652c$var$isFileList = $8ca3655f37d9652c$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $8ca3655f37d9652c$var$isStream = (val)=>$8ca3655f37d9652c$var$isObject(val) && $8ca3655f37d9652c$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $8ca3655f37d9652c$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $8ca3655f37d9652c$var$isFunction(thing.append) && ((kind = $8ca3655f37d9652c$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $8ca3655f37d9652c$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $8ca3655f37d9652c$var$isURLSearchParams = $8ca3655f37d9652c$var$kindOfTest('URLSearchParams');
const [$8ca3655f37d9652c$var$isReadableStream, $8ca3655f37d9652c$var$isRequest, $8ca3655f37d9652c$var$isResponse, $8ca3655f37d9652c$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($8ca3655f37d9652c$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $8ca3655f37d9652c$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $8ca3655f37d9652c$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($8ca3655f37d9652c$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $8ca3655f37d9652c$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $8ca3655f37d9652c$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $8ca3655f37d9652c$var$isContextDefined = (context)=>!$8ca3655f37d9652c$var$isUndefined(context) && context !== $8ca3655f37d9652c$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $8ca3655f37d9652c$var$merge() {
    const { caseless: caseless } = $8ca3655f37d9652c$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $8ca3655f37d9652c$var$findKey(result, key) || key;
        if ($8ca3655f37d9652c$var$isPlainObject(result[targetKey]) && $8ca3655f37d9652c$var$isPlainObject(val)) result[targetKey] = $8ca3655f37d9652c$var$merge(result[targetKey], val);
        else if ($8ca3655f37d9652c$var$isPlainObject(val)) result[targetKey] = $8ca3655f37d9652c$var$merge({}, val);
        else if ($8ca3655f37d9652c$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $8ca3655f37d9652c$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $8ca3655f37d9652c$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $8ca3655f37d9652c$var$forEach(b, (val, key)=>{
        if (thisArg && $8ca3655f37d9652c$var$isFunction(val)) a[key] = (0, $fc8f2e2c969d032f$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $8ca3655f37d9652c$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $8ca3655f37d9652c$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $8ca3655f37d9652c$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $8ca3655f37d9652c$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $8ca3655f37d9652c$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $8ca3655f37d9652c$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($8ca3655f37d9652c$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$8ca3655f37d9652c$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $8ca3655f37d9652c$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $8ca3655f37d9652c$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $8ca3655f37d9652c$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $8ca3655f37d9652c$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $8ca3655f37d9652c$var$isHTMLForm = $8ca3655f37d9652c$var$kindOfTest('HTMLFormElement');
const $8ca3655f37d9652c$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $8ca3655f37d9652c$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $8ca3655f37d9652c$var$isRegExp = $8ca3655f37d9652c$var$kindOfTest('RegExp');
const $8ca3655f37d9652c$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $8ca3655f37d9652c$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $8ca3655f37d9652c$var$freezeMethods = (obj)=>{
    $8ca3655f37d9652c$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($8ca3655f37d9652c$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$8ca3655f37d9652c$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $8ca3655f37d9652c$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $8ca3655f37d9652c$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $8ca3655f37d9652c$var$noop = ()=>{};
const $8ca3655f37d9652c$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $8ca3655f37d9652c$var$isSpecCompliantForm(thing) {
    return !!(thing && $8ca3655f37d9652c$var$isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}
const $8ca3655f37d9652c$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($8ca3655f37d9652c$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $8ca3655f37d9652c$var$isArray(source) ? [] : {};
                $8ca3655f37d9652c$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$8ca3655f37d9652c$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $8ca3655f37d9652c$var$isAsyncFn = $8ca3655f37d9652c$var$kindOfTest('AsyncFunction');
const $8ca3655f37d9652c$var$isThenable = (thing)=>thing && ($8ca3655f37d9652c$var$isObject(thing) || $8ca3655f37d9652c$var$isFunction(thing)) && $8ca3655f37d9652c$var$isFunction(thing.then) && $8ca3655f37d9652c$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $8ca3655f37d9652c$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $8ca3655f37d9652c$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $8ca3655f37d9652c$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $8ca3655f37d9652c$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $8ca3655f37d9652c$var$isFunction($8ca3655f37d9652c$var$_global.postMessage));
const $8ca3655f37d9652c$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($8ca3655f37d9652c$var$_global) : typeof $4acf49f6c3e67aec$exports !== 'undefined' && $4acf49f6c3e67aec$exports.nextTick || $8ca3655f37d9652c$var$_setImmediate;
var // *********************
$8ca3655f37d9652c$export$2e2bcd8739ae039 = {
    isArray: $8ca3655f37d9652c$var$isArray,
    isArrayBuffer: $8ca3655f37d9652c$var$isArrayBuffer,
    isBuffer: $8ca3655f37d9652c$var$isBuffer,
    isFormData: $8ca3655f37d9652c$var$isFormData,
    isArrayBufferView: $8ca3655f37d9652c$var$isArrayBufferView,
    isString: $8ca3655f37d9652c$var$isString,
    isNumber: $8ca3655f37d9652c$var$isNumber,
    isBoolean: $8ca3655f37d9652c$var$isBoolean,
    isObject: $8ca3655f37d9652c$var$isObject,
    isPlainObject: $8ca3655f37d9652c$var$isPlainObject,
    isReadableStream: $8ca3655f37d9652c$var$isReadableStream,
    isRequest: $8ca3655f37d9652c$var$isRequest,
    isResponse: $8ca3655f37d9652c$var$isResponse,
    isHeaders: $8ca3655f37d9652c$var$isHeaders,
    isUndefined: $8ca3655f37d9652c$var$isUndefined,
    isDate: $8ca3655f37d9652c$var$isDate,
    isFile: $8ca3655f37d9652c$var$isFile,
    isBlob: $8ca3655f37d9652c$var$isBlob,
    isRegExp: $8ca3655f37d9652c$var$isRegExp,
    isFunction: $8ca3655f37d9652c$var$isFunction,
    isStream: $8ca3655f37d9652c$var$isStream,
    isURLSearchParams: $8ca3655f37d9652c$var$isURLSearchParams,
    isTypedArray: $8ca3655f37d9652c$var$isTypedArray,
    isFileList: $8ca3655f37d9652c$var$isFileList,
    forEach: $8ca3655f37d9652c$var$forEach,
    merge: $8ca3655f37d9652c$var$merge,
    extend: $8ca3655f37d9652c$var$extend,
    trim: $8ca3655f37d9652c$var$trim,
    stripBOM: $8ca3655f37d9652c$var$stripBOM,
    inherits: $8ca3655f37d9652c$var$inherits,
    toFlatObject: $8ca3655f37d9652c$var$toFlatObject,
    kindOf: $8ca3655f37d9652c$var$kindOf,
    kindOfTest: $8ca3655f37d9652c$var$kindOfTest,
    endsWith: $8ca3655f37d9652c$var$endsWith,
    toArray: $8ca3655f37d9652c$var$toArray,
    forEachEntry: $8ca3655f37d9652c$var$forEachEntry,
    matchAll: $8ca3655f37d9652c$var$matchAll,
    isHTMLForm: $8ca3655f37d9652c$var$isHTMLForm,
    hasOwnProperty: $8ca3655f37d9652c$var$hasOwnProperty,
    hasOwnProp: $8ca3655f37d9652c$var$hasOwnProperty,
    reduceDescriptors: $8ca3655f37d9652c$var$reduceDescriptors,
    freezeMethods: $8ca3655f37d9652c$var$freezeMethods,
    toObjectSet: $8ca3655f37d9652c$var$toObjectSet,
    toCamelCase: $8ca3655f37d9652c$var$toCamelCase,
    noop: $8ca3655f37d9652c$var$noop,
    toFiniteNumber: $8ca3655f37d9652c$var$toFiniteNumber,
    findKey: $8ca3655f37d9652c$var$findKey,
    global: $8ca3655f37d9652c$var$_global,
    isContextDefined: $8ca3655f37d9652c$var$isContextDefined,
    isSpecCompliantForm: $8ca3655f37d9652c$var$isSpecCompliantForm,
    toJSONObject: $8ca3655f37d9652c$var$toJSONObject,
    isAsyncFn: $8ca3655f37d9652c$var$isAsyncFn,
    isThenable: $8ca3655f37d9652c$var$isThenable,
    setImmediate: $8ca3655f37d9652c$var$_setImmediate,
    asap: $8ca3655f37d9652c$var$asap
};







'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $44aee3fe793a4c74$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).inherits($44aee3fe793a4c74$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $44aee3fe793a4c74$var$prototype = $44aee3fe793a4c74$var$AxiosError.prototype;
const $44aee3fe793a4c74$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $44aee3fe793a4c74$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($44aee3fe793a4c74$var$AxiosError, $44aee3fe793a4c74$var$descriptors);
Object.defineProperty($44aee3fe793a4c74$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$44aee3fe793a4c74$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($44aee3fe793a4c74$var$prototype);
    (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    $44aee3fe793a4c74$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $44aee3fe793a4c74$export$2e2bcd8739ae039 = $44aee3fe793a4c74$var$AxiosError;


// eslint-disable-next-line strict
var $82d0d0537dc0bac3$export$2e2bcd8739ae039 = null;



var $0c29ca57d54f85e9$require$Buffer = $24f87a6f86a8996f$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $0c29ca57d54f85e9$var$isVisitable(thing) {
    return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $0c29ca57d54f85e9$var$removeBrackets(key) {
    return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $0c29ca57d54f85e9$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $0c29ca57d54f85e9$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $0c29ca57d54f85e9$var$isFlatArray(arr) {
    return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(arr) && !arr.some($0c29ca57d54f85e9$var$isVisitable);
}
const $0c29ca57d54f85e9$var$predicates = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toFlatObject((0, $8ca3655f37d9652c$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $0c29ca57d54f85e9$var$toFormData(obj, formData, options) {
    if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $82d0d0537dc0bac3$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $0c29ca57d54f85e9$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(value) && $0c29ca57d54f85e9$var$isFlatArray(value) || ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFileList(value) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $0c29ca57d54f85e9$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $0c29ca57d54f85e9$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($0c29ca57d54f85e9$var$isVisitable(value)) return true;
        formData.append($0c29ca57d54f85e9$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($0c29ca57d54f85e9$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $0c29ca57d54f85e9$var$isVisitable
    });
    function build(value, path) {
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $0c29ca57d54f85e9$export$2e2bcd8739ae039 = $0c29ca57d54f85e9$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $63e4e0dff2b7ef1a$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $63e4e0dff2b7ef1a$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $0c29ca57d54f85e9$export$2e2bcd8739ae039)(params, this, options);
}
const $63e4e0dff2b7ef1a$var$prototype = $63e4e0dff2b7ef1a$var$AxiosURLSearchParams.prototype;
$63e4e0dff2b7ef1a$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$63e4e0dff2b7ef1a$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $63e4e0dff2b7ef1a$var$encode);
    } : $63e4e0dff2b7ef1a$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $63e4e0dff2b7ef1a$export$2e2bcd8739ae039 = $63e4e0dff2b7ef1a$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $4858799f155a4706$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $4858799f155a4706$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $4858799f155a4706$var$encode;
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $63e4e0dff2b7ef1a$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $089e14d5c08cea15$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $089e14d5c08cea15$export$2e2bcd8739ae039 = $089e14d5c08cea15$var$InterceptorManager;





'use strict';
var $c54b4d6d29e2eb6b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






'use strict';
var $d2ba66411c13cc9b$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $63e4e0dff2b7ef1a$export$2e2bcd8739ae039);


'use strict';
var $7cdf1698dc68a071$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $2e86ffb493d13ed1$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $97999e9cdfd9bdaf$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $d2ba66411c13cc9b$export$2e2bcd8739ae039,
        FormData: $7cdf1698dc68a071$export$2e2bcd8739ae039,
        Blob: $2e86ffb493d13ed1$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $dcb238ff33d5089b$exports = {};

$parcel$export($dcb238ff33d5089b$exports, "hasBrowserEnv", function () { return $dcb238ff33d5089b$export$c4996c4b7b93b0bf; });
$parcel$export($dcb238ff33d5089b$exports, "navigator", function () { return $dcb238ff33d5089b$export$ec7c8efa7f5790ae; });
$parcel$export($dcb238ff33d5089b$exports, "hasStandardBrowserEnv", function () { return $dcb238ff33d5089b$export$c0bcc9250309d66; });
$parcel$export($dcb238ff33d5089b$exports, "hasStandardBrowserWebWorkerEnv", function () { return $dcb238ff33d5089b$export$c81692cf5af97dac; });
$parcel$export($dcb238ff33d5089b$exports, "origin", function () { return $dcb238ff33d5089b$export$f710a83a91838a36; });
const $dcb238ff33d5089b$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $dcb238ff33d5089b$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $dcb238ff33d5089b$export$c0bcc9250309d66 = $dcb238ff33d5089b$export$c4996c4b7b93b0bf && (!$dcb238ff33d5089b$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($dcb238ff33d5089b$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $dcb238ff33d5089b$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $dcb238ff33d5089b$export$f710a83a91838a36 = $dcb238ff33d5089b$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $96659b0ab5a2bc56$export$2e2bcd8739ae039 = {
    ...$dcb238ff33d5089b$exports,
    ...(0, $97999e9cdfd9bdaf$export$2e2bcd8739ae039)
};


'use strict';
function $3444de215011fd2b$export$2e2bcd8739ae039(data, options) {
    return (0, $0c29ca57d54f85e9$export$2e2bcd8739ae039)(data, new (0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).isNode && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $bdd273a6ec9f935e$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $bdd273a6ec9f935e$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $bdd273a6ec9f935e$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $bdd273a6ec9f935e$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFormData(formData) && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($bdd273a6ec9f935e$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $bdd273a6ec9f935e$export$2e2bcd8739ae039 = $bdd273a6ec9f935e$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $8d19883a18ea96be$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $8d19883a18ea96be$var$defaults = {
    transitional: (0, $c54b4d6d29e2eb6b$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $bdd273a6ec9f935e$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isBuffer(data) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isStream(data) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFile(data) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isBlob(data) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $3444de215011fd2b$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $0c29ca57d54f85e9$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $8d19883a18ea96be$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $8d19883a18ea96be$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isResponse(data) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).from(e, (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $8d19883a18ea96be$var$defaults.headers[method] = {};
});
var $8d19883a18ea96be$export$2e2bcd8739ae039 = $8d19883a18ea96be$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $102410410d0dc09d$var$ignoreDuplicateOf = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $102410410d0dc09d$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $102410410d0dc09d$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $c2923f037e2bae4f$var$$internals = Symbol('internals');
function $c2923f037e2bae4f$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $c2923f037e2bae4f$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(value) ? value.map($c2923f037e2bae4f$var$normalizeValue) : String(value);
}
function $c2923f037e2bae4f$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $c2923f037e2bae4f$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $c2923f037e2bae4f$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $c2923f037e2bae4f$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $c2923f037e2bae4f$var$buildAccessors(obj, header) {
    const accessorName = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $c2923f037e2bae4f$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $c2923f037e2bae4f$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $c2923f037e2bae4f$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$c2923f037e2bae4f$var$isValidHeaderName(header)) setHeaders((0, $102410410d0dc09d$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $c2923f037e2bae4f$var$normalizeHeader(header);
        if (header) {
            const key = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $c2923f037e2bae4f$var$parseTokens(value);
                if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $c2923f037e2bae4f$var$normalizeHeader(header);
        if (header) {
            const key = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $c2923f037e2bae4f$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $c2923f037e2bae4f$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $c2923f037e2bae4f$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $c2923f037e2bae4f$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $c2923f037e2bae4f$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $c2923f037e2bae4f$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $c2923f037e2bae4f$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$c2923f037e2bae4f$var$$internals] = this[$c2923f037e2bae4f$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $c2923f037e2bae4f$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $c2923f037e2bae4f$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$c2923f037e2bae4f$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).reduceDescriptors($c2923f037e2bae4f$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).freezeMethods($c2923f037e2bae4f$var$AxiosHeaders);
var $c2923f037e2bae4f$export$2e2bcd8739ae039 = $c2923f037e2bae4f$var$AxiosHeaders;


'use strict';
function $e27ce2658796d30f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $8d19883a18ea96be$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $ffcdf0443516cf49$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $a251e9fa67c89486$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).inherits($a251e9fa67c89486$var$CanceledError, (0, $44aee3fe793a4c74$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $a251e9fa67c89486$export$2e2bcd8739ae039 = $a251e9fa67c89486$var$CanceledError;







'use strict';
function $df046ee58fb378eb$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $39416e5131ec2dd8$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $a1af1a7f806b22ba$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $a1af1a7f806b22ba$export$2e2bcd8739ae039 = $a1af1a7f806b22ba$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $8ecc9a2101455cbb$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $8ecc9a2101455cbb$export$2e2bcd8739ae039 = $8ecc9a2101455cbb$var$throttle;



const $4d12b2770b9a110e$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $a1af1a7f806b22ba$export$2e2bcd8739ae039)(50, 250);
    return (0, $8ecc9a2101455cbb$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $4d12b2770b9a110e$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $4d12b2770b9a110e$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $6c85e22328488296$export$2e2bcd8739ae039 = (0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).origin), (0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $e52288d5ced91a0f$export$2e2bcd8739ae039 = (0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(path) && cookie.push('path=' + path);
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $57cabc98a428ac0d$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $b453718e09262365$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $c5c7eeec01fb8b89$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $57cabc98a428ac0d$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && isRelativeUrl || allowAbsoluteUrls == false) return (0, $b453718e09262365$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $ed738da9502ca495$var$headersToObject = (thing)=>thing instanceof (0, $c2923f037e2bae4f$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $ed738da9502ca495$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isPlainObject(target) && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($ed738da9502ca495$var$headersToObject(a), $ed738da9502ca495$var$headersToObject(b), prop, true)
    };
    (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $f17e6a7b4883a134$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $ed738da9502ca495$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $4858799f155a4706$export$2e2bcd8739ae039)((0, $c5c7eeec01fb8b89$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $6c85e22328488296$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $e52288d5ced91a0f$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $85bd0ac91b9e9771$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $85bd0ac91b9e9771$export$2e2bcd8739ae039 = $85bd0ac91b9e9771$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $f17e6a7b4883a134$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $df046ee58fb378eb$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)('Request aborted', (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)('Network Error', (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $c54b4d6d29e2eb6b$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ETIMEDOUT : (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $4d12b2770b9a110e$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $4d12b2770b9a110e$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $a251e9fa67c89486$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $39416e5131ec2dd8$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $622ea438e7cb5cf5$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $44aee3fe793a4c74$export$2e2bcd8739ae039) ? err : new (0, $a251e9fa67c89486$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $622ea438e7cb5cf5$export$2e2bcd8739ae039 = $622ea438e7cb5cf5$var$composeSignals;


const $f43abe8046874bdd$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $f43abe8046874bdd$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $f43abe8046874bdd$var$readStream(iterable))yield* $f43abe8046874bdd$export$71b051935044bd5d(chunk, chunkSize);
};
const $f43abe8046874bdd$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $f43abe8046874bdd$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $f43abe8046874bdd$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $3477ac01bee1324a$var$isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const $3477ac01bee1324a$var$isReadableStreamSupported = $3477ac01bee1324a$var$isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const $3477ac01bee1324a$var$encodeText = $3477ac01bee1324a$var$isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $3477ac01bee1324a$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $3477ac01bee1324a$var$supportsRequestStream = $3477ac01bee1324a$var$isReadableStreamSupported && $3477ac01bee1324a$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const $3477ac01bee1324a$var$DEFAULT_CHUNK_SIZE = 65536;
const $3477ac01bee1324a$var$supportsResponseStream = $3477ac01bee1324a$var$isReadableStreamSupported && $3477ac01bee1324a$var$test(()=>(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
const $3477ac01bee1324a$var$resolvers = {
    stream: $3477ac01bee1324a$var$supportsResponseStream && ((res)=>res.body)
};
$3477ac01bee1324a$var$isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !$3477ac01bee1324a$var$resolvers[type] && ($3477ac01bee1324a$var$resolvers[type] = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $3477ac01bee1324a$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).origin, {
            method: 'POST',
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(body)) return (await $3477ac01bee1324a$var$encodeText(body)).byteLength;
};
const $3477ac01bee1324a$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $3477ac01bee1324a$var$getBodyLength(body) : length;
};
var $3477ac01bee1324a$export$2e2bcd8739ae039 = $3477ac01bee1324a$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $f17e6a7b4883a134$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, $622ea438e7cb5cf5$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $3477ac01bee1324a$var$supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await $3477ac01bee1324a$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $4d12b2770b9a110e$export$d9fadd12586c18d6)(requestContentLength, (0, $4d12b2770b9a110e$export$c1b28109d46c3592)((0, $4d12b2770b9a110e$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $f43abe8046874bdd$export$b0119225647bd83)(_request.body, $3477ac01bee1324a$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $3477ac01bee1324a$var$supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if ($3477ac01bee1324a$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, $4d12b2770b9a110e$export$d9fadd12586c18d6)(responseContentLength, (0, $4d12b2770b9a110e$export$c1b28109d46c3592)((0, $4d12b2770b9a110e$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $f43abe8046874bdd$export$b0119225647bd83)(response.body, $3477ac01bee1324a$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await $3477ac01bee1324a$var$resolvers[(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).findKey($3477ac01bee1324a$var$resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $df046ee58fb378eb$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) throw Object.assign(new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)('Network Error', (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $b57d5c296e05dd0f$var$knownAdapters = {
    http: (0, $82d0d0537dc0bac3$export$2e2bcd8739ae039),
    xhr: (0, $85bd0ac91b9e9771$export$2e2bcd8739ae039),
    fetch: (0, $3477ac01bee1324a$export$2e2bcd8739ae039)
};
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach($b57d5c296e05dd0f$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $b57d5c296e05dd0f$var$renderReason = (reason)=>`- ${reason}`;
const $b57d5c296e05dd0f$var$isResolvedHandle = (adapter)=>(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $b57d5c296e05dd0f$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$b57d5c296e05dd0f$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $b57d5c296e05dd0f$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($b57d5c296e05dd0f$var$renderReason).join('\n') : ' ' + $b57d5c296e05dd0f$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $b57d5c296e05dd0f$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $03c1ec60679d4a92$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $a251e9fa67c89486$export$2e2bcd8739ae039)(null, config);
}
function $03c1ec60679d4a92$export$2e2bcd8739ae039(config) {
    $03c1ec60679d4a92$var$throwIfCancellationRequested(config);
    config.headers = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $e27ce2658796d30f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $b57d5c296e05dd0f$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $8d19883a18ea96be$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $03c1ec60679d4a92$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $e27ce2658796d30f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $ffcdf0443516cf49$export$2e2bcd8739ae039)(reason)) {
            $03c1ec60679d4a92$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $e27ce2658796d30f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $f1f155cc89389bcb$export$a4ad2735b021c132 = "1.8.1";



'use strict';
const $73047b42f9e782d3$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $73047b42f9e782d3$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $73047b42f9e782d3$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $73047b42f9e782d3$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $f1f155cc89389bcb$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$73047b42f9e782d3$var$deprecatedWarnings[opt]) {
            $73047b42f9e782d3$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$73047b42f9e782d3$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $73047b42f9e782d3$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)('options must be an object', (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $73047b42f9e782d3$export$2e2bcd8739ae039 = {
    assertOptions: $73047b42f9e782d3$var$assertOptions,
    validators: $73047b42f9e782d3$var$validators
};



'use strict';
const $6c6ea2375c06af66$var$validators = (0, $73047b42f9e782d3$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $6c6ea2375c06af66$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $089e14d5c08cea15$export$2e2bcd8739ae039)(),
            response: new (0, $089e14d5c08cea15$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $ed738da9502ca495$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $73047b42f9e782d3$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $6c6ea2375c06af66$var$validators.transitional($6c6ea2375c06af66$var$validators.boolean),
            forcedJSONParsing: $6c6ea2375c06af66$var$validators.transitional($6c6ea2375c06af66$var$validators.boolean),
            clarifyTimeoutError: $6c6ea2375c06af66$var$validators.transitional($6c6ea2375c06af66$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $73047b42f9e782d3$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $6c6ea2375c06af66$var$validators.function,
                serialize: $6c6ea2375c06af66$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $73047b42f9e782d3$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $6c6ea2375c06af66$var$validators.spelling('baseURL'),
            withXsrfToken: $6c6ea2375c06af66$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $03c1ec60679d4a92$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $03c1ec60679d4a92$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $ed738da9502ca495$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $c5c7eeec01fb8b89$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $4858799f155a4706$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $6c6ea2375c06af66$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $ed738da9502ca495$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $ed738da9502ca495$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $6c6ea2375c06af66$var$Axios.prototype[method] = generateHTTPMethod();
    $6c6ea2375c06af66$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $6c6ea2375c06af66$export$2e2bcd8739ae039 = $6c6ea2375c06af66$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $52ff30ac6ac58fe8$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $a251e9fa67c89486$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $52ff30ac6ac58fe8$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $52ff30ac6ac58fe8$export$2e2bcd8739ae039 = $52ff30ac6ac58fe8$var$CancelToken;






'use strict';
function $6fd2256c627864a1$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $eecd01492f51a517$export$2e2bcd8739ae039(payload) {
    return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $3f8e319a46440ea5$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($3f8e319a46440ea5$var$HttpStatusCode).forEach(([key, value])=>{
    $3f8e319a46440ea5$var$HttpStatusCode[value] = key;
});
var $3f8e319a46440ea5$export$2e2bcd8739ae039 = $3f8e319a46440ea5$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $eb999ef253053d6e$var$createInstance(defaultConfig) {
    const context = new (0, $6c6ea2375c06af66$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $fc8f2e2c969d032f$export$2e2bcd8739ae039)((0, $6c6ea2375c06af66$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).extend(instance, (0, $6c6ea2375c06af66$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $eb999ef253053d6e$var$createInstance((0, $ed738da9502ca495$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $eb999ef253053d6e$var$axios = $eb999ef253053d6e$var$createInstance((0, $8d19883a18ea96be$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$eb999ef253053d6e$var$axios.Axios = (0, $6c6ea2375c06af66$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$eb999ef253053d6e$var$axios.CanceledError = (0, $a251e9fa67c89486$export$2e2bcd8739ae039);
$eb999ef253053d6e$var$axios.CancelToken = (0, $52ff30ac6ac58fe8$export$2e2bcd8739ae039);
$eb999ef253053d6e$var$axios.isCancel = (0, $ffcdf0443516cf49$export$2e2bcd8739ae039);
$eb999ef253053d6e$var$axios.VERSION = (0, $f1f155cc89389bcb$export$a4ad2735b021c132);
$eb999ef253053d6e$var$axios.toFormData = (0, $0c29ca57d54f85e9$export$2e2bcd8739ae039);
// Expose AxiosError class
$eb999ef253053d6e$var$axios.AxiosError = (0, $44aee3fe793a4c74$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$eb999ef253053d6e$var$axios.Cancel = $eb999ef253053d6e$var$axios.CanceledError;
// Expose all/spread
$eb999ef253053d6e$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$eb999ef253053d6e$var$axios.spread = (0, $6fd2256c627864a1$export$2e2bcd8739ae039);
// Expose isAxiosError
$eb999ef253053d6e$var$axios.isAxiosError = (0, $eecd01492f51a517$export$2e2bcd8739ae039);
// Expose mergeConfig
$eb999ef253053d6e$var$axios.mergeConfig = (0, $ed738da9502ca495$export$2e2bcd8739ae039);
$eb999ef253053d6e$var$axios.AxiosHeaders = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039);
$eb999ef253053d6e$var$axios.formToJSON = (thing)=>(0, $bdd273a6ec9f935e$export$2e2bcd8739ae039)((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$eb999ef253053d6e$var$axios.getAdapter = (0, $b57d5c296e05dd0f$export$2e2bcd8739ae039).getAdapter;
$eb999ef253053d6e$var$axios.HttpStatusCode = (0, $3f8e319a46440ea5$export$2e2bcd8739ae039);
$eb999ef253053d6e$var$axios.default = $eb999ef253053d6e$var$axios;
var // this module should only have a default export
$eb999ef253053d6e$export$2e2bcd8739ae039 = $eb999ef253053d6e$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $9fc967f4cbe5a6f7$export$1c00760e9e5a4e95, AxiosError: $9fc967f4cbe5a6f7$export$c1fbed17c2f6a328, CanceledError: $9fc967f4cbe5a6f7$export$1ab0c6b20d94fa14, isCancel: $9fc967f4cbe5a6f7$export$3b22524397b493c6, CancelToken: $9fc967f4cbe5a6f7$export$fd08e3cb425f0d61, VERSION: $9fc967f4cbe5a6f7$export$a4ad2735b021c132, all: $9fc967f4cbe5a6f7$export$84bf76cd7afc7469, Cancel: $9fc967f4cbe5a6f7$export$848c9b7ead0df967, isAxiosError: $9fc967f4cbe5a6f7$export$fbafdbe06a5b5a9a, spread: $9fc967f4cbe5a6f7$export$3ae0fd4797ed47c8, toFormData: $9fc967f4cbe5a6f7$export$10ae0d317ea97f8b, AxiosHeaders: $9fc967f4cbe5a6f7$export$4e7d6ff0f3e6520, HttpStatusCode: $9fc967f4cbe5a6f7$export$a972f69c851492b3, formToJSON: $9fc967f4cbe5a6f7$export$86d7c59254d6a2c9, getAdapter: $9fc967f4cbe5a6f7$export$17ddc20a97d669e2, mergeConfig: $9fc967f4cbe5a6f7$export$7ec1ebcfa9d8bd6a } = (0, $eb999ef253053d6e$export$2e2bcd8739ae039);


class $d0816a754525431e$export$2e2bcd8739ae039 {
    constructor(){
        this.loadTriggerSelector = '.js--load-lessons';
        this.loadUrlAttr = 'data-load-url';
        this.targetAttr = 'data-load-target';
        this.teaserInitClass = 'lesson-teaser--invisible';
        this.teaserSelector = '.lesson-teaser';
        this.loadedId = [];
        this.setupEvents();
    }
    setupEvents() {
        let button = document.querySelector(this.loadTriggerSelector);
        if (!button) return;
        button.addEventListener('click', this.handleClick.bind(this));
        window.addEventListener('scroll', this.handleScroll.bind(this));
    }
    isElementInView(element) {
        const elRect = element.getBoundingClientRect();
        const elTop = elRect.top;
        const elBottom = elRect.bottom;
        const screenBottom = window.innerHeight;
        const screenTop = 0;
        if (screenBottom > elTop && screenTop < elBottom) return true;
        return false;
    }
    handleScroll(ev) {
        let elements = document.querySelectorAll('.' + this.teaserInitClass);
        for (let element of elements)if (this.isElementInView(element)) element.classList.remove(this.teaserInitClass);
    }
    handleClick(ev) {
        const loadDivider = ev.currentTarget;
        const target = document.querySelector(`[${this.targetAttr}]`);
        const url = loadDivider.getAttribute(this.loadUrlAttr);
        // Store all teaser ids that are currently being displayed
        this.loadedId = Array.from(document.querySelectorAll(this.teaserSelector)).map((ele)=>ele.id);
        (0, $eb999ef253053d6e$export$2e2bcd8739ae039).get(url).then((response)=>{
            const parser = new DOMParser();
            const doc = parser.parseFromString(response.data, 'text/html');
            // Filter out elements that haven't been displayed
            const elements = Array.from(doc.querySelectorAll(this.teaserSelector)).filter((ele)=>!this.loadedId.includes(ele.id));
            const newLoadDivider = doc.querySelector(this.loadTriggerSelector);
            if (newLoadDivider) {
                const newUrl = newLoadDivider.getAttribute(this.loadUrlAttr);
                loadDivider.setAttribute(this.loadUrlAttr, newUrl);
            } else loadDivider.style.display = 'none';
            elements.forEach((ele)=>ele.classList.add(this.teaserInitClass));
            target.append(...elements);
            elements[0].querySelector('a, button, label').focus();
            this.handleScroll();
        }).bind(this);
        ev.preventDefault();
    }
}


var $47b7e4a6fa4118a9$exports = {};

/*!
 * imagesLoaded v5.0.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */ (function(window1, factory) {
    // universal module definition
    if (0, $47b7e4a6fa4118a9$exports) // CommonJS
    $47b7e4a6fa4118a9$exports = factory(window1, (parcelRequire("3BvQE")));
    else // browser global
    window1.imagesLoaded = factory(window1, window1.EvEmitter);
})(typeof window !== 'undefined' ? window : $47b7e4a6fa4118a9$exports, function factory(window1, EvEmitter) {
    let $ = window1.jQuery;
    let console = window1.console;
    // -------------------------- helpers -------------------------- //
    // turn element or nodeList into an array
    function makeArray(obj) {
        // use object if already an array
        if (Array.isArray(obj)) return obj;
        let isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
        // convert nodeList to array
        if (isArrayLike) return [
            ...obj
        ];
        // array of single index
        return [
            obj
        ];
    }
    // -------------------------- imagesLoaded -------------------------- //
    /**
 * @param {[Array, Element, NodeList, String]} elem
 * @param {[Object, Function]} options - if function, use as callback
 * @param {Function} onAlways - callback function
 * @returns {ImagesLoaded}
 */ function ImagesLoaded(elem, options, onAlways) {
        // coerce ImagesLoaded() without new, to be new ImagesLoaded()
        if (!(this instanceof ImagesLoaded)) return new ImagesLoaded(elem, options, onAlways);
        // use elem as selector string
        let queryElem = elem;
        if (typeof elem == 'string') queryElem = document.querySelectorAll(elem);
        // bail if bad element
        if (!queryElem) {
            console.error(`Bad element for imagesLoaded ${queryElem || elem}`);
            return;
        }
        this.elements = makeArray(queryElem);
        this.options = {};
        // shift arguments if no options set
        if (typeof options == 'function') onAlways = options;
        else Object.assign(this.options, options);
        if (onAlways) this.on('always', onAlways);
        this.getImages();
        // add jQuery Deferred object
        if ($) this.jqDeferred = new $.Deferred();
        // HACK check async to allow time to bind listeners
        setTimeout(this.check.bind(this));
    }
    ImagesLoaded.prototype = Object.create(EvEmitter.prototype);
    ImagesLoaded.prototype.getImages = function() {
        this.images = [];
        // filter & find items if we have an item selector
        this.elements.forEach(this.addElementImages, this);
    };
    const elementNodeTypes = [
        1,
        9,
        11
    ];
    /**
 * @param {Node} elem
 */ ImagesLoaded.prototype.addElementImages = function(elem) {
        // filter siblings
        if (elem.nodeName === 'IMG') this.addImage(elem);
        // get background image on element
        if (this.options.background === true) this.addElementBackgroundImages(elem);
        // find children
        // no non-element nodes, #143
        let { nodeType: nodeType } = elem;
        if (!nodeType || !elementNodeTypes.includes(nodeType)) return;
        let childImgs = elem.querySelectorAll('img');
        // concat childElems to filterFound array
        for (let img of childImgs)this.addImage(img);
        // get child background images
        if (typeof this.options.background == 'string') {
            let children = elem.querySelectorAll(this.options.background);
            for (let child of children)this.addElementBackgroundImages(child);
        }
    };
    const reURL = /url\((['"])?(.*?)\1\)/gi;
    ImagesLoaded.prototype.addElementBackgroundImages = function(elem) {
        let style = getComputedStyle(elem);
        // Firefox returns null if in a hidden iframe https://bugzil.la/548397
        if (!style) return;
        // get url inside url("...")
        let matches = reURL.exec(style.backgroundImage);
        while(matches !== null){
            let url = matches && matches[2];
            if (url) this.addBackground(url, elem);
            matches = reURL.exec(style.backgroundImage);
        }
    };
    /**
 * @param {Image} img
 */ ImagesLoaded.prototype.addImage = function(img) {
        let loadingImage = new LoadingImage(img);
        this.images.push(loadingImage);
    };
    ImagesLoaded.prototype.addBackground = function(url, elem) {
        let background = new Background(url, elem);
        this.images.push(background);
    };
    ImagesLoaded.prototype.check = function() {
        this.progressedCount = 0;
        this.hasAnyBroken = false;
        // complete if no images
        if (!this.images.length) {
            this.complete();
            return;
        }
        /* eslint-disable-next-line func-style */ let onProgress = (image, elem, message)=>{
            // HACK - Chrome triggers event before object properties have changed. #83
            setTimeout(()=>{
                this.progress(image, elem, message);
            });
        };
        this.images.forEach(function(loadingImage) {
            loadingImage.once('progress', onProgress);
            loadingImage.check();
        });
    };
    ImagesLoaded.prototype.progress = function(image, elem, message) {
        this.progressedCount++;
        this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
        // progress event
        this.emitEvent('progress', [
            this,
            image,
            elem
        ]);
        if (this.jqDeferred && this.jqDeferred.notify) this.jqDeferred.notify(this, image);
        // check if completed
        if (this.progressedCount === this.images.length) this.complete();
        if (this.options.debug && console) console.log(`progress: ${message}`, image, elem);
    };
    ImagesLoaded.prototype.complete = function() {
        let eventName = this.hasAnyBroken ? 'fail' : 'done';
        this.isComplete = true;
        this.emitEvent(eventName, [
            this
        ]);
        this.emitEvent('always', [
            this
        ]);
        if (this.jqDeferred) {
            let jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
            this.jqDeferred[jqMethod](this);
        }
    };
    // --------------------------  -------------------------- //
    function LoadingImage(img) {
        this.img = img;
    }
    LoadingImage.prototype = Object.create(EvEmitter.prototype);
    LoadingImage.prototype.check = function() {
        // If complete is true and browser supports natural sizes,
        // try to check for image status manually.
        let isComplete = this.getIsImageComplete();
        if (isComplete) {
            // report based on naturalWidth
            this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
            return;
        }
        // If none of the checks above matched, simulate loading on detached element.
        this.proxyImage = new Image();
        // add crossOrigin attribute. #204
        if (this.img.crossOrigin) this.proxyImage.crossOrigin = this.img.crossOrigin;
        this.proxyImage.addEventListener('load', this);
        this.proxyImage.addEventListener('error', this);
        // bind to image as well for Firefox. #191
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        this.proxyImage.src = this.img.currentSrc || this.img.src;
    };
    LoadingImage.prototype.getIsImageComplete = function() {
        // check for non-zero, non-undefined naturalWidth
        // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
        return this.img.complete && this.img.naturalWidth;
    };
    LoadingImage.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        let { parentNode: parentNode } = this.img;
        // emit progress with parent <picture> or self <img>
        let elem = parentNode.nodeName === 'PICTURE' ? parentNode : this.img;
        this.emitEvent('progress', [
            this,
            elem,
            message
        ]);
    };
    // ----- events ----- //
    // trigger specified handler for event type
    LoadingImage.prototype.handleEvent = function(event) {
        let method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    LoadingImage.prototype.onload = function() {
        this.confirm(true, 'onload');
        this.unbindEvents();
    };
    LoadingImage.prototype.onerror = function() {
        this.confirm(false, 'onerror');
        this.unbindEvents();
    };
    LoadingImage.prototype.unbindEvents = function() {
        this.proxyImage.removeEventListener('load', this);
        this.proxyImage.removeEventListener('error', this);
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
    };
    // -------------------------- Background -------------------------- //
    function Background(url, element) {
        this.url = url;
        this.element = element;
        this.img = new Image();
    }
    // inherit LoadingImage prototype
    Background.prototype = Object.create(LoadingImage.prototype);
    Background.prototype.check = function() {
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        this.img.src = this.url;
        // check if image is already complete
        let isComplete = this.getIsImageComplete();
        if (isComplete) {
            this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
            this.unbindEvents();
        }
    };
    Background.prototype.unbindEvents = function() {
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
    };
    Background.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        this.emitEvent('progress', [
            this,
            this.element,
            message
        ]);
    };
    // -------------------------- jQuery -------------------------- //
    ImagesLoaded.makeJQueryPlugin = function(jQuery) {
        jQuery = jQuery || window1.jQuery;
        if (!jQuery) return;
        // set local variable
        $ = jQuery;
        // $().imagesLoaded()
        $.fn.imagesLoaded = function(options, onAlways) {
            let instance = new ImagesLoaded(this, options, onAlways);
            return instance.jqDeferred.promise($(this));
        };
    };
    // try making plugin
    ImagesLoaded.makeJQueryPlugin();
    // --------------------------  -------------------------- //
    return ImagesLoaded;
});



var $258eaeee9b8f99a4$exports = {};


/*!
 * Masonry v4.2.2
 * Cascading grid layout library
 * https://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */ (function(window1, factory) {
    // universal module definition
    /* jshint strict: false */ /*globals define, module, require */ if (typeof define == 'function' && define.amd) // AMD
    define([
        'outlayer/outlayer',
        'get-size/get-size'
    ], factory);
    else if (0, $258eaeee9b8f99a4$exports) // CommonJS
    $258eaeee9b8f99a4$exports = factory((parcelRequire("2hMr9")), (parcelRequire("lDySy")));
    else // browser global
    window1.Masonry = factory(window1.Outlayer, window1.getSize);
})(window, function factory(Outlayer, getSize) {
    'use strict';
    // -------------------------- masonryDefinition -------------------------- //
    // create an Outlayer layout class
    var Masonry = Outlayer.create('masonry');
    // isFitWidth -> fitWidth
    Masonry.compatOptions.fitWidth = 'isFitWidth';
    var proto = Masonry.prototype;
    proto._resetLayout = function() {
        this.getSize();
        this._getMeasurement('columnWidth', 'outerWidth');
        this._getMeasurement('gutter', 'outerWidth');
        this.measureColumns();
        // reset column Y
        this.colYs = [];
        for(var i = 0; i < this.cols; i++)this.colYs.push(0);
        this.maxY = 0;
        this.horizontalColIndex = 0;
    };
    proto.measureColumns = function() {
        this.getContainerWidth();
        // if columnWidth is 0, default to outerWidth of first item
        if (!this.columnWidth) {
            var firstItem = this.items[0];
            var firstItemElem = firstItem && firstItem.element;
            // columnWidth fall back to item of first element
            this.columnWidth = firstItemElem && getSize(firstItemElem).outerWidth || // if first elem has no width, default to size of container
            this.containerWidth;
        }
        var columnWidth = this.columnWidth += this.gutter;
        // calculate columns
        var containerWidth = this.containerWidth + this.gutter;
        var cols = containerWidth / columnWidth;
        // fix rounding errors, typically with gutters
        var excess = columnWidth - containerWidth % columnWidth;
        // if overshoot is less than a pixel, round up, otherwise floor it
        var mathMethod = excess && excess < 1 ? 'round' : 'floor';
        cols = Math[mathMethod](cols);
        this.cols = Math.max(cols, 1);
    };
    proto.getContainerWidth = function() {
        // container is parent if fit width
        var isFitWidth = this._getOption('fitWidth');
        var container = isFitWidth ? this.element.parentNode : this.element;
        // check that this.size and size are there
        // IE8 triggers resize on body size change, so they might not be
        var size = getSize(container);
        this.containerWidth = size && size.innerWidth;
    };
    proto._getItemLayoutPosition = function(item) {
        item.getSize();
        // how many columns does this brick span
        var remainder = item.size.outerWidth % this.columnWidth;
        var mathMethod = remainder && remainder < 1 ? 'round' : 'ceil';
        // round if off by 1 pixel, otherwise use ceil
        var colSpan = Math[mathMethod](item.size.outerWidth / this.columnWidth);
        colSpan = Math.min(colSpan, this.cols);
        // use horizontal or top column position
        var colPosMethod = this.options.horizontalOrder ? '_getHorizontalColPosition' : '_getTopColPosition';
        var colPosition = this[colPosMethod](colSpan, item);
        // position the brick
        var position = {
            x: this.columnWidth * colPosition.col,
            y: colPosition.y
        };
        // apply setHeight to necessary columns
        var setHeight = colPosition.y + item.size.outerHeight;
        var setMax = colSpan + colPosition.col;
        for(var i = colPosition.col; i < setMax; i++)this.colYs[i] = setHeight;
        return position;
    };
    proto._getTopColPosition = function(colSpan) {
        var colGroup = this._getTopColGroup(colSpan);
        // get the minimum Y value from the columns
        var minimumY = Math.min.apply(Math, colGroup);
        return {
            col: colGroup.indexOf(minimumY),
            y: minimumY
        };
    };
    /**
   * @param {Number} colSpan - number of columns the element spans
   * @returns {Array} colGroup
   */ proto._getTopColGroup = function(colSpan) {
        if (colSpan < 2) // if brick spans only one column, use all the column Ys
        return this.colYs;
        var colGroup = [];
        // how many different places could this brick fit horizontally
        var groupCount = this.cols + 1 - colSpan;
        // for each group potential horizontal position
        for(var i = 0; i < groupCount; i++)colGroup[i] = this._getColGroupY(i, colSpan);
        return colGroup;
    };
    proto._getColGroupY = function(col, colSpan) {
        if (colSpan < 2) return this.colYs[col];
        // make an array of colY values for that one group
        var groupColYs = this.colYs.slice(col, col + colSpan);
        // and get the max value of the array
        return Math.max.apply(Math, groupColYs);
    };
    // get column position based on horizontal index. #873
    proto._getHorizontalColPosition = function(colSpan, item) {
        var col = this.horizontalColIndex % this.cols;
        var isOver = colSpan > 1 && col + colSpan > this.cols;
        // shift to next row if item can't fit on current row
        col = isOver ? 0 : col;
        // don't let zero-size items take up space
        var hasSize = item.size.outerWidth && item.size.outerHeight;
        this.horizontalColIndex = hasSize ? col + colSpan : this.horizontalColIndex;
        return {
            col: col,
            y: this._getColGroupY(col, colSpan)
        };
    };
    proto._manageStamp = function(stamp) {
        var stampSize = getSize(stamp);
        var offset = this._getElementOffset(stamp);
        // get the columns that this stamp affects
        var isOriginLeft = this._getOption('originLeft');
        var firstX = isOriginLeft ? offset.left : offset.right;
        var lastX = firstX + stampSize.outerWidth;
        var firstCol = Math.floor(firstX / this.columnWidth);
        firstCol = Math.max(0, firstCol);
        var lastCol = Math.floor(lastX / this.columnWidth);
        // lastCol should not go over if multiple of columnWidth #425
        lastCol -= lastX % this.columnWidth ? 0 : 1;
        lastCol = Math.min(this.cols - 1, lastCol);
        // set colYs to bottom of the stamp
        var isOriginTop = this._getOption('originTop');
        var stampMaxY = (isOriginTop ? offset.top : offset.bottom) + stampSize.outerHeight;
        for(var i = firstCol; i <= lastCol; i++)this.colYs[i] = Math.max(stampMaxY, this.colYs[i]);
    };
    proto._getContainerSize = function() {
        this.maxY = Math.max.apply(Math, this.colYs);
        var size = {
            height: this.maxY
        };
        if (this._getOption('fitWidth')) size.width = this._getContainerFitWidth();
        return size;
    };
    proto._getContainerFitWidth = function() {
        var unusedCols = 0;
        // count unused columns
        var i = this.cols;
        while(--i){
            if (this.colYs[i] !== 0) break;
            unusedCols++;
        }
        // fit container to columns that have been used
        return (this.cols - unusedCols) * this.columnWidth - this.gutter;
    };
    proto.needsResizeLayout = function() {
        var previousWidth = this.containerWidth;
        this.getContainerWidth();
        return previousWidth != this.containerWidth;
    };
    return Masonry;
});



class $539bcb0b48adfbd8$export$2e2bcd8739ae039 {
    constructor(stateHandler){
        this.loadMoreButtonSelector = '.js--masonry-load-more';
        this.isLoading = false;
        this.stateHandler = stateHandler;
        this.refreshTimeout;
        this.setupGrid();
    }
    setupGrid() {
        const grid = document.querySelector('.masonry-row');
        if (!grid) return;
        (0, (/*@__PURE__*/$parcel$interopDefault($47b7e4a6fa4118a9$exports)))(grid, (function() {
            // init Masonry after all images have loaded
            this.msnry = new (0, (/*@__PURE__*/$parcel$interopDefault($258eaeee9b8f99a4$exports)))(grid, {
                Selector: '.masonry-row__item',
                horizontalOrder: true
            });
            window.addEventListener('resize', (function() {
                this.refresh();
            }).bind(this));
            this.refresh();
        }).bind(this));
        const button = document.querySelector(this.loadMoreButtonSelector);
        if (button) button.addEventListener('click', (function(event) {
            this.handleClick(event);
        }).bind(this));
    }
    refresh() {
        return new Promise((resolve)=>{
            if (this.refreshTimeout) clearTimeout(this.refreshTimeout);
            this.refreshTimeout = setTimeout((function() {
                this.msnry.layout();
                this.refreshTimeout = null;
                resolve();
            }).bind(this), 500);
        });
    }
    isValid(data) {
        if (typeof data !== 'string') return false;
        const has_load_more = data.match('load-more-container');
        const is_html_page = data.match(/<html/i);
        return is_html_page === null && has_load_more === null;
    }
    handleClick(e) {
        e.preventDefault();
        const target = e.currentTarget;
        const targetId = target.getAttribute('data-masonry-load-target');
        const targetMasonry = document.querySelector('[data-masonry-id="' + targetId + '"]');
        const url = targetMasonry.getAttribute('data-load-url');
        this.fetchItems(url, targetId);
    }
    fetchItems(url, id) {
        if (this.isLoading) return;
        this.isLoading = true;
        (0, $eb999ef253053d6e$export$2e2bcd8739ae039).get(url, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then((response)=>{
            this.handleResponse(response.data, id);
        }).bind(this);
    }
    handleResponse(data, id) {
        this.isLoading = false;
        if (data) {
            const targetMasonry = document.querySelector('[data-masonry-id="' + id + '"]');
            if (this.isValid(data.items.result)) {
                const content = data.items.result;
                const elements = this.htmlToElements(content);
                elements.forEach((elm)=>{
                    this.msnry.element.appendChild(elm);
                    this.msnry.appended(elm);
                });
                //set focus on first new item after page is loaded
                this.refresh().then(()=>{
                    elements[0].querySelector('a, button, label').focus();
                });
            } else console.error('[Masonry] Malformed response');
            const button = document.querySelector(this.loadMoreButtonSelector + '[data-masonry-load-target="' + id + '"]');
            if (data.loadMoreUrl) targetMasonry.setAttribute('data-load-url', data.loadMoreUrl);
            else button.style.display = 'none';
            this.stateHandler.trigger('masonry-load-page');
        } else console.error('[Masonry] No data response');
    }
    htmlToElements(html) {
        let template = document.createElement('template');
        template.innerHTML = html;
        return Array.from(template.content.childNodes).filter((node)=>node.nodeType === Node.ELEMENT_NODE);
    }
}



var $28dfe1161dcbadec$exports = {};
var $6f206615b71b3351$exports = {};

$parcel$defineInteropFlag($6f206615b71b3351$exports);

$parcel$export($6f206615b71b3351$exports, "default", function () { return $6f206615b71b3351$export$2e2bcd8739ae039; });
class $6f206615b71b3351$export$2e2bcd8739ae039 {
    constructor(){
        this.accordionItemClass = '.accordion__list__item';
        this.accordionItemActiveClass = 'accordion__list__item--open';
        this.accordionItemTitleClass = '.accordion__list__item__title';
        this.accordionPanelClass = '.accordion__list__item__content';
        this.accordionShowPanelClass = 'accordion__list__item__content--show';
        this.setupComponent();
    }
    setupComponent() {
        const accordionItems = document.querySelectorAll(this.accordionItemTitleClass);
        accordionItems.forEach((accordion)=>{
            this.setupEvents(accordion);
        });
    }
    setupEvents(accordion) {
        accordion.addEventListener('keydown', (ev)=>{
            const keyCode = ev.code;
            const target = ev.currentTarget;
            const parent = target.closest(this.accordionItemClass);
            const panel = parent.querySelector(this.accordionPanelClass);
            if (keyCode === 'Enter' || keyCode === 'Space') {
                this.toggle(target, panel, parent);
                return false;
            }
        });
        accordion.addEventListener('click', (ev)=>{
            const target = ev.currentTarget;
            const parent = target.closest(this.accordionItemClass);
            const panel = parent.querySelector(this.accordionPanelClass);
            this.toggle(target, panel, parent);
            ev.preventDefault();
        });
    }
    toggle(trigger, panel, parent) {
        const content = parent.querySelector(this.accordionPanelClass);
        const tabbableElements = content.querySelectorAll('a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');
        if (parent.classList.contains(this.accordionItemActiveClass)) {
            parent.classList.remove(this.accordionItemActiveClass);
            panel.setAttribute('aria-hidden', true);
            trigger.setAttribute('aria-expanded', false);
            content.classList.remove(this.accordionShowPanelClass);
        } else {
            parent.classList.add(this.accordionItemActiveClass);
            panel.setAttribute('aria-hidden', false);
            trigger.setAttribute('aria-expanded', true);
            content.classList.add(this.accordionShowPanelClass);
        }
    }
}


var $4479ca1cddeff2f4$exports = {};

$parcel$defineInteropFlag($4479ca1cddeff2f4$exports);

$parcel$export($4479ca1cddeff2f4$exports, "default", function () { return $4479ca1cddeff2f4$export$2e2bcd8739ae039; });
class $4479ca1cddeff2f4$export$2e2bcd8739ae039 {
    // morph straight line path to this swiggly "compressed line" path
    //compressedLinePath = 'M1,2.5h1.9c0,0,0.1-1.9,0.6-2c0.7,0.4,0.8,4,1.6,4c0.9,0,0.9-4,1.7-4c0.9,0,0.9,4,1.7,4c0.9,0,0.9-4,1.7-4c0.9,0,0.9,4,1.7,4c0.9,0,0.9-4,1.7-4c0.9,0,0.9,4,1.7,4c0.9,0,0.9-4,1.7-4c0.9,0,0.9,4,1.7,4c0.9,0,0.9-4,1.7-4s0.9,4,1.7,4';
    //compressedLinePath = 'M1,2.5h1.9l0.6-1l1.6,2l1.7-2l1.7,2l1.7-2l1.7,2l1.7-2l1.7,2l1.7-2l1.7,2l1.7-2l1.7,2';
    //compressedLinePath = 'M2.4,3.3l0.5-0.8l0.6-1l1.6,2l1.7-2l1.7,2l1.7-2l1.7,2l1.7-2l1.7,2l1.7-2l1.7,2l1.7-2l1.7,2';
    //compressedLinePath = 'M2.8,2.7l0.1-0.2l0.6-1l1.6,2l1.7-2l1.7,2l1.7-2l1.7,2l1.7-2l1.7,2l1.7-2l1.7,2l1.7-2l2.1,2.4';
    //compressedLinePath = 'M2.4,2.1L2.4,2.1l1.1-0.6l1.6,2l1.7-2l1.7,2l1.7-2l1.7,2l1.7-2l1.7,2l1.7-2l1.7,2l1.7-2l2.1,2.4';
    //compressedLinePath = 'M2.1,2.7L2.1,2.7l1.4-1.2l1.6,2l1.7-2l1.7,2l1.7-2l1.7,2l1.7-2l1.7,2l1.7-2l1.7,2l1.7-2l2.1,2.4';
    compressedLinePath = 'M2.6,2.9L2.6,2.9l0.9-1.4l1.6,2l1.7-2l1.7,2l1.7-2l1.7,2l1.7-2l1.7,2l1.7-2l1.7,2l1.7-2l2.1,2.4';
    animationTime = 600;
    constructor(){
        this.arrowLineSelector = '.back-arrow__arrow__line';
        this.arrowLineActiveSelector = 'back-arrow__arrow__line--active';
        this.arrowWrapperSelector = '.back-arrow__wrapper';
        this.arrowButtonSelector = '.back-arrow__action';
        this.setupComponent();
    }
    setupComponent() {
        this.arrowLineEl = document.querySelector(this.arrowWrapperSelector);
        var lineSvg = Snap(this.arrowLineSelector);
        if (!lineSvg) return;
        const linePath = lineSvg.select('path');
        const origPathData = linePath.attr('d');
        this.arrowLineEl.addEventListener('mouseover', ()=>{
            this.mouseOver(lineSvg, linePath, origPathData);
        });
        this.arrowLineEl.addEventListener('mouseout', ()=>{
            this.mouseOut(lineSvg, linePath, origPathData);
        });
    }
    mouseOver(lineSvg, linePath, origPathData) {
        if (!this.isActive()) return;
        linePath.animate({
            d: this.compressedLinePath
        }, this.animationTime, mina.bounce);
        this.arrowLineEl.classList.add(this.arrowLineActiveSelector);
    }
    mouseOut(lineSvg, linePath, origPathData) {
        if (!this.isActive()) return;
        linePath.animate({
            d: origPathData
        }, this.animationTime, mina.bounce);
        this.arrowLineEl.classList.remove(this.arrowLineActiveSelector);
    }
    isActive() {
        if (window.innerWidth < 768) return false;
        // Ignore animation control
        return true; //this._animationController.isAnimationsActive();
    }
}


var $f2dee5b0b3cebe99$exports = {};

$parcel$defineInteropFlag($f2dee5b0b3cebe99$exports);

$parcel$export($f2dee5b0b3cebe99$exports, "default", function () { return $f2dee5b0b3cebe99$export$2e2bcd8739ae039; });
var $9f14ae20d7fb17a1$exports = {};
'use strict';
Object.defineProperty($9f14ae20d7fb17a1$exports, '__esModule', {
    value: true
});
var $9f14ae20d7fb17a1$var$win$1 = window;
var $9f14ae20d7fb17a1$var$raf = $9f14ae20d7fb17a1$var$win$1.requestAnimationFrame || $9f14ae20d7fb17a1$var$win$1.webkitRequestAnimationFrame || $9f14ae20d7fb17a1$var$win$1.mozRequestAnimationFrame || $9f14ae20d7fb17a1$var$win$1.msRequestAnimationFrame || function(cb) {
    return setTimeout(cb, 16);
};
var $9f14ae20d7fb17a1$var$win = window;
var $9f14ae20d7fb17a1$var$caf = $9f14ae20d7fb17a1$var$win.cancelAnimationFrame || $9f14ae20d7fb17a1$var$win.mozCancelAnimationFrame || function(id) {
    clearTimeout(id);
};
function $9f14ae20d7fb17a1$var$extend() {
    var obj, name, copy, target = arguments[0] || {}, i = 1, length = arguments.length;
    for(; i < length; i++){
        if ((obj = arguments[i]) !== null) for(name in obj){
            copy = obj[name];
            if (target === copy) continue;
            else if (copy !== undefined) target[name] = copy;
        }
    }
    return target;
}
function $9f14ae20d7fb17a1$var$checkStorageValue(value) {
    return [
        'true',
        'false'
    ].indexOf(value) >= 0 ? JSON.parse(value) : value;
}
function $9f14ae20d7fb17a1$var$setLocalStorage(storage, key, value, access) {
    if (access) try {
        storage.setItem(key, value);
    } catch (e) {}
    return value;
}
function $9f14ae20d7fb17a1$var$getSlideId() {
    var id = window.tnsId;
    window.tnsId = !id ? 1 : id + 1;
    return 'tns' + window.tnsId;
}
function $9f14ae20d7fb17a1$var$getBody() {
    var doc = document, body = doc.body;
    if (!body) {
        body = doc.createElement('body');
        body.fake = true;
    }
    return body;
}
var $9f14ae20d7fb17a1$var$docElement = document.documentElement;
function $9f14ae20d7fb17a1$var$setFakeBody(body) {
    var docOverflow = '';
    if (body.fake) {
        docOverflow = $9f14ae20d7fb17a1$var$docElement.style.overflow; //avoid crashing IE8, if background image is used
        body.style.background = ''; //Safari 5.13/5.1.4 OSX stops loading if ::-webkit-scrollbar is used and scrollbars are visible
        body.style.overflow = $9f14ae20d7fb17a1$var$docElement.style.overflow = 'hidden';
        $9f14ae20d7fb17a1$var$docElement.appendChild(body);
    }
    return docOverflow;
}
function $9f14ae20d7fb17a1$var$resetFakeBody(body, docOverflow) {
    if (body.fake) {
        body.remove();
        $9f14ae20d7fb17a1$var$docElement.style.overflow = docOverflow; // Trigger layout so kinetic scrolling isn't disabled in iOS6+
        // eslint-disable-next-line
        $9f14ae20d7fb17a1$var$docElement.offsetHeight;
    }
}
// get css-calc 
function $9f14ae20d7fb17a1$var$calc() {
    var doc = document, body = $9f14ae20d7fb17a1$var$getBody(), docOverflow = $9f14ae20d7fb17a1$var$setFakeBody(body), div = doc.createElement('div'), result = false;
    body.appendChild(div);
    try {
        var str = '(10px * 10)', vals = [
            'calc' + str,
            '-moz-calc' + str,
            '-webkit-calc' + str
        ], val;
        for(var i = 0; i < 3; i++){
            val = vals[i];
            div.style.width = val;
            if (div.offsetWidth === 100) {
                result = val.replace(str, '');
                break;
            }
        }
    } catch (e) {}
    body.fake ? $9f14ae20d7fb17a1$var$resetFakeBody(body, docOverflow) : div.remove();
    return result;
}
// get subpixel support value
function $9f14ae20d7fb17a1$var$percentageLayout() {
    // check subpixel layout supporting
    var doc = document, body = $9f14ae20d7fb17a1$var$getBody(), docOverflow = $9f14ae20d7fb17a1$var$setFakeBody(body), wrapper = doc.createElement('div'), outer = doc.createElement('div'), str = '', count = 70, perPage = 3, supported = false;
    wrapper.className = "tns-t-subp2";
    outer.className = "tns-t-ct";
    for(var i = 0; i < count; i++)str += '<div></div>';
    outer.innerHTML = str;
    wrapper.appendChild(outer);
    body.appendChild(wrapper);
    supported = Math.abs(wrapper.getBoundingClientRect().left - outer.children[count - perPage].getBoundingClientRect().left) < 2;
    body.fake ? $9f14ae20d7fb17a1$var$resetFakeBody(body, docOverflow) : wrapper.remove();
    return supported;
}
function $9f14ae20d7fb17a1$var$mediaquerySupport() {
    if (window.matchMedia || window.msMatchMedia) return true;
    var doc = document, body = $9f14ae20d7fb17a1$var$getBody(), docOverflow = $9f14ae20d7fb17a1$var$setFakeBody(body), div = doc.createElement('div'), style = doc.createElement('style'), rule = '@media all and (min-width:1px){.tns-mq-test{position:absolute}}', position;
    style.type = 'text/css';
    div.className = 'tns-mq-test';
    body.appendChild(style);
    body.appendChild(div);
    if (style.styleSheet) style.styleSheet.cssText = rule;
    else style.appendChild(doc.createTextNode(rule));
    position = window.getComputedStyle ? window.getComputedStyle(div).position : div.currentStyle['position'];
    body.fake ? $9f14ae20d7fb17a1$var$resetFakeBody(body, docOverflow) : div.remove();
    return position === "absolute";
}
// create and append style sheet
function $9f14ae20d7fb17a1$var$createStyleSheet(media, nonce) {
    // Create the <style> tag
    var style = document.createElement("style"); // style.setAttribute("type", "text/css");
    // Add a media (and/or media query) here if you'd like!
    // style.setAttribute("media", "screen")
    // style.setAttribute("media", "only screen and (max-width : 1024px)")
    if (media) style.setAttribute("media", media);
     // Add nonce attribute for Content Security Policy
    if (nonce) style.setAttribute("nonce", nonce);
     // WebKit hack :(
    // style.appendChild(document.createTextNode(""));
    // Add the <style> element to the page
    document.querySelector('head').appendChild(style);
    return style.sheet ? style.sheet : style.styleSheet;
}
// cross browsers addRule method
function $9f14ae20d7fb17a1$var$addCSSRule(sheet, selector, rules, index) {
    // return raf(function() {
    'insertRule' in sheet ? sheet.insertRule(selector + '{' + rules + '}', index) : sheet.addRule(selector, rules, index); // });
}
// cross browsers addRule method
function $9f14ae20d7fb17a1$var$removeCSSRule(sheet, index) {
    // return raf(function() {
    'deleteRule' in sheet ? sheet.deleteRule(index) : sheet.removeRule(index); // });
}
function $9f14ae20d7fb17a1$var$getCssRulesLength(sheet) {
    var rule = 'insertRule' in sheet ? sheet.cssRules : sheet.rules;
    return rule.length;
}
function $9f14ae20d7fb17a1$var$toDegree(y, x) {
    return Math.atan2(y, x) * (180 / Math.PI);
}
function $9f14ae20d7fb17a1$var$getTouchDirection(angle, range) {
    var direction = false, gap = Math.abs(90 - Math.abs(angle));
    if (gap >= 90 - range) direction = 'horizontal';
    else if (gap <= range) direction = 'vertical';
    return direction;
}
// https://toddmotto.com/ditch-the-array-foreach-call-nodelist-hack/
function $9f14ae20d7fb17a1$var$forEach(arr, callback, scope) {
    for(var i = 0, l = arr.length; i < l; i++)callback.call(scope, arr[i], i);
}
var $9f14ae20d7fb17a1$var$classListSupport = 'classList' in document.createElement('_');
var $9f14ae20d7fb17a1$var$hasClass = $9f14ae20d7fb17a1$var$classListSupport ? function(el, str) {
    return el.classList.contains(str);
} : function(el, str) {
    return el.className.indexOf(str) >= 0;
};
var $9f14ae20d7fb17a1$var$addClass = $9f14ae20d7fb17a1$var$classListSupport ? function(el, str) {
    if (!$9f14ae20d7fb17a1$var$hasClass(el, str)) el.classList.add(str);
} : function(el, str) {
    if (!$9f14ae20d7fb17a1$var$hasClass(el, str)) el.className += ' ' + str;
};
var $9f14ae20d7fb17a1$var$removeClass = $9f14ae20d7fb17a1$var$classListSupport ? function(el, str) {
    if ($9f14ae20d7fb17a1$var$hasClass(el, str)) el.classList.remove(str);
} : function(el, str) {
    if ($9f14ae20d7fb17a1$var$hasClass(el, str)) el.className = el.className.replace(str, '');
};
function $9f14ae20d7fb17a1$var$hasAttr(el, attr) {
    return el.hasAttribute(attr);
}
function $9f14ae20d7fb17a1$var$getAttr(el, attr) {
    return el.getAttribute(attr);
}
function $9f14ae20d7fb17a1$var$isNodeList(el) {
    // Only NodeList has the "item()" function
    return typeof el.item !== "undefined";
}
function $9f14ae20d7fb17a1$var$setAttrs(els, attrs) {
    els = $9f14ae20d7fb17a1$var$isNodeList(els) || els instanceof Array ? els : [
        els
    ];
    if (Object.prototype.toString.call(attrs) !== '[object Object]') return;
    for(var i = els.length; i--;)for(var key in attrs)els[i].setAttribute(key, attrs[key]);
}
function $9f14ae20d7fb17a1$var$removeAttrs(els, attrs) {
    els = $9f14ae20d7fb17a1$var$isNodeList(els) || els instanceof Array ? els : [
        els
    ];
    attrs = attrs instanceof Array ? attrs : [
        attrs
    ];
    var attrLength = attrs.length;
    for(var i = els.length; i--;)for(var j = attrLength; j--;)els[i].removeAttribute(attrs[j]);
}
function $9f14ae20d7fb17a1$var$arrayFromNodeList(nl) {
    var arr = [];
    for(var i = 0, l = nl.length; i < l; i++)arr.push(nl[i]);
    return arr;
}
function $9f14ae20d7fb17a1$var$hideElement(el, forceHide) {
    if (el.style.display !== 'none') el.style.display = 'none';
}
function $9f14ae20d7fb17a1$var$showElement(el, forceHide) {
    if (el.style.display === 'none') el.style.display = '';
}
function $9f14ae20d7fb17a1$var$isVisible(el) {
    return window.getComputedStyle(el).display !== 'none';
}
function $9f14ae20d7fb17a1$var$whichProperty(props) {
    if (typeof props === 'string') {
        var arr = [
            props
        ], Props = props.charAt(0).toUpperCase() + props.substr(1), prefixes = [
            'Webkit',
            'Moz',
            'ms',
            'O'
        ];
        prefixes.forEach(function(prefix) {
            if (prefix !== 'ms' || props === 'transform') arr.push(prefix + Props);
        });
        props = arr;
    }
    var el = document.createElement('fakeelement');
    props.length;
    for(var i = 0; i < props.length; i++){
        var prop = props[i];
        if (el.style[prop] !== undefined) return prop;
    }
    return false; // explicit for ie9-
}
function $9f14ae20d7fb17a1$var$has3DTransforms(tf) {
    if (!tf) return false;
    if (!window.getComputedStyle) return false;
    var doc = document, body = $9f14ae20d7fb17a1$var$getBody(), docOverflow = $9f14ae20d7fb17a1$var$setFakeBody(body), el = doc.createElement('p'), has3d, cssTF = tf.length > 9 ? '-' + tf.slice(0, -9).toLowerCase() + '-' : '';
    cssTF += 'transform'; // Add it to the body to get the computed style
    body.insertBefore(el, null);
    el.style[tf] = 'translate3d(1px,1px,1px)';
    has3d = window.getComputedStyle(el).getPropertyValue(cssTF);
    body.fake ? $9f14ae20d7fb17a1$var$resetFakeBody(body, docOverflow) : el.remove();
    return has3d !== undefined && has3d.length > 0 && has3d !== "none";
}
// get transitionend, animationend based on transitionDuration
// @propin: string
// @propOut: string, first-letter uppercase
// Usage: getEndProperty('WebkitTransitionDuration', 'Transition') => webkitTransitionEnd
function $9f14ae20d7fb17a1$var$getEndProperty(propIn, propOut) {
    var endProp = false;
    if (/^Webkit/.test(propIn)) endProp = 'webkit' + propOut + 'End';
    else if (/^O/.test(propIn)) endProp = 'o' + propOut + 'End';
    else if (propIn) endProp = propOut.toLowerCase() + 'end';
    return endProp;
}
// Test via a getter in the options object to see if the passive property is accessed
var $9f14ae20d7fb17a1$var$supportsPassive = false;
try {
    var $9f14ae20d7fb17a1$var$opts = Object.defineProperty({}, 'passive', {
        get: function() {
            $9f14ae20d7fb17a1$var$supportsPassive = true;
        }
    });
    window.addEventListener("test", null, $9f14ae20d7fb17a1$var$opts);
} catch (e) {}
var $9f14ae20d7fb17a1$var$passiveOption = $9f14ae20d7fb17a1$var$supportsPassive ? {
    passive: true
} : false;
function $9f14ae20d7fb17a1$var$addEvents(el, obj, preventScrolling) {
    for(var prop in obj){
        var option = [
            'touchstart',
            'touchmove'
        ].indexOf(prop) >= 0 && !preventScrolling ? $9f14ae20d7fb17a1$var$passiveOption : false;
        el.addEventListener(prop, obj[prop], option);
    }
}
function $9f14ae20d7fb17a1$var$removeEvents(el, obj) {
    for(var prop in obj){
        var option = [
            'touchstart',
            'touchmove'
        ].indexOf(prop) >= 0 ? $9f14ae20d7fb17a1$var$passiveOption : false;
        el.removeEventListener(prop, obj[prop], option);
    }
}
function $9f14ae20d7fb17a1$var$Events() {
    return {
        topics: {},
        on: function(eventName, fn) {
            this.topics[eventName] = this.topics[eventName] || [];
            this.topics[eventName].push(fn);
        },
        off: function(eventName, fn) {
            if (this.topics[eventName]) {
                for(var i = 0; i < this.topics[eventName].length; i++)if (this.topics[eventName][i] === fn) {
                    this.topics[eventName].splice(i, 1);
                    break;
                }
            }
        },
        emit: function(eventName, data) {
            data.type = eventName;
            if (this.topics[eventName]) this.topics[eventName].forEach(function(fn) {
                fn(data, eventName);
            });
        }
    };
}
function $9f14ae20d7fb17a1$var$jsTransform(element, attr, prefix, postfix, to, duration, callback) {
    var tick = Math.min(duration, 10), unit = to.indexOf('%') >= 0 ? '%' : 'px', to = to.replace(unit, ''), from = Number(element.style[attr].replace(prefix, '').replace(postfix, '').replace(unit, '')), positionTick = (to - from) / duration * tick;
    setTimeout(moveElement, tick);
    function moveElement() {
        duration -= tick;
        from += positionTick;
        element.style[attr] = prefix + from + unit + postfix;
        if (duration > 0) setTimeout(moveElement, tick);
        else callback();
    }
}
// Object.keys
if (!Object.keys) Object.keys = function(object) {
    var keys = [];
    for(var name in object)if (Object.prototype.hasOwnProperty.call(object, name)) keys.push(name);
    return keys;
};
 // ChildNode.remove
if (!("remove" in Element.prototype)) Element.prototype.remove = function() {
    if (this.parentNode) this.parentNode.removeChild(this);
};
var $9f14ae20d7fb17a1$var$tns = function(options) {
    options = $9f14ae20d7fb17a1$var$extend({
        container: '.slider',
        mode: 'carousel',
        axis: 'horizontal',
        items: 1,
        gutter: 0,
        edgePadding: 0,
        fixedWidth: false,
        autoWidth: false,
        viewportMax: false,
        slideBy: 1,
        center: false,
        controls: true,
        controlsPosition: 'top',
        controlsText: [
            'prev',
            'next'
        ],
        controlsContainer: false,
        prevButton: false,
        nextButton: false,
        nav: true,
        navPosition: 'top',
        navContainer: false,
        navAsThumbnails: false,
        arrowKeys: false,
        speed: 300,
        autoplay: false,
        autoplayPosition: 'top',
        autoplayTimeout: 5000,
        autoplayDirection: 'forward',
        autoplayText: [
            'start',
            'stop'
        ],
        autoplayHoverPause: false,
        autoplayButton: false,
        autoplayButtonOutput: true,
        autoplayResetOnVisibility: true,
        animateIn: 'tns-fadeIn',
        animateOut: 'tns-fadeOut',
        animateNormal: 'tns-normal',
        animateDelay: false,
        loop: true,
        rewind: false,
        autoHeight: false,
        responsive: false,
        lazyload: false,
        lazyloadSelector: '.tns-lazy-img',
        touch: true,
        mouseDrag: false,
        swipeAngle: 15,
        nested: false,
        preventActionWhenRunning: false,
        preventScrollOnTouch: false,
        freezable: true,
        onInit: false,
        useLocalStorage: true,
        nonce: false
    }, options || {});
    var doc = document, win = window, KEYS = {
        ENTER: 13,
        SPACE: 32,
        LEFT: 37,
        RIGHT: 39
    }, tnsStorage = {}, localStorageAccess = options.useLocalStorage;
    if (localStorageAccess) {
        // check browser version and local storage access
        var browserInfo = navigator.userAgent;
        var uid = new Date();
        try {
            tnsStorage = win.localStorage;
            if (tnsStorage) {
                tnsStorage.setItem(uid, uid);
                localStorageAccess = tnsStorage.getItem(uid) == uid;
                tnsStorage.removeItem(uid);
            } else localStorageAccess = false;
            if (!localStorageAccess) tnsStorage = {};
        } catch (e) {
            localStorageAccess = false;
        }
        if (localStorageAccess) {
            // remove storage when browser version changes
            if (tnsStorage['tnsApp'] && tnsStorage['tnsApp'] !== browserInfo) [
                'tC',
                'tPL',
                'tMQ',
                'tTf',
                't3D',
                'tTDu',
                'tTDe',
                'tADu',
                'tADe',
                'tTE',
                'tAE'
            ].forEach(function(item) {
                tnsStorage.removeItem(item);
            });
             // update browserInfo
            localStorage['tnsApp'] = browserInfo;
        }
    }
    var CALC = tnsStorage['tC'] ? $9f14ae20d7fb17a1$var$checkStorageValue(tnsStorage['tC']) : $9f14ae20d7fb17a1$var$setLocalStorage(tnsStorage, 'tC', $9f14ae20d7fb17a1$var$calc(), localStorageAccess), PERCENTAGELAYOUT = tnsStorage['tPL'] ? $9f14ae20d7fb17a1$var$checkStorageValue(tnsStorage['tPL']) : $9f14ae20d7fb17a1$var$setLocalStorage(tnsStorage, 'tPL', $9f14ae20d7fb17a1$var$percentageLayout(), localStorageAccess), CSSMQ = tnsStorage['tMQ'] ? $9f14ae20d7fb17a1$var$checkStorageValue(tnsStorage['tMQ']) : $9f14ae20d7fb17a1$var$setLocalStorage(tnsStorage, 'tMQ', $9f14ae20d7fb17a1$var$mediaquerySupport(), localStorageAccess), TRANSFORM = tnsStorage['tTf'] ? $9f14ae20d7fb17a1$var$checkStorageValue(tnsStorage['tTf']) : $9f14ae20d7fb17a1$var$setLocalStorage(tnsStorage, 'tTf', $9f14ae20d7fb17a1$var$whichProperty('transform'), localStorageAccess), HAS3DTRANSFORMS = tnsStorage['t3D'] ? $9f14ae20d7fb17a1$var$checkStorageValue(tnsStorage['t3D']) : $9f14ae20d7fb17a1$var$setLocalStorage(tnsStorage, 't3D', $9f14ae20d7fb17a1$var$has3DTransforms(TRANSFORM), localStorageAccess), TRANSITIONDURATION = tnsStorage['tTDu'] ? $9f14ae20d7fb17a1$var$checkStorageValue(tnsStorage['tTDu']) : $9f14ae20d7fb17a1$var$setLocalStorage(tnsStorage, 'tTDu', $9f14ae20d7fb17a1$var$whichProperty('transitionDuration'), localStorageAccess), TRANSITIONDELAY = tnsStorage['tTDe'] ? $9f14ae20d7fb17a1$var$checkStorageValue(tnsStorage['tTDe']) : $9f14ae20d7fb17a1$var$setLocalStorage(tnsStorage, 'tTDe', $9f14ae20d7fb17a1$var$whichProperty('transitionDelay'), localStorageAccess), ANIMATIONDURATION = tnsStorage['tADu'] ? $9f14ae20d7fb17a1$var$checkStorageValue(tnsStorage['tADu']) : $9f14ae20d7fb17a1$var$setLocalStorage(tnsStorage, 'tADu', $9f14ae20d7fb17a1$var$whichProperty('animationDuration'), localStorageAccess), ANIMATIONDELAY = tnsStorage['tADe'] ? $9f14ae20d7fb17a1$var$checkStorageValue(tnsStorage['tADe']) : $9f14ae20d7fb17a1$var$setLocalStorage(tnsStorage, 'tADe', $9f14ae20d7fb17a1$var$whichProperty('animationDelay'), localStorageAccess), TRANSITIONEND = tnsStorage['tTE'] ? $9f14ae20d7fb17a1$var$checkStorageValue(tnsStorage['tTE']) : $9f14ae20d7fb17a1$var$setLocalStorage(tnsStorage, 'tTE', $9f14ae20d7fb17a1$var$getEndProperty(TRANSITIONDURATION, 'Transition'), localStorageAccess), ANIMATIONEND = tnsStorage['tAE'] ? $9f14ae20d7fb17a1$var$checkStorageValue(tnsStorage['tAE']) : $9f14ae20d7fb17a1$var$setLocalStorage(tnsStorage, 'tAE', $9f14ae20d7fb17a1$var$getEndProperty(ANIMATIONDURATION, 'Animation'), localStorageAccess); // get element nodes from selectors
    var supportConsoleWarn = win.console && typeof win.console.warn === "function", tnsList = [
        'container',
        'controlsContainer',
        'prevButton',
        'nextButton',
        'navContainer',
        'autoplayButton'
    ], optionsElements = {};
    tnsList.forEach(function(item) {
        if (typeof options[item] === 'string') {
            var str = options[item], el = doc.querySelector(str);
            optionsElements[item] = str;
            if (el && el.nodeName) options[item] = el;
            else {
                if (supportConsoleWarn) console.warn('Can\'t find', options[item]);
                return;
            }
        }
    }); // make sure at least 1 slide
    if (options.container.children.length < 1) {
        if (supportConsoleWarn) console.warn('No slides found in', options.container);
        return;
    } // update options
    var responsive = options.responsive, nested = options.nested, carousel = options.mode === 'carousel' ? true : false;
    if (responsive) {
        // apply responsive[0] to options and remove it
        if (0 in responsive) {
            options = $9f14ae20d7fb17a1$var$extend(options, responsive[0]);
            delete responsive[0];
        }
        var responsiveTem = {};
        for(var key in responsive){
            var val = responsive[key]; // update responsive
            // from: 300: 2
            // to:
            //   300: {
            //     items: 2
            //   }
            val = typeof val === 'number' ? {
                items: val
            } : val;
            responsiveTem[key] = val;
        }
        responsive = responsiveTem;
        responsiveTem = null;
    } // update options
    function updateOptions(obj) {
        for(var key in obj){
            if (!carousel) {
                if (key === 'slideBy') obj[key] = 'page';
                if (key === 'edgePadding') obj[key] = false;
                if (key === 'autoHeight') obj[key] = false;
            } // update responsive options
            if (key === 'responsive') updateOptions(obj[key]);
        }
    }
    if (!carousel) updateOptions(options);
     // === define and set variables ===
    if (!carousel) {
        options.axis = 'horizontal';
        options.slideBy = 'page';
        options.edgePadding = false;
        var animateIn = options.animateIn, animateOut = options.animateOut, animateDelay = options.animateDelay, animateNormal = options.animateNormal;
    }
    var horizontal = options.axis === 'horizontal' ? true : false, outerWrapper = doc.createElement('div'), innerWrapper = doc.createElement('div'), middleWrapper, container = options.container, containerParent = container.parentNode, containerHTML = container.outerHTML, slideItems = container.children, slideCount = slideItems.length, breakpointZone, windowWidth = getWindowWidth(), isOn = false;
    if (responsive) setBreakpointZone();
    if (carousel) container.className += ' tns-vpfix';
     // fixedWidth: viewport > rightBoundary > indexMax
    var autoWidth = options.autoWidth, fixedWidth = getOption('fixedWidth'), edgePadding = getOption('edgePadding'), gutter = getOption('gutter'), viewport = getViewportWidth(), center = getOption('center'), items = !autoWidth ? Math.floor(getOption('items')) : 1, slideBy = getOption('slideBy'), viewportMax = options.viewportMax || options.fixedWidthViewportWidth, arrowKeys = getOption('arrowKeys'), speed = getOption('speed'), rewind = options.rewind, loop = rewind ? false : options.loop, autoHeight = getOption('autoHeight'), controls = getOption('controls'), controlsText = getOption('controlsText'), nav = getOption('nav'), touch = getOption('touch'), mouseDrag = getOption('mouseDrag'), autoplay = getOption('autoplay'), autoplayTimeout = getOption('autoplayTimeout'), autoplayText = getOption('autoplayText'), autoplayHoverPause = getOption('autoplayHoverPause'), autoplayResetOnVisibility = getOption('autoplayResetOnVisibility'), sheet = $9f14ae20d7fb17a1$var$createStyleSheet(null, getOption('nonce')), lazyload = options.lazyload, lazyloadSelector = options.lazyloadSelector, slidePositions, // collection of slide positions
    slideItemsOut = [], cloneCount = loop ? getCloneCountForLoop() : 0, slideCountNew = !carousel ? slideCount + cloneCount : slideCount + cloneCount * 2, hasRightDeadZone = (fixedWidth || autoWidth) && !loop ? true : false, rightBoundary = fixedWidth ? getRightBoundary() : null, updateIndexBeforeTransform = !carousel || !loop ? true : false, // transform
    transformAttr = horizontal ? 'left' : 'top', transformPrefix = '', transformPostfix = '', // index
    getIndexMax = function() {
        if (fixedWidth) return function() {
            return center && !loop ? slideCount - 1 : Math.ceil(-rightBoundary / (fixedWidth + gutter));
        };
        else if (autoWidth) return function() {
            for(var i = 0; i < slideCountNew; i++){
                if (slidePositions[i] >= -rightBoundary) return i;
            }
        };
        else return function() {
            if (center && carousel && !loop) return slideCount - 1;
            else return loop || carousel ? Math.max(0, slideCountNew - Math.ceil(items)) : slideCountNew - 1;
        };
    }(), index = getStartIndex(getOption('startIndex')), indexCached = index;
    getCurrentSlide();
    var indexMin = 0, indexMax = !autoWidth ? getIndexMax() : null, preventActionWhenRunning = options.preventActionWhenRunning, swipeAngle = options.swipeAngle, moveDirectionExpected = swipeAngle ? '?' : true, running = false, onInit = options.onInit, events = new $9f14ae20d7fb17a1$var$Events(), // id, class
    newContainerClasses = ' tns-slider tns-' + options.mode, slideId = container.id || $9f14ae20d7fb17a1$var$getSlideId(), disable = getOption('disable'), disabled = false, freezable = options.freezable, freeze = freezable && !autoWidth ? getFreeze() : false, frozen = false, controlsEvents = {
        'click': onControlsClick,
        'keydown': onControlsKeydown
    }, navEvents = {
        'click': onNavClick,
        'keydown': onNavKeydown
    }, hoverEvents = {
        'mouseover': mouseoverPause,
        'mouseout': mouseoutRestart
    }, visibilityEvent = {
        'visibilitychange': onVisibilityChange
    }, docmentKeydownEvent = {
        'keydown': onDocumentKeydown
    }, touchEvents = {
        'touchstart': onPanStart,
        'touchmove': onPanMove,
        'touchend': onPanEnd,
        'touchcancel': onPanEnd
    }, dragEvents = {
        'mousedown': onPanStart,
        'mousemove': onPanMove,
        'mouseup': onPanEnd,
        'mouseleave': onPanEnd
    }, hasControls = hasOption('controls'), hasNav = hasOption('nav'), navAsThumbnails = autoWidth ? true : options.navAsThumbnails, hasAutoplay = hasOption('autoplay'), hasTouch = hasOption('touch'), hasMouseDrag = hasOption('mouseDrag'), slideActiveClass = 'tns-slide-active', slideClonedClass = 'tns-slide-cloned', imgCompleteClass = 'tns-complete', imgEvents = {
        'load': onImgLoaded,
        'error': onImgFailed
    }, imgsComplete, liveregionCurrent, preventScroll = options.preventScrollOnTouch === 'force' ? true : false; // controls
    if (hasControls) var controlsContainer = options.controlsContainer, controlsContainerHTML = options.controlsContainer ? options.controlsContainer.outerHTML : '', prevButton = options.prevButton, nextButton = options.nextButton, prevButtonHTML = options.prevButton ? options.prevButton.outerHTML : '', nextButtonHTML = options.nextButton ? options.nextButton.outerHTML : '', prevIsButton, nextIsButton;
     // nav
    if (hasNav) var navContainer = options.navContainer, navContainerHTML = options.navContainer ? options.navContainer.outerHTML : '', navItems, pages = autoWidth ? slideCount : getPages(), pagesCached = 0, navClicked = -1, navCurrentIndex = getCurrentNavIndex(), navCurrentIndexCached = navCurrentIndex, navActiveClass = 'tns-nav-active', navStr = 'Carousel Page ', navStrCurrent = ' (Current Slide)';
     // autoplay
    if (hasAutoplay) var autoplayDirection = options.autoplayDirection === 'forward' ? 1 : -1, autoplayButton = options.autoplayButton, autoplayButtonHTML = options.autoplayButton ? options.autoplayButton.outerHTML : '', autoplayHtmlStrings = [
        '<span class=\'tns-visually-hidden\'>',
        ' animation</span>'
    ], autoplayTimer, animating, autoplayHoverPaused, autoplayUserPaused, autoplayVisibilityPaused;
    if (hasTouch || hasMouseDrag) var initPosition = {}, lastPosition = {}, translateInit, panStart = false, rafIndex, getDist = horizontal ? function(a, b) {
        return a.x - b.x;
    } : function(a, b) {
        return a.y - b.y;
    };
     // disable slider when slidecount <= items
    if (!autoWidth) resetVariblesWhenDisable(disable || freeze);
    if (TRANSFORM) {
        transformAttr = TRANSFORM;
        transformPrefix = 'translate';
        if (HAS3DTRANSFORMS) {
            transformPrefix += horizontal ? '3d(' : '3d(0px, ';
            transformPostfix = horizontal ? ', 0px, 0px)' : ', 0px)';
        } else {
            transformPrefix += horizontal ? 'X(' : 'Y(';
            transformPostfix = ')';
        }
    }
    if (carousel) container.className = container.className.replace('tns-vpfix', '');
    initStructure();
    initSheet();
    initSliderTransform(); // === COMMON FUNCTIONS === //
    function resetVariblesWhenDisable(condition) {
        if (condition) controls = nav = touch = mouseDrag = arrowKeys = autoplay = autoplayHoverPause = autoplayResetOnVisibility = false;
    }
    function getCurrentSlide() {
        var tem = carousel ? index - cloneCount : index;
        while(tem < 0)tem += slideCount;
        return tem % slideCount + 1;
    }
    function getStartIndex(ind) {
        ind = ind ? Math.max(0, Math.min(loop ? slideCount - 1 : slideCount - items, ind)) : 0;
        return carousel ? ind + cloneCount : ind;
    }
    function getAbsIndex(i) {
        if (i == null) i = index;
        if (carousel) i -= cloneCount;
        while(i < 0)i += slideCount;
        return Math.floor(i % slideCount);
    }
    function getCurrentNavIndex() {
        var absIndex = getAbsIndex(), result;
        result = navAsThumbnails ? absIndex : fixedWidth || autoWidth ? Math.ceil((absIndex + 1) * pages / slideCount - 1) : Math.floor(absIndex / items); // set active nav to the last one when reaches the right edge
        if (!loop && carousel && index === indexMax) result = pages - 1;
        return result;
    }
    function getItemsMax() {
        // fixedWidth or autoWidth while viewportMax is not available
        if (autoWidth || fixedWidth && !viewportMax) return slideCount - 1; // most cases
        else {
            var str = fixedWidth ? 'fixedWidth' : 'items', arr = [];
            if (fixedWidth || options[str] < slideCount) arr.push(options[str]);
            if (responsive) for(var bp in responsive){
                var tem = responsive[bp][str];
                if (tem && (fixedWidth || tem < slideCount)) arr.push(tem);
            }
            if (!arr.length) arr.push(0);
            return Math.ceil(fixedWidth ? viewportMax / Math.min.apply(null, arr) : Math.max.apply(null, arr));
        }
    }
    function getCloneCountForLoop() {
        var itemsMax = getItemsMax(), result = carousel ? Math.ceil((itemsMax * 5 - slideCount) / 2) : itemsMax * 4 - slideCount;
        result = Math.max(itemsMax, result);
        return hasOption('edgePadding') ? result + 1 : result;
    }
    function getWindowWidth() {
        return win.innerWidth || doc.documentElement.clientWidth || doc.body.clientWidth;
    }
    function getInsertPosition(pos) {
        return pos === 'top' ? 'afterbegin' : 'beforeend';
    }
    function getClientWidth(el) {
        if (el == null) return;
        var div = doc.createElement('div'), rect, width;
        el.appendChild(div);
        rect = div.getBoundingClientRect();
        width = rect.right - rect.left;
        div.remove();
        return width || getClientWidth(el.parentNode);
    }
    function getViewportWidth() {
        var gap = edgePadding ? edgePadding * 2 - gutter : 0;
        return getClientWidth(containerParent) - gap;
    }
    function hasOption(item) {
        if (options[item]) return true;
        else {
            if (responsive) for(var bp in responsive){
                if (responsive[bp][item]) return true;
            }
            return false;
        }
    } // get option:
    // fixed width: viewport, fixedWidth, gutter => items
    // others: window width => all variables
    // all: items => slideBy
    function getOption(item, ww) {
        if (ww == null) ww = windowWidth;
        if (item === 'items' && fixedWidth) return Math.floor((viewport + gutter) / (fixedWidth + gutter)) || 1;
        else {
            var result = options[item];
            if (responsive) for(var bp in responsive){
                // bp: convert string to number
                if (ww >= parseInt(bp)) {
                    if (item in responsive[bp]) result = responsive[bp][item];
                }
            }
            if (item === 'slideBy' && result === 'page') result = getOption('items');
            if (!carousel && (item === 'slideBy' || item === 'items')) result = Math.floor(result);
            return result;
        }
    }
    function getSlideMarginLeft(i) {
        return CALC ? CALC + '(' + i * 100 + '% / ' + slideCountNew + ')' : i * 100 / slideCountNew + '%';
    }
    function getInnerWrapperStyles(edgePaddingTem, gutterTem, fixedWidthTem, speedTem, autoHeightBP) {
        var str = '';
        if (edgePaddingTem !== undefined) {
            var gap = edgePaddingTem;
            if (gutterTem) gap -= gutterTem;
            str = horizontal ? 'margin: 0 ' + gap + 'px 0 ' + edgePaddingTem + 'px;' : 'margin: ' + edgePaddingTem + 'px 0 ' + gap + 'px 0;';
        } else if (gutterTem && !fixedWidthTem) {
            var gutterTemUnit = '-' + gutterTem + 'px', dir = horizontal ? gutterTemUnit + ' 0 0' : '0 ' + gutterTemUnit + ' 0';
            str = 'margin: 0 ' + dir + ';';
        }
        if (!carousel && autoHeightBP && TRANSITIONDURATION && speedTem) str += getTransitionDurationStyle(speedTem);
        return str;
    }
    function getContainerWidth(fixedWidthTem, gutterTem, itemsTem) {
        if (fixedWidthTem) return (fixedWidthTem + gutterTem) * slideCountNew + 'px';
        else return CALC ? CALC + '(' + slideCountNew * 100 + '% / ' + itemsTem + ')' : slideCountNew * 100 / itemsTem + '%';
    }
    function getSlideWidthStyle(fixedWidthTem, gutterTem, itemsTem) {
        var width;
        if (fixedWidthTem) width = fixedWidthTem + gutterTem + 'px';
        else {
            if (!carousel) itemsTem = Math.floor(itemsTem);
            var dividend = carousel ? slideCountNew : itemsTem;
            width = CALC ? CALC + '(100% / ' + dividend + ')' : 100 / dividend + '%';
        }
        width = 'width:' + width; // inner slider: overwrite outer slider styles
        return nested !== 'inner' ? width + ';' : width + ' !important;';
    }
    function getSlideGutterStyle(gutterTem) {
        var str = ''; // gutter maybe interger || 0
        // so can't use 'if (gutter)'
        if (gutterTem !== false) {
            var prop = horizontal ? 'padding-' : 'margin-', dir = horizontal ? 'right' : 'bottom';
            str = prop + dir + ': ' + gutterTem + 'px;';
        }
        return str;
    }
    function getCSSPrefix(name, num) {
        var prefix = name.substring(0, name.length - num).toLowerCase();
        if (prefix) prefix = '-' + prefix + '-';
        return prefix;
    }
    function getTransitionDurationStyle(speed) {
        return getCSSPrefix(TRANSITIONDURATION, 18) + 'transition-duration:' + speed / 1000 + 's;';
    }
    function getAnimationDurationStyle(speed) {
        return getCSSPrefix(ANIMATIONDURATION, 17) + 'animation-duration:' + speed / 1000 + 's;';
    }
    function initStructure() {
        var classOuter = 'tns-outer', classInner = 'tns-inner';
        hasOption('gutter');
        outerWrapper.className = classOuter;
        innerWrapper.className = classInner;
        outerWrapper.id = slideId + '-ow';
        innerWrapper.id = slideId + '-iw'; // set container properties
        if (container.id === '') container.id = slideId;
        newContainerClasses += PERCENTAGELAYOUT || autoWidth ? ' tns-subpixel' : ' tns-no-subpixel';
        newContainerClasses += CALC ? ' tns-calc' : ' tns-no-calc';
        if (autoWidth) newContainerClasses += ' tns-autowidth';
        newContainerClasses += ' tns-' + options.axis;
        container.className += newContainerClasses; // add constrain layer for carousel
        if (carousel) {
            middleWrapper = doc.createElement('div');
            middleWrapper.id = slideId + '-mw';
            middleWrapper.className = 'tns-ovh';
            outerWrapper.appendChild(middleWrapper);
            middleWrapper.appendChild(innerWrapper);
        } else outerWrapper.appendChild(innerWrapper);
        if (autoHeight) {
            var wp = middleWrapper ? middleWrapper : innerWrapper;
            wp.className += ' tns-ah';
        }
        containerParent.insertBefore(outerWrapper, container);
        innerWrapper.appendChild(container); // add id, class, aria attributes
        // before clone slides
        $9f14ae20d7fb17a1$var$forEach(slideItems, function(item, i) {
            $9f14ae20d7fb17a1$var$addClass(item, 'tns-item');
            if (!item.id) item.id = slideId + '-item' + i;
            if (!carousel && animateNormal) $9f14ae20d7fb17a1$var$addClass(item, animateNormal);
            $9f14ae20d7fb17a1$var$setAttrs(item, {
                'aria-hidden': 'true',
                'tabindex': '-1'
            });
        }); // ## clone slides
        // carousel: n + slides + n
        // gallery:      slides + n
        if (cloneCount) {
            var fragmentBefore = doc.createDocumentFragment(), fragmentAfter = doc.createDocumentFragment();
            for(var j = cloneCount; j--;){
                var num = j % slideCount, cloneFirst = slideItems[num].cloneNode(true);
                $9f14ae20d7fb17a1$var$addClass(cloneFirst, slideClonedClass);
                $9f14ae20d7fb17a1$var$removeAttrs(cloneFirst, 'id');
                fragmentAfter.insertBefore(cloneFirst, fragmentAfter.firstChild);
                if (carousel) {
                    var cloneLast = slideItems[slideCount - 1 - num].cloneNode(true);
                    $9f14ae20d7fb17a1$var$addClass(cloneLast, slideClonedClass);
                    $9f14ae20d7fb17a1$var$removeAttrs(cloneLast, 'id');
                    fragmentBefore.appendChild(cloneLast);
                }
            }
            container.insertBefore(fragmentBefore, container.firstChild);
            container.appendChild(fragmentAfter);
            slideItems = container.children;
        }
    }
    function initSliderTransform() {
        // ## images loaded/failed
        if (hasOption('autoHeight') || autoWidth || !horizontal) {
            var imgs = container.querySelectorAll('img'); // add img load event listener
            $9f14ae20d7fb17a1$var$forEach(imgs, function(img) {
                var src = img.src;
                if (!lazyload) {
                    // not data img
                    if (src && src.indexOf('data:image') < 0) {
                        img.src = '';
                        $9f14ae20d7fb17a1$var$addEvents(img, imgEvents);
                        $9f14ae20d7fb17a1$var$addClass(img, 'loading');
                        img.src = src; // data img
                    } else imgLoaded(img);
                }
            }); // set imgsComplete
            $9f14ae20d7fb17a1$var$raf(function() {
                imgsLoadedCheck($9f14ae20d7fb17a1$var$arrayFromNodeList(imgs), function() {
                    imgsComplete = true;
                });
            }); // reset imgs for auto height: check visible imgs only
            if (hasOption('autoHeight')) imgs = getImageArray(index, Math.min(index + items - 1, slideCountNew - 1));
            lazyload ? initSliderTransformStyleCheck() : $9f14ae20d7fb17a1$var$raf(function() {
                imgsLoadedCheck($9f14ae20d7fb17a1$var$arrayFromNodeList(imgs), initSliderTransformStyleCheck);
            });
        } else {
            // set container transform property
            if (carousel) doContainerTransformSilent();
             // update slider tools and events
            initTools();
            initEvents();
        }
    }
    function initSliderTransformStyleCheck() {
        if (autoWidth && slideCount > 1) {
            // check styles application
            var num = loop ? index : slideCount - 1;
            (function stylesApplicationCheck() {
                var left = slideItems[num].getBoundingClientRect().left;
                var right = slideItems[num - 1].getBoundingClientRect().right;
                Math.abs(left - right) <= 1 ? initSliderTransformCore() : setTimeout(function() {
                    stylesApplicationCheck();
                }, 16);
            })();
        } else initSliderTransformCore();
    }
    function initSliderTransformCore() {
        // run Fn()s which are rely on image loading
        if (!horizontal || autoWidth) {
            setSlidePositions();
            if (autoWidth) {
                rightBoundary = getRightBoundary();
                if (freezable) freeze = getFreeze();
                indexMax = getIndexMax(); // <= slidePositions, rightBoundary <=
                resetVariblesWhenDisable(disable || freeze);
            } else updateContentWrapperHeight();
        } // set container transform property
        if (carousel) doContainerTransformSilent();
         // update slider tools and events
        initTools();
        initEvents();
    }
    function initSheet() {
        // gallery:
        // set animation classes and left value for gallery slider
        if (!carousel) for(var i = index, l = index + Math.min(slideCount, items); i < l; i++){
            var item = slideItems[i];
            item.style.left = (i - index) * 100 / items + '%';
            $9f14ae20d7fb17a1$var$addClass(item, animateIn);
            $9f14ae20d7fb17a1$var$removeClass(item, animateNormal);
        }
         // #### LAYOUT
        // ## INLINE-BLOCK VS FLOAT
        // ## PercentageLayout:
        // slides: inline-block
        // remove blank space between slides by set font-size: 0
        // ## Non PercentageLayout:
        // slides: float
        //         margin-right: -100%
        //         margin-left: ~
        // Resource: https://docs.google.com/spreadsheets/d/147up245wwTXeQYve3BRSAD4oVcvQmuGsFteJOeA5xNQ/edit?usp=sharing
        if (horizontal) {
            if (PERCENTAGELAYOUT || autoWidth) {
                $9f14ae20d7fb17a1$var$addCSSRule(sheet, '#' + slideId + ' > .tns-item', 'font-size:' + win.getComputedStyle(slideItems[0]).fontSize + ';', $9f14ae20d7fb17a1$var$getCssRulesLength(sheet));
                $9f14ae20d7fb17a1$var$addCSSRule(sheet, '#' + slideId, 'font-size:0;', $9f14ae20d7fb17a1$var$getCssRulesLength(sheet));
            } else if (carousel) $9f14ae20d7fb17a1$var$forEach(slideItems, function(slide, i) {
                slide.style.marginLeft = getSlideMarginLeft(i);
            });
        } // ## BASIC STYLES
        if (CSSMQ) {
            // middle wrapper style
            if (TRANSITIONDURATION) {
                var str = middleWrapper && options.autoHeight ? getTransitionDurationStyle(options.speed) : '';
                $9f14ae20d7fb17a1$var$addCSSRule(sheet, '#' + slideId + '-mw', str, $9f14ae20d7fb17a1$var$getCssRulesLength(sheet));
            } // inner wrapper styles
            str = getInnerWrapperStyles(options.edgePadding, options.gutter, options.fixedWidth, options.speed, options.autoHeight);
            $9f14ae20d7fb17a1$var$addCSSRule(sheet, '#' + slideId + '-iw', str, $9f14ae20d7fb17a1$var$getCssRulesLength(sheet)); // container styles
            if (carousel) {
                str = horizontal && !autoWidth ? 'width:' + getContainerWidth(options.fixedWidth, options.gutter, options.items) + ';' : '';
                if (TRANSITIONDURATION) str += getTransitionDurationStyle(speed);
                $9f14ae20d7fb17a1$var$addCSSRule(sheet, '#' + slideId, str, $9f14ae20d7fb17a1$var$getCssRulesLength(sheet));
            } // slide styles
            str = horizontal && !autoWidth ? getSlideWidthStyle(options.fixedWidth, options.gutter, options.items) : '';
            if (options.gutter) str += getSlideGutterStyle(options.gutter);
             // set gallery items transition-duration
            if (!carousel) {
                if (TRANSITIONDURATION) str += getTransitionDurationStyle(speed);
                if (ANIMATIONDURATION) str += getAnimationDurationStyle(speed);
            }
            if (str) $9f14ae20d7fb17a1$var$addCSSRule(sheet, '#' + slideId + ' > .tns-item', str, $9f14ae20d7fb17a1$var$getCssRulesLength(sheet));
             // non CSS mediaqueries: IE8
        // ## update inner wrapper, container, slides if needed
        // set inline styles for inner wrapper & container
        // insert stylesheet (one line) for slides only (since slides are many)
        } else {
            // middle wrapper styles
            update_carousel_transition_duration(); // inner wrapper styles
            innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth, autoHeight); // container styles
            if (carousel && horizontal && !autoWidth) container.style.width = getContainerWidth(fixedWidth, gutter, items);
             // slide styles
            var str = horizontal && !autoWidth ? getSlideWidthStyle(fixedWidth, gutter, items) : '';
            if (gutter) str += getSlideGutterStyle(gutter);
             // append to the last line
            if (str) $9f14ae20d7fb17a1$var$addCSSRule(sheet, '#' + slideId + ' > .tns-item', str, $9f14ae20d7fb17a1$var$getCssRulesLength(sheet));
        } // ## MEDIAQUERIES
        if (responsive && CSSMQ) for(var bp in responsive){
            // bp: convert string to number
            bp = parseInt(bp);
            var opts = responsive[bp], str = '', middleWrapperStr = '', innerWrapperStr = '', containerStr = '', slideStr = '', itemsBP = !autoWidth ? getOption('items', bp) : null, fixedWidthBP = getOption('fixedWidth', bp), speedBP = getOption('speed', bp), edgePaddingBP = getOption('edgePadding', bp), autoHeightBP = getOption('autoHeight', bp), gutterBP = getOption('gutter', bp); // middle wrapper string
            if (TRANSITIONDURATION && middleWrapper && getOption('autoHeight', bp) && 'speed' in opts) middleWrapperStr = '#' + slideId + '-mw{' + getTransitionDurationStyle(speedBP) + '}';
             // inner wrapper string
            if ('edgePadding' in opts || 'gutter' in opts) innerWrapperStr = '#' + slideId + '-iw{' + getInnerWrapperStyles(edgePaddingBP, gutterBP, fixedWidthBP, speedBP, autoHeightBP) + '}';
             // container string
            if (carousel && horizontal && !autoWidth && ('fixedWidth' in opts || 'items' in opts || fixedWidth && 'gutter' in opts)) containerStr = 'width:' + getContainerWidth(fixedWidthBP, gutterBP, itemsBP) + ';';
            if (TRANSITIONDURATION && 'speed' in opts) containerStr += getTransitionDurationStyle(speedBP);
            if (containerStr) containerStr = '#' + slideId + '{' + containerStr + '}';
             // slide string
            if ('fixedWidth' in opts || fixedWidth && 'gutter' in opts || !carousel && 'items' in opts) slideStr += getSlideWidthStyle(fixedWidthBP, gutterBP, itemsBP);
            if ('gutter' in opts) slideStr += getSlideGutterStyle(gutterBP);
             // set gallery items transition-duration
            if (!carousel && 'speed' in opts) {
                if (TRANSITIONDURATION) slideStr += getTransitionDurationStyle(speedBP);
                if (ANIMATIONDURATION) slideStr += getAnimationDurationStyle(speedBP);
            }
            if (slideStr) slideStr = '#' + slideId + ' > .tns-item{' + slideStr + '}';
             // add up
            str = middleWrapperStr + innerWrapperStr + containerStr + slideStr;
            if (str) sheet.insertRule('@media (min-width: ' + bp / 16 + 'em) {' + str + '}', sheet.cssRules.length);
        }
    }
    function initTools() {
        // == slides ==
        updateSlideStatus(); // == live region ==
        outerWrapper.insertAdjacentHTML('afterbegin', '<div class="tns-liveregion tns-visually-hidden" aria-live="polite" aria-atomic="true">slide <span class="current">' + getLiveRegionStr() + '</span>  of ' + slideCount + '</div>');
        liveregionCurrent = outerWrapper.querySelector('.tns-liveregion .current'); // == autoplayInit ==
        if (hasAutoplay) {
            var txt = autoplay ? 'stop' : 'start';
            if (autoplayButton) $9f14ae20d7fb17a1$var$setAttrs(autoplayButton, {
                'data-action': txt
            });
            else if (options.autoplayButtonOutput) {
                outerWrapper.insertAdjacentHTML(getInsertPosition(options.autoplayPosition), '<button type="button" data-action="' + txt + '">' + autoplayHtmlStrings[0] + txt + autoplayHtmlStrings[1] + autoplayText[0] + '</button>');
                autoplayButton = outerWrapper.querySelector('[data-action]');
            } // add event
            if (autoplayButton) $9f14ae20d7fb17a1$var$addEvents(autoplayButton, {
                'click': toggleAutoplay
            });
            if (autoplay) {
                startAutoplay();
                if (autoplayHoverPause) $9f14ae20d7fb17a1$var$addEvents(container, hoverEvents);
                if (autoplayResetOnVisibility) $9f14ae20d7fb17a1$var$addEvents(container, visibilityEvent);
            }
        } // == navInit ==
        if (hasNav) {
            // will not hide the navs in case they're thumbnails
            if (navContainer) {
                $9f14ae20d7fb17a1$var$setAttrs(navContainer, {
                    'aria-label': 'Carousel Pagination'
                });
                navItems = navContainer.children;
                $9f14ae20d7fb17a1$var$forEach(navItems, function(item, i) {
                    $9f14ae20d7fb17a1$var$setAttrs(item, {
                        'data-nav': i,
                        'tabindex': '-1',
                        'aria-label': navStr + (i + 1),
                        'aria-controls': slideId
                    });
                }); // generated nav
            } else {
                var navHtml = '', hiddenStr = navAsThumbnails ? '' : 'style="display:none"';
                for(var i = 0; i < slideCount; i++)// hide nav items by default
                navHtml += '<button type="button" data-nav="' + i + '" tabindex="-1" aria-controls="' + slideId + '" ' + hiddenStr + ' aria-label="' + navStr + (i + 1) + '"></button>';
                navHtml = '<div class="tns-nav" aria-label="Carousel Pagination">' + navHtml + '</div>';
                outerWrapper.insertAdjacentHTML(getInsertPosition(options.navPosition), navHtml);
                navContainer = outerWrapper.querySelector('.tns-nav');
                navItems = navContainer.children;
            }
            updateNavVisibility(); // add transition
            if (TRANSITIONDURATION) {
                var prefix = TRANSITIONDURATION.substring(0, TRANSITIONDURATION.length - 18).toLowerCase(), str = 'transition: all ' + speed / 1000 + 's';
                if (prefix) str = '-' + prefix + '-' + str;
                $9f14ae20d7fb17a1$var$addCSSRule(sheet, '[aria-controls^=' + slideId + '-item]', str, $9f14ae20d7fb17a1$var$getCssRulesLength(sheet));
            }
            $9f14ae20d7fb17a1$var$setAttrs(navItems[navCurrentIndex], {
                'aria-label': navStr + (navCurrentIndex + 1) + navStrCurrent
            });
            $9f14ae20d7fb17a1$var$removeAttrs(navItems[navCurrentIndex], 'tabindex');
            $9f14ae20d7fb17a1$var$addClass(navItems[navCurrentIndex], navActiveClass); // add events
            $9f14ae20d7fb17a1$var$addEvents(navContainer, navEvents);
        } // == controlsInit ==
        if (hasControls) {
            if (!controlsContainer && (!prevButton || !nextButton)) {
                outerWrapper.insertAdjacentHTML(getInsertPosition(options.controlsPosition), '<div class="tns-controls" aria-label="Carousel Navigation" tabindex="0"><button type="button" data-controls="prev" tabindex="-1" aria-controls="' + slideId + '">' + controlsText[0] + '</button><button type="button" data-controls="next" tabindex="-1" aria-controls="' + slideId + '">' + controlsText[1] + '</button></div>');
                controlsContainer = outerWrapper.querySelector('.tns-controls');
            }
            if (!prevButton || !nextButton) {
                prevButton = controlsContainer.children[0];
                nextButton = controlsContainer.children[1];
            }
            if (options.controlsContainer) $9f14ae20d7fb17a1$var$setAttrs(controlsContainer, {
                'aria-label': 'Carousel Navigation',
                'tabindex': '0'
            });
            if (options.controlsContainer || options.prevButton && options.nextButton) $9f14ae20d7fb17a1$var$setAttrs([
                prevButton,
                nextButton
            ], {
                'aria-controls': slideId,
                'tabindex': '-1'
            });
            if (options.controlsContainer || options.prevButton && options.nextButton) {
                $9f14ae20d7fb17a1$var$setAttrs(prevButton, {
                    'data-controls': 'prev'
                });
                $9f14ae20d7fb17a1$var$setAttrs(nextButton, {
                    'data-controls': 'next'
                });
            }
            prevIsButton = isButton(prevButton);
            nextIsButton = isButton(nextButton);
            updateControlsStatus(); // add events
            if (controlsContainer) $9f14ae20d7fb17a1$var$addEvents(controlsContainer, controlsEvents);
            else {
                $9f14ae20d7fb17a1$var$addEvents(prevButton, controlsEvents);
                $9f14ae20d7fb17a1$var$addEvents(nextButton, controlsEvents);
            }
        } // hide tools if needed
        disableUI();
    }
    function initEvents() {
        // add events
        if (carousel && TRANSITIONEND) {
            var eve = {};
            eve[TRANSITIONEND] = onTransitionEnd;
            $9f14ae20d7fb17a1$var$addEvents(container, eve);
        }
        if (touch) $9f14ae20d7fb17a1$var$addEvents(container, touchEvents, options.preventScrollOnTouch);
        if (mouseDrag) $9f14ae20d7fb17a1$var$addEvents(container, dragEvents);
        if (arrowKeys) $9f14ae20d7fb17a1$var$addEvents(doc, docmentKeydownEvent);
        if (nested === 'inner') events.on('outerResized', function() {
            resizeTasks();
            events.emit('innerLoaded', info());
        });
        else if (responsive || fixedWidth || autoWidth || autoHeight || !horizontal) $9f14ae20d7fb17a1$var$addEvents(win, {
            'resize': onResize
        });
        if (autoHeight) {
            if (nested === 'outer') events.on('innerLoaded', doAutoHeight);
            else if (!disable) doAutoHeight();
        }
        doLazyLoad();
        if (disable) disableSlider();
        else if (freeze) freezeSlider();
        events.on('indexChanged', additionalUpdates);
        if (nested === 'inner') events.emit('innerLoaded', info());
        if (typeof onInit === 'function') onInit(info());
        isOn = true;
    }
    function destroy() {
        // sheet
        sheet.disabled = true;
        if (sheet.ownerNode) sheet.ownerNode.remove();
         // remove win event listeners
        $9f14ae20d7fb17a1$var$removeEvents(win, {
            'resize': onResize
        }); // arrowKeys, controls, nav
        if (arrowKeys) $9f14ae20d7fb17a1$var$removeEvents(doc, docmentKeydownEvent);
        if (controlsContainer) $9f14ae20d7fb17a1$var$removeEvents(controlsContainer, controlsEvents);
        if (navContainer) $9f14ae20d7fb17a1$var$removeEvents(navContainer, navEvents);
         // autoplay
        $9f14ae20d7fb17a1$var$removeEvents(container, hoverEvents);
        $9f14ae20d7fb17a1$var$removeEvents(container, visibilityEvent);
        if (autoplayButton) $9f14ae20d7fb17a1$var$removeEvents(autoplayButton, {
            'click': toggleAutoplay
        });
        if (autoplay) clearInterval(autoplayTimer);
         // container
        if (carousel && TRANSITIONEND) {
            var eve = {};
            eve[TRANSITIONEND] = onTransitionEnd;
            $9f14ae20d7fb17a1$var$removeEvents(container, eve);
        }
        if (touch) $9f14ae20d7fb17a1$var$removeEvents(container, touchEvents);
        if (mouseDrag) $9f14ae20d7fb17a1$var$removeEvents(container, dragEvents);
         // cache Object values in options && reset HTML
        var htmlList = [
            containerHTML,
            controlsContainerHTML,
            prevButtonHTML,
            nextButtonHTML,
            navContainerHTML,
            autoplayButtonHTML
        ];
        tnsList.forEach(function(item, i) {
            var el = item === 'container' ? outerWrapper : options[item];
            if (typeof el === 'object' && el) {
                var prevEl = el.previousElementSibling ? el.previousElementSibling : false, parentEl = el.parentNode;
                el.outerHTML = htmlList[i];
                options[item] = prevEl ? prevEl.nextElementSibling : parentEl.firstElementChild;
            }
        }); // reset variables
        tnsList = animateIn = animateOut = animateDelay = animateNormal = horizontal = outerWrapper = innerWrapper = container = containerParent = containerHTML = slideItems = slideCount = breakpointZone = windowWidth = autoWidth = fixedWidth = edgePadding = gutter = viewport = items = slideBy = viewportMax = arrowKeys = speed = rewind = loop = autoHeight = sheet = lazyload = slidePositions = slideItemsOut = cloneCount = slideCountNew = hasRightDeadZone = rightBoundary = updateIndexBeforeTransform = transformAttr = transformPrefix = transformPostfix = getIndexMax = index = indexCached = indexMin = indexMax = swipeAngle = moveDirectionExpected = running = onInit = events = newContainerClasses = slideId = disable = disabled = freezable = freeze = frozen = controlsEvents = navEvents = hoverEvents = visibilityEvent = docmentKeydownEvent = touchEvents = dragEvents = hasControls = hasNav = navAsThumbnails = hasAutoplay = hasTouch = hasMouseDrag = slideActiveClass = imgCompleteClass = imgEvents = imgsComplete = controls = controlsText = controlsContainer = controlsContainerHTML = prevButton = nextButton = prevIsButton = nextIsButton = nav = navContainer = navContainerHTML = navItems = pages = pagesCached = navClicked = navCurrentIndex = navCurrentIndexCached = navActiveClass = navStr = navStrCurrent = autoplay = autoplayTimeout = autoplayDirection = autoplayText = autoplayHoverPause = autoplayButton = autoplayButtonHTML = autoplayResetOnVisibility = autoplayHtmlStrings = autoplayTimer = animating = autoplayHoverPaused = autoplayUserPaused = autoplayVisibilityPaused = initPosition = lastPosition = translateInit = panStart = rafIndex = getDist = touch = mouseDrag = null; // check variables
        // [animateIn, animateOut, animateDelay, animateNormal, horizontal, outerWrapper, innerWrapper, container, containerParent, containerHTML, slideItems, slideCount, breakpointZone, windowWidth, autoWidth, fixedWidth, edgePadding, gutter, viewport, items, slideBy, viewportMax, arrowKeys, speed, rewind, loop, autoHeight, sheet, lazyload, slidePositions, slideItemsOut, cloneCount, slideCountNew, hasRightDeadZone, rightBoundary, updateIndexBeforeTransform, transformAttr, transformPrefix, transformPostfix, getIndexMax, index, indexCached, indexMin, indexMax, resizeTimer, swipeAngle, moveDirectionExpected, running, onInit, events, newContainerClasses, slideId, disable, disabled, freezable, freeze, frozen, controlsEvents, navEvents, hoverEvents, visibilityEvent, docmentKeydownEvent, touchEvents, dragEvents, hasControls, hasNav, navAsThumbnails, hasAutoplay, hasTouch, hasMouseDrag, slideActiveClass, imgCompleteClass, imgEvents, imgsComplete, controls, controlsText, controlsContainer, controlsContainerHTML, prevButton, nextButton, prevIsButton, nextIsButton, nav, navContainer, navContainerHTML, navItems, pages, pagesCached, navClicked, navCurrentIndex, navCurrentIndexCached, navActiveClass, navStr, navStrCurrent, autoplay, autoplayTimeout, autoplayDirection, autoplayText, autoplayHoverPause, autoplayButton, autoplayButtonHTML, autoplayResetOnVisibility, autoplayHtmlStrings, autoplayTimer, animating, autoplayHoverPaused, autoplayUserPaused, autoplayVisibilityPaused, initPosition, lastPosition, translateInit, disX, disY, panStart, rafIndex, getDist, touch, mouseDrag ].forEach(function(item) { if (item !== null) { console.log(item); } });
        for(var a in this)if (a !== 'rebuild') this[a] = null;
        isOn = false;
    } // === ON RESIZE ===
    // responsive || fixedWidth || autoWidth || !horizontal
    function onResize(e) {
        $9f14ae20d7fb17a1$var$raf(function() {
            resizeTasks(getEvent(e));
        });
    }
    function resizeTasks(e) {
        if (!isOn) return;
        if (nested === 'outer') events.emit('outerResized', info(e));
        windowWidth = getWindowWidth();
        var bpChanged, breakpointZoneTem = breakpointZone, needContainerTransform = false;
        if (responsive) {
            setBreakpointZone();
            bpChanged = breakpointZoneTem !== breakpointZone; // if (hasRightDeadZone) { needContainerTransform = true; } // *?
            if (bpChanged) events.emit('newBreakpointStart', info(e));
        }
        var indChanged, itemsChanged, itemsTem = items, disableTem = disable, freezeTem = freeze, arrowKeysTem = arrowKeys, controlsTem = controls, navTem = nav, touchTem = touch, mouseDragTem = mouseDrag, autoplayTem = autoplay, autoplayHoverPauseTem = autoplayHoverPause, autoplayResetOnVisibilityTem = autoplayResetOnVisibility, indexTem = index;
        if (bpChanged) {
            var fixedWidthTem = fixedWidth, autoHeightTem = autoHeight, controlsTextTem = controlsText, centerTem = center, autoplayTextTem = autoplayText;
            if (!CSSMQ) var gutterTem = gutter, edgePaddingTem = edgePadding;
        } // get option:
        // fixed width: viewport, fixedWidth, gutter => items
        // others: window width => all variables
        // all: items => slideBy
        arrowKeys = getOption('arrowKeys');
        controls = getOption('controls');
        nav = getOption('nav');
        touch = getOption('touch');
        center = getOption('center');
        mouseDrag = getOption('mouseDrag');
        autoplay = getOption('autoplay');
        autoplayHoverPause = getOption('autoplayHoverPause');
        autoplayResetOnVisibility = getOption('autoplayResetOnVisibility');
        if (bpChanged) {
            disable = getOption('disable');
            fixedWidth = getOption('fixedWidth');
            speed = getOption('speed');
            autoHeight = getOption('autoHeight');
            controlsText = getOption('controlsText');
            autoplayText = getOption('autoplayText');
            autoplayTimeout = getOption('autoplayTimeout');
            if (!CSSMQ) {
                edgePadding = getOption('edgePadding');
                gutter = getOption('gutter');
            }
        } // update options
        resetVariblesWhenDisable(disable);
        viewport = getViewportWidth(); // <= edgePadding, gutter
        if ((!horizontal || autoWidth) && !disable) {
            setSlidePositions();
            if (!horizontal) {
                updateContentWrapperHeight(); // <= setSlidePositions
                needContainerTransform = true;
            }
        }
        if (fixedWidth || autoWidth) {
            rightBoundary = getRightBoundary(); // autoWidth: <= viewport, slidePositions, gutter
            // fixedWidth: <= viewport, fixedWidth, gutter
            indexMax = getIndexMax(); // autoWidth: <= rightBoundary, slidePositions
        // fixedWidth: <= rightBoundary, fixedWidth, gutter
        }
        if (bpChanged || fixedWidth) {
            items = getOption('items');
            slideBy = getOption('slideBy');
            itemsChanged = items !== itemsTem;
            if (itemsChanged) {
                if (!fixedWidth && !autoWidth) indexMax = getIndexMax();
                 // <= items
                // check index before transform in case
                // slider reach the right edge then items become bigger
                updateIndex();
            }
        }
        if (bpChanged) {
            if (disable !== disableTem) {
                if (disable) disableSlider();
                else enableSlider(); // <= slidePositions, rightBoundary, indexMax
            }
        }
        if (freezable && (bpChanged || fixedWidth || autoWidth)) {
            freeze = getFreeze(); // <= autoWidth: slidePositions, gutter, viewport, rightBoundary
            // <= fixedWidth: fixedWidth, gutter, rightBoundary
            // <= others: items
            if (freeze !== freezeTem) {
                if (freeze) {
                    doContainerTransform(getContainerTransformValue(getStartIndex(0)));
                    freezeSlider();
                } else {
                    unfreezeSlider();
                    needContainerTransform = true;
                }
            }
        }
        resetVariblesWhenDisable(disable || freeze); // controls, nav, touch, mouseDrag, arrowKeys, autoplay, autoplayHoverPause, autoplayResetOnVisibility
        if (!autoplay) autoplayHoverPause = autoplayResetOnVisibility = false;
        if (arrowKeys !== arrowKeysTem) arrowKeys ? $9f14ae20d7fb17a1$var$addEvents(doc, docmentKeydownEvent) : $9f14ae20d7fb17a1$var$removeEvents(doc, docmentKeydownEvent);
        if (controls !== controlsTem) {
            if (controls) {
                if (controlsContainer) $9f14ae20d7fb17a1$var$showElement(controlsContainer);
                else {
                    if (prevButton) $9f14ae20d7fb17a1$var$showElement(prevButton);
                    if (nextButton) $9f14ae20d7fb17a1$var$showElement(nextButton);
                }
            } else if (controlsContainer) $9f14ae20d7fb17a1$var$hideElement(controlsContainer);
            else {
                if (prevButton) $9f14ae20d7fb17a1$var$hideElement(prevButton);
                if (nextButton) $9f14ae20d7fb17a1$var$hideElement(nextButton);
            }
        }
        if (nav !== navTem) {
            if (nav) {
                $9f14ae20d7fb17a1$var$showElement(navContainer);
                updateNavVisibility();
            } else $9f14ae20d7fb17a1$var$hideElement(navContainer);
        }
        if (touch !== touchTem) touch ? $9f14ae20d7fb17a1$var$addEvents(container, touchEvents, options.preventScrollOnTouch) : $9f14ae20d7fb17a1$var$removeEvents(container, touchEvents);
        if (mouseDrag !== mouseDragTem) mouseDrag ? $9f14ae20d7fb17a1$var$addEvents(container, dragEvents) : $9f14ae20d7fb17a1$var$removeEvents(container, dragEvents);
        if (autoplay !== autoplayTem) {
            if (autoplay) {
                if (autoplayButton) $9f14ae20d7fb17a1$var$showElement(autoplayButton);
                if (!animating && !autoplayUserPaused) startAutoplay();
            } else {
                if (autoplayButton) $9f14ae20d7fb17a1$var$hideElement(autoplayButton);
                if (animating) stopAutoplay();
            }
        }
        if (autoplayHoverPause !== autoplayHoverPauseTem) autoplayHoverPause ? $9f14ae20d7fb17a1$var$addEvents(container, hoverEvents) : $9f14ae20d7fb17a1$var$removeEvents(container, hoverEvents);
        if (autoplayResetOnVisibility !== autoplayResetOnVisibilityTem) autoplayResetOnVisibility ? $9f14ae20d7fb17a1$var$addEvents(doc, visibilityEvent) : $9f14ae20d7fb17a1$var$removeEvents(doc, visibilityEvent);
        if (bpChanged) {
            if (fixedWidth !== fixedWidthTem || center !== centerTem) needContainerTransform = true;
            if (autoHeight !== autoHeightTem) {
                if (!autoHeight) innerWrapper.style.height = '';
            }
            if (controls && controlsText !== controlsTextTem) {
                prevButton.innerHTML = controlsText[0];
                nextButton.innerHTML = controlsText[1];
            }
            if (autoplayButton && autoplayText !== autoplayTextTem) {
                var i = autoplay ? 1 : 0, html = autoplayButton.innerHTML, len = html.length - autoplayTextTem[i].length;
                if (html.substring(len) === autoplayTextTem[i]) autoplayButton.innerHTML = html.substring(0, len) + autoplayText[i];
            }
        } else if (center && (fixedWidth || autoWidth)) needContainerTransform = true;
        if (itemsChanged || fixedWidth && !autoWidth) {
            pages = getPages();
            updateNavVisibility();
        }
        indChanged = index !== indexTem;
        if (indChanged) {
            events.emit('indexChanged', info());
            needContainerTransform = true;
        } else if (itemsChanged) {
            if (!indChanged) additionalUpdates();
        } else if (fixedWidth || autoWidth) {
            doLazyLoad();
            updateSlideStatus();
            updateLiveRegion();
        }
        if (itemsChanged && !carousel) updateGallerySlidePositions();
        if (!disable && !freeze) {
            // non-mediaqueries: IE8
            if (bpChanged && !CSSMQ) {
                // middle wrapper styles
                // inner wrapper styles
                if (edgePadding !== edgePaddingTem || gutter !== gutterTem) innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth, speed, autoHeight);
                if (horizontal) {
                    // container styles
                    if (carousel) container.style.width = getContainerWidth(fixedWidth, gutter, items);
                     // slide styles
                    var str = getSlideWidthStyle(fixedWidth, gutter, items) + getSlideGutterStyle(gutter); // remove the last line and
                    // add new styles
                    $9f14ae20d7fb17a1$var$removeCSSRule(sheet, $9f14ae20d7fb17a1$var$getCssRulesLength(sheet) - 1);
                    $9f14ae20d7fb17a1$var$addCSSRule(sheet, '#' + slideId + ' > .tns-item', str, $9f14ae20d7fb17a1$var$getCssRulesLength(sheet));
                }
            } // auto height
            if (autoHeight) doAutoHeight();
            if (needContainerTransform) {
                doContainerTransformSilent();
                indexCached = index;
            }
        }
        if (bpChanged) events.emit('newBreakpointEnd', info(e));
    } // === INITIALIZATION FUNCTIONS === //
    function getFreeze() {
        if (!fixedWidth && !autoWidth) {
            var a = center ? items - (items - 1) / 2 : items;
            return slideCount <= a;
        }
        var width = fixedWidth ? (fixedWidth + gutter) * slideCount : slidePositions[slideCount], vp = edgePadding ? viewport + edgePadding * 2 : viewport + gutter;
        if (center) vp -= fixedWidth ? (viewport - fixedWidth) / 2 : (viewport - (slidePositions[index + 1] - slidePositions[index] - gutter)) / 2;
        return width <= vp;
    }
    function setBreakpointZone() {
        breakpointZone = 0;
        for(var bp in responsive){
            bp = parseInt(bp); // convert string to number
            if (windowWidth >= bp) breakpointZone = bp;
        }
    } // (slideBy, indexMin, indexMax) => index
    var updateIndex = function() {
        return loop ? carousel ? function() {
            var leftEdge = indexMin, rightEdge = indexMax;
            leftEdge += slideBy;
            rightEdge -= slideBy; // adjust edges when has edge paddings
            // or fixed-width slider with extra space on the right side
            if (edgePadding) {
                leftEdge += 1;
                rightEdge -= 1;
            } else if (fixedWidth) {
                if ((viewport + gutter) % (fixedWidth + gutter)) rightEdge -= 1;
            }
            if (cloneCount) {
                if (index > rightEdge) index -= slideCount;
                else if (index < leftEdge) index += slideCount;
            }
        } : function() {
            if (index > indexMax) while(index >= indexMin + slideCount)index -= slideCount;
            else if (index < indexMin) while(index <= indexMax - slideCount)index += slideCount;
        } : function() {
            index = Math.max(indexMin, Math.min(indexMax, index));
        };
    }();
    function disableUI() {
        if (!autoplay && autoplayButton) $9f14ae20d7fb17a1$var$hideElement(autoplayButton);
        if (!nav && navContainer) $9f14ae20d7fb17a1$var$hideElement(navContainer);
        if (!controls) {
            if (controlsContainer) $9f14ae20d7fb17a1$var$hideElement(controlsContainer);
            else {
                if (prevButton) $9f14ae20d7fb17a1$var$hideElement(prevButton);
                if (nextButton) $9f14ae20d7fb17a1$var$hideElement(nextButton);
            }
        }
    }
    function enableUI() {
        if (autoplay && autoplayButton) $9f14ae20d7fb17a1$var$showElement(autoplayButton);
        if (nav && navContainer) $9f14ae20d7fb17a1$var$showElement(navContainer);
        if (controls) {
            if (controlsContainer) $9f14ae20d7fb17a1$var$showElement(controlsContainer);
            else {
                if (prevButton) $9f14ae20d7fb17a1$var$showElement(prevButton);
                if (nextButton) $9f14ae20d7fb17a1$var$showElement(nextButton);
            }
        }
    }
    function freezeSlider() {
        if (frozen) return;
         // remove edge padding from inner wrapper
        if (edgePadding) innerWrapper.style.margin = '0px';
         // add class tns-transparent to cloned slides
        if (cloneCount) {
            var str = 'tns-transparent';
            for(var i = cloneCount; i--;){
                if (carousel) $9f14ae20d7fb17a1$var$addClass(slideItems[i], str);
                $9f14ae20d7fb17a1$var$addClass(slideItems[slideCountNew - i - 1], str);
            }
        } // update tools
        disableUI();
        frozen = true;
    }
    function unfreezeSlider() {
        if (!frozen) return;
         // restore edge padding for inner wrapper
        // for mordern browsers
        if (edgePadding && CSSMQ) innerWrapper.style.margin = '';
         // remove class tns-transparent to cloned slides
        if (cloneCount) {
            var str = 'tns-transparent';
            for(var i = cloneCount; i--;){
                if (carousel) $9f14ae20d7fb17a1$var$removeClass(slideItems[i], str);
                $9f14ae20d7fb17a1$var$removeClass(slideItems[slideCountNew - i - 1], str);
            }
        } // update tools
        enableUI();
        frozen = false;
    }
    function disableSlider() {
        if (disabled) return;
        sheet.disabled = true;
        container.className = container.className.replace(newContainerClasses.substring(1), '');
        $9f14ae20d7fb17a1$var$removeAttrs(container, [
            'style'
        ]);
        if (loop) for(var j = cloneCount; j--;){
            if (carousel) $9f14ae20d7fb17a1$var$hideElement(slideItems[j]);
            $9f14ae20d7fb17a1$var$hideElement(slideItems[slideCountNew - j - 1]);
        }
         // vertical slider
        if (!horizontal || !carousel) $9f14ae20d7fb17a1$var$removeAttrs(innerWrapper, [
            'style'
        ]);
         // gallery
        if (!carousel) for(var i = index, l = index + slideCount; i < l; i++){
            var item = slideItems[i];
            $9f14ae20d7fb17a1$var$removeAttrs(item, [
                'style'
            ]);
            $9f14ae20d7fb17a1$var$removeClass(item, animateIn);
            $9f14ae20d7fb17a1$var$removeClass(item, animateNormal);
        }
         // update tools
        disableUI();
        disabled = true;
    }
    function enableSlider() {
        if (!disabled) return;
        sheet.disabled = false;
        container.className += newContainerClasses;
        doContainerTransformSilent();
        if (loop) for(var j = cloneCount; j--;){
            if (carousel) $9f14ae20d7fb17a1$var$showElement(slideItems[j]);
            $9f14ae20d7fb17a1$var$showElement(slideItems[slideCountNew - j - 1]);
        }
         // gallery
        if (!carousel) for(var i = index, l = index + slideCount; i < l; i++){
            var item = slideItems[i], classN = i < index + items ? animateIn : animateNormal;
            item.style.left = (i - index) * 100 / items + '%';
            $9f14ae20d7fb17a1$var$addClass(item, classN);
        }
         // update tools
        enableUI();
        disabled = false;
    }
    function updateLiveRegion() {
        var str = getLiveRegionStr();
        if (liveregionCurrent.innerHTML !== str) liveregionCurrent.innerHTML = str;
    }
    function getLiveRegionStr() {
        var arr = getVisibleSlideRange(), start = arr[0] + 1, end = arr[1] + 1;
        return start === end ? start + '' : start + ' to ' + end;
    }
    function getVisibleSlideRange(val) {
        if (val == null) val = getContainerTransformValue();
        var start = index, end, rangestart, rangeend; // get range start, range end for autoWidth and fixedWidth
        if (center || edgePadding) {
            if (autoWidth || fixedWidth) {
                rangestart = -(parseFloat(val) + edgePadding);
                rangeend = rangestart + viewport + edgePadding * 2;
            }
        } else if (autoWidth) {
            rangestart = slidePositions[index];
            rangeend = rangestart + viewport;
        }
         // get start, end
        // - check auto width
        if (autoWidth) slidePositions.forEach(function(point, i) {
            if (i < slideCountNew) {
                if ((center || edgePadding) && point <= rangestart + 0.5) start = i;
                if (rangeend - point >= 0.5) end = i;
            }
        }); // - check percentage width, fixed width
        else {
            if (fixedWidth) {
                var cell = fixedWidth + gutter;
                if (center || edgePadding) {
                    start = Math.floor(rangestart / cell);
                    end = Math.ceil(rangeend / cell - 1);
                } else end = start + Math.ceil(viewport / cell) - 1;
            } else if (center || edgePadding) {
                var a = items - 1;
                if (center) {
                    start -= a / 2;
                    end = index + a / 2;
                } else end = index + a;
                if (edgePadding) {
                    var b = edgePadding * items / viewport;
                    start -= b;
                    end += b;
                }
                start = Math.floor(start);
                end = Math.ceil(end);
            } else end = start + items - 1;
            start = Math.max(start, 0);
            end = Math.min(end, slideCountNew - 1);
        }
        return [
            start,
            end
        ];
    }
    function doLazyLoad() {
        if (lazyload && !disable) {
            var arg = getVisibleSlideRange();
            arg.push(lazyloadSelector);
            getImageArray.apply(null, arg).forEach(function(img) {
                if (!$9f14ae20d7fb17a1$var$hasClass(img, imgCompleteClass)) {
                    // stop propagation transitionend event to container
                    var eve = {};
                    eve[TRANSITIONEND] = function(e) {
                        e.stopPropagation();
                    };
                    $9f14ae20d7fb17a1$var$addEvents(img, eve);
                    $9f14ae20d7fb17a1$var$addEvents(img, imgEvents); // update src
                    img.src = $9f14ae20d7fb17a1$var$getAttr(img, 'data-src'); // update srcset
                    var srcset = $9f14ae20d7fb17a1$var$getAttr(img, 'data-srcset');
                    if (srcset) img.srcset = srcset;
                    $9f14ae20d7fb17a1$var$addClass(img, 'loading');
                }
            });
        }
    }
    function onImgLoaded(e) {
        imgLoaded(getTarget(e));
    }
    function onImgFailed(e) {
        imgFailed(getTarget(e));
    }
    function imgLoaded(img) {
        $9f14ae20d7fb17a1$var$addClass(img, 'loaded');
        imgCompleted(img);
    }
    function imgFailed(img) {
        $9f14ae20d7fb17a1$var$addClass(img, 'failed');
        imgCompleted(img);
    }
    function imgCompleted(img) {
        $9f14ae20d7fb17a1$var$addClass(img, imgCompleteClass);
        $9f14ae20d7fb17a1$var$removeClass(img, 'loading');
        $9f14ae20d7fb17a1$var$removeEvents(img, imgEvents);
    }
    function getImageArray(start, end, imgSelector) {
        var imgs = [];
        if (!imgSelector) imgSelector = 'img';
        while(start <= end){
            $9f14ae20d7fb17a1$var$forEach(slideItems[start].querySelectorAll(imgSelector), function(img) {
                imgs.push(img);
            });
            start++;
        }
        return imgs;
    } // check if all visible images are loaded
    // and update container height if it's done
    function doAutoHeight() {
        var imgs = getImageArray.apply(null, getVisibleSlideRange());
        $9f14ae20d7fb17a1$var$raf(function() {
            imgsLoadedCheck(imgs, updateInnerWrapperHeight);
        });
    }
    function imgsLoadedCheck(imgs, cb) {
        // execute callback function if all images are complete
        if (imgsComplete) return cb();
         // check image classes
        imgs.forEach(function(img, index) {
            if (!lazyload && img.complete) imgCompleted(img);
             // Check image.complete
            if ($9f14ae20d7fb17a1$var$hasClass(img, imgCompleteClass)) imgs.splice(index, 1);
        }); // execute callback function if selected images are all complete
        if (!imgs.length) return cb();
         // otherwise execute this functiona again
        $9f14ae20d7fb17a1$var$raf(function() {
            imgsLoadedCheck(imgs, cb);
        });
    }
    function additionalUpdates() {
        doLazyLoad();
        updateSlideStatus();
        updateLiveRegion();
        updateControlsStatus();
        updateNavStatus();
    }
    function update_carousel_transition_duration() {
        if (carousel && autoHeight) middleWrapper.style[TRANSITIONDURATION] = speed / 1000 + 's';
    }
    function getMaxSlideHeight(slideStart, slideRange) {
        var heights = [];
        for(var i = slideStart, l = Math.min(slideStart + slideRange, slideCountNew); i < l; i++)heights.push(slideItems[i].offsetHeight);
        return Math.max.apply(null, heights);
    } // update inner wrapper height
    // 1. get the max-height of the visible slides
    // 2. set transitionDuration to speed
    // 3. update inner wrapper height to max-height
    // 4. set transitionDuration to 0s after transition done
    function updateInnerWrapperHeight() {
        var maxHeight = autoHeight ? getMaxSlideHeight(index, items) : getMaxSlideHeight(cloneCount, slideCount), wp = middleWrapper ? middleWrapper : innerWrapper;
        if (wp.style.height !== maxHeight) wp.style.height = maxHeight + 'px';
    } // get the distance from the top edge of the first slide to each slide
    // (init) => slidePositions
    function setSlidePositions() {
        slidePositions = [
            0
        ];
        var attr = horizontal ? 'left' : 'top', attr2 = horizontal ? 'right' : 'bottom', base = slideItems[0].getBoundingClientRect()[attr];
        $9f14ae20d7fb17a1$var$forEach(slideItems, function(item, i) {
            // skip the first slide
            if (i) slidePositions.push(item.getBoundingClientRect()[attr] - base);
             // add the end edge
            if (i === slideCountNew - 1) slidePositions.push(item.getBoundingClientRect()[attr2] - base);
        });
    } // update slide
    function updateSlideStatus() {
        var range = getVisibleSlideRange(), start = range[0], end = range[1];
        $9f14ae20d7fb17a1$var$forEach(slideItems, function(item, i) {
            // show slides
            if (i >= start && i <= end) {
                if ($9f14ae20d7fb17a1$var$hasAttr(item, 'aria-hidden')) {
                    $9f14ae20d7fb17a1$var$removeAttrs(item, [
                        'aria-hidden',
                        'tabindex'
                    ]);
                    $9f14ae20d7fb17a1$var$addClass(item, slideActiveClass);
                } // hide slides
            } else if (!$9f14ae20d7fb17a1$var$hasAttr(item, 'aria-hidden')) {
                $9f14ae20d7fb17a1$var$setAttrs(item, {
                    'aria-hidden': 'true',
                    'tabindex': '-1'
                });
                $9f14ae20d7fb17a1$var$removeClass(item, slideActiveClass);
            }
        });
    } // gallery: update slide position
    function updateGallerySlidePositions() {
        var l = index + Math.min(slideCount, items);
        for(var i = slideCountNew; i--;){
            var item = slideItems[i];
            if (i >= index && i < l) {
                // add transitions to visible slides when adjusting their positions
                $9f14ae20d7fb17a1$var$addClass(item, 'tns-moving');
                item.style.left = (i - index) * 100 / items + '%';
                $9f14ae20d7fb17a1$var$addClass(item, animateIn);
                $9f14ae20d7fb17a1$var$removeClass(item, animateNormal);
            } else if (item.style.left) {
                item.style.left = '';
                $9f14ae20d7fb17a1$var$addClass(item, animateNormal);
                $9f14ae20d7fb17a1$var$removeClass(item, animateIn);
            } // remove outlet animation
            $9f14ae20d7fb17a1$var$removeClass(item, animateOut);
        } // removing '.tns-moving'
        setTimeout(function() {
            $9f14ae20d7fb17a1$var$forEach(slideItems, function(el) {
                $9f14ae20d7fb17a1$var$removeClass(el, 'tns-moving');
            });
        }, 300);
    } // set tabindex on Nav
    function updateNavStatus() {
        // get current nav
        if (nav) {
            navCurrentIndex = navClicked >= 0 ? navClicked : getCurrentNavIndex();
            navClicked = -1;
            if (navCurrentIndex !== navCurrentIndexCached) {
                var navPrev = navItems[navCurrentIndexCached], navCurrent = navItems[navCurrentIndex];
                $9f14ae20d7fb17a1$var$setAttrs(navPrev, {
                    'tabindex': '-1',
                    'aria-label': navStr + (navCurrentIndexCached + 1)
                });
                $9f14ae20d7fb17a1$var$removeClass(navPrev, navActiveClass);
                $9f14ae20d7fb17a1$var$setAttrs(navCurrent, {
                    'aria-label': navStr + (navCurrentIndex + 1) + navStrCurrent
                });
                $9f14ae20d7fb17a1$var$removeAttrs(navCurrent, 'tabindex');
                $9f14ae20d7fb17a1$var$addClass(navCurrent, navActiveClass);
                navCurrentIndexCached = navCurrentIndex;
            }
        }
    }
    function getLowerCaseNodeName(el) {
        return el.nodeName.toLowerCase();
    }
    function isButton(el) {
        return getLowerCaseNodeName(el) === 'button';
    }
    function isAriaDisabled(el) {
        return el.getAttribute('aria-disabled') === 'true';
    }
    function disEnableElement(isButton, el, val) {
        if (isButton) el.disabled = val;
        else el.setAttribute('aria-disabled', val.toString());
    } // set 'disabled' to true on controls when reach the edges
    function updateControlsStatus() {
        if (!controls || rewind || loop) return;
        var prevDisabled = prevIsButton ? prevButton.disabled : isAriaDisabled(prevButton), nextDisabled = nextIsButton ? nextButton.disabled : isAriaDisabled(nextButton), disablePrev = index <= indexMin ? true : false, disableNext = !rewind && index >= indexMax ? true : false;
        if (disablePrev && !prevDisabled) disEnableElement(prevIsButton, prevButton, true);
        if (!disablePrev && prevDisabled) disEnableElement(prevIsButton, prevButton, false);
        if (disableNext && !nextDisabled) disEnableElement(nextIsButton, nextButton, true);
        if (!disableNext && nextDisabled) disEnableElement(nextIsButton, nextButton, false);
    } // set duration
    function resetDuration(el, str) {
        if (TRANSITIONDURATION) el.style[TRANSITIONDURATION] = str;
    }
    function getSliderWidth() {
        return fixedWidth ? (fixedWidth + gutter) * slideCountNew : slidePositions[slideCountNew];
    }
    function getCenterGap(num) {
        if (num == null) num = index;
        var gap = edgePadding ? gutter : 0;
        return autoWidth ? (viewport - gap - (slidePositions[num + 1] - slidePositions[num] - gutter)) / 2 : fixedWidth ? (viewport - fixedWidth) / 2 : (items - 1) / 2;
    }
    function getRightBoundary() {
        var gap = edgePadding ? gutter : 0, result = viewport + gap - getSliderWidth();
        if (center && !loop) result = fixedWidth ? -(fixedWidth + gutter) * (slideCountNew - 1) - getCenterGap() : getCenterGap(slideCountNew - 1) - slidePositions[slideCountNew - 1];
        if (result > 0) result = 0;
        return result;
    }
    function getContainerTransformValue(num) {
        if (num == null) num = index;
        var val;
        if (horizontal && !autoWidth) {
            if (fixedWidth) {
                val = -(fixedWidth + gutter) * num;
                if (center) val += getCenterGap();
            } else {
                var denominator = TRANSFORM ? slideCountNew : items;
                if (center) num -= getCenterGap();
                val = -num * 100 / denominator;
            }
        } else {
            val = -slidePositions[num];
            if (center && autoWidth) val += getCenterGap();
        }
        if (hasRightDeadZone) val = Math.max(val, rightBoundary);
        val += horizontal && !autoWidth && !fixedWidth ? '%' : 'px';
        return val;
    }
    function doContainerTransformSilent(val) {
        resetDuration(container, '0s');
        doContainerTransform(val);
    }
    function doContainerTransform(val) {
        if (val == null) val = getContainerTransformValue();
        container.style[transformAttr] = transformPrefix + val + transformPostfix;
    }
    function animateSlide(number, classOut, classIn, isOut) {
        var l = number + items;
        if (!loop) l = Math.min(l, slideCountNew);
        for(var i = number; i < l; i++){
            var item = slideItems[i]; // set item positions
            if (!isOut) item.style.left = (i - index) * 100 / items + '%';
            if (animateDelay && TRANSITIONDELAY) item.style[TRANSITIONDELAY] = item.style[ANIMATIONDELAY] = animateDelay * (i - number) / 1000 + 's';
            $9f14ae20d7fb17a1$var$removeClass(item, classOut);
            $9f14ae20d7fb17a1$var$addClass(item, classIn);
            if (isOut) slideItemsOut.push(item);
        }
    } // make transfer after click/drag:
    // 1. change 'transform' property for mordern browsers
    // 2. change 'left' property for legacy browsers
    var transformCore = function() {
        return carousel ? function() {
            resetDuration(container, '');
            if (TRANSITIONDURATION || !speed) {
                // for morden browsers with non-zero duration or
                // zero duration for all browsers
                doContainerTransform(); // run fallback function manually
                // when duration is 0 / container is hidden
                if (!speed || !$9f14ae20d7fb17a1$var$isVisible(container)) onTransitionEnd();
            } else // for old browser with non-zero duration
            $9f14ae20d7fb17a1$var$jsTransform(container, transformAttr, transformPrefix, transformPostfix, getContainerTransformValue(), speed, onTransitionEnd);
            if (!horizontal) updateContentWrapperHeight();
        } : function() {
            slideItemsOut = [];
            var eve = {};
            eve[TRANSITIONEND] = eve[ANIMATIONEND] = onTransitionEnd;
            $9f14ae20d7fb17a1$var$removeEvents(slideItems[indexCached], eve);
            $9f14ae20d7fb17a1$var$addEvents(slideItems[index], eve);
            animateSlide(indexCached, animateIn, animateOut, true);
            animateSlide(index, animateNormal, animateIn); // run fallback function manually
            // when transition or animation not supported / duration is 0
            if (!TRANSITIONEND || !ANIMATIONEND || !speed || !$9f14ae20d7fb17a1$var$isVisible(container)) onTransitionEnd();
        };
    }();
    function render(e, sliderMoved) {
        if (updateIndexBeforeTransform) updateIndex();
         // render when slider was moved (touch or drag) even though index may not change
        if (index !== indexCached || sliderMoved) {
            // events
            events.emit('indexChanged', info());
            events.emit('transitionStart', info());
            if (autoHeight) doAutoHeight();
             // pause autoplay when click or keydown from user
            if (animating && e && [
                'click',
                'keydown'
            ].indexOf(e.type) >= 0) stopAutoplay();
            running = true;
            transformCore();
        }
    }
    /*
   * Transfer prefixed properties to the same format
   * CSS: -Webkit-Transform => webkittransform
   * JS: WebkitTransform => webkittransform
   * @param {string} str - property
   *
   */ function strTrans(str) {
        return str.toLowerCase().replace(/-/g, '');
    } // AFTER TRANSFORM
    // Things need to be done after a transfer:
    // 1. check index
    // 2. add classes to visible slide
    // 3. disable controls buttons when reach the first/last slide in non-loop slider
    // 4. update nav status
    // 5. lazyload images
    // 6. update container height
    function onTransitionEnd(event) {
        // check running on gallery mode
        // make sure trantionend/animationend events run only once
        if (carousel || running) {
            events.emit('transitionEnd', info(event));
            if (!carousel && slideItemsOut.length > 0) for(var i = 0; i < slideItemsOut.length; i++){
                var item = slideItemsOut[i]; // set item positions
                item.style.left = '';
                if (ANIMATIONDELAY && TRANSITIONDELAY) {
                    item.style[ANIMATIONDELAY] = '';
                    item.style[TRANSITIONDELAY] = '';
                }
                $9f14ae20d7fb17a1$var$removeClass(item, animateOut);
                $9f14ae20d7fb17a1$var$addClass(item, animateNormal);
            }
            /* update slides, nav, controls after checking ...
       * => legacy browsers who don't support 'event'
       *    have to check event first, otherwise event.target will cause an error
       * => or 'gallery' mode:
       *   + event target is slide item
       * => or 'carousel' mode:
       *   + event target is container,
       *   + event.property is the same with transform attribute
       */ if (!event || !carousel && event.target.parentNode === container || event.target === container && strTrans(event.propertyName) === strTrans(transformAttr)) {
                if (!updateIndexBeforeTransform) {
                    var indexTem = index;
                    updateIndex();
                    if (index !== indexTem) {
                        events.emit('indexChanged', info());
                        doContainerTransformSilent();
                    }
                }
                if (nested === 'inner') events.emit('innerLoaded', info());
                running = false;
                indexCached = index;
            }
        }
    } // # ACTIONS
    function goTo(targetIndex, e) {
        if (freeze) return;
         // prev slideBy
        if (targetIndex === 'prev') onControlsClick(e, -1); // next slideBy
        else if (targetIndex === 'next') onControlsClick(e, 1); // go to exact slide
        else {
            if (running) {
                if (preventActionWhenRunning) return;
                else onTransitionEnd();
            }
            var absIndex = getAbsIndex(), indexGap = 0;
            if (targetIndex === 'first') indexGap = -absIndex;
            else if (targetIndex === 'last') indexGap = carousel ? slideCount - items - absIndex : slideCount - 1 - absIndex;
            else {
                if (typeof targetIndex !== 'number') targetIndex = parseInt(targetIndex);
                if (!isNaN(targetIndex)) {
                    // from directly called goTo function
                    if (!e) targetIndex = Math.max(0, Math.min(slideCount - 1, targetIndex));
                    indexGap = targetIndex - absIndex;
                }
            } // gallery: make sure new page won't overlap with current page
            if (!carousel && indexGap && Math.abs(indexGap) < items) {
                var factor = indexGap > 0 ? 1 : -1;
                indexGap += index + indexGap - slideCount >= indexMin ? slideCount * factor : slideCount * 2 * factor * -1;
            }
            index += indexGap; // make sure index is in range
            if (carousel && loop) {
                if (index < indexMin) index += slideCount;
                if (index > indexMax) index -= slideCount;
            } // if index is changed, start rendering
            if (getAbsIndex(index) !== getAbsIndex(indexCached)) render(e);
        }
    } // on controls click
    function onControlsClick(e, dir) {
        if (running) {
            if (preventActionWhenRunning) return;
            else onTransitionEnd();
        }
        var passEventObject;
        if (!dir) {
            e = getEvent(e);
            var target = getTarget(e);
            while(target !== controlsContainer && [
                prevButton,
                nextButton
            ].indexOf(target) < 0)target = target.parentNode;
            var targetIn = [
                prevButton,
                nextButton
            ].indexOf(target);
            if (targetIn >= 0) {
                passEventObject = true;
                dir = targetIn === 0 ? -1 : 1;
            }
        }
        if (rewind) {
            if (index === indexMin && dir === -1) {
                goTo('last', e);
                return;
            } else if (index === indexMax && dir === 1) {
                goTo('first', e);
                return;
            }
        }
        if (dir) {
            index += slideBy * dir;
            if (autoWidth) index = Math.floor(index);
             // pass e when click control buttons or keydown
            render(passEventObject || e && e.type === 'keydown' ? e : null);
        }
    } // on nav click
    function onNavClick(e) {
        if (running) {
            if (preventActionWhenRunning) return;
            else onTransitionEnd();
        }
        e = getEvent(e);
        var target = getTarget(e), navIndex; // find the clicked nav item
        while(target !== navContainer && !$9f14ae20d7fb17a1$var$hasAttr(target, 'data-nav'))target = target.parentNode;
        if ($9f14ae20d7fb17a1$var$hasAttr(target, 'data-nav')) {
            var navIndex = navClicked = Number($9f14ae20d7fb17a1$var$getAttr(target, 'data-nav')), targetIndexBase = fixedWidth || autoWidth ? navIndex * slideCount / pages : navIndex * items, targetIndex = navAsThumbnails ? navIndex : Math.min(Math.ceil(targetIndexBase), slideCount - 1);
            goTo(targetIndex, e);
            if (navCurrentIndex === navIndex) {
                if (animating) stopAutoplay();
                navClicked = -1; // reset navClicked
            }
        }
    } // autoplay functions
    function setAutoplayTimer() {
        autoplayTimer = setInterval(function() {
            onControlsClick(null, autoplayDirection);
        }, autoplayTimeout);
        animating = true;
    }
    function stopAutoplayTimer() {
        clearInterval(autoplayTimer);
        animating = false;
    }
    function updateAutoplayButton(action, txt) {
        $9f14ae20d7fb17a1$var$setAttrs(autoplayButton, {
            'data-action': action
        });
        autoplayButton.innerHTML = autoplayHtmlStrings[0] + action + autoplayHtmlStrings[1] + txt;
    }
    function startAutoplay() {
        setAutoplayTimer();
        if (autoplayButton) updateAutoplayButton('stop', autoplayText[1]);
    }
    function stopAutoplay() {
        stopAutoplayTimer();
        if (autoplayButton) updateAutoplayButton('start', autoplayText[0]);
    } // programaitcally play/pause the slider
    function play() {
        if (autoplay && !animating) {
            startAutoplay();
            autoplayUserPaused = false;
        }
    }
    function pause() {
        if (animating) {
            stopAutoplay();
            autoplayUserPaused = true;
        }
    }
    function toggleAutoplay() {
        if (animating) {
            stopAutoplay();
            autoplayUserPaused = true;
        } else {
            startAutoplay();
            autoplayUserPaused = false;
        }
    }
    function onVisibilityChange() {
        if (doc.hidden) {
            if (animating) {
                stopAutoplayTimer();
                autoplayVisibilityPaused = true;
            }
        } else if (autoplayVisibilityPaused) {
            setAutoplayTimer();
            autoplayVisibilityPaused = false;
        }
    }
    function mouseoverPause() {
        if (animating) {
            stopAutoplayTimer();
            autoplayHoverPaused = true;
        }
    }
    function mouseoutRestart() {
        if (autoplayHoverPaused) {
            setAutoplayTimer();
            autoplayHoverPaused = false;
        }
    } // keydown events on document
    function onDocumentKeydown(e) {
        e = getEvent(e);
        var keyIndex = [
            KEYS.LEFT,
            KEYS.RIGHT
        ].indexOf(e.keyCode);
        if (keyIndex >= 0) onControlsClick(e, keyIndex === 0 ? -1 : 1);
    } // on key control
    function onControlsKeydown(e) {
        e = getEvent(e);
        var keyIndex = [
            KEYS.LEFT,
            KEYS.RIGHT
        ].indexOf(e.keyCode);
        if (keyIndex >= 0) {
            if (keyIndex === 0) {
                if (!prevButton.disabled) onControlsClick(e, -1);
            } else if (!nextButton.disabled) onControlsClick(e, 1);
        }
    } // set focus
    function setFocus(el) {
        el.focus();
    } // on key nav
    function onNavKeydown(e) {
        e = getEvent(e);
        var curElement = doc.activeElement;
        if (!$9f14ae20d7fb17a1$var$hasAttr(curElement, 'data-nav')) return;
         // var code = e.keyCode,
        var keyIndex = [
            KEYS.LEFT,
            KEYS.RIGHT,
            KEYS.ENTER,
            KEYS.SPACE
        ].indexOf(e.keyCode), navIndex = Number($9f14ae20d7fb17a1$var$getAttr(curElement, 'data-nav'));
        if (keyIndex >= 0) {
            if (keyIndex === 0) {
                if (navIndex > 0) setFocus(navItems[navIndex - 1]);
            } else if (keyIndex === 1) {
                if (navIndex < pages - 1) setFocus(navItems[navIndex + 1]);
            } else {
                navClicked = navIndex;
                goTo(navIndex, e);
            }
        }
    }
    function getEvent(e) {
        e = e || win.event;
        return isTouchEvent(e) ? e.changedTouches[0] : e;
    }
    function getTarget(e) {
        return e.target || win.event.srcElement;
    }
    function isTouchEvent(e) {
        return e.type.indexOf('touch') >= 0;
    }
    function preventDefaultBehavior(e) {
        e.preventDefault ? e.preventDefault() : e.returnValue = false;
    }
    function getMoveDirectionExpected() {
        return $9f14ae20d7fb17a1$var$getTouchDirection($9f14ae20d7fb17a1$var$toDegree(lastPosition.y - initPosition.y, lastPosition.x - initPosition.x), swipeAngle) === options.axis;
    }
    function onPanStart(e) {
        if (running) {
            if (preventActionWhenRunning) return;
            else onTransitionEnd();
        }
        if (autoplay && animating) stopAutoplayTimer();
        panStart = true;
        if (rafIndex) {
            $9f14ae20d7fb17a1$var$caf(rafIndex);
            rafIndex = null;
        }
        var $ = getEvent(e);
        events.emit(isTouchEvent(e) ? 'touchStart' : 'dragStart', info(e));
        if (!isTouchEvent(e) && [
            'img',
            'a'
        ].indexOf(getLowerCaseNodeName(getTarget(e))) >= 0) preventDefaultBehavior(e);
        lastPosition.x = initPosition.x = $.clientX;
        lastPosition.y = initPosition.y = $.clientY;
        if (carousel) {
            translateInit = parseFloat(container.style[transformAttr].replace(transformPrefix, ''));
            resetDuration(container, '0s');
        }
    }
    function onPanMove(e) {
        if (panStart) {
            var $ = getEvent(e);
            lastPosition.x = $.clientX;
            lastPosition.y = $.clientY;
            if (carousel) {
                if (!rafIndex) rafIndex = $9f14ae20d7fb17a1$var$raf(function() {
                    panUpdate(e);
                });
            } else {
                if (moveDirectionExpected === '?') moveDirectionExpected = getMoveDirectionExpected();
                if (moveDirectionExpected) preventScroll = true;
            }
            if ((typeof e.cancelable !== 'boolean' || e.cancelable) && preventScroll) e.preventDefault();
        }
    }
    function panUpdate(e) {
        if (!moveDirectionExpected) {
            panStart = false;
            return;
        }
        $9f14ae20d7fb17a1$var$caf(rafIndex);
        if (panStart) rafIndex = $9f14ae20d7fb17a1$var$raf(function() {
            panUpdate(e);
        });
        if (moveDirectionExpected === '?') moveDirectionExpected = getMoveDirectionExpected();
        if (moveDirectionExpected) {
            if (!preventScroll && isTouchEvent(e)) preventScroll = true;
            try {
                if (e.type) events.emit(isTouchEvent(e) ? 'touchMove' : 'dragMove', info(e));
            } catch (err) {}
            var x = translateInit, dist = getDist(lastPosition, initPosition);
            if (!horizontal || fixedWidth || autoWidth) {
                x += dist;
                x += 'px';
            } else {
                var percentageX = TRANSFORM ? dist * items * 100 / ((viewport + gutter) * slideCountNew) : dist * 100 / (viewport + gutter);
                x += percentageX;
                x += '%';
            }
            container.style[transformAttr] = transformPrefix + x + transformPostfix;
        }
    }
    function onPanEnd(e) {
        if (panStart) {
            if (rafIndex) {
                $9f14ae20d7fb17a1$var$caf(rafIndex);
                rafIndex = null;
            }
            if (carousel) resetDuration(container, '');
            panStart = false;
            var $ = getEvent(e);
            lastPosition.x = $.clientX;
            lastPosition.y = $.clientY;
            var dist = getDist(lastPosition, initPosition);
            if (Math.abs(dist)) {
                // drag vs click
                if (!isTouchEvent(e)) {
                    // prevent "click"
                    var target = getTarget(e);
                    $9f14ae20d7fb17a1$var$addEvents(target, {
                        'click': function preventClick(e) {
                            preventDefaultBehavior(e);
                            $9f14ae20d7fb17a1$var$removeEvents(target, {
                                'click': preventClick
                            });
                        }
                    });
                }
                if (carousel) rafIndex = $9f14ae20d7fb17a1$var$raf(function() {
                    if (horizontal && !autoWidth) {
                        var indexMoved = -dist * items / (viewport + gutter);
                        indexMoved = dist > 0 ? Math.floor(indexMoved) : Math.ceil(indexMoved);
                        index += indexMoved;
                    } else {
                        var moved = -(translateInit + dist);
                        if (moved <= 0) index = indexMin;
                        else if (moved >= slidePositions[slideCountNew - 1]) index = indexMax;
                        else {
                            var i = 0;
                            while(i < slideCountNew && moved >= slidePositions[i]){
                                index = i;
                                if (moved > slidePositions[i] && dist < 0) index += 1;
                                i++;
                            }
                        }
                    }
                    render(e, dist);
                    events.emit(isTouchEvent(e) ? 'touchEnd' : 'dragEnd', info(e));
                });
                else if (moveDirectionExpected) onControlsClick(e, dist > 0 ? -1 : 1);
            }
        } // reset
        if (options.preventScrollOnTouch === 'auto') preventScroll = false;
        if (swipeAngle) moveDirectionExpected = '?';
        if (autoplay && !animating) setAutoplayTimer();
    } // === RESIZE FUNCTIONS === //
    // (slidePositions, index, items) => vertical_conentWrapper.height
    function updateContentWrapperHeight() {
        var wp = middleWrapper ? middleWrapper : innerWrapper;
        wp.style.height = slidePositions[index + items] - slidePositions[index] + 'px';
    }
    function getPages() {
        var rough = fixedWidth ? (fixedWidth + gutter) * slideCount / viewport : slideCount / items;
        return Math.min(Math.ceil(rough), slideCount);
    }
    /*
   * 1. update visible nav items list
   * 2. add "hidden" attributes to previous visible nav items
   * 3. remove "hidden" attrubutes to new visible nav items
   */ function updateNavVisibility() {
        if (!nav || navAsThumbnails) return;
        if (pages !== pagesCached) {
            var min = pagesCached, max = pages, fn = $9f14ae20d7fb17a1$var$showElement;
            if (pagesCached > pages) {
                min = pages;
                max = pagesCached;
                fn = $9f14ae20d7fb17a1$var$hideElement;
            }
            while(min < max){
                fn(navItems[min]);
                min++;
            } // cache pages
            pagesCached = pages;
        }
    }
    function info(e) {
        return {
            container: container,
            slideItems: slideItems,
            navContainer: navContainer,
            navItems: navItems,
            controlsContainer: controlsContainer,
            hasControls: hasControls,
            prevButton: prevButton,
            nextButton: nextButton,
            items: items,
            slideBy: slideBy,
            cloneCount: cloneCount,
            slideCount: slideCount,
            slideCountNew: slideCountNew,
            index: index,
            indexCached: indexCached,
            displayIndex: getCurrentSlide(),
            navCurrentIndex: navCurrentIndex,
            navCurrentIndexCached: navCurrentIndexCached,
            pages: pages,
            pagesCached: pagesCached,
            sheet: sheet,
            isOn: isOn,
            event: e || {}
        };
    }
    return {
        version: '2.9.4',
        getInfo: info,
        events: events,
        goTo: goTo,
        play: play,
        pause: pause,
        isOn: isOn,
        updateSliderHeight: updateInnerWrapperHeight,
        refresh: initSliderTransform,
        destroy: destroy,
        rebuild: function() {
            return $9f14ae20d7fb17a1$var$tns($9f14ae20d7fb17a1$var$extend(options, optionsElements));
        }
    };
};
$9f14ae20d7fb17a1$exports.tns = $9f14ae20d7fb17a1$var$tns;



class $f2dee5b0b3cebe99$export$2e2bcd8739ae039 {
    constructor(){
        this.containerSelector = '.carousel__slider';
        this.navContainerSelector = '.carousel__thumbs';
        this.controlsContainerSelector = '.carousel__nav';
        this.slider = {};
        this.init();
    }
    init() {
        document.addEventListener('DOMContentLoaded', ()=>{
            this.setupComponent();
        });
    }
    setupComponent() {
        let container = document.querySelector(this.containerSelector);
        if (container === null) return;
        this.slider = (0, $9f14ae20d7fb17a1$exports.tns)({
            container: this.containerSelector,
            navContainer: this.navContainerSelector,
            controlsContainer: this.controlsContainerSelector,
            autoplay: false,
            center: true,
            speed: 400,
            items: 1,
            loop: true,
            controls: false,
            navAsThumbnails: true,
            slideBy: 'page'
        });
        this.addEventListeners();
        this.setupTabIndex();
    }
    addEventListeners() {
        let prev = document.querySelector('.carousel__prev'), next = document.querySelector('.carousel__next');
        prev.addEventListener('click', ()=>{
            this.slider.goTo('prev');
        });
        next.addEventListener('click', ()=>{
            this.slider.goTo('next');
        });
        document.addEventListener('keydown', (event)=>{
            if (event.key === 'ArrowLeft') this.slider.goTo('prev');
            if (event.key === 'ArrowRight') this.slider.goTo('next');
        });
    }
    setupTabIndex() {
        let i = 1, j = 3;
        let nav = document.querySelectorAll('.carousel__nav > button');
        nav.forEach(function(div) {
            div.setAttribute('tabindex', i++);
        });
        let thumbs = document.querySelectorAll('.thumb-item');
        thumbs.forEach(function(item) {
            item.setAttribute('tabindex', j++);
        });
    }
}


var $4f8ec8687b08d154$exports = {};

$parcel$defineInteropFlag($4f8ec8687b08d154$exports);

$parcel$export($4f8ec8687b08d154$exports, "default", function () { return $4f8ec8687b08d154$export$2e2bcd8739ae039; });
class $4f8ec8687b08d154$export$2e2bcd8739ae039 {
    constructor(){
        this.flipTeaserSelector = '.flip-teaser';
        this.checkboxSelector = '.flip-teaser__flip-state';
        this.init();
    }
    init() {
        document.addEventListener('DOMContentLoaded', ()=>{
            this.setupComponent();
        });
    }
    setupComponent() {
        const elements = document.querySelectorAll(this.flipTeaserSelector);
        if (elements.length === 0) return;
        for (let teaser of elements){
            const frontside = teaser.querySelector('.flip-teaser__frontside');
            const backside = teaser.querySelector('.flip-teaser__backside');
            const button = frontside.querySelector('.flip-teaser__flip-state-label');
            button?.addEventListener('keypress', this.pressedKey.bind(this));
            let heights = [
                frontside.offsetHeight,
                backside.offsetHeight
            ];
            let newHeight = Math.max(...heights);
            frontside.style.height = newHeight + 'px';
            backside.style.height = newHeight + 'px';
        }
    }
    pressedKey(event) {
        const key = event.code;
        const target = event.currentTarget;
        if (key === 'Enter' || key === 'Space') {
            event.preventDefault();
            event.stopPropagation();
            this.flipTeaser(target);
        }
    }
    flipTeaser(target) {
        const teaser = target.closest(this.flipTeaserSelector);
        const checkbox = teaser.querySelector(this.checkboxSelector);
        checkbox.checked = true;
    }
}


var $5c98a5d3a0b97fd7$exports = {};

$parcel$defineInteropFlag($5c98a5d3a0b97fd7$exports);

$parcel$export($5c98a5d3a0b97fd7$exports, "default", function () { return $5c98a5d3a0b97fd7$export$2e2bcd8739ae039; });

var $c5eccf4247c91eed$exports = {};
/*! choices.js v10.2.0 | © 2022 Josh Johnson | https://github.com/jshjohnson/Choices#readme */ (function webpackUniversalModuleDefinition(root, factory) {
    $c5eccf4247c91eed$exports = factory();
})(window, function() {
    return /******/ function() {
        /******/ "use strict";
        /******/ var __webpack_modules__ = {
            /***/ 282: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.clearChoices = exports.activateChoices = exports.filterChoices = exports.addChoice = void 0;
                var constants_1 = __webpack_require__(883);
                var addChoice = function(_a) {
                    var value = _a.value, label = _a.label, id = _a.id, groupId = _a.groupId, disabled = _a.disabled, elementId = _a.elementId, customProperties = _a.customProperties, placeholder = _a.placeholder, keyCode = _a.keyCode;
                    return {
                        type: constants_1.ACTION_TYPES.ADD_CHOICE,
                        value: value,
                        label: label,
                        id: id,
                        groupId: groupId,
                        disabled: disabled,
                        elementId: elementId,
                        customProperties: customProperties,
                        placeholder: placeholder,
                        keyCode: keyCode
                    };
                };
                exports.addChoice = addChoice;
                var filterChoices = function(results) {
                    return {
                        type: constants_1.ACTION_TYPES.FILTER_CHOICES,
                        results: results
                    };
                };
                exports.filterChoices = filterChoices;
                var activateChoices = function(active) {
                    if (active === void 0) active = true;
                    return {
                        type: constants_1.ACTION_TYPES.ACTIVATE_CHOICES,
                        active: active
                    };
                };
                exports.activateChoices = activateChoices;
                var clearChoices = function() {
                    return {
                        type: constants_1.ACTION_TYPES.CLEAR_CHOICES
                    };
                };
                exports.clearChoices = clearChoices;
            /***/ },
            /***/ 783: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.addGroup = void 0;
                var constants_1 = __webpack_require__(883);
                var addGroup = function(_a) {
                    var value = _a.value, id = _a.id, active = _a.active, disabled = _a.disabled;
                    return {
                        type: constants_1.ACTION_TYPES.ADD_GROUP,
                        value: value,
                        id: id,
                        active: active,
                        disabled: disabled
                    };
                };
                exports.addGroup = addGroup;
            /***/ },
            /***/ 464: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.highlightItem = exports.removeItem = exports.addItem = void 0;
                var constants_1 = __webpack_require__(883);
                var addItem = function(_a) {
                    var value = _a.value, label = _a.label, id = _a.id, choiceId = _a.choiceId, groupId = _a.groupId, customProperties = _a.customProperties, placeholder = _a.placeholder, keyCode = _a.keyCode;
                    return {
                        type: constants_1.ACTION_TYPES.ADD_ITEM,
                        value: value,
                        label: label,
                        id: id,
                        choiceId: choiceId,
                        groupId: groupId,
                        customProperties: customProperties,
                        placeholder: placeholder,
                        keyCode: keyCode
                    };
                };
                exports.addItem = addItem;
                var removeItem = function(id, choiceId) {
                    return {
                        type: constants_1.ACTION_TYPES.REMOVE_ITEM,
                        id: id,
                        choiceId: choiceId
                    };
                };
                exports.removeItem = removeItem;
                var highlightItem = function(id, highlighted) {
                    return {
                        type: constants_1.ACTION_TYPES.HIGHLIGHT_ITEM,
                        id: id,
                        highlighted: highlighted
                    };
                };
                exports.highlightItem = highlightItem;
            /***/ },
            /***/ 137: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.setIsLoading = exports.resetTo = exports.clearAll = void 0;
                var constants_1 = __webpack_require__(883);
                var clearAll = function() {
                    return {
                        type: constants_1.ACTION_TYPES.CLEAR_ALL
                    };
                };
                exports.clearAll = clearAll;
                var resetTo = function(state) {
                    return {
                        type: constants_1.ACTION_TYPES.RESET_TO,
                        state: state
                    };
                };
                exports.resetTo = resetTo;
                var setIsLoading = function(isLoading) {
                    return {
                        type: constants_1.ACTION_TYPES.SET_IS_LOADING,
                        isLoading: isLoading
                    };
                };
                exports.setIsLoading = setIsLoading;
            /***/ },
            /***/ 373: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var deepmerge_1 = __importDefault(__webpack_require__(996));
                /* eslint-disable @typescript-eslint/no-explicit-any */ var fuse_js_1 = __importDefault(__webpack_require__(221));
                var choices_1 = __webpack_require__(282);
                var groups_1 = __webpack_require__(783);
                var items_1 = __webpack_require__(464);
                var misc_1 = __webpack_require__(137);
                var components_1 = __webpack_require__(520);
                var constants_1 = __webpack_require__(883);
                var defaults_1 = __webpack_require__(789);
                var utils_1 = __webpack_require__(799);
                var reducers_1 = __webpack_require__(655);
                var store_1 = __importDefault(__webpack_require__(744));
                var templates_1 = __importDefault(__webpack_require__(686));
                /** @see {@link http://browserhacks.com/#hack-acea075d0ac6954f275a70023906050c} */ var IS_IE11 = '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style;
                var USER_DEFAULTS = {};
                /**
 * Choices
 * @author Josh Johnson<josh@joshuajohnson.co.uk>
 */ var Choices = /** @class */ function() {
                    function Choices(element, userConfig) {
                        if (element === void 0) element = '[data-choice]';
                        if (userConfig === void 0) userConfig = {};
                        var _this = this;
                        if (userConfig.allowHTML === undefined) console.warn('Deprecation warning: allowHTML will default to false in a future release. To render HTML in Choices, you will need to set it to true. Setting allowHTML will suppress this message.');
                        this.config = deepmerge_1.default.all([
                            defaults_1.DEFAULT_CONFIG,
                            Choices.defaults.options,
                            userConfig
                        ], // When merging array configs, replace with a copy of the userConfig array,
                        // instead of concatenating with the default array
                        {
                            arrayMerge: function(_, sourceArray) {
                                return __spreadArray([], sourceArray, true);
                            }
                        });
                        var invalidConfigOptions = (0, utils_1.diff)(this.config, defaults_1.DEFAULT_CONFIG);
                        if (invalidConfigOptions.length) console.warn('Unknown config option(s) passed', invalidConfigOptions.join(', '));
                        var passedElement = typeof element === 'string' ? document.querySelector(element) : element;
                        if (!(passedElement instanceof HTMLInputElement || passedElement instanceof HTMLSelectElement)) throw TypeError('Expected one of the following types text|select-one|select-multiple');
                        this._isTextElement = passedElement.type === constants_1.TEXT_TYPE;
                        this._isSelectOneElement = passedElement.type === constants_1.SELECT_ONE_TYPE;
                        this._isSelectMultipleElement = passedElement.type === constants_1.SELECT_MULTIPLE_TYPE;
                        this._isSelectElement = this._isSelectOneElement || this._isSelectMultipleElement;
                        this.config.searchEnabled = this._isSelectMultipleElement || this.config.searchEnabled;
                        if (![
                            'auto',
                            'always'
                        ].includes("".concat(this.config.renderSelectedChoices))) this.config.renderSelectedChoices = 'auto';
                        if (userConfig.addItemFilter && typeof userConfig.addItemFilter !== 'function') {
                            var re = userConfig.addItemFilter instanceof RegExp ? userConfig.addItemFilter : new RegExp(userConfig.addItemFilter);
                            this.config.addItemFilter = re.test.bind(re);
                        }
                        if (this._isTextElement) this.passedElement = new components_1.WrappedInput({
                            element: passedElement,
                            classNames: this.config.classNames,
                            delimiter: this.config.delimiter
                        });
                        else this.passedElement = new components_1.WrappedSelect({
                            element: passedElement,
                            classNames: this.config.classNames,
                            template: function(data) {
                                return _this._templates.option(data);
                            }
                        });
                        this.initialised = false;
                        this._store = new store_1.default();
                        this._initialState = reducers_1.defaultState;
                        this._currentState = reducers_1.defaultState;
                        this._prevState = reducers_1.defaultState;
                        this._currentValue = '';
                        this._canSearch = !!this.config.searchEnabled;
                        this._isScrollingOnIe = false;
                        this._highlightPosition = 0;
                        this._wasTap = true;
                        this._placeholderValue = this._generatePlaceholderValue();
                        this._baseId = (0, utils_1.generateId)(this.passedElement.element, 'choices-');
                        /**
     * setting direction in cases where it's explicitly set on passedElement
     * or when calculated direction is different from the document
     */ this._direction = this.passedElement.dir;
                        if (!this._direction) {
                            var elementDirection = window.getComputedStyle(this.passedElement.element).direction;
                            var documentDirection = window.getComputedStyle(document.documentElement).direction;
                            if (elementDirection !== documentDirection) this._direction = elementDirection;
                        }
                        this._idNames = {
                            itemChoice: 'item-choice'
                        };
                        if (this._isSelectElement) {
                            // Assign preset groups from passed element
                            this._presetGroups = this.passedElement.optionGroups;
                            // Assign preset options from passed element
                            this._presetOptions = this.passedElement.options;
                        }
                        // Assign preset choices from passed object
                        this._presetChoices = this.config.choices;
                        // Assign preset items from passed object first
                        this._presetItems = this.config.items;
                        // Add any values passed from attribute
                        if (this.passedElement.value && this._isTextElement) {
                            var splitValues = this.passedElement.value.split(this.config.delimiter);
                            this._presetItems = this._presetItems.concat(splitValues);
                        }
                        // Create array of choices from option elements
                        if (this.passedElement.options) this.passedElement.options.forEach(function(option) {
                            _this._presetChoices.push({
                                value: option.value,
                                label: option.innerHTML,
                                selected: !!option.selected,
                                disabled: option.disabled || option.parentNode.disabled,
                                placeholder: option.value === '' || option.hasAttribute('placeholder'),
                                customProperties: (0, utils_1.parseCustomProperties)(option.dataset.customProperties)
                            });
                        });
                        this._render = this._render.bind(this);
                        this._onFocus = this._onFocus.bind(this);
                        this._onBlur = this._onBlur.bind(this);
                        this._onKeyUp = this._onKeyUp.bind(this);
                        this._onKeyDown = this._onKeyDown.bind(this);
                        this._onClick = this._onClick.bind(this);
                        this._onTouchMove = this._onTouchMove.bind(this);
                        this._onTouchEnd = this._onTouchEnd.bind(this);
                        this._onMouseDown = this._onMouseDown.bind(this);
                        this._onMouseOver = this._onMouseOver.bind(this);
                        this._onFormReset = this._onFormReset.bind(this);
                        this._onSelectKey = this._onSelectKey.bind(this);
                        this._onEnterKey = this._onEnterKey.bind(this);
                        this._onEscapeKey = this._onEscapeKey.bind(this);
                        this._onDirectionKey = this._onDirectionKey.bind(this);
                        this._onDeleteKey = this._onDeleteKey.bind(this);
                        // If element has already been initialised with Choices, fail silently
                        if (this.passedElement.isActive) {
                            if (!this.config.silent) console.warn('Trying to initialise Choices on element already initialised', {
                                element: element
                            });
                            this.initialised = true;
                            return;
                        }
                        // Let's go
                        this.init();
                    }
                    Object.defineProperty(Choices, "defaults", {
                        get: function() {
                            return Object.preventExtensions({
                                get options () {
                                    return USER_DEFAULTS;
                                },
                                get templates () {
                                    return templates_1.default;
                                }
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Choices.prototype.init = function() {
                        if (this.initialised) return;
                        this._createTemplates();
                        this._createElements();
                        this._createStructure();
                        this._store.subscribe(this._render);
                        this._render();
                        this._addEventListeners();
                        var shouldDisable = !this.config.addItems || this.passedElement.element.hasAttribute('disabled');
                        if (shouldDisable) this.disable();
                        this.initialised = true;
                        var callbackOnInit = this.config.callbackOnInit;
                        // Run callback if it is a function
                        if (callbackOnInit && typeof callbackOnInit === 'function') callbackOnInit.call(this);
                    };
                    Choices.prototype.destroy = function() {
                        if (!this.initialised) return;
                        this._removeEventListeners();
                        this.passedElement.reveal();
                        this.containerOuter.unwrap(this.passedElement.element);
                        this.clearStore();
                        if (this._isSelectElement) this.passedElement.options = this._presetOptions;
                        this._templates = templates_1.default;
                        this.initialised = false;
                    };
                    Choices.prototype.enable = function() {
                        if (this.passedElement.isDisabled) this.passedElement.enable();
                        if (this.containerOuter.isDisabled) {
                            this._addEventListeners();
                            this.input.enable();
                            this.containerOuter.enable();
                        }
                        return this;
                    };
                    Choices.prototype.disable = function() {
                        if (!this.passedElement.isDisabled) this.passedElement.disable();
                        if (!this.containerOuter.isDisabled) {
                            this._removeEventListeners();
                            this.input.disable();
                            this.containerOuter.disable();
                        }
                        return this;
                    };
                    Choices.prototype.highlightItem = function(item, runEvent) {
                        if (runEvent === void 0) runEvent = true;
                        if (!item || !item.id) return this;
                        var id = item.id, _a = item.groupId, groupId = _a === void 0 ? -1 : _a, _b = item.value, value = _b === void 0 ? '' : _b, _c = item.label, label = _c === void 0 ? '' : _c;
                        var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        this._store.dispatch((0, items_1.highlightItem)(id, true));
                        if (runEvent) this.passedElement.triggerEvent(constants_1.EVENTS.highlightItem, {
                            id: id,
                            value: value,
                            label: label,
                            groupValue: group && group.value ? group.value : null
                        });
                        return this;
                    };
                    Choices.prototype.unhighlightItem = function(item) {
                        if (!item || !item.id) return this;
                        var id = item.id, _a = item.groupId, groupId = _a === void 0 ? -1 : _a, _b = item.value, value = _b === void 0 ? '' : _b, _c = item.label, label = _c === void 0 ? '' : _c;
                        var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        this._store.dispatch((0, items_1.highlightItem)(id, false));
                        this.passedElement.triggerEvent(constants_1.EVENTS.highlightItem, {
                            id: id,
                            value: value,
                            label: label,
                            groupValue: group && group.value ? group.value : null
                        });
                        return this;
                    };
                    Choices.prototype.highlightAll = function() {
                        var _this = this;
                        this._store.items.forEach(function(item) {
                            return _this.highlightItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.unhighlightAll = function() {
                        var _this = this;
                        this._store.items.forEach(function(item) {
                            return _this.unhighlightItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.removeActiveItemsByValue = function(value) {
                        var _this = this;
                        this._store.activeItems.filter(function(item) {
                            return item.value === value;
                        }).forEach(function(item) {
                            return _this._removeItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.removeActiveItems = function(excludedId) {
                        var _this = this;
                        this._store.activeItems.filter(function(_a) {
                            var id = _a.id;
                            return id !== excludedId;
                        }).forEach(function(item) {
                            return _this._removeItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.removeHighlightedItems = function(runEvent) {
                        var _this = this;
                        if (runEvent === void 0) runEvent = false;
                        this._store.highlightedActiveItems.forEach(function(item) {
                            _this._removeItem(item);
                            // If this action was performed by the user
                            // trigger the event
                            if (runEvent) _this._triggerChange(item.value);
                        });
                        return this;
                    };
                    Choices.prototype.showDropdown = function(preventInputFocus) {
                        var _this = this;
                        if (this.dropdown.isActive) return this;
                        requestAnimationFrame(function() {
                            _this.dropdown.show();
                            _this.containerOuter.open(_this.dropdown.distanceFromTopWindow);
                            if (!preventInputFocus && _this._canSearch) _this.input.focus();
                            _this.passedElement.triggerEvent(constants_1.EVENTS.showDropdown, {});
                        });
                        return this;
                    };
                    Choices.prototype.hideDropdown = function(preventInputBlur) {
                        var _this = this;
                        if (!this.dropdown.isActive) return this;
                        requestAnimationFrame(function() {
                            _this.dropdown.hide();
                            _this.containerOuter.close();
                            if (!preventInputBlur && _this._canSearch) {
                                _this.input.removeActiveDescendant();
                                _this.input.blur();
                            }
                            _this.passedElement.triggerEvent(constants_1.EVENTS.hideDropdown, {});
                        });
                        return this;
                    };
                    Choices.prototype.getValue = function(valueOnly) {
                        if (valueOnly === void 0) valueOnly = false;
                        var values = this._store.activeItems.reduce(function(selectedItems, item) {
                            var itemValue = valueOnly ? item.value : item;
                            selectedItems.push(itemValue);
                            return selectedItems;
                        }, []);
                        return this._isSelectOneElement ? values[0] : values;
                    };
                    Choices.prototype.setValue = function(items) {
                        var _this = this;
                        if (!this.initialised) return this;
                        items.forEach(function(value) {
                            return _this._setChoiceOrItem(value);
                        });
                        return this;
                    };
                    Choices.prototype.setChoiceByValue = function(value) {
                        var _this = this;
                        if (!this.initialised || this._isTextElement) return this;
                        // If only one value has been passed, convert to array
                        var choiceValue = Array.isArray(value) ? value : [
                            value
                        ];
                        // Loop through each value and
                        choiceValue.forEach(function(val) {
                            return _this._findAndSelectChoiceByValue(val);
                        });
                        return this;
                    };
                    /**
   * Set choices of select input via an array of objects (or function that returns array of object or promise of it),
   * a value field name and a label field name.
   * This behaves the same as passing items via the choices option but can be called after initialising Choices.
   * This can also be used to add groups of choices (see example 2); Optionally pass a true `replaceChoices` value to remove any existing choices.
   * Optionally pass a `customProperties` object to add additional data to your choices (useful when searching/filtering etc).
   *
   * **Input types affected:** select-one, select-multiple
   *
   * @example
   * ```js
   * const example = new Choices(element);
   *
   * example.setChoices([
   *   {value: 'One', label: 'Label One', disabled: true},
   *   {value: 'Two', label: 'Label Two', selected: true},
   *   {value: 'Three', label: 'Label Three'},
   * ], 'value', 'label', false);
   * ```
   *
   * @example
   * ```js
   * const example = new Choices(element);
   *
   * example.setChoices(async () => {
   *   try {
   *      const items = await fetch('/items');
   *      return items.json()
   *   } catch(err) {
   *      console.error(err)
   *   }
   * });
   * ```
   *
   * @example
   * ```js
   * const example = new Choices(element);
   *
   * example.setChoices([{
   *   label: 'Group one',
   *   id: 1,
   *   disabled: false,
   *   choices: [
   *     {value: 'Child One', label: 'Child One', selected: true},
   *     {value: 'Child Two', label: 'Child Two',  disabled: true},
   *     {value: 'Child Three', label: 'Child Three'},
   *   ]
   * },
   * {
   *   label: 'Group two',
   *   id: 2,
   *   disabled: false,
   *   choices: [
   *     {value: 'Child Four', label: 'Child Four', disabled: true},
   *     {value: 'Child Five', label: 'Child Five'},
   *     {value: 'Child Six', label: 'Child Six', customProperties: {
   *       description: 'Custom description about child six',
   *       random: 'Another random custom property'
   *     }},
   *   ]
   * }], 'value', 'label', false);
   * ```
   */ Choices.prototype.setChoices = function(choicesArrayOrFetcher, value, label, replaceChoices) {
                        var _this = this;
                        if (choicesArrayOrFetcher === void 0) choicesArrayOrFetcher = [];
                        if (value === void 0) value = 'value';
                        if (label === void 0) label = 'label';
                        if (replaceChoices === void 0) replaceChoices = false;
                        if (!this.initialised) throw new ReferenceError("setChoices was called on a non-initialized instance of Choices");
                        if (!this._isSelectElement) throw new TypeError("setChoices can't be used with INPUT based Choices");
                        if (typeof value !== 'string' || !value) throw new TypeError("value parameter must be a name of 'value' field in passed objects");
                        // Clear choices if needed
                        if (replaceChoices) this.clearChoices();
                        if (typeof choicesArrayOrFetcher === 'function') {
                            // it's a choices fetcher function
                            var fetcher_1 = choicesArrayOrFetcher(this);
                            if (typeof Promise === 'function' && fetcher_1 instanceof Promise) // that's a promise
                            // eslint-disable-next-line no-promise-executor-return
                            return new Promise(function(resolve) {
                                return requestAnimationFrame(resolve);
                            }).then(function() {
                                return _this._handleLoadingState(true);
                            }).then(function() {
                                return fetcher_1;
                            }).then(function(data) {
                                return _this.setChoices(data, value, label, replaceChoices);
                            }).catch(function(err) {
                                if (!_this.config.silent) console.error(err);
                            }).then(function() {
                                return _this._handleLoadingState(false);
                            }).then(function() {
                                return _this;
                            });
                            // function returned something else than promise, let's check if it's an array of choices
                            if (!Array.isArray(fetcher_1)) throw new TypeError(".setChoices first argument function must return either array of choices or Promise, got: ".concat(typeof fetcher_1));
                            // recursion with results, it's sync and choices were cleared already
                            return this.setChoices(fetcher_1, value, label, false);
                        }
                        if (!Array.isArray(choicesArrayOrFetcher)) throw new TypeError(".setChoices must be called either with array of choices with a function resulting into Promise of array of choices");
                        this.containerOuter.removeLoadingState();
                        this._startLoading();
                        choicesArrayOrFetcher.forEach(function(groupOrChoice) {
                            if (groupOrChoice.choices) _this._addGroup({
                                id: groupOrChoice.id ? parseInt("".concat(groupOrChoice.id), 10) : null,
                                group: groupOrChoice,
                                valueKey: value,
                                labelKey: label
                            });
                            else {
                                var choice = groupOrChoice;
                                _this._addChoice({
                                    value: choice[value],
                                    label: choice[label],
                                    isSelected: !!choice.selected,
                                    isDisabled: !!choice.disabled,
                                    placeholder: !!choice.placeholder,
                                    customProperties: choice.customProperties
                                });
                            }
                        });
                        this._stopLoading();
                        return this;
                    };
                    Choices.prototype.clearChoices = function() {
                        this._store.dispatch((0, choices_1.clearChoices)());
                        return this;
                    };
                    Choices.prototype.clearStore = function() {
                        this._store.dispatch((0, misc_1.clearAll)());
                        return this;
                    };
                    Choices.prototype.clearInput = function() {
                        var shouldSetInputWidth = !this._isSelectOneElement;
                        this.input.clear(shouldSetInputWidth);
                        if (!this._isTextElement && this._canSearch) {
                            this._isSearching = false;
                            this._store.dispatch((0, choices_1.activateChoices)(true));
                        }
                        return this;
                    };
                    Choices.prototype._render = function() {
                        if (this._store.isLoading()) return;
                        this._currentState = this._store.state;
                        var stateChanged = this._currentState.choices !== this._prevState.choices || this._currentState.groups !== this._prevState.groups || this._currentState.items !== this._prevState.items;
                        var shouldRenderChoices = this._isSelectElement;
                        var shouldRenderItems = this._currentState.items !== this._prevState.items;
                        if (!stateChanged) return;
                        if (shouldRenderChoices) this._renderChoices();
                        if (shouldRenderItems) this._renderItems();
                        this._prevState = this._currentState;
                    };
                    Choices.prototype._renderChoices = function() {
                        var _this = this;
                        var _a = this._store, activeGroups = _a.activeGroups, activeChoices = _a.activeChoices;
                        var choiceListFragment = document.createDocumentFragment();
                        this.choiceList.clear();
                        if (this.config.resetScrollPosition) requestAnimationFrame(function() {
                            return _this.choiceList.scrollToTop();
                        });
                        // If we have grouped options
                        if (activeGroups.length >= 1 && !this._isSearching) {
                            // If we have a placeholder choice along with groups
                            var activePlaceholders = activeChoices.filter(function(activeChoice) {
                                return activeChoice.placeholder === true && activeChoice.groupId === -1;
                            });
                            if (activePlaceholders.length >= 1) choiceListFragment = this._createChoicesFragment(activePlaceholders, choiceListFragment);
                            choiceListFragment = this._createGroupsFragment(activeGroups, activeChoices, choiceListFragment);
                        } else if (activeChoices.length >= 1) choiceListFragment = this._createChoicesFragment(activeChoices, choiceListFragment);
                        // If we have choices to show
                        if (choiceListFragment.childNodes && choiceListFragment.childNodes.length > 0) {
                            var activeItems = this._store.activeItems;
                            var canAddItem = this._canAddItem(activeItems, this.input.value);
                            // ...and we can select them
                            if (canAddItem.response) {
                                // ...append them and highlight the first choice
                                this.choiceList.append(choiceListFragment);
                                this._highlightChoice();
                            } else {
                                var notice = this._getTemplate('notice', canAddItem.notice);
                                this.choiceList.append(notice);
                            }
                        } else {
                            // Otherwise show a notice
                            var dropdownItem = void 0;
                            var notice = void 0;
                            if (this._isSearching) {
                                notice = typeof this.config.noResultsText === 'function' ? this.config.noResultsText() : this.config.noResultsText;
                                dropdownItem = this._getTemplate('notice', notice, 'no-results');
                            } else {
                                notice = typeof this.config.noChoicesText === 'function' ? this.config.noChoicesText() : this.config.noChoicesText;
                                dropdownItem = this._getTemplate('notice', notice, 'no-choices');
                            }
                            this.choiceList.append(dropdownItem);
                        }
                    };
                    Choices.prototype._renderItems = function() {
                        var activeItems = this._store.activeItems || [];
                        this.itemList.clear();
                        // Create a fragment to store our list items
                        // (so we don't have to update the DOM for each item)
                        var itemListFragment = this._createItemsFragment(activeItems);
                        // If we have items to add, append them
                        if (itemListFragment.childNodes) this.itemList.append(itemListFragment);
                    };
                    Choices.prototype._createGroupsFragment = function(groups, choices, fragment) {
                        var _this = this;
                        if (fragment === void 0) fragment = document.createDocumentFragment();
                        var getGroupChoices = function(group) {
                            return choices.filter(function(choice) {
                                if (_this._isSelectOneElement) return choice.groupId === group.id;
                                return choice.groupId === group.id && (_this.config.renderSelectedChoices === 'always' || !choice.selected);
                            });
                        };
                        // If sorting is enabled, filter groups
                        if (this.config.shouldSort) groups.sort(this.config.sorter);
                        groups.forEach(function(group) {
                            var groupChoices = getGroupChoices(group);
                            if (groupChoices.length >= 1) {
                                var dropdownGroup = _this._getTemplate('choiceGroup', group);
                                fragment.appendChild(dropdownGroup);
                                _this._createChoicesFragment(groupChoices, fragment, true);
                            }
                        });
                        return fragment;
                    };
                    Choices.prototype._createChoicesFragment = function(choices, fragment, withinGroup) {
                        var _this = this;
                        if (fragment === void 0) fragment = document.createDocumentFragment();
                        if (withinGroup === void 0) withinGroup = false;
                        // Create a fragment to store our list items (so we don't have to update the DOM for each item)
                        var _a = this.config, renderSelectedChoices = _a.renderSelectedChoices, searchResultLimit = _a.searchResultLimit, renderChoiceLimit = _a.renderChoiceLimit;
                        var filter = this._isSearching ? utils_1.sortByScore : this.config.sorter;
                        var appendChoice = function(choice) {
                            var shouldRender = renderSelectedChoices === 'auto' ? _this._isSelectOneElement || !choice.selected : true;
                            if (shouldRender) {
                                var dropdownItem = _this._getTemplate('choice', choice, _this.config.itemSelectText);
                                fragment.appendChild(dropdownItem);
                            }
                        };
                        var rendererableChoices = choices;
                        if (renderSelectedChoices === 'auto' && !this._isSelectOneElement) rendererableChoices = choices.filter(function(choice) {
                            return !choice.selected;
                        });
                        // Split array into placeholders and "normal" choices
                        var _b = rendererableChoices.reduce(function(acc, choice) {
                            if (choice.placeholder) acc.placeholderChoices.push(choice);
                            else acc.normalChoices.push(choice);
                            return acc;
                        }, {
                            placeholderChoices: [],
                            normalChoices: []
                        }), placeholderChoices = _b.placeholderChoices, normalChoices = _b.normalChoices;
                        // If sorting is enabled or the user is searching, filter choices
                        if (this.config.shouldSort || this._isSearching) normalChoices.sort(filter);
                        var choiceLimit = rendererableChoices.length;
                        // Prepend placeholeder
                        var sortedChoices = this._isSelectOneElement ? __spreadArray(__spreadArray([], placeholderChoices, true), normalChoices, true) : normalChoices;
                        if (this._isSearching) choiceLimit = searchResultLimit;
                        else if (renderChoiceLimit && renderChoiceLimit > 0 && !withinGroup) choiceLimit = renderChoiceLimit;
                        // Add each choice to dropdown within range
                        for(var i = 0; i < choiceLimit; i += 1)if (sortedChoices[i]) appendChoice(sortedChoices[i]);
                        return fragment;
                    };
                    Choices.prototype._createItemsFragment = function(items, fragment) {
                        var _this = this;
                        if (fragment === void 0) fragment = document.createDocumentFragment();
                        // Create fragment to add elements to
                        var _a = this.config, shouldSortItems = _a.shouldSortItems, sorter = _a.sorter, removeItemButton = _a.removeItemButton;
                        // If sorting is enabled, filter items
                        if (shouldSortItems && !this._isSelectOneElement) items.sort(sorter);
                        if (this._isTextElement) // Update the value of the hidden input
                        this.passedElement.value = items.map(function(_a) {
                            var value = _a.value;
                            return value;
                        }).join(this.config.delimiter);
                        else // Update the options of the hidden input
                        this.passedElement.options = items;
                        var addItemToFragment = function(item) {
                            // Create new list element
                            var listItem = _this._getTemplate('item', item, removeItemButton);
                            // Append it to list
                            fragment.appendChild(listItem);
                        };
                        // Add each list item to list
                        items.forEach(addItemToFragment);
                        return fragment;
                    };
                    Choices.prototype._triggerChange = function(value) {
                        if (value === undefined || value === null) return;
                        this.passedElement.triggerEvent(constants_1.EVENTS.change, {
                            value: value
                        });
                    };
                    Choices.prototype._selectPlaceholderChoice = function(placeholderChoice) {
                        this._addItem({
                            value: placeholderChoice.value,
                            label: placeholderChoice.label,
                            choiceId: placeholderChoice.id,
                            groupId: placeholderChoice.groupId,
                            placeholder: placeholderChoice.placeholder
                        });
                        this._triggerChange(placeholderChoice.value);
                    };
                    Choices.prototype._handleButtonAction = function(activeItems, element) {
                        if (!activeItems || !element || !this.config.removeItems || !this.config.removeItemButton) return;
                        var itemId = element.parentNode && element.parentNode.dataset.id;
                        var itemToRemove = itemId && activeItems.find(function(item) {
                            return item.id === parseInt(itemId, 10);
                        });
                        if (!itemToRemove) return;
                        // Remove item associated with button
                        this._removeItem(itemToRemove);
                        this._triggerChange(itemToRemove.value);
                        if (this._isSelectOneElement && this._store.placeholderChoice) this._selectPlaceholderChoice(this._store.placeholderChoice);
                    };
                    Choices.prototype._handleItemAction = function(activeItems, element, hasShiftKey) {
                        var _this = this;
                        if (hasShiftKey === void 0) hasShiftKey = false;
                        if (!activeItems || !element || !this.config.removeItems || this._isSelectOneElement) return;
                        var passedId = element.dataset.id;
                        // We only want to select one item with a click
                        // so we deselect any items that aren't the target
                        // unless shift is being pressed
                        activeItems.forEach(function(item) {
                            if (item.id === parseInt("".concat(passedId), 10) && !item.highlighted) _this.highlightItem(item);
                            else if (!hasShiftKey && item.highlighted) _this.unhighlightItem(item);
                        });
                        // Focus input as without focus, a user cannot do anything with a
                        // highlighted item
                        this.input.focus();
                    };
                    Choices.prototype._handleChoiceAction = function(activeItems, element) {
                        if (!activeItems || !element) return;
                        // If we are clicking on an option
                        var id = element.dataset.id;
                        var choice = id && this._store.getChoiceById(id);
                        if (!choice) return;
                        var passedKeyCode = activeItems[0] && activeItems[0].keyCode ? activeItems[0].keyCode : undefined;
                        var hasActiveDropdown = this.dropdown.isActive;
                        // Update choice keyCode
                        choice.keyCode = passedKeyCode;
                        this.passedElement.triggerEvent(constants_1.EVENTS.choice, {
                            choice: choice
                        });
                        if (!choice.selected && !choice.disabled) {
                            var canAddItem = this._canAddItem(activeItems, choice.value);
                            if (canAddItem.response) {
                                this._addItem({
                                    value: choice.value,
                                    label: choice.label,
                                    choiceId: choice.id,
                                    groupId: choice.groupId,
                                    customProperties: choice.customProperties,
                                    placeholder: choice.placeholder,
                                    keyCode: choice.keyCode
                                });
                                this._triggerChange(choice.value);
                            }
                        }
                        this.clearInput();
                        // We want to close the dropdown if we are dealing with a single select box
                        if (hasActiveDropdown && this._isSelectOneElement) {
                            this.hideDropdown(true);
                            this.containerOuter.focus();
                        }
                    };
                    Choices.prototype._handleBackspace = function(activeItems) {
                        if (!this.config.removeItems || !activeItems) return;
                        var lastItem = activeItems[activeItems.length - 1];
                        var hasHighlightedItems = activeItems.some(function(item) {
                            return item.highlighted;
                        });
                        // If editing the last item is allowed and there are not other selected items,
                        // we can edit the item value. Otherwise if we can remove items, remove all selected items
                        if (this.config.editItems && !hasHighlightedItems && lastItem) {
                            this.input.value = lastItem.value;
                            this.input.setWidth();
                            this._removeItem(lastItem);
                            this._triggerChange(lastItem.value);
                        } else {
                            if (!hasHighlightedItems) // Highlight last item if none already highlighted
                            this.highlightItem(lastItem, false);
                            this.removeHighlightedItems(true);
                        }
                    };
                    Choices.prototype._startLoading = function() {
                        this._store.dispatch((0, misc_1.setIsLoading)(true));
                    };
                    Choices.prototype._stopLoading = function() {
                        this._store.dispatch((0, misc_1.setIsLoading)(false));
                    };
                    Choices.prototype._handleLoadingState = function(setLoading) {
                        if (setLoading === void 0) setLoading = true;
                        var placeholderItem = this.itemList.getChild(".".concat(this.config.classNames.placeholder));
                        if (setLoading) {
                            this.disable();
                            this.containerOuter.addLoadingState();
                            if (this._isSelectOneElement) {
                                if (!placeholderItem) {
                                    placeholderItem = this._getTemplate('placeholder', this.config.loadingText);
                                    if (placeholderItem) this.itemList.append(placeholderItem);
                                } else placeholderItem.innerHTML = this.config.loadingText;
                            } else this.input.placeholder = this.config.loadingText;
                        } else {
                            this.enable();
                            this.containerOuter.removeLoadingState();
                            if (this._isSelectOneElement) {
                                if (placeholderItem) placeholderItem.innerHTML = this._placeholderValue || '';
                            } else this.input.placeholder = this._placeholderValue || '';
                        }
                    };
                    Choices.prototype._handleSearch = function(value) {
                        if (!this.input.isFocussed) return;
                        var choices = this._store.choices;
                        var _a = this.config, searchFloor = _a.searchFloor, searchChoices = _a.searchChoices;
                        var hasUnactiveChoices = choices.some(function(option) {
                            return !option.active;
                        });
                        // Check that we have a value to search and the input was an alphanumeric character
                        if (value !== null && typeof value !== 'undefined' && value.length >= searchFloor) {
                            var resultCount = searchChoices ? this._searchChoices(value) : 0;
                            // Trigger search event
                            this.passedElement.triggerEvent(constants_1.EVENTS.search, {
                                value: value,
                                resultCount: resultCount
                            });
                        } else if (hasUnactiveChoices) {
                            // Otherwise reset choices to active
                            this._isSearching = false;
                            this._store.dispatch((0, choices_1.activateChoices)(true));
                        }
                    };
                    Choices.prototype._canAddItem = function(activeItems, value) {
                        var canAddItem = true;
                        var notice = typeof this.config.addItemText === 'function' ? this.config.addItemText(value) : this.config.addItemText;
                        if (!this._isSelectOneElement) {
                            var isDuplicateValue = (0, utils_1.existsInArray)(activeItems, value);
                            if (this.config.maxItemCount > 0 && this.config.maxItemCount <= activeItems.length) {
                                // If there is a max entry limit and we have reached that limit
                                // don't update
                                canAddItem = false;
                                notice = typeof this.config.maxItemText === 'function' ? this.config.maxItemText(this.config.maxItemCount) : this.config.maxItemText;
                            }
                            if (!this.config.duplicateItemsAllowed && isDuplicateValue && canAddItem) {
                                canAddItem = false;
                                notice = typeof this.config.uniqueItemText === 'function' ? this.config.uniqueItemText(value) : this.config.uniqueItemText;
                            }
                            if (this._isTextElement && this.config.addItems && canAddItem && typeof this.config.addItemFilter === 'function' && !this.config.addItemFilter(value)) {
                                canAddItem = false;
                                notice = typeof this.config.customAddItemText === 'function' ? this.config.customAddItemText(value) : this.config.customAddItemText;
                            }
                        }
                        return {
                            response: canAddItem,
                            notice: notice
                        };
                    };
                    Choices.prototype._searchChoices = function(value) {
                        var newValue = typeof value === 'string' ? value.trim() : value;
                        var currentValue = typeof this._currentValue === 'string' ? this._currentValue.trim() : this._currentValue;
                        if (newValue.length < 1 && newValue === "".concat(currentValue, " ")) return 0;
                        // If new value matches the desired length and is not the same as the current value with a space
                        var haystack = this._store.searchableChoices;
                        var needle = newValue;
                        var options = Object.assign(this.config.fuseOptions, {
                            keys: __spreadArray([], this.config.searchFields, true),
                            includeMatches: true
                        });
                        var fuse = new fuse_js_1.default(haystack, options);
                        var results = fuse.search(needle); // see https://github.com/krisk/Fuse/issues/303
                        this._currentValue = newValue;
                        this._highlightPosition = 0;
                        this._isSearching = true;
                        this._store.dispatch((0, choices_1.filterChoices)(results));
                        return results.length;
                    };
                    Choices.prototype._addEventListeners = function() {
                        var documentElement = document.documentElement;
                        // capture events - can cancel event processing or propagation
                        documentElement.addEventListener('touchend', this._onTouchEnd, true);
                        this.containerOuter.element.addEventListener('keydown', this._onKeyDown, true);
                        this.containerOuter.element.addEventListener('mousedown', this._onMouseDown, true);
                        // passive events - doesn't call `preventDefault` or `stopPropagation`
                        documentElement.addEventListener('click', this._onClick, {
                            passive: true
                        });
                        documentElement.addEventListener('touchmove', this._onTouchMove, {
                            passive: true
                        });
                        this.dropdown.element.addEventListener('mouseover', this._onMouseOver, {
                            passive: true
                        });
                        if (this._isSelectOneElement) {
                            this.containerOuter.element.addEventListener('focus', this._onFocus, {
                                passive: true
                            });
                            this.containerOuter.element.addEventListener('blur', this._onBlur, {
                                passive: true
                            });
                        }
                        this.input.element.addEventListener('keyup', this._onKeyUp, {
                            passive: true
                        });
                        this.input.element.addEventListener('focus', this._onFocus, {
                            passive: true
                        });
                        this.input.element.addEventListener('blur', this._onBlur, {
                            passive: true
                        });
                        if (this.input.element.form) this.input.element.form.addEventListener('reset', this._onFormReset, {
                            passive: true
                        });
                        this.input.addEventListeners();
                    };
                    Choices.prototype._removeEventListeners = function() {
                        var documentElement = document.documentElement;
                        documentElement.removeEventListener('touchend', this._onTouchEnd, true);
                        this.containerOuter.element.removeEventListener('keydown', this._onKeyDown, true);
                        this.containerOuter.element.removeEventListener('mousedown', this._onMouseDown, true);
                        documentElement.removeEventListener('click', this._onClick);
                        documentElement.removeEventListener('touchmove', this._onTouchMove);
                        this.dropdown.element.removeEventListener('mouseover', this._onMouseOver);
                        if (this._isSelectOneElement) {
                            this.containerOuter.element.removeEventListener('focus', this._onFocus);
                            this.containerOuter.element.removeEventListener('blur', this._onBlur);
                        }
                        this.input.element.removeEventListener('keyup', this._onKeyUp);
                        this.input.element.removeEventListener('focus', this._onFocus);
                        this.input.element.removeEventListener('blur', this._onBlur);
                        if (this.input.element.form) this.input.element.form.removeEventListener('reset', this._onFormReset);
                        this.input.removeEventListeners();
                    };
                    Choices.prototype._onKeyDown = function(event) {
                        var keyCode = event.keyCode;
                        var activeItems = this._store.activeItems;
                        var hasFocusedInput = this.input.isFocussed;
                        var hasActiveDropdown = this.dropdown.isActive;
                        var hasItems = this.itemList.hasChildren();
                        var keyString = String.fromCharCode(keyCode);
                        // eslint-disable-next-line no-control-regex
                        var wasPrintableChar = /[^\x00-\x1F]/.test(keyString);
                        var BACK_KEY = constants_1.KEY_CODES.BACK_KEY, DELETE_KEY = constants_1.KEY_CODES.DELETE_KEY, ENTER_KEY = constants_1.KEY_CODES.ENTER_KEY, A_KEY = constants_1.KEY_CODES.A_KEY, ESC_KEY = constants_1.KEY_CODES.ESC_KEY, UP_KEY = constants_1.KEY_CODES.UP_KEY, DOWN_KEY = constants_1.KEY_CODES.DOWN_KEY, PAGE_UP_KEY = constants_1.KEY_CODES.PAGE_UP_KEY, PAGE_DOWN_KEY = constants_1.KEY_CODES.PAGE_DOWN_KEY;
                        if (!this._isTextElement && !hasActiveDropdown && wasPrintableChar) {
                            this.showDropdown();
                            if (!this.input.isFocussed) /*
          We update the input value with the pressed key as
          the input was not focussed at the time of key press
          therefore does not have the value of the key.
        */ this.input.value += event.key.toLowerCase();
                        }
                        switch(keyCode){
                            case A_KEY:
                                return this._onSelectKey(event, hasItems);
                            case ENTER_KEY:
                                return this._onEnterKey(event, activeItems, hasActiveDropdown);
                            case ESC_KEY:
                                return this._onEscapeKey(hasActiveDropdown);
                            case UP_KEY:
                            case PAGE_UP_KEY:
                            case DOWN_KEY:
                            case PAGE_DOWN_KEY:
                                return this._onDirectionKey(event, hasActiveDropdown);
                            case DELETE_KEY:
                            case BACK_KEY:
                                return this._onDeleteKey(event, activeItems, hasFocusedInput);
                            default:
                        }
                    };
                    Choices.prototype._onKeyUp = function(_a) {
                        var target = _a.target, keyCode = _a.keyCode;
                        var value = this.input.value;
                        var activeItems = this._store.activeItems;
                        var canAddItem = this._canAddItem(activeItems, value);
                        var backKey = constants_1.KEY_CODES.BACK_KEY, deleteKey = constants_1.KEY_CODES.DELETE_KEY;
                        // We are typing into a text input and have a value, we want to show a dropdown
                        // notice. Otherwise hide the dropdown
                        if (this._isTextElement) {
                            var canShowDropdownNotice = canAddItem.notice && value;
                            if (canShowDropdownNotice) {
                                var dropdownItem = this._getTemplate('notice', canAddItem.notice);
                                this.dropdown.element.innerHTML = dropdownItem.outerHTML;
                                this.showDropdown(true);
                            } else this.hideDropdown(true);
                        } else {
                            var wasRemovalKeyCode = keyCode === backKey || keyCode === deleteKey;
                            var userHasRemovedValue = wasRemovalKeyCode && target && !target.value;
                            var canReactivateChoices = !this._isTextElement && this._isSearching;
                            var canSearch = this._canSearch && canAddItem.response;
                            if (userHasRemovedValue && canReactivateChoices) {
                                this._isSearching = false;
                                this._store.dispatch((0, choices_1.activateChoices)(true));
                            } else if (canSearch) this._handleSearch(this.input.rawValue);
                        }
                        this._canSearch = this.config.searchEnabled;
                    };
                    Choices.prototype._onSelectKey = function(event, hasItems) {
                        var ctrlKey = event.ctrlKey, metaKey = event.metaKey;
                        var hasCtrlDownKeyPressed = ctrlKey || metaKey;
                        // If CTRL + A or CMD + A have been pressed and there are items to select
                        if (hasCtrlDownKeyPressed && hasItems) {
                            this._canSearch = false;
                            var shouldHightlightAll = this.config.removeItems && !this.input.value && this.input.element === document.activeElement;
                            if (shouldHightlightAll) this.highlightAll();
                        }
                    };
                    Choices.prototype._onEnterKey = function(event, activeItems, hasActiveDropdown) {
                        var target = event.target;
                        var enterKey = constants_1.KEY_CODES.ENTER_KEY;
                        var targetWasButton = target && target.hasAttribute('data-button');
                        if (this._isTextElement && target && target.value) {
                            var value = this.input.value;
                            var canAddItem = this._canAddItem(activeItems, value);
                            if (canAddItem.response) {
                                this.hideDropdown(true);
                                this._addItem({
                                    value: value
                                });
                                this._triggerChange(value);
                                this.clearInput();
                            }
                        }
                        if (targetWasButton) {
                            this._handleButtonAction(activeItems, target);
                            event.preventDefault();
                        }
                        if (hasActiveDropdown) {
                            var highlightedChoice = this.dropdown.getChild(".".concat(this.config.classNames.highlightedState));
                            if (highlightedChoice) {
                                // add enter keyCode value
                                if (activeItems[0]) activeItems[0].keyCode = enterKey; // eslint-disable-line no-param-reassign
                                this._handleChoiceAction(activeItems, highlightedChoice);
                            }
                            event.preventDefault();
                        } else if (this._isSelectOneElement) {
                            this.showDropdown();
                            event.preventDefault();
                        }
                    };
                    Choices.prototype._onEscapeKey = function(hasActiveDropdown) {
                        if (hasActiveDropdown) {
                            this.hideDropdown(true);
                            this.containerOuter.focus();
                        }
                    };
                    Choices.prototype._onDirectionKey = function(event, hasActiveDropdown) {
                        var keyCode = event.keyCode, metaKey = event.metaKey;
                        var downKey = constants_1.KEY_CODES.DOWN_KEY, pageUpKey = constants_1.KEY_CODES.PAGE_UP_KEY, pageDownKey = constants_1.KEY_CODES.PAGE_DOWN_KEY;
                        // If up or down key is pressed, traverse through options
                        if (hasActiveDropdown || this._isSelectOneElement) {
                            this.showDropdown();
                            this._canSearch = false;
                            var directionInt = keyCode === downKey || keyCode === pageDownKey ? 1 : -1;
                            var skipKey = metaKey || keyCode === pageDownKey || keyCode === pageUpKey;
                            var selectableChoiceIdentifier = '[data-choice-selectable]';
                            var nextEl = void 0;
                            if (skipKey) {
                                if (directionInt > 0) nextEl = this.dropdown.element.querySelector("".concat(selectableChoiceIdentifier, ":last-of-type"));
                                else nextEl = this.dropdown.element.querySelector(selectableChoiceIdentifier);
                            } else {
                                var currentEl = this.dropdown.element.querySelector(".".concat(this.config.classNames.highlightedState));
                                if (currentEl) nextEl = (0, utils_1.getAdjacentEl)(currentEl, selectableChoiceIdentifier, directionInt);
                                else nextEl = this.dropdown.element.querySelector(selectableChoiceIdentifier);
                            }
                            if (nextEl) {
                                // We prevent default to stop the cursor moving
                                // when pressing the arrow
                                if (!(0, utils_1.isScrolledIntoView)(nextEl, this.choiceList.element, directionInt)) this.choiceList.scrollToChildElement(nextEl, directionInt);
                                this._highlightChoice(nextEl);
                            }
                            // Prevent default to maintain cursor position whilst
                            // traversing dropdown options
                            event.preventDefault();
                        }
                    };
                    Choices.prototype._onDeleteKey = function(event, activeItems, hasFocusedInput) {
                        var target = event.target;
                        // If backspace or delete key is pressed and the input has no value
                        if (!this._isSelectOneElement && !target.value && hasFocusedInput) {
                            this._handleBackspace(activeItems);
                            event.preventDefault();
                        }
                    };
                    Choices.prototype._onTouchMove = function() {
                        if (this._wasTap) this._wasTap = false;
                    };
                    Choices.prototype._onTouchEnd = function(event) {
                        var target = (event || event.touches[0]).target;
                        var touchWasWithinContainer = this._wasTap && this.containerOuter.element.contains(target);
                        if (touchWasWithinContainer) {
                            var containerWasExactTarget = target === this.containerOuter.element || target === this.containerInner.element;
                            if (containerWasExactTarget) {
                                if (this._isTextElement) this.input.focus();
                                else if (this._isSelectMultipleElement) this.showDropdown();
                            }
                            // Prevents focus event firing
                            event.stopPropagation();
                        }
                        this._wasTap = true;
                    };
                    /**
   * Handles mousedown event in capture mode for containetOuter.element
   */ Choices.prototype._onMouseDown = function(event) {
                        var target = event.target;
                        if (!(target instanceof HTMLElement)) return;
                        // If we have our mouse down on the scrollbar and are on IE11...
                        if (IS_IE11 && this.choiceList.element.contains(target)) {
                            // check if click was on a scrollbar area
                            var firstChoice = this.choiceList.element.firstElementChild;
                            var isOnScrollbar = this._direction === 'ltr' ? event.offsetX >= firstChoice.offsetWidth : event.offsetX < firstChoice.offsetLeft;
                            this._isScrollingOnIe = isOnScrollbar;
                        }
                        if (target === this.input.element) return;
                        var item = target.closest('[data-button],[data-item],[data-choice]');
                        if (item instanceof HTMLElement) {
                            var hasShiftKey = event.shiftKey;
                            var activeItems = this._store.activeItems;
                            var dataset = item.dataset;
                            if ('button' in dataset) this._handleButtonAction(activeItems, item);
                            else if ('item' in dataset) this._handleItemAction(activeItems, item, hasShiftKey);
                            else if ('choice' in dataset) this._handleChoiceAction(activeItems, item);
                        }
                        event.preventDefault();
                    };
                    /**
   * Handles mouseover event over this.dropdown
   * @param {MouseEvent} event
   */ Choices.prototype._onMouseOver = function(_a) {
                        var target = _a.target;
                        if (target instanceof HTMLElement && 'choice' in target.dataset) this._highlightChoice(target);
                    };
                    Choices.prototype._onClick = function(_a) {
                        var target = _a.target;
                        var clickWasWithinContainer = this.containerOuter.element.contains(target);
                        if (clickWasWithinContainer) {
                            if (!this.dropdown.isActive && !this.containerOuter.isDisabled) {
                                if (this._isTextElement) {
                                    if (document.activeElement !== this.input.element) this.input.focus();
                                } else {
                                    this.showDropdown();
                                    this.containerOuter.focus();
                                }
                            } else if (this._isSelectOneElement && target !== this.input.element && !this.dropdown.element.contains(target)) this.hideDropdown();
                        } else {
                            var hasHighlightedItems = this._store.highlightedActiveItems.length > 0;
                            if (hasHighlightedItems) this.unhighlightAll();
                            this.containerOuter.removeFocusState();
                            this.hideDropdown(true);
                        }
                    };
                    Choices.prototype._onFocus = function(_a) {
                        var _b;
                        var _this = this;
                        var target = _a.target;
                        var focusWasWithinContainer = target && this.containerOuter.element.contains(target);
                        if (!focusWasWithinContainer) return;
                        var focusActions = (_b = {}, _b[constants_1.TEXT_TYPE] = function() {
                            if (target === _this.input.element) _this.containerOuter.addFocusState();
                        }, _b[constants_1.SELECT_ONE_TYPE] = function() {
                            _this.containerOuter.addFocusState();
                            if (target === _this.input.element) _this.showDropdown(true);
                        }, _b[constants_1.SELECT_MULTIPLE_TYPE] = function() {
                            if (target === _this.input.element) {
                                _this.showDropdown(true);
                                // If element is a select box, the focused element is the container and the dropdown
                                // isn't already open, focus and show dropdown
                                _this.containerOuter.addFocusState();
                            }
                        }, _b);
                        focusActions[this.passedElement.element.type]();
                    };
                    Choices.prototype._onBlur = function(_a) {
                        var _b;
                        var _this = this;
                        var target = _a.target;
                        var blurWasWithinContainer = target && this.containerOuter.element.contains(target);
                        if (blurWasWithinContainer && !this._isScrollingOnIe) {
                            var activeItems = this._store.activeItems;
                            var hasHighlightedItems_1 = activeItems.some(function(item) {
                                return item.highlighted;
                            });
                            var blurActions = (_b = {}, _b[constants_1.TEXT_TYPE] = function() {
                                if (target === _this.input.element) {
                                    _this.containerOuter.removeFocusState();
                                    if (hasHighlightedItems_1) _this.unhighlightAll();
                                    _this.hideDropdown(true);
                                }
                            }, _b[constants_1.SELECT_ONE_TYPE] = function() {
                                _this.containerOuter.removeFocusState();
                                if (target === _this.input.element || target === _this.containerOuter.element && !_this._canSearch) _this.hideDropdown(true);
                            }, _b[constants_1.SELECT_MULTIPLE_TYPE] = function() {
                                if (target === _this.input.element) {
                                    _this.containerOuter.removeFocusState();
                                    _this.hideDropdown(true);
                                    if (hasHighlightedItems_1) _this.unhighlightAll();
                                }
                            }, _b);
                            blurActions[this.passedElement.element.type]();
                        } else {
                            // On IE11, clicking the scollbar blurs our input and thus
                            // closes the dropdown. To stop this, we refocus our input
                            // if we know we are on IE *and* are scrolling.
                            this._isScrollingOnIe = false;
                            this.input.element.focus();
                        }
                    };
                    Choices.prototype._onFormReset = function() {
                        this._store.dispatch((0, misc_1.resetTo)(this._initialState));
                    };
                    Choices.prototype._highlightChoice = function(el) {
                        var _this = this;
                        if (el === void 0) el = null;
                        var choices = Array.from(this.dropdown.element.querySelectorAll('[data-choice-selectable]'));
                        if (!choices.length) return;
                        var passedEl = el;
                        var highlightedChoices = Array.from(this.dropdown.element.querySelectorAll(".".concat(this.config.classNames.highlightedState)));
                        // Remove any highlighted choices
                        highlightedChoices.forEach(function(choice) {
                            choice.classList.remove(_this.config.classNames.highlightedState);
                            choice.setAttribute('aria-selected', 'false');
                        });
                        if (passedEl) this._highlightPosition = choices.indexOf(passedEl);
                        else {
                            // Highlight choice based on last known highlight location
                            if (choices.length > this._highlightPosition) // If we have an option to highlight
                            passedEl = choices[this._highlightPosition];
                            else // Otherwise highlight the option before
                            passedEl = choices[choices.length - 1];
                            if (!passedEl) passedEl = choices[0];
                        }
                        passedEl.classList.add(this.config.classNames.highlightedState);
                        passedEl.setAttribute('aria-selected', 'true');
                        this.passedElement.triggerEvent(constants_1.EVENTS.highlightChoice, {
                            el: passedEl
                        });
                        if (this.dropdown.isActive) {
                            // IE11 ignores aria-label and blocks virtual keyboard
                            // if aria-activedescendant is set without a dropdown
                            this.input.setActiveDescendant(passedEl.id);
                            this.containerOuter.setActiveDescendant(passedEl.id);
                        }
                    };
                    Choices.prototype._addItem = function(_a) {
                        var value = _a.value, _b = _a.label, label = _b === void 0 ? null : _b, _c = _a.choiceId, choiceId = _c === void 0 ? -1 : _c, _d = _a.groupId, groupId = _d === void 0 ? -1 : _d, _e = _a.customProperties, customProperties = _e === void 0 ? {} : _e, _f = _a.placeholder, placeholder = _f === void 0 ? false : _f, _g = _a.keyCode, keyCode = _g === void 0 ? -1 : _g;
                        var passedValue = typeof value === 'string' ? value.trim() : value;
                        var items = this._store.items;
                        var passedLabel = label || passedValue;
                        var passedOptionId = choiceId || -1;
                        var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        var id = items ? items.length + 1 : 1;
                        // If a prepended value has been passed, prepend it
                        if (this.config.prependValue) passedValue = this.config.prependValue + passedValue.toString();
                        // If an appended value has been passed, append it
                        if (this.config.appendValue) passedValue += this.config.appendValue.toString();
                        this._store.dispatch((0, items_1.addItem)({
                            value: passedValue,
                            label: passedLabel,
                            id: id,
                            choiceId: passedOptionId,
                            groupId: groupId,
                            customProperties: customProperties,
                            placeholder: placeholder,
                            keyCode: keyCode
                        }));
                        if (this._isSelectOneElement) this.removeActiveItems(id);
                        // Trigger change event
                        this.passedElement.triggerEvent(constants_1.EVENTS.addItem, {
                            id: id,
                            value: passedValue,
                            label: passedLabel,
                            customProperties: customProperties,
                            groupValue: group && group.value ? group.value : null,
                            keyCode: keyCode
                        });
                    };
                    Choices.prototype._removeItem = function(item) {
                        var id = item.id, value = item.value, label = item.label, customProperties = item.customProperties, choiceId = item.choiceId, groupId = item.groupId;
                        var group = groupId && groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        if (!id || !choiceId) return;
                        this._store.dispatch((0, items_1.removeItem)(id, choiceId));
                        this.passedElement.triggerEvent(constants_1.EVENTS.removeItem, {
                            id: id,
                            value: value,
                            label: label,
                            customProperties: customProperties,
                            groupValue: group && group.value ? group.value : null
                        });
                    };
                    Choices.prototype._addChoice = function(_a) {
                        var value = _a.value, _b = _a.label, label = _b === void 0 ? null : _b, _c = _a.isSelected, isSelected = _c === void 0 ? false : _c, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, _e = _a.groupId, groupId = _e === void 0 ? -1 : _e, _f = _a.customProperties, customProperties = _f === void 0 ? {} : _f, _g = _a.placeholder, placeholder = _g === void 0 ? false : _g, _h = _a.keyCode, keyCode = _h === void 0 ? -1 : _h;
                        if (typeof value === 'undefined' || value === null) return;
                        // Generate unique id
                        var choices = this._store.choices;
                        var choiceLabel = label || value;
                        var choiceId = choices ? choices.length + 1 : 1;
                        var choiceElementId = "".concat(this._baseId, "-").concat(this._idNames.itemChoice, "-").concat(choiceId);
                        this._store.dispatch((0, choices_1.addChoice)({
                            id: choiceId,
                            groupId: groupId,
                            elementId: choiceElementId,
                            value: value,
                            label: choiceLabel,
                            disabled: isDisabled,
                            customProperties: customProperties,
                            placeholder: placeholder,
                            keyCode: keyCode
                        }));
                        if (isSelected) this._addItem({
                            value: value,
                            label: choiceLabel,
                            choiceId: choiceId,
                            customProperties: customProperties,
                            placeholder: placeholder,
                            keyCode: keyCode
                        });
                    };
                    Choices.prototype._addGroup = function(_a) {
                        var _this = this;
                        var group = _a.group, id = _a.id, _b = _a.valueKey, valueKey = _b === void 0 ? 'value' : _b, _c = _a.labelKey, labelKey = _c === void 0 ? 'label' : _c;
                        var groupChoices = (0, utils_1.isType)('Object', group) ? group.choices : Array.from(group.getElementsByTagName('OPTION'));
                        var groupId = id || Math.floor(new Date().valueOf() * Math.random());
                        var isDisabled = group.disabled ? group.disabled : false;
                        if (groupChoices) {
                            this._store.dispatch((0, groups_1.addGroup)({
                                value: group.label,
                                id: groupId,
                                active: true,
                                disabled: isDisabled
                            }));
                            var addGroupChoices = function(choice) {
                                var isOptDisabled = choice.disabled || choice.parentNode && choice.parentNode.disabled;
                                _this._addChoice({
                                    value: choice[valueKey],
                                    label: (0, utils_1.isType)('Object', choice) ? choice[labelKey] : choice.innerHTML,
                                    isSelected: choice.selected,
                                    isDisabled: isOptDisabled,
                                    groupId: groupId,
                                    customProperties: choice.customProperties,
                                    placeholder: choice.placeholder
                                });
                            };
                            groupChoices.forEach(addGroupChoices);
                        } else this._store.dispatch((0, groups_1.addGroup)({
                            value: group.label,
                            id: group.id,
                            active: false,
                            disabled: group.disabled
                        }));
                    };
                    Choices.prototype._getTemplate = function(template) {
                        var _a;
                        var args = [];
                        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                        return (_a = this._templates[template]).call.apply(_a, __spreadArray([
                            this,
                            this.config
                        ], args, false));
                    };
                    Choices.prototype._createTemplates = function() {
                        var callbackOnCreateTemplates = this.config.callbackOnCreateTemplates;
                        var userTemplates = {};
                        if (callbackOnCreateTemplates && typeof callbackOnCreateTemplates === 'function') userTemplates = callbackOnCreateTemplates.call(this, utils_1.strToEl);
                        this._templates = (0, deepmerge_1.default)(templates_1.default, userTemplates);
                    };
                    Choices.prototype._createElements = function() {
                        this.containerOuter = new components_1.Container({
                            element: this._getTemplate('containerOuter', this._direction, this._isSelectElement, this._isSelectOneElement, this.config.searchEnabled, this.passedElement.element.type, this.config.labelId),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            position: this.config.position
                        });
                        this.containerInner = new components_1.Container({
                            element: this._getTemplate('containerInner'),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            position: this.config.position
                        });
                        this.input = new components_1.Input({
                            element: this._getTemplate('input', this._placeholderValue),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            preventPaste: !this.config.paste
                        });
                        this.choiceList = new components_1.List({
                            element: this._getTemplate('choiceList', this._isSelectOneElement)
                        });
                        this.itemList = new components_1.List({
                            element: this._getTemplate('itemList', this._isSelectOneElement)
                        });
                        this.dropdown = new components_1.Dropdown({
                            element: this._getTemplate('dropdown'),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type
                        });
                    };
                    Choices.prototype._createStructure = function() {
                        // Hide original element
                        this.passedElement.conceal();
                        // Wrap input in container preserving DOM ordering
                        this.containerInner.wrap(this.passedElement.element);
                        // Wrapper inner container with outer container
                        this.containerOuter.wrap(this.containerInner.element);
                        if (this._isSelectOneElement) this.input.placeholder = this.config.searchPlaceholderValue || '';
                        else if (this._placeholderValue) {
                            this.input.placeholder = this._placeholderValue;
                            this.input.setWidth();
                        }
                        this.containerOuter.element.appendChild(this.containerInner.element);
                        this.containerOuter.element.appendChild(this.dropdown.element);
                        this.containerInner.element.appendChild(this.itemList.element);
                        if (!this._isTextElement) this.dropdown.element.appendChild(this.choiceList.element);
                        if (!this._isSelectOneElement) this.containerInner.element.appendChild(this.input.element);
                        else if (this.config.searchEnabled) this.dropdown.element.insertBefore(this.input.element, this.dropdown.element.firstChild);
                        if (this._isSelectElement) {
                            this._highlightPosition = 0;
                            this._isSearching = false;
                            this._startLoading();
                            if (this._presetGroups.length) this._addPredefinedGroups(this._presetGroups);
                            else this._addPredefinedChoices(this._presetChoices);
                            this._stopLoading();
                        }
                        if (this._isTextElement) this._addPredefinedItems(this._presetItems);
                    };
                    Choices.prototype._addPredefinedGroups = function(groups) {
                        var _this = this;
                        // If we have a placeholder option
                        var placeholderChoice = this.passedElement.placeholderOption;
                        if (placeholderChoice && placeholderChoice.parentNode && placeholderChoice.parentNode.tagName === 'SELECT') this._addChoice({
                            value: placeholderChoice.value,
                            label: placeholderChoice.innerHTML,
                            isSelected: placeholderChoice.selected,
                            isDisabled: placeholderChoice.disabled,
                            placeholder: true
                        });
                        groups.forEach(function(group) {
                            return _this._addGroup({
                                group: group,
                                id: group.id || null
                            });
                        });
                    };
                    Choices.prototype._addPredefinedChoices = function(choices) {
                        var _this = this;
                        // If sorting is enabled or the user is searching, filter choices
                        if (this.config.shouldSort) choices.sort(this.config.sorter);
                        var hasSelectedChoice = choices.some(function(choice) {
                            return choice.selected;
                        });
                        var firstEnabledChoiceIndex = choices.findIndex(function(choice) {
                            return choice.disabled === undefined || !choice.disabled;
                        });
                        choices.forEach(function(choice, index) {
                            var _a = choice.value, value = _a === void 0 ? '' : _a, label = choice.label, customProperties = choice.customProperties, placeholder = choice.placeholder;
                            if (_this._isSelectElement) {
                                // If the choice is actually a group
                                if (choice.choices) _this._addGroup({
                                    group: choice,
                                    id: choice.id || null
                                });
                                else {
                                    /**
           * If there is a selected choice already or the choice is not the first in
           * the array, add each choice normally.
           *
           * Otherwise we pre-select the first enabled choice in the array ("select-one" only)
           */ var shouldPreselect = _this._isSelectOneElement && !hasSelectedChoice && index === firstEnabledChoiceIndex;
                                    var isSelected = shouldPreselect ? true : choice.selected;
                                    var isDisabled = choice.disabled;
                                    _this._addChoice({
                                        value: value,
                                        label: label,
                                        isSelected: !!isSelected,
                                        isDisabled: !!isDisabled,
                                        placeholder: !!placeholder,
                                        customProperties: customProperties
                                    });
                                }
                            } else _this._addChoice({
                                value: value,
                                label: label,
                                isSelected: !!choice.selected,
                                isDisabled: !!choice.disabled,
                                placeholder: !!choice.placeholder,
                                customProperties: customProperties
                            });
                        });
                    };
                    Choices.prototype._addPredefinedItems = function(items) {
                        var _this = this;
                        items.forEach(function(item) {
                            if (typeof item === 'object' && item.value) _this._addItem({
                                value: item.value,
                                label: item.label,
                                choiceId: item.id,
                                customProperties: item.customProperties,
                                placeholder: item.placeholder
                            });
                            if (typeof item === 'string') _this._addItem({
                                value: item
                            });
                        });
                    };
                    Choices.prototype._setChoiceOrItem = function(item) {
                        var _this = this;
                        var itemType = (0, utils_1.getType)(item).toLowerCase();
                        var handleType = {
                            object: function() {
                                if (!item.value) return;
                                // If we are dealing with a select input, we need to create an option first
                                // that is then selected. For text inputs we can just add items normally.
                                if (!_this._isTextElement) _this._addChoice({
                                    value: item.value,
                                    label: item.label,
                                    isSelected: true,
                                    isDisabled: false,
                                    customProperties: item.customProperties,
                                    placeholder: item.placeholder
                                });
                                else _this._addItem({
                                    value: item.value,
                                    label: item.label,
                                    choiceId: item.id,
                                    customProperties: item.customProperties,
                                    placeholder: item.placeholder
                                });
                            },
                            string: function() {
                                if (!_this._isTextElement) _this._addChoice({
                                    value: item,
                                    label: item,
                                    isSelected: true,
                                    isDisabled: false
                                });
                                else _this._addItem({
                                    value: item
                                });
                            }
                        };
                        handleType[itemType]();
                    };
                    Choices.prototype._findAndSelectChoiceByValue = function(value) {
                        var _this = this;
                        var choices = this._store.choices;
                        // Check 'value' property exists and the choice isn't already selected
                        var foundChoice = choices.find(function(choice) {
                            return _this.config.valueComparer(choice.value, value);
                        });
                        if (foundChoice && !foundChoice.selected) this._addItem({
                            value: foundChoice.value,
                            label: foundChoice.label,
                            choiceId: foundChoice.id,
                            groupId: foundChoice.groupId,
                            customProperties: foundChoice.customProperties,
                            placeholder: foundChoice.placeholder,
                            keyCode: foundChoice.keyCode
                        });
                    };
                    Choices.prototype._generatePlaceholderValue = function() {
                        if (this._isSelectElement && this.passedElement.placeholderOption) {
                            var placeholderOption = this.passedElement.placeholderOption;
                            return placeholderOption ? placeholderOption.text : null;
                        }
                        var _a = this.config, placeholder = _a.placeholder, placeholderValue = _a.placeholderValue;
                        var dataset = this.passedElement.element.dataset;
                        if (placeholder) {
                            if (placeholderValue) return placeholderValue;
                            if (dataset.placeholder) return dataset.placeholder;
                        }
                        return null;
                    };
                    return Choices;
                }();
                exports["default"] = Choices;
            /***/ },
            /***/ 613: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var utils_1 = __webpack_require__(799);
                var constants_1 = __webpack_require__(883);
                var Container = /** @class */ function() {
                    function Container(_a) {
                        var element = _a.element, type = _a.type, classNames = _a.classNames, position = _a.position;
                        this.element = element;
                        this.classNames = classNames;
                        this.type = type;
                        this.position = position;
                        this.isOpen = false;
                        this.isFlipped = false;
                        this.isFocussed = false;
                        this.isDisabled = false;
                        this.isLoading = false;
                        this._onFocus = this._onFocus.bind(this);
                        this._onBlur = this._onBlur.bind(this);
                    }
                    Container.prototype.addEventListeners = function() {
                        this.element.addEventListener('focus', this._onFocus);
                        this.element.addEventListener('blur', this._onBlur);
                    };
                    Container.prototype.removeEventListeners = function() {
                        this.element.removeEventListener('focus', this._onFocus);
                        this.element.removeEventListener('blur', this._onBlur);
                    };
                    /**
   * Determine whether container should be flipped based on passed
   * dropdown position
   */ Container.prototype.shouldFlip = function(dropdownPos) {
                        if (typeof dropdownPos !== 'number') return false;
                        // If flip is enabled and the dropdown bottom position is
                        // greater than the window height flip the dropdown.
                        var shouldFlip = false;
                        if (this.position === 'auto') shouldFlip = !window.matchMedia("(min-height: ".concat(dropdownPos + 1, "px)")).matches;
                        else if (this.position === 'top') shouldFlip = true;
                        return shouldFlip;
                    };
                    Container.prototype.setActiveDescendant = function(activeDescendantID) {
                        this.element.setAttribute('aria-activedescendant', activeDescendantID);
                    };
                    Container.prototype.removeActiveDescendant = function() {
                        this.element.removeAttribute('aria-activedescendant');
                    };
                    Container.prototype.open = function(dropdownPos) {
                        this.element.classList.add(this.classNames.openState);
                        this.element.setAttribute('aria-expanded', 'true');
                        this.isOpen = true;
                        if (this.shouldFlip(dropdownPos)) {
                            this.element.classList.add(this.classNames.flippedState);
                            this.isFlipped = true;
                        }
                    };
                    Container.prototype.close = function() {
                        this.element.classList.remove(this.classNames.openState);
                        this.element.setAttribute('aria-expanded', 'false');
                        this.removeActiveDescendant();
                        this.isOpen = false;
                        // A dropdown flips if it does not have space within the page
                        if (this.isFlipped) {
                            this.element.classList.remove(this.classNames.flippedState);
                            this.isFlipped = false;
                        }
                    };
                    Container.prototype.focus = function() {
                        if (!this.isFocussed) this.element.focus();
                    };
                    Container.prototype.addFocusState = function() {
                        this.element.classList.add(this.classNames.focusState);
                    };
                    Container.prototype.removeFocusState = function() {
                        this.element.classList.remove(this.classNames.focusState);
                    };
                    Container.prototype.enable = function() {
                        this.element.classList.remove(this.classNames.disabledState);
                        this.element.removeAttribute('aria-disabled');
                        if (this.type === constants_1.SELECT_ONE_TYPE) this.element.setAttribute('tabindex', '0');
                        this.isDisabled = false;
                    };
                    Container.prototype.disable = function() {
                        this.element.classList.add(this.classNames.disabledState);
                        this.element.setAttribute('aria-disabled', 'true');
                        if (this.type === constants_1.SELECT_ONE_TYPE) this.element.setAttribute('tabindex', '-1');
                        this.isDisabled = true;
                    };
                    Container.prototype.wrap = function(element) {
                        (0, utils_1.wrap)(element, this.element);
                    };
                    Container.prototype.unwrap = function(element) {
                        if (this.element.parentNode) {
                            // Move passed element outside this element
                            this.element.parentNode.insertBefore(element, this.element);
                            // Remove this element
                            this.element.parentNode.removeChild(this.element);
                        }
                    };
                    Container.prototype.addLoadingState = function() {
                        this.element.classList.add(this.classNames.loadingState);
                        this.element.setAttribute('aria-busy', 'true');
                        this.isLoading = true;
                    };
                    Container.prototype.removeLoadingState = function() {
                        this.element.classList.remove(this.classNames.loadingState);
                        this.element.removeAttribute('aria-busy');
                        this.isLoading = false;
                    };
                    Container.prototype._onFocus = function() {
                        this.isFocussed = true;
                    };
                    Container.prototype._onBlur = function() {
                        this.isFocussed = false;
                    };
                    return Container;
                }();
                exports["default"] = Container;
            /***/ },
            /***/ 217: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var Dropdown = /** @class */ function() {
                    function Dropdown(_a) {
                        var element = _a.element, type = _a.type, classNames = _a.classNames;
                        this.element = element;
                        this.classNames = classNames;
                        this.type = type;
                        this.isActive = false;
                    }
                    Object.defineProperty(Dropdown.prototype, "distanceFromTopWindow", {
                        /**
     * Bottom position of dropdown in viewport coordinates
     */ get: function() {
                            return this.element.getBoundingClientRect().bottom;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Dropdown.prototype.getChild = function(selector) {
                        return this.element.querySelector(selector);
                    };
                    /**
   * Show dropdown to user by adding active state class
   */ Dropdown.prototype.show = function() {
                        this.element.classList.add(this.classNames.activeState);
                        this.element.setAttribute('aria-expanded', 'true');
                        this.isActive = true;
                        return this;
                    };
                    /**
   * Hide dropdown from user
   */ Dropdown.prototype.hide = function() {
                        this.element.classList.remove(this.classNames.activeState);
                        this.element.setAttribute('aria-expanded', 'false');
                        this.isActive = false;
                        return this;
                    };
                    return Dropdown;
                }();
                exports["default"] = Dropdown;
            /***/ },
            /***/ 520: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.WrappedSelect = exports.WrappedInput = exports.List = exports.Input = exports.Container = exports.Dropdown = void 0;
                var dropdown_1 = __importDefault(__webpack_require__(217));
                exports.Dropdown = dropdown_1.default;
                var container_1 = __importDefault(__webpack_require__(613));
                exports.Container = container_1.default;
                var input_1 = __importDefault(__webpack_require__(11));
                exports.Input = input_1.default;
                var list_1 = __importDefault(__webpack_require__(624));
                exports.List = list_1.default;
                var wrapped_input_1 = __importDefault(__webpack_require__(541));
                exports.WrappedInput = wrapped_input_1.default;
                var wrapped_select_1 = __importDefault(__webpack_require__(982));
                exports.WrappedSelect = wrapped_select_1.default;
            /***/ },
            /***/ 11: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var utils_1 = __webpack_require__(799);
                var constants_1 = __webpack_require__(883);
                var Input = /** @class */ function() {
                    function Input(_a) {
                        var element = _a.element, type = _a.type, classNames = _a.classNames, preventPaste = _a.preventPaste;
                        this.element = element;
                        this.type = type;
                        this.classNames = classNames;
                        this.preventPaste = preventPaste;
                        this.isFocussed = this.element.isEqualNode(document.activeElement);
                        this.isDisabled = element.disabled;
                        this._onPaste = this._onPaste.bind(this);
                        this._onInput = this._onInput.bind(this);
                        this._onFocus = this._onFocus.bind(this);
                        this._onBlur = this._onBlur.bind(this);
                    }
                    Object.defineProperty(Input.prototype, "placeholder", {
                        set: function(placeholder) {
                            this.element.placeholder = placeholder;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Input.prototype, "value", {
                        get: function() {
                            return (0, utils_1.sanitise)(this.element.value);
                        },
                        set: function(value) {
                            this.element.value = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Input.prototype, "rawValue", {
                        get: function() {
                            return this.element.value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Input.prototype.addEventListeners = function() {
                        this.element.addEventListener('paste', this._onPaste);
                        this.element.addEventListener('input', this._onInput, {
                            passive: true
                        });
                        this.element.addEventListener('focus', this._onFocus, {
                            passive: true
                        });
                        this.element.addEventListener('blur', this._onBlur, {
                            passive: true
                        });
                    };
                    Input.prototype.removeEventListeners = function() {
                        this.element.removeEventListener('input', this._onInput);
                        this.element.removeEventListener('paste', this._onPaste);
                        this.element.removeEventListener('focus', this._onFocus);
                        this.element.removeEventListener('blur', this._onBlur);
                    };
                    Input.prototype.enable = function() {
                        this.element.removeAttribute('disabled');
                        this.isDisabled = false;
                    };
                    Input.prototype.disable = function() {
                        this.element.setAttribute('disabled', '');
                        this.isDisabled = true;
                    };
                    Input.prototype.focus = function() {
                        if (!this.isFocussed) this.element.focus();
                    };
                    Input.prototype.blur = function() {
                        if (this.isFocussed) this.element.blur();
                    };
                    Input.prototype.clear = function(setWidth) {
                        if (setWidth === void 0) setWidth = true;
                        if (this.element.value) this.element.value = '';
                        if (setWidth) this.setWidth();
                        return this;
                    };
                    /**
   * Set the correct input width based on placeholder
   * value or input value
   */ Input.prototype.setWidth = function() {
                        // Resize input to contents or placeholder
                        var _a = this.element, style = _a.style, value = _a.value, placeholder = _a.placeholder;
                        style.minWidth = "".concat(placeholder.length + 1, "ch");
                        style.width = "".concat(value.length + 1, "ch");
                    };
                    Input.prototype.setActiveDescendant = function(activeDescendantID) {
                        this.element.setAttribute('aria-activedescendant', activeDescendantID);
                    };
                    Input.prototype.removeActiveDescendant = function() {
                        this.element.removeAttribute('aria-activedescendant');
                    };
                    Input.prototype._onInput = function() {
                        if (this.type !== constants_1.SELECT_ONE_TYPE) this.setWidth();
                    };
                    Input.prototype._onPaste = function(event) {
                        if (this.preventPaste) event.preventDefault();
                    };
                    Input.prototype._onFocus = function() {
                        this.isFocussed = true;
                    };
                    Input.prototype._onBlur = function() {
                        this.isFocussed = false;
                    };
                    return Input;
                }();
                exports["default"] = Input;
            /***/ },
            /***/ 624: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var constants_1 = __webpack_require__(883);
                var List = /** @class */ function() {
                    function List(_a) {
                        var element = _a.element;
                        this.element = element;
                        this.scrollPos = this.element.scrollTop;
                        this.height = this.element.offsetHeight;
                    }
                    List.prototype.clear = function() {
                        this.element.innerHTML = '';
                    };
                    List.prototype.append = function(node) {
                        this.element.appendChild(node);
                    };
                    List.prototype.getChild = function(selector) {
                        return this.element.querySelector(selector);
                    };
                    List.prototype.hasChildren = function() {
                        return this.element.hasChildNodes();
                    };
                    List.prototype.scrollToTop = function() {
                        this.element.scrollTop = 0;
                    };
                    List.prototype.scrollToChildElement = function(element, direction) {
                        var _this = this;
                        if (!element) return;
                        var listHeight = this.element.offsetHeight;
                        // Scroll position of dropdown
                        var listScrollPosition = this.element.scrollTop + listHeight;
                        var elementHeight = element.offsetHeight;
                        // Distance from bottom of element to top of parent
                        var elementPos = element.offsetTop + elementHeight;
                        // Difference between the element and scroll position
                        var destination = direction > 0 ? this.element.scrollTop + elementPos - listScrollPosition : element.offsetTop;
                        requestAnimationFrame(function() {
                            _this._animateScroll(destination, direction);
                        });
                    };
                    List.prototype._scrollDown = function(scrollPos, strength, destination) {
                        var easing = (destination - scrollPos) / strength;
                        var distance = easing > 1 ? easing : 1;
                        this.element.scrollTop = scrollPos + distance;
                    };
                    List.prototype._scrollUp = function(scrollPos, strength, destination) {
                        var easing = (scrollPos - destination) / strength;
                        var distance = easing > 1 ? easing : 1;
                        this.element.scrollTop = scrollPos - distance;
                    };
                    List.prototype._animateScroll = function(destination, direction) {
                        var _this = this;
                        var strength = constants_1.SCROLLING_SPEED;
                        var choiceListScrollTop = this.element.scrollTop;
                        var continueAnimation = false;
                        if (direction > 0) {
                            this._scrollDown(choiceListScrollTop, strength, destination);
                            if (choiceListScrollTop < destination) continueAnimation = true;
                        } else {
                            this._scrollUp(choiceListScrollTop, strength, destination);
                            if (choiceListScrollTop > destination) continueAnimation = true;
                        }
                        if (continueAnimation) requestAnimationFrame(function() {
                            _this._animateScroll(destination, direction);
                        });
                    };
                    return List;
                }();
                exports["default"] = List;
            /***/ },
            /***/ 730: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var utils_1 = __webpack_require__(799);
                var WrappedElement = /** @class */ function() {
                    function WrappedElement(_a) {
                        var element = _a.element, classNames = _a.classNames;
                        this.element = element;
                        this.classNames = classNames;
                        if (!(element instanceof HTMLInputElement) && !(element instanceof HTMLSelectElement)) throw new TypeError('Invalid element passed');
                        this.isDisabled = false;
                    }
                    Object.defineProperty(WrappedElement.prototype, "isActive", {
                        get: function() {
                            return this.element.dataset.choice === 'active';
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedElement.prototype, "dir", {
                        get: function() {
                            return this.element.dir;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedElement.prototype, "value", {
                        get: function() {
                            return this.element.value;
                        },
                        set: function(value) {
                            // you must define setter here otherwise it will be readonly property
                            this.element.value = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    WrappedElement.prototype.conceal = function() {
                        // Hide passed input
                        this.element.classList.add(this.classNames.input);
                        this.element.hidden = true;
                        // Remove element from tab index
                        this.element.tabIndex = -1;
                        // Backup original styles if any
                        var origStyle = this.element.getAttribute('style');
                        if (origStyle) this.element.setAttribute('data-choice-orig-style', origStyle);
                        this.element.setAttribute('data-choice', 'active');
                    };
                    WrappedElement.prototype.reveal = function() {
                        // Reinstate passed element
                        this.element.classList.remove(this.classNames.input);
                        this.element.hidden = false;
                        this.element.removeAttribute('tabindex');
                        // Recover original styles if any
                        var origStyle = this.element.getAttribute('data-choice-orig-style');
                        if (origStyle) {
                            this.element.removeAttribute('data-choice-orig-style');
                            this.element.setAttribute('style', origStyle);
                        } else this.element.removeAttribute('style');
                        this.element.removeAttribute('data-choice');
                        // Re-assign values - this is weird, I know
                        // @todo Figure out why we need to do this
                        this.element.value = this.element.value; // eslint-disable-line no-self-assign
                    };
                    WrappedElement.prototype.enable = function() {
                        this.element.removeAttribute('disabled');
                        this.element.disabled = false;
                        this.isDisabled = false;
                    };
                    WrappedElement.prototype.disable = function() {
                        this.element.setAttribute('disabled', '');
                        this.element.disabled = true;
                        this.isDisabled = true;
                    };
                    WrappedElement.prototype.triggerEvent = function(eventType, data) {
                        (0, utils_1.dispatchEvent)(this.element, eventType, data);
                    };
                    return WrappedElement;
                }();
                exports["default"] = WrappedElement;
            /***/ },
            /***/ 541: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var wrapped_element_1 = __importDefault(__webpack_require__(730));
                var WrappedInput = /** @class */ function(_super) {
                    __extends(WrappedInput, _super);
                    function WrappedInput(_a) {
                        var element = _a.element, classNames = _a.classNames, delimiter = _a.delimiter;
                        var _this = _super.call(this, {
                            element: element,
                            classNames: classNames
                        }) || this;
                        _this.delimiter = delimiter;
                        return _this;
                    }
                    Object.defineProperty(WrappedInput.prototype, "value", {
                        get: function() {
                            return this.element.value;
                        },
                        set: function(value) {
                            this.element.setAttribute('value', value);
                            this.element.value = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    return WrappedInput;
                }(wrapped_element_1.default);
                exports["default"] = WrappedInput;
            /***/ },
            /***/ 982: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var wrapped_element_1 = __importDefault(__webpack_require__(730));
                var WrappedSelect = /** @class */ function(_super) {
                    __extends(WrappedSelect, _super);
                    function WrappedSelect(_a) {
                        var element = _a.element, classNames = _a.classNames, template = _a.template;
                        var _this = _super.call(this, {
                            element: element,
                            classNames: classNames
                        }) || this;
                        _this.template = template;
                        return _this;
                    }
                    Object.defineProperty(WrappedSelect.prototype, "placeholderOption", {
                        get: function() {
                            return this.element.querySelector('option[value=""]') || // Backward compatibility layer for the non-standard placeholder attribute supported in older versions.
                            this.element.querySelector('option[placeholder]');
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedSelect.prototype, "optionGroups", {
                        get: function() {
                            return Array.from(this.element.getElementsByTagName('OPTGROUP'));
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedSelect.prototype, "options", {
                        get: function() {
                            return Array.from(this.element.options);
                        },
                        set: function(options) {
                            var _this = this;
                            var fragment = document.createDocumentFragment();
                            var addOptionToFragment = function(data) {
                                // Create a standard select option
                                var option = _this.template(data);
                                // Append it to fragment
                                fragment.appendChild(option);
                            };
                            // Add each list item to list
                            options.forEach(function(optionData) {
                                return addOptionToFragment(optionData);
                            });
                            this.appendDocFragment(fragment);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    WrappedSelect.prototype.appendDocFragment = function(fragment) {
                        this.element.innerHTML = '';
                        this.element.appendChild(fragment);
                    };
                    return WrappedSelect;
                }(wrapped_element_1.default);
                exports["default"] = WrappedSelect;
            /***/ },
            /***/ 883: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SCROLLING_SPEED = exports.SELECT_MULTIPLE_TYPE = exports.SELECT_ONE_TYPE = exports.TEXT_TYPE = exports.KEY_CODES = exports.ACTION_TYPES = exports.EVENTS = void 0;
                exports.EVENTS = {
                    showDropdown: 'showDropdown',
                    hideDropdown: 'hideDropdown',
                    change: 'change',
                    choice: 'choice',
                    search: 'search',
                    addItem: 'addItem',
                    removeItem: 'removeItem',
                    highlightItem: 'highlightItem',
                    highlightChoice: 'highlightChoice',
                    unhighlightItem: 'unhighlightItem'
                };
                exports.ACTION_TYPES = {
                    ADD_CHOICE: 'ADD_CHOICE',
                    FILTER_CHOICES: 'FILTER_CHOICES',
                    ACTIVATE_CHOICES: 'ACTIVATE_CHOICES',
                    CLEAR_CHOICES: 'CLEAR_CHOICES',
                    ADD_GROUP: 'ADD_GROUP',
                    ADD_ITEM: 'ADD_ITEM',
                    REMOVE_ITEM: 'REMOVE_ITEM',
                    HIGHLIGHT_ITEM: 'HIGHLIGHT_ITEM',
                    CLEAR_ALL: 'CLEAR_ALL',
                    RESET_TO: 'RESET_TO',
                    SET_IS_LOADING: 'SET_IS_LOADING'
                };
                exports.KEY_CODES = {
                    BACK_KEY: 46,
                    DELETE_KEY: 8,
                    ENTER_KEY: 13,
                    A_KEY: 65,
                    ESC_KEY: 27,
                    UP_KEY: 38,
                    DOWN_KEY: 40,
                    PAGE_UP_KEY: 33,
                    PAGE_DOWN_KEY: 34
                };
                exports.TEXT_TYPE = 'text';
                exports.SELECT_ONE_TYPE = 'select-one';
                exports.SELECT_MULTIPLE_TYPE = 'select-multiple';
                exports.SCROLLING_SPEED = 4;
            /***/ },
            /***/ 789: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.DEFAULT_CONFIG = exports.DEFAULT_CLASSNAMES = void 0;
                var utils_1 = __webpack_require__(799);
                exports.DEFAULT_CLASSNAMES = {
                    containerOuter: 'choices',
                    containerInner: 'choices__inner',
                    input: 'choices__input',
                    inputCloned: 'choices__input--cloned',
                    list: 'choices__list',
                    listItems: 'choices__list--multiple',
                    listSingle: 'choices__list--single',
                    listDropdown: 'choices__list--dropdown',
                    item: 'choices__item',
                    itemSelectable: 'choices__item--selectable',
                    itemDisabled: 'choices__item--disabled',
                    itemChoice: 'choices__item--choice',
                    placeholder: 'choices__placeholder',
                    group: 'choices__group',
                    groupHeading: 'choices__heading',
                    button: 'choices__button',
                    activeState: 'is-active',
                    focusState: 'is-focused',
                    openState: 'is-open',
                    disabledState: 'is-disabled',
                    highlightedState: 'is-highlighted',
                    selectedState: 'is-selected',
                    flippedState: 'is-flipped',
                    loadingState: 'is-loading',
                    noResults: 'has-no-results',
                    noChoices: 'has-no-choices'
                };
                exports.DEFAULT_CONFIG = {
                    items: [],
                    choices: [],
                    silent: false,
                    renderChoiceLimit: -1,
                    maxItemCount: -1,
                    addItems: true,
                    addItemFilter: null,
                    removeItems: true,
                    removeItemButton: false,
                    editItems: false,
                    allowHTML: true,
                    duplicateItemsAllowed: true,
                    delimiter: ',',
                    paste: true,
                    searchEnabled: true,
                    searchChoices: true,
                    searchFloor: 1,
                    searchResultLimit: 4,
                    searchFields: [
                        'label',
                        'value'
                    ],
                    position: 'auto',
                    resetScrollPosition: true,
                    shouldSort: true,
                    shouldSortItems: false,
                    sorter: utils_1.sortByAlpha,
                    placeholder: true,
                    placeholderValue: null,
                    searchPlaceholderValue: null,
                    prependValue: null,
                    appendValue: null,
                    renderSelectedChoices: 'auto',
                    loadingText: 'Loading...',
                    noResultsText: 'No results found',
                    noChoicesText: 'No choices to choose from',
                    itemSelectText: 'Press to select',
                    uniqueItemText: 'Only unique values can be added',
                    customAddItemText: 'Only values matching specific conditions can be added',
                    addItemText: function(value) {
                        return "Press Enter to add <b>\"".concat((0, utils_1.sanitise)(value), "\"</b>");
                    },
                    maxItemText: function(maxItemCount) {
                        return "Only ".concat(maxItemCount, " values can be added");
                    },
                    valueComparer: function(value1, value2) {
                        return value1 === value2;
                    },
                    fuseOptions: {
                        includeScore: true
                    },
                    labelId: '',
                    callbackOnInit: null,
                    callbackOnCreateTemplates: null,
                    classNames: exports.DEFAULT_CLASSNAMES
                };
            /***/ },
            /***/ 18: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 978: /***/ function(__unused_webpack_module, exports) {
                /* eslint-disable @typescript-eslint/no-explicit-any */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 948: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 359: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 285: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 533: /***/ function(__unused_webpack_module, exports) {
                /* eslint-disable @typescript-eslint/no-explicit-any */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 187: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
                        enumerable: true,
                        get: function() {
                            return m[k];
                        }
                    };
                    Object.defineProperty(o, k2, desc);
                } : function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function(m, exports) {
                    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                __exportStar(__webpack_require__(18), exports);
                __exportStar(__webpack_require__(978), exports);
                __exportStar(__webpack_require__(948), exports);
                __exportStar(__webpack_require__(359), exports);
                __exportStar(__webpack_require__(285), exports);
                __exportStar(__webpack_require__(533), exports);
                __exportStar(__webpack_require__(287), exports);
                __exportStar(__webpack_require__(132), exports);
                __exportStar(__webpack_require__(837), exports);
                __exportStar(__webpack_require__(598), exports);
                __exportStar(__webpack_require__(369), exports);
                __exportStar(__webpack_require__(37), exports);
                __exportStar(__webpack_require__(47), exports);
                __exportStar(__webpack_require__(923), exports);
                __exportStar(__webpack_require__(876), exports);
            /***/ },
            /***/ 287: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 132: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 837: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 598: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 37: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 369: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 47: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 923: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 876: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 799: /***/ function(__unused_webpack_module, exports) {
                /* eslint-disable @typescript-eslint/no-explicit-any */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.parseCustomProperties = exports.diff = exports.cloneObject = exports.existsInArray = exports.dispatchEvent = exports.sortByScore = exports.sortByAlpha = exports.strToEl = exports.sanitise = exports.isScrolledIntoView = exports.getAdjacentEl = exports.wrap = exports.isType = exports.getType = exports.generateId = exports.generateChars = exports.getRandomNumber = void 0;
                var getRandomNumber = function(min, max) {
                    return Math.floor(Math.random() * (max - min) + min);
                };
                exports.getRandomNumber = getRandomNumber;
                var generateChars = function(length) {
                    return Array.from({
                        length: length
                    }, function() {
                        return (0, exports.getRandomNumber)(0, 36).toString(36);
                    }).join('');
                };
                exports.generateChars = generateChars;
                var generateId = function(element, prefix) {
                    var id = element.id || element.name && "".concat(element.name, "-").concat((0, exports.generateChars)(2)) || (0, exports.generateChars)(4);
                    id = id.replace(/(:|\.|\[|\]|,)/g, '');
                    id = "".concat(prefix, "-").concat(id);
                    return id;
                };
                exports.generateId = generateId;
                var getType = function(obj) {
                    return Object.prototype.toString.call(obj).slice(8, -1);
                };
                exports.getType = getType;
                var isType = function(type, obj) {
                    return obj !== undefined && obj !== null && (0, exports.getType)(obj) === type;
                };
                exports.isType = isType;
                var wrap = function(element, wrapper) {
                    if (wrapper === void 0) wrapper = document.createElement('div');
                    if (element.parentNode) {
                        if (element.nextSibling) element.parentNode.insertBefore(wrapper, element.nextSibling);
                        else element.parentNode.appendChild(wrapper);
                    }
                    return wrapper.appendChild(element);
                };
                exports.wrap = wrap;
                var getAdjacentEl = function(startEl, selector, direction) {
                    if (direction === void 0) direction = 1;
                    var prop = "".concat(direction > 0 ? 'next' : 'previous', "ElementSibling");
                    var sibling = startEl[prop];
                    while(sibling){
                        if (sibling.matches(selector)) return sibling;
                        sibling = sibling[prop];
                    }
                    return sibling;
                };
                exports.getAdjacentEl = getAdjacentEl;
                var isScrolledIntoView = function(element, parent, direction) {
                    if (direction === void 0) direction = 1;
                    if (!element) return false;
                    var isVisible;
                    if (direction > 0) // In view from bottom
                    isVisible = parent.scrollTop + parent.offsetHeight >= element.offsetTop + element.offsetHeight;
                    else // In view from top
                    isVisible = element.offsetTop >= parent.scrollTop;
                    return isVisible;
                };
                exports.isScrolledIntoView = isScrolledIntoView;
                var sanitise = function(value) {
                    if (typeof value !== 'string') return value;
                    return value.replace(/&/g, '&amp;').replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
                };
                exports.sanitise = sanitise;
                exports.strToEl = function() {
                    var tmpEl = document.createElement('div');
                    return function(str) {
                        var cleanedInput = str.trim();
                        tmpEl.innerHTML = cleanedInput;
                        var firldChild = tmpEl.children[0];
                        while(tmpEl.firstChild)tmpEl.removeChild(tmpEl.firstChild);
                        return firldChild;
                    };
                }();
                var sortByAlpha = function(_a, _b) {
                    var value = _a.value, _c = _a.label, label = _c === void 0 ? value : _c;
                    var value2 = _b.value, _d = _b.label, label2 = _d === void 0 ? value2 : _d;
                    return label.localeCompare(label2, [], {
                        sensitivity: 'base',
                        ignorePunctuation: true,
                        numeric: true
                    });
                };
                exports.sortByAlpha = sortByAlpha;
                var sortByScore = function(a, b) {
                    var _a = a.score, scoreA = _a === void 0 ? 0 : _a;
                    var _b = b.score, scoreB = _b === void 0 ? 0 : _b;
                    return scoreA - scoreB;
                };
                exports.sortByScore = sortByScore;
                var dispatchEvent = function(element, type, customArgs) {
                    if (customArgs === void 0) customArgs = null;
                    var event = new CustomEvent(type, {
                        detail: customArgs,
                        bubbles: true,
                        cancelable: true
                    });
                    return element.dispatchEvent(event);
                };
                exports.dispatchEvent = dispatchEvent;
                var existsInArray = function(array, value, key) {
                    if (key === void 0) key = 'value';
                    return array.some(function(item) {
                        if (typeof value === 'string') return item[key] === value.trim();
                        return item[key] === value;
                    });
                };
                exports.existsInArray = existsInArray;
                var cloneObject = function(obj) {
                    return JSON.parse(JSON.stringify(obj));
                };
                exports.cloneObject = cloneObject;
                /**
 * Returns an array of keys present on the first but missing on the second object
 */ var diff = function(a, b) {
                    var aKeys = Object.keys(a).sort();
                    var bKeys = Object.keys(b).sort();
                    return aKeys.filter(function(i) {
                        return bKeys.indexOf(i) < 0;
                    });
                };
                exports.diff = diff;
                var parseCustomProperties = function(customProperties) {
                    if (typeof customProperties !== 'undefined') try {
                        return JSON.parse(customProperties);
                    } catch (e) {
                        return customProperties;
                    }
                    return {};
                };
                exports.parseCustomProperties = parseCustomProperties;
            /***/ },
            /***/ 273: /***/ function(__unused_webpack_module, exports) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function choices(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case 'ADD_CHOICE':
                            var addChoiceAction = action;
                            var choice = {
                                id: addChoiceAction.id,
                                elementId: addChoiceAction.elementId,
                                groupId: addChoiceAction.groupId,
                                value: addChoiceAction.value,
                                label: addChoiceAction.label || addChoiceAction.value,
                                disabled: addChoiceAction.disabled || false,
                                selected: false,
                                active: true,
                                score: 9999,
                                customProperties: addChoiceAction.customProperties,
                                placeholder: addChoiceAction.placeholder || false
                            };
                            /*
          A disabled choice appears in the choice dropdown but cannot be selected
          A selected choice has been added to the passed input's value (added as an item)
          An active choice appears within the choice dropdown
        */ return __spreadArray(__spreadArray([], state, true), [
                                choice
                            ], false);
                        case 'ADD_ITEM':
                            var addItemAction_1 = action;
                            // When an item is added and it has an associated choice,
                            // we want to disable it so it can't be chosen again
                            if (addItemAction_1.choiceId > -1) return state.map(function(obj) {
                                var choice = obj;
                                if (choice.id === parseInt("".concat(addItemAction_1.choiceId), 10)) choice.selected = true;
                                return choice;
                            });
                            return state;
                        case 'REMOVE_ITEM':
                            var removeItemAction_1 = action;
                            // When an item is removed and it has an associated choice,
                            // we want to re-enable it so it can be chosen again
                            if (removeItemAction_1.choiceId && removeItemAction_1.choiceId > -1) return state.map(function(obj) {
                                var choice = obj;
                                if (choice.id === parseInt("".concat(removeItemAction_1.choiceId), 10)) choice.selected = false;
                                return choice;
                            });
                            return state;
                        case 'FILTER_CHOICES':
                            var filterChoicesAction_1 = action;
                            return state.map(function(obj) {
                                var choice = obj;
                                // Set active state based on whether choice is
                                // within filtered results
                                choice.active = filterChoicesAction_1.results.some(function(_a) {
                                    var item = _a.item, score = _a.score;
                                    if (item.id === choice.id) {
                                        choice.score = score;
                                        return true;
                                    }
                                    return false;
                                });
                                return choice;
                            });
                        case 'ACTIVATE_CHOICES':
                            var activateChoicesAction_1 = action;
                            return state.map(function(obj) {
                                var choice = obj;
                                choice.active = activateChoicesAction_1.active;
                                return choice;
                            });
                        case 'CLEAR_CHOICES':
                            return exports.defaultState;
                        default:
                            return state;
                    }
                }
                exports["default"] = choices;
            /***/ },
            /***/ 871: /***/ function(__unused_webpack_module, exports) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function groups(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case 'ADD_GROUP':
                            var addGroupAction = action;
                            return __spreadArray(__spreadArray([], state, true), [
                                {
                                    id: addGroupAction.id,
                                    value: addGroupAction.value,
                                    active: addGroupAction.active,
                                    disabled: addGroupAction.disabled
                                }
                            ], false);
                        case 'CLEAR_CHOICES':
                            return [];
                        default:
                            return state;
                    }
                }
                exports["default"] = groups;
            /***/ },
            /***/ 655: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                var redux_1 = __webpack_require__(791);
                var items_1 = __importDefault(__webpack_require__(52));
                var groups_1 = __importDefault(__webpack_require__(871));
                var choices_1 = __importDefault(__webpack_require__(273));
                var loading_1 = __importDefault(__webpack_require__(502));
                var utils_1 = __webpack_require__(799);
                exports.defaultState = {
                    groups: [],
                    items: [],
                    choices: [],
                    loading: false
                };
                var appReducer = (0, redux_1.combineReducers)({
                    items: items_1.default,
                    groups: groups_1.default,
                    choices: choices_1.default,
                    loading: loading_1.default
                });
                var rootReducer = function(passedState, action) {
                    var state = passedState;
                    // If we are clearing all items, groups and options we reassign
                    // state and then pass that state to our proper reducer. This isn't
                    // mutating our actual state
                    // See: http://stackoverflow.com/a/35641992
                    if (action.type === 'CLEAR_ALL') state = exports.defaultState;
                    else if (action.type === 'RESET_TO') return (0, utils_1.cloneObject)(action.state);
                    return appReducer(state, action);
                };
                exports["default"] = rootReducer;
            /***/ },
            /***/ 52: /***/ function(__unused_webpack_module, exports) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function items(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case 'ADD_ITEM':
                            var addItemAction = action;
                            // Add object to items array
                            var newState = __spreadArray(__spreadArray([], state, true), [
                                {
                                    id: addItemAction.id,
                                    choiceId: addItemAction.choiceId,
                                    groupId: addItemAction.groupId,
                                    value: addItemAction.value,
                                    label: addItemAction.label,
                                    active: true,
                                    highlighted: false,
                                    customProperties: addItemAction.customProperties,
                                    placeholder: addItemAction.placeholder || false,
                                    keyCode: null
                                }
                            ], false);
                            return newState.map(function(obj) {
                                var item = obj;
                                item.highlighted = false;
                                return item;
                            });
                        case 'REMOVE_ITEM':
                            // Set item to inactive
                            return state.map(function(obj) {
                                var item = obj;
                                if (item.id === action.id) item.active = false;
                                return item;
                            });
                        case 'HIGHLIGHT_ITEM':
                            var highlightItemAction_1 = action;
                            return state.map(function(obj) {
                                var item = obj;
                                if (item.id === highlightItemAction_1.id) item.highlighted = highlightItemAction_1.highlighted;
                                return item;
                            });
                        default:
                            return state;
                    }
                }
                exports["default"] = items;
            /***/ },
            /***/ 502: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = false;
                var general = function(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case 'SET_IS_LOADING':
                            return action.isLoading;
                        default:
                            return state;
                    }
                };
                exports["default"] = general;
            /***/ },
            /***/ 744: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                /* eslint-disable @typescript-eslint/no-explicit-any */ var redux_1 = __webpack_require__(791);
                var index_1 = __importDefault(__webpack_require__(655));
                var Store = /** @class */ function() {
                    function Store() {
                        this._store = (0, redux_1.createStore)(index_1.default, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
                    }
                    /**
   * Subscribe store to function call (wrapped Redux method)
   */ Store.prototype.subscribe = function(onChange) {
                        this._store.subscribe(onChange);
                    };
                    /**
   * Dispatch event to store (wrapped Redux method)
   */ Store.prototype.dispatch = function(action) {
                        this._store.dispatch(action);
                    };
                    Object.defineProperty(Store.prototype, "state", {
                        /**
     * Get store object (wrapping Redux method)
     */ get: function() {
                            return this._store.getState();
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "items", {
                        /**
     * Get items from store
     */ get: function() {
                            return this.state.items;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "activeItems", {
                        /**
     * Get active items from store
     */ get: function() {
                            return this.items.filter(function(item) {
                                return item.active === true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "highlightedActiveItems", {
                        /**
     * Get highlighted items from store
     */ get: function() {
                            return this.items.filter(function(item) {
                                return item.active && item.highlighted;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "choices", {
                        /**
     * Get choices from store
     */ get: function() {
                            return this.state.choices;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "activeChoices", {
                        /**
     * Get active choices from store
     */ get: function() {
                            return this.choices.filter(function(choice) {
                                return choice.active === true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "selectableChoices", {
                        /**
     * Get selectable choices from store
     */ get: function() {
                            return this.choices.filter(function(choice) {
                                return choice.disabled !== true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "searchableChoices", {
                        /**
     * Get choices that can be searched (excluding placeholders)
     */ get: function() {
                            return this.selectableChoices.filter(function(choice) {
                                return choice.placeholder !== true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "placeholderChoice", {
                        /**
     * Get placeholder choice from store
     */ get: function() {
                            return __spreadArray([], this.choices, true).reverse().find(function(choice) {
                                return choice.placeholder === true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "groups", {
                        /**
     * Get groups from store
     */ get: function() {
                            return this.state.groups;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "activeGroups", {
                        /**
     * Get active groups from store
     */ get: function() {
                            var _a = this, groups = _a.groups, choices = _a.choices;
                            return groups.filter(function(group) {
                                var isActive = group.active === true && group.disabled === false;
                                var hasActiveOptions = choices.some(function(choice) {
                                    return choice.active === true && choice.disabled === false;
                                });
                                return isActive && hasActiveOptions;
                            }, []);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    /**
   * Get loading state from store
   */ Store.prototype.isLoading = function() {
                        return this.state.loading;
                    };
                    /**
   * Get single choice by it's ID
   */ Store.prototype.getChoiceById = function(id) {
                        return this.activeChoices.find(function(choice) {
                            return choice.id === parseInt(id, 10);
                        });
                    };
                    /**
   * Get group by group id
   */ Store.prototype.getGroupById = function(id) {
                        return this.groups.find(function(group) {
                            return group.id === id;
                        });
                    };
                    return Store;
                }();
                exports["default"] = Store;
            /***/ },
            /***/ 686: /***/ function(__unused_webpack_module, exports) {
                /**
 * Helpers to create HTML elements used by Choices
 * Can be overridden by providing `callbackOnCreateTemplates` option
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var templates = {
                    containerOuter: function(_a, dir, isSelectElement, isSelectOneElement, searchEnabled, passedElementType, labelId) {
                        var containerOuter = _a.classNames.containerOuter;
                        var div = Object.assign(document.createElement('div'), {
                            className: containerOuter
                        });
                        div.dataset.type = passedElementType;
                        if (dir) div.dir = dir;
                        if (isSelectOneElement) div.tabIndex = 0;
                        if (isSelectElement) {
                            div.setAttribute('role', searchEnabled ? 'combobox' : 'listbox');
                            if (searchEnabled) div.setAttribute('aria-autocomplete', 'list');
                        }
                        div.setAttribute('aria-haspopup', 'true');
                        div.setAttribute('aria-expanded', 'false');
                        if (labelId) div.setAttribute('aria-labelledby', labelId);
                        return div;
                    },
                    containerInner: function(_a) {
                        var containerInner = _a.classNames.containerInner;
                        return Object.assign(document.createElement('div'), {
                            className: containerInner
                        });
                    },
                    itemList: function(_a, isSelectOneElement) {
                        var _b = _a.classNames, list = _b.list, listSingle = _b.listSingle, listItems = _b.listItems;
                        return Object.assign(document.createElement('div'), {
                            className: "".concat(list, " ").concat(isSelectOneElement ? listSingle : listItems)
                        });
                    },
                    placeholder: function(_a, value) {
                        var _b;
                        var allowHTML = _a.allowHTML, placeholder = _a.classNames.placeholder;
                        return Object.assign(document.createElement('div'), (_b = {
                            className: placeholder
                        }, _b[allowHTML ? 'innerHTML' : 'innerText'] = value, _b));
                    },
                    item: function(_a, _b, removeItemButton) {
                        var _c, _d;
                        var allowHTML = _a.allowHTML, _e = _a.classNames, item = _e.item, button = _e.button, highlightedState = _e.highlightedState, itemSelectable = _e.itemSelectable, placeholder = _e.placeholder;
                        var id = _b.id, value = _b.value, label = _b.label, customProperties = _b.customProperties, active = _b.active, disabled = _b.disabled, highlighted = _b.highlighted, isPlaceholder = _b.placeholder;
                        var div = Object.assign(document.createElement('div'), (_c = {
                            className: item
                        }, _c[allowHTML ? 'innerHTML' : 'innerText'] = label, _c));
                        Object.assign(div.dataset, {
                            item: '',
                            id: id,
                            value: value,
                            customProperties: customProperties
                        });
                        if (active) div.setAttribute('aria-selected', 'true');
                        if (disabled) div.setAttribute('aria-disabled', 'true');
                        if (isPlaceholder) div.classList.add(placeholder);
                        div.classList.add(highlighted ? highlightedState : itemSelectable);
                        if (removeItemButton) {
                            if (disabled) div.classList.remove(itemSelectable);
                            div.dataset.deletable = '';
                            /** @todo This MUST be localizable, not hardcoded! */ var REMOVE_ITEM_TEXT = 'Remove item';
                            var removeButton = Object.assign(document.createElement('button'), (_d = {
                                type: 'button',
                                className: button
                            }, _d[allowHTML ? 'innerHTML' : 'innerText'] = REMOVE_ITEM_TEXT, _d));
                            removeButton.setAttribute('aria-label', "".concat(REMOVE_ITEM_TEXT, ": '").concat(value, "'"));
                            removeButton.dataset.button = '';
                            div.appendChild(removeButton);
                        }
                        return div;
                    },
                    choiceList: function(_a, isSelectOneElement) {
                        var list = _a.classNames.list;
                        var div = Object.assign(document.createElement('div'), {
                            className: list
                        });
                        if (!isSelectOneElement) div.setAttribute('aria-multiselectable', 'true');
                        div.setAttribute('role', 'listbox');
                        return div;
                    },
                    choiceGroup: function(_a, _b) {
                        var _c;
                        var allowHTML = _a.allowHTML, _d = _a.classNames, group = _d.group, groupHeading = _d.groupHeading, itemDisabled = _d.itemDisabled;
                        var id = _b.id, value = _b.value, disabled = _b.disabled;
                        var div = Object.assign(document.createElement('div'), {
                            className: "".concat(group, " ").concat(disabled ? itemDisabled : '')
                        });
                        div.setAttribute('role', 'group');
                        Object.assign(div.dataset, {
                            group: '',
                            id: id,
                            value: value
                        });
                        if (disabled) div.setAttribute('aria-disabled', 'true');
                        div.appendChild(Object.assign(document.createElement('div'), (_c = {
                            className: groupHeading
                        }, _c[allowHTML ? 'innerHTML' : 'innerText'] = value, _c)));
                        return div;
                    },
                    choice: function(_a, _b, selectText) {
                        var _c;
                        var allowHTML = _a.allowHTML, _d = _a.classNames, item = _d.item, itemChoice = _d.itemChoice, itemSelectable = _d.itemSelectable, selectedState = _d.selectedState, itemDisabled = _d.itemDisabled, placeholder = _d.placeholder;
                        var id = _b.id, value = _b.value, label = _b.label, groupId = _b.groupId, elementId = _b.elementId, isDisabled = _b.disabled, isSelected = _b.selected, isPlaceholder = _b.placeholder;
                        var div = Object.assign(document.createElement('div'), (_c = {
                            id: elementId
                        }, _c[allowHTML ? 'innerHTML' : 'innerText'] = label, _c.className = "".concat(item, " ").concat(itemChoice), _c));
                        if (isSelected) div.classList.add(selectedState);
                        if (isPlaceholder) div.classList.add(placeholder);
                        div.setAttribute('role', groupId && groupId > 0 ? 'treeitem' : 'option');
                        Object.assign(div.dataset, {
                            choice: '',
                            id: id,
                            value: value,
                            selectText: selectText
                        });
                        if (isDisabled) {
                            div.classList.add(itemDisabled);
                            div.dataset.choiceDisabled = '';
                            div.setAttribute('aria-disabled', 'true');
                        } else {
                            div.classList.add(itemSelectable);
                            div.dataset.choiceSelectable = '';
                        }
                        return div;
                    },
                    input: function(_a, placeholderValue) {
                        var _b = _a.classNames, input = _b.input, inputCloned = _b.inputCloned;
                        var inp = Object.assign(document.createElement('input'), {
                            type: 'search',
                            name: 'search_terms',
                            className: "".concat(input, " ").concat(inputCloned),
                            autocomplete: 'off',
                            autocapitalize: 'off',
                            spellcheck: false
                        });
                        inp.setAttribute('role', 'textbox');
                        inp.setAttribute('aria-autocomplete', 'list');
                        inp.setAttribute('aria-label', placeholderValue);
                        return inp;
                    },
                    dropdown: function(_a) {
                        var _b = _a.classNames, list = _b.list, listDropdown = _b.listDropdown;
                        var div = document.createElement('div');
                        div.classList.add(list, listDropdown);
                        div.setAttribute('aria-expanded', 'false');
                        return div;
                    },
                    notice: function(_a, innerText, type) {
                        var _b;
                        var allowHTML = _a.allowHTML, _c = _a.classNames, item = _c.item, itemChoice = _c.itemChoice, noResults = _c.noResults, noChoices = _c.noChoices;
                        if (type === void 0) type = '';
                        var classes = [
                            item,
                            itemChoice
                        ];
                        if (type === 'no-choices') classes.push(noChoices);
                        else if (type === 'no-results') classes.push(noResults);
                        return Object.assign(document.createElement('div'), (_b = {}, _b[allowHTML ? 'innerHTML' : 'innerText'] = innerText, _b.className = classes.join(' '), _b));
                    },
                    option: function(_a) {
                        var label = _a.label, value = _a.value, customProperties = _a.customProperties, active = _a.active, disabled = _a.disabled;
                        var opt = new Option(label, value, false, active);
                        if (customProperties) opt.dataset.customProperties = "".concat(customProperties);
                        opt.disabled = !!disabled;
                        return opt;
                    }
                };
                exports["default"] = templates;
            /***/ },
            /***/ 996: /***/ function(module1) {
                var isMergeableObject = function isMergeableObject(value) {
                    return isNonNullObject(value) && !isSpecial(value);
                };
                function isNonNullObject(value) {
                    return !!value && typeof value === 'object';
                }
                function isSpecial(value) {
                    var stringValue = Object.prototype.toString.call(value);
                    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
                }
                // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
                var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
                var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
                function isReactElement(value) {
                    return value.$$typeof === REACT_ELEMENT_TYPE;
                }
                function emptyTarget(val) {
                    return Array.isArray(val) ? [] : {};
                }
                function cloneUnlessOtherwiseSpecified(value, options) {
                    return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
                }
                function defaultArrayMerge(target, source, options) {
                    return target.concat(source).map(function(element) {
                        return cloneUnlessOtherwiseSpecified(element, options);
                    });
                }
                function getMergeFunction(key, options) {
                    if (!options.customMerge) return deepmerge;
                    var customMerge = options.customMerge(key);
                    return typeof customMerge === 'function' ? customMerge : deepmerge;
                }
                function getEnumerableOwnPropertySymbols(target) {
                    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
                        return target.propertyIsEnumerable(symbol);
                    }) : [];
                }
                function getKeys(target) {
                    return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
                }
                function propertyIsOnObject(object, property) {
                    try {
                        return property in object;
                    } catch (_) {
                        return false;
                    }
                }
                // Protects from prototype poisoning and unexpected merging up the prototype chain.
                function propertyIsUnsafe(target, key) {
                    return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
                     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
                     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
                    );
                }
                function mergeObject(target, source, options) {
                    var destination = {};
                    if (options.isMergeableObject(target)) getKeys(target).forEach(function(key) {
                        destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
                    });
                    getKeys(source).forEach(function(key) {
                        if (propertyIsUnsafe(target, key)) return;
                        if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
                        else destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
                    });
                    return destination;
                }
                function deepmerge(target, source, options) {
                    options = options || {};
                    options.arrayMerge = options.arrayMerge || defaultArrayMerge;
                    options.isMergeableObject = options.isMergeableObject || isMergeableObject;
                    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
                    // implementations can use it. The caller may not replace it.
                    options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
                    var sourceIsArray = Array.isArray(source);
                    var targetIsArray = Array.isArray(target);
                    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
                    if (!sourceAndTargetTypesMatch) return cloneUnlessOtherwiseSpecified(source, options);
                    else if (sourceIsArray) return options.arrayMerge(target, source, options);
                    else return mergeObject(target, source, options);
                }
                deepmerge.all = function deepmergeAll(array, options) {
                    if (!Array.isArray(array)) throw new Error('first argument should be an array');
                    return array.reduce(function(prev, next) {
                        return deepmerge(prev, next, options);
                    }, {});
                };
                var deepmerge_1 = deepmerge;
                module1.exports = deepmerge_1;
            /***/ },
            /***/ 221: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": function() {
                        return /* binding */ Fuse;
                    }
                });
                /**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function isArray(value) {
                    return !Array.isArray ? getTag(value) === '[object Array]' : Array.isArray(value);
                }
                // Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
                const INFINITY = 1 / 0;
                function baseToString(value) {
                    // Exit early for strings to avoid a performance hit in some environments.
                    if (typeof value == 'string') return value;
                    let result = value + '';
                    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
                }
                function toString(value) {
                    return value == null ? '' : baseToString(value);
                }
                function isString(value) {
                    return typeof value === 'string';
                }
                function isNumber(value) {
                    return typeof value === 'number';
                }
                // Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
                function isBoolean(value) {
                    return value === true || value === false || isObjectLike(value) && getTag(value) == '[object Boolean]';
                }
                function isObject(value) {
                    return typeof value === 'object';
                }
                // Checks if `value` is object-like.
                function isObjectLike(value) {
                    return isObject(value) && value !== null;
                }
                function isDefined(value) {
                    return value !== undefined && value !== null;
                }
                function isBlank(value) {
                    return !value.trim().length;
                }
                // Gets the `toStringTag` of `value`.
                // Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
                function getTag(value) {
                    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
                }
                const EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
                const INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
                const LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
                const PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
                const MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
                const INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
                const hasOwn = Object.prototype.hasOwnProperty;
                class KeyStore {
                    constructor(keys){
                        this._keys = [];
                        this._keyMap = {};
                        let totalWeight = 0;
                        keys.forEach((key)=>{
                            let obj = createKey(key);
                            totalWeight += obj.weight;
                            this._keys.push(obj);
                            this._keyMap[obj.id] = obj;
                            totalWeight += obj.weight;
                        });
                        // Normalize weights so that their sum is equal to 1
                        this._keys.forEach((key)=>{
                            key.weight /= totalWeight;
                        });
                    }
                    get(keyId) {
                        return this._keyMap[keyId];
                    }
                    keys() {
                        return this._keys;
                    }
                    toJSON() {
                        return JSON.stringify(this._keys);
                    }
                }
                function createKey(key) {
                    let path = null;
                    let id = null;
                    let src = null;
                    let weight = 1;
                    let getFn = null;
                    if (isString(key) || isArray(key)) {
                        src = key;
                        path = createKeyPath(key);
                        id = createKeyId(key);
                    } else {
                        if (!hasOwn.call(key, 'name')) throw new Error(MISSING_KEY_PROPERTY('name'));
                        const name = key.name;
                        src = name;
                        if (hasOwn.call(key, 'weight')) {
                            weight = key.weight;
                            if (weight <= 0) throw new Error(INVALID_KEY_WEIGHT_VALUE(name));
                        }
                        path = createKeyPath(name);
                        id = createKeyId(name);
                        getFn = key.getFn;
                    }
                    return {
                        path: path,
                        id: id,
                        weight: weight,
                        src: src,
                        getFn: getFn
                    };
                }
                function createKeyPath(key) {
                    return isArray(key) ? key : key.split('.');
                }
                function createKeyId(key) {
                    return isArray(key) ? key.join('.') : key;
                }
                function get(obj, path) {
                    let list = [];
                    let arr = false;
                    const deepGet = (obj, path, index)=>{
                        if (!isDefined(obj)) return;
                        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
                        list.push(obj);
                        else {
                            let key = path[index];
                            const value = obj[key];
                            if (!isDefined(value)) return;
                            // If we're at the last value in the path, and if it's a string/number/bool,
                            // add it to the list
                            if (index === path.length - 1 && (isString(value) || isNumber(value) || isBoolean(value))) list.push(toString(value));
                            else if (isArray(value)) {
                                arr = true;
                                // Search each item in the array.
                                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
                            } else if (path.length) // An object. Recurse further.
                            deepGet(value, path, index + 1);
                        }
                    };
                    // Backwards compatibility (since path used to be a string)
                    deepGet(obj, isString(path) ? path.split('.') : path, 0);
                    return arr ? list : list[0];
                }
                const MatchOptions = {
                    // Whether the matches should be included in the result set. When `true`, each record in the result
                    // set will include the indices of the matched characters.
                    // These can consequently be used for highlighting purposes.
                    includeMatches: false,
                    // When `true`, the matching function will continue to the end of a search pattern even if
                    // a perfect match has already been located in the string.
                    findAllMatches: false,
                    // Minimum number of characters that must be matched before a result is considered a match
                    minMatchCharLength: 1
                };
                const BasicOptions = {
                    // When `true`, the algorithm continues searching to the end of the input even if a perfect
                    // match is found before the end of the same input.
                    isCaseSensitive: false,
                    // When true, the matching function will continue to the end of a search pattern even if
                    includeScore: false,
                    // List of properties that will be searched. This also supports nested properties.
                    keys: [],
                    // Whether to sort the result list, by score
                    shouldSort: true,
                    // Default sort function: sort by ascending score, ascending index
                    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
                };
                const FuzzyOptions = {
                    // Approximately where in the text is the pattern expected to be found?
                    location: 0,
                    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
                    // (of both letters and location), a threshold of '1.0' would match anything.
                    threshold: 0.6,
                    // Determines how close the match must be to the fuzzy location (specified above).
                    // An exact letter match which is 'distance' characters away from the fuzzy location
                    // would score as a complete mismatch. A distance of '0' requires the match be at
                    // the exact location specified, a threshold of '1000' would require a perfect match
                    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
                    distance: 100
                };
                const AdvancedOptions = {
                    // When `true`, it enables the use of unix-like search commands
                    useExtendedSearch: false,
                    // The get function to use when fetching an object's properties.
                    // The default will search nested paths *ie foo.bar.baz*
                    getFn: get,
                    // When `true`, search will ignore `location` and `distance`, so it won't matter
                    // where in the string the pattern appears.
                    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
                    ignoreLocation: false,
                    // When `true`, the calculation for the relevance score (used for sorting) will
                    // ignore the field-length norm.
                    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
                    ignoreFieldNorm: false,
                    // The weight to determine how much field length norm effects scoring.
                    fieldNormWeight: 1
                };
                var Config = {
                    ...BasicOptions,
                    ...MatchOptions,
                    ...FuzzyOptions,
                    ...AdvancedOptions
                };
                const SPACE = /[^ ]+/g;
                // Field-length norm: the shorter the field, the higher the weight.
                // Set to 3 decimals to reduce index size.
                function norm(weight = 1, mantissa = 3) {
                    const cache = new Map();
                    const m = Math.pow(10, mantissa);
                    return {
                        get (value) {
                            const numTokens = value.match(SPACE).length;
                            if (cache.has(numTokens)) return cache.get(numTokens);
                            // Default function is 1/sqrt(x), weight makes that variable
                            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
                            // In place of `toFixed(mantissa)`, for faster computation
                            const n = parseFloat(Math.round(norm * m) / m);
                            cache.set(numTokens, n);
                            return n;
                        },
                        clear () {
                            cache.clear();
                        }
                    };
                }
                class FuseIndex {
                    constructor({ getFn: getFn = Config.getFn, fieldNormWeight: fieldNormWeight = Config.fieldNormWeight } = {}){
                        this.norm = norm(fieldNormWeight, 3);
                        this.getFn = getFn;
                        this.isCreated = false;
                        this.setIndexRecords();
                    }
                    setSources(docs = []) {
                        this.docs = docs;
                    }
                    setIndexRecords(records = []) {
                        this.records = records;
                    }
                    setKeys(keys = []) {
                        this.keys = keys;
                        this._keysMap = {};
                        keys.forEach((key, idx)=>{
                            this._keysMap[key.id] = idx;
                        });
                    }
                    create() {
                        if (this.isCreated || !this.docs.length) return;
                        this.isCreated = true;
                        // List is Array<String>
                        if (isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
                            this._addString(doc, docIndex);
                        });
                        else // List is Array<Object>
                        this.docs.forEach((doc, docIndex)=>{
                            this._addObject(doc, docIndex);
                        });
                        this.norm.clear();
                    }
                    // Adds a doc to the end of the index
                    add(doc) {
                        const idx = this.size();
                        if (isString(doc)) this._addString(doc, idx);
                        else this._addObject(doc, idx);
                    }
                    // Removes the doc at the specified index of the index
                    removeAt(idx) {
                        this.records.splice(idx, 1);
                        // Change ref index of every subsquent doc
                        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
                    }
                    getValueForItemAtKeyId(item, keyId) {
                        return item[this._keysMap[keyId]];
                    }
                    size() {
                        return this.records.length;
                    }
                    _addString(doc, docIndex) {
                        if (!isDefined(doc) || isBlank(doc)) return;
                        let record = {
                            v: doc,
                            i: docIndex,
                            n: this.norm.get(doc)
                        };
                        this.records.push(record);
                    }
                    _addObject(doc, docIndex) {
                        let record = {
                            i: docIndex,
                            $: {}
                        };
                        // Iterate over every key (i.e, path), and fetch the value at that key
                        this.keys.forEach((key, keyIndex)=>{
                            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
                            if (!isDefined(value)) return;
                            if (isArray(value)) {
                                let subRecords = [];
                                const stack = [
                                    {
                                        nestedArrIndex: -1,
                                        value: value
                                    }
                                ];
                                while(stack.length){
                                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                                    if (!isDefined(value)) continue;
                                    if (isString(value) && !isBlank(value)) {
                                        let subRecord = {
                                            v: value,
                                            i: nestedArrIndex,
                                            n: this.norm.get(value)
                                        };
                                        subRecords.push(subRecord);
                                    } else if (isArray(value)) value.forEach((item, k)=>{
                                        stack.push({
                                            nestedArrIndex: k,
                                            value: item
                                        });
                                    });
                                }
                                record.$[keyIndex] = subRecords;
                            } else if (isString(value) && !isBlank(value)) {
                                let subRecord = {
                                    v: value,
                                    n: this.norm.get(value)
                                };
                                record.$[keyIndex] = subRecord;
                            }
                        });
                        this.records.push(record);
                    }
                    toJSON() {
                        return {
                            keys: this.keys,
                            records: this.records
                        };
                    }
                }
                function createIndex(keys, docs, { getFn: getFn = Config.getFn, fieldNormWeight: fieldNormWeight = Config.fieldNormWeight } = {}) {
                    const myIndex = new FuseIndex({
                        getFn: getFn,
                        fieldNormWeight: fieldNormWeight
                    });
                    myIndex.setKeys(keys.map(createKey));
                    myIndex.setSources(docs);
                    myIndex.create();
                    return myIndex;
                }
                function parseIndex(data, { getFn: getFn = Config.getFn, fieldNormWeight: fieldNormWeight = Config.fieldNormWeight } = {}) {
                    const { keys: keys, records: records } = data;
                    const myIndex = new FuseIndex({
                        getFn: getFn,
                        fieldNormWeight: fieldNormWeight
                    });
                    myIndex.setKeys(keys);
                    myIndex.setIndexRecords(records);
                    return myIndex;
                }
                function computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = Config.distance, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}) {
                    const accuracy = errors / pattern.length;
                    if (ignoreLocation) return accuracy;
                    const proximity = Math.abs(expectedLocation - currentLocation);
                    if (!distance) // Dodge divide by zero error.
                    return proximity ? 1.0 : accuracy;
                    return accuracy + proximity / distance;
                }
                function convertMaskToIndices(matchmask = [], minMatchCharLength = Config.minMatchCharLength) {
                    let indices = [];
                    let start = -1;
                    let end = -1;
                    let i = 0;
                    for(let len = matchmask.length; i < len; i += 1){
                        let match = matchmask[i];
                        if (match && start === -1) start = i;
                        else if (!match && start !== -1) {
                            end = i - 1;
                            if (end - start + 1 >= minMatchCharLength) indices.push([
                                start,
                                end
                            ]);
                            start = -1;
                        }
                    }
                    // (i-1 - start) + 1 => i - start
                    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
                        start,
                        i - 1
                    ]);
                    return indices;
                }
                // Machine word size
                const MAX_BITS = 32;
                function search(text, pattern, patternAlphabet, { location: location = Config.location, distance: distance = Config.distance, threshold: threshold = Config.threshold, findAllMatches: findAllMatches = Config.findAllMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, includeMatches: includeMatches = Config.includeMatches, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}) {
                    if (pattern.length > MAX_BITS) throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS));
                    const patternLen = pattern.length;
                    // Set starting location at beginning text and initialize the alphabet.
                    const textLen = text.length;
                    // Handle the case when location > text.length
                    const expectedLocation = Math.max(0, Math.min(location, textLen));
                    // Highest score beyond which we give up.
                    let currentThreshold = threshold;
                    // Is there a nearby exact match? (speedup)
                    let bestLocation = expectedLocation;
                    // Performance: only computer matches when the minMatchCharLength > 1
                    // OR if `includeMatches` is true.
                    const computeMatches = minMatchCharLength > 1 || includeMatches;
                    // A mask of the matches, used for building the indices
                    const matchMask = computeMatches ? Array(textLen) : [];
                    let index;
                    // Get all exact matches, here for speed up
                    while((index = text.indexOf(pattern, bestLocation)) > -1){
                        let score = computeScore$1(pattern, {
                            currentLocation: index,
                            expectedLocation: expectedLocation,
                            distance: distance,
                            ignoreLocation: ignoreLocation
                        });
                        currentThreshold = Math.min(score, currentThreshold);
                        bestLocation = index + patternLen;
                        if (computeMatches) {
                            let i = 0;
                            while(i < patternLen){
                                matchMask[index + i] = 1;
                                i += 1;
                            }
                        }
                    }
                    // Reset the best location
                    bestLocation = -1;
                    let lastBitArr = [];
                    let finalScore = 1;
                    let binMax = patternLen + textLen;
                    const mask = 1 << patternLen - 1;
                    for(let i = 0; i < patternLen; i += 1){
                        // Scan for the best match; each iteration allows for one more error.
                        // Run a binary search to determine how far from the match location we can stray
                        // at this error level.
                        let binMin = 0;
                        let binMid = binMax;
                        while(binMin < binMid){
                            const score = computeScore$1(pattern, {
                                errors: i,
                                currentLocation: expectedLocation + binMid,
                                expectedLocation: expectedLocation,
                                distance: distance,
                                ignoreLocation: ignoreLocation
                            });
                            if (score <= currentThreshold) binMin = binMid;
                            else binMax = binMid;
                            binMid = Math.floor((binMax - binMin) / 2 + binMin);
                        }
                        // Use the result from this iteration as the maximum for the next.
                        binMax = binMid;
                        let start = Math.max(1, expectedLocation - binMid + 1);
                        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
                        // Initialize the bit array
                        let bitArr = Array(finish + 2);
                        bitArr[finish + 1] = (1 << i) - 1;
                        for(let j = finish; j >= start; j -= 1){
                            let currentLocation = j - 1;
                            let charMatch = patternAlphabet[text.charAt(currentLocation)];
                            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
                            matchMask[currentLocation] = +!!charMatch;
                            // First pass: exact match
                            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
                            // Subsequent passes: fuzzy match
                            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
                            if (bitArr[j] & mask) {
                                finalScore = computeScore$1(pattern, {
                                    errors: i,
                                    currentLocation: currentLocation,
                                    expectedLocation: expectedLocation,
                                    distance: distance,
                                    ignoreLocation: ignoreLocation
                                });
                                // This match will almost certainly be better than any existing match.
                                // But check anyway.
                                if (finalScore <= currentThreshold) {
                                    // Indeed it is
                                    currentThreshold = finalScore;
                                    bestLocation = currentLocation;
                                    // Already passed `loc`, downhill from here on in.
                                    if (bestLocation <= expectedLocation) break;
                                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                                }
                            }
                        }
                        // No hope for a (better) match at greater error levels.
                        const score = computeScore$1(pattern, {
                            errors: i + 1,
                            currentLocation: expectedLocation,
                            expectedLocation: expectedLocation,
                            distance: distance,
                            ignoreLocation: ignoreLocation
                        });
                        if (score > currentThreshold) break;
                        lastBitArr = bitArr;
                    }
                    const result = {
                        isMatch: bestLocation >= 0,
                        // Count exact matches (those with a score of 0) to be "almost" exact
                        score: Math.max(0.001, finalScore)
                    };
                    if (computeMatches) {
                        const indices = convertMaskToIndices(matchMask, minMatchCharLength);
                        if (!indices.length) result.isMatch = false;
                        else if (includeMatches) result.indices = indices;
                    }
                    return result;
                }
                function createPatternAlphabet(pattern) {
                    let mask = {};
                    for(let i = 0, len = pattern.length; i < len; i += 1){
                        const char = pattern.charAt(i);
                        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
                    }
                    return mask;
                }
                class BitapSearch {
                    constructor(pattern, { location: location = Config.location, threshold: threshold = Config.threshold, distance: distance = Config.distance, includeMatches: includeMatches = Config.includeMatches, findAllMatches: findAllMatches = Config.findAllMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = Config.isCaseSensitive, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}){
                        this.options = {
                            location: location,
                            threshold: threshold,
                            distance: distance,
                            includeMatches: includeMatches,
                            findAllMatches: findAllMatches,
                            minMatchCharLength: minMatchCharLength,
                            isCaseSensitive: isCaseSensitive,
                            ignoreLocation: ignoreLocation
                        };
                        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
                        this.chunks = [];
                        if (!this.pattern.length) return;
                        const addChunk = (pattern, startIndex)=>{
                            this.chunks.push({
                                pattern: pattern,
                                alphabet: createPatternAlphabet(pattern),
                                startIndex: startIndex
                            });
                        };
                        const len = this.pattern.length;
                        if (len > MAX_BITS) {
                            let i = 0;
                            const remainder = len % MAX_BITS;
                            const end = len - remainder;
                            while(i < end){
                                addChunk(this.pattern.substr(i, MAX_BITS), i);
                                i += MAX_BITS;
                            }
                            if (remainder) {
                                const startIndex = len - MAX_BITS;
                                addChunk(this.pattern.substr(startIndex), startIndex);
                            }
                        } else addChunk(this.pattern, 0);
                    }
                    searchIn(text) {
                        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
                        if (!isCaseSensitive) text = text.toLowerCase();
                        // Exact match
                        if (this.pattern === text) {
                            let result = {
                                isMatch: true,
                                score: 0
                            };
                            if (includeMatches) result.indices = [
                                [
                                    0,
                                    text.length - 1
                                ]
                            ];
                            return result;
                        }
                        // Otherwise, use Bitap algorithm
                        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
                        let allIndices = [];
                        let totalScore = 0;
                        let hasMatches = false;
                        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
                            const { isMatch: isMatch, score: score, indices: indices } = search(text, pattern, alphabet, {
                                location: location + startIndex,
                                distance: distance,
                                threshold: threshold,
                                findAllMatches: findAllMatches,
                                minMatchCharLength: minMatchCharLength,
                                includeMatches: includeMatches,
                                ignoreLocation: ignoreLocation
                            });
                            if (isMatch) hasMatches = true;
                            totalScore += score;
                            if (isMatch && indices) allIndices = [
                                ...allIndices,
                                ...indices
                            ];
                        });
                        let result = {
                            isMatch: hasMatches,
                            score: hasMatches ? totalScore / this.chunks.length : 1
                        };
                        if (hasMatches && includeMatches) result.indices = allIndices;
                        return result;
                    }
                }
                class BaseMatch {
                    constructor(pattern){
                        this.pattern = pattern;
                    }
                    static isMultiMatch(pattern) {
                        return getMatch(pattern, this.multiRegex);
                    }
                    static isSingleMatch(pattern) {
                        return getMatch(pattern, this.singleRegex);
                    }
                    search() {}
                }
                function getMatch(pattern, exp) {
                    const matches = pattern.match(exp);
                    return matches ? matches[1] : null;
                }
                // Token: 'file
                class ExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'exact';
                    }
                    static get multiRegex() {
                        return /^="(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^=(.*)$/;
                    }
                    search(text) {
                        const isMatch = text === this.pattern;
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                this.pattern.length - 1
                            ]
                        };
                    }
                }
                // Token: !fire
                class InverseExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'inverse-exact';
                    }
                    static get multiRegex() {
                        return /^!"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^!(.*)$/;
                    }
                    search(text) {
                        const index = text.indexOf(this.pattern);
                        const isMatch = index === -1;
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                text.length - 1
                            ]
                        };
                    }
                }
                // Token: ^file
                class PrefixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'prefix-exact';
                    }
                    static get multiRegex() {
                        return /^\^"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^\^(.*)$/;
                    }
                    search(text) {
                        const isMatch = text.startsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                this.pattern.length - 1
                            ]
                        };
                    }
                }
                // Token: !^fire
                class InversePrefixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'inverse-prefix-exact';
                    }
                    static get multiRegex() {
                        return /^!\^"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^!\^(.*)$/;
                    }
                    search(text) {
                        const isMatch = !text.startsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                text.length - 1
                            ]
                        };
                    }
                }
                // Token: .file$
                class SuffixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'suffix-exact';
                    }
                    static get multiRegex() {
                        return /^"(.*)"\$$/;
                    }
                    static get singleRegex() {
                        return /^(.*)\$$/;
                    }
                    search(text) {
                        const isMatch = text.endsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                text.length - this.pattern.length,
                                text.length - 1
                            ]
                        };
                    }
                }
                // Token: !.file$
                class InverseSuffixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'inverse-suffix-exact';
                    }
                    static get multiRegex() {
                        return /^!"(.*)"\$$/;
                    }
                    static get singleRegex() {
                        return /^!(.*)\$$/;
                    }
                    search(text) {
                        const isMatch = !text.endsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                text.length - 1
                            ]
                        };
                    }
                }
                class FuzzyMatch extends BaseMatch {
                    constructor(pattern, { location: location = Config.location, threshold: threshold = Config.threshold, distance: distance = Config.distance, includeMatches: includeMatches = Config.includeMatches, findAllMatches: findAllMatches = Config.findAllMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = Config.isCaseSensitive, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}){
                        super(pattern);
                        this._bitapSearch = new BitapSearch(pattern, {
                            location: location,
                            threshold: threshold,
                            distance: distance,
                            includeMatches: includeMatches,
                            findAllMatches: findAllMatches,
                            minMatchCharLength: minMatchCharLength,
                            isCaseSensitive: isCaseSensitive,
                            ignoreLocation: ignoreLocation
                        });
                    }
                    static get type() {
                        return 'fuzzy';
                    }
                    static get multiRegex() {
                        return /^"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^(.*)$/;
                    }
                    search(text) {
                        return this._bitapSearch.searchIn(text);
                    }
                }
                // Token: 'file
                class IncludeMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'include';
                    }
                    static get multiRegex() {
                        return /^'"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^'(.*)$/;
                    }
                    search(text) {
                        let location = 0;
                        let index;
                        const indices = [];
                        const patternLen = this.pattern.length;
                        // Get all exact matches
                        while((index = text.indexOf(this.pattern, location)) > -1){
                            location = index + patternLen;
                            indices.push([
                                index,
                                location - 1
                            ]);
                        }
                        const isMatch = !!indices.length;
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: indices
                        };
                    }
                }
                // ❗Order is important. DO NOT CHANGE.
                const searchers = [
                    ExactMatch,
                    IncludeMatch,
                    PrefixExactMatch,
                    InversePrefixExactMatch,
                    InverseSuffixExactMatch,
                    SuffixExactMatch,
                    InverseExactMatch,
                    FuzzyMatch
                ];
                const searchersLen = searchers.length;
                // Regex to split by spaces, but keep anything in quotes together
                const SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
                const OR_TOKEN = '|';
                // Return a 2D array representation of the query, for simpler parsing.
                // Example:
                // "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
                function parseQuery(pattern, options = {}) {
                    return pattern.split(OR_TOKEN).map((item)=>{
                        let query = item.trim().split(SPACE_RE).filter((item)=>item && !!item.trim());
                        let results = [];
                        for(let i = 0, len = query.length; i < len; i += 1){
                            const queryItem = query[i];
                            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
                            let found = false;
                            let idx = -1;
                            while(!found && ++idx < searchersLen){
                                const searcher = searchers[idx];
                                let token = searcher.isMultiMatch(queryItem);
                                if (token) {
                                    results.push(new searcher(token, options));
                                    found = true;
                                }
                            }
                            if (found) continue;
                            // 2. Handle single query matches (i.e, once that are *not* quoted)
                            idx = -1;
                            while(++idx < searchersLen){
                                const searcher = searchers[idx];
                                let token = searcher.isSingleMatch(queryItem);
                                if (token) {
                                    results.push(new searcher(token, options));
                                    break;
                                }
                            }
                        }
                        return results;
                    });
                }
                // These extended matchers can return an array of matches, as opposed
                // to a singl match
                const MultiMatchSet = new Set([
                    FuzzyMatch.type,
                    IncludeMatch.type
                ]);
                /**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class ExtendedSearch {
                    constructor(pattern, { isCaseSensitive: isCaseSensitive = Config.isCaseSensitive, includeMatches: includeMatches = Config.includeMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, ignoreLocation: ignoreLocation = Config.ignoreLocation, findAllMatches: findAllMatches = Config.findAllMatches, location: location = Config.location, threshold: threshold = Config.threshold, distance: distance = Config.distance } = {}){
                        this.query = null;
                        this.options = {
                            isCaseSensitive: isCaseSensitive,
                            includeMatches: includeMatches,
                            minMatchCharLength: minMatchCharLength,
                            findAllMatches: findAllMatches,
                            ignoreLocation: ignoreLocation,
                            location: location,
                            threshold: threshold,
                            distance: distance
                        };
                        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
                        this.query = parseQuery(this.pattern, this.options);
                    }
                    static condition(_, options) {
                        return options.useExtendedSearch;
                    }
                    searchIn(text) {
                        const query = this.query;
                        if (!query) return {
                            isMatch: false,
                            score: 1
                        };
                        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
                        text = isCaseSensitive ? text : text.toLowerCase();
                        let numMatches = 0;
                        let allIndices = [];
                        let totalScore = 0;
                        // ORs
                        for(let i = 0, qLen = query.length; i < qLen; i += 1){
                            const searchers = query[i];
                            // Reset indices
                            allIndices.length = 0;
                            numMatches = 0;
                            // ANDs
                            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                                const searcher = searchers[j];
                                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                                if (isMatch) {
                                    numMatches += 1;
                                    totalScore += score;
                                    if (includeMatches) {
                                        const type = searcher.constructor.type;
                                        if (MultiMatchSet.has(type)) allIndices = [
                                            ...allIndices,
                                            ...indices
                                        ];
                                        else allIndices.push(indices);
                                    }
                                } else {
                                    totalScore = 0;
                                    numMatches = 0;
                                    allIndices.length = 0;
                                    break;
                                }
                            }
                            // OR condition, so if TRUE, return
                            if (numMatches) {
                                let result = {
                                    isMatch: true,
                                    score: totalScore / numMatches
                                };
                                if (includeMatches) result.indices = allIndices;
                                return result;
                            }
                        }
                        // Nothing was matched
                        return {
                            isMatch: false,
                            score: 1
                        };
                    }
                }
                const registeredSearchers = [];
                function register(...args) {
                    registeredSearchers.push(...args);
                }
                function createSearcher(pattern, options) {
                    for(let i = 0, len = registeredSearchers.length; i < len; i += 1){
                        let searcherClass = registeredSearchers[i];
                        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
                    }
                    return new BitapSearch(pattern, options);
                }
                const LogicalOperator = {
                    AND: '$and',
                    OR: '$or'
                };
                const KeyType = {
                    PATH: '$path',
                    PATTERN: '$val'
                };
                const isExpression = (query)=>!!(query[LogicalOperator.AND] || query[LogicalOperator.OR]);
                const isPath = (query)=>!!query[KeyType.PATH];
                const isLeaf = (query)=>!isArray(query) && isObject(query) && !isExpression(query);
                const convertToExplicit = (query)=>({
                        [LogicalOperator.AND]: Object.keys(query).map((key)=>({
                                [key]: query[key]
                            }))
                    });
                // When `auto` is `true`, the parse function will infer and initialize and add
                // the appropriate `Searcher` instance
                function parse(query, options, { auto: auto = true } = {}) {
                    const next = (query)=>{
                        let keys = Object.keys(query);
                        const isQueryPath = isPath(query);
                        if (!isQueryPath && keys.length > 1 && !isExpression(query)) return next(convertToExplicit(query));
                        if (isLeaf(query)) {
                            const key = isQueryPath ? query[KeyType.PATH] : keys[0];
                            const pattern = isQueryPath ? query[KeyType.PATTERN] : query[key];
                            if (!isString(pattern)) throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
                            const obj = {
                                keyId: createKeyId(key),
                                pattern: pattern
                            };
                            if (auto) obj.searcher = createSearcher(pattern, options);
                            return obj;
                        }
                        let node = {
                            children: [],
                            operator: keys[0]
                        };
                        keys.forEach((key)=>{
                            const value = query[key];
                            if (isArray(value)) value.forEach((item)=>{
                                node.children.push(next(item));
                            });
                        });
                        return node;
                    };
                    if (!isExpression(query)) query = convertToExplicit(query);
                    return next(query);
                }
                // Practical scoring function
                function computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = Config.ignoreFieldNorm }) {
                    results.forEach((result)=>{
                        let totalScore = 1;
                        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
                            const weight = key ? key.weight : null;
                            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
                        });
                        result.score = totalScore;
                    });
                }
                function transformMatches(result, data) {
                    const matches = result.matches;
                    data.matches = [];
                    if (!isDefined(matches)) return;
                    matches.forEach((match)=>{
                        if (!isDefined(match.indices) || !match.indices.length) return;
                        const { indices: indices, value: value } = match;
                        let obj = {
                            indices: indices,
                            value: value
                        };
                        if (match.key) obj.key = match.key.src;
                        if (match.idx > -1) obj.refIndex = match.idx;
                        data.matches.push(obj);
                    });
                }
                function transformScore(result, data) {
                    data.score = result.score;
                }
                function format(results, docs, { includeMatches: includeMatches = Config.includeMatches, includeScore: includeScore = Config.includeScore } = {}) {
                    const transformers = [];
                    if (includeMatches) transformers.push(transformMatches);
                    if (includeScore) transformers.push(transformScore);
                    return results.map((result)=>{
                        const { idx: idx } = result;
                        const data = {
                            item: docs[idx],
                            refIndex: idx
                        };
                        if (transformers.length) transformers.forEach((transformer)=>{
                            transformer(result, data);
                        });
                        return data;
                    });
                }
                class Fuse {
                    constructor(docs, options = {}, index){
                        this.options = {
                            ...Config,
                            ...options
                        };
                        this.options.useExtendedSearch;
                        this._keyStore = new KeyStore(this.options.keys);
                        this.setCollection(docs, index);
                    }
                    setCollection(docs, index) {
                        this._docs = docs;
                        if (index && !(index instanceof FuseIndex)) throw new Error(INCORRECT_INDEX_TYPE);
                        this._myIndex = index || createIndex(this.options.keys, this._docs, {
                            getFn: this.options.getFn,
                            fieldNormWeight: this.options.fieldNormWeight
                        });
                    }
                    add(doc) {
                        if (!isDefined(doc)) return;
                        this._docs.push(doc);
                        this._myIndex.add(doc);
                    }
                    remove(predicate = ()=>false) {
                        const results = [];
                        for(let i = 0, len = this._docs.length; i < len; i += 1){
                            const doc = this._docs[i];
                            if (predicate(doc, i)) {
                                this.removeAt(i);
                                i -= 1;
                                len -= 1;
                                results.push(doc);
                            }
                        }
                        return results;
                    }
                    removeAt(idx) {
                        this._docs.splice(idx, 1);
                        this._myIndex.removeAt(idx);
                    }
                    getIndex() {
                        return this._myIndex;
                    }
                    search(query, { limit: limit = -1 } = {}) {
                        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
                        let results = isString(query) ? isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
                        computeScore(results, {
                            ignoreFieldNorm: ignoreFieldNorm
                        });
                        if (shouldSort) results.sort(sortFn);
                        if (isNumber(limit) && limit > -1) results = results.slice(0, limit);
                        return format(results, this._docs, {
                            includeMatches: includeMatches,
                            includeScore: includeScore
                        });
                    }
                    _searchStringList(query) {
                        const searcher = createSearcher(query, this.options);
                        const { records: records } = this._myIndex;
                        const results = [];
                        // Iterate over every string in the index
                        records.forEach(({ v: text, i: idx, n: norm })=>{
                            if (!isDefined(text)) return;
                            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
                            if (isMatch) results.push({
                                item: text,
                                idx: idx,
                                matches: [
                                    {
                                        score: score,
                                        value: text,
                                        norm: norm,
                                        indices: indices
                                    }
                                ]
                            });
                        });
                        return results;
                    }
                    _searchLogical(query) {
                        const expression = parse(query, this.options);
                        const evaluate = (node, item, idx)=>{
                            if (!node.children) {
                                const { keyId: keyId, searcher: searcher } = node;
                                const matches = this._findMatches({
                                    key: this._keyStore.get(keyId),
                                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                                    searcher: searcher
                                });
                                if (matches && matches.length) return [
                                    {
                                        idx: idx,
                                        item: item,
                                        matches: matches
                                    }
                                ];
                                return [];
                            }
                            const res = [];
                            for(let i = 0, len = node.children.length; i < len; i += 1){
                                const child = node.children[i];
                                const result = evaluate(child, item, idx);
                                if (result.length) res.push(...result);
                                else if (node.operator === LogicalOperator.AND) return [];
                            }
                            return res;
                        };
                        const records = this._myIndex.records;
                        const resultMap = {};
                        const results = [];
                        records.forEach(({ $: item, i: idx })=>{
                            if (isDefined(item)) {
                                let expResults = evaluate(expression, item, idx);
                                if (expResults.length) {
                                    // Dedupe when adding
                                    if (!resultMap[idx]) {
                                        resultMap[idx] = {
                                            idx: idx,
                                            item: item,
                                            matches: []
                                        };
                                        results.push(resultMap[idx]);
                                    }
                                    expResults.forEach(({ matches: matches })=>{
                                        resultMap[idx].matches.push(...matches);
                                    });
                                }
                            }
                        });
                        return results;
                    }
                    _searchObjectList(query) {
                        const searcher = createSearcher(query, this.options);
                        const { keys: keys, records: records } = this._myIndex;
                        const results = [];
                        // List is Array<Object>
                        records.forEach(({ $: item, i: idx })=>{
                            if (!isDefined(item)) return;
                            let matches = [];
                            // Iterate over every key (i.e, path), and fetch the value at that key
                            keys.forEach((key, keyIndex)=>{
                                matches.push(...this._findMatches({
                                    key: key,
                                    value: item[keyIndex],
                                    searcher: searcher
                                }));
                            });
                            if (matches.length) results.push({
                                idx: idx,
                                item: item,
                                matches: matches
                            });
                        });
                        return results;
                    }
                    _findMatches({ key: key, value: value, searcher: searcher }) {
                        if (!isDefined(value)) return [];
                        let matches = [];
                        if (isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
                            if (!isDefined(text)) return;
                            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
                            if (isMatch) matches.push({
                                score: score,
                                key: key,
                                value: text,
                                idx: idx,
                                norm: norm,
                                indices: indices
                            });
                        });
                        else {
                            const { v: text, n: norm } = value;
                            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
                            if (isMatch) matches.push({
                                score: score,
                                key: key,
                                value: text,
                                norm: norm,
                                indices: indices
                            });
                        }
                        return matches;
                    }
                }
                Fuse.version = '6.6.2';
                Fuse.createIndex = createIndex;
                Fuse.parseIndex = parseIndex;
                Fuse.config = Config;
                Fuse.parseQuery = parse;
                register(ExtendedSearch);
            /***/ },
            /***/ 791: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                // ESM COMPAT FLAG
                __webpack_require__.r(__webpack_exports__);
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "__DO_NOT_USE__ActionTypes": function() {
                        return /* binding */ ActionTypes;
                    },
                    "applyMiddleware": function() {
                        return /* binding */ applyMiddleware;
                    },
                    "bindActionCreators": function() {
                        return /* binding */ bindActionCreators;
                    },
                    "combineReducers": function() {
                        return /* binding */ combineReducers;
                    },
                    "compose": function() {
                        return /* binding */ compose;
                    },
                    "createStore": function() {
                        return /* binding */ createStore;
                    },
                    "legacy_createStore": function() {
                        return /* binding */ legacy_createStore;
                    }
                });
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                        return typeof obj;
                    } : function(obj) {
                        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    }, _typeof(obj);
                }
                function _toPrimitive(input, hint) {
                    if (_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                function _toPropertyKey(arg) {
                    var key = _toPrimitive(arg, "string");
                    return _typeof(key) === "symbol" ? key : String(key);
                }
                function _defineProperty(obj, key, value) {
                    key = _toPropertyKey(key);
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                function ownKeys(object, enumerableOnly) {
                    var keys = Object.keys(object);
                    if (Object.getOwnPropertySymbols) {
                        var symbols = Object.getOwnPropertySymbols(object);
                        enumerableOnly && (symbols = symbols.filter(function(sym) {
                            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                        })), keys.push.apply(keys, symbols);
                    }
                    return keys;
                }
                function _objectSpread2(target) {
                    for(var i = 1; i < arguments.length; i++){
                        var source = null != arguments[i] ? arguments[i] : {};
                        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                            _defineProperty(target, key, source[key]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                        });
                    }
                    return target;
                }
                /**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function formatProdErrorMessage(code) {
                    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
                }
                // Inlined version of the `symbol-observable` polyfill
                var $$observable = function() {
                    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
                }();
                /**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var randomString = function randomString() {
                    return Math.random().toString(36).substring(7).split('').join('.');
                };
                var ActionTypes = {
                    INIT: "@@redux/INIT" + randomString(),
                    REPLACE: "@@redux/REPLACE" + randomString(),
                    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
                        return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
                    }
                };
                /**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function isPlainObject(obj) {
                    if (typeof obj !== 'object' || obj === null) return false;
                    var proto = obj;
                    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
                    return Object.getPrototypeOf(obj) === proto;
                }
                // Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
                function miniKindOf(val) {
                    if (val === void 0) return 'undefined';
                    if (val === null) return 'null';
                    var type = typeof val;
                    switch(type){
                        case 'boolean':
                        case 'string':
                        case 'number':
                        case 'symbol':
                        case 'function':
                            return type;
                    }
                    if (Array.isArray(val)) return 'array';
                    if (isDate(val)) return 'date';
                    if (isError(val)) return 'error';
                    var constructorName = ctorName(val);
                    switch(constructorName){
                        case 'Symbol':
                        case 'Promise':
                        case 'WeakMap':
                        case 'WeakSet':
                        case 'Map':
                        case 'Set':
                            return constructorName;
                    } // other
                    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
                }
                function ctorName(val) {
                    return typeof val.constructor === 'function' ? val.constructor.name : null;
                }
                function isError(val) {
                    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
                }
                function isDate(val) {
                    if (val instanceof Date) return true;
                    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
                }
                function kindOf(val) {
                    var typeOfVal = typeof val;
                    return typeOfVal;
                }
                /**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function createStore(reducer, preloadedState, enhancer) {
                    var _ref2;
                    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error(formatProdErrorMessage(0));
                    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
                        enhancer = preloadedState;
                        preloadedState = undefined;
                    }
                    if (typeof enhancer !== 'undefined') {
                        if (typeof enhancer !== 'function') throw new Error(formatProdErrorMessage(1));
                        return enhancer(createStore)(reducer, preloadedState);
                    }
                    if (typeof reducer !== 'function') throw new Error(formatProdErrorMessage(2));
                    var currentReducer = reducer;
                    var currentState = preloadedState;
                    var currentListeners = [];
                    var nextListeners = currentListeners;
                    var isDispatching = false;
                    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
                        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
                    }
                    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
                        if (isDispatching) throw new Error(formatProdErrorMessage(3));
                        return currentState;
                    }
                    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
                        if (typeof listener !== 'function') throw new Error(formatProdErrorMessage(4));
                        if (isDispatching) throw new Error(formatProdErrorMessage(5));
                        var isSubscribed = true;
                        ensureCanMutateNextListeners();
                        nextListeners.push(listener);
                        return function unsubscribe() {
                            if (!isSubscribed) return;
                            if (isDispatching) throw new Error(formatProdErrorMessage(6));
                            isSubscribed = false;
                            ensureCanMutateNextListeners();
                            var index = nextListeners.indexOf(listener);
                            nextListeners.splice(index, 1);
                            currentListeners = null;
                        };
                    }
                    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
                        if (!isPlainObject(action)) throw new Error(formatProdErrorMessage(7));
                        if (typeof action.type === 'undefined') throw new Error(formatProdErrorMessage(8));
                        if (isDispatching) throw new Error(formatProdErrorMessage(9));
                        try {
                            isDispatching = true;
                            currentState = currentReducer(currentState, action);
                        } finally{
                            isDispatching = false;
                        }
                        var listeners = currentListeners = nextListeners;
                        for(var i = 0; i < listeners.length; i++){
                            var listener = listeners[i];
                            listener();
                        }
                        return action;
                    }
                    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
                        if (typeof nextReducer !== 'function') throw new Error(formatProdErrorMessage(10));
                        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
                        // Any reducers that existed in both the new and old rootReducer
                        // will receive the previous state. This effectively populates
                        // the new state tree with any relevant data from the old one.
                        dispatch({
                            type: ActionTypes.REPLACE
                        });
                    }
                    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
                        var _ref;
                        var outerSubscribe = subscribe;
                        return _ref = {
                            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                                if (typeof observer !== 'object' || observer === null) throw new Error(formatProdErrorMessage(11));
                                function observeState() {
                                    if (observer.next) observer.next(getState());
                                }
                                observeState();
                                var unsubscribe = outerSubscribe(observeState);
                                return {
                                    unsubscribe: unsubscribe
                                };
                            }
                        }, _ref[$$observable] = function() {
                            return this;
                        }, _ref;
                    } // When a store is created, an "INIT" action is dispatched so that every
                    // reducer returns their initial state. This effectively populates
                    // the initial state tree.
                    dispatch({
                        type: ActionTypes.INIT
                    });
                    return _ref2 = {
                        dispatch: dispatch,
                        subscribe: subscribe,
                        getState: getState,
                        replaceReducer: replaceReducer
                    }, _ref2[$$observable] = observable, _ref2;
                }
                /**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var legacy_createStore = createStore;
                /**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function warning(message) {
                    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
                    /* eslint-enable no-console */ try {
                        // This error was thrown as a convenience so that if you enable
                        // "break on all exceptions" in your console,
                        // it would pause the execution at this line.
                        throw new Error(message);
                    } catch (e) {} // eslint-disable-line no-empty
                }
                function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
                    var reducerKeys = Object.keys(reducers);
                    var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
                    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
                    if (!isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
                    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
                        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
                    });
                    unexpectedKeys.forEach(function(key) {
                        unexpectedKeyCache[key] = true;
                    });
                    if (action && action.type === ActionTypes.REPLACE) return;
                    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
                }
                function assertReducerShape(reducers) {
                    Object.keys(reducers).forEach(function(key) {
                        var reducer = reducers[key];
                        var initialState = reducer(undefined, {
                            type: ActionTypes.INIT
                        });
                        if (typeof initialState === 'undefined') throw new Error(formatProdErrorMessage(12));
                        if (typeof reducer(undefined, {
                            type: ActionTypes.PROBE_UNKNOWN_ACTION()
                        }) === 'undefined') throw new Error(formatProdErrorMessage(13));
                    });
                }
                /**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function combineReducers(reducers) {
                    var reducerKeys = Object.keys(reducers);
                    var finalReducers = {};
                    for(var i = 0; i < reducerKeys.length; i++){
                        var key = reducerKeys[i];
                        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
                    }
                    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
                    // keys multiple times.
                    var unexpectedKeyCache;
                    var shapeAssertionError;
                    try {
                        assertReducerShape(finalReducers);
                    } catch (e) {
                        shapeAssertionError = e;
                    }
                    return function combination(state, action) {
                        if (state === void 0) state = {};
                        if (shapeAssertionError) throw shapeAssertionError;
                        var warningMessage;
                        var hasChanged = false;
                        var nextState = {};
                        for(var _i = 0; _i < finalReducerKeys.length; _i++){
                            var _key = finalReducerKeys[_i];
                            var reducer = finalReducers[_key];
                            var previousStateForKey = state[_key];
                            var nextStateForKey = reducer(previousStateForKey, action);
                            if (typeof nextStateForKey === 'undefined') {
                                var actionType = action && action.type;
                                throw new Error(formatProdErrorMessage(14));
                            }
                            nextState[_key] = nextStateForKey;
                            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
                        }
                        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
                        return hasChanged ? nextState : state;
                    };
                }
                function bindActionCreator(actionCreator, dispatch) {
                    return function() {
                        return dispatch(actionCreator.apply(this, arguments));
                    };
                }
                /**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function bindActionCreators(actionCreators, dispatch) {
                    if (typeof actionCreators === 'function') return bindActionCreator(actionCreators, dispatch);
                    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error(formatProdErrorMessage(16));
                    var boundActionCreators = {};
                    for(var key in actionCreators){
                        var actionCreator = actionCreators[key];
                        if (typeof actionCreator === 'function') boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
                    }
                    return boundActionCreators;
                }
                /**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function compose() {
                    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
                    if (funcs.length === 0) return function(arg) {
                        return arg;
                    };
                    if (funcs.length === 1) return funcs[0];
                    return funcs.reduce(function(a, b) {
                        return function() {
                            return a(b.apply(void 0, arguments));
                        };
                    });
                }
                /**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function applyMiddleware() {
                    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
                    return function(createStore) {
                        return function() {
                            var store = createStore.apply(void 0, arguments);
                            var _dispatch = function dispatch() {
                                throw new Error(formatProdErrorMessage(15));
                            };
                            var middlewareAPI = {
                                getState: store.getState,
                                dispatch: function dispatch() {
                                    return _dispatch.apply(void 0, arguments);
                                }
                            };
                            var chain = middlewares.map(function(middleware) {
                                return middleware(middlewareAPI);
                            });
                            _dispatch = compose.apply(void 0, chain)(store.dispatch);
                            return _objectSpread2(_objectSpread2({}, store), {}, {
                                dispatch: _dispatch
                            });
                        };
                    };
                }
                /*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */ function isCrushed() {}
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ !function() {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = function(module1) {
                /******/ var getter = module1 && module1.__esModule ? /******/ function() {
                    return module1['default'];
                } : /******/ function() {
                    return module1;
                };
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ !function() {
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = function(exports) {
                /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: 'Module'
                });
                /******/ Object.defineProperty(exports, '__esModule', {
                    value: true
                });
            /******/ };
        /******/ }();
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
        !function() {
            /* harmony import */ var _scripts_choices__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(373);
            /* harmony import */ var _scripts_choices__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_scripts_choices__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _scripts_interfaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(187);
            /* harmony import */ var _scripts_interfaces__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_scripts_interfaces__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _scripts_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);
            /* harmony import */ var _scripts_defaults__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(789);
            /* harmony import */ var _scripts_templates__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(686);
            /* harmony default export */ __webpack_exports__["default"] = _scripts_choices__WEBPACK_IMPORTED_MODULE_0___default();
        }();
        __webpack_exports__ = __webpack_exports__["default"];
        /******/ return __webpack_exports__;
    /******/ }();
});


class $5c98a5d3a0b97fd7$export$2e2bcd8739ae039 {
    constructor(){
        this.lessonContainer = document.querySelector('.lesson-filter');
        if (!this.lessonContainer) return;
        this.choices = [];
        this.basePath = '/api/';
        this.apiSubject = 'LessonSubjectFilter';
        this.apiAudience = 'LessonGradeFilter';
        this.apiTheme = 'LessonThemeFilter';
        this.formEl = this.lessonContainer.querySelector('form');
        this.subjectEl = document.getElementById('Subject');
        this.gradeEl = document.getElementById('Grade');
        this.themeEl = document.getElementById('Theme');
        this.selects = this.lessonContainer.querySelectorAll('.lesson-filter__filters__filter__select');
        this.filterAllSelects();
        this.setupComponents();
        this.setupAPI();
    }
    /**
   * Setup all dropdown components.
   */ setupComponents() {
        this.selects.forEach((select)=>{
            this.setupComponent(select);
        });
    }
    /**
   * Setup single dropdown component.
   */ setupComponent(select) {
        const choice = new (0, (/*@__PURE__*/$parcel$interopDefault($c5eccf4247c91eed$exports)))(select, {
            silent: false,
            placeholder: true,
            placeholderValue: "-1",
            shouldSort: false,
            renderSelectedChoices: 'auto',
            allowHTML: false,
            removeItems: false,
            itemSelectText: '',
            searchEnabled: false,
            searchChoices: false
        });
        select.addEventListener('change', this.onSelect.bind(this));
        this.choices.push(choice);
    }
    /**
  * Setup listeners etc.
  */ setupAPI() {
        // Get API Path
        this.basePath = this.formEl.getAttribute('data-filter-api');
        if (typeof this.basePath === 'string' && this.basePath.charAt(this.basePath.length - 1) !== '/') this.basePath = this.basePath + '/';
        else this.basePath = '/api/';
    }
    /**
   * Run filter on all selects
   */ filterAllSelects() {
        this.selects.forEach((select)=>{
            this.filterByElement(select);
        });
    }
    /**
   * Triggered on select event.
   * @param {Object} e Event data
   */ onSelect(e) {
        this.filterByElement(e.target);
    }
    /**
   * Run filter based on given elements data-type attribute.
   * @param element
   */ filterByElement(element) {
        const subjectId = this.subjectEl.value || 0;
        const gradeId = this.gradeEl.value || 0;
        const themeId = this.themeEl.value || 0;
        const type = element.dataset.type;
        //subject changed
        if (type === 'subject') {
            this.fetchFilteredList(this.apiAudience, {
                subjectId: subjectId,
                themeId: themeId
            }, 'audience');
            this.fetchFilteredList(this.apiTheme, {
                subjectId: subjectId,
                gradeId: gradeId
            }, 'theme');
        }
        //audience changed
        if (type === 'audience') {
            this.fetchFilteredList(this.apiSubject, {
                gradeId: gradeId,
                themeId: themeId
            }, 'subject');
            this.fetchFilteredList(this.apiTheme, {
                subjectId: subjectId,
                gradeId: gradeId
            }, 'theme');
        }
        //theme changed
        if (type === 'theme') {
            this.fetchFilteredList(this.apiAudience, {
                subjectId: subjectId,
                themeId: themeId
            }, 'audience');
            this.fetchFilteredList(this.apiSubject, {
                gradeId: gradeId,
                themeId: themeId
            }, 'subject');
        }
    }
    /**
   * Fetches an array of ids that should be kept enabled.
   * @param {Object} e Event
   */ fetchFilteredList(path, data, type) {
        (0, $eb999ef253053d6e$export$2e2bcd8739ae039).get(this.basePath + path, {
            params: data
        }).then((response)=>{
            const parsed = this.parseResponse(response.data);
            this.filterSelect(type, parsed);
        }).catch((error)=>{
            this.filterSelect(type, null);
        });
    }
    /**
   * Parses response from API
   * @param {Array} data
   */ parseResponse(data) {
        return data.map((item)=>{
            return '' + item.id;
        });
    }
    /**
   * Filter a select element. Takes a type and an array of strings.
   * To enable all elements set enabled to null, to disable all set it to an empty array.
   *
   * @param {String} type Used to identify the select.
   * @param {Array} enabled A list of id:s to enable, the rest will be disabled
   */ filterSelect(type, enabled) {
        const choice = this.choices.filter((choice)=>choice.passedElement.element.dataset.type === type)[0];
        if (!choice) return;
        let prev = choice.getValue(true);
        let options = choice.config.choices;
        options.forEach((option)=>{
            const value = option.value;
            if (choice.getValue() === value) option.select = true;
            option.disabled = value !== '-1' && enabled && value && (!enabled.length || !enabled.includes(value));
        });
        choice.clearChoices();
        choice.setChoices(options);
        choice.setChoiceByValue(prev);
    }
}


var $3860d05185e4fe7f$exports = {};

$parcel$defineInteropFlag($3860d05185e4fe7f$exports);

$parcel$export($3860d05185e4fe7f$exports, "default", function () { return $3860d05185e4fe7f$export$2e2bcd8739ae039; });
var $eda8742f5f71de8f$exports = {};
(function(window1) {
    var YouTubeIframeLoader = {
        src: 'https://www.youtube.com/iframe_api',
        loading: false,
        loaded: false,
        listeners: [],
        load: function(callback) {
            var _this = this;
            this.listeners.push(callback);
            if (this.loaded) {
                setTimeout(function() {
                    _this.done();
                });
                return;
            }
            if (this.loading) return;
            this.loading = true;
            window1.onYouTubeIframeAPIReady = function() {
                _this.loaded = true;
                _this.done();
            };
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = this.src;
            document.body.appendChild(script);
        },
        done: function() {
            delete window1.onYouTubeIframeAPIReady;
            while(this.listeners.length)this.listeners.pop()(window1.YT);
        }
    };
    if (0, $eda8742f5f71de8f$exports) $eda8742f5f71de8f$exports = YouTubeIframeLoader;
    else window1.YouTubeIframeLoader = YouTubeIframeLoader;
})(window);


class $3860d05185e4fe7f$export$2e2bcd8739ae039 {
    constructor(){
        this.containerSelector = '.video-player-interpreted';
        this.playerSelector = '.video-player-interpreted__videos__player';
        this.playerTriggerButtonClass = 'button--interpret-select';
        this.playerTriggerButton = '.' + this.playerTriggerButtonClass;
        this.disabledButtonClass = '.button--disabled';
        this.playerTriggerAttr = 'data-type-id';
        this.playerVideoId = 'data-video-id';
        this.playerInEnglish = 'data-in-english';
        this.playingVideo;
        this.cookieInterpretName = 'interpret-type';
        this.cookieInterpretLifetime = 31536000; // A year in seconds.
        // Handle multiple players on a page...
        this.containers = document.querySelectorAll(this.containerSelector);
        this.containers.forEach((container)=>{
            this.setupVideoPlayers(container);
            this.setupEvents(container);
            this.setDefault(container, this.getCookie());
        });
    }
    /**
   * Setup all You Tube video players.
   * */ setupVideoPlayers(container) {
        container.querySelectorAll(this.playerSelector).forEach((element)=>{
            this.setupVideoPlayer(element);
        });
    }
    /**
   * Setup You Tube video player.
   * */ setupVideoPlayer(element) {
        const type = element.getAttribute(this.playerTriggerAttr);
        const videoId = element.getAttribute(this.playerVideoId);
        const inEnglish = element.getAttribute(this.playerInEnglish);
        (0, (/*@__PURE__*/$parcel$interopDefault($eda8742f5f71de8f$exports))).load((YT)=>{
            new YT.Player(`video-${type}-${videoId}`, {
                videoId: videoId,
                playerVars: {
                    rel: 0,
                    hl: inEnglish === 'true' ? 'en' : 'sv'
                },
                events: {
                    onStateChange: (event)=>{
                        if (event.data == YT.PlayerState.PLAYING) this.playingVideo = event.target;
                        else if (event.data == YT.PlayerState.PAUSED) this.playingVideo = null;
                    }
                }
            });
        });
    }
    /**
   * Setup click events for each video type and prevent click events on disabled buttons
   */ setupEvents(container) {
        container.addEventListener('click', (event)=>{
            event.preventDefault();
            if (!event.target.querySelector(this.disabledButtonClass)) {
                const type = event.target.getAttribute(this.playerTriggerAttr);
                this.activateType(container, type);
            }
            if (this.playingVideo) this.playingVideo.pauseVideo();
        });
    }
    /**
   * Sets default preference for video based on cookie value.
   */ setDefault(container, defaultVideo) {
        // Available types of given container.
        let availableTypes = [];
        container.querySelectorAll(this.playerSelector).forEach((element)=>{
            availableTypes.push(element.getAttribute(this.playerTriggerAttr));
        });
        if (defaultVideo && availableTypes.indexOf(defaultVideo) !== -1) this.activateType(container, defaultVideo);
        else if (availableTypes.length) this.activateType(container, availableTypes[0]);
    }
    /**
   * Activate a type for given container.
   * 
   * @param container 
   * @param {String} type 
   */ activateType(container, type) {
        // Activate the video
        container.querySelectorAll(this.playerSelector).forEach((element)=>{
            if (element.getAttribute(this.playerTriggerAttr) === type) element.style.display = 'block';
            else element.style.display = 'none';
        });
        // Activate the button
        container.querySelectorAll(this.playerTriggerButton).forEach((element)=>{
            if (element.getAttribute(this.playerTriggerAttr) === type) element.classList.add(this.playerTriggerButtonClass + '--active');
            else element.classList.remove(this.playerTriggerButtonClass + '--active');
        });
        this.setCookie(type);
    }
    /**
  * Get active interpret video type from cookie.
  */ getCookie() {
        const result = document.cookie.match(new RegExp(this.cookieInterpretName + '="(.+?)"'), 1);
        return result ? result[1] : false;
    }
    /**
   * Store active interpret video type in a cookie.
   */ setCookie(type) {
        const value = this.cookieInterpretName + '="' + type + '"';
        document.cookie = value + ';max-age=' + this.cookieInterpretLifetime + ';path=/';
    }
}


var $9cd0b0b3ce59dfbf$exports = {};

$parcel$defineInteropFlag($9cd0b0b3ce59dfbf$exports);

$parcel$export($9cd0b0b3ce59dfbf$exports, "default", function () { return $9cd0b0b3ce59dfbf$export$2e2bcd8739ae039; });


class $9cd0b0b3ce59dfbf$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($49c4be87a5e25114$exports))) {
    constructor(stateHandler){
        super();
        this.outerContainer = '.masonry-row';
        this.pollElementSelector = '[data-poll]';
        this.pollElementCheckboxSelector = '.flip-teaser__flip-state';
        this.pollBacksideSelector = '.flip-teaser__backside .flip-teaser__inner__vertical-align';
        this.pollPostUrlAttr = 'data-poll-post-url';
        this.pollCanVoteUrlAttr = 'data-poll-can-vote-url';
        this.pollPostUrlSelector = '[' + this.pollPostUrlAttr + ']';
        this.checkVoteStatus();
        stateHandler.on('masonry-load-page', ()=>{
            this.checkVoteStatus();
        });
    }
    checkVoteStatus() {
        const pollElementSelector = document.querySelectorAll(this.pollElementSelector);
        pollElementSelector.forEach((element)=>{
            const url = element.getAttribute(this.pollCanVoteUrlAttr);
            if (url && element) {
                const stateCheckbox = element.querySelectorAll(this.pollElementCheckboxSelector)[0];
                (0, $eb999ef253053d6e$export$2e2bcd8739ae039).get(url).then((response)=>{
                    if (response.data) stateCheckbox.checked = false;
                    else stateCheckbox.checked = true;
                    this.setupComponent();
                });
            }
        });
    }
    setupComponent() {
        const selectors = document.querySelectorAll(this.pollPostUrlSelector);
        selectors.forEach((selector)=>{
            this.removeEvents(selector);
            this.setupEvents(selector);
        });
    }
    setupEvents(selector) {
        selector.addEventListener('keypress', this.pressedKey.bind(this));
        selector.addEventListener('click', this.clickedVote.bind(this));
    }
    removeEvents(selector) {
        selector.removeEventListener('keypress', this.pressedKey.bind(this));
        selector.removeEventListener('click', this.clickedVote.bind(this));
    }
    pressedKey(event) {
        const key = event.code;
        const target = event.currentTarget;
        if (key === 'Enter' || key === 'Space') {
            event.preventDefault();
            event.stopPropagation();
            this.vote(target);
        }
    }
    clickedVote(event) {
        const target = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        this.vote(target);
    }
    vote(target) {
        const url = target.getAttribute(this.pollPostUrlAttr);
        const parent = target.closest(this.pollElementSelector);
        (0, $eb999ef253053d6e$export$2e2bcd8739ae039).get(url).then((response)=>{
            this.flip(parent, response.data);
        });
    }
    flip(pollContainer, backsideContent) {
        const backside = pollContainer.querySelector(this.pollBacksideSelector);
        const stateCheckbox = pollContainer.querySelector(this.pollElementCheckboxSelector);
        backside.innerHTML = backsideContent;
        stateCheckbox.checked = true;
    }
}


var $2344a4cff0b77623$exports = {};

$parcel$defineInteropFlag($2344a4cff0b77623$exports);

$parcel$export($2344a4cff0b77623$exports, "default", function () { return $2344a4cff0b77623$export$2e2bcd8739ae039; });
class $2344a4cff0b77623$export$2e2bcd8739ae039 {
    constructor(){
        this.init();
    }
    init() {
        document.addEventListener('DOMContentLoaded', this.setup.bind(this));
        document.addEventListener('resize', this.setup.bind(this));
    }
    setup() {
        const breakingNews = document.querySelectorAll('.article-teaser--breaking-news .article-teaser__wrapper');
        if (breakingNews.length === 0) return;
        for (let teaser of breakingNews){
            teaser.style.height = 'auto';
            let width = teaser.offsetWidth;
            let height = teaser.offsetHeight;
            if (height < width) teaser.style.height = width + 'px';
        }
    }
}


var $f778cecf957bc365$exports = {};

$parcel$defineInteropFlag($f778cecf957bc365$exports);

$parcel$export($f778cecf957bc365$exports, "default", function () { return $f778cecf957bc365$export$2e2bcd8739ae039; });

class $f778cecf957bc365$export$2e2bcd8739ae039 {
    constructor(){
        this.isLoading = false;
        this.teacherToolsListClass = '.teacher-tools__list';
        this.scope = document.querySelector('.teacher-tools');
        this.setupEvents();
    }
    setupEvents() {
        if (!this.scope) return;
        const loadMore = this.scope.querySelector('.js--load-more');
        if (!loadMore) return;
        loadMore.addEventListener('click', (event)=>{
            this.handleClick(event);
        });
    }
    handleClick(e) {
        e.preventDefault();
        const el = e.currentTarget;
        const url = el.getAttribute('data-load-url');
        this.fetchItems(url);
    }
    fetchItems(url) {
        if (this.isLoading) return;
        this.isLoading = true;
        (0, $eb999ef253053d6e$export$2e2bcd8739ae039).get(url, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then(this.handleResponse.bind(this));
    }
    handleResponse(data) {
        this.isLoading = false;
        if (data) {
            if (this.isValid(data.data.items.result)) {
                const teacherToolsList = this.scope.querySelector(this.teacherToolsListClass);
                teacherToolsList.innerHTML += data.data.items.result;
            } else console.error('[TeacherTools] Malformed response');
            if (data.data.loadMoreUrl) {
                this.scope.querySelector('.js--load-more').getAttribute('data-load-url', data.data.loadMoreUrl);
                this.scope.querySelector('.js--load-more').classList.remove('load-more--hide-button');
            } else this.scope.querySelector('.js--load-more').classList.add('load-more--hide-button');
        } else console.error('[TeacherTools] Malformed response');
    }
    isValid(data) {
        if (typeof data !== 'string') return false;
        const has_load_more = data.match('load-more-container');
        const is_html = data.match(/<html/i);
        return is_html === null && has_load_more === null;
    }
}


var $65b358f0623d1429$exports = {};

$parcel$defineInteropFlag($65b358f0623d1429$exports);

$parcel$export($65b358f0623d1429$exports, "default", function () { return $65b358f0623d1429$export$2e2bcd8739ae039; });

class $65b358f0623d1429$export$2e2bcd8739ae039 {
    constructor(){
        this.isLoading = false;
        this.setupComponent();
        this.setupEvents();
    }
    setupComponent() {
        this.videoList = document.querySelector('.video-list');
        if (!this.videoList) return;
        this.videoListContent = document.querySelector('.video-list__content');
        this.loadMoreButton = this.videoList.querySelector('.js--load-more');
    }
    isValid(data) {
        if (typeof data !== 'string') return false;
        const hasLoadMore = data.match('load-more-container');
        const isHtml = data.match(/<html/i);
        return isHtml === null && hasLoadMore === null;
    }
    setupEvents() {
        if (this.loadMoreButton) this.loadMoreButton.addEventListener('click', this.handleClick.bind(this));
    }
    handleClick(e) {
        e.preventDefault();
        const el = e.currentTarget;
        const url = el.getAttribute('data-load-url');
        this.fetchItems(url);
    }
    fetchItems(url) {
        if (this.isLoading) return;
        this.isLoading = true;
        (0, $eb999ef253053d6e$export$2e2bcd8739ae039).get(url, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then(this.handleResponse.bind(this));
    }
    handleResponse(data) {
        this.isLoading = false;
        if (data) {
            if (this.isValid(data.data.items.result)) {
                this.videoListContent.innerHTML = this.videoListContent.innerHTML + data.data.items.result;
                const firstItemInNewList = this.videoListContent.querySelector("ul:last-of-type li:first-of-type a");
                if (firstItemInNewList) firstItemInNewList.focus();
            } else console.error('[VideoList] Malformed response');
            if (data.data.loadMoreUrl) this.loadMoreButton.setAttribute('data-load-url', data.data.loadMoreUrl);
            else this.loadMoreButton.classList.add('hide-button');
        } else console.error('[VideoList] Malformed response');
    }
}


var $f1f2c6da8500fc6a$exports = {};

$parcel$defineInteropFlag($f1f2c6da8500fc6a$exports);

$parcel$export($f1f2c6da8500fc6a$exports, "default", function () { return $f1f2c6da8500fc6a$export$2e2bcd8739ae039; });
class $f1f2c6da8500fc6a$export$2e2bcd8739ae039 {
    constructor(){}
}


var $aea3921f14820907$exports = {};

$parcel$defineInteropFlag($aea3921f14820907$exports);

$parcel$export($aea3921f14820907$exports, "default", function () { return $aea3921f14820907$export$2e2bcd8739ae039; });


class $aea3921f14820907$export$2e2bcd8739ae039 {
    constructor(){
        this.bobbotChatSelector = '.js--bobbot-web-gui';
        this.bobbotOwnerTypeBot = 'bobbot_owner_type_bot';
        this.bobbotOwnerTypeUser = 'bobbot_owner_type_user';
        this.botStateReady = 'bot_state_ready';
        this.botStatePending = 'bot_state_pending';
        this.botStateError = 'bot_state_error';
        this.botPendingMessageClass = 'pending-message';
        this.analyticsCategory = 'Bobbot Chat';
        this._analytics = new (0, $772783048621dbd5$export$2e2bcd8739ae039)();
        // Default state.
        this.currentState = this.botStateReady;
        // Default message id.
        this.startMessageId = '1034';
        // Flag for tracking scroll
        this._buttonsScrollReached = 0;
        // Bot container element
        const bobbotWebGui = document.querySelector(this.bobbotChatSelector);
        if (bobbotWebGui) this.setup(bobbotWebGui);
    }
    /**
   * Setup the bot gui.
   */ setup(bobbotWebGui) {
        // DOM references
        this.bobbotContainer = bobbotWebGui;
        this.chatBodyContainer = this.bobbotContainer.querySelector('.bobbot__chat__body');
        this.chatHistoryContainer = this.bobbotContainer.querySelector('.bobbot__chat__body__history');
        this.buttonsContainer = this.bobbotContainer.querySelector('.bobbot__chat__footer__buttons');
        this.footerContainer = this.bobbotContainer.querySelector('.bobbot__chat__footer');
        this.resetButtonContainer = this.bobbotContainer.querySelector('.bobbot__chat__body__container__reset-container');
        this.apiPath = this.bobbotContainer.getAttribute('data-bot-api-path') || '/api/';
        // Event listeners
        this.setupEvents();
        this.createRestartButton();
        // Fetch start message
        this.fetchSettings().then(this.parseSettings.bind(this)).then((function() {
            return this.startMessageId;
        }).bind(this)).then(this.fetchMessageData.bind(this));
    }
    setupEvents() {
        this.buttonsContainer.addEventListener('click', (event)=>{
            // Check if the clicked element is a button
            if (event.target.classList.contains('bobbot__chat__footer__buttons__button')) // Call the clickedMessage function with the event target as the argument
            this.clickedMessage(event);
        });
        this.footerContainer.addEventListener('scroll', ()=>{
            // Call the scrollMessages function
            this.scrollMessages();
        });
    }
    // --------------------------------------------------------------
    // AJAX
    // --------------------------------------------------------------
    /**
   * Fetch available settings
   */ fetchSettings() {
        return new Promise((resolve, reject)=>{
            (0, $eb999ef253053d6e$export$2e2bcd8739ae039).get(this.apiPath + 'BotSettings').then((response)=>{
                resolve(response);
            }).catch((response)=>{
                this.setBotState(this.botStateError);
                console.error('[BobbotWebGui] fetchMessageData | fail:', response);
                reject(response);
            });
        });
    }
    /**
   * Parses settings
   * @param {Object} response Object to parse
   */ parseSettings(response) {
        // Parse settings
        if (response && response.getStartedMessageId) this.startMessageId = response.getStartedMessageId;
    }
    /**
   * Fetch a message data object from the API.
   * @param {String} messageId The id of message to fetch from API
   */ fetchMessageData(messageId) {
        return new Promise((resolve, reject)=>{
            this.setBotState(this.botStatePending);
            this.pushPendingBobbotToHistory();
            (0, $eb999ef253053d6e$export$2e2bcd8739ae039).get(this.apiPath + 'BotMessages/' + messageId).then((response)=>{
                setTimeout((function() {
                    this.handleBotResponse(response.data);
                    resolve(response);
                }).bind(this), 1000);
            }).catch((response)=>{
                this.setBotState(this.botStateError);
                console.error('[BobbotWebGui] fetchMessageData | fail:', response);
                reject(response);
            });
        });
    }
    /**
   * Handle message response from chat API.
   * @param {Object} response Response object
   */ handleBotResponse(response) {
        let latest = this.getLatestChatMessage();
        if (latest.classList.contains(this.botPendingMessageClass)) this.injectMessageIntoPendingBox(response.Message, latest);
        else this.pushToChatHistory(response.Message, this.bobbotOwnerTypeBot);
        this.setBotState(this.botStateReady);
        this.createResponseButtons(this.parseOptions(response.Options));
        setTimeout(this.scrollToBottom.bind(this), 600);
    }
    /**
   * Clears chat history.
   */ clearHistory() {
        // Get the children of the container
        let children = this.chatHistoryContainer.children;
        // Loop through the children
        for(let i = 0; i < children.length; i++){
            // Get the current child
            let child = children[i];
            // Hide the child with a delay and a transition
            setTimeout(()=>{
                child.style.transition = 'opacity 600ms';
                child.style.opacity = '0';
                // Remove the child after the transition ends
                child.addEventListener('transitionend', ()=>{
                    child.remove();
                });
            }, i * 80);
        }
    }
    // --------------------------------------------------------------
    // Listeners
    // --------------------------------------------------------------
    /**
   * Click listener
   * @param {*} e Event
   */ clickedMessage(e) {
        e.preventDefault();
        // Get the target element
        let target = e.target;
        // Push the target HTML to the chat history
        this.pushToChatHistory(target.innerHTML, this.bobbotOwnerTypeUser);
        // Set the bot state to pending
        this.setBotState(this.botStatePending);
        // Fetch the message data with a delay
        setTimeout(()=>{
            // Get the message id from the target attribute
            let id = target.getAttribute('data-message-id');
            if (id) // Call the fetchMessageData function with the id as the argument
            this.fetchMessageData(id);
        }, 400);
    }
    /**
   * Trigger on scroll in message box.
   * Track event when reaching bottom, happens once per session.
   */ scrollMessages(e) {
        const footer = this.footerContainer;
        const buttons = this.buttonsContainer;
        const margins = 20;
        const scrollPercent = footer.scrollTop() / (buttons.outerHeight() + margins - footer.innerHeight());
        if (this._buttonsScrollReached < scrollPercent) {
            if (scrollPercent >= 0.9 && this._buttonsScrollReached < 0.9) // Scrolled 90%
            this._analytics.dispatchAnalyticsEvent(this.analyticsCategory, 'Scrolled messages');
            this._buttonsScrollReached = scrollPercent;
        }
    }
    /**
   * Click listener
   * @param {*} e Event
   */ clickedRestart(e) {
        e.preventDefault();
        this.clearHistory();
        this.fetchMessageData(this.startMessageId);
    }
    // --------------------------------------------------------------
    // Getters / Setters
    // --------------------------------------------------------------
    /**
   * Set current state of bot. Is used to disable buttons, display
   * "thinking" animation etc.
   * 
   * @param {String} state The state. Defined in constants.
   */ setBotState(state) {
        this.currentState = state;
        // Add the class based on the state
        switch(state){
            case this.botStateReady:
                this.buttonsContainer.classList.add('ready');
                this.buttonsContainer.classList.remove('pending');
                this.buttonsContainer.classList.remove('error');
                break;
            case this.botStatePending:
                this.buttonsContainer.classList.add('pending');
                this.buttonsContainer.classList.remove('ready');
                this.buttonsContainer.classList.remove('error');
                break;
            case this.botStateError:
                this.buttonsContainer.classList.add('error');
                this.buttonsContainer.classList.remove('pending');
                this.buttonsContainer.classList.remove('ready');
                break;
            default:
                this.buttonsContainer.classList.remove('ready');
                this.buttonsContainer.classList.remove('pending');
                this.buttonsContainer.classList.remove('error');
                break;
        }
    }
    /**
   * Returns object with latest chat message box.
   */ getLatestChatMessage() {
        return this.chatHistoryContainer.lastElementChild;
    }
    // --------------------------------------------------------------
    // Helpers
    // --------------------------------------------------------------
    /**
   * Takes options from API response and returns what
   * is needed to create response buttons.
   * @param {*} options 
   */ parseOptions(options) {
        return options.filter(function(option) {
            return option.ToMessageId && option.Option;
        }).map(function(option) {
            return {
                message: option.Option,
                id: option.ToMessageId
            };
        });
    }
    /**
   * Create new message box with pending state.
   */ pushPendingBobbotToHistory() {
        // Create the message element
        let message = this.createChatMessageMarkup('', this.bobbotOwnerTypeBot);
        // Add the pending class
        message.classList.add(this.botPendingMessageClass);
        // Append the message to the container
        this.chatHistoryContainer.appendChild(message);
        // Show the message with a delay
        setTimeout(()=>{
            // Remove the entering class
            message.classList.remove('entering');
        }, 0);
    }
    /**
   * Inject a message into an existing message box
   * 
   * @param {String} message 
   * @param $pendingBox 
   */ injectMessageIntoPendingBox(message, pendingBox) {
        // Remove the pending class and add the ready class
        pendingBox.classList.remove(this.botPendingMessageClass);
        pendingBox.classList.add('ready');
        // Find the wrapper element
        let wrapper = pendingBox.querySelector('.bobbot__chat__body__history__message-box__wrapper');
        // Set the inner HTML to the message
        wrapper.innerHTML = message;
    }
    /**
   * Display a new message in the chat window.
   * 
   * @param {String} mesage A message to display in the chat conversation
   * @param {String} owner Id of owner, BOBBOT_OWNER_TYPE_BOT or BOBBOT_OWNER_TYPE_USER
   */ pushToChatHistory(message, owner) {
        const messageElement = this.createChatMessageMarkup(message, owner);
        this.chatHistoryContainer.appendChild(messageElement);
        // Show the message with a delay
        setTimeout(()=>{
            // Remove the entering class and add the ready class
            messageElement.classList.remove('entering');
            messageElement.classList.add('ready');
            // Scroll to the bottom with another delay
            setTimeout(()=>{
                this.scrollToBottom();
            }, 100);
        }, 0);
    }
    /**
   * Scroll chat window to bottom
   */ scrollToBottom() {
        // Get the height of the history container
        let height = this.chatHistoryContainer.offsetHeight;
        // Animate the scroll top of the body container
        this.chatBodyContainer.scrollTo({
            top: height,
            behavior: 'smooth'
        });
    }
    /**
   * Remove all buttons.
   */ clearResponseButtons() {
        // Get the children of the container
        let children = this.buttonsContainer.children;
        // Loop through the children
        for(let i = 0; i < children.length; i++){
            // Get the current child
            let child = children[i];
            // Fade out the child with a transition
            child.style.transition = 'opacity 300ms';
            child.style.opacity = '0';
            // Remove the child after the transition ends
            child.addEventListener('transitionend', ()=>{
                child.remove();
            });
        }
    }
    // --------------------------------------------------------------
    // Create DOM elements
    // --------------------------------------------------------------
    /**
   * Create new reponse buttons. Remove any existing buttons.
   * @param {Array} optionsData 
   */ createResponseButtons(optionsData) {
        // Clear the existing buttons
        this.clearResponseButtons();
        // Loop through the options data
        optionsData.forEach((option, i)=>{
            // Create the button element
            let button = this.createResponseButtonMarkup(option.message, option.id);
            // Append the button to the container
            this.buttonsContainer.appendChild(button);
            // Fade in the button with a delay
            setTimeout(()=>{
                button.style.display = 'inline-block';
                button.style.transition = 'opacity 500ms';
                button.style.opacity = '1';
            }, 400 + 200 * i);
        });
    }
    /**
   * Returns a object containing a new chat message markup.
   * 
   * @param {String} mesage A message to display in the chat conversation
   * @param {String} owner Id of owner, BOBBOT_OWNER_TYPE_BOT or BOBBOT_OWNER_TYPE_USER
   */ createChatMessageMarkup(message, owner) {
        // Determine the class name based on the owner
        let className = owner === this.bobbotOwnerTypeBot ? 'bobbot__chat__body__history__message-container--bobbot' : owner === this.bobbotOwnerTypeUser ? 'bobbot__chat__body__history__message-container--user' : '';
        // Create the message element
        let messageElement = document.createElement('div');
        messageElement.classList.add('bobbot__chat__body__history__message-box');
        messageElement.innerHTML = `
      <div class="bobbot__chat__body__history__message-box__wrapper">${message}</div>
      <div class="bobbot__chat__body__history__message-box__indicator"></div>
    `;
        // Create the container element
        let containerElement = document.createElement('div');
        containerElement.classList.add('bobbot__chat__body__history__message-container', 'entering', className);
        containerElement.appendChild(messageElement);
        // Return the container element
        return containerElement;
    }
    /**
   * Returns a object containing a response button
   * @param {String} message Text content of button
   * @param {String} messageId Message ID to load from API when clicked
   */ createResponseButtonMarkup(message, messageId) {
        // Create the button element
        let button = document.createElement('button');
        button.classList.add('button', 'bobbot__chat__footer__buttons__button', 'js--ga-click');
        button.innerHTML = message;
        button.setAttribute('ga-category', this.analyticsCategory);
        button.setAttribute('ga-action', 'Click message');
        button.setAttribute('ga-label', message);
        button.setAttribute('data-message-id', messageId);
        // Return the button element
        return button;
    }
    /**
   * Creates and appends the restart button.
   */ createRestartButton(delay) {
        // Create the restart button element
        let restartButton = document.createElement('button');
        restartButton.classList.add('button', 'bobbot__chat__body__container__reset-container__button-restart', 'js--ga-click');
        restartButton.setAttribute('ga-category', this.analyticsCategory);
        restartButton.setAttribute('ga-action', 'Click restart');
        restartButton.innerHTML = "B\xf6rja om";
        restartButton.addEventListener('click', (event)=>{
            // Call the clickedRestart function with the event target as the argument
            this.clickedRestart(event);
        });
        // Append the button to the container
        this.resetButtonContainer.appendChild(restartButton);
        // Fade in the button with a delay
        setTimeout(()=>{
            restartButton.style.transition = 'opacity 500ms';
            restartButton.style.opacity = '1';
        }, delay);
    }
}


var $753b8781d989bffc$exports = {};

$parcel$defineInteropFlag($753b8781d989bffc$exports);

$parcel$export($753b8781d989bffc$exports, "default", function () { return $753b8781d989bffc$export$2e2bcd8739ae039; });
class $753b8781d989bffc$export$2e2bcd8739ae039 {
    constructor(){
        this.lessonFinderContainer = document.querySelector('.lesson-finder');
        if (!this.lessonFinderContainer) return;
        this.lessonFinderInvalidInputClass = 'lesson-finder--error';
        this.lessonFinderNoInputClass = 'lesson-finder--no-input';
        this.lessonFinderAnimationClass = 'lesson-finder--animation';
        this.defaultTextAttr = 'data-default-text';
        this.validLessonsAttr = 'data-valid-lessons';
        this.errorMessageAttr = 'data-error-message';
        this.errorMessageContainer = this.lessonFinderContainer.querySelectorAll('.js--lesson-finder-error-message');
        this.buttonEl = document.querySelector('.lesson-finder__content__controls__button-container__button');
        this.inputEl = document.querySelectorAll('.lesson-finder__content__controls__input-container__input');
        this.formEl = document.querySelector('form');
        this.errorInvalidInput = 1;
        this.errorEmptyString = 2;
        this.errorLessonDoesntExist = 4;
        this.hasError = false;
        this.lastErrorMessage = '';
        if (window.innerWidth > 768) this.inputEl.forEach((elm)=>{
            elm.focus();
        });
        this.setupEvents();
        this.trapFocus();
        if (this.lessonFinderContainer.getAttribute(this.errorMessageAttr)) this.setErrorState(true, this.lessonFinderContainer.getAttribute(this.errorMessageAttr));
        else if (this.inputEl.value == '') this.setErrorState(this.errorEmptyString, '');
        // Setup animation class in the next tick (setImmediate hack)
        setTimeout(this.setupAnimations.bind(this), 0);
    }
    setupAnimations() {
        this.lessonFinderContainer.classList.add(this.lessonFinderAnimationClass);
    }
    setupEvents() {
        this.formEl.addEventListener('submit', this.handleSubmit.bind(this));
        this.buttonEl.addEventListener('click', this.handleSubmit.bind(this));
        this.inputEl.forEach((elm)=>{
            elm.addEventListener('change', (ev)=>{
                this.validate(ev.target);
            });
            elm.addEventListener('keyup', (ev)=>{
                this.validate(ev.target);
            });
        });
    }
    setErrorState(errorState, message) {
        const changedFromError = this.hasError === 4 && errorState === 2 || this.hasError === 4 && errorState === false;
        let errorClass;
        this.hasError = errorState; // Boolean passed from constructor
        this.lessonFinderContainer.classList.remove(this.lessonFinderInvalidInputClass);
        this.lessonFinderContainer.classList.remove(this.lessonFinderNoInputClass);
        if (!this.hasError) {
            this.setErrorMessage(false);
            // Fixes page jump on mobile caused by page height change.
            if (changedFromError) window.scrollTo(0, document.body.scrollHeight);
            return;
        }
        if (errorState & this.errorInvalidInput) errorClass = this.lessonFinderInvalidInputClass;
        if (errorState & this.errorLessonDoesntExist) errorClass = this.lessonFinderInvalidInputClass;
        if (errorState & this.errorEmptyString) errorClass = this.lessonFinderNoInputClass;
        // Passes data-error-message to setErrorMessage
        this.setErrorMessage(message);
        this.lastErrorMessage = message;
        this.lessonFinderContainer.classList.add(errorClass);
        // Fixes page jump on mobile caused by page height change.
        if (changedFromError) window.scrollTo(0, document.body.scrollHeight);
    }
    setErrorMessage(message) {
        if (!message) {
            this.errorMessageContainer.forEach((el)=>{
                const defaultText = el.getAttribute(this.defaultTextAttr);
                el.innerHTML = defaultText || '&nbsp;';
                if (!defaultText) el.classList.remove('visible');
            });
            return;
        }
        this.errorMessageContainer.forEach((el)=>{
            this.showErrorMessage(el);
            el.innerHTML = message;
        });
    }
    showErrorMessage(el) {
        el.classList.add('visible');
    }
    validate(target) {
        const validLessons = this.lessonFinderContainer.getAttribute(this.validLessonsAttr).split(',');
        let lessonNumber = target.value;
        if (lessonNumber === '') {
            this.setErrorState(this.errorEmptyString, '');
            return;
        }
        if (validLessons.indexOf(lessonNumber) == -1) {
            this.setErrorState(this.errorLessonDoesntExist, 'Lektionen finns inte. Testa ett annat nummer!');
            return;
        }
        this.setErrorState(false, '');
    }
    trapFocus() {
        const element = this.lessonFinderContainer.querySelector('.lesson-finder__content__image__content');
        const focusableElements = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
        const firstFocusableElement = focusableElements[0];
        const lastFocusableElement = focusableElements[focusableElements.length - 1];
        element.addEventListener('keydown', (e)=>{
            let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
            if (!isTabPressed) return;
            if (e.shiftKey) {
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus();
                    e.preventDefault();
                }
            } else if (document.activeElement === lastFocusableElement) {
                firstFocusableElement.focus();
                e.preventDefault();
            }
        });
    }
    handleSubmit(ev) {
        if (this.hasError) {
            ev.preventDefault();
            return;
        }
    }
}


var $b64bc3735fa04bad$exports = {};

$parcel$defineInteropFlag($b64bc3735fa04bad$exports);

$parcel$export($b64bc3735fa04bad$exports, "default", function () { return $b64bc3735fa04bad$export$2e2bcd8739ae039; });


class $b64bc3735fa04bad$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($49c4be87a5e25114$exports))) {
    constructor(stateHandler){
        super();
        this.container = document.querySelector('.lesson');
        if (!this.container) return;
        this.sectionSelector = '.lesson__content__section';
        this.sections = this.container.querySelectorAll(this.sectionSelector);
        this.paginatorElement = this.container.querySelector('.lesson__content__paginator');
        this.labelElement = this.container.querySelector('.lesson-section-label');
        this.paginatorPageSelector = '.lesson-paginator__list__page';
        this.paginatorPageActiveClass = 'lesson-paginator__list__page--active';
        this.paginatorLinkSelector = '.lesson-paginator__list__page__link';
        this.headerSelector = '.lesson__header';
        this.contentSelector = '.lesson__content';
        this.contentInViewClass = 'lesson__content--in-view';
        this.startButtonSelector = '.lesson__header__content__start';
        this.hasNextClass = 'lesson--has-next';
        this.hasPreviousClass = 'lesson--has-previous';
        this.labelAttrName = 'data-lesson-section-label';
        this.nextButtonSelector = '.lesson__buttons__next';
        this.previousButtonSelector = '.lesson__buttons__previous';
        this.illustrationClass = 'lesson-section__illustration';
        this.illustrationSelector = '.' + this.illustrationClass;
        this.lessonCookieName = 'minarattigheter_latest_lesson_section';
        this.scrollSpeed = 500;
        this.desktopBreakpointPx = 1024;
        this.defaultEyeRotation = -90;
        this.svgEyeOffsets = [
            45,
            45,
            45,
            45,
            45,
            45,
            45,
            45,
            45,
            45
        ];
        this.svgSelectors = [
            '#lektion-1 svg',
            '#lektion-2 svg',
            '#lektion-3 svg',
            '#lektion-4 svg',
            '#lektion-5 svg'
        ];
        this.svgEyeSelectors = [
            'svg circle.SVG_Illusar-011',
            'svg circle.SVG_Illusar-022',
            'svg circle.SVG_Illusar-034',
            'svg ellipse.SVG_Illusar-041',
            'svg ellipse.SVG_Illusar-052'
        ];
        this.hasMouse = true;
        this.setupEvents();
        this.renderIllustrations();
        this.update();
        setTimeout(this.rotateEyesToDefault.bind(this, this.defaultEyeRotation), 100);
        stateHandler.on((0, $262f4dc95c26964e$export$16639f4b488a4ee6), (isActive)=>{
            this._isActive = isActive;
            setTimeout(this.rotateEyesToDefault.bind(this, this.defaultEyeRotation), 100);
        });
    }
    /**
   * Converts radians to degrees
   * @param {int} radians 
   */ toDegrees(radians) {
        return radians * (180 / Math.PI);
    }
    /**
   * Calculates the angle between two points
   * @param {int} x 
   * @param {int} y 
   * @param {int} x2 
   * @param {int} y2 
   */ getAngle(x, y, x2, y2) {
        const angle = this.toDegrees(Math.atan2(y - y2, x - x2));
        return angle;
    }
    rotateEyesToDefault(degree) {
        this.svgEyeSelectors.forEach((svgEyeSelector)=>{
            const eyes = document.querySelectorAll(svgEyeSelector);
            if (eyes.length < 0) return;
            eyes.forEach((eye)=>{
                const svg = eye.closest('svg');
                if (svg.length < 0) return;
                this._rotateEyes(eye, degree);
            });
        });
    }
    rotateEyes(ev) {
        if (!this._isActive) {
            this.rotateEyesToDefault(this.defaultEyeRotation);
            return;
        }
        const scrollLeft = window.scrollX;
        const scrollTop = window.scrollY;
        this.svgEyeSelectors.forEach((svgEyeSelector)=>{
            const eyes = document.querySelectorAll(svgEyeSelector);
            if (eyes.length < 0) return;
            eyes.forEach((eye, index)=>{
                const svg = eye.closest('svg');
                const svgOffset = this.getOffset(svg);
                const svgHeight = svg.clientHeight;
                const svgWidth = svg.clientWidth;
                const svgCenterX = svgOffset.left + svgWidth / 2 - scrollLeft;
                const svgCenterY = svgOffset.top + svgHeight / 2 - scrollTop;
                const degree = this.getAngle(ev.clientX, ev.clientY, svgCenterX, svgCenterY) - this.svgEyeOffsets[index];
                this._rotateEyes(eye, degree);
            });
        });
    }
    _rotateEyes(el, degree) {
        const radiusX = el.getAttribute('r') || el.getAttribute('rx');
        const radiusY = el.getAttribute('r') || el.getAttribute('ry');
        const originalOffsetX = Math.round(el.getAttribute('cx') - radiusX);
        const originalOffsetY = Math.round(el.getAttribute('cy') - radiusY);
        el.setAttribute('style', 'transform-origin: ' + originalOffsetX + 'px ' + originalOffsetY + 'px; transform: rotate(' + degree + 'deg);');
    }
    renderIllustrations() {
        const illustrations = document.querySelectorAll(this.illustrationSelector);
        illustrations.forEach((ele)=>{
            const parent = ele.parentNode;
            const src = ele.getAttribute('src');
            if (src.indexOf('.svg') !== -1) fetch(src).then((response)=>response.text()).then((data)=>{
                parent.innerHTML = data;
                const svg = parent.querySelector('svg');
                svg.classList.add(this.illustrationClass);
            });
        });
    }
    getOffset(element) {
        if (!element.getClientRects().length) return {
            top: 0,
            left: 0
        };
        let rect = element.getBoundingClientRect();
        let win = element.ownerDocument.defaultView;
        return {
            top: rect.top + win.pageYOffset,
            left: rect.left + win.pageXOffset
        };
    }
    getElementBox(element) {
        const offset = this.getOffset(element);
        const topOfElement = offset.top;
        const elementHeight = element.offsetHeight;
        const bottomOfElement = topOfElement + elementHeight;
        return {
            top: topOfElement,
            bottom: bottomOfElement,
            height: elementHeight
        };
    }
    getViewBox() {
        const topOfScreen = window.scrollY;
        const viewHeight = window.innerHeight;
        const bottomOfScreen = topOfScreen + viewHeight;
        return {
            top: topOfScreen,
            bottom: bottomOfScreen,
            height: viewHeight
        };
    }
    isElementInView(element) {
        const viewbox = this.getViewBox();
        const elementBox = this.getElementBox(element);
        if (viewbox.bottom > elementBox.top && viewbox.top < elementBox.bottom) return true;
        return false;
    }
    isElementVisible(element, index) {
        if (!this.isElementInView(element)) return false;
        const viewbox = this.getViewBox();
        const elementBox = this.getElementBox(element);
        const multiplier = 0.4; // 0.4 instead of 0.5 because the element box has a marign-top 10vh (10% of view height) which needs to be taken into account
        if (viewbox.bottom > elementBox.top + viewbox.height * multiplier) return true;
        return false;
    }
    isDesktop() {
        const mq = window.matchMedia('(min-width: ' + this.desktopBreakpointPx + 'px)');
        return mq.matches ? true : false;
    }
    setupEvents() {
        window.addEventListener('unload', this._pageDestruct.bind(this));
        window.addEventListener('load', ()=>{
            this._pageLoad(this.getStoredPagePosition());
        });
        this.paginatorElement.addEventListener('click', this.paginatorClick.bind(this));
        document.querySelector(this.startButtonSelector).addEventListener('click', this.scrollToFirstSection.bind(this));
        document.querySelector(this.nextButtonSelector).addEventListener('click', this.scrollToNextPage.bind(this));
        document.querySelector(this.previousButtonSelector).addEventListener('click', this.scrollToPreviousPage.bind(this));
        window.addEventListener('scroll', this.handleScroll.bind(this));
        window.addEventListener('scroll', this.debounceHandleScroll.bind(this));
        window.addEventListener('resize', this.handleResize.bind(this));
        document.querySelector('body').addEventListener('mousemove', this.handleMousemove.bind(this));
        window.addEventListener('mousemove.hasMouse', ()=>{
            window.removeEventListener('.hasMouse');
            this.hasMouse = true;
        });
        window.addEventListener('touchstart.hasMouse', ()=>{
            window.removeEventListener('.hasMouse');
            this.hasMouse = false;
        });
    }
    _pageLoad(state, ev) {
        setTimeout(this.restorePagePosition.bind(this, state), 10);
    }
    _pageDestruct(ev) {
        this.storePagePosition();
    }
    restorePagePosition(optState) {
        const state = optState || this.getStoredPagePosition();
        const path = window.location.pathname;
        let previousPosition = null;
        state.map(function(item) {
            if (item.path === path) previousPosition = item;
        });
        if (previousPosition && previousPosition.section) this.scrollTo('#' + previousPosition.section, null, true);
    }
    getStoredPagePosition() {
        const state = Cookies.getJSON(this.lessonCookieName) || [];
        return state;
    }
    setStoredPagePosition(state) {
        Cookies.set(this.lessonCookieName, state || []);
    }
    storePagePosition() {
        const currentSection = this.getCurrentSection();
        if (!currentSection) return;
        const currentPage = currentSection.getAttribute('id');
        let state = this.getStoredPagePosition();
        let replaced = false;
        const current = {
            path: window.location.pathname,
            section: currentPage
        };
        state = state.map((item, i)=>{
            if (item.path === current.path) {
                replaced = true;
                return current;
            }
            return item;
        });
        if (!replaced) state.push(current);
        this.setStoredPagePosition(state);
    }
    scrollToNextPage(ev) {
        const currentPage = this.getCurrentSection();
        const nextPage = currentPage.nextElementSibling;
        if (nextPage) this.scrollTo('#' + nextPage.getAttribute('id'));
        else this.scrollTo('#' + sections[0].getAttribute('id'));
        ev.preventDefault();
    }
    scrollToPreviousPage(ev) {
        const currentPage = this.getCurrentSection();
        const previousPage = currentPage.previousElementSibling;
        if (previousPage) this.scrollTo('#' + previousPage.getAttribute('id'));
        else this.scrollTo(false, 0);
        ev.preventDefault();
    }
    handleMousemove(ev) {
        this.rotateEyes(ev);
    }
    handleResize(ev) {
        if (!this.isDesktop()) this.resetIllustrationsPositions();
        else this.positionIllustrations();
    }
    debounceHandleScroll(ev) {
        clearInterval(this._scrollDebounceHandler);
        this._scrollDebounceHandler = setTimeout((function(ev) {
            this.storePagePosition();
        }).bind(this, ev), 50);
    }
    handleScroll(ev) {
        this.update();
        this.positionIllustrations();
        if (this.hasMouse == false && this._isActive) {
            const scrollPercent = 100 * window.scrollY / (document.body.clientHeight - window.innerHeight);
            let offset = 45;
            if (window.innerWidth < 768) offset = 300;
            this.rotateEyesToDefault(Math.sin(scrollPercent) * 90 - offset);
        }
    }
    resetIllustrationsPositions(ev) {
        const illustrations = document.querySelectorAll(this.illustrationSelector);
        illustrations.forEach((illustration)=>{
            illustration.removeAttribute('style');
        });
    }
    positionIllustrations(ev) {
        if (!this.isDesktop() || !this._isActive) return;
        const illustrations = document.querySelectorAll(this.illustrationSelector);
        illustrations.forEach((illustration)=>{
            let isInView = this.isElementInView(illustration);
            let parentOffset;
            let scrollTop;
            let position;
            let parent;
            let parentHeight;
            let parentWidth;
            // Don't update if not in view
            if (!isInView) return;
            parent = illustration.parentElement;
            parentOffset = parent.getBoundingClientRect();
            parentHeight = parent.offsetHeight;
            parentWidth = parent.offsetWidth;
            const illustrationHeight = illustration.offsetHeight;
            const centerOffset = window.innerHeight / 2 - illustrationHeight / 2;
            const maxTop = parentHeight - illustrationHeight;
            // Column is smaller than image, nothing to animate
            if (maxTop < 0) return;
            scrollTop = window.scrollY;
            position = scrollTop - parentOffset.top;
            position = position + centerOffset;
            position = position < 0 ? 0 : position;
            position = position > maxTop ? maxTop : position;
            if (position > 0 && position < maxTop) {
                illustration.style.position = 'fixed';
                illustration.style.top = centerOffset + 'px';
                illustration.style.width = parentWidth + 'px';
            } else {
                illustration.style.position = 'absolute';
                illustration.style.top = position + 'px';
            }
        });
    }
    getCurrentSection(ev) {
        const sections1 = Array.from(this.sections);
        const currentSection = sections1.filter((function(ele, i) {
            return this.isElementVisible(ele, i);
        }).bind(this)).slice(-1)[0];
        return currentSection;
    }
    setButtonClasses(currentSection) {
        const header = document.querySelector(this.headerSelector);
        if (this.sections[this.sections.length - 1] == currentSection || !currentSection) this.container.classList.remove(this.hasNextClass);
        else this.container.classList.add(this.hasNextClass);
        if (this.isElementInView(header)) this.container.classList.remove(this.hasPreviousClass);
        else this.container.classList.add(this.hasPreviousClass);
    }
    update() {
        const header = document.querySelector(this.headerSelector);
        const content = document.querySelector(this.contentSelector);
        const currentSection = this.getCurrentSection();
        if (!currentSection) return;
        this.setButtonClasses(currentSection);
        if (this.isElementInView(content) && !this.isElementInView(header)) content.classList.add(this.contentInViewClass);
        else content.classList.remove(this.contentInViewClass);
        this.updateLabel(currentSection);
        this.updatePaginator(currentSection);
    }
    updateLabel(element) {
        const label = element.getAttribute(this.labelAttrName);
        this.labelElement.innerHTML = label;
    }
    updatePaginator(element) {
        const id = element.getAttribute('id');
        const pages = this.paginatorElement.querySelectorAll(this.paginatorPageSelector);
        pages.forEach((page)=>{
            const link = page.querySelector(this.paginatorLinkSelector);
            if (link.getAttribute('href').replace('#', '') == id) page.classList.add(this.paginatorPageActiveClass);
            else page.classList.remove(this.paginatorPageActiveClass);
        });
    }
    scrollTo(eleId, position, noAnimate) {
        const ele = document.querySelector(eleId);
        const scrollPosition = ele ? this.getOffset(ele).top : position;
        if (!noAnimate) window.scrollTo({
            top: scrollPosition,
            behavior: 'smooth'
        });
        else window.scrollTo(0, scrollPosition);
    }
    paginatorClick(ev) {
        const eleId = ev.target.getAttribute('href');
        ev.preventDefault();
        this.scrollTo(eleId);
    }
    scrollToFirstSection(ev) {
        ev.preventDefault();
        const section = document.querySelector(this.sectionSelector + '[id]');
        const id = section.getAttribute('id');
        this.scrollTo('#' + id);
    }
}


$28dfe1161dcbadec$exports = {
    "Components": {
        "Accordion": $6f206615b71b3351$exports,
        "BackArrow": $4479ca1cddeff2f4$exports,
        "Carousel": $f2dee5b0b3cebe99$exports,
        "FlipTeaser": $4f8ec8687b08d154$exports,
        "InstructionList": $5c98a5d3a0b97fd7$exports,
        "InterpretationAdaptedVideo": $3860d05185e4fe7f$exports,
        "Poll": $9cd0b0b3ce59dfbf$exports,
        "Teaser": $2344a4cff0b77623$exports,
        "ToolTeaserList": $f778cecf957bc365$exports,
        "VideoList": $65b358f0623d1429$exports,
        "Youtube": $f1f2c6da8500fc6a$exports
    },
    "Pages": {
        "BobotGui": $aea3921f14820907$exports,
        "LessonFinderPage": $753b8781d989bffc$exports,
        "LessonPage": $b64bc3735fa04bad$exports
    }
};


// Faux links to create a larger clickable area.
// Should not affect keyboard focus or screen readers.
function $62686ca544ffced7$export$2e2bcd8739ae039() {
    const fauxLinks = document.querySelectorAll('[data-faux-href]');
    if (fauxLinks) fauxLinks.forEach((fauxLink)=>{
        let link = fauxLink.getAttribute('data-faux-href');
        fauxLink.addEventListener('click', (e)=>{
            if (e.target.nodeName !== 'A') window.location.href = link;
        });
    });
}


/* eslint-disable no-console */ 
var $9d43591822374332$var$error;


$parcel$global.Promise = (0, (/*@__PURE__*/$parcel$interopDefault($6db9d435a4b7ca46$exports)));
$parcel$global.Buffer = (0, $24f87a6f86a8996f$export$a143d493d941bafc);
const $06c541e85d556d17$var$stateHandler = new (0, $fdd5849d34dcc375$export$2e2bcd8739ae039)();
window.Cookies = (0, (/*@__PURE__*/$parcel$interopDefault($4cde099517bdf0a6$exports)));
const $06c541e85d556d17$var$cookieSettingsHandler = new (0, $b969aba65d155e20$export$2e2bcd8739ae039)();
const $06c541e85d556d17$var$cookieBarHandler = new (0, $662aa7ffe8e46681$export$2e2bcd8739ae039)($06c541e85d556d17$var$cookieSettingsHandler);
$06c541e85d556d17$var$cookieSettingsHandler.cookieBarHandler = $06c541e85d556d17$var$cookieBarHandler;
const $06c541e85d556d17$var$popupHandler = new (0, $22f8a7b52501b877$export$2e2bcd8739ae039)();
const $06c541e85d556d17$var$teaserLoader = new (0, $d0816a754525431e$export$2e2bcd8739ae039)();
document.addEventListener('DOMContentLoaded', function() {
    let html = document.querySelector('html');
    html.classList.remove('no-js');
    html.classList.add('js');
    const polyfills = new (0, $3270094ceade3b50$export$2e2bcd8739ae039)();
    const analytics = new (0, $772783048621dbd5$export$2e2bcd8739ae039)();
    const masonryHandler = new (0, $539bcb0b48adfbd8$export$2e2bcd8739ae039)($06c541e85d556d17$var$stateHandler);
    const animatedBackgroundImageHandler = new (0, $49bb30ae7944f01e$export$2e2bcd8739ae039)($06c541e85d556d17$var$stateHandler);
    const animationHandler = new (0, $262f4dc95c26964e$export$2e2bcd8739ae039)($06c541e85d556d17$var$stateHandler);
});
// Instatiate Components
Object.values((0, (/*@__PURE__*/$parcel$interopDefault($28dfe1161dcbadec$exports)))).flatMap($06c541e85d556d17$var$flattenComponentList).filter((Component)=>Component.default).map((Component)=>new Component.default($06c541e85d556d17$var$stateHandler)).map((component)=>{
    if (typeof component.on === 'function') component.on((0, $fdd5849d34dcc375$export$8b4395497d8b4223), $06c541e85d556d17$var$stateHandler.changeState);
    if (typeof component._stateUpdated === 'function') $06c541e85d556d17$var$stateHandler.on((0, $fdd5849d34dcc375$export$dc7e8c09bf56e28f), component._stateUpdated);
});
function $06c541e85d556d17$var$flattenComponentList(items) {
    if (typeof items.default !== 'undefined') return items;
    if (typeof items.length === 'undefined') items = Object.values(items);
    return items.flatMap($06c541e85d556d17$var$flattenComponentList);
}
(0, $62686ca544ffced7$export$2e2bcd8739ae039)();

})();
//# sourceMappingURL=index.js.map
